
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("VSDnB", function(module, exports) {

$parcel$export(module.exports, "setBooleanFeatureFlagResolver", () => $162b6b7cff61a519$export$ba05d765b8392e5e);
$parcel$export(module.exports, "fg", () => $162b6b7cff61a519$export$b40ec24ac8275656);

var $gNWRx = parcelRequire("gNWRx");
function $162b6b7cff61a519$export$ba05d765b8392e5e(flagResolver) {
    (0, $gNWRx.setBooleanResolver)(flagResolver);
}
function $162b6b7cff61a519$export$470e5c2be1411c89(name) {
    return (0, $gNWRx.resolveBooleanFlag)(name);
}
function $162b6b7cff61a519$export$b40ec24ac8275656(name) {
    return (0, $gNWRx.resolveBooleanFlag)(name);
}

});
parcelRegister("gNWRx", function(module, exports) {

$parcel$export(module.exports, "setBooleanResolver", () => $deb4360f78d10c50$export$f2b591175b3e424c);
$parcel$export(module.exports, "resolveBooleanFlag", () => $deb4360f78d10c50$export$6333b6aff9fc6275);

var $iEN9D = parcelRequire("iEN9D");

var $8z44t = parcelRequire("8z44t");

var $6cAn5 = parcelRequire("6cAn5");
const $deb4360f78d10c50$var$pkgName = '@atlaskit/platform-feature-flags';
const $deb4360f78d10c50$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
const $deb4360f78d10c50$var$hasProcessEnv = typeof $6cAn5 !== 'undefined' && typeof $6cAn5.env !== 'undefined';
// FF global overrides can be configured by test runners or Storybook
const $deb4360f78d10c50$var$ENV_ENABLE_PLATFORM_FF = $deb4360f78d10c50$var$hasProcessEnv ? false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
const $deb4360f78d10c50$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $deb4360f78d10c50$var$hasProcessEnv ? false : false;
const $deb4360f78d10c50$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $deb4360f78d10c50$var$ENV_ENABLE_PLATFORM_FF || $deb4360f78d10c50$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
const $deb4360f78d10c50$var$DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
const $deb4360f78d10c50$var$globalVar = typeof window !== 'undefined' ? window : globalThis;
$deb4360f78d10c50$var$globalVar[$deb4360f78d10c50$export$7e41b1b2bdee3f98] = $deb4360f78d10c50$var$globalVar[$deb4360f78d10c50$export$7e41b1b2bdee3f98] || $deb4360f78d10c50$var$DEFAULT_PFF_GLOBAL;
function $deb4360f78d10c50$export$f2b591175b3e424c(resolver) {
    $deb4360f78d10c50$var$globalVar[$deb4360f78d10c50$export$7e41b1b2bdee3f98].booleanResolver = resolver;
}
function $deb4360f78d10c50$export$6333b6aff9fc6275(flagKey) {
    if ($deb4360f78d10c50$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $8z44t.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $deb4360f78d10c50$var$pkgName, flagKey);
        return true;
    }
    try {
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if ($deb4360f78d10c50$var$globalVar[$deb4360f78d10c50$export$7e41b1b2bdee3f98]?.booleanResolver === undefined || $deb4360f78d10c50$var$globalVar[$deb4360f78d10c50$export$7e41b1b2bdee3f98]?.booleanResolver === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, $iEN9D.default).checkGate(flagKey);
        const result = $deb4360f78d10c50$var$globalVar[$deb4360f78d10c50$export$7e41b1b2bdee3f98]?.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn(`${flagKey} resolved to a non-boolean value, returning false for safety`);
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("iEN9D", function(module, exports) {

$parcel$export(module.exports, "default", () => $35b5264e002d74be$export$2e2bcd8739ae039);

var $BptNL = parcelRequire("BptNL");

var $i9mLs = parcelRequire("i9mLs");



var $8ruqY = parcelRequire("8ruqY");
/**
 * Access the FeatureGates object via the default export.
 * ```ts
 * import FeatureGates from '@atlaskit/feature-gate-js-client';
 * ```
 */ class $35b5264e002d74be$var$FeatureGates {
    static{
        this.client = new (0, $BptNL.Client)();
    }
    static{
        this.hasCheckGateErrorOccurred = false;
    }
    static{
        this.hasGetExperimentValueErrorOccurred = false;
    }
    static{
        this.checkGate = (gateName, options)=>{
            try {
                // Check if the CRITERION override mechanism is available
                if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getFeatureFlagOverride === 'function') {
                    // Attempt to retrieve an override value for the feature gate
                    const overrideValue = window.__CRITERION__.getFeatureFlagOverride(gateName);
                    // If an override value is found, return it immediately
                    if (overrideValue !== undefined) return overrideValue;
                }
            } catch (error) {
                // Log the first occurrence of the error
                if (!$35b5264e002d74be$var$FeatureGates.hasCheckGateErrorOccurred) {
                    // eslint-disable-next-line no-console
                    console.warn({
                        msg: 'An error has occurred checking the feature gate from criterion override. Only the first occurrence of this error is logged.',
                        gateName: gateName,
                        error: error
                    });
                    $35b5264e002d74be$var$FeatureGates.hasCheckGateErrorOccurred = true;
                }
            }
            // Proceed with the main logic if no override is found
            return this.client.checkGate(gateName, options);
        };
    }
    static isGateExists(gateName) {
        return this.client.isGateExist(gateName);
    }
    static isExperimentExists(experimentName) {
        return this.client.isExperimentExist(experimentName);
    }
    static{
        this.getExperimentValue = (experimentName, parameterName, defaultValue, options)=>{
            try {
                // Check if the CRITERION override mechanism is available
                if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getExperimentValueOverride === 'function') {
                    const overrideValue = window.__CRITERION__.getExperimentValueOverride(experimentName, parameterName);
                    if (overrideValue !== undefined && overrideValue !== null) return overrideValue;
                }
            } catch (error) {
                // Log the first occurrence of the error
                if (!$35b5264e002d74be$var$FeatureGates.hasGetExperimentValueErrorOccurred) {
                    // eslint-disable-next-line no-console
                    console.warn({
                        msg: 'An error has occurred getting the experiment value from criterion override. Only the first occurrence of this error is logged.',
                        experimentName: experimentName,
                        defaultValue: defaultValue,
                        options: options,
                        error: error
                    });
                    this.hasGetExperimentValueErrorOccurred = true;
                }
                return defaultValue;
            }
            // Proceed with the main logic if no override is found
            return this.client.getExperimentValue(experimentName, parameterName, defaultValue, options);
        };
    }
    static{
        this.initializeCalled = this.client.initializeCalled.bind(this.client);
    }
    static{
        this.initializeCompleted = this.client.initializeCompleted.bind(this.client);
    }
    static{
        this.initialize = this.client.initialize.bind(this.client);
    }
    static{
        this.initializeWithProvider = this.client.initializeWithProvider.bind(this.client);
    }
    static{
        this.initializeFromValues = this.client.initializeFromValues.bind(this.client);
    }
    static{
        this.manuallyLogGateExposure = this.client.manuallyLogGateExposure.bind(this.client);
    }
    static{
        this.getExperiment = this.client.getExperiment.bind(this.client);
    }
    static{
        this.manuallyLogExperimentExposure = this.client.manuallyLogExperimentExposure.bind(this.client);
    }
    static{
        this.manuallyLogLayerExposure = this.client.manuallyLogLayerExposure.bind(this.client);
    }
    static{
        this.shutdownStatsig = this.client.shutdownStatsig.bind(this.client);
    }
    static{
        this.overrideGate = this.client.overrideGate.bind(this.client);
    }
    static{
        this.clearGateOverride = this.client.clearGateOverride.bind(this.client);
    }
    static{
        this.overrideConfig = this.client.overrideConfig.bind(this.client);
    }
    static{
        this.clearConfigOverride = this.client.clearConfigOverride.bind(this.client);
    }
    static{
        this.setOverrides = this.client.setOverrides.bind(this.client);
    }
    static{
        this.getOverrides = this.client.getOverrides.bind(this.client);
    }
    static{
        this.clearAllOverrides = this.client.clearAllOverrides.bind(this.client);
    }
    static{
        this.isCurrentUser = this.client.isCurrentUser.bind(this.client);
    }
    static{
        this.onGateUpdated = this.client.onGateUpdated.bind(this.client);
    }
    static{
        this.onExperimentValueUpdated = this.client.onExperimentValueUpdated.bind(this.client);
    }
    static{
        this.onAnyUpdated = this.client.onAnyUpdated.bind(this.client);
    }
    static{
        this.updateUser = this.client.updateUser.bind(this.client);
    }
    static{
        this.updateUserWithProvider = this.client.updateUserWithProvider.bind(this.client);
    }
    static{
        this.updateUserWithValues = this.client.updateUserWithValues.bind(this.client);
    }
    static{
        this.getPackageVersion = this.client.getPackageVersion.bind(this.client);
    }
    static{
        this.getLayer = this.client.getLayer.bind(this.client);
    }
    static{
        this.getLayerValue = this.client.getLayerValue.bind(this.client);
    }
}
let $35b5264e002d74be$var$boundFGJS = $35b5264e002d74be$var$FeatureGates;
// This makes it possible to get a reference to the FeatureGates client at runtime.
// This is important for overriding values in Cypress tests, as there needs to be a
// way to get the exact instance for a window in order to mock some of its methods.
if (typeof window !== 'undefined') {
    if (window.__FEATUREGATES_JS__ === undefined) window.__FEATUREGATES_JS__ = $35b5264e002d74be$var$FeatureGates;
    else {
        $35b5264e002d74be$var$boundFGJS = window.__FEATUREGATES_JS__;
        const boundVersion = $35b5264e002d74be$var$boundFGJS?.getPackageVersion?.() || '4.10.0 or earlier';
        if (boundVersion !== (0, $i9mLs.CLIENT_VERSION)) {
            const message = `Multiple versions of FeatureGateClients found on the current page.
      The currently bound version is ${boundVersion} when module version ${(0, $i9mLs.CLIENT_VERSION)} was loading.`;
            // eslint-disable-next-line no-console
            console.warn(message);
        }
    }
}
var /**
 * @property {FeatureGates} FeatureGate default export
 */ $35b5264e002d74be$export$2e2bcd8739ae039 = $35b5264e002d74be$var$boundFGJS;

});
parcelRegister("BptNL", function(module, exports) {

$parcel$export(module.exports, "Client", () => $f5725ccebe8e2f70$export$1f2bb630327ac4b6);

var $1Nxtn = parcelRequire("1Nxtn");

var $9Pvqq = parcelRequire("9Pvqq");

var $hMFzK = parcelRequire("hMFzK");

var $9DDUe = parcelRequire("9DDUe");

var $6jK44 = parcelRequire("6jK44");

var $1VtdU = parcelRequire("1VtdU");

var $l4hNL = parcelRequire("l4hNL");

var $5b5vX = parcelRequire("5b5vX");

var $8ruqY = parcelRequire("8ruqY");

var $GWCtt = parcelRequire("GWCtt");

var $i9mLs = parcelRequire("i9mLs");
const $f5725ccebe8e2f70$var$DEFAULT_CLIENT_KEY = 'client-default-key';
// default event logging api is Atlassian proxy rather than Statsig's domain, to avoid ad blockers
const $f5725ccebe8e2f70$var$DEFAULT_EVENT_LOGGING_API = 'https://xp.atlassian.com/v1/rgstr';
class $f5725ccebe8e2f70$export$1f2bb630327ac4b6 {
    constructor({ localStorageKey: localStorageKey = (0, $5b5vX.LOCAL_STORAGE_KEY), overrideAdapter: overrideAdapter } = {}){
        this.initPromise = null;
        /** True if an initialize method was called and completed successfully. */ this.initCompleted = false;
        /**
	 * True if an initialize method was called and completed, meaning the client is now usable.
	 * However if there was an error during initialization it may have initialized with default
	 * values. Use {@link initCompleted} to check for this.
	 */ this.initWithDefaults = false;
        this.hasCheckGateErrorOccurred = false;
        this.hasGetExperimentErrorOccurred = false;
        this.hasGetExperimentValueErrorOccurred = false;
        this.hasGetLayerErrorOccurred = false;
        this.hasGetLayerValueErrorOccurred = false;
        this.subscriptions = new (0, $9Pvqq.default)();
        this.dataAdapter = new (0, $l4hNL.NoFetchDataAdapter)();
        /**
	 * Call this if modifying the values being served by the Statsig library since it has its own
	 * memoization cache which will not be updated if the values are changed outside of the library.
	 */ this.statsigValuesUpdated = ()=>{
            if (this.user) // Trigger a reset of the memoize cache
            this.statsigClient.updateUserSync(this.user, {
                disableBackgroundCacheRefresh: true
            });
            this.subscriptions.anyUpdated();
        };
        this.overrideAdapter = overrideAdapter || new (0, $5b5vX.PersistentOverrideAdapter)(localStorageKey);
    }
    /**
	 * @description
	 * This method initializes the client using a network call to fetch the bootstrap values.
	 * If the client is inialized with an `analyticsWebClient`, it will send an operational event
	 * to GASv3 with the following attributes:
	 * - targetApp: the target app of the client
	 * - clientVersion: the version of the client
	 * - success: whether the initialization was successful
	 * - startTime: the time when the initialization started
	 * - totalTime: the total time it took to initialize the client
	 * - apiKey: the api key used to initialize the client
	 * @param clientOptions {ClientOptions}
	 * @param identifiers {Identifiers}
	 * @param customAttributes {CustomAttributes}
	 * @returns {Promise<void>}
	 */ async initialize(clientOptions, identifiers, customAttributes) {
        const clientOptionsWithDefaults = (0, $GWCtt.getOptionsWithDefaults)(clientOptions);
        if (this.initPromise) {
            if (!(0, $GWCtt.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
            console.warn('Feature Gates client already initialized with different options. New options were not applied.');
            return this.initPromise;
        }
        const startTime = performance.now();
        this.initOptions = clientOptionsWithDefaults;
        this.initPromise = this.init(clientOptionsWithDefaults, identifiers, customAttributes).then(()=>{
            this.initCompleted = true;
            this.initWithDefaults = true;
        }).finally(()=>{
            const endTime = performance.now();
            const totalTime = endTime - startTime;
            this.fireClientEvent(startTime, totalTime, 'initialize', this.initCompleted, clientOptionsWithDefaults.apiKey);
        });
        return this.initPromise;
    }
    /**
	 * @description
	 * This method initializes the client using the provider given to call to fetch the bootstrap values.
	 * If the client is initialized with an `analyticsWebClient`, it will send an operational event
	 * to GASv3 with the following attributes:
	 * - targetApp: the target app of the client
	 * - clientVersion: the version of the client
	 * - success: whether the initialization was successful
	 * - startTime: the time when the initialization started
	 * - totalTime: the total time it took to initialize the client
	 * - apiKey: the api key used to initialize the client
	 * @param clientOptions {ClientOptions}
	 * @param provider {Provider}
	 * @param identifiers {Identifiers}
	 * @param customAttributes {CustomAttributes}
	 * @returns {Promise<void>}
	 */ async initializeWithProvider(clientOptions, provider, identifiers, customAttributes) {
        const clientOptionsWithDefaults = (0, $GWCtt.getOptionsWithDefaults)(clientOptions);
        if (this.initPromise) {
            if (!(0, $GWCtt.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
            console.warn('Feature Gates client already initialized with different options. New options were not applied.');
            return this.initPromise;
        }
        const startTime = performance.now();
        this.initOptions = clientOptionsWithDefaults;
        this.provider = provider;
        this.provider.setClientVersion((0, $i9mLs.CLIENT_VERSION));
        if (this.provider.setApplyUpdateCallback) this.provider.setApplyUpdateCallback(this.applyUpdateCallback.bind(this));
        this.initPromise = this.initWithProvider(clientOptionsWithDefaults, provider, identifiers, customAttributes).then(()=>{
            this.initCompleted = true;
            this.initWithDefaults = true;
        }).finally(()=>{
            const endTime = performance.now();
            const totalTime = endTime - startTime;
            this.fireClientEvent(startTime, totalTime, 'initializeWithProvider', this.initCompleted, provider.getApiKey ? provider.getApiKey() : undefined);
        });
        return this.initPromise;
    }
    applyUpdateCallback(experimentsResult) {
        try {
            if (this.initCompleted || this.initWithDefaults) {
                this.assertInitialized(this.statsigClient);
                this.dataAdapter.setBootstrapData(experimentsResult.experimentValues);
                this.dataAdapter.setData(JSON.stringify(experimentsResult.experimentValues));
                this.statsigValuesUpdated();
            }
        } catch (error) {
            // eslint-disable-next-line no-console
            console.warn('Error when attempting to apply update', error);
        }
    }
    fireClientEvent(startTime, totalTime, action, success, apiKey) {
        this.initOptions.analyticsWebClient?.then((analyticsWebClient)=>{
            const attributes = {
                targetApp: this.initOptions.targetApp,
                clientVersion: (0, $i9mLs.CLIENT_VERSION),
                success: success,
                startTime: startTime,
                totalTime: totalTime,
                ...apiKey && {
                    apiKey: apiKey
                }
            };
            analyticsWebClient.sendOperationalEvent({
                action: action,
                actionSubject: 'featureGatesClient',
                attributes: attributes,
                tags: [
                    'measurement'
                ],
                source: '@atlaskit/feature-gate-js-client'
            });
        }).catch((err)=>{
            if (this.initOptions.environment !== (0, $8ruqY.FeatureGateEnvironment).Production) // eslint-disable-next-line no-console
            console.error('Analytics web client promise did not resolve', err);
        });
    }
    async initializeFromValues(clientOptions, identifiers, customAttributes, initializeValues = {}) {
        const clientOptionsWithDefaults = (0, $GWCtt.getOptionsWithDefaults)(clientOptions);
        if (this.initPromise) {
            if (!(0, $GWCtt.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
            console.warn('Feature Gates client already initialized with different options. New options were not applied.');
            return this.initPromise;
        }
        // This makes sure the new Statsig client behaves like the old when bootstrap data is
        // passed, and `has_updates` isn't specified (which happens a lot in product integration tests).
        if (!Object.prototype.hasOwnProperty.call(initializeValues, 'has_updates')) initializeValues['has_updates'] = true;
        const startTime = performance.now();
        this.initOptions = clientOptionsWithDefaults;
        this.initPromise = this.initFromValues(clientOptionsWithDefaults, identifiers, customAttributes, initializeValues).then(()=>{
            this.initCompleted = true;
            this.initWithDefaults = true;
        }).finally(()=>{
            const endTime = performance.now();
            const totalTime = endTime - startTime;
            this.fireClientEvent(startTime, totalTime, 'initializeFromValues', this.initCompleted);
        });
        return this.initPromise;
    }
    assertInitialized(statsigClient) {
        if (!statsigClient) throw new Error('Client must be initialized before using this method');
    }
    /**
	 * This method updates the user using a network call to fetch the new set of values.
	 * @param fetchOptions {FetcherOptions}
	 * @param identifiers {Identifiers}
	 * @param customAttributes {CustomAttributes}
	 */ async updateUser(fetchOptions, identifiers, customAttributes) {
        this.assertInitialized(this.statsigClient);
        const fetchOptionsWithDefaults = (0, $GWCtt.getOptionsWithDefaults)(fetchOptions);
        const initializeValuesProducer = ()=>(0, $1VtdU.default).fetchExperimentValues(fetchOptionsWithDefaults, identifiers, customAttributes).then(({ experimentValues: experimentValues, customAttributes: customAttributes })=>({
                    experimentValues: experimentValues,
                    customAttributesFromFetch: customAttributes
                }));
        await this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
    }
    /**
	 * This method updates the user using the provider given on initialisation to get the new set of
	 * values.
	 * @param identifiers {Identifiers}
	 * @param customAttributes {CustomAttributes}
	 */ async updateUserWithProvider(identifiers, customAttributes) {
        this.assertInitialized(this.statsigClient);
        if (!this.provider) throw new Error('Cannot update user using provider as the client was not initialised with a provider');
        await this.provider.setProfile(this.initOptions, identifiers, customAttributes);
        await this.updateUserUsingInitializeValuesProducer(()=>this.provider.getExperimentValues(), identifiers, customAttributes);
    }
    /**
	 * This method updates the user given a new set of bootstrap values obtained from one of the
	 * server-side SDKs.
	 *
	 * @param identifiers {Identifiers}
	 * @param customAttributes {CustomAttributes}
	 * @param initializeValues {Record<string,unknown>}
	 */ async updateUserWithValues(identifiers, customAttributes, initializeValues = {}) {
        this.assertInitialized(this.statsigClient);
        const initializeValuesProducer = ()=>Promise.resolve({
                experimentValues: initializeValues,
                customAttributesFromFetch: customAttributes
            });
        await this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
    }
    initializeCalled() {
        return this.initPromise != null;
    }
    initializeCompleted() {
        return this.initCompleted;
    }
    /**
	 * Returns the value for a feature gate. Returns false if there are errors.
	 * @param {string} gateName - The name of the feature gate.
	 * @param {Object} options
	 * @param {boolean} options.fireGateExposure
	 *        Whether or not to fire the exposure event for the gate. Defaults to true.
	 *        To log an exposure event manually at a later time, use {@link Client.manuallyLogGateExposure}
	 *        (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
	 */ checkGate(gateName, options = {}) {
        try {
            this.assertInitialized(this.statsigClient);
            const { fireGateExposure: fireGateExposure = true } = options;
            return this.statsigClient.checkGate(gateName, {
                disableExposureLog: !fireGateExposure
            });
        } catch (error) {
            // Log the first occurrence of the error
            if (!this.hasCheckGateErrorOccurred) {
                // eslint-disable-next-line no-console
                console.warn({
                    msg: 'An error has occurred checking the feature gate. Only the first occurrence of this error is logged.',
                    gateName: gateName,
                    error: error
                });
                this.hasCheckGateErrorOccurred = true;
            }
            return false;
        }
    }
    isGateExist(gateName) {
        try {
            this.assertInitialized(this.statsigClient);
            const gate = this.statsigClient.getFeatureGate(gateName, {
                disableExposureLog: true
            });
            return !gate.details.reason.includes('Unrecognized');
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error(`Error occurred when trying to check FeatureGate: ${error}`);
            // in case of error report true to avoid false positives.
            return true;
        }
    }
    isExperimentExist(experimentName) {
        try {
            this.assertInitialized(this.statsigClient);
            const config = this.statsigClient.getExperiment(experimentName, {
                disableExposureLog: true
            });
            return !config.details.reason.includes('Unrecognized');
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error(`Error occurred when trying to check Experiment: ${error}`);
            // in case of error report true to avoid false positives.
            return true;
        }
    }
    /**
	 * Manually log a gate exposure (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
	 * This is useful if you have evaluated a gate earlier via {@link Client.checkGate} where
	 * <code>options.fireGateExposure</code> is false.
	 * @param gateName
	 */ manuallyLogGateExposure(gateName) {
        this.assertInitialized(this.statsigClient);
        // This is the approach recommended in the docs
        // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
        this.statsigClient.checkGate(gateName);
    }
    /**
	 * Returns the entire config for a given experiment.
	 *
	 * @param {string} experimentName - The name of the experiment
	 * @param {Object} options
	 * @param {boolean} options.fireExperimentExposure - Whether or not to fire the exposure event
	 * for the experiment. Defaults to true. To log an exposure event manually at a later time, use
	 * {@link Client.manuallyLogExperimentExposure} (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
	 * @returns The config for an experiment
	 * @example
	 * ```ts
	 * const experimentConfig = client.getExperiment('example-experiment-name');
	 * const backgroundColor: string = experimentConfig.get('backgroundColor', 'yellow');
	 * ```
	 */ getExperiment(experimentName, options = {}) {
        try {
            this.assertInitialized(this.statsigClient);
            const { fireExperimentExposure: fireExperimentExposure = true } = options;
            return (0, $hMFzK.DynamicConfig).fromExperiment(this.statsigClient.getExperiment(experimentName, {
                disableExposureLog: !fireExperimentExposure
            }));
        } catch (error) {
            // Log the first occurrence of the error
            if (!this.hasGetExperimentErrorOccurred) {
                // eslint-disable-next-line no-console
                console.warn({
                    msg: 'An error has occurred getting the experiment. Only the first occurrence of this error is logged.',
                    experimentName: experimentName,
                    error: error
                });
                this.hasGetExperimentErrorOccurred = true;
            }
            // Return a default value
            return new (0, $hMFzK.DynamicConfig)(experimentName, {}, '', {
                time: Date.now(),
                reason: (0, $6jK44.EvaluationReason).Error
            });
        }
    }
    /**
	 * Returns the value of a given parameter in an experiment config.
	 *
	 * @template T
	 * @param {string} experimentName - The name of the experiment
	 * @param {string} parameterName - The name of the parameter to fetch from the experiment config
	 * @param {T} defaultValue - The value to serve if the experiment or parameter do not exist, or
	 * if the returned value does not match the expected type.
	 * @param {Object} options
	 * @param {boolean} options.fireExperimentExposure - Whether or not to fire the exposure event
	 * for the experiment. Defaults to true. To log an exposure event manually at a later time, use
	 * {@link Client.manuallyLogExperimentExposure} (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-))
	 * @param {function} options.typeGuard - A function that asserts that the return value has the
	 * expected type. If this function returns false, then the default value will be returned
	 * instead. This can be set to protect your code from unexpected values being set remotely. By
	 * default, this will be done by asserting that the default value and value are the same primitive
	 * type.
	 * @returns The value of the parameter if the experiment and parameter both exist, otherwise the
	 * default value.
	 * @example
	 ``` ts
	 type ValidColor = 'blue' | 'red' | 'yellow';
	 type ValidColorTypeCheck = (value: unknown) => value is ValidColor;

	 const isValidColor: ValidColorTypeCheck =
			(value: unknown) => typeof value === 'string' && ['blue', 'red', 'yellow'].includes(value);

	 const buttonColor: ValidColor = client.getExperimentValue(
			'example-experiment-name',
			'backgroundColor',
			'yellow',
			{
					typeGuard: isValidColor
			}
	 );
	 ```
	*/ getExperimentValue(experimentName, parameterName, defaultValue, options = {}) {
        const experiment = this.getExperiment(experimentName, options);
        try {
            const { typeGuard: typeGuard } = options;
            return experiment.get(parameterName, defaultValue, typeGuard);
        } catch (error) {
            // Log the first occurrence of the error
            if (!this.hasGetExperimentValueErrorOccurred) {
                // eslint-disable-next-line no-console
                console.warn({
                    msg: 'An error has occurred getting the experiment value. Only the first occurrence of this error is logged.',
                    experimentName: experimentName,
                    defaultValue: defaultValue,
                    options: options,
                    error: error
                });
                this.hasGetExperimentValueErrorOccurred = true;
            }
            return defaultValue;
        }
    }
    /**
	 * Manually log an experiment exposure (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
	 * This is useful if you have evaluated an experiment earlier via {@link Client.getExperimentValue} or
	 * {@link Client.getExperiment} where <code>options.fireExperimentExposure</code> is false.
	 * @param experimentName
	 */ manuallyLogExperimentExposure(experimentName) {
        this.assertInitialized(this.statsigClient);
        // This is the approach recommended in the docs
        // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
        this.statsigClient.getExperiment(experimentName);
    }
    /**
	 * Manually log a layer exposure (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
	 * This is useful if you have evaluated a layer earlier via {@link Client.getLayerValue} where <code>options.fireExperimentExposure</code> is false.
	 * @param layerName
	 * @param parameterName
	 */ manuallyLogLayerExposure(layerName, parameterName) {
        this.assertInitialized(this.statsigClient);
        // This is the approach recommended in the docs
        // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
        this.statsigClient.getLayer(layerName)?.get(parameterName);
    }
    shutdownStatsig() {
        this.assertInitialized(this.statsigClient);
        this.statsigClient.shutdown();
    }
    /**
	 * Adds a new override for the given gate.
	 *
	 * This method is additive, meaning you can call it multiple times with different gate names to
	 * build your full set of overrides.
	 *
	 * Overrides are persisted to the `STATSIG_OVERRIDES` key in localStorage, so they
	 * will continue to affect every client that is initialized on the same domain after this method
	 * is called. If you are using this API for testing purposes, you should call
	 * {@link Client.clearGateOverride} after your tests are completed to remove this
	 * localStorage entry.
	 *
	 * @param {string} gateName
	 * @param {boolean} value
	 */ overrideGate(gateName, value) {
        this.overrideAdapter.overrideGate(gateName, value);
        // Trigger a reset of the memoized gate value
        if (this.user) this.statsigClient?.updateUserSync(this.user, {
            disableBackgroundCacheRefresh: true
        });
        this.statsigValuesUpdated();
    }
    /**
	 * Removes any overrides that have been set for the given gate.
	 */ clearGateOverride(gateName) {
        this.overrideAdapter.removeGateOverride(gateName);
        this.statsigValuesUpdated();
    }
    /**
	 * Adds a new override for the given config (or experiment).
	 *
	 * This method is additive, meaning you can call it multiple times with different experiment
	 * names to build your full set of overrides.
	 *
	 * Overrides are persisted to the `STATSIG_OVERRIDES` key in localStorage, so they
	 * will continue to affect every client that is initialized on the same domain after this method
	 * is called. If you are using this API for testing purposes, you should call
	 * {@link Client.clearConfigOverride} after your tests are completed to remove this
	 * localStorage entry.
	 *
	 * @param {string} experimentName
	 * @param {object} values
	 */ overrideConfig(experimentName, values) {
        this.overrideAdapter.overrideDynamicConfig(experimentName, values);
        this.statsigValuesUpdated();
    }
    /**
	 * Removes any overrides that have been set for the given experiment.
	 * @param {string} experimentName
	 */ clearConfigOverride(experimentName) {
        this.overrideAdapter.removeDynamicConfigOverride(experimentName);
        this.statsigValuesUpdated();
    }
    /**
	 * Set overrides for gates, experiments and layers in batch.
	 *
	 * Note that these overrides are **not** additive and will completely replace any that have been
	 * added via prior calls to {@link Client.overrideConfig} or
	 * {@link Client.overrideGate}.
	 *
	 * Overrides are persisted to the `STATSIG_OVERRIDES` key in localStorage, so they
	 * will continue to affect every client that is initialized on the same domain after this method
	 * is called. If you are using this API for testing purposes, you should call
	 * {@link Client.clearAllOverrides} after your tests are completed to remove this
	 * localStorage entry.
	 */ setOverrides(overrides) {
        this.overrideAdapter.setOverrides(overrides);
        this.statsigValuesUpdated();
    }
    /**
	 * @returns The current overrides for gates, configs (including experiments) and layers.
	 */ getOverrides() {
        return this.overrideAdapter.getOverrides();
    }
    /**
	 * Clears overrides for all gates, configs (including experiments) and layers.
	 */ clearAllOverrides() {
        this.overrideAdapter.removeAllOverrides();
        this.statsigValuesUpdated();
    }
    /**
	 * Returns whether the given identifiers and customAttributes align with the current
	 * set that is being used by the client.
	 *
	 * If this method returns false, then the {@link Client.updateUser},
	 * {@link Client.updateUserWithValues} or {@link Client.updateUserWithProvider}
	 * methods can be used to re-align these values.
	 *
	 * @param identifiers
	 * @param customAttributes
	 * @returns a flag indicating whether the clients current configuration aligns with the given values
	 */ isCurrentUser(identifiers, customAttributes) {
        return (0, $GWCtt.shallowEquals)(this.currentIdentifiers, identifiers) && (0, $GWCtt.shallowEquals)(this.currentAttributes, customAttributes);
    }
    /**
	 * Subscribe to updates where the given callback will be called with the current checkGate value
	 * @param gateName
	 * @param callback
	 * @param options
	 * @returns off function to unsubscribe from updates
	 */ onGateUpdated(gateName, callback, options = {}) {
        const wrapCallback = (value)=>{
            const { fireGateExposure: fireGateExposure = true } = options;
            if (fireGateExposure) this.manuallyLogGateExposure(gateName);
            try {
                callback(value);
            } catch (error) {
                // eslint-disable-next-line no-console
                console.warn(`Error calling callback for gate ${gateName} with value ${value}`, error);
            }
        };
        return this.subscriptions.onGateUpdated(gateName, wrapCallback, this.checkGate.bind(this), options);
    }
    /**
	 * Subscribe to updates where the given callback will be called with the current experiment value
	 * @param experimentName
	 * @param parameterName
	 * @param defaultValue
	 * @param callback
	 * @param options
	 * @returns off function to unsubscribe from updates
	 */ onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback, options = {}) {
        const wrapCallback = (value)=>{
            const { fireExperimentExposure: fireExperimentExposure = true } = options;
            if (fireExperimentExposure) this.manuallyLogExperimentExposure(experimentName);
            try {
                callback(value);
            } catch (error) {
                // eslint-disable-next-line no-console
                console.warn(`Error calling callback for experiment ${experimentName} with value ${value}`, error);
            }
        };
        return this.subscriptions.onExperimentValueUpdated(experimentName, parameterName, defaultValue, wrapCallback, this.getExperimentValue.bind(this), options);
    }
    /**
	 * Subscribe so on any update the callback will be called.
	 * NOTE: The callback will be called whenever the values are updated even if the values have not
	 * changed.
	 * @param callback
	 * @returns off function to unsubscribe from updates
	 */ onAnyUpdated(callback) {
        return this.subscriptions.onAnyUpdated(callback);
    }
    /**
	 * This method initializes the client using a network call to fetch the bootstrap values for the
	 * given user.
	 *
	 * @param clientOptions
	 * @param identifiers
	 * @param customAttributes
	 * @private
	 */ async init(clientOptions, identifiers, customAttributes) {
        const fromValuesClientOptions = {
            ...clientOptions
        };
        let experimentValues;
        let customAttributesFromResult;
        try {
            // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
            // the experiment values request to be settled, and it will fall back to use default values.
            const clientSdkKeyPromise = (0, $1VtdU.default).fetchClientSdk(clientOptions).then((value)=>fromValuesClientOptions.sdkKey = value.clientSdkKey);
            const experimentValuesPromise = (0, $1VtdU.default).fetchExperimentValues(clientOptions, identifiers, customAttributes);
            // Only wait for the experiment values request to finish and try to initialise the client
            // with experiment values if both requests are successful. Else an error would be thrown and
            // handled by the catch
            const [, experimentValuesResult] = await Promise.all([
                clientSdkKeyPromise,
                experimentValuesPromise
            ]);
            experimentValues = experimentValuesResult.experimentValues;
            customAttributesFromResult = experimentValuesResult.customAttributes;
        } catch (error) {
            if (error instanceof Error) // eslint-disable-next-line no-console
            console.error(`Error occurred when trying to fetch the Feature Gates client values, error: ${error?.message}`);
            // eslint-disable-next-line no-console
            console.warn(`Initialising Statsig client without values`);
            await this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
            throw error;
        }
        return this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues);
    }
    async initWithProvider(baseClientOptions, provider, identifiers, customAttributes) {
        const fromValuesClientOptions = {
            ...baseClientOptions,
            disableCurrentPageLogging: true
        };
        let experimentValues;
        let customAttributesFromResult;
        try {
            await provider.setProfile(baseClientOptions, identifiers, customAttributes);
            // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
            // the experiment values request to be settled, and it will fall back to use default values.
            const clientSdkKeyPromise = provider.getClientSdkKey().then((value)=>fromValuesClientOptions.sdkKey = value);
            const experimentValuesPromise = provider.getExperimentValues();
            // Only wait for the experiment values request to finish and try to initialise the client
            // with experiment values if both requests are successful. Else an error would be thrown and
            // handled by the catch
            const [, experimentValuesResult] = await Promise.all([
                clientSdkKeyPromise,
                experimentValuesPromise
            ]);
            experimentValues = experimentValuesResult.experimentValues;
            customAttributesFromResult = experimentValuesResult.customAttributesFromFetch;
        } catch (error) {
            if (error instanceof Error) // eslint-disable-next-line no-console
            console.error(`Error occurred when trying to fetch the Feature Gates client values, error: ${error?.message}`);
            // eslint-disable-next-line no-console
            console.warn(`Initialising Statsig client without values`);
            await this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
            throw error;
        }
        return this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues);
    }
    /**
	 * This method initializes the client using a set of boostrap values obtained from one of the
	 * server-side SDKs.
	 *
	 * @param clientOptions
	 * @param identifiers
	 * @param customAttributes
	 * @param initializeValues
	 * @private
	 */ async initFromValues(clientOptions, identifiers, customAttributes, initializeValues = {}) {
        this.overrideAdapter.initFromStoredOverrides();
        this.currentIdentifiers = identifiers;
        this.currentAttributes = customAttributes;
        const newClientOptions = (0, $GWCtt.migrateInitializationOptions)(clientOptions);
        if (!newClientOptions.sdkKey) newClientOptions.sdkKey = $f5725ccebe8e2f70$var$DEFAULT_CLIENT_KEY;
        if (!newClientOptions.networkConfig?.logEventUrl) newClientOptions.networkConfig = {
            ...newClientOptions.networkConfig,
            logEventUrl: $f5725ccebe8e2f70$var$DEFAULT_EVENT_LOGGING_API
        };
        if (newClientOptions.perimeter === (0, $8ruqY.PerimeterType).FEDRAMP_MODERATE) // disable all logging in FedRAMP to prevent egress of sensitive data
        newClientOptions.disableLogging = true;
        const { sdkKey: sdkKey, environment: environment, updateUserCompletionCallback: _updateUserCompletionCallback, perimeter: _perimeter, ...restClientOptions } = newClientOptions;
        this.sdkKey = sdkKey;
        this.user = (0, $GWCtt.toStatsigUser)(identifiers, customAttributes, this.sdkKey);
        const statsigOptions = {
            ...restClientOptions,
            environment: {
                tier: environment
            },
            includeCurrentPageUrlWithEvents: false,
            dataAdapter: this.dataAdapter,
            overrideAdapter: this.overrideAdapter
        };
        try {
            this.statsigClient = new (0, $1Nxtn.StatsigClient)(sdkKey, this.user, statsigOptions);
            this.dataAdapter.setBootstrapData(initializeValues);
            await this.statsigClient.initializeAsync();
        } catch (error) {
            if (error instanceof Error) // eslint-disable-next-line no-console
            console.error(`Error occurred when trying to initialise the Statsig client, error: ${error?.message}`);
            // eslint-disable-next-line no-console
            console.warn(`Initialising Statsig client with default sdk key and without values`);
            this.statsigClient = new (0, $1Nxtn.StatsigClient)($f5725ccebe8e2f70$var$DEFAULT_CLIENT_KEY, this.user, statsigOptions);
            this.dataAdapter.setBootstrapData();
            await this.statsigClient.initializeAsync();
            this.initWithDefaults = true;
            throw error;
        }
    }
    /**
	 * This method updates the user for this client with the bootstrap values returned from a given
	 * Promise.
	 * It uses the customAttributes from fetching experiment values to update the Statsig user but
	 * uses the customAttributes from given input to check if the user has changed.
	 *
	 * @param {Identifiers} identifiers
	 * @param {CustomAttributes} customAttributes
	 * @param {Promise<InitializeValues>} getInitializeValues
	 * @private
	 */ async updateUserUsingInitializeValuesProducer(getInitializeValues, identifiers, customAttributes) {
        this.assertInitialized(this.statsigClient);
        if (!this.initPromise) throw new Error('The client must be initialized before you can update the user.');
        // If the user isn't changing at all, then exit immediately
        if (this.isCurrentUser(identifiers, customAttributes)) return this.initPromise;
        // Wait for the current initialize/update to finish
        const originalInitPromise = this.initPromise;
        try {
            await this.initPromise;
        } catch (err) {
        // Proceed with the user update even if the init failed, since this update
        // may put the client back into a valid state.
        }
        const initializeValuesPromise = getInitializeValues();
        const updateUserPromise = this.updateStatsigClientUser(initializeValuesPromise, identifiers, customAttributes);
        // We replace the init promise here since we are essentially re-initializing the client at this
        // point. Any subsequent calls to await client.initialize() or client.updateUser()
        // will now also await this user update.
        this.initPromise = updateUserPromise.catch(async ()=>{
            // If the update failed then it changed nothing, so revert back to the original promise.
            this.initPromise = originalInitPromise;
            // Set the user profile again to revert back to the current user
            if (this.provider) await this.provider.setProfile(this.initOptions, this.currentIdentifiers, this.currentAttributes);
        });
        return updateUserPromise;
    }
    /**
	 * This method updates the user on the nested Statsig client
	 *
	 * @param identifiers
	 * @param customAttributes
	 * @param initializeValuesPromise
	 * @private
	 */ async updateStatsigClientUser(initializeValuesPromise, identifiers, customAttributes) {
        this.assertInitialized(this.statsigClient);
        let initializeValues, user;
        try {
            initializeValues = await initializeValuesPromise;
            user = (0, $GWCtt.toStatsigUser)(identifiers, initializeValues.customAttributesFromFetch, this.sdkKey);
        } catch (err) {
            // Make sure the updateUserCompletionCallback is called for any errors in our custom code.
            // This is not necessary for the updateUserWithValues call, because the Statsig client will
            // already invoke the callback itself.
            const errMsg = err instanceof Error ? err.message : JSON.stringify(err);
            this.initOptions.updateUserCompletionCallback?.(false, errMsg);
            throw err;
        }
        let success = true;
        let errorMessage = null;
        try {
            this.dataAdapter.setBootstrapData(initializeValues.experimentValues);
            this.user = user;
            await this.statsigClient.updateUserAsync(this.user);
        } catch (err) {
            success = false;
            errorMessage = String(err);
        }
        this.initOptions?.updateUserCompletionCallback?.(success, errorMessage);
        if (success) {
            this.currentIdentifiers = identifiers;
            this.currentAttributes = customAttributes;
            this.subscriptions.anyUpdated();
        } else throw new Error('Failed to update user. An unexpected error occured.');
    }
    /**
	 * @returns string version of the current package in semver style.
	 */ getPackageVersion() {
        return 0, $i9mLs.CLIENT_VERSION;
    }
    /**
	 * Returns a specified layer otherwise returns an empty layer as a default value if the layer doesn't exist.
	 *
	 * @param {string} layerName - The name of the layer
	 * @param {Object} options
	 * @param {boolean} options.fireLayerExposure - Whether or not to fire the exposure event for the
	 * layer. Defaults to true. To log an exposure event manually at a later time, use
	 * {@link Client.manuallyLogLayerExposure} (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
	 * @returns A layer
	 * @example
	 * ```ts
	 * const layer = client.getLayer('example-layer-name');
	 * const exampletitle: string = layer.get("title", "Welcome to Statsig!");
	 * ```
	 */ getLayer(/** The name of the layer */ layerName, options = {}) {
        try {
            this.assertInitialized(this.statsigClient);
            const { fireLayerExposure: fireLayerExposure = true } = options;
            return (0, $9DDUe.Layer).fromLayer(this.statsigClient.getLayer(layerName, {
                disableExposureLog: !fireLayerExposure
            }));
        } catch (error) {
            // Log the first occurrence of the error
            if (!this.hasGetLayerErrorOccurred) {
                // eslint-disable-next-line no-console
                console.warn({
                    msg: 'An error has occurred getting the layer. Only the first occurrence of this error is logged.',
                    layerName: layerName,
                    error: error
                });
                this.hasGetLayerErrorOccurred = true;
            }
            // Return a default value
            return (0, $9DDUe.Layer).fromLayer((0, $1Nxtn._makeLayer)(layerName, {
                reason: 'Error'
            }, null));
        }
    }
    /**
	 * Returns the value of a given parameter in a layer config.
	 *
	 * @template T
	 * @param {string} layerName - The name of the layer
	 * @param {string} parameterName - The name of the parameter to fetch from the layer config
	 * @param {T} defaultValue - The value to serve if the layer or parameter do not exist, or if the
	 * returned value does not match the expected type.
	 * @param {Object} options
	 * @param {boolean} options.fireLayerExposure - Whether or not to fire the exposure event for the
	 * layer. Defaults to true. To log an exposure event manually at a later time, use
	 * {@link Client.manuallyLogLayerExposure} (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-))
	 * @param {function} options.typeGuard - A function that asserts that the return value has the expected type. If this function returns false, then the default value will be returned instead. This can be set to protect your code from unexpected values being set remotely. By default, this will be done by asserting that the default value and value are the same primitive type.
	 * @returns The value of the parameter if the layer and parameter both exist, otherwise the default value.
	 * @example
	 * ``` ts
	 * type ValidColor = 'blue' | 'red' | 'yellow';
	 * type ValidColorTypeCheck = (value: unknown) => value is ValidColor;
	 *
	 * const isValidColor: ValidColorTypeCheck =
	 *    (value: unknown) => typeof value === 'string' && ['blue', 'red', 'yellow'].includes(value);
	 *
	 * const buttonColor: ValidColor = client.getLayerValue(
	 *    'example-layer-name',
	 *    'backgroundColor',
	 *    'yellow',
	 *    {
	 *        typeGuard: isValidColor
	 *    }
	 * );
	 * ```
	 */ getLayerValue(layerName, parameterName, defaultValue, options = {}) {
        const layer = this.getLayer(layerName, options);
        try {
            const { typeGuard: typeGuard } = options;
            return layer.get(parameterName, defaultValue, typeGuard);
        } catch (error) {
            // Log the first occurrence of the error
            if (!this.hasGetLayerValueErrorOccurred) {
                // eslint-disable-next-line no-console
                console.warn({
                    msg: 'An error has occurred getting the layer value. Only the first occurrence of this error is logged.',
                    layerName: layerName,
                    defaultValue: defaultValue,
                    options: options,
                    error: error
                });
                this.hasGetLayerValueErrorOccurred = true;
            }
            return defaultValue;
        }
    }
}

});
parcelRegister("9Pvqq", function(module, exports) {

$parcel$export(module.exports, "default", () => $713542dc64f11289$export$2e2bcd8739ae039);

var $7n9mn = parcelRequire("7n9mn");
const $713542dc64f11289$export$a66cbd9b2289cd78 = '@all-features';
class $713542dc64f11289$export$2e2bcd8739ae039 {
    constructor(){
        this.eventToValue = new Map();
        this.emitter = new (0, $7n9mn.EventEmitter2)();
    }
    onGateUpdated(gateName, callback, checkGate, options) {
        const value = checkGate(gateName, {
            ...options,
            fireGateExposure: false
        });
        if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
        const wrapCallback = ()=>{
            const value = checkGate(gateName, {
                ...options,
                fireGateExposure: false
            });
            const existingValue = this.eventToValue.get(callback);
            if (existingValue !== value) {
                this.eventToValue.set(callback, value);
                callback(value);
            }
        };
        this.emitter.on(gateName, wrapCallback);
        return ()=>{
            this.emitter.off(gateName, wrapCallback);
        };
    }
    onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback, getExperimentValue, options) {
        const experimentEventName = `${experimentName}.${parameterName}`;
        const value = getExperimentValue(experimentName, parameterName, defaultValue, {
            ...options,
            fireExperimentExposure: false
        });
        if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
        const wrapCallback = ()=>{
            const value = getExperimentValue(experimentName, parameterName, defaultValue, {
                ...options,
                fireExperimentExposure: false
            });
            const existingValue = this.eventToValue.get(callback);
            if (existingValue !== value) {
                this.eventToValue.set(callback, value);
                callback(value);
            }
        };
        this.emitter.on(experimentEventName, wrapCallback);
        return ()=>{
            this.emitter.off(experimentEventName, wrapCallback);
        };
    }
    onAnyUpdated(callback) {
        this.emitter.on($713542dc64f11289$export$a66cbd9b2289cd78, callback);
        return ()=>{
            this.emitter.off($713542dc64f11289$export$a66cbd9b2289cd78, callback);
        };
    }
    anyUpdated() {
        this.emitter.emit($713542dc64f11289$export$a66cbd9b2289cd78);
        this.emitter.eventNames().filter((name)=>name !== $713542dc64f11289$export$a66cbd9b2289cd78).forEach((event)=>{
            this.emitter.emit(event);
        });
    }
}

});

parcelRegister("hMFzK", function(module, exports) {

$parcel$export(module.exports, "DynamicConfig", () => $142fe0e7679753ac$export$6dc24881a3d96325);

var $GWCtt = parcelRequire("GWCtt");
class $142fe0e7679753ac$export$6dc24881a3d96325 {
    static fromExperiment(experiment) {
        const config = new $142fe0e7679753ac$export$6dc24881a3d96325(experiment.name, experiment.value, experiment.ruleID, (0, $GWCtt.migrateEvaluationDetails)(experiment.details), experiment.__evaluation?.secondary_exposures, experiment.groupName ?? undefined);
        config.experiment = experiment;
        return config;
    }
    constructor(configName, configValue, ruleID, evaluationDetails, secondaryExposures = [], allocatedExperimentName = '', onDefaultValueFallback = null){
        this.value = configValue;
        this._name = configName;
        this._ruleID = ruleID;
        this._secondaryExposures = secondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._evaluationDetails = evaluationDetails;
        this._onDefaultValueFallback = onDefaultValueFallback;
    }
    get(key, defaultValue, typeGuard) {
        const val = this.getValue(key, defaultValue);
        if (val == null) return defaultValue;
        const expectedType = Array.isArray(defaultValue) ? 'array' : typeof defaultValue;
        const actualType = Array.isArray(val) ? 'array' : typeof val;
        if (typeGuard) {
            if (typeGuard(val)) {
                this.fireExposure(key);
                return val;
            }
            this._onDefaultValueFallback?.(this, key, expectedType, actualType);
            return defaultValue;
        }
        if (defaultValue == null || expectedType === actualType) {
            this.fireExposure(key);
            return val;
        }
        this._onDefaultValueFallback?.(this, key, expectedType, actualType);
        return defaultValue;
    }
    getValue(key, defaultValue) {
        if (key == null) return this.value;
        if (defaultValue == null) defaultValue = null;
        if (this.value[key] == null) return defaultValue;
        this.fireExposure(key);
        return this.value[key];
    }
    fireExposure(key) {
        // Call the wrapped experiment's get method to fire exposure
        if (this.experiment) this.experiment.get(key);
    }
}

});
parcelRegister("GWCtt", function(module, exports) {

$parcel$export(module.exports, "getOptionsWithDefaults", () => $181d0696732d3f0c$export$d119b37e5f788b43);
$parcel$export(module.exports, "shallowEquals", () => $181d0696732d3f0c$export$fa1c2bbf4100b8bc);
$parcel$export(module.exports, "toStatsigUser", () => $181d0696732d3f0c$export$3dad1db244472f32);
$parcel$export(module.exports, "migrateInitializationOptions", () => $181d0696732d3f0c$export$202946b690d26d22);
$parcel$export(module.exports, "migrateEvaluationDetails", () => $181d0696732d3f0c$export$18ad168d3dbac899);

var $1Nxtn = parcelRequire("1Nxtn");

var $aIZdc = parcelRequire("aIZdc");

var $6jK44 = parcelRequire("6jK44");

var $8ruqY = parcelRequire("8ruqY");
const $181d0696732d3f0c$export$d119b37e5f788b43 = (options)=>({
        /**
	 * If more federal PerimeterTypes are added in the future, this should be updated so
	 * that isFedRamp() === true always returns the strictest perimeter.
	 */ perimeter: (0, $aIZdc.isFedRamp)() ? (0, $8ruqY.PerimeterType).FEDRAMP_MODERATE : (0, $8ruqY.PerimeterType).COMMERCIAL,
        ...options
    });
const $181d0696732d3f0c$export$fa1c2bbf4100b8bc = (objectA, objectB)=>{
    if (!objectA && !objectB) return true;
    if (!objectA || !objectB) return false;
    const aEntries = Object.entries(objectA);
    const bEntries = Object.entries(objectB);
    if (aEntries.length !== bEntries.length) return false;
    const ascendingKeyOrder = ([key1], [key2])=>key1.localeCompare(key2);
    aEntries.sort(ascendingKeyOrder);
    bEntries.sort(ascendingKeyOrder);
    for(let i = 0; i < aEntries.length; i++){
        const [, aValue] = aEntries[i];
        const [, bValue] = bEntries[i];
        if (aValue !== bValue) return false;
    }
    return true;
};
const $181d0696732d3f0c$export$3dad1db244472f32 = (identifiers, customAttributes, sdkKey)=>{
    const user = {
        customIDs: !customAttributes?.stableID && sdkKey ? {
            stableID: (0, $1Nxtn.StableID).get(sdkKey),
            ...identifiers
        } : identifiers,
        custom: customAttributes
    };
    if (identifiers.atlassianAccountId) user.userID = identifiers.atlassianAccountId;
    return user;
};
const $181d0696732d3f0c$export$202946b690d26d22 = (options)=>{
    const { api: api, disableCurrentPageLogging: disableCurrentPageLogging, loggingIntervalMillis: loggingIntervalMillis, loggingBufferMaxSize: loggingBufferMaxSize, localMode: localMode, eventLoggingApi: eventLoggingApi, eventLoggingApiForRetries: eventLoggingApiForRetries, disableLocalStorage: disableLocalStorage, ignoreWindowUndefined: ignoreWindowUndefined, disableAllLogging: disableAllLogging, // No equivalent but is pointless anyway since our Statsig init is synchronous
    initTimeoutMs: _initTimeoutMs, // No equivalent in new client but probably not important?
    disableNetworkKeepalive: _disableNetworkKeepalive, // Needs to be implemented manually but unused according to zoekt
    overrideStableID: _overrideStableID, // No equivalent for these but can't see them actually used anywhere in old client?
    disableErrorLogging: _disableErrorLogging, disableAutoMetricsLogging: _disableAutoMetricsLogging, ...rest } = options;
    return {
        ...rest,
        networkConfig: {
            api: api,
            logEventUrl: eventLoggingApi ? eventLoggingApi + 'rgstr' : undefined,
            logEventFallbackUrls: eventLoggingApiForRetries ? [
                eventLoggingApiForRetries
            ] : undefined,
            preventAllNetworkTraffic: localMode || !ignoreWindowUndefined && typeof window === 'undefined'
        },
        includeCurrentPageUrlWithEvents: !disableCurrentPageLogging,
        loggingIntervalMs: loggingIntervalMillis,
        loggingBufferMaxSize: loggingBufferMaxSize,
        disableStorage: disableLocalStorage === undefined ? localMode : disableLocalStorage,
        disableLogging: disableAllLogging === undefined ? localMode : disableAllLogging
    };
};
const $181d0696732d3f0c$var$evaluationReasonMappings = Object.entries((0, $6jK44.EvaluationReason)).map(([key, value])=>[
        key.toLowerCase(),
        value
    ]);
const $181d0696732d3f0c$export$18ad168d3dbac899 = (details)=>{
    const reasonLower = details.reason.toLowerCase();
    return {
        reason: $181d0696732d3f0c$var$evaluationReasonMappings.find(([key])=>reasonLower.includes(key))?.[1] ?? (0, $6jK44.EvaluationReason).Unknown,
        time: details.receivedAt ?? Date.now()
    };
};

});
parcelRegister("aIZdc", function(module, exports) {

$parcel$export(module.exports, "isFedRamp", () => $d33f031e5d50f679$export$64d6499adf9b2e51);

var $bNXfF = parcelRequire("bNXfF");
function $d33f031e5d50f679$export$64d6499adf9b2e51() {
    const global = globalThis;
    // MICROS_PERIMETER is already used by few products, so we need to keep it for backward compatibility
    const env = global.MICROS_PERIMETER || global.UNSAFE_ATL_CONTEXT_BOUNDARY;
    if (env) return env === (0, $bNXfF.FEDRAMP_MODERATE);
    const matches = global.location?.hostname?.match(/atlassian-us-gov-mod\.(com|net)|atlassian-us-gov\.(com|net)|atlassian-fex\.(com|net)|atlassian-stg-fedm\.(com|net)/);
    return matches ? matches.length > 0 : false;
}

});
parcelRegister("bNXfF", function(module, exports) {

$parcel$export(module.exports, "FEDRAMP_MODERATE", () => $16271ea4123e88a6$export$ce553301d55c2fd8);
$parcel$export(module.exports, "COMMERCIAL", () => $16271ea4123e88a6$export$f005e2e9f707cb5f);
$parcel$export(module.exports, "FEDRAMP_FEDEX", () => $16271ea4123e88a6$export$bd6b5a7802d76127);
$parcel$export(module.exports, "STAGING", () => $16271ea4123e88a6$export$a739cd5aac835909);
$parcel$export(module.exports, "PRODUCTION", () => $16271ea4123e88a6$export$42dd0cdd351a4a9);
$parcel$export(module.exports, "DEV", () => $16271ea4123e88a6$export$404582bc18fe4d9e);
const $16271ea4123e88a6$export$ce553301d55c2fd8 = 'fedramp-moderate';
const $16271ea4123e88a6$export$f005e2e9f707cb5f = 'commercial';
const $16271ea4123e88a6$export$bd6b5a7802d76127 = 'fedramp-fedex';
const $16271ea4123e88a6$export$a739cd5aac835909 = 'stg';
const $16271ea4123e88a6$export$42dd0cdd351a4a9 = 'prod';
const $16271ea4123e88a6$export$404582bc18fe4d9e = 'dev';
const $16271ea4123e88a6$export$d8347b4aae768c2d = [
    $16271ea4123e88a6$export$f005e2e9f707cb5f
];
const $16271ea4123e88a6$export$b1b1ccc8f3e7f954 = [
    $16271ea4123e88a6$export$f005e2e9f707cb5f,
    $16271ea4123e88a6$export$ce553301d55c2fd8
];

});


parcelRegister("6jK44", function(module, exports) {

$parcel$export(module.exports, "EvaluationReason", () => $ebf60ba7eff6038f$export$c62558b199e46828);
// Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigStore.ts
var $ebf60ba7eff6038f$export$c62558b199e46828 = /*#__PURE__*/ function(EvaluationReason) {
    // Order is important since the logic for migrating from a new client reason to an old one
    // returns the first which is a substring of the new client reason
    EvaluationReason["Error"] = "Error";
    EvaluationReason["LocalOverride"] = "LocalOverride";
    EvaluationReason["Unrecognized"] = "Unrecognized";
    EvaluationReason["Uninitialized"] = "Uninitialized";
    EvaluationReason["NetworkNotModified"] = "NetworkNotModified";
    EvaluationReason["Network"] = "Network";
    EvaluationReason["InvalidBootstrap"] = "InvalidBootstrap";
    EvaluationReason["Bootstrap"] = "Bootstrap";
    EvaluationReason["Cache"] = "Cache";
    // For when we could not migrate the reason from the new client
    EvaluationReason["Unknown"] = "Unknown";
    return EvaluationReason;
}({});

});

parcelRegister("8ruqY", function(module, exports) {

$parcel$export(module.exports, "FeatureGateEnvironment", () => $2d5b6990a7a5a559$export$479e7351a733299);
$parcel$export(module.exports, "PerimeterType", () => $2d5b6990a7a5a559$export$c42b7bbc5e7ba555);
var $2d5b6990a7a5a559$export$479e7351a733299 = /*#__PURE__*/ function(FeatureGateEnvironment) {
    FeatureGateEnvironment["Development"] = "development";
    FeatureGateEnvironment["Staging"] = "staging";
    FeatureGateEnvironment["Production"] = "production";
    return FeatureGateEnvironment;
}({});
var $2d5b6990a7a5a559$export$c42b7bbc5e7ba555 = /*#__PURE__*/ function(PerimeterType) {
    PerimeterType["COMMERCIAL"] = "commercial";
    PerimeterType["FEDRAMP_MODERATE"] = "fedramp-moderate";
    return PerimeterType;
}({});
const $2d5b6990a7a5a559$export$42f4885608027d0c = 'non_boolean';

});



parcelRegister("9DDUe", function(module, exports) {

$parcel$export(module.exports, "Layer", () => $263dbcb77497739a$export$936d0764594b6eb3);

var $GWCtt = parcelRequire("GWCtt");
class $263dbcb77497739a$export$936d0764594b6eb3 {
    static fromLayer(layer) {
        const value = new $263dbcb77497739a$export$936d0764594b6eb3(layer.name, layer.__value, layer.ruleID, (0, $GWCtt.migrateEvaluationDetails)(layer.details), (_layer, parameterName)=>layer.get(parameterName), layer.__evaluation?.secondary_exposures, layer.__evaluation?.undelegated_secondary_exposures, layer.__evaluation?.allocated_experiment_name, layer.__evaluation?.explicit_parameters);
        return value;
    }
    constructor(name, layerValue, ruleID, evaluationDetails, logParameterFunction = null, secondaryExposures = [], undelegatedSecondaryExposures = [], allocatedExperimentName = '', explicitParameters = []){
        this._logParameterFunction = logParameterFunction;
        this._name = name;
        this._value = JSON.parse(JSON.stringify(layerValue ?? {}));
        this._ruleID = ruleID ?? '';
        this._evaluationDetails = evaluationDetails;
        this._secondaryExposures = secondaryExposures;
        this._undelegatedSecondaryExposures = undelegatedSecondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._explicitParameters = explicitParameters;
    }
    get(key, defaultValue, typeGuard) {
        const val = this._value[key];
        if (val == null) return defaultValue;
        const logAndReturn = ()=>{
            this._logLayerParameterExposure(key);
            return val;
        };
        if (typeGuard) return typeGuard(val) ? logAndReturn() : defaultValue;
        if (defaultValue == null) return logAndReturn();
        if (typeof val === typeof defaultValue && Array.isArray(defaultValue) === Array.isArray(val)) return logAndReturn();
        return defaultValue;
    }
    getValue(key, defaultValue) {
        // eslint-disable-next-line eqeqeq
        if (defaultValue == undefined) defaultValue = null;
        const val = this._value[key];
        if (val != null) this._logLayerParameterExposure(key);
        return val ?? defaultValue;
    }
    _logLayerParameterExposure(parameterName) {
        this._logParameterFunction?.(this, parameterName);
    }
}

});

parcelRegister("1VtdU", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad1f7bf4f3a697b2$export$2e2bcd8739ae039);

var $8ruqY = parcelRequire("8ruqY");

var $i9mLs = parcelRequire("i9mLs");

var $4BA3W = parcelRequire("4BA3W");
const $ad1f7bf4f3a697b2$var$DEFAULT_REQUEST_TIMEOUT_MS = 5000;
const $ad1f7bf4f3a697b2$export$250a58ecde616daa = 'https://api.atlassian.com/flags';
const $ad1f7bf4f3a697b2$export$942ba04389b0d5a2 = 'https://api.stg.atlassian.com/flags';
const $ad1f7bf4f3a697b2$export$f058dbf75c3bc647 = 'https://api.dev.atlassian.com/flags';
const $ad1f7bf4f3a697b2$export$1a401a0da8da3565 = 'https://api.stg.atlassian-us-gov-mod.com/flags';
const $ad1f7bf4f3a697b2$export$18c93900db9358a4 = 'https://api.atlassian-us-gov-mod.com/flags';
const $ad1f7bf4f3a697b2$export$450bd8fb2a6d7ace = '/gateway/api/flags';
class $ad1f7bf4f3a697b2$export$2e2bcd8739ae039 {
    static async fetchClientSdk(fetcherOptions) {
        const { targetApp: targetApp } = fetcherOptions;
        const url = `/api/v2/frontend/clientSdkKey/${targetApp}`;
        try {
            return await this.fetchRequest(url, 'GET', fetcherOptions);
        } catch (error) {
            if (error instanceof Error) throw error;
            throw Error('Failed to retrieve client sdk key');
        }
    }
    static async fetchExperimentValues(fetcherOptions, identifiers, customAttributes) {
        const requestBody = {
            identifiers: identifiers,
            customAttributes: customAttributes,
            targetApp: fetcherOptions.targetApp
        };
        try {
            return await this.fetchRequest('/api/v2/frontend/experimentValues', 'POST', fetcherOptions, requestBody);
        } catch (error) {
            if (error instanceof Error) throw error;
            throw Error('Failed to retrieve experiment values');
        }
    }
    static async handleResponseError(response) {
        if (!response.ok) {
            // Use text() instead of json() as the error body might not be json data
            const body = await response.text();
            throw new (0, $4BA3W.ResponseError)(`Non 2xx response status received, status: ${response.status}, body: ${JSON.stringify(body)}`);
        }
        if (response.status === 204) throw new (0, $4BA3W.ResponseError)('Unexpected 204 response');
    }
    static async extractResponseBody(response) {
        const value = await response.text();
        return JSON.parse(value);
    }
    static getBaseUrl(serviceEnv, useGatewayUrl = false, perimeter) {
        if (useGatewayUrl) return $ad1f7bf4f3a697b2$export$450bd8fb2a6d7ace;
        if (perimeter === (0, $8ruqY.PerimeterType).FEDRAMP_MODERATE) switch(serviceEnv){
            case (0, $8ruqY.FeatureGateEnvironment).Production:
                return $ad1f7bf4f3a697b2$export$18c93900db9358a4;
            case (0, $8ruqY.FeatureGateEnvironment).Staging:
                return $ad1f7bf4f3a697b2$export$1a401a0da8da3565;
            default:
                throw new Error(`Invalid environment "${serviceEnv}" for "${perimeter}" perimeter`);
        }
        else if (perimeter === (0, $8ruqY.PerimeterType).COMMERCIAL) switch(serviceEnv){
            case (0, $8ruqY.FeatureGateEnvironment).Development:
                return $ad1f7bf4f3a697b2$export$f058dbf75c3bc647;
            case (0, $8ruqY.FeatureGateEnvironment).Staging:
                return $ad1f7bf4f3a697b2$export$942ba04389b0d5a2;
            default:
                return $ad1f7bf4f3a697b2$export$250a58ecde616daa;
        }
        else throw new Error(`Invalid perimeter "${perimeter}"`);
    }
    static async fetchRequest(path, method, fetcherOptions, body) {
        const baseUrl = $ad1f7bf4f3a697b2$export$2e2bcd8739ae039.getBaseUrl(fetcherOptions.environment, fetcherOptions.useGatewayURL, fetcherOptions.perimeter);
        const fetchTimeout = fetcherOptions.fetchTimeoutMs || $ad1f7bf4f3a697b2$var$DEFAULT_REQUEST_TIMEOUT_MS;
        let abortSignal;
        if (AbortSignal.timeout) abortSignal = AbortSignal.timeout(fetchTimeout);
        else if (AbortController) {
            const abortController = new AbortController();
            abortSignal = abortController.signal;
            setTimeout(()=>abortController.abort(), fetchTimeout);
        }
        const response = await fetch(`${baseUrl}${path}`, {
            method: method,
            headers: {
                'Content-Type': 'application/json',
                'X-Client-Name': 'feature-gate-js-client',
                'X-Client-Version': (0, $i9mLs.CLIENT_VERSION),
                'X-API-KEY': fetcherOptions.apiKey
            },
            signal: abortSignal,
            ...body && {
                body: JSON.stringify(body)
            }
        });
        await this.handleResponseError(response);
        return await this.extractResponseBody(response);
    }
}

});
parcelRegister("i9mLs", function(module, exports) {

$parcel$export(module.exports, "CLIENT_VERSION", () => $702e4d150695c43b$export$a59f8d67326bd1cb);
/// <reference types="node" />
const $702e4d150695c43b$export$a59f8d67326bd1cb = "0.0.0-use.local";

});

parcelRegister("4BA3W", function(module, exports) {

$parcel$export(module.exports, "ResponseError", () => $362ced472fdb999d$export$286baf652d0b1206);
class $362ced472fdb999d$export$286baf652d0b1206 extends Error {
    constructor(message){
        super(message);
    }
}

});


parcelRegister("l4hNL", function(module, exports) {

$parcel$export(module.exports, "NoFetchDataAdapter", () => $e62c5c62fe23e73a$export$55fffef3474104af);

var $1Nxtn = parcelRequire("1Nxtn");
class $e62c5c62fe23e73a$export$55fffef3474104af extends (0, $1Nxtn.DataAdapterCore) {
    constructor(){
        super('NoFetchDataAdapter', 'nofetch'), this.bootstrapResult = null;
    }
    /**
	 * Make sure to call this **before** calling `initializeAsync` or `updateUserAsync` but
	 * after the Statsig client has been created!
	 */ setBootstrapData(data) {
        this.bootstrapResult = data ? {
            source: 'Bootstrap',
            data: JSON.stringify(data),
            receivedAt: Date.now(),
            stableID: (0, $1Nxtn.StableID).get(this._getSdkKey()),
            fullUserHash: null
        } : null;
    }
    async prefetchData(_user, _options) {}
    async getDataAsync(_current, user, _options) {
        return this.bootstrapResult && {
            ...this.bootstrapResult,
            fullUserHash: (0, $1Nxtn._getFullUserHash)(user)
        };
    }
    getDataSync(user) {
        return this.bootstrapResult && {
            ...this.bootstrapResult,
            fullUserHash: (0, $1Nxtn._getFullUserHash)(user)
        };
    }
    async _fetchFromNetwork(_current, _user, _options) {
        return null;
    }
    _getCacheKey(user) {
        // Same logic as default data adapter
        // https://github.com/statsig-io/js-client-monorepo/blob/main/packages/js-client/src/StatsigEvaluationsDataAdapter.ts
        const key = (0, $1Nxtn._getStorageKey)(this._getSdkKey(), user);
        return `${0, $1Nxtn.DataAdapterCachePrefix}.${this._cacheSuffix}.${key}`;
    }
    _isCachedResultValidFor204(_result, _user) {
        return false;
    }
    setDataLegacy(data, user) {
        super.setData(data, user);
    }
    // Do not stringify options property since that includes this adapter and will
    // cause a circular reference when Statsig sends diagnostic events and including
    // values is not necessary and makes the result huge
    toJSON() {
        const result = {
            ...this
        };
        delete result._options;
        delete result._inMemoryCache;
        delete result.bootstrapResult;
        return result;
    }
}

});

parcelRegister("5b5vX", function(module, exports) {

$parcel$export(module.exports, "LOCAL_STORAGE_KEY", () => $a2f699f5738687d1$export$d8474cff104280f3);
$parcel$export(module.exports, "PersistentOverrideAdapter", () => $a2f699f5738687d1$export$bcb28fbac1def494);

var $10Gqk = parcelRequire("10Gqk");
const $a2f699f5738687d1$var$LOCAL_OVERRIDE_REASON = 'LocalOverride:Recognized';
const $a2f699f5738687d1$export$d8474cff104280f3 = 'STATSIG_OVERRIDES';
const $a2f699f5738687d1$var$LEGACY_LOCAL_STORAGE_KEY = 'STATSIG_JS_LITE_LOCAL_OVERRIDES';
const $a2f699f5738687d1$var$makeEmptyStore = ()=>({
        gates: {},
        configs: {},
        layers: {}
    });
const $a2f699f5738687d1$var$djb2MapKey = (hash, kind)=>kind + ':' + hash;
class $a2f699f5738687d1$export$bcb28fbac1def494 {
    constructor(localStorageKey){
        this._overrides = $a2f699f5738687d1$var$makeEmptyStore();
        this._djb2Map = new Map();
        this._localStorageKey = localStorageKey;
    }
    parseStoredOverrides(localStorageKey) {
        try {
            const json = window.localStorage.getItem(localStorageKey);
            if (!json) return $a2f699f5738687d1$var$makeEmptyStore();
            return JSON.parse(json);
        } catch  {
            return $a2f699f5738687d1$var$makeEmptyStore();
        }
    }
    mergeOverrides(...allOverrides) {
        const merged = $a2f699f5738687d1$var$makeEmptyStore();
        for (const overrides of allOverrides){
            for (const [name, value] of Object.entries(overrides.gates ?? {}))merged.gates[name] = value;
            for (const [name, value] of Object.entries(overrides.configs ?? {}))merged.configs[name] = value;
            for (const [name, value] of Object.entries(overrides.layers ?? {}))merged.layers[name] = value;
        }
        return merged;
    }
    initFromStoredOverrides() {
        const storedOverrides = this.mergeOverrides(this._overrides, this.parseStoredOverrides($a2f699f5738687d1$var$LEGACY_LOCAL_STORAGE_KEY), this.parseStoredOverrides(this._localStorageKey));
        // Clear data from legacy local storage key now we've read from it.
        // This prevents things being stuck in there that are always read but never written to.
        try {
            window.localStorage.removeItem($a2f699f5738687d1$var$LEGACY_LOCAL_STORAGE_KEY);
        } catch  {
        // ignored - window is not defined in non-browser environments, and we don't save things there
        // (things like SSR, etc)
        }
        // In version 4.24.0 we introduced hashes in this override adapter, but had a bug which would cause
        // multiple hashes to continue being created. This code here removes these hashes since we've moved
        // to using a more reliable and easier to maintain map in `_djb2Map`.
        for (const container of Object.values(storedOverrides)){
            const allKeys = new Set(Object.keys(container));
            for (const name of allKeys){
                const hash = (0, $10Gqk._DJB2)(name);
                if (allKeys.has(hash)) delete container[hash];
            }
        }
        this.applyOverrides(storedOverrides);
    }
    saveOverrides() {
        try {
            window.localStorage.setItem(this._localStorageKey, JSON.stringify(this._overrides));
        } catch  {
        // ignored - window is not defined in non-browser environments, and we don't save things there
        // (things like SSR, etc)
        }
    }
    getOverrides() {
        return this.mergeOverrides(this._overrides);
    }
    applyOverrides(overrides) {
        const newOverrides = {
            ...$a2f699f5738687d1$var$makeEmptyStore(),
            ...overrides
        };
        this._djb2Map.clear();
        for (const [containerName, container] of Object.entries(newOverrides))for (const [name, value] of Object.entries(container))this._djb2Map.set($a2f699f5738687d1$var$djb2MapKey((0, $10Gqk._DJB2)(name), containerName), value);
        this._overrides = newOverrides;
    }
    setOverrides(overrides) {
        this.applyOverrides(overrides);
        this.saveOverrides();
    }
    overrideGate(name, value) {
        this._overrides.gates[name] = value;
        this._djb2Map.set($a2f699f5738687d1$var$djb2MapKey((0, $10Gqk._DJB2)(name), 'gates'), value);
        this.saveOverrides();
    }
    removeGateOverride(name) {
        delete this._overrides.gates[name];
        this._djb2Map.delete($a2f699f5738687d1$var$djb2MapKey((0, $10Gqk._DJB2)(name), 'gates'));
        this.saveOverrides();
    }
    getGateOverride(current, _user) {
        const overridden = this._overrides.gates[current.name] ?? this._djb2Map.get($a2f699f5738687d1$var$djb2MapKey(current.name, 'gates'));
        if (overridden == null) return null;
        return {
            ...current,
            value: overridden,
            details: {
                ...current.details,
                reason: $a2f699f5738687d1$var$LOCAL_OVERRIDE_REASON
            }
        };
    }
    overrideDynamicConfig(name, value) {
        this._overrides.configs[name] = value;
        this._djb2Map.set($a2f699f5738687d1$var$djb2MapKey((0, $10Gqk._DJB2)(name), 'configs'), value);
        this.saveOverrides();
    }
    removeDynamicConfigOverride(name) {
        delete this._overrides.configs[name];
        this._djb2Map.delete($a2f699f5738687d1$var$djb2MapKey((0, $10Gqk._DJB2)(name), 'configs'));
        this.saveOverrides();
    }
    getDynamicConfigOverride(current, _user) {
        return this._getConfigOverride(current, this._overrides.configs);
    }
    overrideExperiment(name, value) {
        this._overrides.configs[name] = value;
        this._djb2Map.set($a2f699f5738687d1$var$djb2MapKey((0, $10Gqk._DJB2)(name), 'configs'), value);
        this.saveOverrides();
    }
    removeExperimentOverride(name) {
        delete this._overrides.configs[name];
        this._djb2Map.delete($a2f699f5738687d1$var$djb2MapKey((0, $10Gqk._DJB2)(name), 'configs'));
        this.saveOverrides();
    }
    getExperimentOverride(current, _user) {
        return this._getConfigOverride(current, this._overrides.configs);
    }
    overrideLayer(name, value) {
        this._overrides.layers[name] = value;
        this._djb2Map.set($a2f699f5738687d1$var$djb2MapKey((0, $10Gqk._DJB2)(name), 'layers'), value);
        this.saveOverrides();
    }
    removeLayerOverride(name) {
        delete this._overrides.layers[name];
        this._djb2Map.delete($a2f699f5738687d1$var$djb2MapKey((0, $10Gqk._DJB2)(name), 'layers'));
        this.saveOverrides();
    }
    removeAllOverrides() {
        this._overrides = $a2f699f5738687d1$var$makeEmptyStore();
        try {
            window.localStorage.removeItem(this._localStorageKey);
        } catch  {
        // ignored - window is not defined in non-browser environments, and we don't save things there
        // (things like SSR, etc)
        }
    }
    getLayerOverride(current, _user) {
        const overridden = this._overrides.layers[current.name] ?? this._djb2Map.get($a2f699f5738687d1$var$djb2MapKey(current.name, 'layers'));
        if (overridden == null) return null;
        return {
            ...current,
            __value: overridden,
            get: (0, $10Gqk._makeTypedGet)(current.name, overridden),
            details: {
                ...current.details,
                reason: $a2f699f5738687d1$var$LOCAL_OVERRIDE_REASON
            }
        };
    }
    _getConfigOverride(current, lookup) {
        const overridden = lookup[current.name] ?? this._djb2Map.get($a2f699f5738687d1$var$djb2MapKey(current.name, 'configs'));
        if (overridden == null) return null;
        return {
            ...current,
            value: overridden,
            get: (0, $10Gqk._makeTypedGet)(current.name, overridden),
            details: {
                ...current.details,
                reason: $a2f699f5738687d1$var$LOCAL_OVERRIDE_REASON
            }
        };
    }
}

});



parcelRegister("8z44t", function(module, exports) {

$parcel$export(module.exports, "debug", () => $74a930288ce2e8c4$export$1c9f709888824e05);
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
const $74a930288ce2e8c4$var$TESTS_MODE = globalThis?.process?.env?.JEST_WORKER_ID !== undefined;
const $74a930288ce2e8c4$var$DEBUG_MODE = !$74a930288ce2e8c4$var$TESTS_MODE && globalThis?.process?.env?.NODE_ENV !== 'production';
const $74a930288ce2e8c4$export$1c9f709888824e05 = (...args)=>{
    if (!$74a930288ce2e8c4$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    console.debug(...args);
};

});



parcelRegister("6wxJn", function(module, exports) {

$parcel$export(module.exports, "default", () => $2eee0fd9c3566724$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
var $2eee0fd9c3566724$export$2e2bcd8739ae039 = (0, $5uXOq.createContext)(null);

});

parcelRegister("gSA3s", function(module, exports) {

$parcel$export(module.exports, "allFeatureFlagsAccessed", () => $db1a60e9dc5c9d14$export$5b78c989c8db2561);
$parcel$export(module.exports, "currentFeatureFlagsAccessed", () => $db1a60e9dc5c9d14$export$2a5c8df26bb89760);
$parcel$export(module.exports, "addFeatureFlagAccessed", () => $db1a60e9dc5c9d14$export$47fade9662f71000);

var $g0ix0 = parcelRequire("g0ix0");
const $db1a60e9dc5c9d14$export$5b78c989c8db2561 = new Map();
const $db1a60e9dc5c9d14$export$2a5c8df26bb89760 = new Map();
function $db1a60e9dc5c9d14$export$47fade9662f71000(featureFlagName, featureFlagValue) {
    try {
        // Inform Criterion about FF being accessed
        if (globalThis.__CRITERION__ && typeof globalThis.__CRITERION__.addFeatureFlagAccessed === 'function') globalThis.__CRITERION__.addFeatureFlagAccessed(featureFlagName, featureFlagValue);
    } catch (_e) {
    // ignore the criterion error
    }
    const value = (0, $g0ix0.redactValue)(featureFlagValue);
    $db1a60e9dc5c9d14$export$5b78c989c8db2561.set(featureFlagName, value);
    $db1a60e9dc5c9d14$export$2a5c8df26bb89760.set(featureFlagName, value);
}

});
parcelRegister("g0ix0", function(module, exports) {

$parcel$export(module.exports, "redactValue", () => $9a4ed2bdd42d469b$export$fcc03ee4c944962f);

function $9a4ed2bdd42d469b$var$startsAsObject(value) {
    try {
        if (value.charAt(0) === '{') return true;
    } catch (e) {
        return false;
    }
    return false;
}
function $9a4ed2bdd42d469b$var$isObject(value) {
    return value && typeof value === 'object' && value.constructor === Object;
}
function $9a4ed2bdd42d469b$var$isString(input) {
    let result;
    try {
        result = typeof input === 'string' || input instanceof String;
    } catch (err) {
        // swallow any errors
        result = false;
    }
    return result;
}
function $9a4ed2bdd42d469b$export$7b4abba432e57989(value) {
    return $9a4ed2bdd42d469b$var$isString(value) && $9a4ed2bdd42d469b$var$startsAsObject(value) || $9a4ed2bdd42d469b$var$isObject(value);
}
function $9a4ed2bdd42d469b$export$fcc03ee4c944962f(featureFlagValue) {
    return $9a4ed2bdd42d469b$export$7b4abba432e57989(featureFlagValue) ? (0, $90de389b166e701f$export$42f4885608027d0c) : featureFlagValue;
}

});
const $90de389b166e701f$export$42f4885608027d0c = 'non_boolean';



parcelRegister("tcn7E", function(module, exports) {

$parcel$export(module.exports, "setInteractionActiveTrace", () => $e9d8d7e26b2e602d$export$f2e521e495a88544);
$parcel$export(module.exports, "setActiveTrace", () => $e9d8d7e26b2e602d$export$a1002be327997103);
$parcel$export(module.exports, "getActiveTrace", () => $e9d8d7e26b2e602d$export$b6ac780db3a3cc77);
$parcel$export(module.exports, "clearActiveTrace", () => $e9d8d7e26b2e602d$export$17ab21d7be720b);
$parcel$export(module.exports, "getActiveTraceHttpRequestHeaders", () => $e9d8d7e26b2e602d$export$6e17cce6446848f9);

var $nfArY = parcelRequire("nfArY");
const $e9d8d7e26b2e602d$var$state = {
    context: null
};
function $e9d8d7e26b2e602d$export$295213bc4d0c54ad() {
    return Array.from(new Array(16), ()=>Math.floor(Math.random() * 16).toString(16)).join('');
}
function $e9d8d7e26b2e602d$export$f2e521e495a88544(interactionId, experienceType) {
    $e9d8d7e26b2e602d$export$a1002be327997103(interactionId.replace(/-/g, ''), $e9d8d7e26b2e602d$export$295213bc4d0c54ad(), experienceType);
}
function $e9d8d7e26b2e602d$export$a1002be327997103(traceId, spanId, type) {
    $e9d8d7e26b2e602d$var$state.context = {
        traceId: traceId,
        spanId: spanId,
        type: type
    };
}
function $e9d8d7e26b2e602d$export$b6ac780db3a3cc77() {
    return $e9d8d7e26b2e602d$var$state.context || undefined;
}
function $e9d8d7e26b2e602d$export$17ab21d7be720b() {
    $e9d8d7e26b2e602d$var$state.context = null;
}
function $e9d8d7e26b2e602d$export$6e17cce6446848f9(_url) {
    if ($e9d8d7e26b2e602d$var$state.context === null) return null;
    const { traceId: traceId, spanId: spanId } = $e9d8d7e26b2e602d$var$state.context;
    return (0, $nfArY.makeTraceHttpRequestHeaders)(traceId, spanId);
}
function $e9d8d7e26b2e602d$export$a1e7396778592551(_url) {
    const traceHeaders = $e9d8d7e26b2e602d$export$6e17cce6446848f9(_url);
    return traceHeaders ? new URLSearchParams(traceHeaders).toString().toLowerCase() : null;
}

});
parcelRegister("nfArY", function(module, exports) {

$parcel$export(module.exports, "makeTraceHttpRequestHeaders", () => $ab54be471bba623c$export$1115c5277eb10d5e);
function $ab54be471bba623c$export$1115c5277eb10d5e(traceId, spanId) {
    return {
        'X-B3-TraceId': traceId,
        'X-B3-SpanId': spanId
    };
}

});


parcelRegister("1u4q7", function(module, exports) {

$parcel$export(module.exports, "DefaultInteractionID", () => $7e359588695aef0a$export$3109542b68df9ba1);
$parcel$export(module.exports, "default", () => $7e359588695aef0a$export$2e2bcd8739ae039);
$parcel$export(module.exports, "getInteractionId", () => $7e359588695aef0a$export$37bca3107733ac1e);

var $5uXOq = parcelRequire("5uXOq");
const $7e359588695aef0a$export$3109542b68df9ba1 = {
    current: null
};
var // We use a context to allow modals to have their own lifecycle
$7e359588695aef0a$export$2e2bcd8739ae039 = (0, $5uXOq.createContext)($7e359588695aef0a$export$3109542b68df9ba1);
const $7e359588695aef0a$export$37bca3107733ac1e = ()=>$7e359588695aef0a$export$3109542b68df9ba1;
const $7e359588695aef0a$export$9f6000531b78127e = ()=>$7e359588695aef0a$export$3109542b68df9ba1;

});

parcelRegister("bFU4G", function(module, exports) {

$parcel$export(module.exports, "postInteractionLog", () => $b98c15df5ed39925$export$d8f52e8f804021e8);
$parcel$export(module.exports, "getActiveInteraction", () => $b98c15df5ed39925$export$2b3954d2e8509985);
$parcel$export(module.exports, "updatePageLoadInteractionName", () => $b98c15df5ed39925$export$f6f1cf5bedf83c71);
$parcel$export(module.exports, "addMetadata", () => $b98c15df5ed39925$export$12f2b6cb85d59904);
$parcel$export(module.exports, "addCustomData", () => $b98c15df5ed39925$export$e4380431c2bdabee);
$parcel$export(module.exports, "addCustomTiming", () => $b98c15df5ed39925$export$27cacb7d7f3fe20a);
$parcel$export(module.exports, "addMark", () => $b98c15df5ed39925$export$728e28c22a0fba4);
$parcel$export(module.exports, "addSpan", () => $b98c15df5ed39925$export$2c1d6e17cfa9bbc7);
$parcel$export(module.exports, "addSpanToAll", () => $b98c15df5ed39925$export$943a8b2b5d6b1809);
$parcel$export(module.exports, "extractModuleName", () => $b98c15df5ed39925$export$f5a8f10de74904da);
$parcel$export(module.exports, "addHold", () => $b98c15df5ed39925$export$7606887303596f82);
$parcel$export(module.exports, "addHoldByID", () => $b98c15df5ed39925$export$10582acd678c213);
$parcel$export(module.exports, "removeHoldByID", () => $b98c15df5ed39925$export$4983dfbbb996f7ae);
$parcel$export(module.exports, "getCurrentInteractionType", () => $b98c15df5ed39925$export$2df109852219d16e);
$parcel$export(module.exports, "ModuleLoadingProfiler", () => $b98c15df5ed39925$export$9591b52b33ccc510);
$parcel$export(module.exports, "addError", () => $b98c15df5ed39925$export$239c33984d9b1367);
$parcel$export(module.exports, "addErrorToAll", () => $b98c15df5ed39925$export$7379c15afd3840fa);
$parcel$export(module.exports, "addProfilerTimings", () => $b98c15df5ed39925$export$53d6f611de951a13);
$parcel$export(module.exports, "sinkInteractionHandler", () => $b98c15df5ed39925$export$9e614a29a1ac213e);
$parcel$export(module.exports, "sinkPostInteractionLogHandler", () => $b98c15df5ed39925$export$8a1ba7bef607358a);
$parcel$export(module.exports, "tryComplete", () => $b98c15df5ed39925$export$673be905888f8839);
$parcel$export(module.exports, "abort", () => $b98c15df5ed39925$export$5def58af4fd46132);
$parcel$export(module.exports, "abortByNewInteraction", () => $b98c15df5ed39925$export$c4a545284f55edf2);
$parcel$export(module.exports, "abortAll", () => $b98c15df5ed39925$export$614a7af2affc5dff);
$parcel$export(module.exports, "addOnCancelCallback", () => $b98c15df5ed39925$export$7b9261a96cfe427b);
$parcel$export(module.exports, "addNewInteraction", () => $b98c15df5ed39925$export$1a1ed1e1fdb2006b);
$parcel$export(module.exports, "addBrowserMetricEvent", () => $b98c15df5ed39925$export$4a759336b50e86e3);
$parcel$export(module.exports, "addApdexToAll", () => $b98c15df5ed39925$export$ad216cc25852d44b);
$parcel$export(module.exports, "addApdex", () => $b98c15df5ed39925$export$35220fd6cdd1b731);
$parcel$export(module.exports, "addRequestInfo", () => $b98c15df5ed39925$export$57d55b4569823d8f);
$parcel$export(module.exports, "addSegment", () => $b98c15df5ed39925$export$1c43f9ac826b6462);
$parcel$export(module.exports, "removeSegment", () => $b98c15df5ed39925$export$d0365e48b58231c3);
$parcel$export(module.exports, "addRedirect", () => $b98c15df5ed39925$export$bbf14d79614d9818);
$parcel$export(module.exports, "interactionSpans", () => $b98c15df5ed39925$export$6ce04c7ca6810a7e);
$parcel$export(module.exports, "addCustomSpans", () => $b98c15df5ed39925$export$5342dcad19138a1c);

var $7Jxgt = parcelRequire("7Jxgt");

var $5gx4p = parcelRequire("5gx4p");

var $fe1wc = parcelRequire("fe1wc");

var $f38ba = parcelRequire("f38ba");

var $tcn7E = parcelRequire("tcn7E");

var $gSA3s = parcelRequire("gSA3s");

var $1u4q7 = parcelRequire("1u4q7");

var $a0hd6 = parcelRequire("a0hd6");

var $45w2S = parcelRequire("45w2S");

var $bJCAw = parcelRequire("bJCAw");
const $b98c15df5ed39925$var$PreviousInteractionLog = {
    name: undefined,
    isAborted: undefined
};
const $b98c15df5ed39925$export$d8f52e8f804021e8 = new (0, $bJCAw.default)();
const $b98c15df5ed39925$var$interactionQueue = [];
const $b98c15df5ed39925$var$segmentCache = new Map();
const $b98c15df5ed39925$var$CLEANUP_TIMEOUT = 60000;
const $b98c15df5ed39925$var$CLEANUP_TIMEOUT_AFTER_APDEX = 15000;
const $b98c15df5ed39925$var$segmentObservers = [];
function $b98c15df5ed39925$export$2b3954d2e8509985() {
    const interactionId = (0, $1u4q7.getInteractionId)();
    if (!interactionId.current) return;
    return (0, $45w2S.interactions).get(interactionId.current);
}
function $b98c15df5ed39925$var$isPerformanceTracingEnabled() {
    return (0, $fe1wc.getConfig)()?.enableAdditionalPerformanceMarks || window.__REACT_UFO_ENABLE_PERF_TRACING || false;
}
let $b98c15df5ed39925$var$performanceEventObserver;
const $b98c15df5ed39925$export$17afbba0f16b4b19 = ()=>{
    $b98c15df5ed39925$var$performanceEventObserver = $b98c15df5ed39925$var$performanceEventObserver || new PerformanceObserver((entries)=>{
        const list = entries.getEntries();
        for (let entry of list)if (entry.name === 'click') $b98c15df5ed39925$export$e6be05b411ce21a6(entry);
    });
    return $b98c15df5ed39925$var$performanceEventObserver;
};
const $b98c15df5ed39925$export$e6be05b411ce21a6 = (entry)=>{
    const interaction = $b98c15df5ed39925$export$2b3954d2e8509985();
    if (interaction?.type === 'press') {
        const responsiveness = interaction.responsiveness || {};
        // if happens there is another event interaction that has started after
        // the initial one, we don't want to replace the values if they have already
        // been set up
        responsiveness.experimentalInputToNextPaint = responsiveness.experimentalInputToNextPaint || entry.duration;
        responsiveness.inputDelay = responsiveness.experimentalInputToNextPaint || entry.processingStart - entry.startTime;
        interaction.responsiveness = responsiveness;
        // if the entry start time is lower than the one in the interaction
        // it means the interaction start time is not accurate, we assign
        // this value which will match the timestamp in the event
        if (entry.startTime < interaction.start) interaction.start = entry.startTime;
    }
};
function $b98c15df5ed39925$var$labelStackToString(labelStack, name) {
    const stack = [
        ...labelStack ?? []
    ];
    if (name) stack.push({
        name: name
    });
    return stack.map((l)=>l.name)?.join('/');
}
function $b98c15df5ed39925$var$labelStackToIdString(labelStack) {
    return labelStack?.map((l)=>'segmentId' in l ? `${l.name}:${l.segmentId}` : `${l.name}`)?.join('/');
}
function $b98c15df5ed39925$var$addSegmentObserver(observer) {
    $b98c15df5ed39925$var$segmentObservers.push(observer);
    for (const segmentInfo of $b98c15df5ed39925$var$segmentCache.values())observer.onAdd(segmentInfo);
}
function $b98c15df5ed39925$var$removeSegmentObserver(observer) {
    const index = $b98c15df5ed39925$var$segmentObservers.findIndex((obs)=>obs === observer);
    if (index !== -1) $b98c15df5ed39925$var$segmentObservers.splice(index, 1);
}
function $b98c15df5ed39925$export$cd7f480d6b8286c3(interactionId) {
    (0, $45w2S.interactions).delete(interactionId);
}
function $b98c15df5ed39925$export$f6f1cf5bedf83c71(ufoName, routeName = ufoName) {
    const interaction = $b98c15df5ed39925$export$2b3954d2e8509985();
    if (!interaction || interaction.type !== 'page_load' && interaction.type !== 'transition') return;
    interaction.ufoName = ufoName;
    interaction.routeName = routeName;
}
function $b98c15df5ed39925$export$12f2b6cb85d59904(interactionId, data) {
    const interaction = (0, $45w2S.interactions).get(interactionId);
    if (interaction != null) Object.keys(data).forEach((key)=>{
        interaction.metaData[key] = data[key];
    });
}
function $b98c15df5ed39925$export$e4380431c2bdabee(interactionId, labelStack, data) {
    const interaction = (0, $45w2S.interactions).get(interactionId);
    if (interaction != null) Object.keys(data).forEach((i)=>{
        interaction.customData.push({
            labelStack: labelStack,
            data: {
                [i]: data[i]
            }
        });
    });
}
function $b98c15df5ed39925$export$27cacb7d7f3fe20a(interactionId, labelStack, data) {
    const interaction = (0, $45w2S.interactions).get(interactionId);
    if (interaction != null) {
        interaction.customTimings.push({
            labelStack: labelStack,
            data: data
        });
        if ($b98c15df5ed39925$var$isPerformanceTracingEnabled()) for (const [key, timingData] of Object.entries(data)){
            const { startTime: startTime, endTime: endTime } = timingData;
            try {
                // for Firefox 102 and older
                performance.measure(`\u{1F6F8} ${$b98c15df5ed39925$var$labelStackToString(labelStack, key)} [custom_timing]`, {
                    start: startTime,
                    end: endTime
                });
            } catch (e) {
            // do nothing
            }
        }
    }
}
function $b98c15df5ed39925$export$728e28c22a0fba4(interactionId, type, name, labelStack, time = performance.now()) {
    const interaction = (0, $45w2S.interactions).get(interactionId);
    if (interaction != null) interaction.marks.push({
        type: type,
        name: name,
        labelStack: labelStack,
        time: time
    });
    if ($b98c15df5ed39925$var$isPerformanceTracingEnabled()) performance.mark(`\u{1F6F8} ${$b98c15df5ed39925$var$labelStackToString(labelStack, name)} [${type}]`, {
        startTime: time
    });
}
function $b98c15df5ed39925$export$c4b23cc624bd2fb(type, name, labelStack, time = performance.now()) {
    (0, $45w2S.interactions).forEach((interaction)=>{
        interaction.marks.push({
            type: type,
            name: name,
            labelStack: labelStack,
            time: time
        });
    });
    if ($b98c15df5ed39925$var$isPerformanceTracingEnabled()) performance.mark(`\u{1F6F8} ${$b98c15df5ed39925$var$labelStackToString(labelStack, name)} [${type}]`, {
        startTime: time
    });
}
function $b98c15df5ed39925$export$2c1d6e17cfa9bbc7(interactionId, type, name, labelStack, start, end = performance.now(), size) {
    const interaction = (0, $45w2S.interactions).get(interactionId);
    if (interaction != null) {
        interaction.spans.push({
            type: type,
            name: name,
            labelStack: labelStack,
            start: start,
            end: end,
            size: size
        });
        if ($b98c15df5ed39925$var$isPerformanceTracingEnabled()) try {
            // for Firefox 102 and older
            performance.measure(`\u{1F6F8} ${$b98c15df5ed39925$var$labelStackToString(labelStack, name)} [${type}]`, {
                start: start,
                end: end
            });
        } catch (e) {
        // do nothing
        }
    }
}
function $b98c15df5ed39925$export$943a8b2b5d6b1809(type, name, labelStack, start, end = performance.now(), size = 0) {
    (0, $45w2S.interactions).forEach((interaction)=>{
        interaction.spans.push({
            type: type,
            name: name,
            labelStack: labelStack,
            start: start,
            end: end,
            size: size
        });
    });
    if ($b98c15df5ed39925$var$isPerformanceTracingEnabled()) try {
        // for Firefox 102 and older
        performance.measure(`\u{1F6F8} ${$b98c15df5ed39925$var$labelStackToString(labelStack, name)} [${type}]`, {
            start: start,
            end: end
        });
    } catch (e) {
    // do nothing
    }
}
function $b98c15df5ed39925$export$9e04fe1a58571ec(moduleId, timestamp) {
    $b98c15df5ed39925$export$c4b23cc624bd2fb('bundle_preload', moduleId, null, timestamp);
}
function $b98c15df5ed39925$export$6f228d1fdc911d7(identifier, start, end) {
    $b98c15df5ed39925$export$943a8b2b5d6b1809('bundle_load', identifier, null, start, end - start);
}
const $b98c15df5ed39925$var$moduleLoadingRequests = {};
function $b98c15df5ed39925$export$f5a8f10de74904da(input) {
    let result = input ?? '';
    result = result.replace(/^\.\/src\/packages\//, '');
    result = result.replace(/^\.\/node_modules\//, '');
    result = result.replace(/(\/src)?\/(index|main)\.(tsx|ts|js|jsx)$/, '');
    return result;
}
function $b98c15df5ed39925$var$addHoldCriterion(id, labelStack, name, startTime) {
    if (!window.__CRITERION__?.addUFOHold) return;
    window.__CRITERION__.addUFOHold(id, $b98c15df5ed39925$var$labelStackToString(labelStack), name, startTime);
}
function $b98c15df5ed39925$var$removeHoldCriterion(id) {
    if (!window.__CRITERION__?.removeUFOHold) return;
    window.__CRITERION__.removeUFOHold(id);
}
function $b98c15df5ed39925$export$7606887303596f82(interactionId, labelStack, name, experimental) {
    const interaction = (0, $45w2S.interactions).get(interactionId);
    const id = (0, $7Jxgt.v4)();
    if (interaction != null) {
        const start = performance.now();
        const holdActive = {
            labelStack: labelStack,
            name: name,
            start: start
        };
        if ((0, $fe1wc.getConfig)()?.experimentalInteractionMetrics?.enabled && experimental) interaction.holdExpActive.set(id, {
            ...holdActive,
            start: start
        });
        if (!experimental) interaction.holdActive.set(id, {
            ...holdActive,
            start: start
        });
        $b98c15df5ed39925$var$addHoldCriterion(id, labelStack, name, start);
        return ()=>{
            const end = performance.now();
            if ($b98c15df5ed39925$var$isPerformanceTracingEnabled()) try {
                // for Firefox 102 and older
                performance.measure(`\u{1F6F8} ${$b98c15df5ed39925$var$labelStackToString(labelStack, name)} [hold]`, {
                    start: start,
                    end: end
                });
            } catch (e) {
            // do nothing
            }
            $b98c15df5ed39925$var$removeHoldCriterion(id);
            const currentInteraction = (0, $45w2S.interactions).get(interactionId);
            const currentHold = interaction.holdActive.get(id);
            const expHold = interaction.holdExpActive.get(id);
            if (currentInteraction != null) {
                if (currentHold != null) {
                    currentInteraction.holdInfo.push({
                        ...currentHold,
                        end: end
                    });
                    interaction.holdActive.delete(id);
                }
                if (expHold != null) {
                    currentInteraction.holdExpInfo.push({
                        ...expHold,
                        end: end
                    });
                    interaction.holdExpActive.delete(id);
                }
            }
        };
    }
    return ()=>{};
}
function $b98c15df5ed39925$export$10582acd678c213(interactionId, labelStack, name, id, ignoreOnSubmit) {
    const interaction = (0, $45w2S.interactions).get(interactionId);
    if (interaction != null) {
        const start = performance.now();
        interaction.holdActive.set(id, {
            labelStack: labelStack,
            name: name,
            start: start,
            ignoreOnSubmit: ignoreOnSubmit
        });
        $b98c15df5ed39925$var$addHoldCriterion(id, labelStack, name, start);
    }
    return ()=>{};
}
function $b98c15df5ed39925$export$4983dfbbb996f7ae(interactionId, id) {
    const interaction = (0, $45w2S.interactions).get(interactionId);
    if (interaction != null) {
        const end = performance.now();
        const currentInteraction = (0, $45w2S.interactions).get(interactionId);
        const currentHold = interaction.holdActive.get(id);
        if (currentInteraction != null && currentHold != null) {
            currentInteraction.holdInfo.push({
                ...currentHold,
                end: end
            });
            interaction.holdActive.delete(id);
            $b98c15df5ed39925$var$removeHoldCriterion(id);
        }
    }
}
function $b98c15df5ed39925$export$2df109852219d16e(interactionId) {
    const interaction = (0, $45w2S.interactions).get(interactionId);
    if (interaction) return interaction.type;
    return null;
}
const $b98c15df5ed39925$export$9591b52b33ccc510 = {
    onPreload (moduleId, _priority) {
        $b98c15df5ed39925$export$9e04fe1a58571ec($b98c15df5ed39925$export$f5a8f10de74904da(moduleId), performance.now());
    },
    onLoadStart (info) {
        const timeoutId = setTimeout(()=>{
            delete $b98c15df5ed39925$var$moduleLoadingRequests[info.identifier];
        }, 30000);
        const request = {
            start: performance.now(),
            timeoutId: timeoutId
        };
        $b98c15df5ed39925$var$moduleLoadingRequests[info.identifier] = request;
    },
    onLoadComplete (info) {
        const request = $b98c15df5ed39925$var$moduleLoadingRequests[info.identifier];
        if (request) {
            clearTimeout(request.timeoutId);
            delete $b98c15df5ed39925$var$moduleLoadingRequests[info.identifier];
            $b98c15df5ed39925$export$6f228d1fdc911d7($b98c15df5ed39925$export$f5a8f10de74904da(info.identifier), request.start, performance.now());
        }
    },
    placeholderFallBackMounted (id, moduleId) {
        const interactionId = (0, $1u4q7.getInteractionId)();
        const currentInteractionId = interactionId.current;
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        $b98c15df5ed39925$export$10582acd678c213(currentInteractionId, [], moduleId, id);
    },
    placeholderFallBackUnmounted (id) {
        const interactionId = (0, $1u4q7.getInteractionId)();
        const currentInteractionId = interactionId.current;
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        $b98c15df5ed39925$export$4983dfbbb996f7ae(currentInteractionId, id);
    }
};
function $b98c15df5ed39925$export$239c33984d9b1367(interactionId, name, labelStack, errorType, errorMessage, errorStack, forcedError) {
    const interaction = (0, $45w2S.interactions).get(interactionId);
    if (interaction != null) interaction.errors.push({
        name: name,
        labelStack: labelStack,
        errorType: errorType,
        errorMessage: errorMessage,
        errorStack: errorStack,
        forcedError: forcedError
    });
}
function $b98c15df5ed39925$export$7379c15afd3840fa(name, labelStack, errorType, errorMessage, errorStack) {
    (0, $45w2S.interactions).forEach((interaction)=>{
        interaction.errors.push({
            name: name,
            labelStack: labelStack,
            errorType: errorType,
            errorMessage: errorMessage,
            errorStack: errorStack
        });
    });
}
function $b98c15df5ed39925$export$53d6f611de951a13(interactionId, labelStack, type, actualDuration, baseDuration, startTime, commitTime) {
    if ($b98c15df5ed39925$var$isPerformanceTracingEnabled()) try {
        // for Firefox 102 and older
        performance.measure(`\u{1F6F8} ${$b98c15df5ed39925$var$labelStackToString(labelStack)} [react-profiler] ${type}`, {
            start: startTime,
            duration: actualDuration
        });
    } catch (e) {
    // do nothing
    }
    const interaction = (0, $45w2S.interactions).get(interactionId);
    if (interaction != null) interaction.reactProfilerTimings.push({
        labelStack: labelStack,
        type: type,
        actualDuration: actualDuration,
        baseDuration: baseDuration,
        startTime: startTime,
        commitTime: commitTime
    });
    else if ((0, $fe1wc.getConfig)()?.postInteractionLog?.enabled) $b98c15df5ed39925$export$d8f52e8f804021e8.addProfilerTimings(labelStack, type, actualDuration, baseDuration, startTime, commitTime);
}
function $b98c15df5ed39925$var$pushToQueue(id, data) {
    $b98c15df5ed39925$var$interactionQueue.push({
        id: id,
        data: data
    });
}
let $b98c15df5ed39925$var$handleInteraction = $b98c15df5ed39925$var$pushToQueue;
function $b98c15df5ed39925$var$callCleanUpCallbacks(interaction) {
    interaction.cleanupCallbacks.reverse().forEach((cleanUpCallback)=>{
        cleanUpCallback();
    });
}
function $b98c15df5ed39925$var$finishInteraction(id, data, endTime = performance.now()) {
    data.end = endTime;
    try {
        // for Firefox 102 and older
        performance.measure(`\u{1F6F8} [${data.type}] ${data.ufoName} [ttai]`, {
            start: data.start,
            end: data.end
        });
    } catch (e) {
    // do nothing
    }
    if (data.featureFlags) data.featureFlags.during = Object.fromEntries((0, $gSA3s.currentFeatureFlagsAccessed));
    (0, $tcn7E.clearActiveTrace)();
    $b98c15df5ed39925$var$callCleanUpCallbacks(data);
    if ((0, $fe1wc.getConfig)()?.vc?.stopVCAtInteractionFinish) data.vc = (0, $a0hd6.getVCObserver)().getVCRawData();
    if (!(0, $fe1wc.getConfig)()?.experimentalInteractionMetrics?.enabled) $b98c15df5ed39925$export$cd7f480d6b8286c3(id);
    $b98c15df5ed39925$var$PreviousInteractionLog.name = data.ufoName || 'unknown';
    $b98c15df5ed39925$var$PreviousInteractionLog.isAborted = data.abortReason != null;
    if (data.ufoName) $b98c15df5ed39925$var$handleInteraction(id, data);
    if ($b98c15df5ed39925$var$isPerformanceTracingEnabled()) {
        const profilerTimingMap = new Map();
        data.reactProfilerTimings.forEach((profilerTiming)=>{
            const labelStackId = $b98c15df5ed39925$var$labelStackToIdString(profilerTiming.labelStack);
            if (labelStackId) {
                const timing = profilerTimingMap.get(labelStackId) ?? {
                    labelStack: profilerTiming.labelStack
                };
                timing.start = profilerTiming.startTime < (timing.start ?? Number.MAX_SAFE_INTEGER) ? profilerTiming.startTime : timing.start;
                timing.end = profilerTiming.commitTime > (timing.end ?? Number.MIN_SAFE_INTEGER) ? profilerTiming.commitTime : timing.end;
                profilerTimingMap.set(labelStackId, timing);
            }
        });
        try {
            // for Firefox 102 and older
            for (const [, { labelStack: labelStack, start: start, end: end }] of profilerTimingMap.entries())performance.measure(`\u{1F6F8} ${$b98c15df5ed39925$var$labelStackToString(labelStack)} [segment_ttai]`, {
                start: start,
                end: end
            });
        } catch (e) {
        // do nothing
        }
    }
    try {
        // dispatch a global window event to notify the measure is completed
        window.dispatchEvent(new CustomEvent('UFO_FINISH_INTERACTION', {
            detail: data
        }));
    } catch (error) {
    // do nothing
    }
}
function $b98c15df5ed39925$export$9e614a29a1ac213e(sinkFn) {
    if ($b98c15df5ed39925$var$handleInteraction === $b98c15df5ed39925$var$pushToQueue) {
        $b98c15df5ed39925$var$handleInteraction = sinkFn;
        $b98c15df5ed39925$var$interactionQueue.forEach((interaction)=>{
            sinkFn(interaction.id, interaction.data);
        });
        $b98c15df5ed39925$var$interactionQueue.length = 0;
    }
}
function $b98c15df5ed39925$export$8a1ba7bef607358a(sinkFn) {
    $b98c15df5ed39925$export$d8f52e8f804021e8.sinkHandler(sinkFn);
}
// a flag to prevent multiple submitting
let $b98c15df5ed39925$var$activeSubmitted = false;
function $b98c15df5ed39925$export$673be905888f8839(interactionId, endTime) {
    const interaction = (0, $45w2S.interactions).get(interactionId);
    if (interaction != null) {
        const noMoreActiveHolds = interaction.holdActive.size === 0;
        const noMoreExpHolds = interaction.holdExpActive.size === 0;
        const postInteraction = async ()=>{
            if ((0, $fe1wc.getConfig)()?.postInteractionLog?.enabled) {
                let experimentalVC90;
                let experimentalTTAI;
                if ((0, $fe1wc.getConfig)()?.experimentalInteractionMetrics?.enabled) {
                    experimentalVC90 = (await (0, $f38ba.getExperimentalVCMetrics)(interaction))?.['metric:experimental:vc90'];
                    const { start: start, end: end } = interaction;
                    experimentalTTAI = !interaction.abortReason ? Math.round(end - start) : undefined;
                }
                $b98c15df5ed39925$export$d8f52e8f804021e8.onInteractionComplete({
                    ...interaction,
                    experimentalTTAI: experimentalTTAI,
                    experimentalVC90: experimentalVC90
                });
            }
            if ((0, $fe1wc.getConfig)()?.experimentalInteractionMetrics?.enabled) $b98c15df5ed39925$export$cd7f480d6b8286c3(interactionId);
            $b98c15df5ed39925$var$activeSubmitted = false;
        };
        if (noMoreActiveHolds) {
            if (!$b98c15df5ed39925$var$activeSubmitted) {
                $b98c15df5ed39925$var$finishInteraction(interactionId, interaction, endTime);
                $b98c15df5ed39925$var$activeSubmitted = true;
            }
            if (noMoreExpHolds) {
                if ((0, $fe1wc.getConfig)()?.experimentalInteractionMetrics?.enabled) (0, $f38ba.onExperimentalInteractionComplete)(interactionId, interaction, endTime);
                postInteraction();
            }
        }
    }
}
function $b98c15df5ed39925$var$callCancelCallbacks(interaction) {
    interaction.cancelCallbacks.reverse().forEach((cancelCallback)=>{
        cancelCallback();
    });
}
function $b98c15df5ed39925$export$5def58af4fd46132(interactionId, abortReason) {
    const interaction = (0, $45w2S.interactions).get(interactionId);
    if (interaction != null) {
        $b98c15df5ed39925$var$callCancelCallbacks(interaction);
        interaction.abortReason = abortReason;
        $b98c15df5ed39925$var$finishInteraction(interactionId, interaction);
        if ((0, $fe1wc.getConfig)()?.experimentalInteractionMetrics?.enabled) {
            (0, $f38ba.onExperimentalInteractionComplete)(interactionId, interaction);
            $b98c15df5ed39925$export$cd7f480d6b8286c3(interactionId);
        }
    }
}
function $b98c15df5ed39925$export$c4a545284f55edf2(interactionId, interactionName) {
    const interaction = (0, $45w2S.interactions).get(interactionId);
    if (interaction != null) {
        $b98c15df5ed39925$var$callCancelCallbacks(interaction);
        interaction.abortReason = 'new_interaction';
        interaction.abortedByInteractionName = interactionName;
        $b98c15df5ed39925$var$finishInteraction(interactionId, interaction);
        if ((0, $fe1wc.getConfig)()?.experimentalInteractionMetrics?.enabled) {
            (0, $f38ba.onExperimentalInteractionComplete)(interactionId, interaction);
            $b98c15df5ed39925$export$cd7f480d6b8286c3(interactionId);
        }
    }
}
function $b98c15df5ed39925$export$614a7af2affc5dff(abortReason, abortedByInteractionName) {
    (0, $45w2S.interactions).forEach((interaction, interactionId)=>{
        const noMoreHolds = interaction.holdActive.size === 0;
        if (!noMoreHolds) {
            $b98c15df5ed39925$var$callCancelCallbacks(interaction);
            interaction.abortReason = abortReason;
            if (abortedByInteractionName != null) interaction.abortedByInteractionName = abortedByInteractionName;
        }
        $b98c15df5ed39925$var$finishInteraction(interactionId, interaction);
        if ((0, $fe1wc.getConfig)()?.experimentalInteractionMetrics?.enabled) {
            (0, $f38ba.onExperimentalInteractionComplete)(interactionId, interaction);
            $b98c15df5ed39925$export$cd7f480d6b8286c3(interactionId);
        }
    });
}
function $b98c15df5ed39925$export$7b9261a96cfe427b(id, cancelCallback) {
    const interaction = (0, $45w2S.interactions).get(id);
    interaction?.cancelCallbacks.push(cancelCallback);
}
function $b98c15df5ed39925$export$1a1ed1e1fdb2006b(interactionId, ufoName, type, startTime, rate, labelStack, routeName, trace = null) {
    if ((0, $fe1wc.getConfig)()?.postInteractionLog?.enabled) $b98c15df5ed39925$export$d8f52e8f804021e8.reset();
    let previousTime = startTime;
    let timeoutTime = $b98c15df5ed39925$var$CLEANUP_TIMEOUT;
    const timerID = setTimeout(()=>{
        $b98c15df5ed39925$export$5def58af4fd46132(interactionId, 'timeout');
    }, $b98c15df5ed39925$var$CLEANUP_TIMEOUT);
    function changeTimeout(newTime) {
        // we compare if the time left is lower than the new time to no
        // extend the timeout beyond the initial waiting time
        const currentTime = performance.now();
        const timeLeft = timeoutTime - (currentTime - previousTime);
        if (timeLeft < newTime) return;
        clearTimeout(this.timerID);
        const newTimerID = setTimeout(()=>{
            $b98c15df5ed39925$export$5def58af4fd46132(interactionId, 'timeout');
        }, newTime);
        timeoutTime = newTime;
        previousTime = currentTime;
        this.timerID = newTimerID;
    }
    const addFeatureFlagsToInteraction = (0, $5gx4p.default)((0, $fe1wc.getCapabilityRate)('feature_flag_access'));
    const metrics = {
        id: interactionId,
        start: startTime,
        end: 0,
        ufoName: ufoName,
        type: type,
        previousInteractionName: $b98c15df5ed39925$var$PreviousInteractionLog.name,
        isPreviousInteractionAborted: $b98c15df5ed39925$var$PreviousInteractionLog.isAborted === true,
        marks: [],
        customData: [],
        customTimings: [],
        spans: [],
        requestInfo: [],
        reactProfilerTimings: [],
        holdInfo: [],
        holdExpInfo: [],
        holdActive: new Map(),
        holdExpActive: new Map(),
        // measure when we execute this code
        // from this, we can measure the input delay -
        // how long the browser took to hand execution back to JS)
        measureStart: performance.now(),
        rate: rate,
        cancelCallbacks: [],
        metaData: {},
        errors: [],
        apdex: [],
        labelStack: labelStack,
        routeName: routeName ?? ufoName,
        featureFlags: addFeatureFlagsToInteraction ? {
            prior: Object.fromEntries((0, $gSA3s.allFeatureFlagsAccessed)),
            during: {}
        } : undefined,
        knownSegments: [],
        cleanupCallbacks: [],
        awaitReactProfilerCount: 0,
        redirects: [],
        timerID: timerID,
        changeTimeout: changeTimeout,
        trace: trace
    };
    if (addFeatureFlagsToInteraction) (0, $gSA3s.currentFeatureFlagsAccessed).clear();
    (0, $45w2S.interactions).set(interactionId, metrics);
    const segmentObserver = {
        onAdd (segment) {
            metrics.knownSegments.push(segment);
        },
        onRemove () {}
    };
    $b98c15df5ed39925$var$addSegmentObserver(segmentObserver);
    metrics.cleanupCallbacks.push(()=>{
        $b98c15df5ed39925$var$removeSegmentObserver(segmentObserver);
    });
    metrics.cleanupCallbacks.push(()=>{
        clearTimeout(metrics.timerID);
    });
    const awaitBM3TTIList = (0, $fe1wc.getAwaitBM3TTIList)();
    if (awaitBM3TTIList.includes(ufoName)) $b98c15df5ed39925$export$10582acd678c213(interactionId, [], ufoName, ufoName, true);
    if (type === 'transition') {
        (0, $a0hd6.getVCObserver)().start({
            startTime: startTime
        });
        $b98c15df5ed39925$export$d8f52e8f804021e8.startVCObserver({
            startTime: startTime
        });
        if ((0, $fe1wc.getConfig)()?.experimentalInteractionMetrics?.enabled) (0, $f38ba.experimentalVC).start({
            startTime: startTime
        });
    }
}
function $b98c15df5ed39925$export$4a759336b50e86e3(event) {
    const interaction = $b98c15df5ed39925$export$2b3954d2e8509985();
    if (interaction) {
        interaction.legacyMetrics = interaction.legacyMetrics || [];
        interaction.legacyMetrics.push(event);
        if ((interaction.type === 'page_load' || interaction.type === 'transition') && event.config?.type === 'PAGE_LOAD') {
            interaction.changeTimeout($b98c15df5ed39925$var$CLEANUP_TIMEOUT_AFTER_APDEX);
            $b98c15df5ed39925$export$4983dfbbb996f7ae(interaction.id, interaction.ufoName);
        }
    }
}
function $b98c15df5ed39925$export$ad216cc25852d44b(apdex) {
    (0, $45w2S.interactions).forEach((interaction, key)=>{
        interaction.apdex.push(apdex);
        try {
            // for Firefox 102 and older
            performance.measure(`\u{1F6F8} ${apdex.key} [bm3_tti]`, {
                start: apdex.startTime ?? interaction.start,
                end: apdex.stopTime
            });
        } catch (e) {
        // do nothing
        }
        if (interaction.type === 'page_load' || interaction.type === 'transition') {
            interaction.changeTimeout($b98c15df5ed39925$var$CLEANUP_TIMEOUT_AFTER_APDEX);
            $b98c15df5ed39925$export$4983dfbbb996f7ae(key, interaction.ufoName);
        }
    });
}
function $b98c15df5ed39925$export$35220fd6cdd1b731(interactionId, apdexInfo) {
    const interaction = (0, $45w2S.interactions).get(interactionId);
    if (interaction != null) {
        interaction.apdex.push(apdexInfo);
        try {
            // for Firefox 102 and older
            performance.measure(`\u{1F6F8} ${apdexInfo.key} [bm3_tti]`, {
                start: apdexInfo.startTime ?? interaction.start,
                end: apdexInfo.stopTime
            });
        } catch (e) {
        // do nothing
        }
        if (interaction.type === 'page_load' || interaction.type === 'transition') {
            interaction.changeTimeout($b98c15df5ed39925$var$CLEANUP_TIMEOUT_AFTER_APDEX);
            $b98c15df5ed39925$export$4983dfbbb996f7ae(interactionId, interaction.ufoName);
        }
    }
}
function $b98c15df5ed39925$export$57d55b4569823d8f(interactionId, labelStack, requestInfo) {
    const interaction = (0, $45w2S.interactions).get(interactionId);
    if (interaction != null) interaction.requestInfo.push({
        labelStack: labelStack,
        ...requestInfo
    });
}
function $b98c15df5ed39925$var$isSegmentLabel(obj) {
    return obj && typeof obj.name === 'string' && typeof obj.segmentId === 'string';
}
function $b98c15df5ed39925$var$getSegmentCacheKey(labelStack) {
    return labelStack.map((l)=>{
        if ($b98c15df5ed39925$var$isSegmentLabel(l)) return `${l.name}_${l.segmentId}`;
        return l.name;
    }).join('|');
}
function $b98c15df5ed39925$export$1c43f9ac826b6462(labelStack) {
    const key = $b98c15df5ed39925$var$getSegmentCacheKey(labelStack);
    const existingSegment = $b98c15df5ed39925$var$segmentCache.get(key);
    if (!existingSegment) {
        const segmentInfo = {
            labelStack: labelStack
        };
        $b98c15df5ed39925$var$segmentCache.set(key, segmentInfo);
        $b98c15df5ed39925$var$segmentObservers.forEach((observer)=>{
            observer.onAdd(segmentInfo);
        });
    }
}
function $b98c15df5ed39925$export$d0365e48b58231c3(labelStack) {
    const key = $b98c15df5ed39925$var$getSegmentCacheKey(labelStack);
    const segmentInfo = $b98c15df5ed39925$var$segmentCache.get(key);
    if (segmentInfo) {
        $b98c15df5ed39925$var$segmentCache.delete(JSON.stringify(labelStack));
        $b98c15df5ed39925$var$segmentObservers.forEach((observer)=>{
            observer.onRemove(segmentInfo);
        });
    }
}
function $b98c15df5ed39925$export$bbf14d79614d9818(interactionId, fromUfoName, nextUfoName, nextRouteName, time) {
    const interaction = (0, $45w2S.interactions).get(interactionId);
    if (interaction != null) {
        interaction.ufoName = nextUfoName;
        interaction.routeName = nextRouteName;
        interaction.redirects.push({
            fromInteractionName: fromUfoName,
            time: time
        });
        if ($b98c15df5ed39925$var$isPerformanceTracingEnabled()) {
            const prevRedirect = interaction.redirects.at(-2);
            try {
                // for Firefox 102 and older
                performance.measure(`\u{1F6F8} ${nextUfoName} [redirect]`, {
                    start: prevRedirect?.time ?? interaction.start,
                    end: time
                });
            } catch (e) {
            // do nothing
            }
        }
    }
}
const $b98c15df5ed39925$export$6ce04c7ca6810a7e = [];
const $b98c15df5ed39925$var$defaultLabelStack = [
    {
        name: 'custom'
    }
];
function $b98c15df5ed39925$export$5342dcad19138a1c(name, start, end = performance.now(), size = 0, labelStack = $b98c15df5ed39925$var$defaultLabelStack) {
    const customSpan = {
        type: 'custom',
        name: name,
        start: start,
        end: end,
        labelStack: labelStack,
        size: size
    };
    $b98c15df5ed39925$export$6ce04c7ca6810a7e.push(customSpan);
}

});
parcelRegister("5gx4p", function(module, exports) {

$parcel$export(module.exports, "default", () => $50f3dab3adc4e602$export$2e2bcd8739ae039);
/**
 * A random function that passes one in rate times.
 * E.g. coinflip(2) is the same as if you flipped a coin.
 * It will pass 50% of the time
 * @param rate The change that it will pass (1 in <rate> times)
 * @returns bool, if it passes or not
 */ function $50f3dab3adc4e602$var$coinflip(rate) {
    if (rate === 0) return false;
    else if (rate === 1) return true;
    else return Math.random() * rate <= 1;
}
var $50f3dab3adc4e602$export$2e2bcd8739ae039 = $50f3dab3adc4e602$var$coinflip;

});

parcelRegister("fe1wc", function(module, exports) {

$parcel$export(module.exports, "setUFOConfig", () => $884a08804b0d324c$export$10d6139a8fb42158);
$parcel$export(module.exports, "getConfig", () => $884a08804b0d324c$export$44487a86467333c3);
$parcel$export(module.exports, "isVCRevisionEnabled", () => $884a08804b0d324c$export$4babcefc81a3ef0b);
$parcel$export(module.exports, "getInteractionRate", () => $884a08804b0d324c$export$9466a8f085fa7d4e);
$parcel$export(module.exports, "getExperimentalInteractionRate", () => $884a08804b0d324c$export$563f73272328c0d);
$parcel$export(module.exports, "getPostInteractionRate", () => $884a08804b0d324c$export$1d459f020c06ae34);
$parcel$export(module.exports, "getCapabilityRate", () => $884a08804b0d324c$export$29b9ffb14861a1d);
$parcel$export(module.exports, "getTypingPerformanceTracingMethod", () => $884a08804b0d324c$export$7e32aae12bf9b50f);
$parcel$export(module.exports, "getAwaitBM3TTIList", () => $884a08804b0d324c$export$2d311b3fd18dcab1);
$parcel$export(module.exports, "getUfoNameOverrides", () => $884a08804b0d324c$export$4f4649ef27b6f5d6);
$parcel$export(module.exports, "getDoNotAbortActivePressInteraction", () => $884a08804b0d324c$export$3c170167645a0eff);
$parcel$export(module.exports, "getDoNotAbortActivePressInteractionOnTransition", () => $884a08804b0d324c$export$d6dc9444bd15f70f);
let $884a08804b0d324c$var$config;
const $884a08804b0d324c$var$DEFAULT_TTVC_REVISION = 'fy25.02';
function $884a08804b0d324c$export$10d6139a8fb42158(newConfig) {
    $884a08804b0d324c$var$config = newConfig;
}
function $884a08804b0d324c$export$44487a86467333c3() {
    return $884a08804b0d324c$var$config;
}
function $884a08804b0d324c$export$87fbc8e01b137811() {
    try {
        if (!$884a08804b0d324c$var$config) return [];
        if ($884a08804b0d324c$var$config.vc?.enabled) return Array.isArray($884a08804b0d324c$var$config.vc?.enabledVCRevisions) && $884a08804b0d324c$var$config.vc?.enabledVCRevisions.length > 0 ? $884a08804b0d324c$var$config.vc.enabledVCRevisions : [
            $884a08804b0d324c$var$DEFAULT_TTVC_REVISION
        ];
        return [];
    } catch  {
        return [];
    }
}
function $884a08804b0d324c$export$4babcefc81a3ef0b(revision) {
    return $884a08804b0d324c$export$87fbc8e01b137811().includes(revision);
}
function $884a08804b0d324c$export$9466a8f085fa7d4e(name, interactionKind) {
    try {
        if (!$884a08804b0d324c$var$config) return 0;
        const { killswitch: killswitch, rates: rates, rules: rules, kind: kind, autoGeneratedRate: autoGeneratedRate } = $884a08804b0d324c$var$config;
        if (killswitch != null) {
            // Specifically kill certain events
            if (killswitch.includes(name)) return 0;
        }
        if (rates != null) {
            // Decide the rate explicitly
            if (rates[name] != null) return rates[name];
        }
        if (rules != null) for(let i = 0; i < rules.length; i++){
            const rule = rules[i];
            const { test: test, rate: rate } = rule;
            if (test != null && rate != null) {
                const regexp = new RegExp(test, 'ig');
                if (regexp.test(name)) return rate;
            }
        }
        const isAutogenerated = name?.startsWith('auto-generated');
        if (isAutogenerated) {
            const rate = autoGeneratedRate;
            if (rate != null) return rate;
        }
        if (kind != null) {
            const rate = kind[interactionKind];
            if (rate != null) return rate;
        }
        return 0;
    } catch (e) {
        // Fallback
        return 0;
    }
}
function $884a08804b0d324c$export$563f73272328c0d(name, interactionType) {
    try {
        if (!$884a08804b0d324c$var$config) return 0;
        const { experimentalInteractionMetrics: experimentalInteractionMetrics } = $884a08804b0d324c$var$config;
        if (!experimentalInteractionMetrics?.enabled) return 0;
        if (experimentalInteractionMetrics.rates && typeof experimentalInteractionMetrics.rates[name] === 'number') return experimentalInteractionMetrics.rates[name];
        if (experimentalInteractionMetrics.kind && typeof experimentalInteractionMetrics.kind[interactionType] === 'number') return experimentalInteractionMetrics.kind[interactionType];
        return 0;
    } catch (e) {
        return 0;
    }
}
function $884a08804b0d324c$export$1d459f020c06ae34(name, interactionType) {
    try {
        if (!$884a08804b0d324c$var$config) return 0;
        const { postInteractionLog: postInteractionLog } = $884a08804b0d324c$var$config;
        if (!postInteractionLog?.enabled) return 0;
        if (postInteractionLog.rates && typeof postInteractionLog.rates[name] === 'number') return postInteractionLog.rates[name];
        if (postInteractionLog.kind && typeof postInteractionLog.kind[interactionType] === 'number') return postInteractionLog.kind[interactionType];
        return 0;
    } catch (e) {
        return 0;
    }
}
function $884a08804b0d324c$export$29b9ffb14861a1d(capability) {
    try {
        if (!$884a08804b0d324c$var$config) return 0;
        const { capability: capabilityRate } = $884a08804b0d324c$var$config;
        if (capabilityRate != null) {
            const rate = capabilityRate[capability];
            if (rate != null) return rate;
        }
        return 0;
    } catch  {
        return 0;
    }
}
const $884a08804b0d324c$var$validTypingMethods = [
    'timeout',
    'timeoutNoAlloc',
    'mutationObserver'
];
function $884a08804b0d324c$export$7e32aae12bf9b50f() {
    const defaultMethod = 'timeout';
    try {
        if (!$884a08804b0d324c$var$config) return defaultMethod;
        const { typingMethod: typingMethod } = $884a08804b0d324c$var$config;
        if (typingMethod != null && $884a08804b0d324c$var$validTypingMethods.find((m)=>m === typingMethod)) return typingMethod;
        else return defaultMethod;
    } catch (e) {
        return defaultMethod;
    }
}
function $884a08804b0d324c$export$2d311b3fd18dcab1() {
    try {
        if (!$884a08804b0d324c$var$config) return [];
        const { awaitBM3TTI: awaitBM3TTI } = $884a08804b0d324c$var$config;
        if (awaitBM3TTI != null) return awaitBM3TTI;
        else return [];
    } catch (e) {
        return [];
    }
}
function $884a08804b0d324c$export$e2ea675800536898() {
    try {
        if (!$884a08804b0d324c$var$config) return false;
        const { removePageSegmentsUFOPrefixes: removePageSegmentsUFOPrefixes } = $884a08804b0d324c$var$config;
        if (removePageSegmentsUFOPrefixes != null) return removePageSegmentsUFOPrefixes;
        else return false;
    } catch (e) {
        return false;
    }
}
function $884a08804b0d324c$export$525ba53ca98e9db() {
    try {
        if (!$884a08804b0d324c$var$config) return false;
        const { removeInteractionsUFOPrefixes: removeInteractionsUFOPrefixes } = $884a08804b0d324c$var$config;
        if (removeInteractionsUFOPrefixes != null) return removeInteractionsUFOPrefixes;
        else return false;
    } catch (e) {
        return false;
    }
}
function $884a08804b0d324c$export$4f4649ef27b6f5d6() {
    try {
        if (!$884a08804b0d324c$var$config) return undefined;
        const { ufoNameOverrides: ufoNameOverrides } = $884a08804b0d324c$var$config;
        if (ufoNameOverrides != null) return ufoNameOverrides;
        return undefined;
    } catch (e) {
        return undefined;
    }
}
function $884a08804b0d324c$export$3c170167645a0eff() {
    try {
        if (!$884a08804b0d324c$var$config) return undefined;
        const { doNotAbortActivePressInteraction: doNotAbortActivePressInteraction } = $884a08804b0d324c$var$config;
        return doNotAbortActivePressInteraction;
    } catch (e) {
        return undefined;
    }
}
function $884a08804b0d324c$export$d6dc9444bd15f70f() {
    try {
        if (!$884a08804b0d324c$var$config) return undefined;
        const { doNotAbortActivePressInteractionOnTransition: doNotAbortActivePressInteractionOnTransition } = $884a08804b0d324c$var$config;
        return doNotAbortActivePressInteractionOnTransition;
    } catch (e) {
        return undefined;
    }
}

});

parcelRegister("f38ba", function(module, exports) {

$parcel$export(module.exports, "sinkExperimentalHandler", () => $ae10169b4d4f0485$export$7aa99c40634ac65f);
$parcel$export(module.exports, "onExperimentalInteractionComplete", () => $ae10169b4d4f0485$export$1aed449484dedf63);
$parcel$export(module.exports, "experimentalVC", () => $ae10169b4d4f0485$export$81b28dca2587ec47);
$parcel$export(module.exports, "getExperimentalVCMetrics", () => $ae10169b4d4f0485$export$d17d2b5c5e8d732e);

var $37gc9 = parcelRequire("37gc9");

var $h2sI1 = parcelRequire("h2sI1");
const $ae10169b4d4f0485$var$interactionBuffer = [];
let $ae10169b4d4f0485$var$bufferInteractionData = (interactionId, data)=>{
    $ae10169b4d4f0485$var$interactionBuffer.push({
        interactionId: interactionId,
        data: data
    });
};
function $ae10169b4d4f0485$var$clearInteractionBuffer() {
    $ae10169b4d4f0485$var$interactionBuffer.length = 0;
}
function $ae10169b4d4f0485$var$appendInteractionData(interactionId, data) {
    $ae10169b4d4f0485$var$bufferInteractionData(interactionId, data);
}
function $ae10169b4d4f0485$export$c8a9e17ae62a073d(handler) {
    for (const { interactionId: interactionId, data: data } of $ae10169b4d4f0485$var$interactionBuffer)handler(interactionId, data);
    $ae10169b4d4f0485$var$clearInteractionBuffer();
    $ae10169b4d4f0485$var$bufferInteractionData = handler;
}
function $ae10169b4d4f0485$export$7aa99c40634ac65f(sinkFn) {
    $ae10169b4d4f0485$export$c8a9e17ae62a073d(sinkFn);
}
function $ae10169b4d4f0485$export$1aed449484dedf63(interactionId, data, endTime = performance.now()) {
    if (data.ufoName) {
        data.end = endTime;
        $ae10169b4d4f0485$var$appendInteractionData(interactionId, data);
        $ae10169b4d4f0485$var$clearInteractionBuffer();
    }
}
class $ae10169b4d4f0485$export$f9a59f57e0282541 {
    initialize(options) {
        if (this.vcObserver === null) this.vcObserver = new (0, $h2sI1.VCObserver)({
            ...options,
            isPostInteraction: true
        });
        return this;
    }
    start({ startTime: startTime }) {
        this.vcObserver?.start({
            startTime: startTime
        });
    }
    constructor(){
        this.vcObserver = null;
    }
}
const $ae10169b4d4f0485$export$81b28dca2587ec47 = new $ae10169b4d4f0485$export$f9a59f57e0282541();
async function $ae10169b4d4f0485$export$d17d2b5c5e8d732e(interaction) {
    if ($ae10169b4d4f0485$export$81b28dca2587ec47.vcObserver) {
        const prefix = 'ufo-experimental';
        const result = await $ae10169b4d4f0485$export$81b28dca2587ec47.vcObserver.getVCResult({
            start: interaction.start,
            stop: interaction.end,
            tti: interaction.apdex?.[0]?.stopTime,
            isEventAborted: !!interaction.abortReason,
            prefix: prefix,
            vc: interaction.vc
        });
        const VC = result?.['metrics:vc'];
        if (!VC || !result?.[`${prefix}:vc:clean`]) return result;
        const pageVisibilityUpToTTAI = (0, $37gc9.getPageVisibilityState)(interaction.start, interaction.end);
        if (interaction.abortReason || pageVisibilityUpToTTAI !== 'visible') return result;
        return {
            ...result,
            'metric:experimental:vc90': VC['90']
        };
    }
    return null;
}

});
parcelRegister("37gc9", function(module, exports) {

$parcel$export(module.exports, "setupHiddenTimingCapture", () => $9d4714fe1b0ac403$export$554cefe0f0373da4);
$parcel$export(module.exports, "getPageVisibilityState", () => $9d4714fe1b0ac403$export$768b2008623433e1);

var $cBeZP = parcelRequire("cBeZP");
const $9d4714fe1b0ac403$var$timings = [];
let $9d4714fe1b0ac403$var$wasHiddenFlag;
let $9d4714fe1b0ac403$var$setupFlag = false;
function $9d4714fe1b0ac403$var$isPageHidden() {
    if ('visibilityState' in document) return document.visibilityState === 'hidden';
    else // @ts-expect-error - Property 'hidden' does not exist on type 'never'.
    return document.hidden;
}
const $9d4714fe1b0ac403$var$SIZE = 50;
let $9d4714fe1b0ac403$var$insertIndex = 0;
function $9d4714fe1b0ac403$var$pushHidden(isPageHiddenFlag, time) {
    $9d4714fe1b0ac403$var$timings[$9d4714fe1b0ac403$var$insertIndex] = {
        time: time ?? performance.now(),
        hidden: isPageHiddenFlag
    };
    $9d4714fe1b0ac403$var$insertIndex = ($9d4714fe1b0ac403$var$insertIndex + 1) % $9d4714fe1b0ac403$var$SIZE;
    $9d4714fe1b0ac403$var$wasHiddenFlag = isPageHiddenFlag;
}
function $9d4714fe1b0ac403$var$handleChange() {
    const isPageHiddenFlag = $9d4714fe1b0ac403$var$isPageHidden();
    if (isPageHiddenFlag) {
        if (!$9d4714fe1b0ac403$var$wasHiddenFlag) $9d4714fe1b0ac403$var$pushHidden(isPageHiddenFlag);
        $9d4714fe1b0ac403$var$wasHiddenFlag = true;
    } else {
        if ($9d4714fe1b0ac403$var$wasHiddenFlag) $9d4714fe1b0ac403$var$pushHidden(isPageHiddenFlag);
        $9d4714fe1b0ac403$var$wasHiddenFlag = false;
    }
}
function $9d4714fe1b0ac403$var$setup() {
    (0, $cBeZP.bind)(window, {
        type: 'pageshow',
        listener: $9d4714fe1b0ac403$var$handleChange
    });
    (0, $cBeZP.bind)(window, {
        type: 'pagehide',
        listener: $9d4714fe1b0ac403$var$handleChange
    });
    (0, $cBeZP.bind)(document, {
        type: 'visibilitychange',
        listener: $9d4714fe1b0ac403$var$handleChange
    });
}
function $9d4714fe1b0ac403$export$554cefe0f0373da4() {
    if (!$9d4714fe1b0ac403$var$setupFlag) {
        const isPageHiddenFlag = $9d4714fe1b0ac403$var$isPageHidden();
        $9d4714fe1b0ac403$var$pushHidden(isPageHiddenFlag, 0);
        $9d4714fe1b0ac403$var$setup();
        $9d4714fe1b0ac403$var$setupFlag = true;
    }
}
function $9d4714fe1b0ac403$export$768b2008623433e1(start, end) {
    // Desirable default value is visible
    if ($9d4714fe1b0ac403$var$timings.length === 0) return 'visible';
    const currentSize = $9d4714fe1b0ac403$var$timings.length;
    let hiddenState = 'mixed';
    let startIdx = $9d4714fe1b0ac403$var$insertIndex;
    let endIdx = $9d4714fe1b0ac403$var$insertIndex;
    // currentSize is capped at SIZE.
    for(let i = 0; i < currentSize; i++){
        const tmpIdx = ($9d4714fe1b0ac403$var$insertIndex + i) % currentSize;
        if ($9d4714fe1b0ac403$var$timings[tmpIdx].time <= end) {
            endIdx = tmpIdx;
            if ($9d4714fe1b0ac403$var$timings[tmpIdx].time <= start) startIdx = tmpIdx;
        }
    }
    if (endIdx - startIdx === 0) {
        if ($9d4714fe1b0ac403$var$timings[startIdx].hidden) hiddenState = 'hidden';
        else hiddenState = 'visible';
    }
    return hiddenState;
}

});

parcelRegister("h2sI1", function(module, exports) {

$parcel$export(module.exports, "VCObserver", () => $8281afea1c2bf80e$export$1f70d263701b1d01);

var $VSDnB = parcelRequire("VSDnB");

var $fe1wc = parcelRequire("fe1wc");

var $aceO8 = parcelRequire("aceO8");

var $5lAmc = parcelRequire("5lAmc");

var $epQcA = parcelRequire("epQcA");

var $6Subd = parcelRequire("6Subd");

var $eZGsd = parcelRequire("eZGsd");

var $joHOM = parcelRequire("joHOM");
const $8281afea1c2bf80e$var$abortReason = {
    scroll: 'scroll',
    keypress: 'keypress',
    resize: 'resize',
    error: 'error'
};
const $8281afea1c2bf80e$var$UNUSED_SECTOR = 0;
function $8281afea1c2bf80e$var$filterComponentsLog(log) {
    return Object.fromEntries(Object.entries(log).map(([timestamp, entries])=>[
            Number(timestamp),
            entries.map((entry)=>{
                const { __debug__element: __debug__element, ...rest } = entry;
                return rest;
            })
        ]));
}
class $8281afea1c2bf80e$export$1f70d263701b1d01 {
    static{
        /** config * */ this.VCParts = [
            '25',
            '50',
            '75',
            '80',
            '85',
            '90',
            '95',
            '98',
            '99'
        ];
    }
    constructor(options){
        /* abort logic */ this.abortReason = {
            reason: null,
            info: '',
            timestamp: -1,
            blocking: false
        };
        this.outOfBoundaryInfo = '';
        this.viewport = {
            w: 0,
            h: 0
        };
        /* heatmap */ this.arraySize = 0;
        this.multiHeatmap = null;
        this.componentsLog = {};
        this.vcRatios = {};
        this.active = false;
        this.totalTime = 0;
        this.startTime = 0;
        this._startMeasureTimestamp = -1;
        this.ssr = {
            reactRendered: -1
        };
        this.unbind = [];
        this.getAbortReasonInfo = ()=>{
            if (this.abortReason.reason === null) return null;
            const info = this.abortReason.info !== '' ? ` ${this.abortReason.info}` : '';
            return `${this.abortReason.reason}${info}`;
        };
        this.getVCRawData = ()=>{
            this.measureStart();
            if (!this.active) {
                this.measureStop();
                return null;
            }
            this.stop();
            const abortReasonInfo = this.getAbortReasonInfo();
            this.measureStop();
            return {
                abortReasonInfo: abortReasonInfo,
                abortReason: {
                    ...this.abortReason
                },
                heatmap: this.heatmap,
                heatmapNext: this.heatmapNext,
                multiHeatmap: this.multiHeatmap,
                outOfBoundaryInfo: this.outOfBoundaryInfo,
                totalTime: Math.round(this.totalTime + this.observers.getTotalTime()),
                componentsLog: {
                    ...this.componentsLog
                },
                viewport: {
                    ...this.viewport
                },
                oldDomUpdatesEnabled: this.oldDomUpdatesEnabled,
                devToolsEnabled: this.devToolsEnabled,
                ratios: this.vcRatios
            };
        };
        this.getVCResult = async ({ start: start, stop: stop, tti: tti, prefix: prefix, ssr: ssr, vc: vc, isEventAborted: isEventAborted })=>{
            const startTime = performance.now();
            // add local measurement
            const fullPrefix = prefix !== undefined && prefix !== '' ? `${prefix}:` : '';
            const rawData = vc !== undefined ? vc : this.getVCRawData();
            if (rawData === null) return {};
            const { abortReason: abortReason, abortReasonInfo: abortReasonInfo, heatmap: heatmap, heatmapNext: heatmapNext, outOfBoundaryInfo: outOfBoundaryInfo, totalTime: totalTime, componentsLog: componentsLog, viewport: viewport, devToolsEnabled: devToolsEnabled, ratios: ratios, multiHeatmap: multiHeatmap } = rawData;
            const isTTVCv1Disabled = !(0, $fe1wc.isVCRevisionEnabled)('fy25.01');
            // NOTE: as part of platform_ufo_add_vc_abort_reason_by_revisions feature,
            // we want to report abort by scroll events the same way as other abort reasons
            // i.e. not have the concept of `abortReason.blocking` anymore
            if (abortReasonInfo !== null && (0, $VSDnB.fg)('platform_ufo_add_vc_abort_reason_by_revisions')) {
                // exposing data to devtools
                try {
                    if (devToolsEnabled && !this.isPostInteraction) window.__vcNotAvailableReason = abortReasonInfo;
                } catch (e) {}
                const vcAbortedResultWithRevisions = {
                    [`${fullPrefix}vc:state`]: false,
                    [`${fullPrefix}vc:abort:reason`]: abortReason.reason,
                    [`${fullPrefix}vc:abort:timestamp`]: abortReason.timestamp,
                    [`${fullPrefix}vc:rev`]: [
                        {
                            revision: 'fy25.02',
                            clean: false,
                            'metric:vc90': null,
                            abortReason: abortReason.reason
                        }
                    ]
                };
                if (!isTTVCv1Disabled) vcAbortedResultWithRevisions[`${fullPrefix}vc:rev`].push({
                    revision: 'fy25.01',
                    clean: false,
                    'metric:vc90': null,
                    abortReason: abortReason.reason
                });
                return vcAbortedResultWithRevisions;
            } else if (abortReasonInfo !== null && abortReason.blocking) {
                // exposing data to devtools
                try {
                    if (devToolsEnabled && !this.isPostInteraction) window.__vcNotAvailableReason = abortReasonInfo;
                } catch (e) {}
                return {
                    [`${fullPrefix}vc:state`]: false,
                    [`${fullPrefix}vc:abort:reason`]: abortReasonInfo,
                    [`${fullPrefix}vc:abort:timestamp`]: abortReason.timestamp
                };
            }
            const ttvcV1Result = isTTVCv1Disabled ? {
                VC: {},
                VCBox: {},
                VCEntries: {
                    abs: [],
                    rel: [],
                    speedIndex: -1
                },
                totalPainted: -1
            } : $8281afea1c2bf80e$export$1f70d263701b1d01.calculateVC({
                heatmap: heatmap,
                ssr: ssr,
                componentsLog: {
                    ...componentsLog
                },
                viewport: viewport
            });
            const { VC: VC, VCBox: VCBox, VCEntries: VCEntries, totalPainted: totalPainted } = ttvcV1Result;
            const _componentsLog = {};
            Object.entries(this.componentsLog).forEach(([_timestamp, value])=>{
                const timestamp = Number(_timestamp);
                if (stop > timestamp) _componentsLog[timestamp] = value;
            });
            const vcNext = $8281afea1c2bf80e$export$1f70d263701b1d01.calculateVC({
                heatmap: heatmapNext,
                ssr: ssr,
                componentsLog: _componentsLog,
                viewport: viewport
            });
            try {
                if (!this.isPostInteraction) $8281afea1c2bf80e$export$1f70d263701b1d01.VCParts.forEach((key)=>{
                    if (isTTVCv1Disabled) {
                        const duration = vcNext.VC[key];
                        if (duration !== null && duration !== undefined) {
                            performance.measure(`VC${key}`, {
                                start: start,
                                duration: duration
                            });
                            performance.measure(`VC_Next${key}`, {
                                start: start,
                                duration: duration
                            });
                        }
                    } else {
                        const ttvcV1duration = VC[key];
                        if (ttvcV1duration !== null && ttvcV1duration !== undefined) performance.measure(`VC${key}`, {
                            start: start,
                            duration: ttvcV1duration
                        });
                        const ttvcV2duration = vcNext.VC[key];
                        if (ttvcV2duration !== null && ttvcV2duration !== undefined) performance.measure(`VC_Next${key}`, {
                            start: start,
                            duration: ttvcV2duration
                        });
                    }
                });
            } catch (e) {
            /* empty */ }
            const outOfBoundary = outOfBoundaryInfo ? {
                [`${fullPrefix}vc:oob`]: outOfBoundaryInfo
            } : {};
            //const oldDomUpdates = oldDomUpdatesEnabled ? { [`${fullPrefix}vc:old:dom`]: vcNext.VCBox } : {};
            const stopTime = performance.now();
            // exposing data to devtools
            try {
                if (!this.isPostInteraction && devToolsEnabled) {
                    const ttvcV1DevToolInfo = isTTVCv1Disabled ? undefined : {
                        entries: VCEntries.rel,
                        log: componentsLog,
                        metrics: {
                            '75': VC['75'],
                            '80': VC['80'],
                            '85': VC['85'],
                            '90': VC['90'],
                            '95': VC['95'],
                            '98': VC['98'],
                            '99': VC['99'],
                            tti: tti,
                            ttai: stop - start
                        },
                        start: start,
                        stop: stop,
                        heatmap: heatmap,
                        ratios: ratios
                    };
                    const ttvcV2DevToolInfo = {
                        entries: vcNext.VCEntries.rel,
                        log: componentsLog,
                        metrics: {
                            '75': vcNext.VC['75'],
                            '80': vcNext.VC['80'],
                            '85': vcNext.VC['85'],
                            '90': vcNext.VC['90'],
                            '95': vcNext.VC['95'],
                            '98': vcNext.VC['98'],
                            '99': vcNext.VC['99'],
                            tti: tti,
                            ttai: stop - start
                        },
                        start: start,
                        stop: stop,
                        heatmap: heatmapNext,
                        ratios: ratios
                    };
                    if (isTTVCv1Disabled) {
                        window.__vc = ttvcV2DevToolInfo;
                        window.__vcNext = ttvcV2DevToolInfo;
                    } else {
                        window.__vc = ttvcV1DevToolInfo;
                        window.__vcNext = ttvcV2DevToolInfo;
                    }
                    // Emitting a custom event to make it available in the Chrome extension
                    window.dispatchEvent(new CustomEvent('vcReady', {
                        detail: {
                            log: $8281afea1c2bf80e$var$filterComponentsLog(componentsLog),
                            entries: isTTVCv1Disabled ? vcNext.VCEntries.rel : VCEntries.rel
                        }
                    }));
                }
            } catch (e) {
            /*  do nothing */ }
            const isVCClean = !abortReasonInfo;
            const revisionsData = (0, $5lAmc.getVCRevisionsData)({
                fullPrefix: fullPrefix,
                interaction: {
                    start: start,
                    end: stop
                },
                isVCClean: isVCClean,
                multiHeatmap: multiHeatmap,
                ssr: ssr,
                calculatedVC: {
                    VC: VC,
                    VCBox: VCBox
                },
                calculatedVCNext: {
                    VC: vcNext.VC,
                    VCBox: vcNext.VCBox
                },
                isEventAborted: isEventAborted
            });
            const speedIndex = {
                [`ufo:speedIndex`]: isTTVCv1Disabled ? vcNext.VCEntries.speedIndex : VCEntries.speedIndex,
                [`ufo:next:speedIndex`]: vcNext.VCEntries.speedIndex
            };
            if (isTTVCv1Disabled) return {
                [`${fullPrefix}vc:size`]: viewport,
                [`${fullPrefix}vc:time`]: Math.round(totalTime + (stopTime - startTime)),
                [`${fullPrefix}vc:ratios`]: ratios,
                ...outOfBoundary,
                [`${fullPrefix}vc:ignored`]: this.getIgnoredElements(componentsLog),
                ...revisionsData,
                ...speedIndex
            };
            const isTTVCv3Enabled = (0, $fe1wc.isVCRevisionEnabled)('fy25.03');
            return {
                'metrics:vc': VC,
                [`${fullPrefix}vc:state`]: true,
                [`${fullPrefix}vc:clean`]: isVCClean,
                [`${fullPrefix}vc:dom`]: VCBox,
                [`${fullPrefix}vc:updates`]: isTTVCv3Enabled ? undefined : VCEntries.rel.slice(0, 50),
                [`${fullPrefix}vc:size`]: viewport,
                [`${fullPrefix}vc:time`]: Math.round(totalTime + (stopTime - startTime)),
                [`${fullPrefix}vc:total`]: totalPainted,
                [`${fullPrefix}vc:ratios`]: ratios,
                ...outOfBoundary,
                [`${fullPrefix}vc:next`]: vcNext.VC,
                [`${fullPrefix}vc:next:updates`]: isTTVCv3Enabled ? undefined : vcNext.VCEntries.rel.slice(0, 50),
                [`${fullPrefix}vc:next:dom`]: vcNext.VCBox,
                [`${fullPrefix}vc:ignored`]: this.getIgnoredElements(componentsLog),
                ...revisionsData,
                ...speedIndex
            };
        };
        this.handleUpdate = (rawTime, intersectionRect, targetName, element, type, ignoreReason, attributeName, oldValue, newValue)=>{
            this.measureStart();
            this.legacyHandleUpdate(rawTime, intersectionRect, targetName, element, type, ignoreReason, attributeName, oldValue, newValue);
            if (!(0, $fe1wc.isVCRevisionEnabled)('fy25.03')) this.onViewportChangeDetected({
                timestamp: rawTime,
                intersectionRect: intersectionRect,
                targetName: targetName,
                element: element,
                type: type,
                ignoreReason: ignoreReason,
                attributeName: attributeName,
                oldValue: oldValue,
                newValue: newValue
            });
            this.measureStop();
        };
        this.legacyHandleUpdate = (rawTime, intersectionRect, targetName, element, type, ignoreReason, attributeName, oldValue, newValue)=>{
            if (this.abortReason.reason === null || this.abortReason.blocking === false) {
                const time = Math.round(rawTime - this.startTime);
                const mappedValues = this.mapPixelsToHeatmap(intersectionRect.left, intersectionRect.top, intersectionRect.width, intersectionRect.height);
                this.vcRatios[targetName] = this.getElementRatio(mappedValues);
                if (!ignoreReason) this.applyChangesToHeatMap(mappedValues, time, this.heatmapNext);
                const isTTVCv1Disabled = !(0, $fe1wc.isVCRevisionEnabled)('fy25.01');
                if (!isTTVCv1Disabled && (!ignoreReason || ignoreReason === 'not-visible') && type !== 'attr') this.applyChangesToHeatMap(mappedValues, time, this.heatmap);
                if (!this.componentsLog[time]) this.componentsLog[time] = [];
                this.componentsLog[time].push({
                    __debug__element: this.devToolsEnabled ? new WeakRef(element) : null,
                    type: type,
                    intersectionRect: intersectionRect,
                    targetName: targetName,
                    ignoreReason: ignoreReason,
                    attributeName: attributeName,
                    oldValue: oldValue,
                    newValue: newValue
                });
            }
        };
        this.onViewportChangeDetected = ({ element: element, type: type, ignoreReason: ignoreReason, timestamp: timestamp, targetName: targetName, intersectionRect: intersectionRect, attributeName: attributeName, oldValue: oldValue, newValue: newValue })=>{
            if (this.multiHeatmap === null) return;
            // @todo add abort reason handling
            const time = Math.round(timestamp - this.startTime);
            const revisions = (0, $joHOM.getRevisions)();
            const revisionsClassification = revisions.map((revision)=>{
                return revision.classifier.classifyUpdate({
                    element: element,
                    type: type,
                    ignoreReason: ignoreReason
                });
            }, []);
            this.multiHeatmap.handleUpdate({
                time: time,
                targetName: targetName,
                intersectionRect: intersectionRect,
                type: type,
                element: element,
                classification: revisionsClassification,
                onError: (error)=>{
                    this.setAbortReason($8281afea1c2bf80e$var$abortReason.error, error.time, error.error);
                },
                attributeName: attributeName,
                oldValue: oldValue,
                newValue: newValue
            });
        };
        this.mapPixelsToHeatmap = (left, top, width, height)=>{
            const { w: w, h: h } = this.viewport;
            const l = Math.floor(left / w * this.arraySize);
            const t = Math.floor(top / h * this.arraySize);
            const r = Math.ceil((left + width) / w * this.arraySize);
            const b = Math.ceil((top + height) / h * this.arraySize);
            // that info is temporary to get info why it goes over boundary
            if (this.outOfBoundaryInfo === '') {
                let outOfBoundaryInfo = '';
                if (r > this.arraySize) outOfBoundaryInfo += ` r ${r} ! ${left} ${width}`;
                if (b > this.arraySize) outOfBoundaryInfo += ` r ${r} ! ${top} ${height}`;
                this.outOfBoundaryInfo = outOfBoundaryInfo;
            }
            // correct values to min - 0, max - arraySize
            const result = {
                l: Math.max(0, l),
                t: Math.max(0, t),
                r: Math.min(this.arraySize, r),
                b: Math.min(this.arraySize, b)
            };
            return result;
        };
        this.getElementRatio = (mappedValues)=>{
            const { r: r, l: l, b: b, t: t } = mappedValues;
            return (r - l) * (b - t) / (this.arraySize * this.arraySize);
        };
        this.abortReasonCallback = (key, time)=>{
            switch(key){
                case 'wheel':
                    this.setAbortReason($8281afea1c2bf80e$var$abortReason.scroll, time);
                    break;
                case 'keydown':
                    this.setAbortReason($8281afea1c2bf80e$var$abortReason.keypress, time);
                    break;
                case 'resize':
                    this.setAbortReason($8281afea1c2bf80e$var$abortReason.resize, time);
                    break;
            }
        };
        this.attachAbortListeners = ()=>{
            this.detachAbortListeners();
            let unbinds = (0, $aceO8.attachAbortListeners)(window, this.viewport, this.abortReasonCallback);
            if (window?.__SSR_ABORT_LISTENERS__) {
                Object.entries(window.__SSR_ABORT_LISTENERS__.aborts).forEach(([key, time])=>{
                    if (time) this.abortReasonCallback(key, time);
                });
                unbinds = unbinds.concat(window.__SSR_ABORT_LISTENERS__.unbinds);
                delete window?.__SSR_ABORT_LISTENERS__;
            }
            this.unbind = unbinds;
        };
        this.arraySize = options.heatmapSize || 200;
        this.devToolsEnabled = options.devToolsEnabled || false;
        this.oldDomUpdatesEnabled = options.oldDomUpdates || false;
        this.observers = new (0, $eZGsd.Observers)({
            selectorConfig: options.selectorConfig || {
                id: false,
                testId: false,
                role: false,
                className: true,
                dataVC: true
            }
        });
        this.heatmap = !(0, $fe1wc.isVCRevisionEnabled)('fy25.01') ? [] : this.getCleanHeatmap();
        this.heatmapNext = this.getCleanHeatmap();
        this.multiHeatmap = new (0, $6Subd.MultiRevisionHeatmap)({
            viewport: this.viewport,
            revisions: (0, $joHOM.getRevisions)(),
            devToolsEnabled: this.devToolsEnabled
        });
        this.isPostInteraction = options.isPostInteraction || false;
    }
    start({ startTime: startTime }) {
        this.active = true;
        if (this.observers.isBrowserSupported()) {
            this.setViewportSize();
            this.resetState();
            this.startTime = startTime;
            this.attachAbortListeners();
            this.observers.subscribeResults(this.handleUpdate);
            this.observers.observe();
        } else this.setAbortReason('not-supported', startTime);
    }
    stop() {
        this.observers.disconnect();
        this.detachAbortListeners();
    }
    getIgnoredElements(componentsLog) {
        return Object.values(componentsLog).flat().filter(({ ignoreReason: ignoreReason })=>Boolean(ignoreReason)).map(({ targetName: targetName, ignoreReason: ignoreReason })=>({
                targetName: targetName,
                ignoreReason: ignoreReason
            }));
    }
    static calculateVC({ heatmap: heatmap, ssr: ssr = $8281afea1c2bf80e$var$UNUSED_SECTOR, componentsLog: componentsLog, viewport: viewport }) {
        const lastUpdate = {};
        let totalPainted = 0;
        if (ssr !== $8281afea1c2bf80e$var$UNUSED_SECTOR) {
            const element = {
                __debug__element: new WeakRef(window.document?.body),
                intersectionRect: {
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    x: 0,
                    y: 0,
                    width: viewport.w,
                    height: viewport.h,
                    toJSON () {
                        return {};
                    }
                },
                targetName: 'SSR'
            };
            if (!componentsLog[ssr]) componentsLog[ssr] = [];
            componentsLog[ssr].push(element);
        }
        heatmap.forEach((line)=>{
            line.forEach((entry)=>{
                const rounded = Math.floor(entry === $8281afea1c2bf80e$var$UNUSED_SECTOR && ssr !== $8281afea1c2bf80e$var$UNUSED_SECTOR ? ssr : entry);
                totalPainted += rounded !== $8281afea1c2bf80e$var$UNUSED_SECTOR ? 1 : 0;
                if (rounded !== $8281afea1c2bf80e$var$UNUSED_SECTOR) lastUpdate[rounded] = lastUpdate[rounded] ? lastUpdate[rounded] + 1 : 1;
            });
        });
        const entries = Object.entries(lastUpdate).map((a)=>[
                parseInt(a[0], 10),
                a[1]
            ]).sort((a, b)=>a[0] > b[0] ? 1 : -1);
        const VC = $8281afea1c2bf80e$export$1f70d263701b1d01.makeVCReturnObj();
        const VCBox = $8281afea1c2bf80e$export$1f70d263701b1d01.makeVCReturnObj();
        entries.reduce((acc = 0, v)=>{
            const currRatio = v[1] / totalPainted;
            let VCRatio = currRatio + acc;
            const preciseCurrRatio = Math.round(100 * (v[1] / totalPainted));
            const preciseAccRatio = Math.round(acc * 100);
            VCRatio = (preciseCurrRatio + preciseAccRatio) / 100;
            const time = v[0];
            $8281afea1c2bf80e$export$1f70d263701b1d01.VCParts.forEach((key)=>{
                const value = parseInt(key, 10);
                if ((VC[key] === null || VC[key] === undefined) && VCRatio >= value / 100) {
                    VC[key] = time;
                    VCBox[key] = [
                        ...new Set(componentsLog[time]?.filter((v)=>!v.ignoreReason).map((v)=>v.targetName))
                    ];
                }
            });
            return VCRatio;
        }, 0);
        const VCEntries = entries.reduce((acc, [timestamp, entryPainted], i)=>{
            const currentlyPainted = entryPainted + (acc.abs[i - 1]?.[1] || 0);
            const currentlyPaintedRatio = Math.round(currentlyPainted / totalPainted * 1000) / 10;
            const logEntry = [
                ...new Set(componentsLog[timestamp]?.filter((v)=>!v.ignoreReason).map((v)=>v.targetName))
            ];
            const ratioDelta = (currentlyPaintedRatio - (acc.rel[i - 1]?.vc ?? 0)) / 100;
            const speedIndex = timestamp * ratioDelta;
            acc.speedIndex += speedIndex;
            acc.abs.push([
                timestamp,
                currentlyPainted
            ]);
            acc.rel.push({
                time: timestamp,
                vc: currentlyPaintedRatio,
                elements: logEntry
            });
            return acc;
        }, {
            abs: [],
            rel: [],
            speedIndex: 0
        });
        VCEntries.speedIndex = Math.round(VCEntries.speedIndex);
        return {
            VC: VC,
            VCBox: VCBox,
            VCEntries: VCEntries,
            totalPainted: totalPainted
        };
    }
    setSSRElement(element) {
        this.observers.setReactRootElement(element);
    }
    setReactRootRenderStart(startTime = performance.now()) {
        this.observers.setReactRootRenderStart(startTime);
    }
    setReactRootRenderStop(stopTime = performance.now()) {
        this.observers.setReactRootRenderStop(stopTime);
    }
    setAbortReason(abort, timestamp, info = '') {
        if (this.abortReason.reason === null || this.abortReason.blocking === false) {
            this.abortReason.reason = abort;
            this.abortReason.info = info;
            this.abortReason.timestamp = timestamp;
            this.abortReason.blocking = abort !== $8281afea1c2bf80e$var$abortReason.scroll;
            if (this.abortReason.blocking) this.detachAbortListeners();
        }
    }
    resetState() {
        this.abortReason = {
            reason: null,
            info: '',
            timestamp: -1,
            blocking: false
        };
        this.detachAbortListeners();
        this.heatmap = !(0, $fe1wc.isVCRevisionEnabled)('fy25.01') ? [] : this.getCleanHeatmap();
        this.heatmapNext = this.getCleanHeatmap();
        this.multiHeatmap = new (0, $6Subd.MultiRevisionHeatmap)({
            viewport: this.viewport,
            revisions: (0, $joHOM.getRevisions)(),
            devToolsEnabled: this.devToolsEnabled
        });
        this.totalTime = 0;
        this.componentsLog = {};
        this.vcRatios = {};
    }
    getCleanHeatmap() {
        return Array(this.arraySize).fill('').map(()=>Array(this.arraySize).fill($8281afea1c2bf80e$var$UNUSED_SECTOR));
    }
    setViewportSize() {
        this.viewport.w = (0, $epQcA.getViewportWidth)();
        this.viewport.h = (0, $epQcA.getViewportHeight)();
    }
    applyChangesToHeatMap(a, time, heatmap) {
        const { l: l, t: t, r: r, b: b } = a;
        const localHeatmap = heatmap;
        for(let row = t; row < b; row++){
            for(let col = l; col < r; col++)if (localHeatmap[row] === undefined) {
                try {
                    this.setAbortReason($8281afea1c2bf80e$var$abortReason.error, time, `index - ${row}`);
                } catch (e) {
                    this.setAbortReason($8281afea1c2bf80e$var$abortReason.error, time, 'row error');
                }
                return;
            } else localHeatmap[row][col] = time;
        }
    }
    static makeVCReturnObj() {
        const vc = {};
        $8281afea1c2bf80e$export$1f70d263701b1d01.VCParts.forEach((v)=>{
            vc[v] = null;
        });
        return vc;
    }
    detachAbortListeners() {
        if (Array.isArray(this.unbind)) {
            this.unbind.forEach((fn)=>fn());
            this.unbind = [];
        }
    }
    measureStart() {
        this._startMeasureTimestamp = performance.now();
    }
    measureStop() {
        if (this._startMeasureTimestamp === -1) return;
        this.totalTime += performance.now() - this._startMeasureTimestamp;
        this._startMeasureTimestamp = -1;
    }
}

});
parcelRegister("aceO8", function(module, exports) {

$parcel$export(module.exports, "attachAbortListeners", () => $05d54f94441303a8$export$9010aa71841a6887);

var $cBeZP = parcelRequire("cBeZP");

var $Pu2vb = parcelRequire("Pu2vb");

var $epQcA = parcelRequire("epQcA");
function $05d54f94441303a8$export$9010aa71841a6887(window, initialViewPort, callback) {
    const unbindWheel = (0, $cBeZP.bind)(window, {
        type: (0, $Pu2vb.AbortEvent).wheel,
        listener: (e)=>{
            callback((0, $Pu2vb.AbortEvent).wheel, e.timeStamp);
        },
        options: {
            passive: true,
            once: true
        }
    });
    const unbindKeydown = (0, $cBeZP.bind)(window, {
        type: (0, $Pu2vb.AbortEvent).keydown,
        listener: (e)=>{
            callback((0, $Pu2vb.AbortEvent).keydown, e.timeStamp);
        },
        options: {
            once: true
        }
    });
    const unbindResize = (0, $cBeZP.bind)(window, {
        type: (0, $Pu2vb.AbortEvent).resize,
        listener: (e)=>{
            if ((0, $epQcA.getViewportWidth)() !== initialViewPort.w || (0, $epQcA.getViewportHeight)() !== initialViewPort.h) {
                callback((0, $Pu2vb.AbortEvent).resize, e.timeStamp);
                unbindResize();
            }
        }
    });
    return [
        unbindWheel,
        unbindKeydown,
        unbindResize
    ];
}

});
parcelRegister("Pu2vb", function(module, exports) {

$parcel$export(module.exports, "AbortEvent", () => $b4a560c0776083f4$export$199edc0307b5587f);
const $b4a560c0776083f4$export$199edc0307b5587f = {
    wheel: 'wheel',
    keydown: 'keydown',
    resize: 'resize'
};

});

parcelRegister("epQcA", function(module, exports) {

$parcel$export(module.exports, "getViewportWidth", () => $20743fc2a72ae229$export$a497a1dcb4408212);
$parcel$export(module.exports, "getViewportHeight", () => $20743fc2a72ae229$export$4f01c15d21ef9cc6);
function $20743fc2a72ae229$export$a497a1dcb4408212(document = window.document) {
    let documentWidth;
    try {
        documentWidth = document.documentElement.clientWidth || 0;
    } catch (e) {
        documentWidth = 0;
    }
    return Math.max(documentWidth, window.innerWidth || 0);
}
function $20743fc2a72ae229$export$4f01c15d21ef9cc6(document = window.document) {
    let documentHeight;
    try {
        documentHeight = document.documentElement.clientHeight || 0;
    } catch (e) {
        documentHeight = 0;
    }
    return Math.max(documentHeight, window.innerHeight || 0);
}

});


parcelRegister("5lAmc", function(module, exports) {

$parcel$export(module.exports, "getVCRevisionsData", () => $01e36a1b8e73b8a5$export$5c86a34c9becd6d0);

var $fe1wc = parcelRequire("fe1wc");

var $37gc9 = parcelRequire("37gc9");

var $joHOM = parcelRequire("joHOM");
const $01e36a1b8e73b8a5$var$VCParts = [
    '25',
    '50',
    '75',
    '80',
    '85',
    '90',
    '95',
    '98',
    '99'
];
const $01e36a1b8e73b8a5$var$READONLY_EMPTY_ARRAY = Array.from({
    length: 0
});
// Helper function to create vcDetails object to avoid code duplication
function $01e36a1b8e73b8a5$var$createVCDetails(calculatedVC, shouldHaveVCmetric) {
    if (!shouldHaveVCmetric || !calculatedVC || !calculatedVC.VC || !calculatedVC.VCBox) return {};
    const details = {};
    const { VC: VC, VCBox: VCBox } = calculatedVC; // Destructure once to avoid repeated property access
    for (const key of $01e36a1b8e73b8a5$var$VCParts)details[key] = {
        t: VC[key],
        e: VCBox[key] || $01e36a1b8e73b8a5$var$READONLY_EMPTY_ARRAY
    };
    return details;
}
function $01e36a1b8e73b8a5$export$5c86a34c9becd6d0({ fullPrefix: fullPrefix, interaction: interaction, isVCClean: isVCClean, isEventAborted: isEventAborted, multiHeatmap: multiHeatmap, ssr: ssr, calculatedVC: calculatedVC, calculatedVCNext: calculatedVCNext }) {
    if (!(0, $fe1wc.isVCRevisionEnabled)('fy25.03')) {
        if (!multiHeatmap) return null;
        return {
            [`${fullPrefix}vc:rev`]: multiHeatmap?.getPayloadShapedData({
                VCParts: $01e36a1b8e73b8a5$var$VCParts.map((v)=>parseInt(v)),
                VCCalculationMethods: (0, $joHOM.getRevisions)().map(({ classifier: classifier })=>classifier.VCCalculationMethod),
                filterComponentsLog: (0, $joHOM.getRevisions)().map(({ classifier: classifier })=>classifier.filterComponentsLog),
                isEventAborted: isEventAborted,
                interactionStart: interaction.start,
                ttai: interaction.end,
                ssr: ssr,
                clean: isVCClean
            })
        };
    }
    // Calculate these conditions once
    const pageVisibilityUpToTTAI = (0, $37gc9.getPageVisibilityState)(interaction.start, interaction.end);
    const isVisiblePageVisibleUpToTTAI = pageVisibilityUpToTTAI === 'visible';
    const shouldHaveVCmetric = isVCClean && !isEventAborted && isVisiblePageVisibleUpToTTAI;
    // Create the V2 revision object which is always needed
    const ttvcV2Revision = {
        revision: 'fy25.02',
        clean: isVCClean,
        'metric:vc90': shouldHaveVCmetric ? calculatedVCNext.VC['90'] : null,
        vcDetails: $01e36a1b8e73b8a5$var$createVCDetails(calculatedVCNext, shouldHaveVCmetric)
    };
    if (!(0, $fe1wc.isVCRevisionEnabled)('fy25.01')) return {
        [`${fullPrefix}vc:rev`]: [
            ttvcV2Revision
        ]
    };
    // Only create ttvcV1Revision when we're actually going to use it
    const ttvcV1Revision = {
        revision: 'fy25.01',
        clean: isVCClean,
        'metric:vc90': shouldHaveVCmetric ? calculatedVC.VC['90'] : null,
        vcDetails: $01e36a1b8e73b8a5$var$createVCDetails(calculatedVC, shouldHaveVCmetric)
    };
    return {
        [`${fullPrefix}vc:rev`]: [
            ttvcV1Revision,
            ttvcV2Revision
        ]
    };
}

});
parcelRegister("joHOM", function(module, exports) {

$parcel$export(module.exports, "getRevisions", () => $661e71f007ef70c7$export$3a6bcaa2795a58f8);

var $fe1wc = parcelRequire("fe1wc");

var $fxqmJ = parcelRequire("fxqmJ");

var $2YVdr = parcelRequire("2YVdr");
function $661e71f007ef70c7$export$3a6bcaa2795a58f8() {
    if (!(0, $fe1wc.isVCRevisionEnabled)('fy25.01')) return [
        {
            name: 'fy25.02',
            classifier: (0, $2YVdr.revFY25_02Classifier)
        }
    ];
    return [
        {
            name: 'fy25.01',
            classifier: (0, $fxqmJ.revFY25_01Classifier)
        },
        {
            name: 'fy25.02',
            classifier: (0, $2YVdr.revFY25_02Classifier)
        }
    ];
}

});
parcelRegister("fxqmJ", function(module, exports) {

$parcel$export(module.exports, "FY25_01Classifier", () => $f82147c2ef7ad89b$export$1287fed0f253eee5);
$parcel$export(module.exports, "revFY25_01Classifier", () => $f82147c2ef7ad89b$export$d822caadc9ee5453);

var $jPXob = parcelRequire("jPXob");
const $f82147c2ef7ad89b$var$legacyIgnoreReasons = [
    'image',
    'ssr-hydration'
];
class $f82147c2ef7ad89b$export$1287fed0f253eee5 extends (0, $jPXob.ViewportUpdateClassifier) {
    VCCalculationMethod({ VCParts: VCParts, entries: entries, totalPainted: totalPainted, componentsLog: componentsLog }) {
        const VC = {};
        const VCBox = {};
        entries.reduce((acc = 0, v)=>{
            let VCRatio = v[1] / totalPainted + acc;
            const time = v[0];
            // @todo apply fix to include small changes into accumulator
            const preciseCurrRatio = Math.round(100 * (v[1] / totalPainted));
            const preciseAccRatio = Math.round(acc * 100);
            VCRatio = (preciseCurrRatio + preciseAccRatio) / 100;
            VCParts.forEach((value)=>{
                if ((VC[value] === null || VC[value] === undefined) && VCRatio >= value / 100) {
                    VC[value] = time;
                    VCBox[value] = new Set();
                    componentsLog[time]?.forEach((v)=>VCBox[value]?.add(v.targetName));
                }
            });
            return VCRatio;
        }, 0);
        return {
            VC: VC,
            VCBox: VCBox
        };
    }
    constructor(){
        super(), this.revision = 'fy25.01', this.types = [
            'html',
            'text'
        ], this.filters = [
            {
                name: 'default-ignore-reasons',
                filter: ({ type: type, ignoreReason: ignoreReason })=>{
                    return !ignoreReason || !$f82147c2ef7ad89b$var$legacyIgnoreReasons.includes(ignoreReason);
                }
            }
        ];
        this.mergeConfig();
    }
}
const $f82147c2ef7ad89b$export$d822caadc9ee5453 = new $f82147c2ef7ad89b$export$1287fed0f253eee5();

});
parcelRegister("jPXob", function(module, exports) {

$parcel$export(module.exports, "ViewportUpdateClassifier", () => $503d28df6b954812$export$66a5f74f04eab7df);
class $503d28df6b954812$export$66a5f74f04eab7df {
    VCCalculationMethod(_) {
        return {
            VC: {},
            VCBox: {}
        };
    }
    // @todo remove it once fixed as described: https://product-fabric.atlassian.net/browse/AFO-3443
    filterComponentsLog({ componentsLog: componentsLog }) {
        return componentsLog;
    }
    mergeConfig() {
        this.__combinedTypes = [
            ...this.types,
            ...this?.__combinedTypes || []
        ];
        const previousFilters = this.removedFilters.length === 0 ? this.__combinedFilters : this.__combinedFilters.filter((filter)=>!this.removedFilters.includes(filter.name));
        this.__combinedFilters = [
            ...this.filters,
            ...previousFilters
        ];
    }
    classifyUpdate({ element: element, type: type, tags: tags, ignoreReason: ignoreReason }) {
        if (!this.__combinedTypes.includes(type)) return false;
        return this.__combinedFilters.every(({ filter: filter, name: name })=>{
            return filter({
                type: type,
                tags: tags,
                ignoreReason: ignoreReason
            });
        });
    }
    constructor(){
        this.types = [];
        this.filters = [];
        this.removedFilters = [];
        this.__combinedTypes = [];
        this.__combinedFilters = [];
    }
}

});


parcelRegister("2YVdr", function(module, exports) {

$parcel$export(module.exports, "revFY25_02Classifier", () => $de8b48bc6201ce8c$export$624b2c3760a5ab41);

var $fxqmJ = parcelRequire("fxqmJ");
class $de8b48bc6201ce8c$export$d8e8ccb82df07b7c extends (0, $fxqmJ.FY25_01Classifier) {
    // @todo remove it once fixed as described: https://product-fabric.atlassian.net/browse/AFO-3443
    filterComponentsLog({ componentsLog: componentsLog, ttai: ttai }) {
        const _componentsLog = {};
        Object.entries(componentsLog).forEach(([_timestamp, value])=>{
            const timestamp = Number(_timestamp);
            if (Math.ceil(ttai) >= timestamp) _componentsLog[timestamp] = value;
        });
        return _componentsLog;
    }
    constructor(){
        super(), this.revision = 'fy25.02', this.types = [
            'attr'
        ], this.filters = [
            {
                name: 'not-visible',
                filter: ({ type: type, ignoreReason: ignoreReason })=>{
                    return !ignoreReason?.includes('not-visible') && ignoreReason !== 'non-visual-style';
                }
            }
        ], this.removedFilters = [];
        this.mergeConfig();
    }
}
const $de8b48bc6201ce8c$export$624b2c3760a5ab41 = new $de8b48bc6201ce8c$export$d8e8ccb82df07b7c();

});



parcelRegister("6Subd", function(module, exports) {

$parcel$export(module.exports, "MultiRevisionHeatmap", () => $e691834d2c757960$export$40923620784ea2c1);

var $37gc9 = parcelRequire("37gc9");
const $e691834d2c757960$var$UNUSED_SECTOR = 0;
class $e691834d2c757960$export$40923620784ea2c1 {
    constructor({ viewport: viewport, revisions: revisions, arraySize: arraySize, devToolsEnabled: devToolsEnabled }){
        this.arraySize = {
            w: 200,
            h: 200
        };
        this.mapPixelsToHeatmap = (left, top, width, height)=>{
            const { w: w, h: h } = this.viewport;
            const l = Math.floor(left / w * this.arraySize.w);
            const t = Math.floor(top / h * this.arraySize.h);
            const r = Math.ceil((left + width) / w * this.arraySize.w);
            const b = Math.ceil((top + height) / h * this.arraySize.h);
            // correct values to min - 0, max - arraySize
            const result = {
                l: Math.max(0, l),
                t: Math.max(0, t),
                r: Math.min(this.arraySize.w, r),
                b: Math.min(this.arraySize.h, b)
            };
            return result;
        };
        this.getElementRatio = (mappedValues)=>{
            const { r: r, l: l, b: b, t: t } = mappedValues;
            return (r - l) * (b - t) / (this.arraySize.w * this.arraySize.h);
        };
        this.viewport = viewport;
        this.revisions = revisions;
        if (arraySize) this.arraySize = arraySize;
        this.heatmaps = new Array(revisions.length);
        this.componentsLogs = new Array(revisions.length);
        this.vcRatios = new Array(revisions.length);
        this.devToolsEnabled = devToolsEnabled || false;
        revisions.forEach(({}, i)=>{
            this.heatmaps[i] = this.getCleanHeatmap();
            this.componentsLogs[i] = {};
            this.vcRatios[i] = {};
        });
    }
    handleUpdate({ time: time, type: type, classification: classification, intersectionRect: intersectionRect, element: element, targetName: targetName, ignoreReason: ignoreReason, onError: onError, attributeName: attributeName, oldValue: oldValue, newValue: newValue }) {
        const mappedValues = this.mapPixelsToHeatmap(intersectionRect.left, intersectionRect.top, intersectionRect.width, intersectionRect.height);
        const result = this.applyChangesToHeatMap(mappedValues, time, classification);
        if (result !== true) onError(result);
        const componentRatio = this.getElementRatio(mappedValues);
        this.revisions.forEach((_, i)=>{
            if (classification[i]) this.vcRatios[i][targetName] = componentRatio;
            if (!this.componentsLogs[i][time]) this.componentsLogs[i][time] = [];
            this.componentsLogs[i][time].push({
                __debug__element: this.devToolsEnabled ? new WeakRef(element) : null,
                intersectionRect: intersectionRect,
                targetName: targetName,
                ignoreReason: ignoreReason,
                attributeName: attributeName,
                oldValue: oldValue,
                newValue: newValue
            });
        });
    }
    getData() {
        return {
            heatmaps: this.heatmaps
        };
    }
    getPayloadShapedData(args) {
        const pageVisibilityUpToTTAI = (0, $37gc9.getPageVisibilityState)(args.interactionStart, args.ttai);
        const result = this.processData(args);
        const payload = this.revisions.map((rev, i)=>{
            const vcDetails = {};
            args.VCParts.forEach((VCPart)=>{
                vcDetails[VCPart] = {
                    t: result[i].VC[VCPart] || 0,
                    e: Array.from(result[i].VCBox[VCPart] || [])
                };
            });
            return {
                revision: rev.name,
                clean: args.clean,
                'metric:vc90': args.clean && !args.isEventAborted && pageVisibilityUpToTTAI === 'visible' ? vcDetails?.['90']?.t : null,
                vcDetails: vcDetails
            };
        });
        return payload;
    }
    processData({ VCParts: VCParts, VCCalculationMethods: VCCalculationMethods, filterComponentsLog: filterComponentsLog, ttai: ttai, ssr: ssr = $e691834d2c757960$var$UNUSED_SECTOR }) {
        return this.heatmaps.map((heatmap, i)=>{
            const lastUpdate = {};
            let totalPainted = 0;
            let componentsLog = this.componentsLogs[i];
            if (ssr !== $e691834d2c757960$var$UNUSED_SECTOR) {
                const element = {
                    __debug__element: new WeakRef(window.document?.body),
                    intersectionRect: {
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        x: 0,
                        y: 0,
                        width: this.viewport.w,
                        height: this.viewport.h,
                        toJSON () {
                            return {};
                        }
                    },
                    targetName: 'SSR'
                };
                if (!componentsLog[ssr]) componentsLog[ssr] = [];
                componentsLog[ssr].push(element);
            }
            for(let i = 0; i < heatmap.length; i++){
                const rounded = Math.floor(heatmap[i] === $e691834d2c757960$var$UNUSED_SECTOR && ssr !== $e691834d2c757960$var$UNUSED_SECTOR ? ssr : heatmap[i]);
                totalPainted += rounded !== $e691834d2c757960$var$UNUSED_SECTOR ? 1 : 0;
                if (rounded !== $e691834d2c757960$var$UNUSED_SECTOR) lastUpdate[rounded] = lastUpdate[rounded] ? lastUpdate[rounded] + 1 : 1;
            }
            const entries = Object.entries(lastUpdate).map((a)=>[
                    parseInt(a[0], 10),
                    a[1]
                ]).sort((a, b)=>a[0] > b[0] ? 1 : -1);
            // @todo remove it once fixed as described: https://product-fabric.atlassian.net/browse/AFO-3443
            componentsLog = filterComponentsLog[i]({
                componentsLog: componentsLog,
                ttai: ttai
            });
            const { VC: VC, VCBox: VCBox } = VCCalculationMethods[i]({
                VCParts: VCParts,
                componentsLog: componentsLog,
                entries: entries,
                totalPainted: totalPainted
            });
            const VCEntries = entries.reduce((acc, [timestamp, entryPainted], i)=>{
                const currentlyPainted = entryPainted + (acc.abs[i - 1]?.[1] || 0);
                const currentlyPaintedRatio = Math.round(currentlyPainted / totalPainted * 1000) / 10;
                const logEntry = componentsLog[timestamp]?.map((v)=>v.targetName);
                acc.abs.push([
                    timestamp,
                    currentlyPainted
                ]);
                acc.rel.push({
                    time: timestamp,
                    vc: currentlyPaintedRatio,
                    elements: logEntry
                });
                return acc;
            }, {
                abs: [],
                rel: []
            });
            return {
                VC: VC,
                VCBox: VCBox,
                VCEntries: VCEntries,
                totalPainted: totalPainted
            };
        });
    }
    applyChangesToHeatMap(a, time, classification) {
        const { l: l, t: t, r: r, b: b } = a;
        const size = classification.length;
        for(let row = t; row < b; row++){
            if (this.heatmaps[0][row] === undefined) try {
                return {
                    error: `index - ${row}`,
                    time: time
                };
            } catch (e) {
                return {
                    error: 'row error',
                    time: time
                };
            }
            else {
                for(let heatmapIndex = 0; heatmapIndex < size; heatmapIndex++)if (classification[heatmapIndex]) this.heatmaps[heatmapIndex].fill(time, this.getIndex(l, row), this.getIndex(r, row));
            }
        }
        return true;
    }
    getIndex(x, y) {
        return x + this.arraySize.w * y;
    }
    getCleanHeatmap() {
        return new Int32Array(this.arraySize.w * this.arraySize.h);
    }
    static makeVCReturnObj(VCParts) {
        const vc = {};
        VCParts.forEach((v)=>{
            vc[v] = null;
        });
        return vc;
    }
}

});

parcelRegister("eZGsd", function(module, exports) {

$parcel$export(module.exports, "Observers", () => $aa3fefb78ef7f562$export$b65d046240060e78);

var $1HYUt = parcelRequire("1HYUt");

var $eliYW = parcelRequire("eliYW");

var $flJpT = parcelRequire("flJpT");
const $aa3fefb78ef7f562$var$state = {
    normal: 1,
    waitingForFirstRender: 2,
    ignoring: 3
};
function $aa3fefb78ef7f562$var$isElementVisible(target) {
    if (!target || typeof target.checkVisibility !== 'function') return true;
    const isVisible = target.checkVisibility({
        contentVisibilityAuto: true,
        opacityProperty: true,
        visibilityProperty: true
    });
    return isVisible;
}
class $aa3fefb78ef7f562$export$b65d046240060e78 {
    constructor(opts){
        this.observedMutations = new WeakMap();
        this.elementsInView = new Set();
        this.callbacks = new Set();
        this.totalTime = 0;
        this._startMeasureTimestamp = -1;
        this.ssr = {
            state: $aa3fefb78ef7f562$var$state.normal,
            reactRootElement: null,
            renderStart: -1,
            renderStop: -1
        };
        this.selectorConfig = {
            id: false,
            testId: false,
            role: false,
            className: true,
            dataVC: true
        };
        this.subscribeResults = (cb)=>{
            this.callbacks.add(cb);
        };
        this.observeElement = (node, mutation, type, ignoreReason, attributeName, oldValue = null, newValue = null)=>{
            this.intersectionObserver?.observe(node);
            this.observedMutations.set(node, {
                mutation: mutation,
                ignoreReason: ignoreReason,
                type: type,
                attributeName: attributeName,
                oldValue: oldValue,
                newValue: newValue
            });
        };
        this.selectorConfig = {
            ...this.selectorConfig,
            ...opts.selectorConfig
        };
        this.intersectionObserver = this.getIntersectionObserver();
        this.mutationObserver = this.getMutationObserver();
        this.ssrPlaceholderHandler = new (0, $flJpT.SSRPlaceholderHandlers)();
    }
    isBrowserSupported() {
        return typeof window.IntersectionObserver === 'function' && typeof window.MutationObserver === 'function';
    }
    observe() {
        this.totalTime = 0;
        this.ssr = {
            state: $aa3fefb78ef7f562$var$state.normal,
            reactRootElement: null,
            renderStart: -1,
            renderStop: -1
        };
        this.mutationObserver?.observe(document.body, {
            attributeFilter: [
                'hidden',
                'style',
                'src',
                'class'
            ],
            attributeOldValue: true,
            attributes: true,
            childList: true,
            subtree: true
        });
    }
    disconnect() {
        this.mutationObserver?.disconnect();
        this.intersectionObserver?.disconnect();
        this.observedMutations = new WeakMap();
        this.elementsInView = new Set();
        this.callbacks = new Set();
        this.ssr.reactRootElement = null;
        this.ssrPlaceholderHandler.clear();
    }
    getTotalTime() {
        return this.totalTime;
    }
    setReactRootElement(element) {
        this.ssr.reactRootElement = element;
    }
    setReactRootRenderStart(startTime = performance.now()) {
        this.ssr.renderStart = startTime;
        this.ssr.state = $aa3fefb78ef7f562$var$state.waitingForFirstRender;
    }
    setReactRootRenderStop(stopTime = performance.now()) {
        this.ssr.renderStop = stopTime;
    }
    getMutationObserver() {
        if (!this.isBrowserSupported()) return null;
        return new MutationObserver((mutations)=>{
            this.measureStart();
            mutations.forEach((mutation)=>{
                // patching element if timestamp not automatically added
                // eslint-disable-next-line no-param-reassign
                mutation.timestamp = mutation.timestamp === undefined ? performance.now() : mutation.timestamp;
                let ignoreReason = '';
                if (this.ssr.state === $aa3fefb78ef7f562$var$state.waitingForFirstRender && mutation.timestamp > this.ssr.renderStart && mutation.target === this.ssr.reactRootElement) {
                    this.ssr.state = $aa3fefb78ef7f562$var$state.ignoring;
                    if (this.ssr.renderStop === -1) // arbitrary 500ms DOM update window
                    this.ssr.renderStop = mutation.timestamp + 500;
                    ignoreReason = 'ssr-hydration';
                }
                if (this.ssr.state === $aa3fefb78ef7f562$var$state.ignoring && mutation.timestamp > this.ssr.renderStart && mutation.target === this.ssr.reactRootElement) {
                    if (mutation.timestamp <= this.ssr.renderStop) ignoreReason = 'ssr-hydration';
                    else this.ssr.state = $aa3fefb78ef7f562$var$state.normal;
                }
                if (mutation.type === 'childList') {
                    mutation.addedNodes.forEach((node)=>{
                        if ((0, $1HYUt.isContainedWithinMediaWrapper)(node)) ignoreReason = 'image';
                        if (node instanceof HTMLElement) {
                            if (this.ssrPlaceholderHandler.isPlaceholder(node) || this.ssrPlaceholderHandler.isPlaceholderIgnored(node)) {
                                this.ssrPlaceholderHandler.checkIfExistedAndSizeMatching(node).then((result)=>{
                                    if (result === false) this.observeElement(node, mutation, 'html', ignoreReason);
                                });
                                return;
                            }
                            if (this.ssrPlaceholderHandler.isPlaceholderReplacement(node) || this.ssrPlaceholderHandler.isPlaceholderIgnored(node)) {
                                this.ssrPlaceholderHandler.validateReactComponentMatchToPlaceholder(node).then((result)=>{
                                    if (result === false) this.observeElement(node, mutation, 'html', ignoreReason);
                                });
                                return;
                            }
                            this.observeElement(node, mutation, 'html', ignoreReason);
                        }
                        if (node instanceof Text && node.parentElement != null) this.observeElement(node.parentElement, mutation, 'text', ignoreReason);
                    });
                    mutation.removedNodes.forEach((node)=>{
                        if (node instanceof Element) {
                            this.elementsInView.delete(node);
                            this.intersectionObserver?.unobserve(node);
                        }
                    });
                } else if (mutation.type === 'attributes') {
                    if (mutation.target instanceof HTMLElement) {
                        const attributeName = mutation.attributeName;
                        /*
							"MutationObserver was explicitly designed to work that way, but I can't now recall the reasoning.
							I think it might have been something along the lines that for consistency every setAttribute call should create a record.
							Conceptually there is after all a mutation: there is an old value replaced with a new one,
							and whether or not they are the same doesn't really matter.
							And Custom elements should work the same way as MutationObserver."
							https://github.com/whatwg/dom/issues/520#issuecomment-336574796
						*/ const oldValue = mutation.oldValue ?? undefined;
                        const newValue = attributeName ? mutation.target.getAttribute(attributeName) : undefined;
                        if (oldValue !== newValue) {
                            if ((0, $eliYW.default)(mutation)) ignoreReason = 'non-visual-style';
                            if ((0, $1HYUt.isContainedWithinMediaWrapper)(mutation.target)) ignoreReason = 'image';
                            this.observeElement(mutation.target, mutation, 'attr', ignoreReason, attributeName, oldValue, newValue);
                        }
                    }
                }
            });
        });
    }
    getElementName(element) {
        try {
            const tagName = element.localName;
            const dataVCAttr = element.getAttribute('data-vc');
            const dataVC = this.selectorConfig.dataVC && dataVCAttr ? `[data-vc="${dataVCAttr}"]` : '';
            const id = this.selectorConfig.id && element.id ? `#${element.id}` : '';
            let testId = this.selectorConfig.testId ? element.getAttribute('data-testid') || element.getAttribute('data-test-id') : '';
            testId = testId ? `[testid=${testId}]` : '';
            let role = this.selectorConfig.role ? element.getAttribute('role') : '';
            role = role ? `[role=${role}]` : '';
            let classList = this.selectorConfig.className ? Array.from(element.classList).join('.') : '';
            classList = classList === '' ? '' : `.${classList}`;
            const attrs = dataVC ? dataVC : [
                id,
                testId,
                role
            ].join('');
            let idString = '';
            if (attrs === '' && classList === '') {
                const parent = element.parentElement ? this.getElementName(element.parentElement) : 'unknown';
                idString = `${parent} > ${tagName}`;
            } else idString = [
                tagName,
                attrs || classList
            ].join('');
            return idString;
        } catch (e) {
            return 'error';
        }
    }
    getIntersectionObserver() {
        if (!this.isBrowserSupported()) return null;
        return new IntersectionObserver((entries)=>{
            this.measureStart();
            entries.forEach(({ isIntersecting: isIntersecting, intersectionRect: ir, target: target })=>{
                const data = this.observedMutations.get(target);
                this.observedMutations.delete(target);
                if (isIntersecting && ir.width > 0 && ir.height > 0) {
                    if (!(target instanceof HTMLElement)) return;
                    if (!data?.mutation) // ignore intersection report without recent mutation
                    return;
                    if (!$aa3fefb78ef7f562$var$isElementVisible(target)) data.ignoreReason = 'not-visible';
                    this.callbacks.forEach((callback)=>{
                        let elementName;
                        try {
                            elementName = this.getElementName(target);
                        } catch (e) {
                            elementName = 'error';
                        }
                        callback(data.mutation.timestamp || performance.now(), ir, elementName, target, data.type, data.ignoreReason, data.attributeName, data.oldValue, data.newValue);
                    });
                    this.elementsInView.add(target);
                } else this.elementsInView.delete(target);
            });
            this.measureStop();
        });
    }
    measureStart() {
        this._startMeasureTimestamp = performance.now();
    }
    measureStop() {
        if (this._startMeasureTimestamp === -1) return;
        this.totalTime += performance.now() - this._startMeasureTimestamp;
        this._startMeasureTimestamp = -1;
    }
}

});
parcelRegister("1HYUt", function(module, exports) {

$parcel$export(module.exports, "isContainedWithinMediaWrapper", () => $dac8a3c213f349f7$export$f61fbc3b9c4a9019);

var $lr1Nm = parcelRequire("lr1Nm");
function $dac8a3c213f349f7$export$f61fbc3b9c4a9019(node) {
    while(node){
        if (node instanceof Element && node.hasAttribute((0, $lr1Nm.MEDIA_WRAPPER_TAG))) return true;
        node = node.parentNode;
    }
    return false;
}

});
parcelRegister("lr1Nm", function(module, exports) {

$parcel$export(module.exports, "MEDIA_WRAPPER_TAG", () => $71e1e5daed4f23b4$export$7674290405cc25b0);
$parcel$export(module.exports, "VcMediaWrapperProps", () => $71e1e5daed4f23b4$export$7028e9efe569888c);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
const $71e1e5daed4f23b4$export$7674290405cc25b0 = 'data-media-vc-wrapper';
const $71e1e5daed4f23b4$export$7028e9efe569888c = {
    [$71e1e5daed4f23b4$export$7674290405cc25b0]: true
};
function $71e1e5daed4f23b4$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ...$71e1e5daed4f23b4$export$7028e9efe569888c,
        children: children
    });
}

});


parcelRegister("eliYW", function(module, exports) {

$parcel$export(module.exports, "default", () => $95c623265a80191b$export$2e2bcd8739ae039);
/**
 * Checks if a mutation record represents a non-visual style change
 * @param mutation - The mutation record to check
 * @returns boolean indicating if this is a non-visual style mutation
 *
 * A mutation is considered non-visual if:
 * - The target has data-	vc-nvs="true" attribute
 * - The changed attribute is either 'class' or 'style'
 */ function $95c623265a80191b$var$isNonVisualStyleMutation({ target: target, attributeName: attributeName }) {
    if (!(target instanceof Element)) return false;
    if (attributeName !== 'class' && attributeName !== 'style') return false;
    if (target.getAttribute('data-vc-nvs') !== 'true') return false;
    return true;
}
var $95c623265a80191b$export$2e2bcd8739ae039 = $95c623265a80191b$var$isNonVisualStyleMutation;

});

parcelRegister("flJpT", function(module, exports) {

$parcel$export(module.exports, "SSRPlaceholderHandlers", () => $8867921f8b6036b7$export$c0102f1a1198d10f);
const $8867921f8b6036b7$var$ANCESTOR_LOOKUP_LIMIT = 10;
class $8867921f8b6036b7$export$c0102f1a1198d10f {
    constructor(){
        this.staticPlaceholders = new Map();
        this.callbacks = new Map();
        this.getSizeCallbacks = new Map();
        this.reactValidateCallbacks = new Map();
        this.EQUALITY_THRESHOLD = 1;
        this.intersectionObserverCallback = ({ target: target, boundingClientRect: boundingClientRect })=>{
            this.intersectionObserver?.unobserve(target);
            if (!(target instanceof HTMLElement)) // impossible case - keep typescript healthy
            return;
            const staticKey = target.dataset.ssrPlaceholder || '';
            if (staticKey) {
                if (this.staticPlaceholders.has(staticKey) && this.callbacks.has(staticKey)) {
                    // validation
                    const resolve = this.callbacks.get(staticKey);
                    if (!resolve) return;
                    const rect = this.staticPlaceholders.get(staticKey);
                    const hasSameSizePosition = this.hasSameSizePosition(rect, boundingClientRect);
                    if (hasSameSizePosition || this.isDummyRect(rect)) resolve(hasSameSizePosition);
                    else requestAnimationFrame(()=>{
                        const targetRect = target.getBoundingClientRect();
                        const hasSameSizePosition = this.hasSameSizePosition(rect, targetRect);
                        resolve(hasSameSizePosition);
                    });
                    this.callbacks.delete(staticKey);
                }
            } else {
                const key = target.dataset.ssrPlaceholderReplace || '';
                const resolve = this.reactValidateCallbacks.get(key);
                if (!resolve) return;
                const rect = this.staticPlaceholders.get(key);
                const hasSameSizePosition = this.hasSameSizePosition(rect, boundingClientRect);
                if (hasSameSizePosition || this.isDummyRect(rect)) resolve(hasSameSizePosition);
                else requestAnimationFrame(()=>{
                    const targetRect = target.getBoundingClientRect();
                    const hasSameSizePosition = this.hasSameSizePosition(rect, targetRect);
                    resolve(hasSameSizePosition);
                });
                this.staticPlaceholders.delete(staticKey);
                this.reactValidateCallbacks.delete(staticKey);
            }
        };
        if (typeof IntersectionObserver === 'function') // Only instantiate the IntersectionObserver if it's supported
        this.intersectionObserver = new IntersectionObserver((entries)=>entries.filter((entry)=>entry.intersectionRatio > 0).forEach(this.intersectionObserverCallback));
        if (window.document) try {
            const existingElements = document.querySelectorAll('[data-ssr-placeholder]');
            existingElements.forEach((el)=>{
                if (el instanceof HTMLElement && el?.dataset?.ssrPlaceholder) {
                    let width = -1;
                    let height = -1;
                    let x = -1;
                    let y = -1;
                    const boundingClientRect = window.__SSR_PLACEHOLDERS_DIMENSIONS__?.[el.dataset.ssrPlaceholder];
                    if (boundingClientRect) {
                        width = boundingClientRect.width;
                        height = boundingClientRect.height;
                        x = boundingClientRect.x;
                        y = boundingClientRect.y;
                    }
                    this.staticPlaceholders.set(el.dataset.ssrPlaceholder, {
                        width: width,
                        height: height,
                        x: x,
                        y: y
                    });
                    this.intersectionObserver?.observe(el);
                }
            });
        } catch (e) {} finally{
            delete window.__SSR_PLACEHOLDERS_DIMENSIONS__;
        }
    }
    clear() {
        this.staticPlaceholders = new Map();
        this.callbacks = new Map();
        this.getSizeCallbacks = new Map();
        this.reactValidateCallbacks = new Map();
    }
    isPlaceholder(element) {
        return Boolean(element.dataset.ssrPlaceholder);
    }
    isPlaceholderReplacement(element) {
        return Boolean(element.dataset.ssrPlaceholderReplace);
    }
    isPlaceholderIgnored(element) {
        // data-ssr-placeholder-ignored doesn't have a value.
        return 'ssrPlaceholderIgnored' in element.dataset;
    }
    findNearestPlaceholderContainerIfIgnored(element) {
        if (!this.isPlaceholderIgnored(element)) return element;
        let ancestor = element.parentElement;
        let i = 0;
        while(ancestor && i < $8867921f8b6036b7$var$ANCESTOR_LOOKUP_LIMIT){
            if (this.isPlaceholder(ancestor) || this.isPlaceholderReplacement(ancestor)) return ancestor;
            ancestor = ancestor.parentElement;
            i++;
        }
        return element;
    }
    checkIfExistedAndSizeMatching(el) {
        el = this.findNearestPlaceholderContainerIfIgnored(el);
        const id = el.dataset.ssrPlaceholder || '';
        return new Promise((resolve)=>{
            if (!this.staticPlaceholders.has(id)) {
                resolve(false);
                return;
            } else {
                this.callbacks.set(id, resolve);
                this.intersectionObserver?.observe(el);
            }
        });
    }
    getSize(el) {
        return new Promise((resolve)=>{
            this.getSizeCallbacks.set(el.dataset.ssrPlaceholder || '', resolve);
            this.intersectionObserver?.observe(el);
        });
    }
    validateReactComponentMatchToPlaceholder(el) {
        el = this.findNearestPlaceholderContainerIfIgnored(el);
        const id = el.dataset.ssrPlaceholderReplace || '';
        return new Promise((resolve)=>{
            if (!this.staticPlaceholders.has(id)) {
                resolve(false);
                return;
            } else {
                this.reactValidateCallbacks.set(id, resolve);
                this.intersectionObserver?.observe(el);
            }
        });
    }
    hasSameSizePosition(rect, boundingClientRect) {
        return rect && Math.abs(rect.x - boundingClientRect.x) < this.EQUALITY_THRESHOLD && Math.abs(rect.y - boundingClientRect.y) < this.EQUALITY_THRESHOLD && Math.abs(rect.width - boundingClientRect.width) < this.EQUALITY_THRESHOLD && Math.abs(rect.height - boundingClientRect.height) < this.EQUALITY_THRESHOLD || false;
    }
    isDummyRect(rect) {
        return rect && rect.width < 0 && rect.height < 0 || false;
    }
}

});




parcelRegister("a0hd6", function(module, exports) {

$parcel$export(module.exports, "getVCObserver", () => $fa52152d064ec067$export$b3bc47985717b49e);

var $fe1wc = parcelRequire("fe1wc");

var $i0vFa = parcelRequire("i0vFa");

var $h2sI1 = parcelRequire("h2sI1");

var $cmAu5 = parcelRequire("cmAu5");

var $6cAn5 = parcelRequire("6cAn5");
class $fa52152d064ec067$var$VCObserverWrapper {
    constructor(opts = {}){
        this.newVCObserver = null;
        if ((0, $fe1wc.isVCRevisionEnabled)('fy25.03')) this.newVCObserver = new (0, $cmAu5.default)({
            selectorConfig: opts.selectorConfig
        });
        this.oldVCObserver = new (0, $h2sI1.VCObserver)(opts);
    }
    start(startArg) {
        this.oldVCObserver?.start(startArg);
        this.newVCObserver?.start({
            startTime: startArg.startTime
        });
    }
    stop() {
        this.oldVCObserver?.stop();
        this.newVCObserver?.stop();
    }
    getVCRawData() {
        return this.oldVCObserver?.getVCRawData() ?? null;
    }
    async getVCResult(param) {
        const oldResult = await this.oldVCObserver?.getVCResult(param);
        const newResult = await this.newVCObserver?.getVCResult({
            start: param.start,
            stop: param.stop
        });
        if (oldResult && !newResult) return oldResult;
        return {
            ...oldResult ?? {},
            'ufo:vc:rev': [
                ...oldResult?.['ufo:vc:rev'] ?? [],
                ...newResult ?? []
            ]
        };
    }
    setSSRElement(element) {
        this.oldVCObserver?.setSSRElement(element);
    }
    setReactRootRenderStart(startTime) {
        this.oldVCObserver?.setReactRootRenderStart(startTime || performance.now());
    }
    setReactRootRenderStop(stopTime) {
        this.oldVCObserver?.setReactRootRenderStop(stopTime || performance.now());
    }
}
// Some products set this variable to indicate it is running in SSR
let $fa52152d064ec067$var$isServer = Boolean(globalThis?.false);
// Other products set this other variable to indicate it is running in SSR
let $fa52152d064ec067$var$isReactSSR = typeof $6cAn5 !== 'undefined' && Boolean($6cAn5?.env?.REACT_SSR || false);
function $fa52152d064ec067$export$68d57b133e88584d() {
    // SSR environment aren't supported
    if ($fa52152d064ec067$var$isReactSSR || $fa52152d064ec067$var$isServer) return false;
    // Legacy browsers that doesn't support WeakRef
    // aren't valid
    if (typeof globalThis?.WeakRef !== 'function') return false;
    if (typeof globalThis?.MutationObserver !== 'function' || typeof globalThis?.IntersectionObserver !== 'function' || typeof globalThis?.PerformanceObserver !== 'function') return false;
    return true;
}
function $fa52152d064ec067$export$b3bc47985717b49e(opts = {}) {
    if (!globalThis.__vcObserver) {
        const shouldMockVCObserver = !$fa52152d064ec067$export$68d57b133e88584d();
        globalThis.__vcObserver = shouldMockVCObserver ? new (0, $i0vFa.VCObserverNOOP)() : new $fa52152d064ec067$var$VCObserverWrapper(opts);
    }
    return globalThis.__vcObserver;
}

});
parcelRegister("i0vFa", function(module, exports) {

$parcel$export(module.exports, "VCObserverNOOP", () => $b94cebb0b45b066d$export$24d07287b49da906);
class $b94cebb0b45b066d$export$24d07287b49da906 {
    start(startArg) {}
    stop() {}
    getVCRawData() {
        return null;
    }
    getVCResult(param) {
        return Promise.resolve({
            'ufo:vc:noop': true
        });
    }
    setSSRElement(element) {}
    setReactRootRenderStart(startTime) {}
    setReactRootRenderStop(stopTime) {}
}

});

parcelRegister("cmAu5", function(module, exports) {

$parcel$export(module.exports, "default", () => $56a174c05d81ba02$export$2e2bcd8739ae039);

var $7JcwI = parcelRequire("7JcwI");

var $ijRKb = parcelRequire("ijRKb");

var $9XWZI = parcelRequire("9XWZI");

var $1OMZa = parcelRequire("1OMZa");

var $ePAog = parcelRequire("ePAog");
const $56a174c05d81ba02$var$DEFAULT_SELECTOR_CONFIG = {
    id: false,
    testId: true,
    role: false,
    className: false,
    dataVC: true
};
class $56a174c05d81ba02$export$2e2bcd8739ae039 {
    constructor(config){
        this.viewportObserver = null;
        this.windowEventObserver = null;
        this.entriesTimeline = new (0, $7JcwI.default)();
        this.selectorConfig = config.selectorConfig ?? $56a174c05d81ba02$var$DEFAULT_SELECTOR_CONFIG;
        this.viewportObserver = new (0, $1OMZa.default)({
            onChange: (onChangeArg)=>{
                const { time: time, type: type, elementRef: elementRef, visible: visible, rect: rect, previousRect: previousRect, mutationData: mutationData } = onChangeArg;
                let elementName = 'unknown';
                const element = elementRef.deref();
                if (element) elementName = this.getElementName(element);
                this.entriesTimeline.push({
                    time: time,
                    type: type,
                    data: {
                        elementName: elementName,
                        rect: rect,
                        previousRect: previousRect,
                        visible: visible,
                        attributeName: mutationData?.attributeName
                    }
                });
            }
        });
        this.windowEventObserver = new (0, $ePAog.default)({
            onEvent: ({ time: time, type: type })=>{
                this.entriesTimeline.push({
                    time: time,
                    type: 'window:event',
                    data: {
                        eventType: type
                    }
                });
            }
        });
    }
    start({ startTime: startTime }) {
        this.viewportObserver?.start();
        this.windowEventObserver?.start();
        this.entriesTimeline.clear();
    }
    stop() {
        this.viewportObserver?.stop();
        this.windowEventObserver?.stop();
    }
    async getVCResult(param) {
        const { start: start, stop: stop } = param;
        const results = [];
        const calculator_fy25_03 = new (0, $9XWZI.default)();
        const orderedEntries = this.entriesTimeline.getOrderedEntries({
            start: start,
            stop: stop
        });
        const fy25_03 = await calculator_fy25_03.calculate({
            orderedEntries: orderedEntries,
            startTime: start,
            stopTime: stop
        });
        if (fy25_03) results.push(fy25_03);
        return results;
    }
    getElementName(element) {
        return (0, $ijRKb.default)(this.selectorConfig, element);
    }
}

});
parcelRegister("7JcwI", function(module, exports) {

$parcel$export(module.exports, "default", () => $eddbcb024948b44d$export$2e2bcd8739ae039);
class $eddbcb024948b44d$export$2e2bcd8739ae039 {
    constructor(){
        this.unorderedEntries = [];
        this.sortedEntriesCache = new Map();
        this.unorderedEntries = [];
    }
    push(entry) {
        this.unorderedEntries.push(entry);
        this.sortedEntriesCache.clear();
    }
    getCacheKey(start, stop) {
        return `${start ?? 'null'}_${stop ?? 'null'}`;
    }
    getOrderedEntries({ start: start, stop: stop }) {
        const cacheKey = this.getCacheKey(start, stop);
        const cachedSortedEntries = this.sortedEntriesCache.get(cacheKey)?.deref();
        if (cachedSortedEntries) return cachedSortedEntries;
        const filteredEntries = this.unorderedEntries.filter((e)=>e.time >= (start ?? 0) && e.time <= (stop ?? performance.now()));
        const sortedEntries = filteredEntries.sort((a, b)=>a.time - b.time);
        this.sortedEntriesCache.set(cacheKey, new WeakRef(sortedEntries));
        return sortedEntries;
    }
    clear() {
        this.unorderedEntries = [];
        this.sortedEntriesCache.clear();
    }
}

});

parcelRegister("ijRKb", function(module, exports) {

$parcel$export(module.exports, "default", () => $c41a358eae106edf$export$2e2bcd8739ae039);
const $c41a358eae106edf$var$nameCache = new WeakMap();
function $c41a358eae106edf$var$getElementName(selectorConfig, element) {
    if (!(element instanceof HTMLElement)) return 'error';
    const cachedName = $c41a358eae106edf$var$nameCache.get(element);
    if (cachedName) return cachedName;
    // Get the tag name of the element.
    const tagName = element.localName;
    const encodeValue = (s)=>{
        if (typeof encodeURIComponent !== 'function') return '';
        try {
            return encodeURIComponent(s);
        } catch (e) {
            return 'malformed_value';
        }
    };
    // Helper function to construct attribute selectors.
    const getAttributeSelector = (attributeName, prefix = '')=>{
        if (element && typeof element.getAttribute !== 'function') return '';
        const attrValue = element.getAttribute(attributeName);
        if (!attrValue) return '';
        const encondedAttrValue = encodeValue(attrValue);
        return `${prefix}[${attributeName}="${encondedAttrValue}"]`;
    };
    // Construct the data-vc attribute selector if specified in the config.
    const dataVC = selectorConfig.dataVC !== false ? getAttributeSelector('data-vc') : '';
    // Construct the ID selector if specified in the config and the element has an ID.
    const id = selectorConfig.id && element.id ? `#${encodeValue(element.id)}` : '';
    // Construct the test ID selector if specified in the config.
    const testId = selectorConfig.testId ? getAttributeSelector('data-testid') || getAttributeSelector('data-test-id') : '';
    // Construct the role selector if specified in the config.
    const role = selectorConfig.role ? getAttributeSelector('role') : '';
    const classNames = Array.from(element.classList).map(encodeValue).join('.');
    // Construct the class list selector if specified in the config.
    const classList = selectorConfig.className && classNames ? `.${classNames}` : '';
    // Combine primary attribute selectors (id, testId, role) into a single string.
    const primaryAttributes = [
        id,
        testId,
        role
    ].filter(Boolean).join('');
    // Use dataVC if available, otherwise use the primary attributes.
    const attributes = dataVC || primaryAttributes;
    // If no attributes or class list, recursively get the parent's name.
    if (!attributes && !classList) {
        const parentName = element.parentElement ? $c41a358eae106edf$var$getElementName(selectorConfig, element.parentElement) : 'unknown';
        return `${parentName} > ${tagName}`;
    }
    // Return the final constructed name: tagName + attributes or classList.
    const name = `${tagName}${attributes || classList}`;
    $c41a358eae106edf$var$nameCache.set(element, name);
    return name;
}
var $c41a358eae106edf$export$2e2bcd8739ae039 = $c41a358eae106edf$var$getElementName;

});

parcelRegister("9XWZI", function(module, exports) {

$parcel$export(module.exports, "default", () => $7fcf1b81943b604c$export$2e2bcd8739ae039);

var $Z0DvF = parcelRequire("Z0DvF");

var $aXT4C = parcelRequire("aXT4C");
const $7fcf1b81943b604c$var$ABORTING_WINDOW_EVENT = [
    'wheel',
    'scroll',
    'keydown',
    'resize'
];
const $7fcf1b81943b604c$var$REVISION_NO = 'fy25.03';
const $7fcf1b81943b604c$var$CONSIDERED_ENTRY_TYPE = [
    'mutation:child-element',
    'mutation:element',
    'mutation:attribute',
    'layout-shift',
    'window:event'
];
const $7fcf1b81943b604c$export$98812f4e79596e2b = [
    'data-drop-target-for-element',
    'draggable'
];
class $7fcf1b81943b604c$export$2e2bcd8739ae039 extends (0, $Z0DvF.default) {
    constructor(){
        super($7fcf1b81943b604c$var$REVISION_NO);
    }
    isEntryIncluded(entry) {
        if (!$7fcf1b81943b604c$var$CONSIDERED_ENTRY_TYPE.includes(entry.type)) return false;
        if (entry.type === 'mutation:attribute') {
            const entryData = entry.data;
            const attributeName = entryData.attributeName;
            if (!attributeName || $7fcf1b81943b604c$export$98812f4e79596e2b.includes(attributeName)) return false;
            return true;
        }
        if ((0, $aXT4C.default)(entry.data) && !entry.data.visible) return false;
        return true;
    }
    isVCClean(filteredEntries) {
        const hasAbortEvent = filteredEntries.some((entry)=>{
            if (entry.type === 'window:event') {
                const data = entry.data;
                if ($7fcf1b81943b604c$var$ABORTING_WINDOW_EVENT.includes(data.eventType)) return true;
            }
            return false;
        });
        return !hasAbortEvent;
    }
    getVCCleanStatus(filteredEntries) {
        let dirtyReason = '';
        const hasAbortEvent = filteredEntries.some((entry)=>{
            if (entry.type === 'window:event') {
                const data = entry.data;
                if ($7fcf1b81943b604c$var$ABORTING_WINDOW_EVENT.includes(data.eventType)) {
                    dirtyReason = data.eventType === 'keydown' ? 'keypress' : data.eventType;
                    return true;
                }
            }
            return false;
        });
        if (hasAbortEvent && dirtyReason) return {
            isVCClean: false,
            dirtyReason: dirtyReason
        };
        return {
            isVCClean: true
        };
    }
}

});
parcelRegister("Z0DvF", function(module, exports) {

$parcel$export(module.exports, "default", () => $de18581208359322$export$2e2bcd8739ae039);

var $VSDnB = parcelRequire("VSDnB");

var $8c8Ex = parcelRequire("8c8Ex");

var $6RK1A = parcelRequire("6RK1A");

var $dF9Lu = parcelRequire("dF9Lu");
class $de18581208359322$export$2e2bcd8739ae039 {
    constructor(revisionNo){
        this.revisionNo = revisionNo;
    }
    async calculate({ startTime: startTime, stopTime: stopTime, orderedEntries: orderedEntries }) {
        const filteredEntries = orderedEntries.filter((entry)=>{
            return this.isEntryIncluded(entry);
        });
        if ((0, $VSDnB.fg)('platform_ufo_add_vc_abort_reason_by_revisions')) {
            const { isVCClean: isVCClean, dirtyReason: dirtyReason } = this.getVCCleanStatus(filteredEntries);
            if (!isVCClean) return {
                revision: this.revisionNo,
                'metric:vc90': null,
                clean: false,
                abortReason: dirtyReason
            };
        } else {
            const isVCClean = this.isVCClean(filteredEntries);
            if (!isVCClean) return {
                revision: this.revisionNo,
                'metric:vc90': null,
                clean: false
            };
        }
        const vcDetails = await (0, $8c8Ex.default)({
            viewport: {
                width: (0, $dF9Lu.default)(),
                height: (0, $6RK1A.default)()
            },
            startTime: startTime,
            stopTime: stopTime,
            orderedEntries: filteredEntries,
            percentiles: [
                25,
                50,
                75,
                80,
                85,
                90,
                95,
                98,
                99
            ]
        });
        return {
            revision: this.revisionNo,
            clean: true,
            'metric:vc90': vcDetails?.['90']?.t ?? null,
            vcDetails: vcDetails ?? undefined
        };
    }
}

});
parcelRegister("8c8Ex", function(module, exports) {

$parcel$export(module.exports, "default", () => $17901c826f2eaa4d$export$2e2bcd8739ae039);

var $2Fqls = parcelRequire("2Fqls");

var $7YUd0 = parcelRequire("7YUd0");

var $aBSWp = parcelRequire("aBSWp");
async function $17901c826f2eaa4d$var$calculateTTVCPercentiles(arg) {
    const algo = 'canvas_heatmap';
    if (algo === 'canvas_heatmap') {
        const vcDetails = await (0, $2Fqls.default)(arg);
        return vcDetails;
    }
    if (algo === 'rect_sweeping') {
        const vcDetails = await (0, $aBSWp.default)(arg);
        return vcDetails;
    }
    if (algo === 'old_heatmap') {
        const vcDetails = await (0, $7YUd0.default)(arg);
        return vcDetails;
    }
    throw new Error('unexpected Error algo not chosen correctly');
}
var $17901c826f2eaa4d$export$2e2bcd8739ae039 = $17901c826f2eaa4d$var$calculateTTVCPercentiles;

});
parcelRegister("2Fqls", function(module, exports) {

$parcel$export(module.exports, "default", () => $aadfe5c88ea5db2d$export$2e2bcd8739ae039);

var $VSDnB = parcelRequire("VSDnB");

var $a6vME = parcelRequire("a6vME");
async function $aadfe5c88ea5db2d$var$calculateTTVCPercentiles({ viewport: viewport, orderedEntries: orderedEntries, percentiles: percentiles, startTime: startTime }) {
    const canvas = new (0, $a6vME.ViewportCanvas)(viewport, (0, $VSDnB.fg)('platform_ufo_canvas_heatmap_full_precision') ? 1 : 0.25);
    const elementMap = new Map();
    for (const entry of orderedEntries){
        if (!('rect' in entry.data)) continue;
        const rect = entry.data.rect;
        const elementName = entry.data.elementName;
        canvas.drawRect(rect, entry.time);
        if (!elementMap.has(entry.time)) elementMap.set(entry.time, new Set());
        elementMap.get(entry.time).add(elementName);
    }
    // Get pixel counts
    const timePixelCounts = await canvas.getPixelCounts();
    const canvasDimenstions = canvas.getScaledDimensions();
    const totalPixels = canvasDimenstions.width * canvasDimenstions.height;
    return $aadfe5c88ea5db2d$export$89c8da9b65eff678(timePixelCounts, elementMap, percentiles, totalPixels, startTime);
}
var $aadfe5c88ea5db2d$export$2e2bcd8739ae039 = $aadfe5c88ea5db2d$var$calculateTTVCPercentiles;
function $aadfe5c88ea5db2d$export$89c8da9b65eff678(timePixelCounts, elementMap, unorderedPercentiles, totalPixels, startTime) {
    const results = {};
    let cumulativePixels = 0;
    const percentiles = unorderedPercentiles.sort((a, b)=>a - b);
    // Sort entries by timestamp for consistent processing
    const sortedEntries = Array.from(timePixelCounts.entries()).sort(([timeA], [timeB])=>Number(timeA) - Number(timeB));
    let percentileIndex = 0;
    let domElementsBuffer = new Set();
    for (const [time, pixelCount] of sortedEntries){
        cumulativePixels += pixelCount;
        const percentCovered = cumulativePixels / totalPixels * 100;
        const elementNames = elementMap.get(time) || new Set();
        elementNames.forEach((elName)=>domElementsBuffer.add(elName));
        let matchesAnyCheckpoints = false;
        while(percentileIndex < percentiles.length && percentCovered >= percentiles[percentileIndex]){
            results[`${percentiles[percentileIndex]}`] = {
                t: Math.round(Number(time - startTime)),
                e: Array.from(domElementsBuffer)
            };
            percentileIndex++;
            matchesAnyCheckpoints = true;
        }
        if (matchesAnyCheckpoints) domElementsBuffer.clear();
        if (percentileIndex >= percentiles.length) break;
    }
    let previousResult = {
        t: 0,
        e: []
    };
    for(let i = 0; i < percentiles.length; i++){
        const percentile = percentiles[i];
        if (!(percentile in results)) results[`${percentile}`] = previousResult;
        previousResult = results[`${percentile}`];
    }
    return results;
}

});
parcelRegister("a6vME", function(module, exports) {

$parcel$export(module.exports, "ViewportCanvas", () => $0e1e69660e38aacc$export$3e59ac9de7402fb1);

var $ctFNJ = parcelRequire("ctFNJ");
class $0e1e69660e38aacc$export$3e59ac9de7402fb1 {
    /**
	 * Creates a new ViewportCanvas instance.
	 * @param viewport - The dimensions of the viewport
	 * @param scaleFactor - Scale factor to apply to the canvas (default: 0.5)
	 * @throws {Error} If canvas context cannot be obtained
	 */ constructor(viewport, scaleFactor = 1){
        this.scaleFactor = scaleFactor;
        this.colorCounter = 1;
        this.colorTimeMap = new Map();
        const safeViewportWidth = Math.max(viewport.width, 1);
        const safeViewportHeight = Math.max(viewport.height, 1);
        // Calculate scaled dimensions
        this.scaledWidth = Math.max(Math.ceil(safeViewportWidth * scaleFactor), 1);
        this.scaledHeight = Math.max(Math.ceil(safeViewportHeight * scaleFactor), 1);
        this.scaleX = this.scaledWidth / safeViewportWidth;
        this.scaleY = this.scaledHeight / safeViewportHeight;
        // Initialize OffscreenCanvas with scaled dimensions
        this.canvas = document.createElement('canvas');
        this.canvas.width = this.scaledWidth;
        this.canvas.height = this.scaledHeight;
        const ctx = this.canvas.getContext('2d', {
            alpha: false,
            willReadFrequently: true,
            colorSpace: 'srgb'
        });
        if (!ctx) throw new Error('Could not get canvas context');
        this.ctx = ctx;
        this.ctx.globalCompositeOperation = 'source-over';
        this.clear();
    }
    getScaledDimensions() {
        return {
            width: this.scaledWidth,
            height: this.scaledHeight
        };
    }
    /**
	 * Clears the entire canvas by removing all drawn content.
	 * @private
	 */ clear() {
        this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
    }
    /**
	 * Generates a unique RGB color from an incrementing counter.
	 * Uses a 24-bit color space (16,777,216 possible colors).
	 *
	 * @private
	 * @returns A unique RGB color string
	 *
	 * @example
	 * // Example bit operations for color 0x00FF8040:
	 * // Red:   (0x00FF8040 >> 16) & 0xFF = 0xFF = 255
	 * // Green: (0x00FF8040 >> 8) & 0xFF  = 0x80 = 128
	 * // Blue:   0x00FF8040 & 0xFF        = 0x40 = 64
	 */ generateColor() {
        // Wrap around at 16,777,215 (0x00FFFFFF) to stay within 24-bit color space
        const rgbColor = this.colorCounter++ % 0x00ffffff;
        return $0e1e69660e38aacc$export$54591583ed0b20ce(rgbColor);
    }
    /**
	 * Draws a rectangle on the canvas with a unique color and associates it with a timestamp.
	 * Each drawn rectangle gets a unique color which is mapped to the provided timestamp.
	 *
	 * @param rect - The rectangle dimensions to draw
	 * @param timestamp - The timestamp to associate with this drawing operation
	 */ drawRect(rect, timestamp) {
        const color = this.generateColor();
        this.colorTimeMap.set(color, timestamp);
        this.ctx.fillStyle = color;
        if (this.scaleFactor === 1) return this.ctx.fillRect(rect.x, rect.y, rect.width, rect.height);
        const scaledX = rect.x * this.scaleX;
        const scaledY = rect.y * this.scaleY;
        const scaledWidth = rect.width * this.scaleX;
        const scaledHeight = rect.height * this.scaleY;
        this.ctx.fillRect(Math.floor(scaledX), Math.ceil(scaledY), Math.max(scaledWidth, 1), Math.max(scaledHeight, 1));
    }
    /**
	 * Calculates the number of pixels drawn for each timestamp.
	 * This method:
	 * 1. Reads the pixel data from the canvas
	 * 2. Counts pixels of each unique color
	 * 3. Maps colors back to their timestamps
	 * 4. Adjusts counts based on the scale factor
	 *
	 * @returns A Map containing timestamp to pixel count mappings
	 */ async getPixelCounts() {
        const imageData = this.ctx.getImageData(0, 0, this.canvas.width, this.canvas.height);
        const timestampsAmount = this.colorTimeMap.size;
        const pixelCounts = await $0e1e69660e38aacc$export$fafc9be44839f9c8(imageData, this.scaleFactor, timestampsAmount);
        // Convert color counts to timestamp counts
        const timePixelCounts = new Map();
        for(let i = 0; i < pixelCounts.length; i++){
            const count = pixelCounts[i];
            if (typeof count !== 'number') continue;
            const color = i + 1;
            const rgbColor = $0e1e69660e38aacc$export$54591583ed0b20ce(color);
            const timestamp = this.colorTimeMap.get(rgbColor);
            if (timestamp !== undefined) timePixelCounts.set(timestamp, (timePixelCounts.get(timestamp) || 0) + count);
        }
        return timePixelCounts;
    }
}
function $0e1e69660e38aacc$export$54591583ed0b20ce(n) {
    // Ensure the input is within the valid range for a 24-bit color
    if (n < 0 || n > 0xffffff) throw new Error('Input number must be between 0 and 16777215 (inclusive).');
    // Extract blue component (bits 0-7)
    const blue = n & 0xff;
    // Extract green component (bits 8-15)
    const green = n >> 8 & 0xff;
    // Extract red component (bits 16-23)
    const red = n >> 16 & 0xff;
    return `rgb(${red}, ${green}, ${blue})`;
}
async function $0e1e69660e38aacc$export$fafc9be44839f9c8(imageData, scaleFactor, arraySize) {
    const data = imageData.data;
    const arr = new Uint32Array(arraySize);
    for(let i = 0; i < data.length; i += 4){
        // Check alpha
        if (data[i + 3] !== 0) {
            // Combine RGB components into a single 24-bit color value:
            // (data[i] << 16)   - Shift red component left 16 bits   (bits 16-23)
            // (data[i + 1] << 8) - Shift green component left 8 bits (bits 8-15)
            // data[i + 2]       - Blue component stays as is         (bits 0-7)
            // The | operator combines all bits together
            const color = data[i] << 16 | data[i + 1] << 8 | data[i + 2];
            const colorIndex = color - 1;
            arr[colorIndex] = (arr[colorIndex] || 0) + 1;
        }
        if (i % 10000 === 0) await (0, $ctFNJ.default)();
    }
    return arr;
}

});
parcelRegister("ctFNJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $7427e932608e9a3e$export$2e2bcd8739ae039);
// See https://developer.mozilla.org/en-US/docs/Web/API/Prioritized_Task_Scheduling_API
async function $7427e932608e9a3e$var$taskYield() {
    // This is using globalThis to allow the yield task to be used outside of a browser env
    if ('scheduler' in globalThis && // @ts-ignore
    'yield' in globalThis.scheduler) {
        // @ts-ignore
        await scheduler.yield();
        return;
    }
    let resolve = ()=>{};
    const p = new Promise((a)=>{
        resolve = a;
    });
    setTimeout(resolve, 0);
    await p;
}
var $7427e932608e9a3e$export$2e2bcd8739ae039 = $7427e932608e9a3e$var$taskYield;

});



parcelRegister("7YUd0", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1907482eac6f531$export$2e2bcd8739ae039);

var $aXT4C = parcelRequire("aXT4C");

var $ctFNJ = parcelRequire("ctFNJ");
const $d1907482eac6f531$var$MAX_HEATMAP_SIZE = 1000;
function $d1907482eac6f531$var$createEmptyHeatmapEntry() {
    return {
        head: null,
        previousEntries: []
    };
}
function $d1907482eac6f531$var$createEmptyMap(heatmapWidth, heatmapHeight) {
    return Array.from({
        length: heatmapHeight
    }).map(()=>Array.from({
            length: heatmapWidth
        }).map($d1907482eac6f531$var$createEmptyHeatmapEntry));
}
function $d1907482eac6f531$var$isRectInside(a, b) {
    if (!a || !b) return false;
    // Check if all corners of rectangle a are within the bounds of rectangle b
    return a.left >= b.left && a.right <= b.right && a.top >= b.top && a.bottom <= b.bottom;
}
class $d1907482eac6f531$var$Heatmap {
    constructor({ viewport: viewport, heatmapSize: heatmapSize }){
        // TODO timeOrigin? do we need? for SSR??
        this.viewport = viewport;
        const safeSize = Math.min(heatmapSize, $d1907482eac6f531$var$MAX_HEATMAP_SIZE);
        if (viewport.width === 0 || viewport.height === 0) {
            this.width = safeSize;
            this.height = safeSize;
            this.scaleX = 1;
            this.scaleY = 1;
            this.heatmapAreaSize = 0;
            this.map = $d1907482eac6f531$var$createEmptyMap(safeSize, safeSize);
            return;
        }
        const aspectRatio = viewport.width / viewport.height;
        if (aspectRatio > 1) {
            // Landscape orientation
            this.width = safeSize;
            this.height = Math.round(safeSize / aspectRatio);
        } else {
            // Portrait orientation
            this.width = safeSize;
            this.height = Math.round(safeSize * aspectRatio);
        }
        this.scaleX = this.width / viewport.width;
        this.scaleY = this.height / viewport.height;
        this.heatmapAreaSize = this.width * this.height;
        this.map = $d1907482eac6f531$var$createEmptyMap(this.width, this.height);
    }
    getHeatmap() {
        return this.map;
    }
    getCell(row, col) {
        return this.map[row]?.[col];
    }
    /**
	 * Map Dom Rect to Heatmap Rect, rounded up to occupy full cell.
	 * @param rect DOM Rect
	 * @returns
	 */ mapDOMRectToHeatmap(rect) {
        const scaledX = rect.x * this.scaleX;
        const scaledY = rect.y * this.scaleY;
        const scaledWidth = rect.width * this.scaleX;
        const scaledHeight = rect.height * this.scaleY;
        return {
            left: Math.floor(scaledX),
            right: Math.ceil(scaledX + scaledWidth),
            top: Math.floor(scaledY),
            bottom: Math.ceil(scaledY + scaledHeight)
        };
    }
    /**
	 * Calculate the ratio of a HeatmapRect compared to the full heatmap
	 *
	 * This function determines what fraction of the heatmap is covered by the given heatmap rectangle.
	 *
	 * @param rect
	 */ getRatio(rect) {
        if (this.viewport.width === 0 || this.viewport.height === 0) return 0;
        const { right: right, left: left, bottom: bottom, top: top } = rect;
        const rectWidth = right - left;
        const rectHeight = bottom - top;
        const rectArea = rectWidth * rectHeight;
        const ratio = rectArea / this.heatmapAreaSize;
        if (ratio > 1) return 1;
        return ratio;
    }
    async applyEntriesToHeatmap(entries) {
        for(let i = 0; i < entries.length; i++){
            const entry = entries[i];
            const { time: time, type: type, data: data } = entry;
            if ((0, $aXT4C.default)(data)) {
                const rect = this.mapDOMRectToHeatmap(data.rect);
                const ratio = this.getRatio(rect);
                const heatmapEntryData = {
                    time: time,
                    elementName: data.elementName,
                    ratio: ratio ?? null,
                    rect: rect,
                    source: type
                };
                const roundedTop = Math.floor(rect.top);
                const roundedBottom = Math.min(rect.bottom, this.height);
                const roundedLeft = Math.floor(rect.left);
                const roundedRight = Math.min(rect.right, this.width);
                for(let row = roundedTop; row < roundedBottom; row++)for(let col = roundedLeft; col < roundedRight; col++){
                    const cell = this.getCell(row, col);
                    if (!cell) continue;
                    const previousEntry = cell.head;
                    // When elements are added at the same time
                    // we try to keep the inner element changes as the head
                    if (previousEntry?.time === entry.time && $d1907482eac6f531$var$isRectInside(previousEntry.rect, heatmapEntryData.rect)) {
                        cell.previousEntries.push({
                            ...heatmapEntryData,
                            source: 'mutation:parent-mounted'
                        });
                        continue;
                    }
                    cell.head = {
                        ...heatmapEntryData,
                        source: heatmapEntryData.source || null
                    };
                    if (previousEntry !== null) cell.previousEntries.push(previousEntry);
                }
            }
            // Every 100 events processed
            // we give the browser the power
            // to process any other high priority task
            if (i % 100 === 0) await (0, $ctFNJ.default)();
        }
    }
    async getVCPercentMetrics(vcPercentCheckpoint, startTime) {
        const sortedCheckpoints = [
            ...vcPercentCheckpoint
        ].sort((a, b)=>a - b);
        const flattenHeatmap = this.map.flat();
        const totalCells = flattenHeatmap.length;
        const timestampMap = new Map();
        for(let i = 0; i < flattenHeatmap.length; i++){
            const cell = flattenHeatmap[i];
            const cellHead = cell.head;
            const timestamp = Math.trunc(cellHead?.time ?? 0);
            const elementName = cellHead?.elementName;
            const curr = timestampMap.get(timestamp) ?? {
                cellCount: 0,
                domElements: new Set()
            };
            curr.cellCount += 1;
            if (elementName) curr.domElements.add(elementName);
            timestampMap.set(timestamp, curr);
            // Every 10000 heatmap entries processed
            // we give the browser the power
            // to process any other high priority task
            if (i > 10000 && i % 10000 === 0) await (0, $ctFNJ.default)();
        }
        const sortedTimings = [
            ...timestampMap.keys()
        ].sort((a, b)=>a - b);
        let totalCellPainted = 0;
        const result = {};
        let domElementsBuffer = new Set();
        for(let i = 0; i < sortedTimings.length; i++){
            const timestamp = sortedTimings[i];
            const timestampInfo = timestampMap.get(timestamp);
            if (!timestampInfo) throw new Error('unexpected timestampInfo not found');
            const { cellCount: cellCount, domElements: domElements } = timestampInfo;
            totalCellPainted += cellCount;
            const currVCRatio = totalCellPainted / totalCells;
            const currVCPercent = Math.round(currVCRatio * 100);
            domElements.forEach((domElement)=>{
                domElementsBuffer.add(domElement);
            });
            let matchesAnyCheckpoints = false;
            while(sortedCheckpoints.length > 0 && currVCPercent >= sortedCheckpoints[0]){
                const checkpoint = sortedCheckpoints.shift();
                const domElements = [
                    ...domElementsBuffer
                ];
                if (!checkpoint) break;
                matchesAnyCheckpoints = true;
                result[checkpoint.toString()] = {
                    t: Math.round(timestamp - startTime),
                    e: domElements
                };
            }
            if (matchesAnyCheckpoints) domElementsBuffer.clear();
            if (i % 500 === 0) await (0, $ctFNJ.default)();
        }
        return result;
    }
}
async function $d1907482eac6f531$var$calculateTTVCPercentiles({ orderedEntries: orderedEntries, viewport: viewport, percentiles: percentiles, startTime: startTime }) {
    const heatmap = new $d1907482eac6f531$var$Heatmap({
        viewport: viewport,
        heatmapSize: 200
    });
    await heatmap.applyEntriesToHeatmap(orderedEntries);
    const vcDetails = await heatmap.getVCPercentMetrics(percentiles, startTime);
    return vcDetails;
}
var $d1907482eac6f531$export$2e2bcd8739ae039 = $d1907482eac6f531$var$calculateTTVCPercentiles;

});
parcelRegister("aXT4C", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a3a0b9cd58731c0$export$2e2bcd8739ae039);
function $1a3a0b9cd58731c0$var$isViewportEntryData(data) {
    if (data) {
        const hasElementName = typeof data.elementName === 'string';
        const hasRect = typeof data.rect !== 'undefined';
        if (hasRect && hasElementName) return true;
    }
    return false;
}
var $1a3a0b9cd58731c0$export$2e2bcd8739ae039 = $1a3a0b9cd58731c0$var$isViewportEntryData;

});


parcelRegister("aBSWp", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f28caeda438a786$export$2e2bcd8739ae039);

var $aXT4C = parcelRequire("aXT4C");

var $ctFNJ = parcelRequire("ctFNJ");

var $4SPdL = parcelRequire("4SPdL");
async function $4f28caeda438a786$var$calculateTTVCPercentiles({ orderedEntries: orderedEntries, viewport: viewport, percentiles: percentiles, startTime: startTime }) {
    const sortedPercentiles = [
        ...percentiles
    ].sort((a, b)=>a - b);
    const viewportArea = viewport.width * viewport.height;
    const checkpoints = {};
    let activeRects = orderedEntries.filter((e)=>(0, $aXT4C.default)(e.data)).map((e)=>e.data.rect);
    const removeActiveRect = (rectToRemove)=>{
        const index = activeRects.indexOf(rectToRemove);
        // Check if the element exists in the array
        if (index !== -1) // Remove the element at the found index
        activeRects.splice(index, 1);
    };
    let domElementsBuffer = new Set();
    for(let i = 0; i < orderedEntries.length; i++){
        const iEntry = orderedEntries[i];
        const iEntryData = iEntry.data;
        if (!(0, $aXT4C.default)(iEntryData)) continue;
        const { rect: rect, elementName: elementName } = iEntryData;
        domElementsBuffer.add(elementName);
        removeActiveRect(rect);
        const exclusionArea = (0, $4SPdL.default)(activeRects);
        const currentArea = viewportArea - exclusionArea;
        const currVCPercent = Math.round(currentArea / viewportArea * 100);
        let matchesAnyCheckpoints = false;
        while(sortedPercentiles.length > 0 && currVCPercent >= sortedPercentiles[0]){
            const checkpoint = sortedPercentiles.shift();
            const domElements = [
                ...domElementsBuffer
            ];
            if (!checkpoint) break;
            matchesAnyCheckpoints = true;
            checkpoints[checkpoint.toString()] = {
                t: Math.round(iEntry.time - startTime),
                e: domElements
            };
        }
        if (matchesAnyCheckpoints) domElementsBuffer.clear();
        if (i % 500 === 0) await (0, $ctFNJ.default)();
    }
    return checkpoints;
}
var $4f28caeda438a786$export$2e2bcd8739ae039 = $4f28caeda438a786$var$calculateTTVCPercentiles;

});
parcelRegister("4SPdL", function(module, exports) {

$parcel$export(module.exports, "default", () => $35172c167051c304$export$2e2bcd8739ae039);
/**
 * Calculate the union areas of all rectangles using Sweep Line Algorithm
 *
 * Reference:
 * 	https://en.wikipedia.org/wiki/Sweep_line_algorithm
 *  https://www.hackerearth.com/practice/math/geometry/line-sweep-technique/tutorial/#:~:text=A%20sweep%20line%20is%20an,order%20to%20discretize%20the%20sweep.
 *
 * @param rectangles
 * @returns
 */ function $35172c167051c304$var$calculateUnionArea(rectangles) {
    // Step 1: Create sweep line events
    const events = $35172c167051c304$var$createSweepLineEvents(rectangles);
    // Step 2: Process events to calculate total area
    const activeIntervals = new Map();
    let totalArea = 0;
    let previousX = 0;
    for (const event of events){
        // Calculate height at current x-position
        const currentHeight = $35172c167051c304$var$calculateActiveHeight(activeIntervals);
        // Add area since last x-position
        totalArea += currentHeight * (event.x - previousX);
        // Update x-position
        previousX = event.x;
        // Update active intervals
        $35172c167051c304$var$updateActiveIntervals(activeIntervals, event);
    }
    return totalArea;
}
var $35172c167051c304$export$2e2bcd8739ae039 = $35172c167051c304$var$calculateUnionArea;
function $35172c167051c304$var$createSweepLineEvents(rectangles) {
    const events = [];
    for (const rect of rectangles){
        // Create start and end events for each rectangle
        events.push({
            x: rect.left,
            type: 'start',
            top: rect.top,
            bottom: rect.bottom
        });
        events.push({
            x: rect.right,
            type: 'end',
            top: rect.top,
            bottom: rect.bottom
        });
    }
    // Sort events by x-coordinate (and type as tiebreaker)
    return events.sort((a, b)=>a.x === b.x ? a.type === 'end' ? 1 : -1 : a.x - b.x);
}
function $35172c167051c304$var$calculateActiveHeight(intervals) {
    if (intervals.size === 0) return 0;
    // Get all unique y-coordinates
    const coordinates = [];
    for (const [key] of intervals){
        const [start, end] = key.split(',').map(Number);
        coordinates.push(start, end);
    }
    // Sort coordinates
    const sortedCoords = [
        ...new Set(coordinates)
    ].sort((a, b)=>a - b);
    let totalHeight = 0;
    // Check each segment between consecutive coordinates
    for(let i = 0; i < sortedCoords.length; i++){
        const y1 = sortedCoords[i];
        const y2 = sortedCoords[i + 1];
        // Check if this segment is covered by any active interval
        let covered = false;
        for (const [key, count] of intervals){
            if (count <= 0) continue;
            const [start, end] = key.split(',').map(Number);
            if (start <= y1 && end >= y2) {
                covered = true;
                break;
            }
        }
        if (covered) totalHeight += y2 - y1;
    }
    return totalHeight;
}
function $35172c167051c304$var$updateActiveIntervals(intervals, event) {
    const key = `${event.top},${event.bottom}`;
    if (event.type === 'start') intervals.set(key, (intervals.get(key) || 0) + 1);
    else {
        const count = intervals.get(key) || 0;
        if (count > 1) intervals.set(key, count - 1);
        else intervals.delete(key);
    }
}

});



parcelRegister("6RK1A", function(module, exports) {

$parcel$export(module.exports, "default", () => $6076bc8255230f24$export$2e2bcd8739ae039);
function $6076bc8255230f24$var$getViewportHeight(document = window.document) {
    let documentHeight;
    try {
        documentHeight = document.documentElement.clientHeight || 0;
    } catch (e) {
        documentHeight = 0;
    }
    return Math.max(documentHeight, window.innerHeight || 0);
}
var $6076bc8255230f24$export$2e2bcd8739ae039 = $6076bc8255230f24$var$getViewportHeight;

});

parcelRegister("dF9Lu", function(module, exports) {

$parcel$export(module.exports, "default", () => $50f98cb8540d04a5$export$2e2bcd8739ae039);
function $50f98cb8540d04a5$var$getViewportWidth(document = window.document) {
    let documentWidth;
    try {
        documentWidth = document.documentElement.clientWidth || 0;
    } catch (e) {
        documentWidth = 0;
    }
    return Math.max(documentWidth, window.innerWidth || 0);
}
var $50f98cb8540d04a5$export$2e2bcd8739ae039 = $50f98cb8540d04a5$var$getViewportWidth;

});



parcelRegister("1OMZa", function(module, exports) {

$parcel$export(module.exports, "default", () => $924a5faf49f93f96$export$2e2bcd8739ae039);

var $1HYUt = parcelRequire("1HYUt");

var $eliYW = parcelRequire("eliYW");

var $aS5cI = parcelRequire("aS5cI");

var $4b2DW = parcelRequire("4b2DW");

var $aq5g1 = parcelRequire("aq5g1");
function $924a5faf49f93f96$var$isElementVisible(element) {
    if (!(element instanceof HTMLElement)) return true;
    try {
        const visible = element.checkVisibility({
            // @ts-expect-error
            visibilityProperty: true,
            contentVisibilityAuto: true,
            opacityProperty: true
        });
        return visible;
    } catch (e) {
        // there is no support for checkVisibility
        return true;
    }
}
function $924a5faf49f93f96$var$sameRectSize(a, b) {
    if (!a || !b) return false;
    return a.width === b.width && a.height === b.height;
}
function $924a5faf49f93f96$var$sameRectDimensions(a, b) {
    if (!a || !b) return false;
    return a.width === b.width && a.height === b.height && a.x === b.x && a.y === b.y;
}
const $924a5faf49f93f96$var$createElementMutationsWatcher = (removedNodeRects)=>({ rect: rect })=>{
        const wasDeleted = removedNodeRects.some((nr)=>$924a5faf49f93f96$var$sameRectDimensions(nr, rect));
        if (wasDeleted) return 'mutation:element-replacement';
        return 'mutation:element';
    };
class $924a5faf49f93f96$export$2e2bcd8739ae039 {
    constructor({ onChange: onChange }){
        this.mapVisibleNodeRects = new WeakMap();
        this.intersectionObserver = (0, $aS5cI.createIntersectionObserver)({
            onEntry: ({ target: target, rect: rect, time: time, type: type, mutationData: mutationData })=>{
                if (!target) return;
                const visible = $924a5faf49f93f96$var$isElementVisible(target);
                const lastElementRect = this.mapVisibleNodeRects.get(target);
                this.mapVisibleNodeRects.set(target, rect);
                onChange({
                    time: time,
                    type: type,
                    elementRef: new WeakRef(target),
                    visible: visible,
                    rect: rect,
                    previousRect: lastElementRect,
                    mutationData: mutationData
                });
            }
        });
        this.mutationObserver = (0, $4b2DW.default)({
            onChildListMutation: ({ addedNodes: addedNodes, removedNodes: removedNodes })=>{
                const removedNodeRects = removedNodes?.map((n)=>this.mapVisibleNodeRects.get(n)) ?? [];
                addedNodes.forEach((addedNode)=>{
                    // for (const elem of addedNode.querySelectorAll('*')) {
                    // 	this.intersectionObserver?.watchAndTag(elem, 'mutation:child-element');
                    // }
                    const sameDeletedNode = removedNodes.find((n)=>n.isEqualNode(addedNode));
                    if (sameDeletedNode) {
                        this.intersectionObserver?.watchAndTag(addedNode, 'mutation:remount');
                        return;
                    }
                    if ((0, $1HYUt.isContainedWithinMediaWrapper)(addedNode)) {
                        this.intersectionObserver?.watchAndTag(addedNode, 'mutation:media');
                        return;
                    }
                    this.intersectionObserver?.watchAndTag(addedNode, $924a5faf49f93f96$var$createElementMutationsWatcher(removedNodeRects));
                });
            },
            onAttributeMutation: ({ target: target, attributeName: attributeName })=>{
                this.intersectionObserver?.watchAndTag(target, ({ target: target, rect: rect })=>{
                    if ((0, $1HYUt.isContainedWithinMediaWrapper)(target)) return {
                        type: 'mutation:media',
                        mutationData: {
                            attributeName: attributeName
                        }
                    };
                    if ((0, $eliYW.default)({
                        target: target,
                        attributeName: attributeName,
                        type: 'attributes'
                    })) return {
                        type: 'mutation:attribute:non-visual-style',
                        mutationData: {
                            attributeName: attributeName
                        }
                    };
                    const lastElementRect = this.mapVisibleNodeRects.get(target);
                    if (lastElementRect && $924a5faf49f93f96$var$sameRectSize(rect, lastElementRect)) return {
                        type: 'mutation:attribute:no-layout-shift',
                        mutationData: {
                            attributeName: attributeName
                        }
                    };
                    return {
                        type: 'mutation:attribute',
                        mutationData: {
                            attributeName: attributeName
                        }
                    };
                });
            }
        });
        this.performanceObserver = (0, $aq5g1.default)({
            onLayoutShift: ({ time: time, changedRects: changedRects })=>{
                for (const changedRect of changedRects){
                    const target = changedRect.node;
                    if (target) onChange({
                        time: time,
                        elementRef: new WeakRef(target),
                        visible: true,
                        rect: changedRect.rect,
                        previousRect: changedRect.previousRect,
                        type: 'layout-shift'
                    });
                }
            }
        });
    }
    start() {
        this.mutationObserver?.observe(document.body, {
            attributeOldValue: true,
            attributes: true,
            childList: true,
            subtree: true
        });
        this.performanceObserver?.observe({
            type: 'layout-shift',
            buffered: true,
            // @ts-ignore-error
            durationThreshold: 30
        });
    }
    stop() {
        this.mutationObserver?.disconnect();
        this.intersectionObserver?.disconnect();
        this.performanceObserver?.disconnect();
    }
}

});
parcelRegister("aS5cI", function(module, exports) {

$parcel$export(module.exports, "createIntersectionObserver", () => $aed46d2ac193da35$export$c3799d33e0ae80a5);
function $aed46d2ac193da35$var$isValidEntry(entry) {
    return entry.isIntersecting && entry.intersectionRect.width > 0 && entry.intersectionRect.height > 0;
}
function $aed46d2ac193da35$export$c3799d33e0ae80a5({ onEntry: onEntry, onObserved: onObserved }) {
    if (!window || typeof window.IntersectionObserver !== 'function') return null;
    const callbacksPerElement = new WeakMap();
    const intersectionObserverCallback = (entries)=>{
        const validEntries = [];
        const startTime = performance.now();
        entries.forEach((entry)=>{
            if (!(entry.target instanceof HTMLElement) || !$aed46d2ac193da35$var$isValidEntry(entry)) return;
            let mutationTag = null;
            let mutationData = null;
            const tagOrCallback = callbacksPerElement.get(entry.target);
            if (typeof tagOrCallback === 'function') {
                const tagOrCallbackResult = tagOrCallback({
                    target: entry.target,
                    rect: entry.intersectionRect
                });
                if (!tagOrCallbackResult) mutationTag = 'unknown';
                else if (typeof tagOrCallbackResult === 'string') mutationTag = tagOrCallbackResult;
                else {
                    mutationTag = tagOrCallbackResult.type;
                    mutationData = tagOrCallbackResult.mutationData;
                }
            } else if (typeof tagOrCallback === 'string') mutationTag = tagOrCallback;
            onEntry({
                target: entry.target,
                rect: entry.intersectionRect,
                time: entry.time,
                type: mutationTag ?? 'unknown',
                mutationData: mutationData
            });
            validEntries.push(new WeakRef(entry.target));
            callbacksPerElement.delete(entry.target);
            observer.unobserve(entry.target);
        });
        onObserved?.({
            time: startTime,
            elements: validEntries
        });
    };
    const observer = new IntersectionObserver(intersectionObserverCallback);
    return {
        disconnect: ()=>{
            observer.disconnect();
        },
        unobserve: (target)=>{
            observer.unobserve(target);
        },
        watchAndTag: (target, tagOrCallback)=>{
            callbacksPerElement.set(target, tagOrCallback);
            observer.observe(target);
        }
    };
}

});

parcelRegister("4b2DW", function(module, exports) {

$parcel$export(module.exports, "default", () => $b967497fd95af45c$export$2e2bcd8739ae039);
function $b967497fd95af45c$var$createMutationObserver({ onAttributeMutation: onAttributeMutation, onChildListMutation: onChildListMutation, onMutationFinished: onMutationFinished }) {
    if (!window || typeof window.IntersectionObserver !== 'function') return null;
    const mutationObserverCallback = (mutations)=>{
        const addedNodes = [];
        const removedNodes = [];
        const targets = [];
        for (const mut of mutations){
            if (!(mut.target instanceof HTMLElement)) continue;
            if (mut.type === 'attributes') {
                /*
							"MutationObserver was explicitly designed to work that way, but I can't now recall the reasoning.
							I think it might have been something along the lines that for consistency every setAttribute call should create a record.
							Conceptually there is after all a mutation: there is an old value replaced with a new one,
							and whether or not they are the same doesn't really matter.
							And Custom elements should work the same way as MutationObserver."
							https://github.com/whatwg/dom/issues/520#issuecomment-336574796
						*/ const oldValue = mut.oldValue ?? undefined;
                const newValue = mut.attributeName ? mut.target.getAttribute(mut.attributeName) : undefined;
                if (oldValue !== newValue) onAttributeMutation({
                    target: mut.target,
                    attributeName: mut.attributeName ?? 'unknown'
                });
                continue;
            } else if (mut.type === 'childList') {
                (mut.addedNodes ?? []).forEach((node)=>{
                    if (node instanceof HTMLElement) addedNodes.push(node);
                });
                (mut.removedNodes ?? []).forEach((node)=>{
                    if (node instanceof HTMLElement) removedNodes.push(node);
                });
            }
            targets.push(mut.target);
        }
        onChildListMutation({
            addedNodes: addedNodes,
            removedNodes: removedNodes
        });
        onMutationFinished?.({
            targets: targets
        });
    };
    const observer = new MutationObserver(mutationObserverCallback);
    return observer;
}
var $b967497fd95af45c$export$2e2bcd8739ae039 = $b967497fd95af45c$var$createMutationObserver;

});

parcelRegister("aq5g1", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0f4470e0f19f214$export$2e2bcd8739ae039);
// The LayoutShiftAttribution API is returning the numbers on physical dimension
function $a0f4470e0f19f214$export$5e3f54cad8cb65e2(rect) {
    if (typeof window.devicePixelRatio !== 'number') return rect;
    if (window.devicePixelRatio === 1) return rect;
    // eslint-disable-next-line compat/compat
    return new DOMRect(rect.x / window.devicePixelRatio, rect.y / window.devicePixelRatio, rect.width / window.devicePixelRatio, rect.height / window.devicePixelRatio);
}
function $a0f4470e0f19f214$var$createPerformanceObserver({ onLayoutShift: onLayoutShift }) {
    if (!window || typeof window.PerformanceObserver !== 'function') return null;
    const performanceObserverCallback = (entries)=>{
        for (const entry of entries.getEntries())if (entry.entryType === 'layout-shift') {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const changedRects = entry.sources.reduceRight((acc, attr)=>{
                acc.push({
                    rect: $a0f4470e0f19f214$export$5e3f54cad8cb65e2(attr.currentRect),
                    previousRect: $a0f4470e0f19f214$export$5e3f54cad8cb65e2(attr.previousRect),
                    node: attr.node
                });
                return acc;
            }, []);
            onLayoutShift({
                time: entry.startTime,
                changedRects: changedRects
            });
        }
    };
    const observer = new PerformanceObserver(performanceObserverCallback);
    return observer;
}
var $a0f4470e0f19f214$export$2e2bcd8739ae039 = $a0f4470e0f19f214$var$createPerformanceObserver;

});


parcelRegister("ePAog", function(module, exports) {

$parcel$export(module.exports, "default", () => $91e5589b99c2bea9$export$2e2bcd8739ae039);

var $cBeZP = parcelRequire("cBeZP");
class $91e5589b99c2bea9$export$2e2bcd8739ae039 {
    constructor(opts){
        this.unbindFns = [];
        this.onEvent = opts.onEvent;
    }
    bindEvent(type) {
        const unbindCallback = (0, $cBeZP.bind)(window, {
            type: type,
            listener: (event)=>{
                if (!event.isTrusted) return;
                this.onEvent({
                    time: event.timeStamp,
                    type: type,
                    event: event
                });
            },
            options: {
                passive: true,
                once: true
            }
        });
        this.unbindFns.push(unbindCallback);
    }
    start() {
        this.bindEvent('wheel');
        this.bindEvent('scroll');
        this.bindEvent('keydown');
        this.bindEvent('resize');
    }
    stop() {
        this.unbindFns.forEach((cb)=>{
            cb();
        });
        this.unbindFns = [];
    }
}

});



parcelRegister("45w2S", function(module, exports) {

$parcel$export(module.exports, "interactions", () => $689164667c3e99b9$export$cc97b17ef9aeb088);
const $689164667c3e99b9$export$cc97b17ef9aeb088 = new Map();

});

parcelRegister("bJCAw", function(module, exports) {

$parcel$export(module.exports, "default", () => $34ef004db30d88d6$export$2e2bcd8739ae039);

var $fe1wc = parcelRequire("fe1wc");

var $h2sI1 = parcelRequire("h2sI1");
const $34ef004db30d88d6$var$POST_INTERACTION_LOG_SEND_DEFAULT_TIMEOUT = 3000;
class $34ef004db30d88d6$export$2e2bcd8739ae039 {
    initializeVCObserver(options) {
        if (this.vcObserver === null) this.vcObserver = new (0, $h2sI1.VCObserver)({
            ...options,
            isPostInteraction: true
        });
    }
    startVCObserver({ startTime: startTime }) {
        this.vcObserver?.start({
            startTime: startTime
        });
    }
    setVCObserverSSRConfig(vcObserverSSRConfig) {
        this.vcObserverSSRConfig = vcObserverSSRConfig;
    }
    /**
	 * Set the VC result as per the last interaction
	 * Used to compare diffs of VC updates vs post interaction VC observer
	 * @param result - VC result as calculated by UFO create payload
	 */ setLastInteractionFinishVCResult(result) {
        this.lastInteractionFinishVCResult = result;
    }
    /**
	 * Set the fn that would be invoked to process / send the observation data
	 */ sinkHandler(sinkHandlerFn) {
        this.sinkHandlerFn = sinkHandlerFn;
    }
    /**
	 * Reset state of the log
	 */ reset() {
        this.lastInteractionFinish = null;
        this.reactProfilerTimings = [];
        if (this.sinkTimeoutId != null) {
            clearTimeout(this.sinkTimeoutId);
            this.sinkTimeoutId = null;
        }
        this.setVCObserverSSRConfig(null);
    }
    /**
	 * Check if there is data in the log
	 */ hasData() {
        return this.reactProfilerTimings?.length > 0;
    }
    /**
	 * Send the log if there is data
	 */ async sendPostInteractionLog() {
        if (!this.hasData() || !this.lastInteractionFinish || !this.sinkHandlerFn) {
            this.reset();
            if ((0, $fe1wc.getConfig)()?.experimentalInteractionMetrics?.enabled) this.vcObserver?.stop();
            return;
        }
        const postInteractionFinishVCResult = await this.vcObserver?.getVCResult({
            start: this.lastInteractionFinish.start,
            stop: performance.now(),
            tti: -1,
            isEventAborted: !!this.lastInteractionFinish.abortReason,
            prefix: 'ufo',
            ...this.vcObserverSSRConfig
        });
        if ((0, $fe1wc.getConfig)()?.experimentalInteractionMetrics?.enabled) this.vcObserver?.stop();
        this.sinkHandlerFn({
            lastInteractionFinish: this.lastInteractionFinish,
            reactProfilerTimings: this.reactProfilerTimings,
            postInteractionFinishVCResult: // NOTE: invoking `getVCResult` at latest possible point in time here (not earlier) to get the most accurate result (from performance.now())
            postInteractionFinishVCResult,
            lastInteractionFinishVCResult: this.lastInteractionFinishVCResult
        });
        this.reset();
    }
    /**
	 * This fn should be invoked when an interaction has finished
	 * Basic details about the finished interaction will be recorded
	 * A timeout will be setup to send the post interaction observation after some time.
	 */ onInteractionComplete({ ufoName: ufoName, start: start, end: end, id: id, abortReason: abortReason, abortedByInteractionName: abortedByInteractionName, routeName: routeName, type: type, experimentalTTAI: experimentalTTAI, experimentalVC90: experimentalVC90 }) {
        this.lastInteractionFinish = {
            ufoName: ufoName,
            start: start,
            end: end,
            id: id,
            abortReason: abortReason,
            abortedByInteractionName: abortedByInteractionName,
            routeName: routeName,
            type: type,
            experimentalTTAI: experimentalTTAI,
            experimentalVC90: experimentalVC90
        };
        const timeout = (0, $fe1wc.getConfig)()?.timeWindowForLateMutationsInMilliseconds || $34ef004db30d88d6$var$POST_INTERACTION_LOG_SEND_DEFAULT_TIMEOUT;
        this.sinkTimeoutId = window.setTimeout(async ()=>{
            await this.sendPostInteractionLog();
        }, timeout);
    }
    /**
	 * This fn should be invoked when a React render happens after interaction has finished
	 */ addProfilerTimings(labelStack, type, actualDuration, baseDuration, startTime, commitTime) {
        if (this.lastInteractionFinish != null) this.reactProfilerTimings.push({
            type: type,
            actualDuration: actualDuration,
            baseDuration: baseDuration,
            startTime: startTime,
            commitTime: commitTime,
            labelStack: labelStack
        });
    }
    constructor(){
        /**
	 * Basic info about interaction that has just finished
	 */ this.lastInteractionFinish = null;
        /**
	 * Array of observed react render timings
	 */ this.reactProfilerTimings = [];
        /**
	 * Store the scheduled sink timeout Id so that it can be cancelled when needed
	 */ this.sinkTimeoutId = null;
        /**
	 * independent VC observer, that observes until `custom.post-interaction-logs` event is sent
	 */ this.vcObserver = null;
        this.vcObserverSSRConfig = null;
        /**
	 * Handler function to process / send the observation data
	 */ this.sinkHandlerFn = ()=>{};
    }
}

});


parcelRegister("2gQ83", function(module, exports) {

$parcel$export(module.exports, "default", () => $3fa6ca1de5bed78b$export$2e2bcd8739ae039);
// import uuid from 'uuid/v4';

var $7Jxgt = parcelRequire("7Jxgt");

var $lu9OT = parcelRequire("lu9OT");

var $aWBhb = parcelRequire("aWBhb");
const $3fa6ca1de5bed78b$var$packageVersion = "0.0.0-use.local";
const $3fa6ca1de5bed78b$var$originParamName = 'atlOrigin';
const $3fa6ca1de5bed78b$var$originVersioningAttributes = {
    originLibrary: `origin-tracing.js@${$3fa6ca1de5bed78b$var$packageVersion}`
};
class $3fa6ca1de5bed78b$export$2e2bcd8739ae039 {
    constructor({ id: id = $3fa6ca1de5bed78b$export$2e2bcd8739ae039.generateId(), product: product, dangerouslySkipValidation: dangerouslySkipValidation = false }){
        this.id = id;
        this.product = product;
        if (!dangerouslySkipValidation) this.validate();
    }
    static isValidId(value) {
        return typeof value === 'string' && /^[-_a-zA-Z0-9]{1,36}$/.test(value);
    }
    static isValidProduct(value) {
        return typeof value === 'string' && /^[-_a-zA-Z0-9]{1,20}$/.test(value);
    }
    static generateId() {
        const id = (0, $7Jxgt.v4)();
        // Dash positions are fixed so they don't add to uniqueness.
        // Remove them to save space in the encoded form.
        return id.replace(/-/g, '');
    }
    static createEmpty() {
        return new $3fa6ca1de5bed78b$var$EmptyOriginTracer();
    }
    static createMalformed() {
        return new $3fa6ca1de5bed78b$var$MalformedOriginTracer();
    }
    static fromUrl(url) {
        let params = new ((0, $aWBhb.getEnv)()).URLSearchParams();
        $3fa6ca1de5bed78b$var$replaceQuery(url, (queryString)=>{
            params = new ((0, $aWBhb.getEnv)()).URLSearchParams(queryString);
        });
        return $3fa6ca1de5bed78b$export$2e2bcd8739ae039.fromEncoded(params.get($3fa6ca1de5bed78b$var$originParamName));
    }
    static fromEncoded(encoded) {
        if (!encoded) return $3fa6ca1de5bed78b$export$2e2bcd8739ae039.createEmpty();
        try {
            return $3fa6ca1de5bed78b$export$2e2bcd8739ae039.decode(encoded);
        } catch (e) {
            return $3fa6ca1de5bed78b$export$2e2bcd8739ae039.createMalformed();
        }
    }
    static removeFromUrl(url) {
        return $3fa6ca1de5bed78b$var$replaceQuery(url, (queryString)=>{
            const params = new ((0, $aWBhb.getEnv)()).URLSearchParams(queryString);
            params.delete($3fa6ca1de5bed78b$var$originParamName);
            return params.toString();
        });
    }
    static decode(encodedOrigin) {
        const originData = (0, $lu9OT.decode)(encodedOrigin);
        return new $3fa6ca1de5bed78b$export$2e2bcd8739ae039(originData);
    }
    encode() {
        return (0, $lu9OT.encode)({
            id: this.id,
            product: this.product
        });
    }
    addToUrl(url) {
        return $3fa6ca1de5bed78b$var$replaceQuery(url, (originalQueryString)=>{
            const params = new ((0, $aWBhb.getEnv)()).URLSearchParams(originalQueryString);
            params.set($3fa6ca1de5bed78b$var$originParamName, this.encode());
            return params.toString();
        });
    }
    isEmpty() {
        return false;
    }
    isMalformed() {
        return !this.isEmpty() && !this.isValid();
    }
    isValid() {
        return true;
    }
    toAnalyticsAttributes({ transformValue: transformValue = (v)=>v === null ? undefined : v, hasGeneratedId: hasGeneratedId = false } = {}) {
        // `originIdGenerated` should be used in analytic events that generated this originId.
        // Subsequent events should use `originId`.
        // No two events should have the same value of originIdGenerated.
        const originIdProp = hasGeneratedId ? 'originIdGenerated' : 'originId';
        return {
            [originIdProp]: transformValue(this.id),
            originProduct: transformValue(this.product),
            ...$3fa6ca1de5bed78b$var$originVersioningAttributes
        };
    }
    validate() {
        if (!$3fa6ca1de5bed78b$export$2e2bcd8739ae039.isValidId(this.id)) throw new TypeError('Invalid Origin id');
        if (!$3fa6ca1de5bed78b$export$2e2bcd8739ae039.isValidProduct(this.product)) throw new TypeError('Missing/invalid Origin product');
    }
}
class $3fa6ca1de5bed78b$var$EmptyOriginTracer extends $3fa6ca1de5bed78b$export$2e2bcd8739ae039 {
    constructor(){
        super({
            id: null,
            product: null,
            dangerouslySkipValidation: true
        });
    }
    isValid() {
        return false;
    }
    isEmpty() {
        return true;
    }
    toAnalyticsAttributes() {
        return {
            ...$3fa6ca1de5bed78b$var$originVersioningAttributes
        };
    }
}
class $3fa6ca1de5bed78b$var$MalformedOriginTracer extends $3fa6ca1de5bed78b$export$2e2bcd8739ae039 {
    constructor(){
        super({
            id: null,
            product: null,
            dangerouslySkipValidation: true
        });
    }
    isValid() {
        return false;
    }
    isEmpty() {
        return false;
    }
    toAnalyticsAttributes() {
        return {
            originMalformed: true,
            ...$3fa6ca1de5bed78b$var$originVersioningAttributes
        };
    }
}
function $3fa6ca1de5bed78b$var$replaceQuery(url, replacer) {
    const urlWithQueryStringRegex = /(^[^?#]*)(?:\?)?([^#]*?)(#.*|$)$/;
    // If we get passed window.location, we don't want to call window.location.replace()
    const urlString = String(url);
    return urlString.replace(urlWithQueryStringRegex, (_wholeMatch, beforeQuery, queryString, afterQuery)=>{
        let newQueryString = replacer(queryString);
        if (newQueryString) newQueryString = `?${newQueryString}`;
        return `${beforeQuery}${newQueryString}${afterQuery}`;
    });
}

});
parcelRegister("lu9OT", function(module, exports) {

$parcel$export(module.exports, "encode", () => $c6803b60c51754ac$export$c564cdbbe6da493);
$parcel$export(module.exports, "decode", () => $c6803b60c51754ac$export$2f872c0f2117be69);

var $8FuSo = parcelRequire("8FuSo");

var $aWBhb = parcelRequire("aWBhb");
const $c6803b60c51754ac$var$productShorthands = {
    confluence: 'c',
    jira: 'j',
    stride: 's',
    bitbucket: 'b',
    trello: 't'
};
function $c6803b60c51754ac$export$c564cdbbe6da493(originData) {
    const json = JSON.stringify($c6803b60c51754ac$export$4bc4b533a565aabe(originData));
    const base64 = (0, $aWBhb.getEnv)().btoa(json);
    return (0, $8FuSo.base64ToBase64Url)(base64);
}
function $c6803b60c51754ac$export$2f872c0f2117be69(encodedOriginString) {
    const base64 = (0, $8FuSo.base64UrlToBase64)(encodedOriginString);
    const json = (0, $aWBhb.getEnv)().atob(base64);
    return $c6803b60c51754ac$export$46d5cda6b884b7ab(JSON.parse(json));
}
function $c6803b60c51754ac$export$4bc4b533a565aabe({ id: id, product: product }) {
    return {
        i: id,
        p: product && product in $c6803b60c51754ac$var$productShorthands ? $c6803b60c51754ac$var$productShorthands[product] : product
    };
}
function $c6803b60c51754ac$export$46d5cda6b884b7ab(originJSONObject) {
    const originData = {};
    if (originJSONObject.i) originData.id = originJSONObject.i;
    if (originJSONObject.p) originData.product = $c6803b60c51754ac$var$expandProductShorthand(originJSONObject.p);
    return originData;
}
function $c6803b60c51754ac$var$expandProductShorthand(maybeShorthand) {
    const products = Object.keys($c6803b60c51754ac$var$productShorthands);
    for(let i = 0; i < products.length; i++){
        const product = products[i];
        const shorthand = $c6803b60c51754ac$var$productShorthands[product];
        if (maybeShorthand === shorthand) return product;
    }
    return maybeShorthand;
}

});
parcelRegister("8FuSo", function(module, exports) {

$parcel$export(module.exports, "base64ToBase64Url", () => $232e5bc3d2389a2f$export$3b91e21dac1023c6);
$parcel$export(module.exports, "base64UrlToBase64", () => $232e5bc3d2389a2f$export$47c5265a25535d02);
/**
 * This file converts between Base64 and Base 64 Encoding with URL and Filename Safe Alphabet,
 * the latter of which has URL-safe characters only (drops =, + and /).
 *
 * Why not use a library? The popular libs use Buffer to be able to
 * encode any data to base64. We don't need this capability, and it causes
 * Webpack to include 30KB of a Buffer polyfill.
 * Webpack's/UglifyJS's Tree Shaking seems to be unable to drop it.
 *
 * See: RFC 4648 section 5 (https://tools.ietf.org/html/rfc4648#section-5)
 */ function $232e5bc3d2389a2f$export$3b91e21dac1023c6(base64) {
    if (base64 == null) return '';
    return String(base64).replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
}
function $232e5bc3d2389a2f$export$47c5265a25535d02(base64url) {
    if (base64url == null) return '';
    const base64 = String(base64url).replace(/-/g, '+').replace(/_/g, '/');
    const padLength = (4 - base64url.length % 4) % 4;
    const pad = '==='.slice(0, padLength);
    return base64 + pad;
}

});

parcelRegister("aWBhb", function(module, exports) {

$parcel$export(module.exports, "getEnv", () => $1a7c166c1d080aee$export$4bd44a2aa29d3d6e);

var $5k7LC = parcelRequire("5k7LC");

const $1a7c166c1d080aee$export$d3cd91e0fdbfdbc0 = ()=>({
        atob: // atob/btoa need to be bound because they throw an illegal invocation error when called as a method (obj.atob())
        typeof atob === 'function' && atob.bind(undefined) || typeof (0, $5k7LC.Buffer) !== 'undefined' && ((encoded)=>(0, $5k7LC.Buffer).from(encoded, 'base64').toString()),
        btoa: typeof btoa === 'function' && btoa.bind(undefined) || typeof (0, $5k7LC.Buffer) !== 'undefined' && ((str)=>(0, $5k7LC.Buffer).from(str).toString('base64')),
        URLSearchParams: typeof URLSearchParams === 'function' && URLSearchParams || (0, (parcelRequire("6vAaw")).URLSearchParams)
    });
let $1a7c166c1d080aee$var$env;
const $1a7c166c1d080aee$export$4bd44a2aa29d3d6e = ()=>$1a7c166c1d080aee$var$env || ($1a7c166c1d080aee$var$env = $1a7c166c1d080aee$var$validateEnv($1a7c166c1d080aee$export$d3cd91e0fdbfdbc0()));
const $1a7c166c1d080aee$var$validateEnv = (env)=>{
    if (!(env.atob && env.btoa && env.URLSearchParams)) throw new TypeError(`Origin-Tracing: missing environment APIs. Required: btoa(), atob(), URLSearchParams() (or in Node: Buffer, require('url').URLSearchParams).`);
    return env;
};

});



parcelRegister("fYgl8", function(module, exports) {

$parcel$export(module.exports, "CompressionRule", () => $ec49cb044e2703e6$export$89b3253ddfd2e6e8);

var $ibWJJ = parcelRequire("ibWJJ");

var $gYqa8 = parcelRequire("gYqa8");
class $ec49cb044e2703e6$export$89b3253ddfd2e6e8 {
    /**
	 * @callback EventPredicate
	 * @param {object} event An analytics event
	 * @returns {boolean} A flag indicating whether or not the event matches the conditions
	 */ /**
	 * @callback CompressionFunction
	 * @param {Array.<Object>} events A collection of analytics events that match the predicate of this compression rule
	 * @returns {Array.<Object>} compressedEvents The compressed analytics events to fire
	 */ /**
	 * This constructor defines a new rule for compressing analytics events.
	 * @param {EventPredicate} predicate
	 * @param {CompressionFunction} compressFn
	 */ constructor(predicate, compressFn){
        /**
	 * This function returns a flag indicating whether or not this instance is capable of compressing the given event.
	 * @param event
	 * @returns {boolean}
	 */ this.canCompress = (event)=>{
            try {
                return event && (0, $ibWJJ.isActionEventType)(event.eventType) && this.predicate(event);
            } catch (e) {
                return false;
            }
        };
        /**
	 * This function compresses as many events in the given collection as possible.<p>
	 * Any events in the given collection that do not match the conditions of {@link canCompress} will be left uncompressed and
	 * appended to the end of the resulting array.
	 *
	 * @param events A collection of analytic events to compress
	 * @returns {Array.<Object>} The action fields for the resulting compressed events
	 */ this.compress = (events)=>{
            const [compatibleEvents, incompatibleEvents] = (0, $gYqa8.partition)(events, (event)=>this.canCompress(event));
            const compressedEvents = this.compressFn(compatibleEvents);
            if (!compressedEvents) throw new Error('No events were returned from the compression function');
            compressedEvents.forEach((event)=>{
                (0, $ibWJJ.validateActionEventType)(event.eventType);
                (0, $ibWJJ.validateActionEvent)(event);
            });
            return compressedEvents.concat(incompatibleEvents);
        };
        if (typeof predicate !== 'function') throw new Error('Invalid predicate, must be a function that accepts an event and returns a boolean');
        if (typeof compressFn !== 'function') throw new Error('Invalid compressFn, must be a function that both accepts and returns an array of events');
        this.predicate = predicate;
        this.compressFn = compressFn;
    }
}

});
parcelRegister("ibWJJ", function(module, exports) {

$parcel$export(module.exports, "validateContainers", () => $e3b790962f90cf08$export$e63ea5d8477971d3);
$parcel$export(module.exports, "isActionEventType", () => $e3b790962f90cf08$export$d19cebda16f7579a);
$parcel$export(module.exports, "validateActionEventType", () => $e3b790962f90cf08$export$4a8d7476662aebcc);
$parcel$export(module.exports, "validateActionEvent", () => $e3b790962f90cf08$export$e0c121325c66ed4c);
$parcel$export(module.exports, "validateScreenEvent", () => $e3b790962f90cf08$export$dc993432a592dc27);
$parcel$export(module.exports, "validateTrackEvent", () => $e3b790962f90cf08$export$8c014fd74b0c8b99);
$parcel$export(module.exports, "validateDwellBaseEvent", () => $e3b790962f90cf08$export$39d6334da9a44984);
$parcel$export(module.exports, "validateUIEvent", () => $e3b790962f90cf08$export$e5bac0930c812e90);
$parcel$export(module.exports, "validateOperationalEvent", () => $e3b790962f90cf08$export$1e561554275607ef);
$parcel$export(module.exports, "validateIdentifyEvent", () => $e3b790962f90cf08$export$c16a4e16aa4026c0);
$parcel$export(module.exports, "validatePlatform", () => $e3b790962f90cf08$export$801b46c35394d316);

var $iZhen = parcelRequire("iZhen");

var $eB7xz = parcelRequire("eB7xz");
const $e3b790962f90cf08$var$actionEventTypes = Object.freeze([
    (0, $iZhen.eventType).OPERATIONAL,
    (0, $iZhen.eventType).TRACK,
    (0, $iZhen.eventType).UI
]);
function $e3b790962f90cf08$export$df8ff30e3c960006(container) {
    if (!(0, $eB7xz.isPlainObject)(container)) throw new Error('properties.containers must be an Object');
    if (!('id' in container)) throw new Error("properties.containers is missing field 'id'");
    if (typeof container.id !== 'string') throw new Error('properties.containers.id must be of type String');
    if ('type' in container && typeof container.type !== 'string') throw new Error('properties.containers.type must be of type String');
}
function $e3b790962f90cf08$export$e63ea5d8477971d3(containers) {
    if (!containers) return;
    if (containers && containers.constructor !== Object) throw new Error('properties.containers must be an Object');
    Object.values(containers).forEach((container)=>$e3b790962f90cf08$export$df8ff30e3c960006(container));
}
function $e3b790962f90cf08$export$d19cebda16f7579a(type) {
    switch(type){
        case (0, $iZhen.eventType).OPERATIONAL:
        case (0, $iZhen.eventType).TRACK:
        case (0, $iZhen.eventType).UI:
            return true;
        default:
            return false;
    }
}
function $e3b790962f90cf08$export$4a8d7476662aebcc(type) {
    if (!$e3b790962f90cf08$export$d19cebda16f7579a(type)) throw new Error(`Invalid action event type: ${type}, must be one of: [${$e3b790962f90cf08$var$actionEventTypes}]`);
    return true;
}
function $e3b790962f90cf08$export$e0c121325c66ed4c(event) {
    if (!event) throw new Error('Missing event');
    if (!event.source) throw new Error('Missing event.source');
    if (!event.actionSubject) throw new Error('Missing event.actionSubject');
    if (!event.action) throw new Error('Missing event.action');
    $e3b790962f90cf08$export$e63ea5d8477971d3(event.containers);
}
function $e3b790962f90cf08$export$dc993432a592dc27(name) {
    if (!name) throw new Error('Missing name');
}
function $e3b790962f90cf08$export$8c014fd74b0c8b99(event) {
    $e3b790962f90cf08$export$e0c121325c66ed4c(event);
}
function $e3b790962f90cf08$export$39d6334da9a44984(event) {
    if (!event) throw new Error('Missing event');
    if (!event.source) throw new Error('Missing event.source');
    if (!event.actionSubject) throw new Error('Missing event.actionSubject');
}
function $e3b790962f90cf08$export$e5bac0930c812e90(event) {
    $e3b790962f90cf08$export$e0c121325c66ed4c(event);
}
function $e3b790962f90cf08$export$1e561554275607ef(event) {
    $e3b790962f90cf08$export$e0c121325c66ed4c(event);
}
function $e3b790962f90cf08$export$c16a4e16aa4026c0(userIdType, userId) {
    if (!userIdType) throw new Error('Missing userIdType');
    if (!userId) throw new Error('Missing userId');
    if (!(0, $iZhen.isType)((0, $iZhen.userType), userIdType)) throw new Error(`Invalid userIdType '${userIdType}', ` + `must be an userType: [${(0, $iZhen.objectValues)((0, $iZhen.userType))}]`);
}
function $e3b790962f90cf08$export$801b46c35394d316(productInfo) {
    if (!(0, $iZhen.isType)((0, $iZhen.platformType), productInfo.platform)) throw new Error(`Invalid productInfo.platform '${productInfo.platform}', ` + `must be a platformType: [${(0, $iZhen.objectValues)((0, $iZhen.platformType))}]`);
    if (productInfo.origin === (0, $iZhen.originType).DESKTOP && !(0, $iZhen.isType)((0, $iZhen.desktopPlatforms), productInfo.platform)) throw new Error(`Invalid productInfo.platform '${productInfo.platform}', ` + 'must be one of [mac, linux, windows]');
    if (productInfo.origin === (0, $iZhen.originType).WEB && !(0, $iZhen.isType)((0, $iZhen.webPlatforms), productInfo.platform)) throw new Error(`Invalid productInfo.platform '${productInfo.platform}', must be one of [web, mobileWeb]`);
}

});
parcelRegister("iZhen", function(module, exports) {

$parcel$export(module.exports, "envType", () => $cc3cc1fbdc8ce7b5$export$56ac8ebc9870b1b9);
$parcel$export(module.exports, "eventType", () => $cc3cc1fbdc8ce7b5$export$4c045e605d532c98);
$parcel$export(module.exports, "platformType", () => $cc3cc1fbdc8ce7b5$export$6b4f396210e539f3);
$parcel$export(module.exports, "originType", () => $cc3cc1fbdc8ce7b5$export$f73e9fcd368bb695);
$parcel$export(module.exports, "tenantType", () => $cc3cc1fbdc8ce7b5$export$496f06ac2a964da2);
$parcel$export(module.exports, "productEmbedType", () => $cc3cc1fbdc8ce7b5$export$f49776dca27a2e7c);
$parcel$export(module.exports, "userType", () => $cc3cc1fbdc8ce7b5$export$1827adfd178b4870);
$parcel$export(module.exports, "apdexType", () => $cc3cc1fbdc8ce7b5$export$99b37380a464d794);
$parcel$export(module.exports, "desktopPlatforms", () => $cc3cc1fbdc8ce7b5$export$809831be6c4c6227);
$parcel$export(module.exports, "webPlatforms", () => $cc3cc1fbdc8ce7b5$export$19c579398ad213e7);
$parcel$export(module.exports, "originTracingType", () => $cc3cc1fbdc8ce7b5$export$62a500c02dc63ee);
$parcel$export(module.exports, "objectValues", () => $cc3cc1fbdc8ce7b5$export$ad1854f4a08c15f8);
$parcel$export(module.exports, "isType", () => $cc3cc1fbdc8ce7b5$export$26b9f946b448f23e);
$parcel$export(module.exports, "perimeterType", () => $cc3cc1fbdc8ce7b5$export$bdd41749d2096e4b);
$parcel$export(module.exports, "aliasType", () => $cc3cc1fbdc8ce7b5$export$a8c99e46b781d936);
$parcel$export(module.exports, "groupType", () => $cc3cc1fbdc8ce7b5$export$e73680b18d9b7c6e);
// These types have been converted from frozen objects to enums.
// We cannot change their name, or even capitalise them without breaking API.
var $cc3cc1fbdc8ce7b5$export$56ac8ebc9870b1b9 = /*#__PURE__*/ function(envType) {
    envType["LOCAL"] = "local";
    envType["DEV"] = "dev";
    envType["STAGING"] = "staging";
    envType["PROD"] = "prod";
    return envType;
}({});
var $cc3cc1fbdc8ce7b5$export$4c045e605d532c98 = /*#__PURE__*/ function(eventType) {
    eventType["TRACK"] = "track";
    eventType["UI"] = "ui";
    eventType["OPERATIONAL"] = "operational";
    eventType["SCREEN"] = "screen";
    eventType["IDENTIFY"] = "identify";
    return eventType;
}({});
var $cc3cc1fbdc8ce7b5$export$6b4f396210e539f3 = /*#__PURE__*/ function(platformType) {
    platformType["MAC"] = "mac";
    platformType["LINUX"] = "linux";
    platformType["WINDOWS"] = "windows";
    /**
	 *  @deprecated desktop is here for retrocompatibility, please select one of the above OS instead.
	 */ platformType["DESKTOP"] = "desktop";
    platformType["WEB"] = "web";
    platformType["MOBILE_WEB"] = "mobileWeb";
    return platformType;
}({});
var $cc3cc1fbdc8ce7b5$export$f73e9fcd368bb695 = /*#__PURE__*/ function(originType) {
    originType["DESKTOP"] = "desktop";
    originType["WEB"] = "web";
    return originType;
}({});
var $cc3cc1fbdc8ce7b5$export$496f06ac2a964da2 = /*#__PURE__*/ function(tenantType) {
    tenantType["CLOUD_ID"] = "cloudId";
    tenantType["ORG_ID"] = "orgId";
    tenantType["OPSGENIE_CUSTOMER_ID"] = "opsgenieCustomerId";
    tenantType["HALP_TEAM_ID"] = "halpTeamId";
    tenantType["LOOM_ORG_ID"] = "loomOrgId";
    tenantType["TRANSACTION_ACCOUNT_ID"] = "transactionAccountId";
    tenantType["TRELLO_WORKSPACE_ID"] = "trelloWorkspaceId";
    tenantType["JA_WORKSPACE_ID"] = "jiraAlignWorkspaceId";
    tenantType["NONE"] = "none";
    return tenantType;
}({});
var $cc3cc1fbdc8ce7b5$export$f49776dca27a2e7c = /*#__PURE__*/ function(productEmbedType) {
    productEmbedType["FIRST_PARTY"] = "FIRST_PARTY";
    productEmbedType["THIRD_PARTY"] = "THIRD_PARTY";
    return productEmbedType;
}({});
var $cc3cc1fbdc8ce7b5$export$1827adfd178b4870 = /*#__PURE__*/ function(userType) {
    userType["ATLASSIAN_ACCOUNT"] = "atlassianAccount";
    userType["HASHED_EMAIL"] = "hashedEmail";
    userType["LOOM"] = "loom";
    userType["TRELLO"] = "trello";
    userType["OPSGENIE"] = "opsgenie";
    userType["JA_USER_ID"] = "jiraAlign";
    userType["HALP"] = "halp";
    return userType;
}({});
var $cc3cc1fbdc8ce7b5$export$99b37380a464d794 = /*#__PURE__*/ function(apdexType) {
    apdexType["TRANSITION"] = "transition";
    apdexType["INITIAL_LOAD"] = "initialLoad";
    return apdexType;
}({});
const $cc3cc1fbdc8ce7b5$export$809831be6c4c6227 = Object.freeze([
    "desktop",
    "mac",
    "linux",
    "windows"
]);
const $cc3cc1fbdc8ce7b5$export$19c579398ad213e7 = Object.freeze([
    "web",
    "mobileWeb"
]);
var $cc3cc1fbdc8ce7b5$export$62a500c02dc63ee = /*#__PURE__*/ function(originTracingType) {
    originTracingType["ATL_ORIGIN"] = "atlOrigin";
    return originTracingType;
}({});
function $cc3cc1fbdc8ce7b5$export$ad1854f4a08c15f8(object) {
    return Object.values(object);
}
function $cc3cc1fbdc8ce7b5$export$26b9f946b448f23e(type, value) {
    return Object.values(type).indexOf(value) > -1;
}
var $cc3cc1fbdc8ce7b5$export$bdd41749d2096e4b = /*#__PURE__*/ function(perimeterType) {
    perimeterType["C5"] = "c5";
    perimeterType["COMMERCIAL"] = "commercial";
    perimeterType["FEDRAMP_MODERATE"] = "fedramp-moderate";
    perimeterType["FEDRAMP_HIGH"] = "fedramp-high";
    return perimeterType;
}({});
var $cc3cc1fbdc8ce7b5$export$a8c99e46b781d936 = /*#__PURE__*/ function(aliasType) {
    return aliasType;
}({});
var $cc3cc1fbdc8ce7b5$export$e73680b18d9b7c6e = /*#__PURE__*/ function(groupType) {
    groupType["TRANSACTION_ACCOUNT_ID"] = "transactionAccountId";
    return groupType;
}({});
var $cc3cc1fbdc8ce7b5$export$12b75c708da5a04b = /*#__PURE__*/ function(envOverrides) {
    return envOverrides;
}({});

});

parcelRegister("eB7xz", function(module, exports) {

$parcel$export(module.exports, "isPlainObject", () => $e2842dac7ef4c0ca$export$53b83ca8eaab0383);
// Modified from https://github.com/jonschlinkert/is-plain-object/blob/master/index.js
function $e2842dac7ef4c0ca$var$isObject(val) {
    return val !== null && typeof val === 'object' && Array.isArray(val) === false;
}
function $e2842dac7ef4c0ca$var$isObjectObject(o) {
    return $e2842dac7ef4c0ca$var$isObject(o) === true && Object.prototype.toString.call(o) === '[object Object]';
}
function $e2842dac7ef4c0ca$export$53b83ca8eaab0383(o) {
    if ($e2842dac7ef4c0ca$var$isObjectObject(o) === false) return false;
    // If has modified constructor
    const ctor = o.constructor;
    if (typeof ctor !== 'function') return false;
    // If has modified prototype
    const prot = ctor.prototype;
    if ($e2842dac7ef4c0ca$var$isObjectObject(prot) === false) return false;
    // If constructor does not have an Object-specific method
    if (!('isPrototypeOf' in prot)) return false;
    // Most likely a plain Object
    return true;
}

});


parcelRegister("gYqa8", function(module, exports) {

$parcel$export(module.exports, "mapKeys", () => $45e0b808c9dc848d$export$781522908e4e76a1);
$parcel$export(module.exports, "pick", () => $45e0b808c9dc848d$export$357523c63a2253b9);
$parcel$export(module.exports, "omitBy", () => $45e0b808c9dc848d$export$d7a617dda645b4e3);
$parcel$export(module.exports, "pickBy", () => $45e0b808c9dc848d$export$b460b275d6c6aa0);
$parcel$export(module.exports, "omit", () => $45e0b808c9dc848d$export$30a06c8d3562193f);
$parcel$export(module.exports, "equals", () => $45e0b808c9dc848d$export$e9bab7fafb253603);
$parcel$export(module.exports, "partition", () => $45e0b808c9dc848d$export$b29f828819edca8d);
/* eslint-disable no-return-assign, no-sequences */ // https://www.30secondsofcode.org/js/s/map-keys
const $45e0b808c9dc848d$export$781522908e4e76a1 = (obj, fn)=>Object.keys(obj).reduce((acc, k)=>{
        const key = fn(obj[k], k, obj);
        acc[key] = obj[k];
        return acc;
    }, {});
// https://www.30secondsofcode.org/js/s/pick
const $45e0b808c9dc848d$export$357523c63a2253b9 = (obj, arr)=>arr.reduce((acc, curr)=>(curr in obj && (acc[curr] = obj[curr]), acc), {});
// https://www.30secondsofcode.org/js/s/omit-by
const $45e0b808c9dc848d$export$d7a617dda645b4e3 = (obj, fn)=>Object.keys(obj).filter((k)=>!fn(obj[k], k)).reduce((acc, key)=>(acc[key] = obj[key], acc), {});
// https://www.30secondsofcode.org/js/s/pick-by
const $45e0b808c9dc848d$export$b460b275d6c6aa0 = (obj, fn)=>Object.keys(obj).filter((k)=>fn(obj[k], k)).reduce((acc, key)=>(acc[key] = obj[key], acc), {});
// https://www.30secondsofcode.org/js/s/omit
const $45e0b808c9dc848d$export$30a06c8d3562193f = (obj, arr)=>Object.keys(obj).filter((k)=>arr.indexOf(k) < 0).reduce((acc, key)=>(acc[key] = obj[key], acc), {});
// https://www.30secondsofcode.org/js/s/equals
const $45e0b808c9dc848d$export$e9bab7fafb253603 = (a, b)=>{
    if (a === b) return true;
    if (a instanceof Date && b instanceof Date) return a.getTime() === b.getTime();
    if (!a || !b || typeof a !== 'object' && typeof b !== 'object') return a === b;
    if (a.prototype !== b.prototype) return false;
    const keys = Object.keys(a);
    if (keys.length !== Object.keys(b).length) return false;
    return keys.every((k)=>$45e0b808c9dc848d$export$e9bab7fafb253603(a[k], b[k]));
};
// https://www.30secondsofcode.org/js/s/partition
const $45e0b808c9dc848d$export$b29f828819edca8d = (arr, fn)=>arr.reduce(// eslint-disable-next-line no-shadow
    (acc, val, i, arr)=>{
        acc[fn(val, i, arr) ? 0 : 1].push(val);
        return acc;
    }, [
        [],
        []
    ]);

});


parcelRegister("buAWB", function(module, exports) {

$parcel$export(module.exports, "default", () => $a2554ad786286b0a$export$2e2bcd8739ae039);

var $bXrHm = parcelRequire("bXrHm");

var $iZhen = parcelRequire("iZhen");

var $hI2MJ = parcelRequire("hI2MJ");

var $kljjv = parcelRequire("kljjv");

var $3mN0k = parcelRequire("3mN0k");

var $fNiuW = parcelRequire("fNiuW");

var $76MW0 = parcelRequire("76MW0");

var $ibWJJ = parcelRequire("ibWJJ");

var $fHcqB = parcelRequire("fHcqB");

var $3pTuY = parcelRequire("3pTuY");

var $cxufL = parcelRequire("cxufL");

var $2xy0c = parcelRequire("2xy0c");

var $cT8IU = parcelRequire("cT8IU");

var $4NslB = parcelRequire("4NslB");

var $lbyTT = parcelRequire("lbyTT");

var $5cwz8 = parcelRequire("5cwz8");

var $3ErS8 = parcelRequire("3ErS8");

var $fOR5Q = parcelRequire("fOR5Q");

var $edTAR = parcelRequire("edTAR");

var $d7bc1 = parcelRequire("d7bc1");

var $ztCik = parcelRequire("ztCik");

var $j7FCN = parcelRequire("j7FCN");

var $iNSWY = parcelRequire("iNSWY");
const $a2554ad786286b0a$export$5df9262e102d0c32 = '/gateway/api/gasv3/api/v1';
const $a2554ad786286b0a$var$LAST_SCREEN_EVENT_STORAGE_KEY = 'last.screen.event';
class $a2554ad786286b0a$export$48361b6ed38f1b0 {
    static getCallback(logger) {
        logger = logger || console;
        return (response)=>{
            $a2554ad786286b0a$export$48361b6ed38f1b0.callback(response, logger);
        };
    }
    static callback(response, logger) {
        const statusCode = response.getStatusCode();
        if (statusCode >= 200 && statusCode <= 299) response.getEventResponseList().forEach((eventResponse)=>{
            logger.warn('Validation report for event with message ID %s:\n', eventResponse.getMessageId(), eventResponse);
        });
        else if (statusCode === 400 || statusCode === 404) {
            logger.warn('GASv3 submission failed with HTTP Status Code %d: %s', response.getStatusCode(), response.getMessage());
            response.getEventResponseList().forEach((eventResponse)=>{
                logger.warn('Event with message ID %s:\n', eventResponse.getMessageId(), eventResponse);
            });
        } else {
            logger.log('GASv3 submission failed with HTTP Status Code %d: %s', response.getStatusCode(), response.getMessage());
            response.eventResponseList.forEach((eventResponse)=>{
                logger.debug('Event with message ID %s:\n', eventResponse.getMessageId(), eventResponse);
            });
        }
    }
}
class $a2554ad786286b0a$export$2e2bcd8739ae039 {
    constructor(productInfo, settings = {}){
        this._useStargate = (useStargate)=>{
            if (useStargate == null) return true;
            return useStargate;
        };
        this._changeInternalUserId = (userId, anonymousId)=>{
            this._eventProcessor.getUser().setUserId(userId);
            if (anonymousId && anonymousId !== this._eventProcessor.getUser().getAnonymousId()) // Setting anonymous id can take a long time. Reading is a lot faster.
            // Only update if it has changed.
            this._eventProcessor.getUser().setAnonymousId(anonymousId);
        };
        this._createSubproductGetter = (subproduct)=>(0, $kljjv.default)(subproduct, 'Cannot get subproduct from the callback. Proceeding without it.');
        this._createEmbeddedProductGetter = (embeddedProduct)=>(0, $kljjv.default)(embeddedProduct, 'Cannot get embeddedProduct from the callback. Proceeding without it.');
        this._getLastScreenEvent = ()=>{
            try {
                return JSON.parse(this._safeSessionStorage.getItem($a2554ad786286b0a$var$LAST_SCREEN_EVENT_STORAGE_KEY) || '');
            } catch (err) {
                this._safeSessionStorage.removeItem($a2554ad786286b0a$var$LAST_SCREEN_EVENT_STORAGE_KEY);
                return null;
            }
        };
        this._setLastScreenEvent = (event)=>{
            this._safeSessionStorage.setItem($a2554ad786286b0a$var$LAST_SCREEN_EVENT_STORAGE_KEY, JSON.stringify({
                name: event.name,
                attributes: event.attributes
            }));
        };
        this._shouldEventBeDelayed = (event)=>{
            // TODO: this is a temporary restriction for the purposes of the Track All Changes project
            // The delay mechanism has a chance of event loss, which we can only accept for our own data at this point.
            // Once the delay queue implementation has been improved and measured to confirm that it is reliable enough,
            // then we will be able to open it up for other products to use by removing this check.
            if (!event.tags || event.tags.indexOf('measurement') === -1) return false;
            const isEventHighPriority = event.highPriority !== false; // defaults to true if excluded
            return this._eventDelayQueue.isDelayingLowPriorityEvents() && !isEventHighPriority;
        };
        this._fireEvent = (identifier, builtEvent, context, callback)=>{
            switch(builtEvent.eventType){
                case (0, $iZhen.eventType).UI:
                case (0, $iZhen.eventType).OPERATIONAL:
                case (0, $iZhen.eventType).TRACK:
                    return this._eventProcessor.track(identifier, builtEvent, context, callback);
                case (0, $iZhen.eventType).SCREEN:
                    return this._eventProcessor.page(identifier, builtEvent, context, callback);
                case (0, $iZhen.eventType).IDENTIFY:
                    return this._eventProcessor.identify(identifier, builtEvent, context, callback);
                default:
                    throw new Error(`No handler has been defined for events of type ${builtEvent.eventType}`);
            }
        };
        this._fireDelayedEvent = (identifier, builtEvent, context, userInfo)=>{
            try {
                // User information can change while the delay period is active, so we need to restore the values that
                // were active when the event was originally fired.
                this._changeInternalUserId(userInfo.userId, userInfo.anonymousId);
                builtEvent.tags = [
                    ...builtEvent.tags || [],
                    'sentWithDelay'
                ];
                // The callbacks for delayed events are fired immediately, so there is nothing to pass through for this argument.
                this._fireEvent(identifier, builtEvent, context, undefined);
            } finally{
                this._changeInternalUserId(this._userInfo.userId, this._userInfo.anonymousId);
            }
        };
        this._delayEvent = (identifier, builtEvent, context, userInfo, callback)=>{
            this._eventDelayQueue.push(identifier, builtEvent, context, userInfo);
            // Fire the callback immediately, as we can consider the event successfully processed at this point
            if (callback) callback();
        };
        this._processEvent = (identifier, builtEvent, context, callback)=>{
            this._testingCache.saveEvent(builtEvent);
            if (this._shouldEventBeDelayed(builtEvent)) {
                this._delayEvent(identifier, builtEvent, context, this._userInfo, callback);
                return Promise.resolve();
            } else return this._fireEvent(identifier, builtEvent, context, callback);
        };
        this.setEmbeddedProduct = (embeddedProduct)=>{
            this._internalProductInfo.embeddedProduct = this._createEmbeddedProductGetter(embeddedProduct);
            this.resetUIViewedTimers();
        };
        this.clearEmbeddedProduct = ()=>{
            this._internalProductInfo.embeddedProduct = this._createEmbeddedProductGetter(null);
        };
        this.setSubproduct = (subproduct)=>{
            this._internalProductInfo.subproduct = this._createSubproductGetter(subproduct);
            this.resetUIViewedTimers();
        };
        /**
   * Calling this function in the intialisation of the client in product
   * captures specified 'origin tracing' URL params and fires a single origin landed event
   * <p>
   * This function expects a mapping between the keys for any URL parameters
   *  that should be captured and removed for origin tracing
   * Multiple parameters may be captured simultaneously if multiple key: handler function pairs are provided
   * Each handler function should return an object with two items
   * a) 'originTracingAttributes' - an object that will be added to the 'origin landed' event's attributes under 'originTracing
   * b) 'taskSessionId' (optional) - an Id string that will be added to the tasksessions for any event that fires from the tab, with the key
   *    matching the URL parameter, for the purpose of attributing subsequent analytics event to the origin land.
   * </p>
   * The general use case for this feature is for allowing attributation of user behaviour to a out of product or cross product link,
   * e.g. from a share or email
   *
   * An example calling this function using an external decoding library, with taskSessionId specified to persist
   * analyticsWebClient.setOriginTracingHandlers({
        atlOrigin: encodedOrigin => {
            const { id, product } = OriginTracing.fromEncoded(encodedOrigin);
            return { originTracingAttributes: {'id': id, 'product': product}, taskSessionId: id };
        },
    });
   *
   * @param  {Object} originParamHandlerMapping a dictionary of mappings between origin url param keys and handler functions
   * @this {AnalyticsWebClient}
   */ this.setOriginTracingHandlers = (originParamHandlerMapping)=>{
            const capturedOriginTraces = this._originTracing.handleOriginParameters(originParamHandlerMapping, this._historyReplaceFn);
            Object.keys(capturedOriginTraces).forEach((x)=>{
                if (typeof capturedOriginTraces[x].taskSessionId !== 'undefined') this._task.createTaskSessionWithProvidedId(x, capturedOriginTraces[x].taskSessionId);
            });
            const originAttributes = {};
            Object.keys(capturedOriginTraces).forEach((x)=>{
                if (capturedOriginTraces[x].originTracingAttributes) originAttributes[x] = capturedOriginTraces[x].originTracingAttributes;
                else // eslint-disable-next-line no-console
                console.warn(`Handling method for origin parameter ${x} has not returned any attributes`);
            });
            if (Object.keys(capturedOriginTraces).length > 0) return this.sendOperationalEvent({
                action: 'landed',
                actionSubject: 'origin',
                source: 'webClient',
                attributes: {
                    originTracesLanded: originAttributes
                }
            }, // eslint-disable-next-line @typescript-eslint/no-empty-function
            ()=>{});
            return Promise.resolve();
        };
        this.setTenantInfo = (tenantIdType, tenantId)=>{
            if (!tenantIdType) throw new Error('Missing tenantIdType');
            if (tenantIdType !== (0, $iZhen.tenantType).NONE && !tenantId) throw new Error('Missing tenantId');
            if (!(0, $iZhen.isType)((0, $iZhen.tenantType), tenantIdType)) throw new Error(`Invalid tenantIdType '${tenantIdType}', ` + `must be an tenantType: [${(0, $iZhen.objectValues)((0, $iZhen.tenantType))}]`);
            this._tenantInfo = {
                tenantIdType: tenantIdType,
                tenantId: tenantId
            };
            this._eventProcessor.refreshMetadata(this._userInfo, this._tenantInfo);
        };
        this.clearTenantInfo = ()=>{
            this._tenantInfo = {};
            this._eventProcessor.refreshMetadata(this._userInfo, this._tenantInfo);
        };
        this.setOrgInfo = (orgId)=>{
            if (!orgId) throw new Error('Missing orgId');
            this._orgInfo = {
                orgId: orgId
            };
        };
        this.clearOrgInfo = ()=>{
            this._orgInfo = {};
        };
        this.setWorkspaceInfo = (workspaceId)=>{
            if (!workspaceId) throw new Error('Missing workspaceId');
            this._workspaceInfo = {
                workspaceId: workspaceId
            };
        };
        this.clearWorkspaceInfo = ()=>{
            this._workspaceInfo = {};
        };
        this.setUserInfo = (userIdType, userId)=>{
            (0, $ibWJJ.validateIdentifyEvent)(userIdType, userId);
            this._changeInternalUserId(userId);
            this._userInfo = {
                userIdType: userIdType,
                userId: userId,
                anonymousId: this._eventProcessor.getUser().getAnonymousId()
            };
            this._eventProcessor.refreshMetadata(this._userInfo, this._tenantInfo);
        };
        this.clearUserInfo = ()=>{
            this._changeInternalUserId(undefined);
            this._userInfo = {
                anonymousId: this._eventProcessor.getUser().getAnonymousId()
            };
            this._eventProcessor.refreshMetadata(this._userInfo, this._tenantInfo);
        };
        this.setAlias = (aliasKeyType, alias)=>{
            if (!aliasKeyType) throw new Error('Missing aliasType');
            if (!(0, $iZhen.isType)((0, $iZhen.aliasType), aliasKeyType)) throw new Error(`Invalid aliasType '${aliasKeyType}', ` + `must be an aliasType: [${(0, $iZhen.objectValues)((0, $iZhen.aliasType))}]`);
            this._aliases[aliasKeyType] = alias;
        };
        this.clearAlias = ()=>{
            this._aliases = {};
        };
        this.setGroup = (groupsKeyType, group)=>{
            if (!groupsKeyType) throw new Error('Missing groupType');
            if (!(0, $iZhen.isType)((0, $iZhen.groupType), groupsKeyType)) throw new Error(`Invalid groupType '${groupsKeyType}', ` + `must be an groupType: [${(0, $iZhen.objectValues)((0, $iZhen.groupType))}]`);
            this._groups[groupsKeyType] = group;
        };
        this.clearGroup = ()=>{
            this._groups = {};
        };
        this.getAnonymousId = ()=>this._userInfo.anonymousId;
        this.setUIViewedAttributes = (uiViewedAttributes)=>{
            if (!uiViewedAttributes) throw new Error('Missing uiViewedAttributes');
            if (typeof uiViewedAttributes !== 'object' || Array.isArray(uiViewedAttributes)) throw new Error('Invalid uiViewedAttributes type, should be a non array object');
            this._uiViewedAttributes = {
                ...uiViewedAttributes
            };
        };
        this.getUIViewedAttributes = ()=>{
            return this._uiViewedAttributes;
        };
        this.clearUIViewedAttributes = ()=>{
            this._uiViewedAttributes = {};
        };
        this.sendIdentifyEvent = (userIdType, userId, callback)=>{
            this.setUserInfo(userIdType, userId);
            const builtEvent = {
                userIdType: userIdType,
                eventType: (0, $iZhen.eventType).IDENTIFY
            };
            return this._processEvent(userId, builtEvent, this._context, callback);
        };
        /**
	 * @deprecated
	 * please use {@link sendScreenEvent instead)
	 */ this.sendPageEvent = (name, callback)=>{
            return this.sendScreenEvent(name, callback);
        };
        /**
	 * send screen event
	 * @param event The event / For retrocompatibility event name is still supported here.
	 * @param callback
	 * @param attributes. Deprecated, will get ignored if using an event object as first param.
	 */ this.sendScreenEvent = (event, callback, attributes)=>{
            let screenName;
            let screenAttributes;
            let screenContainers;
            let screenTags;
            if (typeof event === 'object') {
                /* This is for retrocompatibility */ screenName = event.name;
                screenAttributes = event.attributes;
                screenContainers = event.containers;
                screenTags = event.tags;
            } else {
                screenName = event;
                screenAttributes = attributes;
            }
            (0, $ibWJJ.validateScreenEvent)(screenName);
            (0, $ibWJJ.validateContainers)(screenContainers);
            const builtEvent = (0, $fNiuW.buildScreenEvent)(this._internalProductInfo, this._tenantInfo, this._userInfo, screenAttributes, // TODO: Remove the as any and move into a place where we know event is an object
            event.nonPrivacySafeAttributes, screenTags, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this._task.getAllTaskSessions(), this._orgInfo, this._pageLoadId, this._workspaceInfo, event, screenContainers, this._aliases, this._groups);
            const builtEventWithName = {
                name: screenName,
                ...builtEvent
            };
            this._setLastScreenEvent(builtEventWithName);
            return this._processEvent(screenName, builtEventWithName, this._context, (0, $j7FCN.default)(callback, builtEventWithName));
        };
        this.sendTrackEvent = (event, callback)=>{
            (0, $ibWJJ.validateTrackEvent)(event);
            const builtEvent = (0, $fNiuW.buildActionEvent)(this._internalProductInfo, this._tenantInfo, this._userInfo, event, (0, $iZhen.eventType).TRACK, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this._task.getAllTaskSessions(), this._orgInfo, this._pageLoadId, this._workspaceInfo, this._aliases, this._groups);
            return this._processEvent((0, $fNiuW.buildActionName)(event), builtEvent, this._context, (0, $j7FCN.default)(callback, builtEvent));
        };
        this.sendUIEvent = (event, callback)=>{
            (0, $ibWJJ.validateUIEvent)(event);
            const builtEvent = (0, $fNiuW.buildActionEvent)(this._internalProductInfo, this._tenantInfo, this._userInfo, event, (0, $iZhen.eventType).UI, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this._task.getAllTaskSessions(), this._orgInfo, this._pageLoadId, this._workspaceInfo, this._aliases, this._groups);
            return this._processEvent((0, $fNiuW.buildActionName)(event), builtEvent, this._context, (0, $j7FCN.default)(callback, builtEvent));
        };
        this.sendOperationalEvent = (event, callback)=>{
            (0, $ibWJJ.validateOperationalEvent)(event);
            const builtEvent = (0, $fNiuW.buildActionEvent)(this._internalProductInfo, this._tenantInfo, this._userInfo, event, (0, $iZhen.eventType).OPERATIONAL, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this._task.getAllTaskSessions(), this._orgInfo, this._pageLoadId, this._workspaceInfo, this._aliases, this._groups);
            return this._processEvent((0, $fNiuW.buildActionName)(event), builtEvent, this._context, (0, $j7FCN.default)(callback, builtEvent));
        };
        this.startUIViewedEvent = (callback)=>{
            this.stopUIViewedEvent();
            this._uiViewedEvent = new (0, $edTAR.default)(this._internalProductInfo, ()=>({
                    embeddedProduct: this._internalProductInfo.embeddedProduct(),
                    subproduct: this._internalProductInfo.subproduct(),
                    tenantIdType: this._tenantInfo.tenantIdType,
                    tenantId: this._tenantInfo.tenantId,
                    userId: this._userInfo.userId,
                    lastScreenEvent: this._getLastScreenEvent(),
                    attributes: this._uiViewedAttributes
                }), (event)=>this.sendUIEvent(event, callback));
            this._uiViewedEvent.start();
        };
        this.stopUIViewedEvent = ()=>{
            if (this._uiViewedEvent) {
                this._uiViewedEvent.stop();
                this._uiViewedEvent = null;
            }
        };
        this.resetUIViewedTimers = ()=>{
            if (this._uiViewedEvent) this._uiViewedEvent.resetTimers();
        };
        this.startApdexEvent = (apdexEvent)=>{
            this._apdexEvent.start(apdexEvent);
        };
        this.getApdexStart = (apdexEvent)=>this._apdexEvent.getStart(apdexEvent);
        this.stopApdexEvent = (apdexEvent, callback)=>{
            this._apdexEvent.stop(apdexEvent, callback);
        };
        // TODO If we ever make another breaking change, merge these two optional args into an `options` object arg.
        this.startLowPriorityEventDelay = (timeout, callback)=>{
            this._eventDelayQueue.startLowPriorityEventDelay(timeout, callback);
        };
        this.stopLowPriorityEventDelay = ()=>{
            this._eventDelayQueue.stopLowPriorityEventDelay();
        };
        this.onEvent = (_analyticsId, analyticsData)=>{
            if (!analyticsData) throw new Error('Missing analyticsData');
            if (!analyticsData.eventType) throw new Error('Missing analyticsData.eventType');
            if (analyticsData.eventType === (0, $iZhen.eventType).TRACK) return this.sendTrackEvent(analyticsData);
            else if (analyticsData.eventType === (0, $iZhen.eventType).UI) return this.sendUIEvent(analyticsData);
            else if (analyticsData.eventType === (0, $iZhen.eventType).OPERATIONAL) return this.sendOperationalEvent(analyticsData);
            else if (analyticsData.eventType === (0, $iZhen.eventType).SCREEN) return this.sendScreenEvent(analyticsData.name, null, analyticsData.attributes);
            else if (analyticsData.eventType === (0, $iZhen.eventType).IDENTIFY) return this.sendIdentifyEvent(analyticsData.userIdType, analyticsData.userId);
            throw new Error(`Invalid analyticsData.eventType '${analyticsData.eventType}', ` + `must be an eventType: [${(0, $iZhen.objectValues)((0, $iZhen.eventType))}]`);
        };
        this.setResponseCallback = (responseCallback)=>{
            this._eventProcessor.setResponseCallback(responseCallback);
        };
        if (!productInfo) throw new Error('Missing productInfo');
        if (!productInfo.env) throw new Error('Missing productInfo.env');
        if (!productInfo.product) throw new Error('Missing productInfo.product');
        if (!(0, $iZhen.isType)((0, $iZhen.envType), productInfo.env)) throw new Error(`Invalid productInfo.env '${productInfo.env}', ` + `must be an envType: [${(0, $iZhen.objectValues)((0, $iZhen.envType))}]`);
        if (productInfo.perimeter && !(0, $iZhen.isType)((0, $iZhen.perimeterType), productInfo.perimeter)) throw new Error(`Invalid productInfo.perimeter '${productInfo.perimeter}', ` + `must be an perimeterType: [${(0, $iZhen.objectValues)((0, $iZhen.perimeterType))}]`);
        if (!productInfo.origin) productInfo.origin = (0, $iZhen.originType).WEB;
        else if (!(0, $iZhen.isType)((0, $iZhen.originType), productInfo.origin)) throw new Error(`Invalid productInfo.origin '${productInfo.origin}', ` + `must be an originType: [${(0, $iZhen.objectValues)((0, $iZhen.originType))}]`);
        if (!productInfo.platform) productInfo.platform = productInfo.origin === (0, $iZhen.originType).WEB ? (0, $iZhen.platformType).WEB : (0, $iZhen.platformType).DESKTOP;
        else (0, $ibWJJ.validatePlatform)(productInfo);
        this._logger = settings.logger || console;
        this._internalProductInfo = {
            ...productInfo,
            subproduct: this._createSubproductGetter(productInfo.subproduct),
            embeddedProduct: this._createEmbeddedProductGetter(productInfo.embeddedProduct)
        };
        this._tenantInfo = {};
        this._orgInfo = {};
        this._uiViewedAttributes = {};
        if (productInfo?.embeddedContext) {
            this._embeddedContext = productInfo.embeddedContext;
            if ((0, $3mN0k.isFirstParty)(this._embeddedContext)) this.setUIViewedAttributes({
                embeddedType: this._embeddedContext['embeddedType'],
                embeddedFromProduct: this._embeddedContext['embeddedFromProduct'],
                embeddedFromSubproduct: this._embeddedContext['embeddedFromSubproduct'],
                embeddedFromTopLevelDomain: this._embeddedContext['embeddedFromTopLevelDomain']
            });
            if ((0, $3mN0k.isThirdParty)(this._embeddedContext)) this.setUIViewedAttributes({
                embeddedType: this._embeddedContext['embeddedType'],
                embeddedFromTopLevelDomain: this._embeddedContext['embeddedFromTopLevelDomain']
            });
        }
        this._context = (0, $fNiuW.buildContext)(this._internalProductInfo);
        this._safeSessionStorage = new (0, $lbyTT.default)();
        const useStargate = this._useStargate(settings.useStargate);
        const apiHost = settings.apiHost || (0, $cT8IU.selectHost)({
            useStargate: useStargate,
            env: productInfo.env,
            useLegacyUrl: settings.useLegacyUrl,
            perimeter: productInfo.perimeter,
            envOverride: productInfo.envOverride
        });
        const apiHostProtocol = settings.apiHostProtocol || 'https';
        const minRetryDelay = settings.minRetryDelay || 1000;
        const maxAttempts = settings.maxRetryAttempts !== undefined && Number.isInteger(settings.maxRetryAttempts) && settings.maxRetryAttempts >= 0 ? settings.maxRetryAttempts + 1 : undefined;
        const retryQueueOptions = {
            maxRetryDelay: 60000,
            minRetryDelay: minRetryDelay,
            backoffFactor: 2,
            flushWaitMs: settings.flushWaitInterval,
            flushBeforeUnload: settings.flushBeforeUnload,
            maxAttempts: maxAttempts
        };
        const retryQueuePrefix = `awc-${productInfo.env}`;
        const xidPromiseGetter = ()=>(0, $iNSWY.XIDPromise)(settings.xidConsent, settings.xidPromiseFn);
        const disableCookiePersistence = settings.disableCookiePersistence || false;
        const metadataClientFactory = settings.metadataClientFactory || (0, $3pTuY.MetadataClient).Factory;
        const metadataClient = metadataClientFactory(apiHostProtocol, apiHost, productInfo.product);
        this._eventProcessor = new (0, $fHcqB.default)({
            apiHost: apiHost,
            apiHostProtocol: apiHostProtocol,
            product: productInfo.product,
            retryQueuePrefix: retryQueuePrefix,
            retryQueueOptions: retryQueueOptions,
            xidPromiseGetter: xidPromiseGetter,
            logger: this._logger,
            metadataClient: metadataClient,
            disableCookiePersistence: disableCookiePersistence,
            responseCallback: $a2554ad786286b0a$export$48361b6ed38f1b0.getCallback(this._logger),
            env: productInfo.env,
            perimeter: productInfo.perimeter,
            enableMetadataCalls: this.metadataCallsEnabled(settings),
            enableEventCalls: this.eventCallsEnabled(settings)
        });
        this._userInfo = {
            anonymousId: this._eventProcessor.getUser().getAnonymousId(settings?.customAnonymousIdGenerator)
        };
        this._pageVisibility = new (0, $2xy0c.default)();
        this._tabTracking = new (0, $5cwz8.default)();
        this._sessionTracking = new (0, $4NslB.default)({
            sessionExpiryTime: settings.sessionExpiryTime,
            onNewSessionStarted: settings.onNewSessionStarted
        });
        this._task = new (0, $3ErS8.default)();
        this._originTracing = new (0, $cxufL.default)();
        // Init Apdex
        this._apdexEvent = new (0, $hI2MJ.default)(this.sendOperationalEvent, this._pageVisibility);
        this._historyReplaceFn = typeof settings.historyReplaceFn === 'function' ? settings.historyReplaceFn : (0, $d7bc1.defaultHistoryReplaceFn);
        this._eventDelayQueue = new (0, $76MW0.default)(this._fireDelayedEvent, settings.delayQueueCompressors || []);
        this._testingCache = new (0, $fOR5Q.default)();
        this._pageLoadId = (0, (/*@__PURE__*/$parcel$interopDefault($bXrHm)))();
        this._workspaceInfo = {};
        this._aliases = {};
        this._groups = {};
    }
    metadataCallsEnabled(settings) {
        if (typeof settings.disableMetadataCalls === 'boolean') return !settings.disableMetadataCalls;
        return !(0, $ztCik.TestSupport).isGeminiVREnvironment() && !(0, $ztCik.TestSupport).areFetchCallsDisabled();
    }
    eventCallsEnabled(settings) {
        if (typeof settings.disableEventCalls === 'boolean') return !settings.disableEventCalls;
        return !(0, $ztCik.TestSupport).isGeminiVREnvironment() && !(0, $ztCik.TestSupport).areFetchCallsDisabled();
    }
    setEventValidationMode(eventValidationMode) {
        this._context.context.validationMode = eventValidationMode;
    }
    /**
	 * @private
	 * @deprecated
	 * Please avoid using internal properties. They are not part of the public
	 * API and may change without notice.
	 *
	 * This property has been exposed for backward compatibility with existing
	 * tests in external code
	 */ get task() {
        return this._task;
    }
    /**
	 * @private
	 * @deprecated
	 * Please avoid using internal properties.
	 * They are not part of the public API and may change without notice.
	 *
	 * This property has been exposed for backward compatibility with existing
	 * tests in external code
	 */ get _productInfo() {
        return this._internalProductInfo;
    }
}

});
parcelRegister("hI2MJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $14beea5fd4f9cf3d$export$2e2bcd8739ae039);

var $iZhen = parcelRequire("iZhen");

var $2xy0c = parcelRequire("2xy0c");

var $acAer = parcelRequire("acAer");
class $14beea5fd4f9cf3d$export$2e2bcd8739ae039 {
    constructor(onEvent, pageVisibility){
        this._getEventKey = ({ task: task, taskId: taskId })=>taskId ? `${task}.${taskId}` : task;
        this._getEventTimingByName = (name)=>{
            const eventTimings = this._performance.getEntriesByName(name);
            const eventTiming = eventTimings[eventTimings.length - 1];
            return eventTiming;
        };
        this._getApdexFields = (event)=>{
            const apdexTimings = this._getApdexTimings(event);
            const apdexScore = this._calculateApdex({
                duration: apdexTimings.duration,
                threshold: event.threshold
            });
            return {
                ...apdexTimings,
                apdex: apdexScore
            };
        };
        this._getApdexTimings = (event)=>{
            const eventKey = this._getEventKey(event);
            const eventStartName = `${eventKey}-start`;
            const startTime = event.startTime || this._getStartTime(event, eventStartName);
            const stopTime = event.stopTime || this._getStopTime();
            // We do some clean up of the marks and started events
            this._cleanApdexState(eventKey);
            return {
                startTime: startTime,
                stopTime: stopTime,
                duration: stopTime - startTime
            };
        };
        this._getStartTime = (event, eventName)=>{
            let startTime;
            const timeOrigin = this._performance.getTimeOrigin();
            if (event.type === (0, $iZhen.apdexType).INITIAL_LOAD) startTime = timeOrigin;
            else {
                const eventTiming = this._getEventTimingByName(eventName);
                startTime = timeOrigin + eventTiming.startTime;
            }
            return startTime;
        };
        this._getStopTime = ()=>this._performance.getTimeOrigin() + this._performance.now();
        this._cleanApdexState = (eventKey)=>{
            this._performance.clearMarks(`${eventKey}-start`);
            this._performance.clearMarks(`${eventKey}-stop`);
            this._startedEvents.delete(eventKey);
        };
        this._getVisibilityFields = (event)=>{
            let isActiveTab;
            /**
		 * For initialLoad type:
		 * 1. if tab was not ever hidden (!_wasPreviouslyHidden)
		 *
		 * For transition type:
		 * 1. active status is tracked in active events map (_isActiveEvents)
		 *
		 * For any type, if startTime or stopTime is specified:
		 * 1. If currently active (!_isHidden)
		 */ if (event.type === (0, $iZhen.apdexType).INITIAL_LOAD) isActiveTab = !this._wasPreviouslyHidden;
            else if (event.type === (0, $iZhen.apdexType).TRANSITION) {
                const eventKey = this._getEventKey(event);
                isActiveTab = this._isActiveEvents.get(eventKey);
            }
            if (event.startTime || event.stopTime) isActiveTab = !this._pageVisibility.getIsHidden();
            return {
                isActiveTab: isActiveTab
            };
        };
        this._calculateApdex = ({ duration: duration, threshold: threshold = this._threshold })=>{
            let apdex;
            const satisfiedThreshold = threshold;
            const tolerableThreshold = threshold * 4;
            if (duration <= satisfiedThreshold) apdex = 1;
            else if (duration <= tolerableThreshold) apdex = 0.5;
            else apdex = 0;
            return apdex;
        };
        this._validateStartEvent = (event)=>{
            if (!event) throw new Error('Missing "event" in Apdex start event');
            if (!event.task) throw new Error('Missing "task" in Apdex start event');
            if (typeof event.task !== 'string') throw new Error('Invalid "task" in Apdex start event');
            if (event.taskId && typeof event.taskId !== 'string') throw new Error('Invalid "taskId" in Apdex start event');
        };
        this._validateStopEvent = (event)=>{
            if (!event) throw new Error('Missing "event" in Apdex stop event');
            if (!event.task) throw new Error('Missing "task" in Apdex stop event');
            if (typeof event.task !== 'string') throw new Error('Invalid "task" in Apdex stop event');
            if (event.taskId && typeof event.taskId !== 'string') throw new Error('Invalid "taskId" in Apdex stop event');
            if (!event.type) throw new Error('Missing "type" in Apdex stop event');
            if (event.type && !(0, $iZhen.isType)((0, $iZhen.apdexType), event.type)) throw new Error('Invalid "type" in Apdex stop event');
            if (event.threshold && typeof event.threshold !== 'number') throw new Error('Invalid "threshold" in Apdex stop event');
            /*
		 * For a transition, if the startTime was not specified,
		 * the start event should have been present.
		 */ if (!event.startTime && event.type === (0, $iZhen.apdexType).TRANSITION) {
                const eventKey = this._getEventKey(event);
                if (!this._startedEvents.has(eventKey)) throw new Error(`Apdex event transition "${eventKey}" was not started`);
            }
            if (event.startTime && !(typeof event.startTime === 'number' && event.startTime >= 0)) throw new Error('Invalid "startTime" in Apdex stop event');
            if (event.stopTime && typeof event.stopTime !== 'number') throw new Error('Invalid "stopTime" in Apdex stop event');
            if (event.stopTime <= event.startTime) throw new Error('"stopTime" should be greater than "startTime" in Apdex stop event');
        };
        this._shouldSendEvent = (event)=>{
            if (!event) return false;
            if (typeof event.apdex !== 'number') return false;
            return true;
        };
        this._sendEvent = (event, callback)=>{
            if (this._shouldSendEvent(event)) this._onEvent({
                source: 'ui',
                action: 'readyForUser',
                actionSubject: 'ui',
                attributes: {
                    ...event.additionalAttributes,
                    task: event.task,
                    taskId: event.taskId,
                    type: event.type,
                    threshold: event.threshold || this._threshold,
                    apdex: event.apdex,
                    startTime: event.startTime,
                    stopTime: event.stopTime,
                    duration: event.duration,
                    isActiveTab: event.isActiveTab
                }
            }, callback);
        };
        if (!onEvent) throw new Error('Missing onEvent callback');
        if (typeof onEvent !== 'function') throw new Error('Invalid onEvent, must be function');
        if (!(pageVisibility instanceof (0, $2xy0c.default))) throw new Error('Invalid pageVisibility, must be PageVisibility class');
        this._startedEvents = new Map();
        this._performance = new (0, $acAer.default)();
        this._onEvent = onEvent;
        this._threshold = 1000;
        this._wasPreviouslyHidden = pageVisibility.getIsHidden();
        this._isActiveEvents = new Map();
        this._pageVisibility = pageVisibility;
        this._pageVisibility.addCallback('apdexEvent', (isHidden)=>{
            this.onVisibilityChange(!isHidden);
        });
    }
    start(event) {
        this._validateStartEvent(event);
        if (!this._performance.isAvailable()) return;
        const eventKey = this._getEventKey(event);
        const eventStartName = `${eventKey}-start`;
        this._startedEvents.set(eventKey, true);
        this._isActiveEvents.set(eventKey, !this._pageVisibility.getIsHidden());
        this._performance.clearMarks(eventStartName);
        this._performance.mark(eventStartName);
    }
    getStart(event) {
        this._validateStartEvent(event);
        if (!this._performance.isAvailable()) return undefined;
        const eventKey = this._getEventKey(event);
        const eventStartName = `${eventKey}-start`;
        return this._getEventTimingByName(eventStartName);
    }
    stop(event, callback) {
        this._validateStopEvent(event);
        if (!this._performance.isAvailable()) return;
        const apdexFields = this._getApdexFields(event);
        const visibilityFields = this._getVisibilityFields(event);
        this._sendEvent({
            ...event,
            ...apdexFields,
            ...visibilityFields
        }, callback);
    }
    onVisibilityChange(isActive) {
        if (!isActive) {
            this._wasPreviouslyHidden = true;
            Array.from(this._isActiveEvents.keys()).forEach((key)=>this._isActiveEvents.set(key, false));
        }
    }
}

});
parcelRegister("2xy0c", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e5fbd7ed6f3ccee$export$2e2bcd8739ae039);
class $3e5fbd7ed6f3ccee$export$2e2bcd8739ae039 {
    constructor(){
        this._bindEventListeners = ()=>{
            document.addEventListener(this._visibilityChange, this._handleVisibilityChange, false);
        };
        this._handleVisibilityChange = ()=>{
            const isHidden = document[this._hidden];
            this._isHidden = isHidden;
            this._callbacks.forEach((callbackFn)=>callbackFn(isHidden));
        };
        this._isHidden = false;
        this._callbacks = new Map();
        this._hidden = undefined;
        this._visibilityChange = undefined;
        if (typeof document !== 'undefined') {
            if (typeof document.hidden !== 'undefined') {
                // Opera 12.10 and Firefox 18 and later support
                this._isHidden = document.hidden;
                this._hidden = 'hidden';
                this._visibilityChange = 'visibilitychange';
            } else if (typeof document.msHidden !== 'undefined') {
                this._isHidden = document.msHidden;
                this._hidden = 'msHidden';
                this._visibilityChange = 'msvisibilitychange';
            } else if (typeof document.webkitHidden !== 'undefined') {
                this._isHidden = document.webkitHidden;
                this._hidden = 'webkitHidden';
                this._visibilityChange = 'webkitvisibilitychange';
            }
            if (typeof document.addEventListener !== 'undefined' && this._hidden !== undefined) this._bindEventListeners();
        }
    }
    addCallback(name, fn) {
        if (typeof name !== 'string') throw new Error('Invalid name, must be string');
        if (typeof fn !== 'function') throw new Error('Invalid callback, must be function');
        this._callbacks.set(name, fn);
    }
    removeCallback(name) {
        if (this._callbacks.has(name)) this._callbacks.delete(name);
    }
    getIsHidden() {
        return this._isHidden;
    }
}

});

parcelRegister("acAer", function(module, exports) {

$parcel$export(module.exports, "default", () => $73261f1aa6ec2e2d$export$2e2bcd8739ae039);
class $73261f1aa6ec2e2d$export$2e2bcd8739ae039 {
    constructor(){
        this._performance = window.performance;
    }
    clearMarks(...args) {
        if (!this._performance || !this._performance.clearMarks) return;
        this._performance.clearMarks(...args);
    }
    mark(...args) {
        if (!this._performance || !this._performance.mark) return;
        this._performance.mark(...args);
    }
    getEntriesByName(...args) {
        if (!this._performance || !this._performance.getEntriesByName) return [];
        return this._performance.getEntriesByName(...args);
    }
    getTimeOrigin() {
        if (!this._performance || !this._performance.timeOrigin && !this._performance.timing) return 0;
        return this._performance.timeOrigin || this._performance.timing.navigationStart;
    }
    now() {
        if (!this._performance || !this._performance.now) return Date.now ? Date.now() : +new Date();
        return this._performance.now();
    }
    isAvailable() {
        return !!this._performance && !!this._performance.clearMarks && !!this._performance.mark && !!this._performance.getEntriesByName && !!this._performance.timing;
    }
}

});


parcelRegister("kljjv", function(module, exports) {

$parcel$export(module.exports, "default", () => $4aa7c27f9f910a27$export$2e2bcd8739ae039);
/**
 * Wraps {possibleFn} into a error-safe function and handles cases where {possibleFn}
 * is a function or object
 *
 * @param possibleFn - function that returns and object or the object itself
 * @param errorMessage - error message to log if {possibleFn} is a function and
 *                        throws an error when called
 * @returns {Function}
 */ const $4aa7c27f9f910a27$var$isFunction = (possibleFn)=>typeof possibleFn === 'function';
var $4aa7c27f9f910a27$export$2e2bcd8739ae039 = (possibleFn, errorMessage)=>{
    return ()=>{
        if ($4aa7c27f9f910a27$var$isFunction(possibleFn)) try {
            return possibleFn();
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(`${errorMessage} - ${e instanceof Error ? e.message : String(e)}`);
            return undefined;
        }
        return possibleFn;
    };
};

});

parcelRegister("3mN0k", function(module, exports) {

$parcel$export(module.exports, "isFirstParty", () => $4fba850c97b0dc98$export$f56713ced121eb91);
$parcel$export(module.exports, "isThirdParty", () => $4fba850c97b0dc98$export$ab34f90cc32c8960);

var $iZhen = parcelRequire("iZhen");
const $4fba850c97b0dc98$export$f56713ced121eb91 = (input)=>{
    return input.embeddedType === (0, $iZhen.productEmbedType).FIRST_PARTY && input.embeddedFromProduct !== undefined;
};
const $4fba850c97b0dc98$export$ab34f90cc32c8960 = (input)=>{
    return input.embeddedType === (0, $iZhen.productEmbedType).THIRD_PARTY && input.embeddedFromTopLevelDomain !== undefined;
};

});

parcelRegister("fNiuW", function(module, exports) {

$parcel$export(module.exports, "buildActionFields", () => $f88fb9a422872384$export$655ecf7241feac42);
$parcel$export(module.exports, "buildScreenEvent", () => $f88fb9a422872384$export$c7d9a5f56acc4b19);
$parcel$export(module.exports, "buildActionName", () => $f88fb9a422872384$export$9c5623a792efc9b0);
$parcel$export(module.exports, "buildContext", () => $f88fb9a422872384$export$3a7fe28f9bf4f3d9);
$parcel$export(module.exports, "buildActionEvent", () => $f88fb9a422872384$export$7bf451af4a8e3dd9);

var $iZhen = parcelRequire("iZhen");

var $eB7xz = parcelRequire("eB7xz");
const $f88fb9a422872384$var$libraryVersion = "0.0.0-use.local";
function $f88fb9a422872384$var$buildTenantFields(tenantInfo) {
    return {
        tenantIdType: tenantInfo.tenantIdType,
        tenantId: tenantInfo.tenantId
    };
}
function $f88fb9a422872384$var$buildUserFields(userInfo) {
    return {
        userIdType: userInfo.userIdType
    };
}
function $f88fb9a422872384$var$buildOrgFields(orgInfo) {
    return {
        orgId: orgInfo.orgId
    };
}
function $f88fb9a422872384$var$buildWorkspaceFields(workspaceInfo) {
    return {
        workspaceId: workspaceInfo.workspaceId
    };
}
function $f88fb9a422872384$var$buildAliases(aliases) {
    if ($f88fb9a422872384$var$isNotEmptyObject(aliases)) return {
        aliases: aliases
    };
    return undefined;
}
function $f88fb9a422872384$var$buildGroups(groups) {
    if ($f88fb9a422872384$var$isNotEmptyObject(groups)) return {
        groups: groups
    };
    return undefined;
}
function $f88fb9a422872384$var$buildEventOverrides(event) {
    if (event.anonymousId) return {
        anonymousId: event.anonymousId
    };
    return {};
}
function $f88fb9a422872384$var$getProductField(field, override) {
    return override === undefined ? field : override;
}
function $f88fb9a422872384$var$buildProductFields(productInfo, productOverrides) {
    const overrides = productOverrides || {};
    const env = $f88fb9a422872384$var$getProductField(productInfo.env, overrides.env);
    const product = $f88fb9a422872384$var$getProductField(productInfo.product, overrides.product);
    const subproduct = $f88fb9a422872384$var$getProductField(productInfo.subproduct(), overrides.subproduct);
    const version = $f88fb9a422872384$var$getProductField(productInfo.version, overrides.version);
    const origin = $f88fb9a422872384$var$getProductField(productInfo.origin, overrides.origin);
    const platform = $f88fb9a422872384$var$getProductField(productInfo.platform, overrides.platform);
    return {
        env: env,
        product: product,
        subproduct: subproduct,
        version: version,
        origin: origin,
        platform: platform
    };
}
function $f88fb9a422872384$var$isNotEmptyObject(obj) {
    return (0, $eB7xz.isPlainObject)(obj) && Object.keys(obj).length > 0;
}
function $f88fb9a422872384$var$buildAttributesWithName(name, attrObject) {
    return $f88fb9a422872384$var$isNotEmptyObject(attrObject) ? {
        [name]: attrObject
    } : undefined;
}
function $f88fb9a422872384$var$buildAttributes(attributes) {
    return $f88fb9a422872384$var$buildAttributesWithName('attributes', attributes);
}
function $f88fb9a422872384$export$3f5115a568819c1a(containers) {
    const validContainers = {};
    Object.keys(containers).forEach((key)=>{
        const value = containers[key];
        validContainers[key] = {
            id: value.id,
            type: value.type
        };
    });
    return validContainers;
}
function $f88fb9a422872384$export$f045f238d77c002a(containers) {
    if ($f88fb9a422872384$var$isNotEmptyObject(containers)) {
        const validContainers = $f88fb9a422872384$export$3f5115a568819c1a(containers);
        return $f88fb9a422872384$var$buildAttributesWithName('containers', validContainers);
    }
    return undefined;
}
function $f88fb9a422872384$export$655ecf7241feac42(event, actionEventType) {
    return {
        containerType: event.containerType,
        containerId: event.containerId,
        source: event.source,
        objectType: event.objectType,
        objectId: event.objectId,
        actionSubject: event.actionSubject,
        action: event.action,
        actionSubjectId: event.actionSubjectId,
        attributes: event.attributes,
        nonPrivacySafeAttributes: event.nonPrivacySafeAttributes,
        tags: event.tags,
        highPriority: event.highPriority,
        eventType: actionEventType,
        ...$f88fb9a422872384$export$f045f238d77c002a(event.containers)
    };
}
function $f88fb9a422872384$var$buildNonPrivacySafeAttributes(nonPrivacySafeAttributes) {
    return $f88fb9a422872384$var$buildAttributesWithName('nonPrivacySafeAttributes', nonPrivacySafeAttributes);
}
function $f88fb9a422872384$export$c7d9a5f56acc4b19(productInfo, tenantInfo, userInfo, attributes, nonPrivacySafeAttributes, tags, tabId, sessionId, taskSessions, orgInfo, pageLoadId, workspaceInfo, event, containers, aliases, groups) {
    const productFields = $f88fb9a422872384$var$buildProductFields(productInfo);
    const tenantFields = $f88fb9a422872384$var$buildTenantFields(tenantInfo);
    const userFields = $f88fb9a422872384$var$buildUserFields(userInfo);
    const orgFields = $f88fb9a422872384$var$buildOrgFields(orgInfo);
    const workspaceFields = $f88fb9a422872384$var$buildWorkspaceFields(workspaceInfo);
    const overrides = {
        title: '',
        path: '',
        url: '',
        referrer: '',
        search: '',
        eventType: (0, $iZhen.eventType).SCREEN
    };
    return {
        ...productFields,
        ...tenantFields,
        ...userFields,
        ...orgFields,
        ...overrides,
        ...$f88fb9a422872384$var$buildAttributes(attributes),
        ...$f88fb9a422872384$var$buildNonPrivacySafeAttributes(nonPrivacySafeAttributes),
        ...$f88fb9a422872384$export$f045f238d77c002a(containers),
        ...$f88fb9a422872384$var$buildEventOverrides(event),
        tags: tags,
        tabId: tabId,
        sessionId: sessionId,
        taskSessions: taskSessions,
        pageLoadId: pageLoadId,
        ...workspaceFields,
        ...$f88fb9a422872384$var$buildAliases(aliases),
        ...$f88fb9a422872384$var$buildGroups(groups)
    };
}
function $f88fb9a422872384$export$9c5623a792efc9b0(event) {
    return `${event.actionSubject} ${event.action}`;
}
var $f88fb9a422872384$export$fbd92247fb4d6159 = /*#__PURE__*/ function(validationMode) {
    validationMode["QUIET"] = "quiet";
    validationMode["STANDARD"] = "standard";
    validationMode["COMPLETE"] = "complete";
    return validationMode;
}({});
function $f88fb9a422872384$var$getDefaultValidationMode(productInfo) {
    const environment = productInfo.env;
    if (environment === undefined) return "quiet";
    if (environment.includes('prod')) return "quiet";
    return "complete";
}
function $f88fb9a422872384$export$3a7fe28f9bf4f3d9(productInfo) {
    const screen = window.screen || {};
    return {
        context: {
            locale: productInfo.locale,
            screen: {
                width: screen.width,
                height: screen.height,
                density: window.devicePixelRatio
            },
            library: {
                name: 'analytics.js',
                version: $f88fb9a422872384$var$libraryVersion
            },
            validationMode: $f88fb9a422872384$var$getDefaultValidationMode(productInfo)
        }
    };
}
function $f88fb9a422872384$export$e3d99b4bfec06f6e(event) {
    const { env: env, product: product, subproduct: subproduct, version: version, origin: origin, platform: platform } = event;
    return {
        env: env,
        product: product,
        subproduct: subproduct,
        version: version,
        origin: origin,
        platform: platform
    };
}
function $f88fb9a422872384$export$7bf451af4a8e3dd9(productInfo, tenantInfo, userInfo, event, actionEventType, tabId, sessionId, taskSessions, orgInfo, pageLoadId, workspaceInfo, aliases, groups) {
    const productFields = $f88fb9a422872384$var$buildProductFields(productInfo, $f88fb9a422872384$export$e3d99b4bfec06f6e(event));
    const tenantFields = $f88fb9a422872384$var$buildTenantFields(tenantInfo);
    const orgFields = $f88fb9a422872384$var$buildOrgFields(orgInfo);
    const workspaceFields = $f88fb9a422872384$var$buildWorkspaceFields(workspaceInfo);
    const userFields = $f88fb9a422872384$var$buildUserFields(userInfo);
    const actionFields = $f88fb9a422872384$export$655ecf7241feac42(event, actionEventType);
    return {
        ...productFields,
        ...tenantFields,
        ...orgFields,
        ...userFields,
        ...actionFields,
        ...$f88fb9a422872384$var$buildEventOverrides(event),
        tabId: tabId,
        sessionId: sessionId,
        taskSessions: taskSessions,
        pageLoadId: pageLoadId,
        ...workspaceFields,
        ...$f88fb9a422872384$var$buildAliases(aliases),
        ...$f88fb9a422872384$var$buildGroups(groups)
    };
}

});

parcelRegister("76MW0", function(module, exports) {

$parcel$export(module.exports, "default", () => $4995e34560b65b19$export$2e2bcd8739ae039);


var $rwsom = parcelRequire("rwsom");

var $fqOJ4 = parcelRequire("fqOJ4");
class $4995e34560b65b19$export$2e2bcd8739ae039 {
    constructor(fireDelayedEvent, compressors){
        this.push = (identifier, builtEvent, context, userInfo)=>{
            this.delayQueue.push(identifier, builtEvent, context, userInfo);
        };
        this.startLowPriorityEventDelay = (timeout = (0, $b2e0d12d54fddedd$export$cf090d5281b5ae06), callback)=>{
            if (Number.isNaN(timeout) || timeout <= 0) throw new Error(`Invalid timeout period: ${timeout}, must be a number greater than 0`);
            if (this.delayTimeout) clearTimeout(this.delayTimeout);
            const delayTimeoutPeriod = timeout ? Math.min(timeout, (0, $b2e0d12d54fddedd$export$8575e30be0feb909)) : (0, $b2e0d12d54fddedd$export$8575e30be0feb909);
            this.delayCallback = callback;
            this.delayTimeout = setTimeout(()=>this.stopLowPriorityEventDelay((0, $fqOJ4.StopLowPriorityEventDelayReason).TIMEOUT), delayTimeoutPeriod);
            // If the queue is still flushing from a previous delay period, then we should cancel that flush
            // to stop it from negatively impacting the performance of the new critical section
            this.delayQueue.cancelFlush();
            this.isDelaying = true;
        };
        this.stopLowPriorityEventDelay = (reason = (0, $fqOJ4.StopLowPriorityEventDelayReason).MANUAL)=>{
            if (this.delayTimeout) {
                clearTimeout(this.delayTimeout);
                this.delayTimeout = undefined;
            }
            this.delayQueue.startFlush();
            this.isDelaying = false;
            this.delayCallback?.(reason);
            this.delayCallback = undefined;
        };
        this.isDelayingLowPriorityEvents = ()=>this.isDelaying;
        this.isDelaying = false;
        this.delayQueue = new (0, $rwsom.default)(fireDelayedEvent, compressors);
    }
}

});
const $b2e0d12d54fddedd$export$cf090d5281b5ae06 = 10000;
const $b2e0d12d54fddedd$export$8575e30be0feb909 = 30000;

parcelRegister("rwsom", function(module, exports) {

$parcel$export(module.exports, "default", () => $471ee136644d53ae$export$2e2bcd8739ae039);

var $fNiuW = parcelRequire("fNiuW");

var $gYqa8 = parcelRequire("gYqa8");

var $59vML = parcelRequire("59vML");
// We want to throttle the flush rate so that we don't have a huge upfront performance hit from starting the flush,
// and so that the underlying Segment client has some time to process some events in its queue before more are added.
const $471ee136644d53ae$var$FLUSH_BATCH_SIZE = 7; // aligns with the default batch size of Segment's BatchableQueue
const $471ee136644d53ae$var$FLUSH_BATCH_BACKOFF_PERIOD = 100;
class $471ee136644d53ae$export$2e2bcd8739ae039 {
    constructor(processFn, compressionRules){
        this.push = (identifier, builtEvent, context, userInfo)=>{
            this.eventArgs.push({
                identifier: identifier,
                builtEvent: builtEvent,
                context: context,
                userInfo: userInfo
            });
        };
        this.size = ()=>this.eventArgs.length;
        this.startFlush = ()=>{
            try {
                this.eventArgs = this.compressEventArgs(this.eventArgs);
            } catch (e) {
                // eslint-disable-next-line no-console
                console.warn('Failed to perform compression on the delayed analytics events. ' + `Error: ${e.message}. Sending ${this.eventArgs.length} uncompressed events instead`);
            }
            this.flushNextBatch();
        };
        this.cancelFlush = ()=>{
            if (this.flushBatchTimeout) {
                clearTimeout(this.flushBatchTimeout);
                this.flushBatchTimeout = null;
            }
        };
        this.flushNextBatch = ()=>{
            const batch = this.eventArgs.splice(0, $471ee136644d53ae$var$FLUSH_BATCH_SIZE);
            batch.forEach((item)=>this.processFn(item.identifier, item.builtEvent, item.context, item.userInfo));
            if (this.eventArgs.length > 0) this.flushBatchTimeout = setTimeout(()=>this.flushNextBatch(), $471ee136644d53ae$var$FLUSH_BATCH_BACKOFF_PERIOD);
            else this.flushBatchTimeout = null;
        };
        this.compressEventArgs = (eventArgs)=>{
            const [compressibleEventArgs, incompressibleEventArgs] = (0, $gYqa8.partition)(eventArgs, (args)=>this.compressor.canCompress(args.builtEvent));
            // Events can only be compressed together if they share the same context and user info, since these are top-level
            // fields that need to exist on the fired event and can only be set to a single value.
            // We can achieve this by grouping our events by context prior to passing them to the compressor.
            const contextGroups = compressibleEventArgs.reduce((groups, args)=>{
                const matchingGroup = groups.find((group)=>(0, $gYqa8.equals)(group.userInfo, args.userInfo) && (0, $gYqa8.equals)(group.context, args.context));
                if (matchingGroup) matchingGroup.eventArgs.push(args);
                else groups.push({
                    userInfo: args.userInfo,
                    context: args.context,
                    eventArgs: [
                        args
                    ]
                });
                return groups;
            }, []);
            // Run the compressor on each group
            const allCompressedEventArgs = contextGroups.reduce((acc, group)=>{
                try {
                    const events = group.eventArgs.map((args)=>args.builtEvent);
                    const compressedEvents = this.compressor.compress(events);
                    const compressedEventArgs = compressedEvents.map((compressedEvent)=>({
                            identifier: (0, $fNiuW.buildActionName)(compressedEvent),
                            builtEvent: compressedEvent,
                            userInfo: group.userInfo,
                            context: group.context
                        }));
                    return acc.concat(compressedEventArgs);
                } catch (e) {
                    // If anything goes wrong while compressing this group, then just fall back on the
                    // uncompressed events instead. The event compressor already handles errors with invalid
                    // generator functions or results, but this is an extra layer of defense to prevent data
                    // loss in the event of an unexpected error.
                    // eslint-disable-next-line no-console
                    console.warn('Failed to compress some analytics events. ' + `Error: ${e.message}. Sending ${group.eventArgs.length} uncompressed events instead`);
                    return group.eventArgs;
                }
            }, []);
            incompressibleEventArgs.forEach((args)=>allCompressedEventArgs.push(args));
            return allCompressedEventArgs;
        };
        this.processFn = processFn;
        this.flushBatchTimeout = null;
        this.eventArgs = [];
        this.compressor = new (0, $59vML.default)(compressionRules);
    }
}

});
parcelRegister("59vML", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0d93e47c2e6a6a2$export$2e2bcd8739ae039);
/* eslint-disable implicit-arrow-linebreak */ /* eslint-disable max-classes-per-file */ 
var $fNiuW = parcelRequire("fNiuW");

var $gYqa8 = parcelRequire("gYqa8");

var $fYgl8 = parcelRequire("fYgl8");
class $c0d93e47c2e6a6a2$export$2e2bcd8739ae039 {
    constructor(compressionRules = []){
        this.canCompress = (event)=>this.compressionRules.some((compressionRule)=>compressionRule.canCompress(event));
        this.compress = (events)=>{
            const groups = this.createGroups(events);
            return groups.reduce((allCompressedEvents, group)=>{
                const groupCompressedEvents = this.compressGroup(group);
                return allCompressedEvents.concat(groupCompressedEvents);
            }, []);
        };
        this.createGroups = (events)=>// Group events based on contextual fields. These fields are anything that is added by the client itself,
            // rather than passed in by the caller (eg. product, org. and tenant info)
            events.reduce((groups, event)=>{
                const matchingCompressor = this.compressionRules.find((compressor)=>compressor.canCompress(event));
                let contextFields;
                if (matchingCompressor) {
                    const actionFields = (0, $fNiuW.buildActionFields)(event, event.eventType);
                    contextFields = (0, $gYqa8.omit)(event, Object.keys(actionFields));
                }
                const matchingGroup = groups.find((group)=>matchingCompressor === group.compressor && (0, $gYqa8.equals)(contextFields, group.contextFields));
                if (matchingGroup) matchingGroup.events.push(event);
                else groups.push({
                    contextFields: contextFields,
                    compressor: matchingCompressor,
                    events: [
                        event
                    ]
                });
                return groups;
            }, []);
        this.compressGroup = (group)=>{
            // If this group doesn't have any compressor, then the event args are already in their final format
            if (!group.compressor) return group.events;
            try {
                // Run the compressor on the group to generate some new events.
                // The compression function is only expected to return the action fields for each
                // event that it generates, since all other fields are generated by the client.
                const compressedEventActionFields = group.compressor.compress(group.events);
                // Add the context fields to each of the resulting events to inflate them into a full action event
                return compressedEventActionFields.map((actionFields)=>({
                        ...actionFields,
                        ...group.contextFields
                    }));
            } catch (e) {
                // If we fail to compress the events, then just fall back the uncompressed events
                // so that no data is lost. This can happen if the compression function throws an error
                // or returns some invalid event payloads.
                // eslint-disable-next-line no-console
                // console.warn(
                // 	'Failed to compress some analytics events. ' +
                // 		`Error: ${(e as Error).message}. Sending ${
                // 			group.events.length
                // 		} uncompressed events instead`,
                // );
                return group.events;
            }
        };
        if (!Array.isArray(compressionRules)) throw new Error('Event compressors must be constructed with an array of CompressionRules');
        if (!compressionRules.every((rule)=>rule instanceof (0, $fYgl8.CompressionRule))) throw new Error('Event compressors can only be constructed with instances of CompressionRule');
        this.compressionRules = compressionRules;
    }
}

});


parcelRegister("fqOJ4", function(module, exports) {

$parcel$export(module.exports, "StopLowPriorityEventDelayReason", () => $bd02218c2e0bc4f2$export$fa6e3729c21cb8f);
var $bd02218c2e0bc4f2$export$fa6e3729c21cb8f = /*#__PURE__*/ function(StopLowPriorityEventDelayReason) {
    StopLowPriorityEventDelayReason["TIMEOUT"] = "timeout";
    StopLowPriorityEventDelayReason["MANUAL"] = "manual";
    return StopLowPriorityEventDelayReason;
}({});

});


parcelRegister("fHcqB", function(module, exports) {

$parcel$export(module.exports, "default", () => $17fa72493f4c4ecf$export$2e2bcd8739ae039);

var $bXrHm = parcelRequire("bXrHm");

var $hFrZh = parcelRequire("hFrZh");

var $6xafg = parcelRequire("6xafg");

var $kM7SS = parcelRequire("kM7SS");

var $57AWV = parcelRequire("57AWV");

var $kG09p = parcelRequire("kG09p");

var $cdwq4 = parcelRequire("cdwq4");

var $gjgR4 = parcelRequire("gjgR4");

var $9Mu5e = parcelRequire("9Mu5e");

var $1T3jD = parcelRequire("1T3jD");
class $17fa72493f4c4ecf$var$AnalyticsAPIResponse {
    constructor(success, validationErrors, message, code, validationReports){
        this.success = success;
        this.validationErrors = validationErrors;
        this.message = message;
        this.code = code;
        this.validationReports = validationReports;
    }
    isSuccess() {
        return this.success;
    }
    getValidationErrors() {
        return this.validationErrors;
    }
    getMessage() {
        return this.message;
    }
    getCode() {
        return this.code;
    }
    getValidationReports() {
        return this.validationReports === undefined ? null : this.validationReports;
    }
}
class $17fa72493f4c4ecf$var$Message {
    constructor(error){
        this.error = error;
    }
}
class $17fa72493f4c4ecf$var$EventValidationReport {
    constructor(messageId, results){
        this.messageId = messageId;
        this.results = results;
    }
    getMessageId() {
        return this.messageId;
    }
    getResults() {
        return this.results;
    }
}
class $17fa72493f4c4ecf$export$133650fcdde1b226 {
    constructor(success, statusCode, message, eventResponseList){
        this.success = success;
        this.statusCode = statusCode;
        this.message = message;
        this.eventResponseList = eventResponseList;
    }
    isSuccess() {
        return this.success;
    }
    getStatusCode() {
        return this.statusCode;
    }
    getMessage() {
        return this.message;
    }
    getEventResponseList() {
        return this.eventResponseList;
    }
}
class $17fa72493f4c4ecf$var$EventResponse {
    constructor(messageId, results, segmentEvent){
        this.messageId = messageId;
        this.results = results;
        this.segmentEvent = segmentEvent;
    }
    getMessageId() {
        return this.messageId;
    }
    getResults() {
        return this.results;
    }
    getSegmentEvent() {
        return this.segmentEvent;
    }
}
class $17fa72493f4c4ecf$var$EventValidationResult {
    constructor(type, severity, propertyPath, message){
        this.type = type;
        this.severity = severity;
        this.propertyPath = propertyPath;
        this.message = message;
    }
    getType() {
        return this.type;
    }
    getSeverity() {
        return this.severity;
    }
    getPropertyPath() {
        return this.propertyPath;
    }
    getMessage() {
        return this.message;
    }
}
class $17fa72493f4c4ecf$export$2e2bcd8739ae039 {
    constructor(options){
        // Using anonymous function so it can have the BatchFlushCallback type associated with it
        // And to allow it to not need bind when passing through to ResilieceQueue.
        this.sendEvents = async (items, callback)=>{
            if (this.options.enableEventCalls === false) return;
            const httpRetryCount = this.resilienceQueue.getGlobalRetryCount();
            const metricsPayload = this.metrics.getMetricsPayload();
            const eventsWithXID = await this.attachXIDs(items);
            // Calculating sentAt after the XID generation as this may take some time.
            const sentAt = new Date().toISOString();
            const metadataInfo = await this.metadataClient.getMetadataAsync();
            const [eventUrl, isFallbackUrl] = this.getEventUrl(metadataInfo);
            const metadata = {
                ...metricsPayload,
                httpRetryCount: httpRetryCount,
                lastSendEventsErrorReason: this.lastSendEventsError?.message || null,
                lastSendEventsError: this.lastSendEventsError,
                lastUrlFallbackError: this.lastUrlFallbackError,
                isUsingFallbackUrl: isFallbackUrl,
                props: metadataInfo?.props || null,
                metadataClientMetrics: this.metadataClient?.metrics || null
            };
            // Remove default values from metadata to save space
            this.cleanLibraryMetadata(metadata);
            const unpackagedEvents = eventsWithXID.map((item)=>{
                item.msg.sentAt = sentAt;
                return item.msg;
            });
            const batchBody = {
                batch: unpackagedEvents,
                sentAt: sentAt,
                metadata: metadata
            };
            try {
                const response = await (0, $cdwq4.sendEvents)({
                    url: eventUrl,
                    batch: batchBody,
                    timeout: this.options.requestTimeout
                });
                this.lastSendEventsError = null;
                this.lastUrlFallbackError = null;
                this.metrics.subtractFromMetrics(metricsPayload);
                callback(null, response);
                await this.invokeLocalResponseCallbackAsync(items, response, null);
            } catch (error) {
                // If there's an error, other than one which indicates a temporary problem with the service,
                // we'll stop using the URL from the metadata and fall back to the default URL. After a time
                // we'll fall forward again in case the problem has been resolved.
                if (error instanceof (0, $gjgR4.FetchError) && [
                    429,
                    503
                ].includes(error.statusCode)) // Ignore 429 and 503 errors since they're considered to indicate a temporary
                // issue with the service, rather than a network failure due to blocked requests.
                this.lastSendEventsError = new (0, $gjgR4.LastError)('ServerBusyError', error);
                else {
                    const errorName = error instanceof Error && (0, $gjgR4.ALLOW_LISTED_FETCH_ERROR_NAMES).includes(error.name) ? error.name : 'Unknown';
                    this.lastSendEventsError = new (0, $gjgR4.LastError)(errorName, error);
                    // Handle falling back to the default URL if we're using the metadata URL.
                    this.useUrlFromMetadata = false;
                    // If we're now using the fallback URL, and the last attempt wasn't,
                    // we'll record this as the error that triggered the fallback.
                    const [_, willUseFallbackUrl] = this.getEventUrl(metadataInfo);
                    if (willUseFallbackUrl && willUseFallbackUrl !== isFallbackUrl) this.lastUrlFallbackError = this.lastSendEventsError;
                }
                callback(error, null);
                await this.invokeLocalResponseCallbackAsync(items, null, error);
            }
        };
        this.options = {
            ...options,
            requestTimeout: options.requestTimeout || (0, $57AWV.DEFAULT_REQUEST_TIMEOUT),
            retryQueueOptions: options.retryQueueOptions || {},
            logger: options.logger || console,
            disableCookiePersistence: options.disableCookiePersistence || false,
            env: options.env,
            perimeter: options.perimeter || '',
            enableMetadataCalls: typeof options.enableMetadataCalls === 'boolean' ? options.enableMetadataCalls : true,
            enableEventCalls: typeof options.enableEventCalls === 'boolean' ? options.enableEventCalls : true
        };
        this.user = new (0, $9Mu5e.default)(this.options?.disableCookiePersistence);
        this.xidPromiseCallback = options.xidPromiseGetter();
        this.gasv3BatchUrl = `${options.apiHostProtocol}://${options.apiHost}/batch`;
        this.metrics = (0, $6xafg.default)();
        this.responseCallback = options.responseCallback;
        this.resilienceQueue = (0, $hFrZh.default)(options.retryQueuePrefix, options.product, this.options.retryQueueOptions, this.options.logger);
        this.metadataClient = options.metadataClient;
        this.useUrlFromMetadata = true;
        this.lastSendEventsError = null;
        this.lastUrlFallbackError = null;
        setInterval(()=>{
            this.useUrlFromMetadata = true;
        }, 600000);
        this.resilienceQueue.start(this.sendEvents);
    }
    getUser() {
        return this.user;
    }
    async track(eventName, builtEvent, context, callback) {
        const baseEvent = this.buildBaseEvent(context, (0, $gjgR4.SegmentEventTypes).TRACK, builtEvent);
        const eventWithoutMessageId = {
            ...baseEvent,
            type: (0, $gjgR4.SegmentEventTypes).TRACK,
            properties: (0, $1T3jD.prepareEventProperties)(builtEvent),
            event: eventName
        };
        const event = {
            ...eventWithoutMessageId,
            messageId: this.createMessageId()
        };
        const packagedEvent = this.packageEvent(event);
        await this.enqueueEvent(packagedEvent);
        if (callback) callback();
    }
    async page(eventName, builtEvent, context, callback) {
        const baseEvent = this.buildBaseEvent(context, (0, $gjgR4.SegmentEventTypes).PAGE, builtEvent);
        const eventWithoutMessageId = {
            ...baseEvent,
            type: (0, $gjgR4.SegmentEventTypes).PAGE,
            properties: (0, $1T3jD.prepareEventProperties)(builtEvent),
            name: eventName
        };
        const event = {
            ...eventWithoutMessageId,
            messageId: this.createMessageId()
        };
        const packagedEvent = this.packageEvent(event);
        await this.enqueueEvent(packagedEvent);
        if (callback) callback();
    }
    // Segment uses the identifier to update user id which we have already done in the analyticsWebClient.ts
    async identify(_identifier, builtEvent, context, callback) {
        const baseEvent = this.buildBaseEvent(context, (0, $gjgR4.SegmentEventTypes).IDENTIFY, builtEvent);
        const eventWithoutMessageId = {
            ...baseEvent,
            type: (0, $gjgR4.SegmentEventTypes).IDENTIFY,
            traits: (0, $1T3jD.prepareEventProperties)(builtEvent)
        };
        const event = {
            ...eventWithoutMessageId,
            messageId: this.createMessageId()
        };
        const packagedEvent = this.packageEvent(event);
        await this.enqueueEvent(packagedEvent);
        if (callback) callback();
    }
    async enqueueEvent(packagedEvent) {
        if (this.options.enableMetadataCalls) this.metadataClient.start(false); // Start the metadata client if needed
        await this.resilienceQueue.addItem(packagedEvent);
    }
    buildBaseEvent(context, type, overrides) {
        const clonedContext = (0, $1T3jD.prepareEventProperties)(context);
        const segmentContext = (0, $1T3jD.buildContext)(clonedContext);
        return {
            context: segmentContext,
            timestamp: new Date().toISOString(),
            type: type,
            userId: this.user.getUserId(),
            anonymousId: overrides.anonymousId || this.user.getAnonymousId()
        };
    }
    createMessageId() {
        return `ajs-${(0, (/*@__PURE__*/$parcel$interopDefault($bXrHm)))()}`;
    }
    packageEvent(event) {
        const { apiHost: apiHost, apiHostProtocol: apiHostProtocol } = this.options;
        return {
            headers: {
                'Content-Type': 'text/plain'
            },
            msg: event,
            url: `${apiHostProtocol}://${apiHost}/${event.type.charAt(0)}`
        };
    }
    getEventUrl(metadataInfo) {
        const preferredBatchUrl = metadataInfo?.url ? metadataInfo.url : this.gasv3BatchUrl;
        const finalBatchUrl = this.useUrlFromMetadata ? preferredBatchUrl : this.gasv3BatchUrl;
        const isFallbackUrl = preferredBatchUrl === this.gasv3BatchUrl ? null : finalBatchUrl !== preferredBatchUrl;
        return [
            finalBatchUrl,
            isFallbackUrl
        ];
    }
    cleanLibraryMetadata(obj) {
        // skip if the parameter is not an object
        if (obj === null || typeof obj !== 'object') return;
        for(const key in obj){
            let value = obj[key];
            // Remove null or undefined values
            if (value === null || value === undefined) delete obj[key];
            else if (typeof value === 'number' && value === 0) delete obj[key];
            else if (Array.isArray(value)) {
                if (value.length === 0) delete obj[key];
                else value.forEach((item)=>{
                    this.cleanLibraryMetadata(item);
                });
            } else if (typeof value === 'object') this.cleanLibraryMetadata(obj[key]);
        }
    }
    async invokeLocalResponseCallbackAsync(items, response, error) {
        const localResponseCallback = this.responseCallback;
        if (localResponseCallback) {
            // If we have a response, we'll parse it and create an AnalyticsAPIResponse from it.
            let analyticsAPIResponse = null;
            if (response) {
                let responseObject;
                try {
                    responseObject = await response.clone().json();
                } catch (error) {
                // Ignore errors parsing the response, we can't do anything about them
                }
                // Ensure we've got a valid object to work with, filling in any missing
                // properties as best we can.
                responseObject = responseObject || {};
                responseObject.code = Number.parseInt(responseObject.code) > 0 ? Number.parseInt(responseObject.code) : response.status;
                responseObject.success = responseObject.success || responseObject.code >= 200 && responseObject.code <= 299;
                analyticsAPIResponse = new $17fa72493f4c4ecf$var$AnalyticsAPIResponse(responseObject.success, responseObject.validationErrors || new Map(), new $17fa72493f4c4ecf$var$Message(responseObject.message?.error || ''), responseObject.code, responseObject.validationReports || null);
            }
            // If we have an error, but it's not an instance of Error (e.g. it's a string), we'll convert it to an Error object.
            if (error && !(error instanceof Error)) error = new Error(String(error));
            const analyticsResponse = $17fa72493f4c4ecf$var$BatchInterceptor.toAnalyticsResponse(items || [], error || null, analyticsAPIResponse);
            localResponseCallback(analyticsResponse);
        }
    }
    async attachXIDs(items) {
        if (this.xidPromiseCallback) return (0, $kM7SS.attachXidToMultipleEvents)(items, this.xidPromiseCallback);
        return Promise.resolve(items);
    }
    setResponseCallback(responseCallback) {
        this.responseCallback = responseCallback;
    }
    refreshMetadata(userInfo, tenantInfo) {
        this.metadataClient.userInfo = userInfo;
        this.metadataClient.tenantInfo = tenantInfo;
    }
}
class $17fa72493f4c4ecf$var$BatchInterceptor {
    static{
        this.http_error_regex = /HTTP Error\s([0-9]{3})\s\((.+)\)/;
    }
    static toAnalyticsResponse(items, error, analyticsAPIResponse) {
        const eventResponseList = [];
        if (analyticsAPIResponse !== null) {
            const [statusCode, success] = [
                analyticsAPIResponse.code,
                analyticsAPIResponse.success
            ];
            if (statusCode >= 200 && statusCode <= 299) {
                analyticsAPIResponse.validationReports?.forEach((report)=>{
                    const matchedEvent = items.find((item)=>item.msg.messageId === report.messageId);
                    if (matchedEvent) eventResponseList.push(new $17fa72493f4c4ecf$var$EventResponse(matchedEvent.msg.messageId, report.results, matchedEvent.msg));
                });
                return new $17fa72493f4c4ecf$export$133650fcdde1b226(success, statusCode, (0, $kG09p.HTTP_STATUS_CODE_MAP).get(statusCode), eventResponseList);
            } else if (statusCode >= 400 && statusCode <= 499) {
                // not exluding "HTTP 429 Too Many Requests error" as it is thrown as an error and handled below
                const errorMessage = analyticsAPIResponse.message?.error !== null ? analyticsAPIResponse.message.error : (0, $kG09p.HTTP_STATUS_CODE_MAP).has(statusCode) ? (0, $kG09p.HTTP_STATUS_CODE_MAP).get(statusCode) : (0, $kG09p.HTTP_STATUS_CODE_MAP).get(-1);
                items.forEach((item)=>{
                    eventResponseList.push(new $17fa72493f4c4ecf$var$EventResponse(item.msg.messageId, [], item.msg));
                });
                return new $17fa72493f4c4ecf$export$133650fcdde1b226(success, statusCode, errorMessage, eventResponseList);
            }
        } else if (error?.message) {
            const match = error.message.match($17fa72493f4c4ecf$var$BatchInterceptor.http_error_regex);
            if (match) {
                items.forEach((item)=>{
                    eventResponseList.push(new $17fa72493f4c4ecf$var$EventResponse(item.msg.messageId, [], item.msg));
                });
                return new $17fa72493f4c4ecf$export$133650fcdde1b226(false, Number(match[1]), match[2], eventResponseList);
            }
        }
        items.forEach((item)=>{
            eventResponseList.push(new $17fa72493f4c4ecf$var$EventResponse(item.msg.messageId, [], item.msg));
        });
        return new $17fa72493f4c4ecf$export$133650fcdde1b226(false, -1, (0, $kG09p.HTTP_STATUS_CODE_MAP).get(-1), eventResponseList);
    }
}

});
parcelRegister("hFrZh", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd231604eac6729b$export$2e2bcd8739ae039);

var $jChFm = parcelRequire("jChFm");

var $bd231604eac6729b$export$2e2bcd8739ae039 = (retryQueuePrefix, product, options, logger)=>{
    return new (0, $jChFm.default)(retryQueuePrefix, product, options || {}, logger);
};

});
parcelRegister("jChFm", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_POLLING_OPTIONS", () => $39d95da3d6d99845$export$d219df4fe04c04a7);
$parcel$export(module.exports, "default", () => $39d95da3d6d99845$export$2e2bcd8739ae039);

var $k3k8u = parcelRequire("k3k8u");
var $dviIT = parcelRequire("dviIT");

var $fKoyL = parcelRequire("fKoyL");
var $42k5W = parcelRequire("42k5W");
var $2A2TO = parcelRequire("2A2TO");

var $6xafg = parcelRequire("6xafg");

var $1LZzU = parcelRequire("1LZzU");

var $38r8F = parcelRequire("38r8F");
var $aRK7K = parcelRequire("aRK7K");

var $ePz85 = parcelRequire("ePz85");
const $39d95da3d6d99845$var$ONE_MINUTE = 60000;
const $39d95da3d6d99845$var$LONG_POLLING_OPTIONS = {
    backoffFactor: 0,
    backoffJitterPercentage: 0,
    flushWaitMs: $39d95da3d6d99845$var$ONE_MINUTE,
    minRetryDelay: $39d95da3d6d99845$var$ONE_MINUTE,
    maxRetryDelay: $39d95da3d6d99845$var$ONE_MINUTE
};
const $39d95da3d6d99845$export$d219df4fe04c04a7 = {
    backoffFactor: 2,
    backoffJitterPercentage: 0.2,
    batchFlushSize: 7,
    flushBeforeUnload: false,
    flushWaitMs: 500,
    maxAttempts: 10,
    // TODO figure out this number. For indexeddb we are sharing the queue with all tabs
    maxItems: 1000,
    maxRetryDelay: 30000,
    minRetryDelay: 1000
};
class $39d95da3d6d99845$export$2e2bcd8739ae039 {
    constructor(queuePrefix, product, options, logger){
        this.queuePrefix = queuePrefix;
        // Avoiding using options in ResilienceDB at this stage as
        // the options are optimised for the PushBatchableQueue
        this.resilience = new (0, $42k5W.default)(product, {
            logger: logger,
            maxAttempts: options?.maxAttempts,
            maxEventLimit: options?.maxItems
        });
        this.options = this.buildOptions(options);
        this.scheduler = new (0, $38r8F.default)({
            ...this.options,
            waitInterval: options?.flushBeforeUnload ? 0 : this.options.flushWaitMs
        }, this.scheduleCallback.bind(this));
        this.longPollingScheduler = new (0, $38r8F.default)({
            ...$39d95da3d6d99845$var$LONG_POLLING_OPTIONS,
            waitInterval: $39d95da3d6d99845$var$LONG_POLLING_OPTIONS.flushWaitMs
        }, this.scheduleLongCallBack.bind(this));
        this.metricsCollector = (0, $6xafg.default)();
        this.networkStatus = new (0, $1LZzU.default)((status)=>{
            if (status === (0, $ePz85.NetworkStatusEnum).OFFLINE) this.scheduler.stop();
            else this.checkEventCountAndReschedule();
        });
    }
    start(flushCallback) {
        this.batchFlushCallback = flushCallback;
        this.longPollingScheduler.schedule();
    }
    stop() {
        this.scheduler.stop();
        this.longPollingScheduler.stop();
    }
    async addItem(item) {
        // Since Jira and Confluence use `.toJSON` on objects that should be strings
        // And expect us to use `JSON.stringify` on these objects,
        // And indexeddb strips these functions from the objects when adding them to the DB,
        // We must run this silly stringify and parse before passing the event to the resilience meechanism.
        // Planning on removing this in v4
        const jsonStringifiedAndParsedItem = JSON.parse(JSON.stringify(item));
        const { numberOfEvictedItems: numberOfEvictedItems } = await this.resilience.addItem(jsonStringifiedAndParsedItem, {}, (0, $2A2TO.GuardPolicy).EVICT);
        this.scheduler.schedule();
        this.metricsCollector.addToEventCount();
        if (numberOfEvictedItems > 0) this.metricsCollector.addToItemsDiscardedByOverflowCounter(numberOfEvictedItems);
    }
    getGlobalRetryCount() {
        return this.scheduler.getFailureCount();
    }
    async scheduleCallback(done) {
        // Even though we stopped the scheduler, it can be restarted with a call to schedule.
        // This could be triggered by a new event or the longPollingScheduler
        if (this.networkStatus.getNetworkStatus() === (0, $ePz85.NetworkStatusEnum).OFFLINE) {
            done((0, $aRK7K.DoneState).NOOP);
            return;
        }
        try {
            const result = await this.resilience.processItems(this.flush.bind(this), this.options.batchFlushSize);
            done(result);
        } catch (error) {
            if (error.name === (0, $fKoyL.CallbackProcessingErrorName)) {
                done((0, $aRK7K.DoneState).ERROR);
                return;
            }
        // TODO we can probably log here but throwing is useless as it will just be shallowed by the Scheduler
        // In theory something else should catch all other errors from indexeddb and this should never happen.
        } finally{
            await this.checkEventCountAndReschedule();
        }
    }
    async checkEventCountAndReschedule() {
        const eventWaitingCount = await this.resilience.getItemCount();
        if (eventWaitingCount > 0) this.scheduler.schedule({
            immediate: eventWaitingCount >= this.options.batchFlushSize
        });
    }
    async scheduleLongCallBack(done) {
        // Eventually we will want to send data about how many queues were purged
        const numberOfQueuesPurged = (0, $k3k8u.default)(this.queuePrefix);
        this.metricsCollector.addToPurgedQueuesMetrics(numberOfQueuesPurged);
        // Eventually we will want to send data about how attempted reclaims and actual reclaims were made
        const reclaimMetrics = await (0, $dviIT.default)(this.queuePrefix, async (localStorageItems)=>{
            const itemsToAdd = localStorageItems.map((localStorageItem)=>({
                    item: localStorageItem.item,
                    retryAttempts: localStorageItem.attemptNumber,
                    id: localStorageItem.id
                }));
            const { items: addedEvents } = await this.resilience.bulkAddItem(itemsToAdd, (0, $2A2TO.GuardPolicy).IGNORE);
            if (addedEvents.length === itemsToAdd.length) return {
                status: 'successful'
            };
            else return {
                status: 'partial',
                acceptedItemIds: addedEvents.map((event)=>event.id)
            };
        });
        this.metricsCollector.addToReclaimMetrics(reclaimMetrics);
        // We dont want to flush events from here as there maybe issues with analytics-service
        // Scheduler has all the context and can schedule the next batch accordingly
        await this.checkEventCountAndReschedule();
        done((0, $aRK7K.DoneState).SUCCESS);
        this.longPollingScheduler.schedule();
    }
    flush(wrappedItems, otherMetadata) {
        this.metricsCollector.setResilienceMechanism(this.resilience.storeType());
        const { batchFlushCallback: batchFlushCallback } = this;
        if (!batchFlushCallback) throw new Error('batchFlushCallback has not been set. Call PullBatchableQueue#start first.');
        return new Promise((resolve, reject)=>{
            if (wrappedItems.length <= 0) {
                resolve((0, $aRK7K.DoneState).NOOP);
                return;
            }
            const items = wrappedItems.map((wrappedItem)=>{
                const item = wrappedItem.item;
                if (wrappedItem.retryAttempts > 0 && item.msg) {
                    if (!item.msg._metadata) item.msg._metadata = {};
                    item.msg._metadata.failedAttempts = wrappedItem.retryAttempts;
                }
                return item;
            });
            batchFlushCallback(items, (error)=>{
                if (error) {
                    if (otherMetadata.numberOfDeletedItems > 0) this.metricsCollector.addToItemsDiscardedByRetryCounter(otherMetadata.numberOfDeletedItems);
                    reject(error);
                } else resolve((0, $aRK7K.DoneState).SUCCESS);
            });
        });
    }
    buildOptions(options) {
        return {
            backoffFactor: options?.backoffFactor || $39d95da3d6d99845$export$d219df4fe04c04a7.backoffFactor,
            backoffJitterPercentage: options?.backoffJitterPercentage !== undefined ? options.backoffJitterPercentage : $39d95da3d6d99845$export$d219df4fe04c04a7.backoffJitterPercentage,
            batchFlushSize: options?.batchFlushSize || $39d95da3d6d99845$export$d219df4fe04c04a7.batchFlushSize,
            flushBeforeUnload: options?.flushBeforeUnload || $39d95da3d6d99845$export$d219df4fe04c04a7.flushBeforeUnload,
            flushWaitMs: options?.flushWaitMs || $39d95da3d6d99845$export$d219df4fe04c04a7.flushWaitMs,
            maxItems: options?.maxItems || $39d95da3d6d99845$export$d219df4fe04c04a7.maxItems,
            maxAttempts: options?.maxAttempts || $39d95da3d6d99845$export$d219df4fe04c04a7.maxAttempts,
            maxRetryDelay: options?.maxRetryDelay || $39d95da3d6d99845$export$d219df4fe04c04a7.maxRetryDelay,
            minRetryDelay: options?.minRetryDelay || $39d95da3d6d99845$export$d219df4fe04c04a7.minRetryDelay
        };
    }
}

});
parcelRegister("k3k8u", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd76f1476c4f2479$export$2e2bcd8739ae039);

var $i1Orc = parcelRequire("i1Orc");

var $eswaT = parcelRequire("eswaT");
// For more details on this funciton, see https://hello.atlassian.net/wiki/spaces/MEASURE/pages/585086028/Investigation+Local+storage+full
// TL;DR
// If a queue looses its `ack` key in localstorage, it will never get claimed.
// There is a small chance that this can happen.
// This function is to run through queues and clean any that have been orphaned.
// Keys stolen from https://github.com/segmentio/localstorage-retry/blob/master/lib/index.js#L55
const $fd76f1476c4f2479$var$validSuffixs = Object.values((0, $i1Orc.LocalStorageKeySuffix));
var $fd76f1476c4f2479$export$2e2bcd8739ae039 = (prefix)=>{
    if (typeof prefix !== 'string' || prefix.length === 0) // We do not want to start deleting everything in localstorage
    return 0;
    try {
        const queueStates = Object.keys(localStorage).filter((key)=>key && key.startsWith(`${prefix}.`) || false).map((key)=>key.split('.')).filter((splitKeys)=>splitKeys.length === 3 && $fd76f1476c4f2479$var$validSuffixs.includes(splitKeys[2])).reduce((accumulator, currentKeys)=>{
            const [, id, suffix] = currentKeys;
            if (accumulator[id] === undefined) accumulator[id] = {};
            accumulator[id][suffix] = true;
            return accumulator;
        }, {});
        const queuesToPurge = Object.keys(queueStates).filter((id)=>queueStates[id][(0, $i1Orc.LocalStorageKeySuffix).ACK] !== true);
        queuesToPurge.forEach((id)=>{
            const { queue: queue, inProgress: inProgress, reclaimStart: reclaimStart, reclaimEnd: reclaimEnd } = (0, $eswaT.createLocalStorageKeys)(prefix, id);
            localStorage.removeItem(inProgress);
            localStorage.removeItem(queue);
            localStorage.removeItem(reclaimStart);
            localStorage.removeItem(reclaimEnd);
        });
        return queuesToPurge.length;
    } catch (_error) {
    // Ignore errors from localStorage.
    }
    return 0;
};

});
parcelRegister("i1Orc", function(module, exports) {

$parcel$export(module.exports, "LocalStorageKeySuffix", () => $393cf75dcd124cc1$export$ecfa71cbc9b28241);
$parcel$export(module.exports, "Timers", () => $393cf75dcd124cc1$export$8bb2c1fb2b1765a9);
var $393cf75dcd124cc1$export$ecfa71cbc9b28241 = /*#__PURE__*/ function(LocalStorageKeySuffix) {
    LocalStorageKeySuffix["IN_PROGRESS"] = "inProgress";
    LocalStorageKeySuffix["QUEUE"] = "queue";
    LocalStorageKeySuffix["RECLAIM_START"] = "reclaimStart";
    LocalStorageKeySuffix["RECLAIM_END"] = "reclaimEnd";
    LocalStorageKeySuffix["ACK"] = "ack";
    return LocalStorageKeySuffix;
}({});
var $393cf75dcd124cc1$export$8bb2c1fb2b1765a9 = /*#__PURE__*/ function(Timers) {
    Timers[Timers["RECLAIM_TIMEOUT"] = 10000] = "RECLAIM_TIMEOUT";
    Timers[Timers["RECLAIM_WAIT"] = 500] = "RECLAIM_WAIT";
    Timers[Timers["RECLAIM_WAIT_THRESHOLD"] = 2000] = "RECLAIM_WAIT_THRESHOLD";
    return Timers;
}({});

});

parcelRegister("eswaT", function(module, exports) {

$parcel$export(module.exports, "createLocalStorageKeys", () => $43898d43f8cc5c71$export$8433d54f767cbec5);

var $i1Orc = parcelRequire("i1Orc");
const $43898d43f8cc5c71$export$8433d54f767cbec5 = (queuePrefix, queueId)=>({
        [(0, $i1Orc.LocalStorageKeySuffix).ACK]: `${queuePrefix}.${queueId}.${(0, $i1Orc.LocalStorageKeySuffix).ACK}`,
        [(0, $i1Orc.LocalStorageKeySuffix).QUEUE]: `${queuePrefix}.${queueId}.${(0, $i1Orc.LocalStorageKeySuffix).QUEUE}`,
        [(0, $i1Orc.LocalStorageKeySuffix).IN_PROGRESS]: `${queuePrefix}.${queueId}.${(0, $i1Orc.LocalStorageKeySuffix).IN_PROGRESS}`,
        [(0, $i1Orc.LocalStorageKeySuffix).RECLAIM_START]: `${queuePrefix}.${queueId}.${(0, $i1Orc.LocalStorageKeySuffix).RECLAIM_START}`,
        [(0, $i1Orc.LocalStorageKeySuffix).RECLAIM_END]: `${queuePrefix}.${queueId}.${(0, $i1Orc.LocalStorageKeySuffix).RECLAIM_END}`
    });

});


parcelRegister("dviIT", function(module, exports) {

$parcel$export(module.exports, "default", () => $c23d944238e95a41$export$2e2bcd8739ae039);

var $bXrHm = parcelRequire("bXrHm");

var $i1Orc = parcelRequire("i1Orc");

var $eswaT = parcelRequire("eswaT");
const $c23d944238e95a41$var$promisedSetTimeout = (msToWait)=>new Promise((resolve)=>{
        setTimeout(resolve, msToWait);
    });
const $c23d944238e95a41$var$findOtherQueues = (queuePrefix)=>{
    try {
        return Object.keys(localStorage).filter((key)=>key.startsWith(queuePrefix)).map((key)=>key.split('.')).filter((split)=>{
            if (split.length === 3 && split[0] === queuePrefix && split[2] === (0, $i1Orc.LocalStorageKeySuffix).ACK) try {
                const ackTimestamp = localStorage.getItem(split.join('.'));
                if (ackTimestamp) {
                    const ackTimestampNumber = parseInt(ackTimestamp);
                    return (0, $i1Orc.Timers).RECLAIM_TIMEOUT + ackTimestampNumber < Date.now();
                }
            } catch (error) {
            // ignore and drop value
            }
            return false;
        }).map((split)=>split[1]);
    } catch (_error) {
    // Ignore errors from accessing localStorage.
    }
    return [];
};
const $c23d944238e95a41$var$tryReclaim = async (options, callback)=>{
    const { ack: ack, reclaimStart: reclaimStart, reclaimEnd: reclaimEnd } = options.storageKeys;
    const start = Date.now();
    localStorage.setItem(reclaimStart, options.reclaimProcessId);
    localStorage.setItem(ack, start.toString());
    await $c23d944238e95a41$var$promisedSetTimeout((0, $i1Orc.Timers).RECLAIM_WAIT);
    if (// Prevent duplicates when extracting events from localstorage due to CPU / Memory pressure on client
    Date.now() > start + (0, $i1Orc.Timers).RECLAIM_WAIT_THRESHOLD || // Either the parent has caught up and removed our claim, or someone else started a claim instead
    localStorage.getItem(reclaimStart) !== options.reclaimProcessId) throw new Error('Took to long to callback, reclaim abandonded. After reclaimStart.');
    localStorage.setItem(reclaimEnd, options.reclaimProcessId);
    await $c23d944238e95a41$var$promisedSetTimeout((0, $i1Orc.Timers).RECLAIM_WAIT);
    if (// Prevent duplicates when extracting events from localstorage due to CPU / Memory pressure on client
    Date.now() > start + (0, $i1Orc.Timers).RECLAIM_WAIT_THRESHOLD || // Either the parent has caught up and removed our claim, or someone else started a claim instead
    localStorage.getItem(reclaimStart) !== options.reclaimProcessId || localStorage.getItem(reclaimEnd) !== options.reclaimProcessId) throw new Error('Took to long to callback, reclaim abandonded. After reclaimEnd.');
    return $c23d944238e95a41$var$reclaim(options, callback);
};
const $c23d944238e95a41$var$reclaim = async (options, callback)=>{
    const { queue: queue, inProgress: inProgress } = options.storageKeys;
    // Queue is an array of events while inProgress is an object with a uuid for key
    // Either of these queues may legitimately be missing.
    const eventsInQueue = JSON.parse(localStorage.getItem(queue) || '[]');
    const eventsInProgress = JSON.parse(localStorage.getItem(inProgress) || '{}');
    const arrayOfEventsInProgress = Object.entries(eventsInProgress).map(([key, item])=>{
        const itemWithId = {
            ...item,
            // LocalStorage-retry would add the attemptCounter after failure, rather than
            // as it was being processed
            attemptNumber: item.attemptNumber + 1,
            id: key
        };
        return itemWithId;
    });
    const eventsToProcess = [
        ...eventsInQueue,
        ...arrayOfEventsInProgress
    ];
    if (eventsToProcess.length > 0) {
        const result = await callback(eventsToProcess);
        if (result.status === 'successful') $c23d944238e95a41$var$clearLocalStorageKeys(options.storageKeys);
        else if (result.status === 'partial') {
            // Dont delete all events if we are only able to take some of them.
            const leftover = eventsToProcess.filter((event)=>!result.acceptedItemIds.includes(event.id));
            // This way around, we can almost ensure that we wont hit memory quota exceeded errors.
            // However, there is a very small chance that we may lose events if the process exits between these two commands.
            localStorage.removeItem(inProgress);
            localStorage.setItem(queue, JSON.stringify(leftover));
            return {
                fullReclaim: false
            };
        }
    } else $c23d944238e95a41$var$clearLocalStorageKeys(options.storageKeys);
    return {
        fullReclaim: true
    };
};
// Exterminate
const $c23d944238e95a41$var$clearLocalStorageKeys = (keys)=>{
    // Always good to do queue and inprogress first to reduce duplications
    // and to free up more space in localstorage
    localStorage.removeItem(keys.queue);
    localStorage.removeItem(keys.inProgress);
    localStorage.removeItem(keys.reclaimEnd);
    localStorage.removeItem(keys.reclaimStart);
    // This has to be last or we risk leaving things in localStorage that have to be purged
    localStorage.removeItem(keys.ack);
};
var $c23d944238e95a41$export$2e2bcd8739ae039 = async (queuePrefix, callback)=>{
    if (typeof queuePrefix !== 'string' || queuePrefix.length === 0) // We do not want to start deleting everything in localstorage
    return {
        fullReclaims: 0,
        partialReclaims: 0,
        failedReclaims: 0
    };
    const reclaimProcessId = (0, (/*@__PURE__*/$parcel$interopDefault($bXrHm)))();
    const queuesToReclaim = $c23d944238e95a41$var$findOtherQueues(queuePrefix);
    const claims = queuesToReclaim.map((id)=>$c23d944238e95a41$var$tryReclaim({
            queuePrefix: queuePrefix,
            reclaimProcessId: reclaimProcessId,
            storageKeys: (0, $eswaT.createLocalStorageKeys)(queuePrefix, id)
        }, callback));
    const settledClaims = await Promise.allSettled(claims);
    const failedReclaims = settledClaims.filter((claim)=>claim.status === 'rejected');
    const successfulClaims = settledClaims.filter((settledValue)=>settledValue.status === 'fulfilled').map((result)=>result.value);
    const fullReclaims = successfulClaims.filter((claim)=>claim.fullReclaim);
    const partialReclaims = successfulClaims.filter((claim)=>!claim.fullReclaim);
    return {
        failedReclaims: failedReclaims.length,
        partialReclaims: partialReclaims.length,
        fullReclaims: fullReclaims.length
    };
};

});

parcelRegister("fKoyL", function(module, exports) {

$parcel$export(module.exports, "CallbackProcessingErrorName", () => $f964b3c84933dfcd$export$a409c8de90e11e14);
$parcel$export(module.exports, "default", () => $f964b3c84933dfcd$export$2e2bcd8739ae039);
const $f964b3c84933dfcd$export$a409c8de90e11e14 = 'CallbackProcessingError';
class $f964b3c84933dfcd$export$2e2bcd8739ae039 extends Error {
    constructor(error){
        const messageFromError = error && typeof error === 'object' && 'toString' in error && typeof error.toString === 'function' && error.toString();
        const messageFromString = typeof error === 'string' && error;
        const message = messageFromError || messageFromString || 'Argument passed to CallbackProcessingError was not an Error or string.';
        super(`Error thrown while processing events in callback: ${message}`);
        // Must reset the prototypes after calling super of builtin classes
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $f964b3c84933dfcd$export$2e2bcd8739ae039.prototype);
        this.name = $f964b3c84933dfcd$export$a409c8de90e11e14;
    }
}

});

parcelRegister("42k5W", function(module, exports) {

$parcel$export(module.exports, "default", () => $f0cb9a64b4ca8416$export$2e2bcd8739ae039);

var $hEfNx = parcelRequire("hEfNx");

var $2A2TO = parcelRequire("2A2TO");

var $fKoyL = parcelRequire("fKoyL");
var $f0cb9a64b4ca8416$export$2e2bcd8739ae039 = (0, $hEfNx.default);

});
parcelRegister("hEfNx", function(module, exports) {

$parcel$export(module.exports, "default", () => $1270c8838eaac632$export$2e2bcd8739ae039);

var $2A2TO = parcelRequire("2A2TO");

var $5tWx3 = parcelRequire("5tWx3");
var $2oiOa = parcelRequire("2oiOa");

var $3q6DL = parcelRequire("3q6DL");

var $lGyYf = parcelRequire("lGyYf");

var $iYeWv = parcelRequire("iYeWv");
class $1270c8838eaac632$export$2e2bcd8739ae039 {
    constructor(namespace, options = {}){
        this.namespace = namespace;
        this.options = (0, $iYeWv.createOptionsWithDefaults)(options);
        if (!namespace || namespace.length === 0 || typeof namespace !== 'string') throw new Error('Invalid namespace provided');
        this.resilience = this.getResilienceMechanism(namespace, options);
    }
    getResilienceMechanism(namespace, options) {
        if (!options.useMemory) try {
            return new (0, $3q6DL.default)(namespace, options);
        } catch (error) {
            if (!(error instanceof (0, $5tWx3.default))) options.logger?.warn('Attempted to create IndexedDbResilience but failed. Using memory instead.');
        }
        return new (0, $lGyYf.default)(this.namespace, options);
    }
    addItem(item, options, policy = (0, $2A2TO.GuardPolicy).ABANDON) {
        return this.runOrFailOver(()=>this.resilience.addItem(item, options, policy));
    }
    bulkAddItem(itemOptions, policy = (0, $2A2TO.GuardPolicy).ABANDON) {
        return this.runOrFailOver(()=>this.resilience.bulkAddItem(itemOptions, policy));
    }
    getItems(count) {
        return this.runOrFailOver(()=>this.resilience.getItems(count));
    }
    deleteItems(itemIds) {
        return this.runOrFailOver(()=>this.resilience.deleteItems(itemIds));
    }
    getItemCount() {
        return this.runOrFailOver(()=>this.resilience.getItemCount());
    }
    processItems(processFn, count) {
        return this.runOrFailOver(()=>this.resilience.processItems(processFn, count));
    }
    storeType() {
        return this.resilience.storeType();
    }
    async runOrFailOver(runnable) {
        try {
            return await runnable();
        } catch (error) {
            if ((0, $2oiOa.shouldIgnoreResilienceDbError)(error)) throw error;
            else if (this.resilience.storeType() === (0, $2A2TO.StoreType).INDEXEDDB) await this.failOver();
            return runnable();
        }
    }
    async failOver() {
        // Attempt to get any events we can and put them into memory
        const oldResilience = this.resilience;
        const newResilience = new (0, $lGyYf.default)(this.namespace, this.options);
        this.resilience = newResilience;
        try {
            const { items: items } = await oldResilience.getItems(this.options.maxEventLimit);
            if (items.length > 0) {
                const bulkAddItemsResponse = await newResilience.bulkAddItemWrapperType(items, (0, $2A2TO.GuardPolicy).IGNORE);
                const addedItemIds = bulkAddItemsResponse.items.map((item)=>item.id);
                await oldResilience.deleteItems(addedItemIds);
            }
        } catch (error) {
            this.options.logger.warn('Unexpected error from ResilienceDb, switching to MemoryDb');
        // Dont need to catch. We are just getting events if we can
        }
    }
}

});
parcelRegister("2A2TO", function(module, exports) {

$parcel$export(module.exports, "NAMESPACE_AND_TIME_ADDED_INDEX", () => $81274d443ac00760$export$d21fbb25eb37b5bf);
$parcel$export(module.exports, "RESILIENCE_DB_NAME", () => $81274d443ac00760$export$8cad224051643259);
$parcel$export(module.exports, "RESILIENCE_STORE_NAME", () => $81274d443ac00760$export$3d8420be07b276ab);
$parcel$export(module.exports, "TIME_TO_PROCESS_AFTER_INDEX", () => $81274d443ac00760$export$a512a65455fce2a6);
$parcel$export(module.exports, "TIME_ADDED_INDEX", () => $81274d443ac00760$export$89d9c1ff8ac91862);
$parcel$export(module.exports, "RETRY_INDEX", () => $81274d443ac00760$export$a37d385bcd713809);
$parcel$export(module.exports, "INDEXEDDB_TIMEOUT", () => $81274d443ac00760$export$6d8635fed0e4b14d);
$parcel$export(module.exports, "StoreType", () => $81274d443ac00760$export$39337ab5872e9457);
$parcel$export(module.exports, "GuardPolicy", () => $81274d443ac00760$export$7710d69e6f450f20);
const $81274d443ac00760$export$d21fbb25eb37b5bf = 'namespace-timeAdded';
const $81274d443ac00760$export$8cad224051643259 = 'analytics-web-client';
const $81274d443ac00760$export$3d8420be07b276ab = 'analytics-resilience';
const $81274d443ac00760$export$a512a65455fce2a6 = 'timeToBeProcessedAfter';
const $81274d443ac00760$export$89d9c1ff8ac91862 = 'timeAdded';
const $81274d443ac00760$export$a37d385bcd713809 = 'retryAttempts';
const $81274d443ac00760$export$6d8635fed0e4b14d = 15000;
var $81274d443ac00760$export$39337ab5872e9457 = /*#__PURE__*/ function(StoreType) {
    StoreType["INDEXEDDB"] = "indexeddb";
    StoreType["MEMORY"] = "memory";
    return StoreType;
}({});
var $81274d443ac00760$export$7710d69e6f450f20 = /*#__PURE__*/ function(GuardPolicy) {
    // Adds as many items as possible and IGONRES the rest.
    // Only to be used with BulkAdd
    GuardPolicy["IGNORE"] = "ignore";
    // ABANDON the request if not all items can be added.
    GuardPolicy["ABANDON"] = "abandon";
    // EVICT old items to make room for new items if space is tight.
    GuardPolicy["EVICT"] = "evict";
    return GuardPolicy;
}({});

});

parcelRegister("5tWx3", function(module, exports) {

$parcel$export(module.exports, "default", () => $7cd5196ce2007ee4$export$2e2bcd8739ae039);
const $7cd5196ce2007ee4$export$fc14cf6dcea0f8ed = 'NoIndexedDbError';
class $7cd5196ce2007ee4$export$2e2bcd8739ae039 extends Error {
    constructor(){
        super('window.indexeddb is undefined.');
        // Must reset the prototypes after calling super of builtin classes
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $7cd5196ce2007ee4$export$2e2bcd8739ae039.prototype);
        this.name = $7cd5196ce2007ee4$export$fc14cf6dcea0f8ed;
    }
}

});

parcelRegister("2oiOa", function(module, exports) {

$parcel$export(module.exports, "shouldIgnoreResilienceDbError", () => $87139c67bec8a68b$export$74101021e0969375);

var $3pkX4 = parcelRequire("3pkX4");

var $fKoyL = parcelRequire("fKoyL");

var $3HwLa = parcelRequire("3HwLa");
const $87139c67bec8a68b$export$74101021e0969375 = (error)=>{
    if (error && typeof error === 'object' && 'name' in error) {
        const errorWithName = error;
        return typeof errorWithName.name === 'string' && (errorWithName.name === (0, $3pkX4.AbandonWriteErrorName) || errorWithName.name === (0, $fKoyL.CallbackProcessingErrorName) || errorWithName.name === (0, $3HwLa.InvalidPolicyErrorName));
    }
    return false;
};

});
parcelRegister("3pkX4", function(module, exports) {

$parcel$export(module.exports, "AbandonWriteErrorName", () => $7d73589f9d57753a$export$ba95206613c96b28);
$parcel$export(module.exports, "default", () => $7d73589f9d57753a$export$2e2bcd8739ae039);
const $7d73589f9d57753a$export$ba95206613c96b28 = 'AbandonWriteError';
class $7d73589f9d57753a$export$2e2bcd8739ae039 extends Error {
    constructor(source){
        super(`Event Limit reached. Abandoning write to: ${source}`);
        // Must reset the prototypes after calling super of builtin classes
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $7d73589f9d57753a$export$2e2bcd8739ae039.prototype);
        this.name = $7d73589f9d57753a$export$ba95206613c96b28;
    }
}

});

parcelRegister("3HwLa", function(module, exports) {

$parcel$export(module.exports, "InvalidPolicyErrorName", () => $bbb2589fd5297db7$export$7e7aee9a953465ec);
$parcel$export(module.exports, "default", () => $bbb2589fd5297db7$export$2e2bcd8739ae039);
const $bbb2589fd5297db7$export$7e7aee9a953465ec = 'InvalidPolicyError';
class $bbb2589fd5297db7$export$2e2bcd8739ae039 extends Error {
    constructor(policy, method){
        super(`Method '${method}' cannot be called with policy '${policy}'.`);
        this.name = $bbb2589fd5297db7$export$7e7aee9a953465ec;
    }
}

});


parcelRegister("3q6DL", function(module, exports) {

$parcel$export(module.exports, "default", () => $0125edab3e8ecd13$export$2e2bcd8739ae039);

var $2A2TO = parcelRequire("2A2TO");

var $aUIZi = parcelRequire("aUIZi");

var $fKoyL = parcelRequire("fKoyL");
var $3HwLa = parcelRequire("3HwLa");
var $5tWx3 = parcelRequire("5tWx3");
var $2oiOa = parcelRequire("2oiOa");

var $cyn6r = parcelRequire("cyn6r");

var $iYeWv = parcelRequire("iYeWv");
class $0125edab3e8ecd13$export$2e2bcd8739ae039 {
    constructor(namespace, options = {}){
        this.startDB = async ()=>{
            return new Promise(async (resolve, reject)=>{
                if (typeof window !== 'undefined') {
                    const dbTimeout = window.setTimeout(()=>{
                        this.logger.warn('IndexedDB timed out.');
                        reject(new (0, $5tWx3.default)());
                    }, (0, $2A2TO.INDEXEDDB_TIMEOUT));
                    /*
				 * The database version number can never change.
				 * An upgrade transaction is limited to only one connection to the database.
				 * Once this is done, we cannot open any connections with older versions of the schema.
				 * https://www.w3.org/TR/IndexedDB/#upgrade-transaction-construct
				 *
				 * Due to the nature of how AWC is used (multiple tabs that are very long lived),
				 * we will not be able to run version upgrades via indexeddb.
				 *
				 * This does not mean we cant change what is stored in the tables,
				 * this limitation just prevents us from:
				 *   - Creating new ObjectStores in this database connection, and
				 *   - Creating new indexes on our ObjectStores
				 *
				 * Any upgrades we wish to run in the future will have to create a new database,
				 * and migrate all the data from older databases.
				 *
				 * This also means any migrations we make will have to be supported until we have evidence
				 * that no events are coming from old versions of the database.
				 * This may take a long time.
				 */ const request = window.indexedDB.open((0, $2A2TO.RESILIENCE_DB_NAME), 1);
                    request.onupgradeneeded = (event)=>{
                        if (event.oldVersion !== 0) throw new Error('We cannot upgrade the database. Do not do this.');
                        const db = request.result;
                        const store = db.createObjectStore((0, $2A2TO.RESILIENCE_STORE_NAME), {
                            keyPath: 'id'
                        });
                        store.createIndex((0, $2A2TO.TIME_TO_PROCESS_AFTER_INDEX), (0, $2A2TO.TIME_TO_PROCESS_AFTER_INDEX), {
                            unique: false
                        });
                        store.createIndex((0, $2A2TO.RETRY_INDEX), (0, $2A2TO.RETRY_INDEX), {
                            unique: false
                        });
                        store.createIndex((0, $2A2TO.TIME_ADDED_INDEX), (0, $2A2TO.TIME_ADDED_INDEX), {
                            unique: false
                        });
                        // Compound key index of product - timeAdded.
                        store.createIndex((0, $2A2TO.NAMESPACE_AND_TIME_ADDED_INDEX), [
                            'namespace',
                            'timeAdded'
                        ], {
                            unique: false
                        });
                    };
                    request.onerror = function() {
                        reject(new (0, $5tWx3.default)());
                    };
                    try {
                        await (0, $iYeWv.requestToPromise)(request);
                        return resolve(request.result);
                    } catch (error) {
                        this.logger.warn('IndexedDB failed to initialise.', error);
                        reject(new (0, $5tWx3.default)());
                    } finally{
                        window.clearTimeout(dbTimeout);
                    }
                } else {
                    this.logger.warn("IndexedDB failed to initialise. No 'window' object.");
                    reject(new (0, $5tWx3.default)());
                }
            });
        };
        this.addItem = async (item, options = {}, policy = (0, $2A2TO.GuardPolicy).ABANDON)=>{
            const { logger: logger, namespace: namespace } = this;
            const value = (0, $iYeWv.convertToItemWrapper)(item, namespace, options);
            const { objectStore: objectStore } = await this.getObjectStoreAndTransaction('readwrite');
            if (policy === (0, $2A2TO.GuardPolicy).IGNORE) throw new (0, $3HwLa.default)(policy, 'IndexedDbConnector#addItem');
            try {
                if (!value.namespace || value.namespace.length === 0 || typeof value.namespace !== 'string') throw new Error('Namespace not specified');
                // Making space for 1 event, if required.
                const bulkAddResult = await this.globalEventLimitGuard.insertItems(objectStore, [
                    value
                ], policy);
                if (bulkAddResult.items.length === 1) return {
                    item: bulkAddResult.items[0],
                    numberOfEvictedItems: bulkAddResult.numberOfEvictedItems
                };
                // Should never happen as the Policy and EventCountGuard should cause another pathway
                throw new Error(`Incorrect number of items added. Expected: 1, got: ${bulkAddResult.items.length}`);
            } catch (error) {
                if ((0, $2oiOa.shouldIgnoreResilienceDbError)(error)) throw error;
                logger.log('Failed to add item to table', error);
                throw new Error('Request to add item to table failed');
            }
        };
        this.bulkAddItem = async (itemOptions, policy = (0, $2A2TO.GuardPolicy).ABANDON)=>{
            const { logger: logger, namespace: namespace } = this;
            const items = itemOptions.map(({ item: item, ...options })=>(0, $iYeWv.convertToItemWrapper)(item, namespace, options));
            const { objectStore: objectStore } = await this.getObjectStoreAndTransaction('readwrite');
            try {
                return await this.globalEventLimitGuard.insertItems(objectStore, items, policy);
            } catch (error) {
                if ((0, $2oiOa.shouldIgnoreResilienceDbError)(error)) throw error;
                logger.log('Failed to add item to table', error);
                throw new Error('Request to add item to table failed');
            }
        };
        this.getItems = async (count = (0, $aUIZi.GET_ITEM_COUNT))=>{
            const fixedCount = count > 0 ? count : (0, $aUIZi.GET_ITEM_COUNT);
            const { logger: logger } = this;
            const maxAttempts = this.options.maxAttempts;
            const { transaction: transaction, objectStore: objectStore } = await this.getObjectStoreAndTransaction('readwrite');
            const timeIndex = objectStore.index((0, $2A2TO.TIME_TO_PROCESS_AFTER_INDEX));
            const upperBoundOpenKeyRange = IDBKeyRange.upperBound(Date.now());
            const request = timeIndex.openCursor(upperBoundOpenKeyRange);
            const getResult = await new Promise(async (resolve, reject)=>{
                const items = [];
                let numberOfDeletedItems = 0;
                request.onerror = (error)=>{
                    logger.error('Failed to open cursor:', error);
                    reject('Failed to open cursor');
                };
                // Requests for Cursors call onsuccess multiple times and cannot be converted to promises
                request.onsuccess = (event)=>{
                    const cursor = event.target.result;
                    if (cursor) {
                        // Prevent mutation of the value we are returning
                        const value = {
                            ...cursor.value
                        };
                        items.push(value);
                        // Mutations seem to be required for testing indexeddb library
                        const updatedValue = cursor.value;
                        updatedValue.retryAttempts += 1;
                        updatedValue.timeToBeProcessedAfter = Date.now() + (0, $aUIZi.VISIBILITY_TIMEOUT);
                        if (updatedValue.retryAttempts >= maxAttempts) {
                            ++numberOfDeletedItems;
                            const request = cursor.delete();
                            (0, $iYeWv.monitorErrorsOnRequest)(request, logger);
                        } else {
                            const request = cursor.update(updatedValue);
                            (0, $iYeWv.monitorErrorsOnRequest)(request, logger);
                        }
                        if (items.length < fixedCount) cursor.continue();
                        else resolve({
                            items: items,
                            numberOfDeletedItems: numberOfDeletedItems
                        });
                    } else resolve({
                        items: items,
                        numberOfDeletedItems: numberOfDeletedItems
                    });
                };
            });
            await (0, $iYeWv.commitTransaction)(transaction, this.logger);
            return getResult;
        };
        this.deleteItems = async (itemIds)=>{
            const { transaction: transaction, objectStore: objectStore } = await this.getObjectStoreAndTransaction('readwrite');
            try {
                const deletePromises = itemIds.map((id)=>this.deleteItem(objectStore, id));
                await (0, $iYeWv.commitTransaction)(transaction, this.logger);
                await Promise.all(deletePromises);
            } catch (error) {
                this.logger.warn('Failed to delete items from indexeddb.', error);
                throw error;
            }
        };
        this.getItemCount = async ()=>{
            const { transaction: transaction, objectStore: objectStore } = await this.getObjectStoreAndTransaction('readonly');
            const timeIndex = objectStore.index((0, $2A2TO.TIME_TO_PROCESS_AFTER_INDEX));
            const upperBoundOpenKeyRange = IDBKeyRange.upperBound(Date.now());
            const request = timeIndex.count(upperBoundOpenKeyRange);
            const event = await (0, $iYeWv.requestToPromise)(request);
            await (0, $iYeWv.commitTransaction)(transaction, this.logger);
            return event.target.result;
        };
        this.processItems = async (processFn, count = (0, $aUIZi.GET_ITEM_COUNT))=>{
            const { items: items, ...partialResult } = await this.getItems(count);
            try {
                const result = await processFn(items, partialResult);
                const itemIds = items.map((item)=>item.id);
                // We should not await this delete as a rejected promise would get caught by the catch statement
                await this.deleteItems(itemIds);
                return result;
            } catch (error) {
                // Eventually we will need a intermediate class to catch all errors but we should ignore this error
                // This allows libraries beneath to distinguish between a success or failure in processing to update schedulers or anything else
                // To provide back off or any other mechanism to allow what ever is cauing the errors to recover
                throw new (0, $fKoyL.default)(error);
            }
        };
        this.deleteItem = async (objectStore, id)=>{
            const { logger: logger } = this;
            try {
                await (0, $iYeWv.requestToPromise)(objectStore.delete(id));
            } catch (error) {
                logger.error('Failed to delete item:', id, error);
                throw error;
            }
        };
        this.getObjectStoreAndTransaction = async (mode)=>{
            const transaction = (await this.db).transaction((0, $2A2TO.RESILIENCE_STORE_NAME), mode);
            const objectStore = transaction.objectStore((0, $2A2TO.RESILIENCE_STORE_NAME));
            return {
                transaction: transaction,
                objectStore: objectStore
            };
        };
        this.options = (0, $iYeWv.createOptionsWithDefaults)(options);
        this.namespace = namespace;
        this.logger = this.options.logger;
        if (!window.indexedDB) throw new (0, $5tWx3.default)();
        this.db = this.startDB();
        // We just swallow any errors as we know that these are intermittent errors
        // when switching from indexeddb -> localStorage
        this.db.catch(()=>{});
        /**
		 *
		 * This class will enforce the number of analytics events we can store in our IndexedDB object store
		 * if asked before adding items to the object store.
		 */ this.globalEventLimitGuard = new (0, $cyn6r.default)(this.options.maxEventLimit, this.namespace, this.logger, this.deleteItem);
    }
    storeType() {
        return (0, $2A2TO.StoreType).INDEXEDDB;
    }
}

});
parcelRegister("aUIZi", function(module, exports) {

$parcel$export(module.exports, "GET_ITEM_COUNT", () => $d15942d15e8d8a11$export$b6df3d334cec060f);
$parcel$export(module.exports, "VISIBILITY_TIMEOUT", () => $d15942d15e8d8a11$export$14ef152a03a4b6ee);
$parcel$export(module.exports, "MAX_ATTEMPTS", () => $d15942d15e8d8a11$export$da9ab7b2fd5998e8);
$parcel$export(module.exports, "EVENT_COUNT_LIMIT", () => $d15942d15e8d8a11$export$1188664dfff364c8);
const $d15942d15e8d8a11$export$b6df3d334cec060f = 7;
const $d15942d15e8d8a11$export$14ef152a03a4b6ee = 60000;
const $d15942d15e8d8a11$export$da9ab7b2fd5998e8 = 10;
const $d15942d15e8d8a11$export$1188664dfff364c8 = 5000;

});

parcelRegister("cyn6r", function(module, exports) {

$parcel$export(module.exports, "default", () => $31b27e310e15cd9a$export$2e2bcd8739ae039);

var $2A2TO = parcelRequire("2A2TO");

var $3pkX4 = parcelRequire("3pkX4");

var $iYeWv = parcelRequire("iYeWv");
class $31b27e310e15cd9a$export$2e2bcd8739ae039 {
    constructor(eventLimit, namespace, logger, deleteItemHandler){
        /**
	 * This query fetches the oldest events currently stored in AWC IndexedDb object store
	 * and deletes them sequentially
	 */ this.deleteOldestNEvents = async (objectStore, count)=>{
            const productTimeAddedIndex = objectStore.index((0, $2A2TO.NAMESPACE_AND_TIME_ADDED_INDEX));
            const keyRangeValues = IDBKeyRange.bound([
                this.namespace,
                0
            ], [
                this.namespace,
                Date.now()
            ]);
            const getAllRequest = productTimeAddedIndex.getAllKeys(keyRangeValues, count);
            const event = await (0, $iYeWv.requestToPromise)(getAllRequest);
            const result = event?.target?.result;
            // Adding extra safety
            if (result && Array.isArray(result) && result.length > 0) try {
                const deletePromises = result.map((item)=>this.deleteItemHandler(objectStore, item));
                await Promise.all(deletePromises);
            } catch (error) {
                this.logger.warn('Failed to delete items from indexeddb.', error);
                throw error;
            }
        };
        if (eventLimit > 0) this.eventLimit = eventLimit;
        else throw Error('Event Limit has to be set higher than 1');
        this.namespace = namespace;
        this.logger = logger;
        this.deleteItemHandler = deleteItemHandler;
    }
    /**
	 * This function checks the number of events currently in AWC IndexedDB object store and if necessary,
	 * will evict the oldest events in favour of the events we want to add.
	 *
	 * The indexed is treated as effectively: partitioned by product and sorted by timeAdded.
	 *
	 * This function can be re-used when the bulk add functionality is added in IndexedDbConnector.
	 *
	 * @param countOfEventsToAdd - The number of events we are proposing to add.
	 */ async insertItems(objectStore, items, policy = (0, $2A2TO.GuardPolicy).ABANDON) {
        const itemsToAdd = [
            ...items
        ];
        let numberOfEvictedItems = 0;
        switch(policy){
            case (0, $2A2TO.GuardPolicy).ABANDON:
                await this.throwIfNotEnoughSpace(objectStore, items.length);
                break;
            case (0, $2A2TO.GuardPolicy).EVICT:
                numberOfEvictedItems = await this.evictIfNotEnoughSpace(objectStore, items.length);
                break;
            case (0, $2A2TO.GuardPolicy).IGNORE:
                // Removed items from `itemsToAdd` if there is insufficient space
                await this.calculateHowManyEventsWeCanAdd(objectStore, itemsToAdd);
                break;
        }
        const promises = itemsToAdd.map((item)=>(0, $iYeWv.requestToPromise)(objectStore.add(item)));
        await Promise.all(promises);
        await (0, $iYeWv.commitTransaction)(objectStore.transaction, this.logger);
        return {
            items: itemsToAdd,
            numberOfEvictedItems: numberOfEvictedItems
        };
    }
    async throwIfNotEnoughSpace(objectStore, requiredSpace) {
        const freeSpace = await this.calculateFreeSpace(objectStore);
        if (freeSpace < requiredSpace) throw new (0, $3pkX4.default)(`Not enough space in IndexedDb. Needed ${requiredSpace} but only had ${freeSpace}`);
    }
    async evictIfNotEnoughSpace(objectStore, requiredSpace) {
        const freeSpace = await this.calculateFreeSpace(objectStore);
        if (freeSpace < requiredSpace) {
            const extraSpace = requiredSpace - freeSpace;
            await this.deleteOldestNEvents(objectStore, extraSpace);
            return extraSpace;
        }
        return 0;
    }
    async calculateHowManyEventsWeCanAdd(objectStore, items) {
        const freeSpace = await this.calculateFreeSpace(objectStore);
        if (freeSpace < items.length) {
            const numberOfItemsToRemove = items.length - freeSpace;
            const start = items.length - numberOfItemsToRemove;
            items.splice(start, numberOfItemsToRemove);
        }
    }
    async calculateFreeSpace(objectStore) {
        const numberOfEventsInDb = await this.getCountofEventsInObjectStore(objectStore);
        return this.eventLimit - numberOfEventsInDb;
    }
    /**
	 * This query returns the count of items held in AWC IndexedDB object store per product.
	 */ async getCountofEventsInObjectStore(objectStore) {
        const productTimeAddedIndex = objectStore.index((0, $2A2TO.NAMESPACE_AND_TIME_ADDED_INDEX));
        const keyRangeValues = IDBKeyRange.bound([
            this.namespace,
            0
        ], [
            this.namespace,
            Date.now()
        ]);
        const request = productTimeAddedIndex.count(keyRangeValues);
        const event = await (0, $iYeWv.requestToPromise)(request);
        return event.target.result;
    }
}

});
parcelRegister("iYeWv", function(module, exports) {

$parcel$export(module.exports, "convertToItemWrapper", () => $26ace48ea3baf04e$export$aec476f33d77be11);
$parcel$export(module.exports, "createOptionsWithDefaults", () => $26ace48ea3baf04e$export$ddc6718318090f71);
$parcel$export(module.exports, "requestToPromise", () => $26ace48ea3baf04e$export$85ceed0783e42041);
$parcel$export(module.exports, "commitTransaction", () => $26ace48ea3baf04e$export$feab8418f018df89);
$parcel$export(module.exports, "monitorErrorsOnRequest", () => $26ace48ea3baf04e$export$342d941b6f724995);

var $bXrHm = parcelRequire("bXrHm");

var $aUIZi = parcelRequire("aUIZi");
const $26ace48ea3baf04e$export$aec476f33d77be11 = (item, namespace, { id: id, retryAttempts: retryAttempts, timeToProcessOffset: timeToProcessOffset })=>({
        item: item,
        id: id || (0, (/*@__PURE__*/$parcel$interopDefault($bXrHm)))(),
        retryAttempts: retryAttempts || 0,
        timeToBeProcessedAfter: Date.now() + (timeToProcessOffset || 0),
        namespace: namespace,
        timeAdded: Date.now()
    });
const $26ace48ea3baf04e$export$ddc6718318090f71 = (options)=>({
        logger: options.logger || console,
        useMemory: options.useMemory || false,
        maxAttempts: options.maxAttempts || (0, $aUIZi.MAX_ATTEMPTS),
        // This is so that we can customise `maxEventLimit`, primarily for testing.
        maxEventLimit: options.maxEventLimit || (0, $aUIZi.EVENT_COUNT_LIMIT)
    });
const $26ace48ea3baf04e$export$85ceed0783e42041 = (request)=>{
    return new Promise((resolve, reject)=>{
        request.onsuccess = (event)=>{
            resolve(event);
        };
        request.onerror = (event)=>{
            reject(event);
        };
    });
};
const $26ace48ea3baf04e$export$2a5213bce1720b42 = (transaction)=>{
    return new Promise((resolve, reject)=>{
        // We will have to see how much cost there is to waiting for the transaction to complete in the real world.
        // In theory in some cases we could return as soon as the request is complete and
        // just monitor errors on transactions with the logger.
        // This maybe more of an issue in Safari and other older browsers where commit isnt available
        // and we would have to wait for the transaction to complete itself.
        transaction.oncomplete = ()=>{
            resolve();
        };
        transaction.onerror = (event)=>{
            reject(event);
        };
        transaction.onabort = (event)=>{
            reject(event);
        };
    });
};
const $26ace48ea3baf04e$export$feab8418f018df89 = (transaction, logger)=>{
    try {
        if (typeof transaction.commit === 'function') transaction.commit();
    } catch (error) {
        logger.error('Failed to force commit transaction:', error);
        throw error;
    }
    return $26ace48ea3baf04e$export$2a5213bce1720b42(transaction);
};
const $26ace48ea3baf04e$export$342d941b6f724995 = (request, logger)=>{
    request.onerror = (event)=>{
        logger.warn('Error thrown from request:', event);
    };
};

});



parcelRegister("lGyYf", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d75680abe8fa453$export$2e2bcd8739ae039);

var $2A2TO = parcelRequire("2A2TO");

var $aUIZi = parcelRequire("aUIZi");

var $fKoyL = parcelRequire("fKoyL");
var $3HwLa = parcelRequire("3HwLa");

var $fb8pT = parcelRequire("fb8pT");

var $iYeWv = parcelRequire("iYeWv");
class $0d75680abe8fa453$export$2e2bcd8739ae039 {
    constructor(namespace, options = {}){
        this.namespace = namespace;
        this.memoryStore = [];
        this.options = (0, $iYeWv.createOptionsWithDefaults)(options);
        /**
		 * This class will enforce the number of analytics events we can store in our MemoryDb
		 */ this.globalEventLimitGuard = new (0, $fb8pT.default)(this.options.maxEventLimit, {
            addItems: this.addItems.bind(this),
            getItemCount: this.getItemCount.bind(this),
            evictEventsIfNeeded: this.evictEventsIfNeeded.bind(this)
        });
    }
    /**
	 * This method is used mainly to write new events to MemoryDB and uses the MEMORY_DB_GUARD_POLICY.EVICT_OLDEST_IF_LIMIT_EXECEEDED policy
	 * to removes oldest events when limit is reached.
	 */ async addItem(item, options = {}, policy = (0, $2A2TO.GuardPolicy).ABANDON) {
        if (policy === (0, $2A2TO.GuardPolicy).IGNORE) throw new (0, $3HwLa.default)(policy, 'IndexedDbConnector#addItem');
        const storedValue = (0, $iYeWv.convertToItemWrapper)(item, this.namespace, options);
        // Delegated responsiblity to event limit guard to insert to memory stored
        const bulkAddItemsResult = await this.globalEventLimitGuard.insertItemsToMemoryStore([
            storedValue
        ], policy);
        return Promise.resolve({
            item: bulkAddItemsResult.items[0],
            numberOfEvictedItems: bulkAddItemsResult.numberOfEvictedItems
        });
    }
    bulkAddItem(itemOptions, policy = (0, $2A2TO.GuardPolicy).ABANDON) {
        const items = itemOptions.map(({ item: item, ...addOptions })=>(0, $iYeWv.convertToItemWrapper)(item, this.namespace, addOptions));
        return this.bulkAddItemWrapperType(items, policy);
    }
    /**
	 * This method is used mainly to write events to MemoryDB when unknown errors are thrown from IndexedDB.
	 */ bulkAddItemWrapperType(items, policy = (0, $2A2TO.GuardPolicy).ABANDON) {
        return Promise.resolve(this.globalEventLimitGuard.insertItemsToMemoryStore(items, policy));
    }
    getItems(count = (0, $aUIZi.GET_ITEM_COUNT)) {
        return Promise.resolve(this.synchronousGetItems(count));
    }
    synchronousGetItems(count = (0, $aUIZi.GET_ITEM_COUNT)) {
        const fixedCount = count > 0 ? count : (0, $aUIZi.GET_ITEM_COUNT);
        const now = Date.now();
        const wrappedItems = [];
        const itemsToRemove = [];
        for (let wrappedItem of this.memoryStore){
            if (wrappedItem.timeToBeProcessedAfter <= now) {
                wrappedItems.push({
                    ...wrappedItem
                });
                // Mutates the item in the memoryStore array, but not whats inside of wrappedItems
                wrappedItem.timeToBeProcessedAfter += (0, $aUIZi.VISIBILITY_TIMEOUT);
                wrappedItem.retryAttempts += 1;
                if (wrappedItem.retryAttempts >= this.options.maxAttempts) itemsToRemove.push(wrappedItem);
            }
            if (wrappedItems.length >= fixedCount) break;
        }
        itemsToRemove.forEach((item)=>{
            const index = this.memoryStore.indexOf(item);
            this.memoryStore.splice(index, 1);
        });
        return {
            items: wrappedItems,
            numberOfDeletedItems: itemsToRemove.length
        };
    }
    deleteItems(itemIds) {
        this.memoryStore = this.memoryStore.filter((item)=>!itemIds.includes(item.id));
        return Promise.resolve(void 0);
    }
    getItemCount() {
        const now = Date.now();
        const count = this.memoryStore.filter((item)=>item.timeToBeProcessedAfter <= now).length;
        return Promise.resolve(count);
    }
    async processItems(processFn, count) {
        const { items: items, ...partialGetResult } = this.synchronousGetItems(count);
        const itemIds = items.map((i)=>i.id);
        try {
            const result = await processFn(items, partialGetResult);
            await this.deleteItems(itemIds);
            return result;
        } catch (error) {
            throw new (0, $fKoyL.default)(error);
        }
    }
    storeType() {
        return (0, $2A2TO.StoreType).MEMORY;
    }
    /**
	 * This function is adding items to the tail of the memoryStore and as it adds new items it keeps the
	 * memory store sorted by timeAdded property. This makes evictions easier and adding elements to
	 * memoryStore much faster.
	 *
	 * @param itemsToAdd
	 */ addItems(itemsToAdd) {
        this.memoryStore.push(...itemsToAdd);
        // Sorting everytime, intentionally.
        this.memoryStore.sort(function(a, b) {
            return a.timeAdded - b.timeAdded;
        });
    }
    /**
	 * This function checks the number of events currently in AWC MemoryDb and if necessary,
	 * will evict the oldest events in favour of the events we want to add.
	 *
	 * @param countOfEventsToAdd - The number of events we are proposing to add.
	 */ evictEventsIfNeeded(eventLimit) {
        const numberOfEventsInDb = this.memoryStore.length;
        // The number of analytics events currently in MemoryDb and
        // the Z events we are proposing to add will exceed our event count limit.
        if (numberOfEventsInDb > eventLimit) {
            const m = numberOfEventsInDb - eventLimit;
            // Removing oldest M events
            this.memoryStore.splice(0, m);
            return m;
        }
        return 0;
    }
}

});
parcelRegister("fb8pT", function(module, exports) {

$parcel$export(module.exports, "default", () => $afe04ff9e61a40bc$export$2e2bcd8739ae039);

var $2A2TO = parcelRequire("2A2TO");

var $3pkX4 = parcelRequire("3pkX4");
class $afe04ff9e61a40bc$export$2e2bcd8739ae039 {
    constructor(eventLimit, memoryItemHandlers){
        /**
	 * Unlike IndexedDb, we cannot take advantage of any index. So we are,
	 * treating the memory store as a sorted set when adding items.
	 */ this.insertItemsToMemoryStore = (itemsToAdd, policy)=>{
            switch(policy){
                case (0, $2A2TO.GuardPolicy).ABANDON:
                    return this.handleAbandonIfLimitWillExceedPolicy(itemsToAdd);
                case (0, $2A2TO.GuardPolicy).EVICT:
                    return Promise.resolve(this.handleEvictOldestIfLimitExceededPolicy(itemsToAdd));
                case (0, $2A2TO.GuardPolicy).IGNORE:
                    return this.handleAddAsManyAsPossible(itemsToAdd);
            }
        };
        if (eventLimit > 0) this.eventLimit = eventLimit;
        else throw Error('Event Limit has to be set higher than 1');
        this.memoryItemHandlers = memoryItemHandlers;
    }
    async handleAbandonIfLimitWillExceedPolicy(itemsToAdd) {
        const itemCount = await this.memoryItemHandlers.getItemCount();
        if (itemCount + itemsToAdd.length > this.eventLimit) throw new (0, $3pkX4.default)((0, $2A2TO.StoreType).MEMORY);
        this.memoryItemHandlers.addItems(itemsToAdd);
        return {
            items: itemsToAdd,
            numberOfEvictedItems: 0
        };
    }
    handleEvictOldestIfLimitExceededPolicy(itemsToAdd) {
        this.memoryItemHandlers.addItems(itemsToAdd);
        const numberOfEvictedItems = this.memoryItemHandlers.evictEventsIfNeeded(this.eventLimit);
        return {
            items: itemsToAdd,
            numberOfEvictedItems: numberOfEvictedItems
        };
    }
    async handleAddAsManyAsPossible(itemsToAdd) {
        const freeSpace = this.eventLimit - await this.memoryItemHandlers.getItemCount();
        const partialEventsToAdd = freeSpace > itemsToAdd.length ? itemsToAdd : itemsToAdd.slice(0, freeSpace);
        this.memoryItemHandlers.addItems(partialEventsToAdd);
        return {
            items: partialEventsToAdd,
            numberOfEvictedItems: 0
        };
    }
}

});




parcelRegister("6xafg", function(module, exports) {

$parcel$export(module.exports, "default", () => $36af94c5b8051ee1$export$2e2bcd8739ae039);

var $ePz85 = parcelRequire("ePz85");
class $36af94c5b8051ee1$export$4b62ee5120ab50a8 {
    addToItemsDiscardedByRetryCounter(numberOfDeletedEvents = 1) {
        this.itemsDiscardedByRetry += numberOfDeletedEvents;
    }
    addToEventCount() {
        this.eventCount++;
    }
    addToItemsDiscardedByOverflowCounter(numberOfDeletedEvents = 1) {
        this.itemsDiscardedByOverflow += numberOfDeletedEvents;
    }
    setResilienceMechanism(mechanism) {
        this.resilienceMechanism = mechanism;
    }
    /* <Localstorage specific> */ addToReclaimMetrics(reclaimMetrics) {
        this.localstorageNumberOfFullReclaims += reclaimMetrics.fullReclaims;
        this.localstorageNumberOfPartialReclaims += reclaimMetrics.partialReclaims;
        this.localstorageNumberOfFailedReclaims += reclaimMetrics.failedReclaims;
    }
    addToPurgedQueuesMetrics(numberOfQueuesPurged) {
        this.localstorageNumberOfQueuesPurged += numberOfQueuesPurged;
    }
    /* </Localstorage specific> */ subtractFromMetrics(sentMetrics) {
        this.itemsDiscardedByRetry = this.subtractFromCount(this.itemsDiscardedByRetry, sentMetrics.itemsDiscardedByRetry);
        this.eventCount = this.subtractFromCount(this.eventCount, sentMetrics.eventCount);
        this.itemsDiscardedByOverflow = this.subtractFromCount(this.itemsDiscardedByOverflow, sentMetrics.itemsDiscardedByOverflow);
        // Localstorage specific
        this.localstorageNumberOfFullReclaims = this.subtractFromCount(this.localstorageNumberOfFullReclaims, sentMetrics.fullReclaims);
        this.localstorageNumberOfPartialReclaims = this.subtractFromCount(this.localstorageNumberOfPartialReclaims, sentMetrics.partialReclaims);
        this.localstorageNumberOfFailedReclaims = this.subtractFromCount(this.localstorageNumberOfFailedReclaims, sentMetrics.failedReclaims);
        this.localstorageNumberOfQueuesPurged = this.subtractFromCount(this.localstorageNumberOfQueuesPurged, sentMetrics.localstorageQueuesPurged);
    }
    subtractFromCount(count, subtract) {
        return Math.max(count - (subtract || 0), 0);
    }
    getMetricsPayload() {
        return {
            itemsDiscardedByRetry: this.itemsDiscardedByRetry,
            eventCount: this.eventCount,
            itemsDiscardedByOverflow: this.itemsDiscardedByOverflow,
            resilienceMechanism: this.resilienceMechanism,
            // Localstorage specific
            localstorageQueuesPurged: this.localstorageNumberOfQueuesPurged,
            fullReclaims: this.localstorageNumberOfFullReclaims,
            partialReclaims: this.localstorageNumberOfPartialReclaims,
            failedReclaims: this.localstorageNumberOfFailedReclaims
        };
    }
    constructor(){
        // Number of events discarded due to exceeding retry limits.
        this.itemsDiscardedByRetry = 0;
        // Number of events created by the product in current tab.
        this.eventCount = 0;
        // Number of events discarded due to reaching queue max size.
        this.itemsDiscardedByOverflow = 0;
        // Will be used in the future when we get more resilience mechanisms
        this.resilienceMechanism = (0, $ePz85.ResilienceMechanism).INDEXEDDB;
        /* --- LocalStorage specific metrics --- */ // Emitted by purgeOrphanedQueues to tell us how many queues we have had to clean up due to
        // https://github.com/segmentio/localstorage-retry/pull/17
        this.localstorageNumberOfQueuesPurged = 0;
        // Emitted by reclaimEvents to tell us how many queues were seen in the process of reclaim.
        // We will only emit metrics for queues that are not currently being maintained (i.e. `ack` is not being updated).
        // Queue was found, all events removed and put into resilienceDb.
        this.localstorageNumberOfFullReclaims = 0;
        // Queue was found but not all events were able to be put into resilienceDb.
        this.localstorageNumberOfPartialReclaims = 0;
        // Reclaim failed for a queue and reclaim was abandonded.
        this.localstorageNumberOfFailedReclaims = 0;
    }
}
let $36af94c5b8051ee1$var$cachedMetricsClient = null;
var $36af94c5b8051ee1$export$2e2bcd8739ae039 = ()=>{
    if (!$36af94c5b8051ee1$var$cachedMetricsClient) $36af94c5b8051ee1$var$cachedMetricsClient = new $36af94c5b8051ee1$export$4b62ee5120ab50a8();
    return $36af94c5b8051ee1$var$cachedMetricsClient;
};

});
parcelRegister("ePz85", function(module, exports) {

$parcel$export(module.exports, "ResilienceMechanism", () => $d9ff0adc42a1d4e7$export$c75161629e3ec34e);
$parcel$export(module.exports, "NetworkStatusEnum", () => $d9ff0adc42a1d4e7$export$ee138fa712d11b84);
var $d9ff0adc42a1d4e7$export$c75161629e3ec34e = /*#__PURE__*/ function(ResilienceMechanism) {
    ResilienceMechanism["INDEXEDDB"] = "indexeddb";
    ResilienceMechanism["MEMORY"] = "memory";
    return ResilienceMechanism;
}({});
var $d9ff0adc42a1d4e7$export$ee138fa712d11b84 = /*#__PURE__*/ function(NetworkStatusEnum) {
    NetworkStatusEnum[NetworkStatusEnum["ONLINE"] = 0] = "ONLINE";
    NetworkStatusEnum[NetworkStatusEnum["OFFLINE"] = 1] = "OFFLINE";
    return NetworkStatusEnum;
}({});

});


parcelRegister("1LZzU", function(module, exports) {

$parcel$export(module.exports, "default", () => $d93f5ad08a797773$export$2e2bcd8739ae039);

var $ePz85 = parcelRequire("ePz85");
class $d93f5ad08a797773$export$2e2bcd8739ae039 {
    constructor(networkChangeCallback){
        this._networkChangeCallback = networkChangeCallback;
        if (typeof window !== 'undefined') {
            window.addEventListener('offline', ()=>this._networkChangeCallback((0, $ePz85.NetworkStatusEnum).OFFLINE));
            window.addEventListener('online', ()=>this._networkChangeCallback((0, $ePz85.NetworkStatusEnum).ONLINE));
        }
    }
    removeListeners() {
        if (typeof window !== 'undefined') {
            window.addEventListener('offline', ()=>this._networkChangeCallback((0, $ePz85.NetworkStatusEnum).OFFLINE));
            window.addEventListener('online', ()=>this._networkChangeCallback((0, $ePz85.NetworkStatusEnum).ONLINE));
        }
    }
    getNetworkStatus() {
        if (window.navigator.onLine) return (0, $ePz85.NetworkStatusEnum).ONLINE;
        return (0, $ePz85.NetworkStatusEnum).OFFLINE;
    }
}

});

parcelRegister("38r8F", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0bd718b1da09b89$export$2e2bcd8739ae039);

var $dL792 = parcelRequire("dL792");

var $aRK7K = parcelRequire("aRK7K");
const $c0bd718b1da09b89$var$SCHEDULER_OPTIONS_DEFAULT = {
    minRetryDelay: 1000,
    maxRetryDelay: 30000,
    backoffFactor: 2,
    backoffJitterPercentage: 0,
    waitInterval: 500,
    callbackTimeoutPeriod: 5000
};
var $c0bd718b1da09b89$export$8bb92baee001fc60 = /*#__PURE__*/ function(QueuedScheduleTypes) {
    QueuedScheduleTypes[QueuedScheduleTypes["NONE"] = 0] = "NONE";
    QueuedScheduleTypes[QueuedScheduleTypes["IMMEDIATE"] = 1] = "IMMEDIATE";
    QueuedScheduleTypes[QueuedScheduleTypes["WAIT"] = 2] = "WAIT";
    return QueuedScheduleTypes;
}({});
class $c0bd718b1da09b89$export$2e2bcd8739ae039 {
    constructor(retryOptions, callback){
        this.schedule = ({ immediate: immediate } = {})=>{
            if (typeof window === 'undefined') return;
            if (this.operationInFlight) {
                if (immediate) this.queuedSchedule = 1;
                else if (this.queuedSchedule !== 1) this.queuedSchedule = 2;
            // Only run immediately if we have no failures
            } else if ((immediate || this.options.waitInterval <= 0) && this.failureCount === 0) {
                this.clearTimeout();
                this.run();
            // Backoff
            } else if (this.failureCount > 0 && this.scheduledTimeout === null) this.scheduledTimeout = window.setTimeout(this.run, this.calculateBackoff());
            else if (this.scheduledTimeout === null) this.scheduledTimeout = window.setTimeout(this.run, this.options.waitInterval);
        };
        this.stop = ()=>{
            this.clearTimeout();
            this.queuedSchedule = 0;
        };
        this.getFailureCount = ()=>this.failureCount;
        this.getCallbackStatus = ()=>{
            return this.callbackTimer.getCallbackStatus();
        };
        this.clearTimeout = ()=>{
            if (typeof window !== 'undefined' && this.scheduledTimeout !== null) {
                window.clearTimeout(this.scheduledTimeout);
                this.scheduledTimeout = null;
            }
        };
        this.run = ()=>{
            this.operationInFlight = true;
            this.clearTimeout();
            try {
                this.callbackTimer.executeCallbackWithTimeout(// callback to execute
                this.callback, // when callback completes, call this function
                this.done, // on timeout, do this instead
                ()=>this.done((0, $aRK7K.DoneState).ERROR));
            } catch (err) {
                this.done(err);
            }
        };
        this.done = (state)=>{
            this.operationInFlight = false;
            if (state === (0, $aRK7K.DoneState).ERROR || this.callbackTimer.getCallbackStatus() === (0, $dL792.CallbackStatus).TIMED_OUT) {
                this.failureCount++;
                this.clearTimeout();
            } else if (state === (0, $aRK7K.DoneState).SUCCESS) this.failureCount = 0;
            this.processQueuedSchedule();
        };
        this.processQueuedSchedule = ()=>{
            if (this.queuedSchedule !== 0) {
                const immediate = this.queuedSchedule === 1;
                this.queuedSchedule = 0;
                this.schedule({
                    immediate: immediate
                });
            } else if (this.failureCount > 0) // This will schedule tasks when this._done was called with a truthy value
            // For example, when this.callback(this._done) was not called within
            // this.callbackTimeoutPeriod
            this.schedule();
        };
        this.calculateBackoff = ()=>{
            const { minRetryDelay: minRetryDelay, maxRetryDelay: maxRetryDelay, backoffFactor: backoffFactor, backoffJitterPercentage: backoffJitterPercentage } = this.options;
            let ms = minRetryDelay * backoffFactor ** this.failureCount;
            if (backoffJitterPercentage) {
                const rand = Math.random();
                const deviation = Math.floor(rand * backoffJitterPercentage * ms);
                if (Math.floor(rand * 10) < 5) ms -= deviation;
                else ms += deviation;
            }
            return Number(Math.min(ms, maxRetryDelay).toPrecision(1));
        };
        this.options = {
            minRetryDelay: retryOptions.minRetryDelay || $c0bd718b1da09b89$var$SCHEDULER_OPTIONS_DEFAULT.minRetryDelay,
            maxRetryDelay: retryOptions.maxRetryDelay || $c0bd718b1da09b89$var$SCHEDULER_OPTIONS_DEFAULT.maxRetryDelay,
            backoffFactor: retryOptions.backoffFactor || $c0bd718b1da09b89$var$SCHEDULER_OPTIONS_DEFAULT.backoffFactor,
            backoffJitterPercentage: retryOptions.backoffJitterPercentage || $c0bd718b1da09b89$var$SCHEDULER_OPTIONS_DEFAULT.backoffJitterPercentage,
            waitInterval: retryOptions.waitInterval !== undefined ? retryOptions.waitInterval : $c0bd718b1da09b89$var$SCHEDULER_OPTIONS_DEFAULT.waitInterval,
            callbackTimeoutPeriod: retryOptions.callbackTimeoutPeriod || $c0bd718b1da09b89$var$SCHEDULER_OPTIONS_DEFAULT.callbackTimeoutPeriod
        };
        this.scheduledTimeout = null;
        this.failureCount = 0;
        this.callback = callback;
        this.operationInFlight = false;
        this.queuedSchedule = 0;
        this.callbackTimer = new (0, $dL792.CallbackWithTimeout)(this.options.callbackTimeoutPeriod);
    }
}

});
parcelRegister("dL792", function(module, exports) {

$parcel$export(module.exports, "CallbackStatus", () => $5dc3863f86ce6ade$export$ef3353088fca369c);
$parcel$export(module.exports, "CallbackWithTimeout", () => $5dc3863f86ce6ade$export$590a718599f8f8b3);
var $5dc3863f86ce6ade$export$ef3353088fca369c = /*#__PURE__*/ function(CallbackStatus) {
    CallbackStatus["IDLE"] = "idle";
    CallbackStatus["RUNNING"] = "running";
    CallbackStatus["COMPLETED"] = "completed";
    CallbackStatus["TIMED_OUT"] = "timedOut";
    return CallbackStatus;
}({});
var $5dc3863f86ce6ade$export$def7d978353eaa0 = /*#__PURE__*/ function(CallbackEvent) {
    CallbackEvent["EXECUTE"] = "execute";
    CallbackEvent["COMPLETE"] = "complete";
    CallbackEvent["TIMEOUT"] = "timeout";
    return CallbackEvent;
}({});
class $5dc3863f86ce6ade$export$590a718599f8f8b3 {
    constructor(timeoutPeriod){
        // Tracks the settimeout; so that we can clear the timeout
        this.timeoutHandle = undefined;
        this.callbackStatus = "idle";
        if (timeoutPeriod > 0) {
            this.timeoutPeriod = timeoutPeriod;
            return;
        }
        throw new Error('CallbackWithTimeout requires timeout period higher than 0');
    }
    // This is a state machine to control the flow of execution.
    // IDLE -> RUNNING -> COMPLETED
    // IDLE -> RUNNING -> TIMEDOUT
    transitionCallbackStatus(currentStatus, event) {
        switch(currentStatus){
            case "idle":
            case "timedOut":
            case "completed":
                if (event === "execute") this.callbackStatus = "running";
                break;
            case "running":
                switch(event){
                    case "complete":
                        this.callbackStatus = "completed";
                        break;
                    case "timeout":
                        this.callbackStatus = "timedOut";
                        break;
                }
                break;
            default:
                this.callbackStatus = currentStatus;
        }
    }
    // Start a timeout. If this.callback(this._done) does not finish
    // by this.options.callbackTimeoutPeriod time period,
    // we will call done with a true value.
    executeCallbackWithTimeout(callback, onDone, onTimeout) {
        if (typeof window === 'undefined') return;
        this.transitionCallbackStatus(this.callbackStatus, "execute");
        // Setting timeout
        this.timeoutHandle = window.setTimeout(()=>{
            this.transitionCallbackStatus(this.callbackStatus, "timeout");
            onTimeout();
        }, this.timeoutPeriod);
        // Executing callback
        callback((state)=>{
            this.cancelTimeout();
            if (this.getCallbackStatus() !== "timedOut") {
                this.transitionCallbackStatus(this.callbackStatus, "complete");
                onDone(state);
            }
        });
    }
    getCallbackStatus() {
        return this.callbackStatus;
    }
    // This allows us to cancel the timeout function, for example, if the callback finishes before the timeout period
    // or, if the user wants to manually cancel the timeout
    cancelTimeout() {
        if (typeof window !== 'undefined' && this.timeoutPeriod > 0 && this.timeoutHandle) {
            window.clearTimeout(this.timeoutHandle);
            this.timeoutHandle = undefined;
        }
    }
}

});

parcelRegister("aRK7K", function(module, exports) {

$parcel$export(module.exports, "DoneState", () => $6981e064cf5eaab0$export$f93c40fda808dd0c);
// Clients can optionally provide the callbackTimeoutPeriod parameter
var $6981e064cf5eaab0$export$f93c40fda808dd0c = /*#__PURE__*/ function(DoneState) {
    DoneState[DoneState["NOOP"] = 0] = "NOOP";
    DoneState[DoneState["SUCCESS"] = 1] = "SUCCESS";
    DoneState[DoneState["ERROR"] = 2] = "ERROR";
    return DoneState;
}({});

});




parcelRegister("kM7SS", function(module, exports) {

$parcel$export(module.exports, "attachXidToMultipleEvents", () => $9d12fe3c013c2adb$export$c21270cab66ab290);

var $gjgR4 = parcelRequire("gjgR4");
function $9d12fe3c013c2adb$export$c9c3aaf655d6f275(item, xidCallback) {
    if (!(xidCallback && xidCallback instanceof Function)) return item;
    if (item.msg.type === (0, $gjgR4.SegmentEventTypes).PAGE || item.msg.type === (0, $gjgR4.SegmentEventTypes).TRACK) {
        const xid = xidCallback();
        if (xid && Array.isArray(xid)) item.msg.properties = {
            ...item.msg.properties,
            xid: xid
        };
    } else if (item.msg.traits && item.msg.type === (0, $gjgR4.SegmentEventTypes).IDENTIFY) {
        const xid = xidCallback();
        if (xid && Array.isArray(xid)) item.msg.traits = {
            ...item.msg.traits,
            xid: xid
        };
    }
    return item;
}
async function $9d12fe3c013c2adb$export$c21270cab66ab290(items, xidItemPromiseCallback) {
    try {
        const xidCallback = await xidItemPromiseCallback;
        return items.map((item)=>$9d12fe3c013c2adb$export$c9c3aaf655d6f275(item, xidCallback));
    } catch (error) {
        return items;
    }
}

});
parcelRegister("gjgR4", function(module, exports) {

$parcel$export(module.exports, "LastError", () => $46dd75a741c58f9d$export$a63e16b3351b8c36);
$parcel$export(module.exports, "FetchError", () => $46dd75a741c58f9d$export$26e841bcf1aeb894);
$parcel$export(module.exports, "SegmentEventTypes", () => $46dd75a741c58f9d$export$ddf929981dc6feb3);
$parcel$export(module.exports, "MetadataResponse", () => $46dd75a741c58f9d$export$4b1a5e5486cc0d80);
$parcel$export(module.exports, "ALLOW_LISTED_FETCH_ERROR_NAMES", () => $46dd75a741c58f9d$export$96f086dcf574a9e2);
class $46dd75a741c58f9d$export$a63e16b3351b8c36 {
    constructor(reason, error){
        this.reason = reason;
        this.message = error instanceof Error ? error.message : null;
        this.statusCode = error instanceof $46dd75a741c58f9d$export$26e841bcf1aeb894 ? error.statusCode : null;
    }
}
var $46dd75a741c58f9d$export$ddf929981dc6feb3 = /*#__PURE__*/ function(SegmentEventTypes) {
    SegmentEventTypes["IDENTIFY"] = "identify";
    SegmentEventTypes["PAGE"] = "page";
    // Dont need Screen as page and screen are the same and we only use page
    SegmentEventTypes["TRACK"] = "track";
    return SegmentEventTypes;
}({});
var $46dd75a741c58f9d$export$8d8db47b9b0efb63 = /*#__PURE__*/ function(CrossDomainIdentifierType) {
    CrossDomainIdentifierType["XC"] = "xc";
    CrossDomainIdentifierType["UID"] = "uid";
    return CrossDomainIdentifierType;
}({});
var $46dd75a741c58f9d$export$2140495465f9e528 = /*#__PURE__*/ function(CrossDomainIdentifierState) {
    CrossDomainIdentifierState["NEW"] = "NEW";
    CrossDomainIdentifierState["CHANGED"] = "CHANGED";
    CrossDomainIdentifierState["EXISTING"] = "EXISTING";
    CrossDomainIdentifierState["TIMEOUT"] = "TIMEOUT";
    CrossDomainIdentifierState["ERROR"] = "ERROR";
    CrossDomainIdentifierState["UNAVAILABLE"] = "UNAVAILABLE";
    CrossDomainIdentifierState["MALFORMED"] = "MALFORMED";
    CrossDomainIdentifierState["UNKNOWN"] = "UNKNOWN";
    return CrossDomainIdentifierState;
}({});
class $46dd75a741c58f9d$export$4b1a5e5486cc0d80 {
    constructor(props, url){
        this.props = props;
        this.url = url;
    }
    static fromJson(json) {
        let isString = (value)=>typeof value === 'string' || value instanceof String;
        const url = isString(json?.url) ? json.url.trim() : '';
        return new $46dd75a741c58f9d$export$4b1a5e5486cc0d80(json?.props || null, url.startsWith('http') ? url : null);
    }
}
class $46dd75a741c58f9d$export$26e841bcf1aeb894 extends Error {
    constructor(message, statusCode, statusText){
        super(message);
        this.statusCode = statusCode;
        this.statusText = statusText;
    }
}
const $46dd75a741c58f9d$export$96f086dcf574a9e2 = [
    'FetchError',
    'AbortError',
    'TypeError'
];

});


parcelRegister("57AWV", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_REQUEST_TIMEOUT", () => $2b3e54d72b8de01e$export$9175ce0e1c95daf2);
$parcel$export(module.exports, "DEFAULT_METADATA_REQUEST_TIMEOUT", () => $2b3e54d72b8de01e$export$8fddcd1eff390364);
$parcel$export(module.exports, "DEFAULT_METADATA_REFRESH_INTERVAL", () => $2b3e54d72b8de01e$export$92ed669a3d41dad3);
$parcel$export(module.exports, "DEFAULT_METADATA_PROPERTY_CHANGE_REFRESH_INTERVAL", () => $2b3e54d72b8de01e$export$6f1c008dd0c3b67e);
const $2b3e54d72b8de01e$export$9175ce0e1c95daf2 = 10000; // 10 seconds
const $2b3e54d72b8de01e$export$8fddcd1eff390364 = 60000; // 60 seconds
const $2b3e54d72b8de01e$export$92ed669a3d41dad3 = 600000; // 10 minutes
const $2b3e54d72b8de01e$export$6f1c008dd0c3b67e = 10; // 10 milliseconds

});

parcelRegister("kG09p", function(module, exports) {

$parcel$export(module.exports, "HTTP_STATUS_CODE_MAP", () => $e60573b530fe86c6$export$ba118f9de1e5ac63);
const $e60573b530fe86c6$export$ba118f9de1e5ac63 = new Map([
    [
        200,
        'OK'
    ],
    [
        400,
        'Bad Request'
    ],
    [
        401,
        'Unauthorized'
    ],
    [
        402,
        'Payment Required'
    ],
    [
        403,
        'Forbidden'
    ],
    [
        404,
        'Not Found'
    ],
    [
        405,
        'Method Not Allowed'
    ],
    [
        406,
        'Not Acceptable'
    ],
    [
        407,
        'Proxy Authentication Required'
    ],
    [
        408,
        'Request Timeout'
    ],
    [
        409,
        'Conflict'
    ],
    [
        410,
        'Gone'
    ],
    [
        411,
        'Length Required'
    ],
    [
        412,
        'Precondition Failed'
    ],
    [
        413,
        'Payload Too Large'
    ],
    [
        414,
        'URI Too Long'
    ],
    [
        415,
        'Unsupported Media Type'
    ],
    [
        416,
        'Requested range not satisfiable'
    ],
    [
        417,
        'Expectation Failed'
    ],
    [
        418,
        "I'm a teapot"
    ],
    [
        422,
        'Unprocessable Entity'
    ],
    [
        423,
        'Locked'
    ],
    [
        424,
        'Failed Dependency'
    ],
    [
        425,
        'Too Early'
    ],
    [
        426,
        'Upgrade Required'
    ],
    [
        428,
        'Precondition Required'
    ],
    [
        429,
        'Too Many Requests'
    ],
    [
        431,
        'Request Header Fields Too Large'
    ],
    [
        451,
        'Unavailable For Legal Reasons'
    ],
    [
        500,
        'Internal Server Error'
    ],
    [
        501,
        'Not Implemented'
    ],
    [
        502,
        'Bad Gateway'
    ],
    [
        503,
        'Service Unavailable'
    ],
    [
        504,
        'Gateway Timeout'
    ],
    [
        505,
        'HTTP Version not supported'
    ],
    [
        506,
        'Variant Also Negotiates'
    ],
    [
        507,
        'Insufficient Storage'
    ],
    [
        508,
        'Loop Detected'
    ],
    [
        509,
        'Bandwidth Limit Exceeded'
    ],
    [
        510,
        'Not Extended'
    ],
    [
        511,
        'Network Authentication Required'
    ],
    [
        -1,
        'Unknown Status'
    ]
]);

});

parcelRegister("cdwq4", function(module, exports) {

$parcel$export(module.exports, "sendEvents", () => $c518ad8962a188f2$export$8e8f0180c1b41fad);

var $8QpSo = parcelRequire("8QpSo");

var $gjgR4 = parcelRequire("gjgR4");
const $c518ad8962a188f2$export$8e8f0180c1b41fad = async (options)=>{
    const signal = $c518ad8962a188f2$var$createOrGetAbortController(options)?.signal;
    const corsOptions = $c518ad8962a188f2$var$getCorsForUrl(options.url);
    const response = await fetch(options.url, {
        method: 'POST',
        // Content-type has to be text/plain in order to prevent unnecessary `OPTIONS` requests.
        headers: {
            'Content-Type': 'text/plain'
        },
        body: JSON.stringify(options.batch),
        signal: signal,
        ...corsOptions
    });
    if (response.status === 429 || response.status >= 500 && response.status < 600) throw new (0, $gjgR4.FetchError)(`HTTP Error ${response.status} (${response.statusText})`, response.status, response.statusText);
    return response;
};
const $c518ad8962a188f2$var$createOrGetAbortController = (options)=>{
    if (options.abortController) return options.abortController;
    else if (options.timeout) {
        const abortController = new AbortController();
        // After a fetch has completed, calling abort is ignored.
        setTimeout(()=>{
            abortController.abort();
        }, options.timeout);
        return abortController;
    }
};
// To ensure we always have cookies, we should check if the origins match.
// If they dont, we need to set mode to `cors` and credentials to `include`.
const $c518ad8962a188f2$var$getCorsForUrl = (0, $8QpSo.default)((url)=>{
    const origin = new URL(url).origin;
    if (origin === location.origin) return {};
    else return {
        mode: 'cors',
        credentials: 'include'
    };
});

});

parcelRegister("9Mu5e", function(module, exports) {

$parcel$export(module.exports, "default", () => $a63cf0c99f90bef2$export$2e2bcd8739ae039);

var $4mBKK = parcelRequire("4mBKK");

var $bXrHm = parcelRequire("bXrHm");

var $hDpfo = parcelRequire("hDpfo");
var $dITTJ = parcelRequire("dITTJ");

var $KX1VQ = parcelRequire("KX1VQ");
// Cookie is stale, if anonymousId was generated 7 days ago.
const $a63cf0c99f90bef2$var$ANONYMOUS_ID_COOKIE_STALE_DAYS = 7;
const $a63cf0c99f90bef2$var$SAFE = 'SAFE';
const $a63cf0c99f90bef2$var$UNSAFE = 'UNSAFE';
const $a63cf0c99f90bef2$var$NOT_FOUND = 'NOT_FOUND';
const $a63cf0c99f90bef2$var$COOKIE = 'COOKIE';
const $a63cf0c99f90bef2$var$LOCAL_STORAGE = 'LOCAL_STORAGE';
class $a63cf0c99f90bef2$export$2e2bcd8739ae039 {
    constructor(disableCookiePersistence){
        this.store = new (0, $KX1VQ.default)({
            useStoragePrefix: false
        });
        this.cookie = new (0, $dITTJ.default)(disableCookiePersistence);
    }
    getUserId() {
        return this.userId || null;
    }
    setUserId(userId) {
        this.userId = userId;
    }
    getAnonymousId(customAnonymousIdGenerator) {
        /**
		 * Prefer localStorage as there cant be duplicate keys, and its faster. Also update cookie, if stale.
		 * If not set in localStorage, check cookies. Also set localStorage for future attempts.
		 * If not in cookies, generate a new one. Set both cookie and localStorage keys.
		 */ return this.getAnonymousIdFromLocalStorageAndUpdateCookieIfStale() || this.getAnonymousIdFromCookieAndUpdateLocalStorage() || this.generateNewAnonymousId(customAnonymousIdGenerator);
    }
    setAnonymousId(anonymousId) {
        const stringifyAnonymosId = JSON.stringify(anonymousId);
        this.cookie.set((0, $hDpfo.AWCCookiesKeys).AJS_ANONYMOUS_ID, stringifyAnonymosId);
        this.lastAnonymousIdCookieUpdate = Date.now();
        return this.store.setItem((0, $hDpfo.AllAnalyticsCookies).AJS_ANONYMOUS_ID.getKey(), stringifyAnonymosId);
    }
    getAnonymousIdFromStorage(source) {
        const rawStorageAnonidValue = source === $a63cf0c99f90bef2$var$LOCAL_STORAGE ? this.store.getItem((0, $hDpfo.AllAnalyticsCookies).AJS_ANONYMOUS_ID.getKey()) : this.cookie.get((0, $hDpfo.AWCCookiesKeys).AJS_ANONYMOUS_ID);
        if (rawStorageAnonidValue) {
            const unsafeValue = {
                type: $a63cf0c99f90bef2$var$UNSAFE,
                anonymousId: rawStorageAnonidValue
            };
            try {
                const parsedAnonId = JSON.parse(rawStorageAnonidValue);
                if (parsedAnonId && typeof parsedAnonId === 'string') return {
                    type: $a63cf0c99f90bef2$var$SAFE,
                    anonymousId: parsedAnonId
                };
                return unsafeValue;
            } catch (err) {
                /*
				 * Segments new Analytics-next client will store strings as strings without stringifing.
				 * The legacy Segment client and AWC always stringify and parse cookies and values.
				 * If the new Segment analytics-client stores a cookie and local storage value first, it will
				 * breaking old clients.
				 *
				 * Additionally, JSON.parse can cause exceptions to be thrown in some browsers; see AAP-324.
				 *
				 * Intentionally swalling errors here and returning the original value found in storage to avoid ping-pong.
				 */ return unsafeValue;
            }
        }
        return {
            type: $a63cf0c99f90bef2$var$NOT_FOUND
        };
    }
    getAnonymousIdFromLocalStorageAndUpdateCookieIfStale() {
        const localStorageValue = this.getAnonymousIdFromStorage($a63cf0c99f90bef2$var$LOCAL_STORAGE);
        let shouldUpdateCookie = false;
        if (!this.lastAnonymousIdCookieUpdate || (0, $4mBKK.default)(new Date(), new Date(this.lastAnonymousIdCookieUpdate)) >= $a63cf0c99f90bef2$var$ANONYMOUS_ID_COOKIE_STALE_DAYS) shouldUpdateCookie = true;
        switch(localStorageValue.type){
            case $a63cf0c99f90bef2$var$SAFE:
                if (shouldUpdateCookie) this.setAnonymousId(localStorageValue.anonymousId);
                return localStorageValue.anonymousId;
            case $a63cf0c99f90bef2$var$UNSAFE:
                return localStorageValue.anonymousId;
            case $a63cf0c99f90bef2$var$NOT_FOUND:
            default:
                return null;
        }
    }
    getAnonymousIdFromCookieAndUpdateLocalStorage() {
        const cookieValue = this.getAnonymousIdFromStorage($a63cf0c99f90bef2$var$COOKIE);
        switch(cookieValue.type){
            case $a63cf0c99f90bef2$var$SAFE:
            case $a63cf0c99f90bef2$var$UNSAFE:
                this.store.setItem((0, $hDpfo.AllAnalyticsCookies).AJS_ANONYMOUS_ID.getKey(), JSON.stringify(cookieValue.anonymousId));
                return cookieValue.anonymousId;
            case $a63cf0c99f90bef2$var$NOT_FOUND:
            default:
                return null;
        }
    }
    generateNewAnonymousId(customAnonymousIdGenerator = (0, (/*@__PURE__*/$parcel$interopDefault($bXrHm)))) {
        const newAnonId = customAnonymousIdGenerator();
        this.setAnonymousId(newAnonId);
        return newAnonId;
    }
}

});
parcelRegister("hDpfo", function(module, exports) {

$parcel$export(module.exports, "AWCCookiesKeys", () => $69f86d587451d1d5$export$202d555a5dbfd90c);
$parcel$export(module.exports, "AllAnalyticsCookies", () => $69f86d587451d1d5$export$d4cb17942ea57c95);
var $69f86d587451d1d5$export$202d555a5dbfd90c = /*#__PURE__*/ function(AWCCookiesKeys) {
    AWCCookiesKeys["AWC_TLD_TEST"] = "AWC_TLD_TEST";
    AWCCookiesKeys["AWC_ANALYTICS_DEBUG"] = "AWC_ANALYTICS_DEBUG";
    AWCCookiesKeys["AJS_ANONYMOUS_ID"] = "AJS_ANONYMOUS_ID";
    return AWCCookiesKeys;
}({});
class $69f86d587451d1d5$var$CookieSchema {
    constructor(key, options){
        this.key = key;
        this.options = options;
    }
    getAttributes() {
        return this.options;
    }
    getKey() {
        return this.key;
    }
}
const $69f86d587451d1d5$var$isSecure = ()=>{
    try {
        return window && window.location && window.location.protocol === 'https:';
    } catch (err) {
        return false;
    }
};
const $69f86d587451d1d5$export$d4cb17942ea57c95 = {
    ["AWC_TLD_TEST"]: new $69f86d587451d1d5$var$CookieSchema('__awc_tld_test__', {
        expires: 365,
        secure: $69f86d587451d1d5$var$isSecure(),
        path: '/'
    }),
    ["AWC_ANALYTICS_DEBUG"]: new $69f86d587451d1d5$var$CookieSchema('atlassian_analytics_debug', {
        expires: 365,
        secure: $69f86d587451d1d5$var$isSecure(),
        path: '/'
    }),
    ["AJS_ANONYMOUS_ID"]: new $69f86d587451d1d5$var$CookieSchema('ajs_anonymous_id', {
        expires: 365,
        secure: $69f86d587451d1d5$var$isSecure(),
        path: '/'
    })
};

});

parcelRegister("dITTJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b7ba5c42c42aa6b$export$2e2bcd8739ae039);

var $eYli8 = parcelRequire("eYli8");

var $hDpfo = parcelRequire("hDpfo");

var $axlw3 = parcelRequire("axlw3");

var $aXi7r = parcelRequire("aXi7r");
class $7b7ba5c42c42aa6b$export$2e2bcd8739ae039 {
    constructor(disableCookiePersistence){
        this.cookieLike = (0, $aXi7r.canUseCookie)(disableCookiePersistence) ? (0, (/*@__PURE__*/$parcel$interopDefault($eYli8))) : new (0, $axlw3.default)();
    }
    set(name, value, options) {
        // no-op
        if (!(0, $hDpfo.AllAnalyticsCookies)[name]) {
            // eslint-disable-next-line no-console
            console.warn(`Unknown cookie key ${name} provided, not set.`);
            return;
        }
        return this.cookieLike.set((0, $hDpfo.AllAnalyticsCookies)[name].getKey(), value, {
            ...(0, $hDpfo.AllAnalyticsCookies)[name].getAttributes(),
            // Function is memoized so we only calculate this once per page load
            domain: (0, $aXi7r.getTld)(),
            ...options
        });
    }
    get(name) {
        if (!(0, $hDpfo.AllAnalyticsCookies)[name]) {
            // eslint-disable-next-line no-console
            console.warn(`Unknown cookie key ${name} provided, not fetched.`);
            return;
        }
        return this.cookieLike.get((0, $hDpfo.AllAnalyticsCookies)[name].getKey());
    }
    remove(name, options) {
        if (!(0, $hDpfo.AllAnalyticsCookies)[name]) {
            // eslint-disable-next-line no-console
            console.warn(`Unknown cookie key ${name} provided, not removed.`);
            return;
        }
        this.cookieLike.remove((0, $hDpfo.AllAnalyticsCookies)[name].getKey(), {
            ...options
        });
    }
}

});
parcelRegister("axlw3", function(module, exports) {

$parcel$export(module.exports, "default", () => $ecfcde579a576a11$export$2e2bcd8739ae039);

var $KX1VQ = parcelRequire("KX1VQ");
class $ecfcde579a576a11$export$2e2bcd8739ae039 {
    constructor(){
        this.safeStorage = new (0, $KX1VQ.default)({
            useStoragePrefix: false
        });
    }
    set(name, value) {
        this.safeStorage.setItem(name, value);
        return value;
    }
    get(name) {
        const value = this.safeStorage.getItem(name);
        return value || undefined;
    }
    remove(name) {
        this.safeStorage.removeItem(name);
    }
}

});
parcelRegister("KX1VQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $a42b1f8ae9ae72bb$export$2e2bcd8739ae039);

var $8TsCv = parcelRequire("8TsCv");

var $5jnRh = parcelRequire("5jnRh");
class $a42b1f8ae9ae72bb$export$2e2bcd8739ae039 extends (0, $5jnRh.default) {
    constructor(options){
        let storageToUse;
        try {
            storageToUse = window.localStorage || (0, $8TsCv.default);
        } catch (err) {
            storageToUse = (0, $8TsCv.default);
        }
        super(storageToUse, options);
    }
}

});
parcelRegister("8TsCv", function(module, exports) {

$parcel$export(module.exports, "default", () => $2876d84234385448$export$2e2bcd8739ae039);
class $2876d84234385448$export$90e3e001bcac59c7 {
    constructor(){
        this._data = {};
        this.length = 0;
        this.setItem = (key, value)=>{
            this._data[key] = value;
            this.length = Object.keys(this._data).length;
            return value;
        };
        this.getItem = (key)=>{
            if (key in this._data) return this._data[key];
            return null;
        };
        this.removeItem = (key)=>{
            if (key in this._data) delete this._data[key];
            this.length = Object.keys(this._data).length;
            return null;
        };
        this.clear = ()=>{
            this._data = {};
            this.length = 0;
        };
        this.key = (index)=>Object.keys(this._data)[index];
    }
}
var // eslint-disable-next-line import/no-anonymous-default-export
$2876d84234385448$export$2e2bcd8739ae039 = new $2876d84234385448$export$90e3e001bcac59c7();

});

parcelRegister("5jnRh", function(module, exports) {

$parcel$export(module.exports, "default", () => $8496869f39880b37$export$2e2bcd8739ae039);
/*
 * Code heavily influenced by Segment's Store https://github.com/segmentio/localstorage-retry/blob/master/lib/store.js
 * and Engine https://github.com/segmentio/localstorage-retry/blob/master/lib/engine.js
 * But is not used because it's not public API and is too restrictive in the way it sets keys and does JSON parsing and stringify
 */ 
var $iZhen = parcelRequire("iZhen");

var $8TsCv = parcelRequire("8TsCv");
const $8496869f39880b37$export$41c06fdd37b7e9a5 = 'awc';
const $8496869f39880b37$export$770aa8bc07b3de03 = 'awcInMemoryStorageFallback';
function $8496869f39880b37$export$48c17662a6902497(store) {
    const TEST_VALUE = 'test_value';
    if (!store) return false;
    try {
        const key = 'awc.storage.support';
        store.setItem(key, TEST_VALUE);
        const value = store.getItem(key);
        store.removeItem(key);
        // handle localStorage silently failing
        return value === TEST_VALUE;
    } catch (e) {
        // Can throw if localStorage is disabled
        return false;
    }
}
function $8496869f39880b37$export$6325979d1c67607f(e) {
    let quotaExceeded = false;
    if (e.code) switch(e.code){
        case 22:
            quotaExceeded = true;
            break;
        case 1014:
            // Firefox
            if (e.name === 'NS_ERROR_DOM_QUOTA_REACHED') quotaExceeded = true;
            break;
        default:
            break;
    }
    else if (e.number === -2147024882) // Internet Explorer 8
    quotaExceeded = true;
    return quotaExceeded;
}
class $8496869f39880b37$export$2e2bcd8739ae039 {
    constructor(storageToUse, options = {}){
        this.getStore = ()=>this._store;
        this.getItem = (key)=>this._store.getItem(this.createKey(key));
        this.removeItem = (key)=>this._store.removeItem(this.createKey(key));
        this.setItem = (key, value)=>{
            try {
                this._store.setItem(this.createKey(key), value);
            } catch (err) {
                if ($8496869f39880b37$export$6325979d1c67607f(err)) {
                    this.swapToInMemory();
                    this._store.setItem(this.createKey(key), value);
                }
            }
        };
        this.swapToInMemory = ()=>{
            if (this._store === (0, $8TsCv.default) || typeof window === 'undefined') return;
            const keys = Object.keys(this._store || {});
            let inMemoryStorage;
            if ($8496869f39880b37$export$48c17662a6902497(window[$8496869f39880b37$export$770aa8bc07b3de03])) inMemoryStorage = window[$8496869f39880b37$export$770aa8bc07b3de03];
            else {
                inMemoryStorage = (0, $8TsCv.default);
                if (!window[$8496869f39880b37$export$770aa8bc07b3de03]) // If not already attached to window then attach our instance of InMemoryStorage
                // We need to do this because if there are multiple instances of Analytics Client in multiple scopes,
                // there is no way to guarantee the throttling behaviour of the UI viewed event across those instances without a global singleton
                window[$8496869f39880b37$export$770aa8bc07b3de03] = (0, $8TsCv.default);
            }
            keys.forEach((key)=>{
                if (key.indexOf(this.getPrefix()) === 0) {
                    const value = this._store.getItem(key);
                    if (value) inMemoryStorage.setItem(key, value);
                }
            });
            this._store = inMemoryStorage;
        };
        this.clear = ()=>this._store.clear();
        this.key = (index)=>this._store.key(index);
        this.getPrefix = ()=>this._prefix;
        this.createKey = (key)=>{
            if (this._prefix) return `${this.getPrefix()}.${key}`;
            return key;
        };
        this.options = options;
        const prefixes = [];
        if (options.useStoragePrefix === undefined || options.useStoragePrefix) prefixes.push($8496869f39880b37$export$41c06fdd37b7e9a5);
        if (options.envPrefix && options.envPrefix !== (0, $iZhen.envType).PROD) prefixes.push(options.envPrefix);
        this._prefix = prefixes.join('-');
        if ($8496869f39880b37$export$48c17662a6902497(storageToUse)) this._store = storageToUse;
        else this.swapToInMemory();
    }
}

});



parcelRegister("aXi7r", function(module, exports) {

$parcel$export(module.exports, "canUseCookie", () => $e056f358404ee1a8$export$a9330601ee8f4d95);
$parcel$export(module.exports, "getTld", () => $e056f358404ee1a8$export$de6821eed3d5f32d);

var $eYli8 = parcelRequire("eYli8");

var $8QpSo = parcelRequire("8QpSo");

var $hDpfo = parcelRequire("hDpfo");
const $e056f358404ee1a8$export$a9330601ee8f4d95 = (disableCookiePersistence = false)=>{
    if (disableCookiePersistence) return false;
    return !(location.protocol === 'file:' || location.protocol === 'chrome-extension:');
};
const $e056f358404ee1a8$export$eb80e1beaa8dacf8 = (0, $hDpfo.AllAnalyticsCookies).AWC_TLD_TEST.getKey();
const $e056f358404ee1a8$export$19164982d36535d8 = 'tld_test';
const $e056f358404ee1a8$export$de6821eed3d5f32d = (0, $8QpSo.default)(()=>{
    if (typeof location === 'undefined') return '';
    const { hostname: hostname } = location;
    const splitHostname = hostname.split('.');
    for(let i = 1; i <= splitHostname.length; i++){
        const domainParts = splitHostname.slice(i * -1);
        const domain = `.${domainParts.join('.')}`;
        (0, (/*@__PURE__*/$parcel$interopDefault($eYli8))).set($e056f358404ee1a8$export$eb80e1beaa8dacf8, $e056f358404ee1a8$export$19164982d36535d8, {
            domain: domain
        });
        if ((0, (/*@__PURE__*/$parcel$interopDefault($eYli8))).get($e056f358404ee1a8$export$eb80e1beaa8dacf8) === $e056f358404ee1a8$export$19164982d36535d8) {
            (0, (/*@__PURE__*/$parcel$interopDefault($eYli8))).remove($e056f358404ee1a8$export$eb80e1beaa8dacf8, {
                domain: domain
            });
            return domain;
        }
    }
    return hostname;
});

});



parcelRegister("1T3jD", function(module, exports) {

$parcel$export(module.exports, "buildContext", () => $50d6a5cf3019b770$export$3a7fe28f9bf4f3d9);
$parcel$export(module.exports, "prepareEventProperties", () => $50d6a5cf3019b770$export$44d22e5fb02cc68e);
// @ts-ignore

var $1m0iJ = parcelRequire("1m0iJ");
const $50d6a5cf3019b770$export$3a7fe28f9bf4f3d9 = (context)=>{
    return {
        ...context.context,
        userAgent: navigator.userAgent
    };
};
const $50d6a5cf3019b770$export$44d22e5fb02cc68e = (properties)=>{
    const propertiesWithoutUndefined = $50d6a5cf3019b770$export$2250ccecd1e040fd(properties);
    return (0, (/*@__PURE__*/$parcel$interopDefault($1m0iJ)))(propertiesWithoutUndefined);
};
const $50d6a5cf3019b770$export$2250ccecd1e040fd = (obj)=>{
    if (obj === null || typeof obj !== 'object') return obj;
    const clone = {};
    Object.keys(obj).forEach((key)=>{
        const value = $50d6a5cf3019b770$var$getValueOfObject(obj, key);
        if (value !== undefined) {
            if (Array.isArray(value)) clone[key] = value.map((i)=>$50d6a5cf3019b770$export$2250ccecd1e040fd(i));
            else if (typeof value === 'object' && value !== null) clone[key] = $50d6a5cf3019b770$export$2250ccecd1e040fd(value);
            else clone[key] = value;
        }
    });
    return clone;
};
// Using ts-ignore everywhere urked me
const $50d6a5cf3019b770$var$getValueOfObject = (obj, key)=>{
    // @ts-ignore This is an object
    return obj[key];
};

});


parcelRegister("3pTuY", function(module, exports) {

$parcel$export(module.exports, "MetadataClient", () => $812bb85a24bf7660$export$1ac223ae496131c9);

var $1LZzU = parcelRequire("1LZzU");

var $jChFm = parcelRequire("jChFm");

var $38r8F = parcelRequire("38r8F");
var $aRK7K = parcelRequire("aRK7K");

var $ePz85 = parcelRequire("ePz85");

var $cT8IU = parcelRequire("cT8IU");

var $ztCik = parcelRequire("ztCik");

var $57AWV = parcelRequire("57AWV");

var $ebE7i = parcelRequire("ebE7i");

var $gjgR4 = parcelRequire("gjgR4");
class $812bb85a24bf7660$export$1ac223ae496131c9 {
    static{
        this.INITIAL_REFRESH_DELAY = 1;
    }
    static{
        this.Factory = (apiHostProtocol, apiHost, product)=>{
            return new $812bb85a24bf7660$export$1ac223ae496131c9(apiHostProtocol, apiHost, product);
        };
    }
    constructor(apiHostProtocol, apiHost, product){
        this._userInfo = {
            anonymousId: ''
        };
        this._tenantInfo = {};
        this._url = `${apiHostProtocol}://${apiHost}/metadata`;
        this._product = product;
        this._metadataInfo = null;
        this._requestStatus = 'PENDING';
        this._lastFetchRequestCount = 0;
        this._lastErrorReason = null;
        this._fetchAbortController = null;
        this._hasBeenStopped = false;
        this._isEnabled = false;
        this._propertyChangeRefreshTimeout = null;
        const isStargateProxy = (0, $cT8IU.isStargateProxyPath)({
            apiHost: apiHost
        });
        this._metadataHost = isStargateProxy ? 'PRODUCT_HOST' : apiHost;
        this._options = this.buildOptions({
            backoffFactor: 2,
            backoffJitterPercentage: 0.2,
            batchFlushSize: 7,
            flushBeforeUnload: false,
            flushWaitMs: 500,
            maxAttempts: 10,
            maxItems: 1000,
            maxRetryDelay: 30000,
            minRetryDelay: 1000
        });
        this._scheduler = new (0, $38r8F.default)({
            ...this._options,
            waitInterval: (0, $57AWV.DEFAULT_METADATA_REFRESH_INTERVAL)
        }, this.scheduleCallback.bind(this));
        this._networkStatus = null;
    }
    /**
	 * Starts the metadata client. This will start the scheduler and begin
	 * fetching metadata.
	 *
	 * @param allowRestart - If false, the client will not be restarted if it has already been stopped
	 *						 by a call to stop().
	 */ start(allowRestart) {
        if (this._isEnabled || this._hasBeenStopped && !allowRestart) return;
        this._isEnabled = true;
        this.startNetworkStatusMonitor();
        setTimeout(()=>{
            this._scheduler.schedule({
                immediate: true
            });
        }, $812bb85a24bf7660$export$1ac223ae496131c9.INITIAL_REFRESH_DELAY);
    }
    stop() {
        if (!this._isEnabled) return;
        this._hasBeenStopped = true;
        this._isEnabled = false;
        this.stopNetworkStatusMonitor();
        this._scheduler.stop();
        this._fetchAbortController?.abort();
        this.resetPropertyChangeRefresh();
    }
    startNetworkStatusMonitor() {
        if (this._networkStatus) return;
        this._networkStatus = new (0, $1LZzU.default)((status)=>{
            if (status === (0, $ePz85.NetworkStatusEnum).OFFLINE) this._scheduler.stop();
            else if (this._isEnabled) this._scheduler.schedule({
                immediate: this._metadataInfo === null
            });
        });
    }
    stopNetworkStatusMonitor() {
        if (this._networkStatus) {
            this._networkStatus.removeListeners();
            this._networkStatus = null;
        }
    }
    async refreshMetadataAsync() {
        if ((0, $ztCik.TestSupport).areFetchCallsDisabled() || !this._isEnabled) return Promise.resolve();
        this._fetchAbortController?.abort();
        this._fetchAbortController = new AbortController();
        const fetchAbortSignal = this._fetchAbortController.signal;
        this._lastFetchRequestCount = this._scheduler.getFailureCount();
        await (0, $ebE7i.fetchMetadata)(this._url, {
            product: this._product,
            userInfo: this._userInfo,
            tenantInfo: this._tenantInfo
        }, (0, $57AWV.DEFAULT_METADATA_REQUEST_TIMEOUT), fetchAbortSignal).then(async (response)=>{
            const metadata = await response.json();
            this._metadataInfo = (0, $gjgR4.MetadataResponse).fromJson(metadata);
            this._lastFetchRequestCount++;
            this._requestStatus = 'FETCHED';
            this._lastErrorReason = null;
        }).catch((error)=>{
            if (fetchAbortSignal.aborted) // This request was aborted, so we don't need to handle it.
            return;
            this._requestStatus = 'FAILED';
            if (error instanceof (0, $gjgR4.FetchError) && [
                429,
                503
            ].includes(error.statusCode)) this._lastErrorReason = 'ServerBusyError';
            else this._lastErrorReason = error instanceof Error && (0, $gjgR4.ALLOW_LISTED_FETCH_ERROR_NAMES).includes(error.name) ? error.name : 'Unknown';
            throw error;
        });
    }
    getMetadataAsync() {
        return Promise.resolve(this._metadataInfo);
    }
    get status() {
        return this._requestStatus;
    }
    get lastErrorReason() {
        return this._lastErrorReason;
    }
    get lastFetchRequestCount() {
        return this._lastFetchRequestCount;
    }
    get userInfo() {
        return this._userInfo;
    }
    set userInfo(userInfo) {
        if (this._userInfo?.userId === userInfo?.userId && this._userInfo?.userIdType === userInfo?.userIdType) return;
        this._userInfo = userInfo;
        this.schedulePropertyChangeRefresh();
    }
    get tenantInfo() {
        return this._tenantInfo;
    }
    set tenantInfo(tenantInfo) {
        if (this._tenantInfo?.tenantId === tenantInfo?.tenantId && this._tenantInfo?.tenantIdType === tenantInfo?.tenantIdType) return;
        this._tenantInfo = tenantInfo;
        this.schedulePropertyChangeRefresh();
    }
    get metrics() {
        return {
            host: this._metadataHost,
            status: this.status,
            lastErrorReason: this.lastErrorReason,
            lastRefreshRequestCount: this.lastFetchRequestCount
        };
    }
    async scheduleCallback(done) {
        if (this._networkStatus?.getNetworkStatus() === (0, $ePz85.NetworkStatusEnum).OFFLINE) {
            done((0, $aRK7K.DoneState).NOOP);
            return;
        }
        try {
            await this.refreshMetadataAsync();
            done((0, $aRK7K.DoneState).SUCCESS);
            this._scheduler.schedule();
        } catch (error) {
            done((0, $aRK7K.DoneState).ERROR);
        }
    }
    /**
	 * Schedules a refresh of the metadata when the user or tenant info changes. There is
	 * a short delay to allow for multiple changes to be batched together, such as when the
	 * callers sets the user info and tenant info in quick succession.
	 */ schedulePropertyChangeRefresh() {
        if (!this._isEnabled) return;
        this.resetPropertyChangeRefresh();
        this._propertyChangeRefreshTimeout = setTimeout(()=>{
            this.resetPropertyChangeRefresh();
            this._scheduler.schedule({
                immediate: true
            });
        }, (0, $57AWV.DEFAULT_METADATA_PROPERTY_CHANGE_REFRESH_INTERVAL));
    }
    resetPropertyChangeRefresh() {
        if (this._propertyChangeRefreshTimeout) {
            clearTimeout(this._propertyChangeRefreshTimeout);
            this._propertyChangeRefreshTimeout = null;
        }
    }
    buildOptions(options) {
        return {
            backoffFactor: options?.backoffFactor || (0, $jChFm.DEFAULT_POLLING_OPTIONS).backoffFactor,
            backoffJitterPercentage: options?.backoffJitterPercentage !== undefined ? options.backoffJitterPercentage : (0, $jChFm.DEFAULT_POLLING_OPTIONS).backoffJitterPercentage,
            batchFlushSize: options?.batchFlushSize || (0, $jChFm.DEFAULT_POLLING_OPTIONS).batchFlushSize,
            flushBeforeUnload: options?.flushBeforeUnload || (0, $jChFm.DEFAULT_POLLING_OPTIONS).flushBeforeUnload,
            flushWaitMs: options?.flushWaitMs || (0, $jChFm.DEFAULT_POLLING_OPTIONS).flushWaitMs,
            maxItems: options?.maxItems || (0, $jChFm.DEFAULT_POLLING_OPTIONS).maxItems,
            maxAttempts: options?.maxAttempts || (0, $jChFm.DEFAULT_POLLING_OPTIONS).maxAttempts,
            maxRetryDelay: options?.maxRetryDelay || (0, $jChFm.DEFAULT_POLLING_OPTIONS).maxRetryDelay,
            minRetryDelay: options?.minRetryDelay || (0, $jChFm.DEFAULT_POLLING_OPTIONS).minRetryDelay
        };
    }
}

});
parcelRegister("cT8IU", function(module, exports) {

$parcel$export(module.exports, "selectHost", () => $271f084adaa9086b$export$18c0b81944902eae);
$parcel$export(module.exports, "isStargateProxyPath", () => $271f084adaa9086b$export$83a9dd8d74be72c);

var $iZhen = parcelRequire("iZhen");
const $271f084adaa9086b$var$PROD_HOST = 'as.atlassian.com/api/v1';
const $271f084adaa9086b$var$STARGATE_PROD_HOST = 'api-private.atlassian.com/gasv3/api/v1';
const $271f084adaa9086b$var$STAGING_HOST = 'as.staging.atl-paas.net/api/v1';
const $271f084adaa9086b$var$STARGATE_STAGING_HOST = 'api-private.stg.atlassian.com/gasv3/api/v1';
const $271f084adaa9086b$var$FEDRAMP_STAGING_HOST = 'as.staging.atl-paas-us-gov-mod.net/api/v1';
const $271f084adaa9086b$var$FEDRAMP_PROD_HOST = 'as.atlassian-us-gov-mod.com/api/v1';
const $271f084adaa9086b$var$STARGATE_FEDRAMP_STAGING_HOST = 'api.stg.atlassian-us-gov-mod.com/gasv3/api/v1';
const $271f084adaa9086b$var$STARGATE_FEDRAMP_PROD_HOST = 'api.atlassian-us-gov-mod.com/gasv3/api/v1';
const $271f084adaa9086b$var$STARGATE_PROXY_PATH = '/gateway/api/gasv3/api/v1';
const $271f084adaa9086b$var$handleFedRampStagingDirect = ()=>{
    return $271f084adaa9086b$var$FEDRAMP_STAGING_HOST;
};
const $271f084adaa9086b$var$handleFedRampStagingStargate = ()=>{
    return $271f084adaa9086b$var$STARGATE_FEDRAMP_STAGING_HOST;
};
const $271f084adaa9086b$var$handleFedRampModerate = ({ useStargate: useStargate, env: env, useLegacyUrl: useLegacyUrl, envOverride: envOverride })=>{
    if (env === (0, $iZhen.envType).LOCAL || env === (0, $iZhen.envType).DEV) throw Error('No LOCAL or DEV environments for FedRAMP.');
    if (env === (0, $iZhen.envType).PROD && envOverride) throw Error('Cannot override to FedRAMP Sandbox for Prod.');
    if (!useStargate) return env === (0, $iZhen.envType).PROD ? $271f084adaa9086b$var$FEDRAMP_PROD_HOST : $271f084adaa9086b$var$handleFedRampStagingDirect();
    if (useLegacyUrl) return env === (0, $iZhen.envType).PROD ? $271f084adaa9086b$var$STARGATE_FEDRAMP_PROD_HOST : $271f084adaa9086b$var$handleFedRampStagingStargate();
    /**
	 * Stargate proxy path now needs to be the default to work around browser restrictions with cookies.
	 * For more details, see:
	 *  - https://experimentation-platform.atlassian.net/browse/MHD-326, and
	 *  - https://hello.atlassian.net/wiki/spaces/I/pages/1217206437/api-private+is+broken+is+your+product+impacted
	 */ return window.location.host + $271f084adaa9086b$var$STARGATE_PROXY_PATH;
};
const $271f084adaa9086b$var$handleCommercial = ({ useStargate: useStargate, env: env, useLegacyUrl: useLegacyUrl })=>{
    if (!useStargate) return env === (0, $iZhen.envType).PROD ? $271f084adaa9086b$var$PROD_HOST : $271f084adaa9086b$var$STAGING_HOST;
    if (useLegacyUrl) return env === (0, $iZhen.envType).PROD ? $271f084adaa9086b$var$STARGATE_PROD_HOST : $271f084adaa9086b$var$STARGATE_STAGING_HOST;
    /**
	 * Stargate proxy path now needs to be the default to work around browser restrictions with cookies.
	 * For more details, see:
	 *  - https://experimentation-platform.atlassian.net/browse/MHD-326, and
	 *  - https://hello.atlassian.net/wiki/spaces/I/pages/1217206437/api-private+is+broken+is+your+product+impacted
	 */ return window.location.host + $271f084adaa9086b$var$STARGATE_PROXY_PATH;
};
function $271f084adaa9086b$export$18c0b81944902eae({ useStargate: useStargate, env: env, useLegacyUrl: useLegacyUrl, perimeter: perimeter, envOverride: envOverride }) {
    if (perimeter === (0, $iZhen.perimeterType).FEDRAMP_MODERATE) return $271f084adaa9086b$var$handleFedRampModerate({
        useStargate: useStargate,
        env: env,
        useLegacyUrl: useLegacyUrl,
        envOverride: envOverride
    });
    return $271f084adaa9086b$var$handleCommercial({
        useStargate: useStargate,
        env: env,
        useLegacyUrl: useLegacyUrl
    });
}
function $271f084adaa9086b$export$83a9dd8d74be72c({ apiHost: apiHost }) {
    return apiHost === window.location.host + $271f084adaa9086b$var$STARGATE_PROXY_PATH;
}
function $271f084adaa9086b$export$f276ce8838b8fe0({ env: env, perimeter: perimeter }) {
    if (perimeter === (0, $iZhen.perimeterType).FEDRAMP_MODERATE) return env === (0, $iZhen.envType).PROD ? $271f084adaa9086b$var$FEDRAMP_PROD_HOST : $271f084adaa9086b$var$handleFedRampStagingDirect();
    return env === (0, $iZhen.envType).PROD ? $271f084adaa9086b$var$PROD_HOST : $271f084adaa9086b$var$STAGING_HOST;
}

});

parcelRegister("ztCik", function(module, exports) {

$parcel$export(module.exports, "TestSupport", () => $de60eec8e954ee73$export$44b578549c42d779);
class $de60eec8e954ee73$export$44b578549c42d779 {
    static{
        this.DISABLE_METADATA_CALLS_PROPERTY = '__awc_disable_metadata_calls__';
    }
    static{
        this.DISABLE_EVENT_CALLS_PROPERTY = '__awc_disable_event_calls__';
    }
    static{
        this.DISABLE_FETCH_CALLS_PROPERTY = '__awc_disable_fetch_calls__';
    }
    static isGeminiVREnvironment() {
        try {
            for(const k in $parcel$global){
                if (k.startsWith('__gemini_') && k.endsWith('__')) return true;
            }
        } catch (e) {
        // ignore
        }
        return false;
    }
    static areMetadataCallsDisabled() {
        return this.areFetchCallsDisabled() || this.getGlobalBooleanProperty($de60eec8e954ee73$export$44b578549c42d779.DISABLE_METADATA_CALLS_PROPERTY);
    }
    static areEventCallsDisabled() {
        return this.areFetchCallsDisabled() || this.getGlobalBooleanProperty($de60eec8e954ee73$export$44b578549c42d779.DISABLE_EVENT_CALLS_PROPERTY);
    }
    static areFetchCallsDisabled() {
        return this.getGlobalBooleanProperty($de60eec8e954ee73$export$44b578549c42d779.DISABLE_FETCH_CALLS_PROPERTY);
    }
    static getGlobalBooleanProperty(propertyName) {
        if ($parcel$global && $parcel$global.hasOwnProperty(propertyName)) return $parcel$global[propertyName] === true;
        return false;
    }
}

});

parcelRegister("ebE7i", function(module, exports) {

$parcel$export(module.exports, "fetchMetadata", () => $673bd1d6a145d56d$export$55b0d0261469055);

var $8QpSo = parcelRequire("8QpSo");

var $gjgR4 = parcelRequire("gjgR4");
const $673bd1d6a145d56d$export$55b0d0261469055 = async (url, params, timeout, signal)=>{
    const requestAbortController = $673bd1d6a145d56d$var$createRequestAbortController(timeout, signal);
    const corsOptions = $673bd1d6a145d56d$var$getCorsForUrl(url);
    const metadataUrl = url + '?' + new URLSearchParams({
        product: `${params.product}`,
        userId: `${params.userInfo?.userId || ''}`,
        userIdType: `${params.userInfo?.userIdType || ''}`,
        tenantId: `${params.tenantInfo?.tenantId || ''}`,
        tenantIdType: `${params.tenantInfo?.tenantIdType || ''}`
    }).toString();
    const response = await fetch(metadataUrl, {
        method: 'GET',
        signal: requestAbortController.signal,
        ...corsOptions
    });
    // Response must be a 200 (we expect a JSON response, so 204 is not valid for instance)
    if (response.status !== 200) throw new (0, $gjgR4.FetchError)(`Metadata: HTTP Error ${response.status} (${response.statusText})`, response.status, response.statusText);
    return response;
};
const $673bd1d6a145d56d$var$createRequestAbortController = (timeout, signal)=>{
    const abortController = new AbortController();
    setTimeout(()=>{
        abortController.abort();
    }, timeout || 30000);
    signal?.addEventListener('abort', ()=>{
        abortController.abort();
    });
    return abortController;
};
// To ensure we always have cookies, we should check if the origins match.
// If they dont, we need to set mode to `cors` and credentials to `include`.
const $673bd1d6a145d56d$var$getCorsForUrl = (0, $8QpSo.default)((url)=>{
    const origin = new URL(url).origin;
    if (origin === location.origin) return {};
    else return {
        mode: 'cors',
        credentials: 'include'
    };
});

});


parcelRegister("cxufL", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b6cb20f24034e63$export$2e2bcd8739ae039);

var $iZhen = parcelRequire("iZhen");

var $d7bc1 = parcelRequire("d7bc1");
class $4b6cb20f24034e63$export$2e2bcd8739ae039 {
    constructor(){
        this.handleOriginParameters = (originParamHandlerMapping, historyReplaceFn)=>{
            // Collect all the parameter labels to be handled
            const originParamLabelList = Object.keys(originParamHandlerMapping);
            if (!(originParamLabelList.length > 0)) throw new Error('Empty parameter mapping provided');
            // Check if the parameter labels are valid. If any invalid labels are found throw an exception.
            const invalidParams = originParamLabelList.filter((x)=>Object.values((0, $iZhen.originTracingType)).indexOf(x) < 0);
            if (invalidParams.length > 0) throw new Error(`Invalid Origin Tracing Parameter(s) supplied: ${invalidParams.join()}!`);
            const isCaptureParam = (_, key)=>originParamLabelList.indexOf(key) >= 0;
            // Capture and remove params from URL
            const capturedURLParams = (0, $d7bc1.default)(isCaptureParam, historyReplaceFn);
            // Apply provided handler function to extract origin trace ID from each URL parameter
            const applyHandlerFunction = (key)=>{
                const x = originParamHandlerMapping[key](capturedURLParams[key]);
                return {
                    [key]: x
                };
            };
            const extractedOriginID = Object.keys(capturedURLParams).map(applyHandlerFunction).reduce((accumulator, currentValue)=>Object.assign(accumulator, currentValue), {});
            return extractedOriginID;
        };
        this._originStore = {};
    }
}

});
parcelRegister("d7bc1", function(module, exports) {

$parcel$export(module.exports, "defaultHistoryReplaceFn", () => $48efccf7b35993ac$export$600dd5bf1b049f11);
$parcel$export(module.exports, "default", () => $48efccf7b35993ac$export$2e2bcd8739ae039);

var $dFA29 = parcelRequire("dFA29");

var $gYqa8 = parcelRequire("gYqa8");
const $48efccf7b35993ac$export$600dd5bf1b049f11 = (newUrl)=>window.history.replaceState({}, '', newUrl);
const $48efccf7b35993ac$var$urlParamExtractor = (isCaptureParam, historyReplaceFn = $48efccf7b35993ac$export$600dd5bf1b049f11)=>{
    // Extract target parameters and values from URL if present
    const originalUrl = window.location.href;
    const fragmentHash = window.location.hash;
    const removedFragmentURL = fragmentHash !== '' ? originalUrl.replace(fragmentHash, '') : originalUrl;
    const { url: url, query: query } = (0, $dFA29.parseUrl)(removedFragmentURL);
    const captureParams = (0, $gYqa8.pickBy)(query, isCaptureParam);
    // Do not modify URL if no matches
    if (Object.keys(captureParams).length > 0) {
        const queryWithoutCaptureParams = (0, $gYqa8.omitBy)(query, isCaptureParam);
        // Replace the URL minus captured parameters
        if (Object.keys(queryWithoutCaptureParams).length > 0) {
            const newUrl = `${url}?${(0, $dFA29.stringify)(queryWithoutCaptureParams)}${fragmentHash}`;
            historyReplaceFn(newUrl);
        } else historyReplaceFn(`${url}${fragmentHash}`);
    }
    return captureParams;
};
var $48efccf7b35993ac$export$2e2bcd8739ae039 = $48efccf7b35993ac$var$urlParamExtractor;

});
parcelRegister("dFA29", function(module, exports) {

$parcel$export(module.exports, "extract", () => $9f3b0e3f738c0c19$export$f9380c9a627682d3, (v) => $9f3b0e3f738c0c19$export$f9380c9a627682d3 = v);
$parcel$export(module.exports, "parse", () => $9f3b0e3f738c0c19$export$98e6a39c04603d36, (v) => $9f3b0e3f738c0c19$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "stringify", () => $9f3b0e3f738c0c19$export$fac44ee5b035f737, (v) => $9f3b0e3f738c0c19$export$fac44ee5b035f737 = v);
$parcel$export(module.exports, "parseUrl", () => $9f3b0e3f738c0c19$export$7a5253c0f62e0150, (v) => $9f3b0e3f738c0c19$export$7a5253c0f62e0150 = v);
$parcel$export(module.exports, "stringifyUrl", () => $9f3b0e3f738c0c19$export$a8c1621ea79325d3, (v) => $9f3b0e3f738c0c19$export$a8c1621ea79325d3 = v);
$parcel$export(module.exports, "pick", () => $9f3b0e3f738c0c19$export$357523c63a2253b9, (v) => $9f3b0e3f738c0c19$export$357523c63a2253b9 = v);
var $9f3b0e3f738c0c19$export$f9380c9a627682d3;
var $9f3b0e3f738c0c19$export$98e6a39c04603d36;
var $9f3b0e3f738c0c19$export$fac44ee5b035f737;
var $9f3b0e3f738c0c19$export$7a5253c0f62e0150;
var $9f3b0e3f738c0c19$export$a8c1621ea79325d3;
var $9f3b0e3f738c0c19$export$357523c63a2253b9;
var $9f3b0e3f738c0c19$export$44c361b8ec72ef7f;
'use strict';

var $hlggt = parcelRequire("hlggt");

var $aCrRe = parcelRequire("aCrRe");

var $gjKya = parcelRequire("gjKya");

var $cNVkY = parcelRequire("cNVkY");
const $9f3b0e3f738c0c19$var$isNullOrUndefined = (value)=>value === null || value === undefined;
const $9f3b0e3f738c0c19$var$encodeFragmentIdentifier = Symbol('encodeFragmentIdentifier');
function $9f3b0e3f738c0c19$var$encoderForArrayFormat(options) {
    switch(options.arrayFormat){
        case 'index':
            return (key)=>(result, value)=>{
                    const index = result.length;
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            $9f3b0e3f738c0c19$var$encode(key, options),
                            '[',
                            index,
                            ']'
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            $9f3b0e3f738c0c19$var$encode(key, options),
                            '[',
                            $9f3b0e3f738c0c19$var$encode(index, options),
                            ']=',
                            $9f3b0e3f738c0c19$var$encode(value, options)
                        ].join('')
                    ];
                };
        case 'bracket':
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            $9f3b0e3f738c0c19$var$encode(key, options),
                            '[]'
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            $9f3b0e3f738c0c19$var$encode(key, options),
                            '[]=',
                            $9f3b0e3f738c0c19$var$encode(value, options)
                        ].join('')
                    ];
                };
        case 'colon-list-separator':
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            $9f3b0e3f738c0c19$var$encode(key, options),
                            ':list='
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            $9f3b0e3f738c0c19$var$encode(key, options),
                            ':list=',
                            $9f3b0e3f738c0c19$var$encode(value, options)
                        ].join('')
                    ];
                };
        case 'comma':
        case 'separator':
        case 'bracket-separator':
            {
                const keyValueSep = options.arrayFormat === 'bracket-separator' ? '[]=' : '=';
                return (key)=>(result, value)=>{
                        if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                        // Translate null to an empty string so that it doesn't serialize as 'null'
                        value = value === null ? '' : value;
                        if (result.length === 0) return [
                            [
                                $9f3b0e3f738c0c19$var$encode(key, options),
                                keyValueSep,
                                $9f3b0e3f738c0c19$var$encode(value, options)
                            ].join('')
                        ];
                        return [
                            [
                                result,
                                $9f3b0e3f738c0c19$var$encode(value, options)
                            ].join(options.arrayFormatSeparator)
                        ];
                    };
            }
        default:
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        $9f3b0e3f738c0c19$var$encode(key, options)
                    ];
                    return [
                        ...result,
                        [
                            $9f3b0e3f738c0c19$var$encode(key, options),
                            '=',
                            $9f3b0e3f738c0c19$var$encode(value, options)
                        ].join('')
                    ];
                };
    }
}
function $9f3b0e3f738c0c19$var$parserForArrayFormat(options) {
    let result;
    switch(options.arrayFormat){
        case 'index':
            return (key, value, accumulator)=>{
                result = /\[(\d*)\]$/.exec(key);
                key = key.replace(/\[\d*\]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) accumulator[key] = {};
                accumulator[key][result[1]] = value;
            };
        case 'bracket':
            return (key, value, accumulator)=>{
                result = /(\[\])$/.exec(key);
                key = key.replace(/\[\]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case 'colon-list-separator':
            return (key, value, accumulator)=>{
                result = /(:list)$/.exec(key);
                key = key.replace(/:list$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case 'comma':
        case 'separator':
            return (key, value, accumulator)=>{
                const isArray = typeof value === 'string' && value.includes(options.arrayFormatSeparator);
                const isEncodedArray = typeof value === 'string' && !isArray && $9f3b0e3f738c0c19$var$decode(value, options).includes(options.arrayFormatSeparator);
                value = isEncodedArray ? $9f3b0e3f738c0c19$var$decode(value, options) : value;
                const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map((item)=>$9f3b0e3f738c0c19$var$decode(item, options)) : value === null ? value : $9f3b0e3f738c0c19$var$decode(value, options);
                accumulator[key] = newValue;
            };
        case 'bracket-separator':
            return (key, value, accumulator)=>{
                const isArray = /(\[\])$/.test(key);
                key = key.replace(/\[\]$/, '');
                if (!isArray) {
                    accumulator[key] = value ? $9f3b0e3f738c0c19$var$decode(value, options) : value;
                    return;
                }
                const arrayValue = value === null ? [] : value.split(options.arrayFormatSeparator).map((item)=>$9f3b0e3f738c0c19$var$decode(item, options));
                if (accumulator[key] === undefined) {
                    accumulator[key] = arrayValue;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], arrayValue);
            };
        default:
            return (key, value, accumulator)=>{
                if (accumulator[key] === undefined) {
                    accumulator[key] = value;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
    }
}
function $9f3b0e3f738c0c19$var$validateArrayFormatSeparator(value) {
    if (typeof value !== 'string' || value.length !== 1) throw new TypeError('arrayFormatSeparator must be single character string');
}
function $9f3b0e3f738c0c19$var$encode(value, options) {
    if (options.encode) return options.strict ? $hlggt(value) : encodeURIComponent(value);
    return value;
}
function $9f3b0e3f738c0c19$var$decode(value, options) {
    if (options.decode) return $aCrRe(value);
    return value;
}
function $9f3b0e3f738c0c19$var$keysSorter(input) {
    if (Array.isArray(input)) return input.sort();
    if (typeof input === 'object') return $9f3b0e3f738c0c19$var$keysSorter(Object.keys(input)).sort((a, b)=>Number(a) - Number(b)).map((key)=>input[key]);
    return input;
}
function $9f3b0e3f738c0c19$var$removeHash(input) {
    const hashStart = input.indexOf('#');
    if (hashStart !== -1) input = input.slice(0, hashStart);
    return input;
}
function $9f3b0e3f738c0c19$var$getHash(url) {
    let hash = '';
    const hashStart = url.indexOf('#');
    if (hashStart !== -1) hash = url.slice(hashStart);
    return hash;
}
function $9f3b0e3f738c0c19$var$extract(input) {
    input = $9f3b0e3f738c0c19$var$removeHash(input);
    const queryStart = input.indexOf('?');
    if (queryStart === -1) return '';
    return input.slice(queryStart + 1);
}
function $9f3b0e3f738c0c19$var$parseValue(value, options) {
    if (options.parseNumbers && !Number.isNaN(Number(value)) && typeof value === 'string' && value.trim() !== '') value = Number(value);
    else if (options.parseBooleans && value !== null && (value.toLowerCase() === 'true' || value.toLowerCase() === 'false')) value = value.toLowerCase() === 'true';
    return value;
}
function $9f3b0e3f738c0c19$var$parse(query, options) {
    options = Object.assign({
        decode: true,
        sort: true,
        arrayFormat: 'none',
        arrayFormatSeparator: ',',
        parseNumbers: false,
        parseBooleans: false
    }, options);
    $9f3b0e3f738c0c19$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const formatter = $9f3b0e3f738c0c19$var$parserForArrayFormat(options);
    // Create an object with no prototype
    const ret = Object.create(null);
    if (typeof query !== 'string') return ret;
    query = query.trim().replace(/^[?#&]/, '');
    if (!query) return ret;
    for (const param of query.split('&')){
        if (param === '') continue;
        let [key, value] = $gjKya(options.decode ? param.replace(/\+/g, ' ') : param, '=');
        // Missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        value = value === undefined ? null : [
            'comma',
            'separator',
            'bracket-separator'
        ].includes(options.arrayFormat) ? value : $9f3b0e3f738c0c19$var$decode(value, options);
        formatter($9f3b0e3f738c0c19$var$decode(key, options), value, ret);
    }
    for (const key of Object.keys(ret)){
        const value = ret[key];
        if (typeof value === 'object' && value !== null) for (const k of Object.keys(value))value[k] = $9f3b0e3f738c0c19$var$parseValue(value[k], options);
        else ret[key] = $9f3b0e3f738c0c19$var$parseValue(value, options);
    }
    if (options.sort === false) return ret;
    return (options.sort === true ? Object.keys(ret).sort() : Object.keys(ret).sort(options.sort)).reduce((result, key)=>{
        const value = ret[key];
        if (Boolean(value) && typeof value === 'object' && !Array.isArray(value)) // Sort object keys, not values
        result[key] = $9f3b0e3f738c0c19$var$keysSorter(value);
        else result[key] = value;
        return result;
    }, Object.create(null));
}
$9f3b0e3f738c0c19$export$f9380c9a627682d3 = $9f3b0e3f738c0c19$var$extract;
$9f3b0e3f738c0c19$export$98e6a39c04603d36 = $9f3b0e3f738c0c19$var$parse;
$9f3b0e3f738c0c19$export$fac44ee5b035f737 = (object, options)=>{
    if (!object) return '';
    options = Object.assign({
        encode: true,
        strict: true,
        arrayFormat: 'none',
        arrayFormatSeparator: ','
    }, options);
    $9f3b0e3f738c0c19$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const shouldFilter = (key)=>options.skipNull && $9f3b0e3f738c0c19$var$isNullOrUndefined(object[key]) || options.skipEmptyString && object[key] === '';
    const formatter = $9f3b0e3f738c0c19$var$encoderForArrayFormat(options);
    const objectCopy = {};
    for (const key of Object.keys(object))if (!shouldFilter(key)) objectCopy[key] = object[key];
    const keys = Object.keys(objectCopy);
    if (options.sort !== false) keys.sort(options.sort);
    return keys.map((key)=>{
        const value = object[key];
        if (value === undefined) return '';
        if (value === null) return $9f3b0e3f738c0c19$var$encode(key, options);
        if (Array.isArray(value)) {
            if (value.length === 0 && options.arrayFormat === 'bracket-separator') return $9f3b0e3f738c0c19$var$encode(key, options) + '[]';
            return value.reduce(formatter(key), []).join('&');
        }
        return $9f3b0e3f738c0c19$var$encode(key, options) + '=' + $9f3b0e3f738c0c19$var$encode(value, options);
    }).filter((x)=>x.length > 0).join('&');
};
$9f3b0e3f738c0c19$export$7a5253c0f62e0150 = (url, options)=>{
    options = Object.assign({
        decode: true
    }, options);
    const [url_, hash] = $gjKya(url, '#');
    return Object.assign({
        url: url_.split('?')[0] || '',
        query: $9f3b0e3f738c0c19$var$parse($9f3b0e3f738c0c19$var$extract(url), options)
    }, options && options.parseFragmentIdentifier && hash ? {
        fragmentIdentifier: $9f3b0e3f738c0c19$var$decode(hash, options)
    } : {});
};
$9f3b0e3f738c0c19$export$a8c1621ea79325d3 = (object, options)=>{
    options = Object.assign({
        encode: true,
        strict: true,
        [$9f3b0e3f738c0c19$var$encodeFragmentIdentifier]: true
    }, options);
    const url = $9f3b0e3f738c0c19$var$removeHash(object.url).split('?')[0] || '';
    const queryFromUrl = $9f3b0e3f738c0c19$export$f9380c9a627682d3(object.url);
    const parsedQueryFromUrl = $9f3b0e3f738c0c19$export$98e6a39c04603d36(queryFromUrl, {
        sort: false
    });
    const query = Object.assign(parsedQueryFromUrl, object.query);
    let queryString = $9f3b0e3f738c0c19$export$fac44ee5b035f737(query, options);
    if (queryString) queryString = `?${queryString}`;
    let hash = $9f3b0e3f738c0c19$var$getHash(object.url);
    if (object.fragmentIdentifier) hash = `#${options[$9f3b0e3f738c0c19$var$encodeFragmentIdentifier] ? $9f3b0e3f738c0c19$var$encode(object.fragmentIdentifier, options) : object.fragmentIdentifier}`;
    return `${url}${queryString}${hash}`;
};
$9f3b0e3f738c0c19$export$357523c63a2253b9 = (input, filter, options)=>{
    options = Object.assign({
        parseFragmentIdentifier: true,
        [$9f3b0e3f738c0c19$var$encodeFragmentIdentifier]: false
    }, options);
    const { url: url, query: query, fragmentIdentifier: fragmentIdentifier } = $9f3b0e3f738c0c19$export$7a5253c0f62e0150(input, options);
    return $9f3b0e3f738c0c19$export$a8c1621ea79325d3({
        url: url,
        query: $cNVkY(query, filter),
        fragmentIdentifier: fragmentIdentifier
    }, options);
};
$9f3b0e3f738c0c19$export$44c361b8ec72ef7f = (input, filter, options)=>{
    const exclusionFilter = Array.isArray(filter) ? (key)=>!filter.includes(key) : (key, value)=>!filter(key, value);
    return $9f3b0e3f738c0c19$export$357523c63a2253b9(input, exclusionFilter, options);
};

});



parcelRegister("4NslB", function(module, exports) {

$parcel$export(module.exports, "default", () => $4edf0393cec4b422$export$2e2bcd8739ae039);

var $KX1VQ = parcelRequire("KX1VQ");
const $4edf0393cec4b422$var$SESSION_ID_STORAGE_KEY = 'session.id';
const $4edf0393cec4b422$var$SESSION_EXPIRY_STORAGE_KEY = 'session.expiry';
const $4edf0393cec4b422$var$ONLY_NUMBERS_REGEX = /^\d+$/;
const $4edf0393cec4b422$export$285f6bddd927a06d = 1800000; // 30 minutes
const $4edf0393cec4b422$export$a92e915d70316eb2 = 5000; // 5 seconds
const $4edf0393cec4b422$export$de43760b2dc10c19 = 0.9; // 90% of expiry
const $4edf0393cec4b422$export$5702a91a6f42969f = ()=>{};
class $4edf0393cec4b422$export$2e2bcd8739ae039 {
    constructor(options = {}){
        this._generateNewSessionId = ()=>{
            const newSessionId = Date.now().toString();
            this._safeLocalStorage.setItem($4edf0393cec4b422$var$SESSION_ID_STORAGE_KEY, newSessionId);
            // COMMENTS-123 - When a new session starts, call the callback if it is given
            this._onNewSessionStarted && this._onNewSessionStarted();
            return newSessionId;
        };
        this._updateSessionExpiry = ()=>{
            const expiry = Date.now() + this._sessionExpiryTime;
            this._safeLocalStorage.setItem($4edf0393cec4b422$var$SESSION_EXPIRY_STORAGE_KEY, expiry.toString());
            return expiry;
        };
        this._debouncedUpdateSessionExpiry = (currentExpiry)=>{
            const { _updateSessionExpiry: _updateSessionExpiry } = this;
            // If the current expiry is out of date by more than 10% of the expiry, update immediately
            if (currentExpiry < Date.now() + this._sessionExpiryDebounceThresholdPercentage * this._sessionExpiryTime) return _updateSessionExpiry();
            else {
                if (this._sessionExpiryDebounceTimer) clearTimeout(this._sessionExpiryDebounceTimer);
                // @ts-ignore Something wrong with our types... this is legit
                this._sessionExpiryDebounceTimer = setTimeout(()=>{
                    _updateSessionExpiry();
                }, this._sessionExpiryDebounce);
            }
        };
        this._sessionExpiryTime = options.sessionExpiryTime || $4edf0393cec4b422$export$285f6bddd927a06d;
        this._sessionExpiryDebounce = options.sessionExpiryDebounce || $4edf0393cec4b422$export$a92e915d70316eb2;
        this._sessionExpiryDebounceThresholdPercentage = options.sessionExpiryDebounceThresholdPercentage || $4edf0393cec4b422$export$de43760b2dc10c19;
        this._onNewSessionStarted = options.onNewSessionStarted ? options.onNewSessionStarted : $4edf0393cec4b422$export$5702a91a6f42969f;
        this._safeLocalStorage = new (0, $KX1VQ.default)();
    }
    getCurrentSessionId() {
        const sessionId = this._safeLocalStorage.getItem($4edf0393cec4b422$var$SESSION_ID_STORAGE_KEY);
        const sessionExpiry = parseInt(this._safeLocalStorage.getItem($4edf0393cec4b422$var$SESSION_EXPIRY_STORAGE_KEY) || '0', 10) || 0;
        this._debouncedUpdateSessionExpiry(sessionExpiry);
        if (!sessionId || sessionExpiry <= Date.now() || Number.isNaN(sessionExpiry)) return this._generateNewSessionId();
        // Old versions of sessionId were UUIDs which caused issues for Amplitude which only accepts
        // integers for this field. In these scenarios we want to regenerate the sessionId as an integer
        if (!$4edf0393cec4b422$var$ONLY_NUMBERS_REGEX.test(sessionId)) return this._generateNewSessionId();
        return sessionId;
    }
}

});

parcelRegister("lbyTT", function(module, exports) {

$parcel$export(module.exports, "default", () => $3dab3cde056915e8$export$2e2bcd8739ae039);

var $8TsCv = parcelRequire("8TsCv");

var $5jnRh = parcelRequire("5jnRh");
class $3dab3cde056915e8$export$2e2bcd8739ae039 extends (0, $5jnRh.default) {
    constructor(options){
        let storageToUse;
        try {
            storageToUse = window.sessionStorage || (0, $8TsCv.default);
        } catch (err) {
            storageToUse = (0, $8TsCv.default);
        }
        super(storageToUse, options);
    }
}

});

parcelRegister("5cwz8", function(module, exports) {

$parcel$export(module.exports, "default", () => $1cc99fb31715affb$export$2e2bcd8739ae039);

var $bXrHm = parcelRequire("bXrHm");

var $lbyTT = parcelRequire("lbyTT");
const $1cc99fb31715affb$var$STORAGE_KEY = 'tab.id';
class $1cc99fb31715affb$export$2e2bcd8739ae039 {
    constructor(){
        this._generateNewTabId = ()=>{
            const newTabId = (0, (/*@__PURE__*/$parcel$interopDefault($bXrHm)))();
            this._safeSessionStorage.setItem($1cc99fb31715affb$var$STORAGE_KEY, newTabId);
            return newTabId;
        };
        this._safeSessionStorage = new (0, $lbyTT.default)();
    }
    getCurrentTabId() {
        let tabId = this._safeSessionStorage.getItem($1cc99fb31715affb$var$STORAGE_KEY);
        if (!tabId) tabId = this._generateNewTabId();
        return tabId;
    }
}

});

parcelRegister("3ErS8", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c958a1cb0049824$export$2e2bcd8739ae039);

var $dFA29 = parcelRequire("dFA29");

var $bXrHm = parcelRequire("bXrHm");

var $iZhen = parcelRequire("iZhen");

var $gYqa8 = parcelRequire("gYqa8");

var $lbyTT = parcelRequire("lbyTT");

var $d7bc1 = parcelRequire("d7bc1");
const $8c958a1cb0049824$var$STORAGE_KEY = 'taskSessions';
const $8c958a1cb0049824$var$INIT_KEY = 'taskSessionsInit';
const $8c958a1cb0049824$var$AWC_PARAM_PREFIX = 'awc.';
const $8c958a1cb0049824$var$TASK_SESSION_RELOAD_TIME = 3000;
class $8c958a1cb0049824$export$2e2bcd8739ae039 {
    constructor(){
        this._taskSessionsNotRecentlyInitialised = (currentTimestamp)=>this._safeSessionStorage.getItem($8c958a1cb0049824$var$STORAGE_KEY) === null || this._safeSessionStorage.getItem($8c958a1cb0049824$var$INIT_KEY) === null || parseInt(this._safeSessionStorage.getItem($8c958a1cb0049824$var$INIT_KEY) || '0', 10) < currentTimestamp - $8c958a1cb0049824$var$TASK_SESSION_RELOAD_TIME;
        this._removeTaskSessionPrefix = (_, taskSessionName)=>taskSessionName.split($8c958a1cb0049824$var$AWC_PARAM_PREFIX)[1];
        this._isTaskSessionQueryParam = (_, taskSessionName)=>taskSessionName.startsWith($8c958a1cb0049824$var$AWC_PARAM_PREFIX);
        this.getAllTaskSessions = ()=>{
            try {
                return JSON.parse(this._safeSessionStorage.getItem($8c958a1cb0049824$var$STORAGE_KEY) || '');
            } catch (e) {
                return {};
            }
        };
        this._writeToSessionStorage = (taskSessions)=>{
            try {
                this._safeSessionStorage.setItem($8c958a1cb0049824$var$STORAGE_KEY, JSON.stringify(taskSessions));
            // eslint-disable-next-line no-empty
            } catch (e) {}
        };
        this._appendTaskSessions = (newTaskSessions)=>{
            const currentState = this.getAllTaskSessions();
            const newState = currentState === null ? newTaskSessions : Object.assign(currentState, newTaskSessions);
            this._writeToSessionStorage(newState);
        };
        this._safelyRemoveKey = (currentState, taskSessionName)=>{
            if (currentState === null) return {};
            delete currentState[taskSessionName];
            return currentState;
        };
        this.createTaskSession = (taskSessionName)=>{
            const taskSessionId = (0, (/*@__PURE__*/$parcel$interopDefault($bXrHm)))();
            const newTaskSessions = {};
            newTaskSessions[taskSessionName] = taskSessionId;
            this._appendTaskSessions(newTaskSessions);
            return taskSessionId;
        };
        this.createTaskSessionWithProvidedId = (taskSessionName, taskSessionId)=>{
            if (typeof taskSessionId !== 'string') throw new TypeError('invalid taskSessionId, must be string');
            const newTaskSessions = {};
            newTaskSessions[taskSessionName] = taskSessionId;
            this._appendTaskSessions(newTaskSessions);
        };
        this.completeTaskSession = (taskSessionName)=>{
            const currentState = this.getAllTaskSessions();
            const updatedState = this._safelyRemoveKey(currentState, taskSessionName);
            this._writeToSessionStorage(updatedState);
        };
        this.formatTaskSessionQueryString = ({ uri: uri, includedTaskSessions: includedTaskSessions })=>{
            const { url: url, query: query } = (0, $dFA29.parseUrl)(uri);
            const currentState = this.getAllTaskSessions();
            // Use specified task sessions, otherwise all tasksessions excluding originTracing sessions
            const filteredTaskSessions = includedTaskSessions ? (0, $gYqa8.pick)(currentState, includedTaskSessions) : (0, $gYqa8.omit)(currentState, Object.values((0, $iZhen.originTracingType)));
            if (Object.keys(filteredTaskSessions).length === 0) return uri;
            const queryWithTaskSessions = {
                ...(0, $gYqa8.mapKeys)(filteredTaskSessions, (_, taskSessionName)=>$8c958a1cb0049824$var$AWC_PARAM_PREFIX + taskSessionName),
                ...query
            };
            return `${url}?${(0, $dFA29.stringify)(queryWithTaskSessions)}`;
        };
        this.stripQueryParameters = ()=>{
            const extractedTaskSessions = (0, $gYqa8.mapKeys)((0, $d7bc1.default)(this._isTaskSessionQueryParam), this._removeTaskSessionPrefix);
            this._appendTaskSessions(extractedTaskSessions);
        };
        const currentTimestamp = Date.now();
        this._safeSessionStorage = new (0, $lbyTT.default)();
        // Wrapping all sessionStorage calls in try catch to stop any error propogation, taskSessions should gracefully fail.
        try {
            if (this._taskSessionsNotRecentlyInitialised(currentTimestamp)) {
                this._writeToSessionStorage({});
                this._safeSessionStorage.setItem($8c958a1cb0049824$var$INIT_KEY, currentTimestamp.toString());
            }
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}

});

parcelRegister("fOR5Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $de63b39d39935d35$export$2e2bcd8739ae039);

var $eYli8 = parcelRequire("eYli8");

var $hDpfo = parcelRequire("hDpfo");
const $de63b39d39935d35$var$MAX_CACHE_SIZE = 100;
const $de63b39d39935d35$var$COOKIE_NAME = (0, $hDpfo.AllAnalyticsCookies).AWC_ANALYTICS_DEBUG.getKey();
const $de63b39d39935d35$var$DEBUG_TAG = 'synthetic';
const $de63b39d39935d35$var$getDebugCookie = ()=>{
    try {
        return JSON.parse((0, (/*@__PURE__*/$parcel$interopDefault($eYli8))).get($de63b39d39935d35$var$COOKIE_NAME) || 'false');
    } catch (error) {
        (0, (/*@__PURE__*/$parcel$interopDefault($eYli8))).remove($de63b39d39935d35$var$COOKIE_NAME);
    }
    return false;
};
class $de63b39d39935d35$var$TestingCache {
    constructor(){
        this._bind = ()=>{
            if (typeof window === 'undefined' || window.testAnalytics) return;
            window.testAnalytics = {
                eventCache: [],
                events: ()=>window.testAnalytics.eventCache,
                clear: ()=>{
                    window.testAnalytics.eventCache = [];
                    try {
                        localStorage.removeItem('awc.ui.viewed.last.sent');
                        localStorage.removeItem('awc-staging.ui.viewed.last.sent');
                        localStorage.removeItem('awc-dev.ui.viewed.last.sent');
                        localStorage.removeItem('awc-local.ui.viewed.last.sent');
                    } catch (_error) {
                    // Ignore errors from localStorage.
                    }
                }
            };
        };
        this._cache = (event)=>{
            if (typeof window === 'undefined') return;
            if (window.testAnalytics.eventCache.length >= $de63b39d39935d35$var$MAX_CACHE_SIZE) window.testAnalytics.eventCache = window.testAnalytics.eventCache.slice(1, window.testAnalytics.eventCache.length);
            window.testAnalytics.eventCache.push(event);
        };
        this._shouldCacheEvent = ()=>this._isDebugCookieEnabled;
        this.saveEvent = (event)=>{
            if (event && this._shouldCacheEvent()) {
                if (!window.testAnalytics) this._bind();
                if (event.tags instanceof Array) event.tags.push($de63b39d39935d35$var$DEBUG_TAG);
                else event.tags = [
                    $de63b39d39935d35$var$DEBUG_TAG
                ];
                this._cache(event);
            }
        };
        this._isDebugCookieEnabled = $de63b39d39935d35$var$getDebugCookie();
        if (this._isDebugCookieEnabled) this._bind();
    }
}
var $de63b39d39935d35$export$2e2bcd8739ae039 = $de63b39d39935d35$var$TestingCache;

});

parcelRegister("edTAR", function(module, exports) {

$parcel$export(module.exports, "default", () => $7fcb679b12390b8a$export$2e2bcd8739ae039);

var $iZhen = parcelRequire("iZhen");

var $KX1VQ = parcelRequire("KX1VQ");
const $7fcb679b12390b8a$var$DEFAULT_DELAY = 2000; // 2 seconds
const $7fcb679b12390b8a$var$DEFAULT_THROTTLE = 3600000; // 1 hour
const $7fcb679b12390b8a$var$DEFAULT_STORAGE_KEY = 'ui.viewed.last.sent';
const $7fcb679b12390b8a$var$DEFAULT_MALFORMED_UIVIEWED_EVENT = 'malformed.uiviewed.last.sent';
class $7fcb679b12390b8a$export$2e2bcd8739ae039 {
    constructor(productInfo, getContext, onEvent, settings = {}){
        this.start = ()=>{
            this._startInterval();
            this._bindEventListeners();
        };
        this.stop = ()=>{
            this._stopInterval();
            this._unbindEventListeners();
        };
        this.resetTimers = ()=>{
            if (this._intervalId) {
                this.stop();
                this.start();
            }
        };
        this._bindEventListeners = ()=>{
            if (typeof window !== 'undefined') {
                window.addEventListener('focus', this._focusListener);
                window.addEventListener('blur', this._blurListener);
            }
        };
        this._unbindEventListeners = ()=>{
            if (typeof window !== 'undefined') {
                window.removeEventListener('focus', this._focusListener);
                window.removeEventListener('blur', this._blurListener);
            }
        };
        this._startInterval = ()=>{
            clearInterval(this._intervalId);
            this._intervalId = setInterval(this._handleInterval, this._delay);
        };
        this._stopInterval = ()=>{
            if (this._intervalId) {
                clearInterval(this._intervalId);
                this._intervalId = null;
            }
        };
        this._getProductKey = (product, subproduct)=>{
            let productKey = product;
            if (subproduct) productKey += `-${subproduct}`;
            return productKey;
        };
        this._getLastSentTimestamp = (productKey, tenantId, userId)=>{
            const json = this._parseLocalStorageData(this._storageKey) || {};
            const u = json[userId] || {};
            const t = u[tenantId] || {};
            const p = t[productKey] || null;
            return p;
        };
        this._parseLocalStorageData = (key)=>{
            const data = this._safeLocalStorage.getItem(key);
            try {
                return JSON.parse(data || '');
            } catch (error) {
                this._safeLocalStorage.removeItem(key);
                return null;
            }
        };
        this._getMalformedLastSentTimestamp = (productKey, tenantId, userId)=>{
            const json = this._parseLocalStorageData(this._malformedEventStorageKey) || {};
            const finalUserId = userId || 'NOT_SET';
            const finalTenantId = tenantId || 'NOT_SET';
            const u = json[finalUserId] || {};
            const t = u[finalTenantId] || {};
            const p = t[productKey] || null;
            return p;
        };
        this._setLastSentTimestamp = (productKey, tenantId, userId)=>{
            const json = this._parseLocalStorageData(this._storageKey) || {};
            const u = json[userId] || {};
            const t = u[tenantId] || {};
            t[productKey] = Date.now();
            u[tenantId] = t;
            json[userId] = u;
            this._safeLocalStorage.setItem(this._storageKey, JSON.stringify(json));
        };
        this._setMalformedLastSentTimestamp = (productKey, tenantId, userId)=>{
            const json = this._parseLocalStorageData(this._malformedEventStorageKey) || {};
            const finalUserId = userId || 'NOT_SET';
            const finalTenantId = tenantId || 'NOT_SET';
            const u = json[finalUserId] || {};
            const t = u[finalTenantId] || {};
            t[productKey] = Date.now();
            u[finalTenantId] = t;
            json[finalUserId] = u;
            this._safeLocalStorage.setItem(this._malformedEventStorageKey, JSON.stringify(json));
        };
        this._shouldSendEvent = (productKey, tenantIdType, tenantId, userId)=>{
            if (!document.hasFocus()) return 'FocusLost';
            // TENANT OR USER ID NOT SET
            if (tenantIdType !== (0, $iZhen.tenantType).NONE && !tenantId || !userId) {
                const sinceLastSent = Date.now() - this._getMalformedLastSentTimestamp(productKey, tenantId, userId);
                if (sinceLastSent === null || sinceLastSent > this._throttle) return 'UserOrTenantIncomplete';
                return 'MalformedUiViewedRateLimited';
            }
            const sinceLastSent = Date.now() - this._getLastSentTimestamp(productKey, tenantId, userId);
            if (sinceLastSent === null || sinceLastSent > this._throttle) return 'EligibleToSend';
            return 'UiViewedRateLimited';
        };
        this._handleInterval = ()=>{
            const { embeddedProduct: embeddedProduct, ...context } = this._getContext();
            this._sendEvent(this._product, context);
            if (embeddedProduct) this._sendEvent(embeddedProduct, context, true);
        };
        this._sendEvent = (product, context, isEmbeddedProduct = false)=>{
            const { subproduct: subproduct, tenantIdType: tenantIdType, tenantId: tenantId, userId: userId, lastScreenEvent: lastScreenEvent, attributes: attributes } = context;
            const productKey = this._getProductKey(product, subproduct);
            const shouldSendEventTriggerStatus = this._shouldSendEvent(productKey, tenantIdType, tenantId, userId);
            switch(shouldSendEventTriggerStatus){
                case 'EligibleToSend':
                    this._setLastSentTimestamp(productKey, tenantId, userId);
                    this._onEvent(this._createEvent(product, subproduct, isEmbeddedProduct, lastScreenEvent, attributes, 'ui', 'viewed'));
                    break;
                case 'UserOrTenantIncomplete':
                    this._setMalformedLastSentTimestamp(productKey, tenantId, userId);
                    this._onEvent(this._createEvent(product, subproduct, isEmbeddedProduct, lastScreenEvent, attributes, 'malformed', 'uiviewed'));
                    break;
                default:
                    break;
            }
        };
        this._createEvent = (product, subproduct, isEmbeddedProduct, lastScreenEvent, extraAttributes, actionSubject, action)=>{
            const event = {
                product: product,
                source: 'ui',
                action: action,
                actionSubject: actionSubject,
                attributes: extraAttributes
            };
            if (isEmbeddedProduct) {
                // Clear the subproduct and version as they don't relate to the embedded product
                event.subproduct = null;
                event.version = null;
                event.attributes = {
                    ...event.attributes,
                    embeddedInEnv: this._productInfo.env,
                    embeddedInProduct: this._productInfo.product,
                    embeddedInSubproduct: subproduct,
                    embeddedInVersion: this._productInfo.version,
                    embeddedInOrigin: this._productInfo.origin,
                    embeddedInPlatform: this._productInfo.platform
                };
            }
            if (lastScreenEvent) event.attributes = {
                ...event.attributes,
                lastScreenEvent: {
                    name: lastScreenEvent.name,
                    attributes: lastScreenEvent.attributes
                }
            };
            return event;
        };
        if (!productInfo) throw new Error('Missing productInfo');
        if (!productInfo.product) throw new Error('Missing productInfo.product');
        if (!getContext) throw new Error('Missing getContext callback');
        if (typeof getContext !== 'function') throw new Error('Invalid getContext, must be function');
        if (!onEvent) throw new Error('Missing onEvent callback');
        if (typeof onEvent !== 'function') throw new Error('Invalid onEvent, must be function');
        this._productInfo = productInfo;
        this._product = productInfo.product;
        this._getContext = getContext;
        this._onEvent = onEvent;
        this._delay = settings.delay || $7fcb679b12390b8a$var$DEFAULT_DELAY;
        this._throttle = settings.throttle || $7fcb679b12390b8a$var$DEFAULT_THROTTLE;
        this._storageKey = settings.storageKey || $7fcb679b12390b8a$var$DEFAULT_STORAGE_KEY;
        this._malformedEventStorageKey = settings.malformedStorageKey || $7fcb679b12390b8a$var$DEFAULT_MALFORMED_UIVIEWED_EVENT;
        this._safeLocalStorage = new (0, $KX1VQ.default)({
            envPrefix: this._productInfo.env
        });
        this._focusListener = ()=>{
            this._startInterval();
        };
        this._blurListener = ()=>{
            this._stopInterval();
        };
    }
}

});

parcelRegister("j7FCN", function(module, exports) {

$parcel$export(module.exports, "default", () => $4efcab6452689b70$export$2e2bcd8739ae039);
function $4efcab6452689b70$export$2e2bcd8739ae039(callback, event) {
    if (!callback || typeof callback !== 'function') return null;
    return ()=>{
        callback(event);
    };
}

});

parcelRegister("iNSWY", function(module, exports) {

$parcel$export(module.exports, "XIDPromise", () => $087b35ad0bdaa6e1$export$fbe53bbbe682bcdd);

var $4LmqD = parcelRequire("4LmqD");
const $087b35ad0bdaa6e1$export$fbe53bbbe682bcdd = (xidConsent, xidPromiseFn)=>{
    if (xidConsent && xidPromiseFn && typeof xidPromiseFn === 'function') {
        const timeoutPromise = ()=>{
            return new Promise((resolve)=>{
                setTimeout(()=>resolve(()=>(0, $4LmqD.createTimeoutXid)()), (0, $4LmqD.XID_TIMEOUT));
            });
        };
        const xidPromise = ()=>{
            return xidPromiseFn().catch(()=>()=>(0, $4LmqD.createUnknownXid)());
        };
        return Promise.race([
            xidPromise(),
            timeoutPromise()
        ]);
    }
    return undefined;
};

});
parcelRegister("4LmqD", function(module, exports) {

$parcel$export(module.exports, "XID_TIMEOUT", () => $ef5896d1f0db8e24$export$545bcbd53afabfa3);
$parcel$export(module.exports, "createTimeoutXid", () => $ef5896d1f0db8e24$export$af4087e36d63846);
$parcel$export(module.exports, "createUnknownXid", () => $ef5896d1f0db8e24$export$fa341d0c750d705b);

var $cLbOk = parcelRequire("cLbOk");
const $ef5896d1f0db8e24$export$545bcbd53afabfa3 = 5000;
const $ef5896d1f0db8e24$export$af4087e36d63846 = ()=>[
        {
            type: (0, $cLbOk.XIDItemType).XC,
            state: 'TIMEOUT'
        },
        {
            type: (0, $cLbOk.XIDItemType).UID,
            state: 'TIMEOUT'
        }
    ];
const $ef5896d1f0db8e24$export$fa341d0c750d705b = ()=>[
        {
            type: (0, $cLbOk.XIDItemType).XC,
            state: 'UNKNOWN'
        },
        {
            type: (0, $cLbOk.XIDItemType).UID,
            state: 'UNKNOWN'
        }
    ];

});
parcelRegister("cLbOk", function(module, exports) {

$parcel$export(module.exports, "XIDItemType", () => $b05a497c89498e1b$export$92ca0438bcb0d396);
var $b05a497c89498e1b$export$92ca0438bcb0d396 = /*#__PURE__*/ function(XIDItemType) {
    XIDItemType["XC"] = "xc";
    XIDItemType["UID"] = "uid";
    return XIDItemType;
}({});
var $b05a497c89498e1b$export$c9079017d1f5aab9 = /*#__PURE__*/ function(XIDState) {
    XIDState["NEW"] = "NEW";
    XIDState["CHANGED"] = "CHANGED";
    XIDState["EXISTING"] = "EXISTING";
    XIDState["TIMEOUT"] = "TIMEOUT";
    XIDState["ERROR"] = "ERROR";
    XIDState["UNAVAILABLE"] = "UNAVAILABLE";
    XIDState["MALFORMED"] = "MALFORMED";
    XIDState["UNKNOWN"] = "UNKNOWN";
    return XIDState;
}({});

});




parcelRegister("cm6fz", function(module, exports) {

$parcel$export(module.exports, "canCompress", () => $1cdc0562980ed846$export$ec3662f84d9f778c);
$parcel$export(module.exports, "buildCompressionFunction", () => $1cdc0562980ed846$export$20de0576abb0bcc5);
const $1cdc0562980ed846$export$ec3662f84d9f778c = (event)=>event.actionSubject === 'feature' && event.action === 'exposed' && event.eventType === 'operational' && event.attributes && event.tags && event.tags.includes('measurement') && !event.tags.includes('hasCustomAttributes');
const $1cdc0562980ed846$export$ca25d5d7792a4f37 = (events, batchSize = 50)=>{
    if (!events || events.length <= 0) return [];
    if (batchSize <= 0) throw new Error('Batch size must be greater than 0');
    // Extract evaluations and reduce into a single array
    const flagEvaluations = events.map((currentEvent)=>{
        const { flagKey: flagKey, value: value, reason: reason, ruleId: ruleId, errorKind: errorKind } = currentEvent.attributes;
        return {
            key: flagKey,
            value: value,
            ...reason && {
                reason: reason
            },
            ...ruleId && {
                ruleId: ruleId
            },
            ...errorKind && {
                errorKind: errorKind
            }
        };
    });
    // Batch evaluations into specified batchSize
    return $1cdc0562980ed846$var$createBatches(flagEvaluations, batchSize);
};
const $1cdc0562980ed846$var$createBatches = (array, batchSize)=>{
    let compressedEvaluations = [];
    for(let i = 0; i < array.length; i += batchSize){
        let evaluationBatch = array.slice(i, i + batchSize);
        compressedEvaluations.push({
            actionSubject: 'features',
            action: 'exposed',
            eventType: 'operational',
            attributes: {
                evaluations: evaluationBatch
            },
            tags: [
                'measurement'
            ],
            source: '@atlassian/exposure-events-compressor'
        });
    }
    return compressedEvaluations;
};
const $1cdc0562980ed846$export$20de0576abb0bcc5 = (batchSize)=>(events)=>$1cdc0562980ed846$export$ca25d5d7792a4f37(events, batchSize);

});

parcelRegister("5bWbX", function(module, exports) {

$parcel$export(module.exports, "default", () => $e546a6b546e21170$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $cb25w = parcelRequire("cb25w");

var $f1t8h = parcelRequire("f1t8h");

var $4qJHz = parcelRequire("4qJHz");

var $5pZVQ = parcelRequire("5pZVQ");
const $e546a6b546e21170$var$EngagementProviderWithEvents = (0, $cb25w.default)()((0, $5pZVQ.EngagementProvider));
const $e546a6b546e21170$var$EngagementProviderWithDefaultStore = (props)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)($e546a6b546e21170$var$EngagementProviderWithEvents, {
        ...props,
        store: (0, $4qJHz.default)(props.config)
    });
};
var $e546a6b546e21170$export$2e2bcd8739ae039 = (0, $f1t8h.default)($e546a6b546e21170$var$EngagementProviderWithDefaultStore);

});
parcelRegister("f1t8h", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ad0ae17a77d9b94$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
function $2ad0ae17a77d9b94$export$2e2bcd8739ae039(Component) {
    const PreventNestedInstancesContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext(false);
    return function PreventNestedInstances(props) {
        return(// TODO: Replace usage of PreventNestedInstancesContext.Consumer with useContext(PreventNestedInstancesContext)
        /*#__PURE__*/ (0, $2OMIu.jsx)(PreventNestedInstancesContext.Consumer, {
            children: (shouldPreventInstantiation)=>shouldPreventInstantiation ? props.children : /*#__PURE__*/ (0, $2OMIu.jsx)(PreventNestedInstancesContext.Provider, {
                    value: true,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
                        ...props
                    })
                })
        }));
    };
}

});

parcelRegister("4qJHz", function(module, exports) {

$parcel$export(module.exports, "store", () => $d623685d32003ec6$export$6f57813fe9f31bf9);
$parcel$export(module.exports, "default", () => $d623685d32003ec6$export$2e2bcd8739ae039);

var $ajpes = parcelRequire("ajpes");

var $3f2cs = parcelRequire("3f2cs");

var $9JnaK = parcelRequire("9JnaK");

var $7CfdH = parcelRequire("7CfdH");

var $kjEZw = parcelRequire("kjEZw");

var $aS5YT = parcelRequire("aS5YT");
const $d623685d32003ec6$export$36d128238e6b60f5 = {
    messageMapping: new Map(),
    current: null,
    initialized: false,
    initializing: false,
    config: {
        cloudId: '',
        aaid: '',
        locale: '',
        product: '',
        stargateUrl: '',
        orgId: '',
        workspaceId: ''
    }
};
let $d623685d32003ec6$var$processMessagesCancellationToken = (0, $9JnaK.createCancellationToken)();
function $d623685d32003ec6$export$7a10f46f72407bc5(messageMapping, component) {
    const newMapping = new Map();
    messageMapping.forEach((value, key)=>{
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(value.component, component)) newMapping.set(key, value);
    });
    return newMapping;
}
const $d623685d32003ec6$export$6f57813fe9f31bf9 = (0, $3f2cs.createStore)((state = $d623685d32003ec6$export$36d128238e6b60f5, action)=>{
    switch(action.type){
        case 0, $kjEZw.SET_MESSAGE_MAPPING:
            return {
                ...state,
                initialized: true,
                initializing: false,
                messageMapping: action.messageMapping
            };
        case 0, $kjEZw.SET_INITIALIZING:
            return {
                ...state,
                config: action.config,
                initializing: true
            };
        case 0, $kjEZw.SET_CURRENT:
            {
                const { eventMapping: eventMapping } = action;
                const { message: message, component: component } = eventMapping;
                const messageMapping = $d623685d32003ec6$export$7a10f46f72407bc5(state.messageMapping, component);
                return {
                    ...state,
                    current: {
                        messageId: message.messageId,
                        variationId: message.variationId,
                        ...component
                    },
                    messageMapping: messageMapping
                };
            }
        case 0, $kjEZw.CLEAR_CURRENT:
            return {
                ...state,
                current: null
            };
        case 0, $kjEZw.RESET_STORE:
            return $d623685d32003ec6$export$36d128238e6b60f5;
        default:
            return state;
    }
});
var $d623685d32003ec6$export$2e2bcd8739ae039 = (config)=>{
    const state = $d623685d32003ec6$export$6f57813fe9f31bf9.getState();
    if (state.initializing || state.initialized) {
        if (state.config.cloudId === config.cloudId) return $d623685d32003ec6$export$6f57813fe9f31bf9;
        // CloudId has changed, cancel any in process processMessages request
        $d623685d32003ec6$var$processMessagesCancellationToken.isCancelled = true;
        $d623685d32003ec6$var$processMessagesCancellationToken = (0, $9JnaK.createCancellationToken)();
        $d623685d32003ec6$export$6f57813fe9f31bf9.dispatch((0, $kjEZw.resetStore)());
    }
    const newConfig = {
        ...config
    };
    newConfig.locale = newConfig.locale.replace('_', '-');
    $d623685d32003ec6$export$6f57813fe9f31bf9.dispatch((0, $kjEZw.initialize)(newConfig));
    if ((0, $7CfdH.isMessagingEnabled)()) (0, $aS5YT.processMessages)($d623685d32003ec6$export$6f57813fe9f31bf9, newConfig, $d623685d32003ec6$var$processMessagesCancellationToken);
    return $d623685d32003ec6$export$6f57813fe9f31bf9;
};

});
parcelRegister("9JnaK", function(module, exports) {

$parcel$export(module.exports, "createCancellationToken", () => $5392f8ffa29adec8$export$eac027797b968991);
function $5392f8ffa29adec8$export$eac027797b968991(isCancelled = false) {
    return {
        isCancelled: isCancelled
    };
}

});

parcelRegister("7CfdH", function(module, exports) {

$parcel$export(module.exports, "isMessagingEnabled", () => $ea3b9aec0dd8c076$export$a77934ac158768dd);

var $aIZdc = parcelRequire("aIZdc");
function $ea3b9aec0dd8c076$export$a77934ac158768dd() {
    return !(0, $aIZdc.isFedRamp)();
}

});

parcelRegister("kjEZw", function(module, exports) {

$parcel$export(module.exports, "SET_MESSAGE_MAPPING", () => $6bb038d2cae8e000$export$d05fe3e897340c89);
$parcel$export(module.exports, "SET_INITIALIZING", () => $6bb038d2cae8e000$export$eacd3ec165715d8);
$parcel$export(module.exports, "RESET_STORE", () => $6bb038d2cae8e000$export$874c5149d7f0e3b8);
$parcel$export(module.exports, "CLEAR_CURRENT", () => $6bb038d2cae8e000$export$cb5041d68cb18859);
$parcel$export(module.exports, "SET_CURRENT", () => $6bb038d2cae8e000$export$a9319af002a4c677);
$parcel$export(module.exports, "resetStore", () => $6bb038d2cae8e000$export$a20a1205b2a2b7e4);
$parcel$export(module.exports, "initialize", () => $6bb038d2cae8e000$export$2a47f398eeff8b01);
$parcel$export(module.exports, "setMessageMapping", () => $6bb038d2cae8e000$export$375dd0a76fecd4c7);
$parcel$export(module.exports, "setCurrent", () => $6bb038d2cae8e000$export$5f80f094fd31fffd);
$parcel$export(module.exports, "clearCurrent", () => $6bb038d2cae8e000$export$96105f873ade39d7);
const $6bb038d2cae8e000$export$d05fe3e897340c89 = 'SET_MESSAGE_MAPPING';
const $6bb038d2cae8e000$export$eacd3ec165715d8 = 'SET_INITIALIZING';
const $6bb038d2cae8e000$export$874c5149d7f0e3b8 = 'RESET_STORE';
const $6bb038d2cae8e000$export$cb5041d68cb18859 = 'CLEAR_CURRENT';
const $6bb038d2cae8e000$export$a9319af002a4c677 = 'SET_CURRENT';
const $6bb038d2cae8e000$export$a20a1205b2a2b7e4 = ()=>({
        type: $6bb038d2cae8e000$export$874c5149d7f0e3b8
    });
const $6bb038d2cae8e000$export$2a47f398eeff8b01 = (config)=>({
        type: $6bb038d2cae8e000$export$eacd3ec165715d8,
        config: config
    });
const $6bb038d2cae8e000$export$375dd0a76fecd4c7 = (messageMapping)=>({
        type: $6bb038d2cae8e000$export$d05fe3e897340c89,
        messageMapping: messageMapping
    });
function $6bb038d2cae8e000$export$5f80f094fd31fffd(eventMapping) {
    return {
        type: $6bb038d2cae8e000$export$a9319af002a4c677,
        eventMapping: eventMapping
    };
}
function $6bb038d2cae8e000$export$96105f873ade39d7() {
    return {
        type: $6bb038d2cae8e000$export$cb5041d68cb18859
    };
}

});

parcelRegister("aS5YT", function(module, exports) {

$parcel$export(module.exports, "processMessages", () => $c38f3c5bf4ee4a6a$export$d2e92820f98a2592);

var $1gxex = parcelRequire("1gxex");

var $kjEZw = parcelRequire("kjEZw");

var $4qJHz = parcelRequire("4qJHz");
const $c38f3c5bf4ee4a6a$export$a9d4ce3abb5d2365 = (messages)=>{
    const mapping = new Map();
    messages.forEach((message)=>{
        const components = message.components;
        components.forEach((component, index)=>{
            component.triggers.forEach((trigger)=>{
                mapping.set(trigger, {
                    message: message,
                    component: {
                        componentId: index,
                        isLast: index === components.length - 1,
                        ...component
                    }
                });
            });
        });
    });
    return mapping;
};
async function $c38f3c5bf4ee4a6a$export$d2e92820f98a2592(engagementStore, config, cancellationToken) {
    if (cancellationToken.isCancelled) return;
    const state = (0, $4qJHz.store).getState();
    const { cloudId: cloudId, stargateUrl: stargateUrl, product: product, locale: locale } = config;
    let messages, interval;
    try {
        const results = await (0, $1gxex.getMessages)(cloudId, stargateUrl, product, locale);
        if (cancellationToken.isCancelled) return;
        messages = results.messages;
        interval = results.interval;
    } catch (e) {
        // TODO: Configure metal to monitor errors here
        // Give up, don't try fetching again
        return;
    }
    // Don't overwrite the messageMapping if there's an active message
    if (state.current === null) {
        const messageMapping = $c38f3c5bf4ee4a6a$export$a9d4ce3abb5d2365(messages);
        engagementStore.dispatch((0, $kjEZw.setMessageMapping)(messageMapping));
    }
    if (interval !== 0) setTimeout(()=>{
        $c38f3c5bf4ee4a6a$export$d2e92820f98a2592(engagementStore, config, cancellationToken);
    }, interval * 1000);
// TODO: Configure metal to monitor success response here
}

});
parcelRegister("1gxex", function(module, exports) {

$parcel$export(module.exports, "getMessages", () => $175a1c1c29f80349$export$8c20ab16ac9cf14f);
$parcel$export(module.exports, "startMessage", () => $175a1c1c29f80349$export$7a77c9a7b182680b);
$parcel$export(module.exports, "stopMessage", () => $175a1c1c29f80349$export$159ff839f1f095d2);
$parcel$export(module.exports, "sendUserResponse", () => $175a1c1c29f80349$export$e1fd1449cf83c1f5);
$parcel$export(module.exports, "markAsSeenAndFatigued", () => $175a1c1c29f80349$export$3683393f780c6905);
/* eslint-disable @atlassian/tangerine/import/no-restricted-paths -- Preventing pre-commit error from being thrown when importing NO_CONTENT from controllers folder*/ 
var $M4Zg0 = parcelRequire("M4Zg0");

var $k8luc = parcelRequire("k8luc");


var $5Xk79 = parcelRequire("5Xk79");
const $175a1c1c29f80349$export$f4d1b02d312560f5 = '2';
const $175a1c1c29f80349$var$inProductMessagesUrlTemplate = (0, (/*@__PURE__*/$parcel$interopDefault($M4Zg0))).parse('/engage-targeting/api/v2/user/{cloudId}/in-product-messages{?product,schema,locale}');
async function $175a1c1c29f80349$export$8c20ab16ac9cf14f(cloudId, stargateUrl, product, locale) {
    return (0, $5Xk79.stargateFetch)(`${stargateUrl}${$175a1c1c29f80349$var$inProductMessagesUrlTemplate.expand({
        cloudId: cloudId,
        product: product,
        schema: $175a1c1c29f80349$export$f4d1b02d312560f5,
        locale: locale
    })}`).then((0, $5Xk79.errorIfNotOk)).then((r)=>r.json().then((messages)=>({
                messages: messages,
                interval: Number.parseFloat(r.headers.get('POLL-INTERVAL') || '0')
            })));
}
function $175a1c1c29f80349$var$handleStartStopMessageResponse(response) {
    return response.status === (0, $da88f8f66d8f0f0a$export$3288b14b6745c572);
}
const $175a1c1c29f80349$var$startMessageUrlTemplate = (0, (/*@__PURE__*/$parcel$interopDefault($M4Zg0))).parse('/engage-targeting/api/v2/user/messages/{messageId}/start');
const $175a1c1c29f80349$var$startMessageWithVariationIdUrlTemplate = (0, (/*@__PURE__*/$parcel$interopDefault($M4Zg0))).parse('/engage-targeting/api/v2/user/messages/{messageId}/start/{variationId}');
const $175a1c1c29f80349$var$stopMessageUrlTemplate = (0, (/*@__PURE__*/$parcel$interopDefault($M4Zg0))).parse('/engage-targeting/api/v2/user/messages/{messageId}/stop');
var $175a1c1c29f80349$export$56ac8ebc9870b1b9 = /*#__PURE__*/ function(envType) {
    envType["LOCAL"] = "local";
    envType["DEV"] = "dev";
    envType["STAGING"] = "staging";
    envType["PROD"] = "prod";
    return envType;
}({});
// Initialize the choreographer plugin on module load
// const choreographerPlugin = new EngagekitChoreographerPlugin();
let $175a1c1c29f80349$var$choreographerPlugin;
async function $175a1c1c29f80349$export$7a77c9a7b182680b(startMessageConfig, options) {
    if (options?.enableChoreographer) return $175a1c1c29f80349$var$startMessageWithChoreographer(startMessageConfig, options);
    return $175a1c1c29f80349$var$startMessageWithCoordination(startMessageConfig);
}
async function $175a1c1c29f80349$export$159ff839f1f095d2(stopMessageConfig, options) {
    if (options?.enableChoreographer) return $175a1c1c29f80349$var$stopMessageWithChoreographer(stopMessageConfig, options);
    return $175a1c1c29f80349$var$stopMessageWithCoordination(stopMessageConfig);
}
async function $175a1c1c29f80349$var$startMessageWithChoreographer(startMessageConfig, options) {
    if (!$175a1c1c29f80349$var$choreographerPlugin) $175a1c1c29f80349$var$choreographerPlugin = new (0, $k8luc.EngagekitChoreographerPlugin)(options.envType ?? "local");
    return $175a1c1c29f80349$var$choreographerPlugin.startMessageWithPlugin(startMessageConfig.messageId, ()=>$175a1c1c29f80349$var$startMessageWithCoordination(startMessageConfig, true), options.additionalData);
}
async function $175a1c1c29f80349$var$stopMessageWithChoreographer(stopMessageConfig, options) {
    if (!$175a1c1c29f80349$var$choreographerPlugin) $175a1c1c29f80349$var$choreographerPlugin = new (0, $k8luc.EngagekitChoreographerPlugin)(options.envType ?? "local");
    return $175a1c1c29f80349$var$choreographerPlugin.stopMessageWithPlugin(stopMessageConfig.messageId, ()=>$175a1c1c29f80349$var$stopMessageWithCoordination(stopMessageConfig, true), options.additionalData);
}
async function $175a1c1c29f80349$var$startMessageWithCoordination(startMessageConfig, choreographerEnabled = false) {
    const requestBody = {
        cloudId: startMessageConfig.cloudId,
        orgId: startMessageConfig.orgId,
        workspaceId: startMessageConfig.workspaceId,
        choreographerEnabled: choreographerEnabled
    };
    return (0, $5Xk79.stargateFetch)(startMessageConfig.variationId ? `${startMessageConfig.stargateUrl}${$175a1c1c29f80349$var$startMessageWithVariationIdUrlTemplate.expand({
        messageId: startMessageConfig.messageId,
        variationId: startMessageConfig.variationId
    })}` : `${startMessageConfig.stargateUrl}${$175a1c1c29f80349$var$startMessageUrlTemplate.expand({
        messageId: startMessageConfig.messageId
    })}`, {
        method: 'post',
        body: JSON.stringify(requestBody),
        headers: {
            'Content-Type': 'application/json'
        }
    }).then((0, $5Xk79.pullResponseTextIfNotOk)).then($175a1c1c29f80349$var$handleStartStopMessageResponse);
}
async function $175a1c1c29f80349$var$stopMessageWithCoordination(stopMessageConfig, choreographerEnabled = false) {
    const requestBody = {
        cloudId: stopMessageConfig.cloudId,
        orgId: stopMessageConfig.orgId,
        workspaceId: stopMessageConfig.workspaceId,
        choreographerEnabled: choreographerEnabled
    };
    return (0, $5Xk79.stargateFetch)(`${stopMessageConfig.stargateUrl}${$175a1c1c29f80349$var$stopMessageUrlTemplate.expand({
        messageId: stopMessageConfig.messageId
    })}`, {
        method: 'post',
        body: JSON.stringify(requestBody),
        headers: {
            'Content-Type': 'application/json'
        }
    }).then((0, $5Xk79.pullResponseTextIfNotOk)).then($175a1c1c29f80349$var$handleStartStopMessageResponse);
}
const $175a1c1c29f80349$var$userResponseUrlTemplate = (0, (/*@__PURE__*/$parcel$interopDefault($M4Zg0))).parse('/engage-targeting/api/v2/user/{cloudId}/messages/{messageId}/response');
async function $175a1c1c29f80349$export$e1fd1449cf83c1f5(cloudId, stargateUrl, messageId, payload) {
    return (0, $5Xk79.stargateFetch)(`${stargateUrl}${$175a1c1c29f80349$var$userResponseUrlTemplate.expand({
        cloudId: cloudId,
        messageId: messageId
    })}`, {
        method: 'post',
        body: JSON.stringify(payload),
        headers: {
            'Content-Type': 'application/json'
        }
    }).then((0, $5Xk79.pullResponseTextIfNotOk)).then(()=>Promise.resolve());
}
const $175a1c1c29f80349$var$markSeenAndFatigueUrlTemplate = (0, (/*@__PURE__*/$parcel$interopDefault($M4Zg0))).parse('/engage-targeting/api/v2/user/messages/{messageId}/seen');
async function $175a1c1c29f80349$export$3683393f780c6905(seenMessageConfig) {
    const requestBody = {
        cloudId: seenMessageConfig.cloudId,
        orgId: seenMessageConfig.orgId,
        workspaceId: seenMessageConfig.workspaceId
    };
    return (0, $5Xk79.stargateFetch)(`${seenMessageConfig.stargateUrl}${$175a1c1c29f80349$var$markSeenAndFatigueUrlTemplate.expand({
        messageId: seenMessageConfig.messageId
    })}`, {
        method: 'post',
        body: JSON.stringify(requestBody),
        headers: {
            'Content-Type': 'application/json'
        }
    }).then((0, $5Xk79.pullResponseTextIfNotOk)).then(()=>Promise.resolve());
}

});
parcelRegister("k8luc", function(module, exports) {

$parcel$export(module.exports, "EngagekitChoreographerPlugin", () => $3c659b536805a56f$export$da23bd36e2d631b);

var $9ACoj = parcelRequire("9ACoj");

var $TTRxY = parcelRequire("TTRxY");

var $labik = parcelRequire("labik");

var $7cTYp = parcelRequire("7cTYp");

var $4YUjU = parcelRequire("4YUjU");
const $3c659b536805a56f$export$63ce1a41d951945d = 300000; // 5m timeout for duplicate request attempts
class $3c659b536805a56f$export$da23bd36e2d631b extends (0, $4YUjU.ChoreographerPlugin) {
    constructor(env, metaMetricsData = {}){
        super((0, $TTRxY.ProductIds).ENGAGEKIT, env, metaMetricsData);
    }
    /**
	 * Informs the Logger utility class to *NOT* log the provided event if it contains a blockedByProductId
	 * attribute of the Engagekit product. EP is _super_ noisy when it comes to logging, and we get no value
	 * out of the events it logs for its own message starts that are blocked, by any messages. The reason is
	 * that EP tries to start all of its messages all of the time, and lets the gateway determine whether to
	 * actually display the message. Roughly 99.9% of messages fail to start for reasons of prior exposure,
	 * the user being in the holdout group, or any number of other reasons, so we're logging roughly 1000x what
	 * we get any value out of. This filter will now prevent all of those extra, more useless logs, from being
	 * actually fired off, and will keep just the log entries from which we can derive some actual value.
	 *
	 * @param event OperationalEventPayload
	 * @returns boolean
	 */ shouldLogEvent(event) {
        return event.actionSubject !== (0, $TTRxY.MessageAction).START || event.action !== (0, $TTRxY.MessageDeliveryStatus).BLOCKED;
    }
    isValidDuplicateStartRequest(messageId) {
        const currentMessage = (0, $9ACoj.Choreographer).getInstance().getCurrentMessage() ?? (0, $9ACoj.Choreographer).getInstance().getCurrentPendingMessage();
        return Boolean(currentMessage && currentMessage.productId === this.state.productId && currentMessage.messageId === messageId && Date.now() - currentMessage.timestamp < $3c659b536805a56f$export$63ce1a41d951945d);
    }
    async startMessageWithPlugin(messageId, callback, additionalData = {}) {
        const debugLogger = new (0, $labik.DebugLogger)(this.state.productId, messageId);
        const actionSubject = (0, $TTRxY.MessageAction).START;
        debugLogger.trace({
            verbose: `EngagekitChoreographerPlugin::startMessageWithPlugin`
        });
        /**
		 * The Choreographer sets a 5m TTL for any message that opens, before forcefully closing it.
		 * EP also allows a messageId to re-request its start if it hasn't yet been dismissed (this is a
		 * feature of HISI. For this reason, we can mimic that functionality here (otherwise, Choreographer
		 * will block the subsequest start request attempt altogether), by checking the Choreographer's
		 * currentMessage against our productId/messageId combo here. If this *is* the currentMessage being
		 * displayed, it means it hasn't been dismissed, and we let the request dispatch for EP to make the call.
		 */ const isValidDuplicateStartRequest = this.isValidDuplicateStartRequest(messageId);
        if (isValidDuplicateStartRequest) {
            const logger = new (0, $7cTYp.Logger)(actionSubject, messageId, {
                ...this.state.metaMetricsData,
                ...additionalData
            }, this.analyticsClient);
            const didStart = Boolean(await callback());
            if (didStart) {
                logger.started();
                debugLogger.log({
                    verbose: {
                        phase: actionSubject,
                        plugin: this.constructor.name,
                        disposition: (0, $TTRxY.MessageDeliveryStatus).STARTED,
                        timestamp: performance.now()
                    }
                });
            }
            return didStart;
        }
        // Do a just-in-time message start subscription with our callback to stargate
        this.onStart(messageId, callback);
        /**
		 * Dispatch the request to start the message, and return the response, which will
		 * either be 'started' if successful, and anything else if unsuccessful. Convert
		 * that value with a boolean check, because the consumer only cares about true/false.
		 */ const result = await this.startMessage(messageId, additionalData);
        return result === (0, $TTRxY.MessageDeliveryStatus).STARTED;
    }
    async stopMessageWithPlugin(messageId, callback, additionalData = {}) {
        const debugLogger = new (0, $labik.DebugLogger)(this.state.productId, messageId);
        debugLogger.trace({
            verbose: `EngagekitChoreographerPlugin::stopMessageWithPlugin`
        });
        // Do a just-in-time message stop subscription with our callback to stargate
        this.onStop(messageId, callback);
        /**
		 * Dispatch the request to stop the message, and return the response, which will
		 * either be 'stopped' if successful, and anything else if unsuccessful. Convert
		 * that value with a boolean check, because the consumer only cares about true/false.
		 */ const result = await this.stopMessage(messageId, additionalData);
        return result === (0, $TTRxY.MessageDeliveryStatus).STOPPED;
    }
}

});
parcelRegister("9ACoj", function(module, exports) {

$parcel$export(module.exports, "Choreographer", () => $9286911f96545296$export$236158f15971c92e);

var $TTRxY = parcelRequire("TTRxY");

var $labik = parcelRequire("labik");

var $7cTYp = parcelRequire("7cTYp");

var $8HM6e = parcelRequire("8HM6e");
// This timeout is used for any long-running messages that are either stuck for some reason, or that the user has yet to clear, to ensure that messaging doesn't stay blocked indefinitely
const $9286911f96545296$var$CHOREOGRAPHER_MESSAGE_TTL = 300000; // 5 minute TTL for messages
// Lazily instantiate this the first time it's requested
let $9286911f96545296$var$singleton;
class $9286911f96545296$export$236158f15971c92e {
    /**
	 * Static method to create and/or return a singleton of the choreographer API.
	 *
	 * @returns Shared instance of choreographer API.
	 */ static getInstance() {
        if (!$9286911f96545296$var$singleton) $9286911f96545296$var$singleton = new this();
        return $9286911f96545296$var$singleton;
    }
    constructor(){
        this.state = {
            currentMessage: null,
            isDisabled: false,
            messages: new Map(),
            messageQueue: [],
            messageTtl: null,
            plugins: new Map(),
            queueingBehindMessage: null,
            shouldQueueMessages: false
        };
    }
    stopCurrentMessage() {
        if (this.state.currentMessage) this.stopMessageInternal(this.state.currentMessage.productId, this.state.currentMessage.messageId, this.state.currentMessage.analyticsClient, this.state.currentMessage.metricsData, this.state.currentMessage.plugin, true).then(()=>{
            // Manually clear the message TTL and reenable plugins here just in case the unregistered plugin's message denied the
            // stop request. We may still get a collision on-screen, but we're considering the message forcibly stopped at this
            // point, so need to allow new requests.
            this.clearMessageTtl();
            this.enablePlugins();
        });
    }
    /**
	 * Enables the message queue, and logs which message everybody else is queueing up behind.
	 *
	 * @param productId Unique identifier for the product making the current startMessage request blocking others.
	 * @param messageId Unique identifier for the messageId blocking others.
	 */ queueMessages(productId, messageId) {
        this.state.shouldQueueMessages = true;
        this.state.queueingBehindMessage = {
            productId: productId,
            messageId: messageId,
            timestamp: Date.now()
        };
    }
    /**
	 * Pushes all data associated with a startMessage request onto an internal queue, to potentially be processed at a later time.
	 * If a pending message request opts out (or otherwise fails to start), this data will be used to reinitiate the startMessage
	 * request for this message request instance. Returns a Promise that the caller can await as normal, and which will eventually
	 * either be resolved as 'blocked' if any prior pending message is started, or will be resolved with its eventual outcome when
	 * its startMessage request is processed.
	 *
	 * @param productId Unique identifier for the product making the current startMessage request being queued.
	 * @param messageId Unique identifier for the messageId being queued.
	 * @param analyticsClient The analytics client to be used for logging/metrics.
	 * @param metricsData Additional data from plugin to be sent for metrics logging.
	 * @param [plugin] An optional plugin instance.
	 * @returns A Promise that resolves to a MessageDeliveryStatus value, to denote the ultimate status of the attempted message start operation.
	 */ queueMessage(productId, messageId, analyticsClient, metricsData, plugin) {
        return new Promise((resolve)=>{
            this.state.messageQueue.push({
                productId: productId,
                messageId: messageId,
                analyticsClient: analyticsClient,
                metricsData: metricsData,
                plugin: plugin,
                resolve: resolve
            });
        });
    }
    /**
	 * Responsible for pulling a previously queued message request that was received while a message request was already in flight.
	 * Shift the first message off the top of the queue, and use the stored resolve function to kickstart another pass through the
	 * startMessage function, ultimately resolving with the final disposition of the request. Set the internal state for shouldQueueMessages
	 * to false if we're restarting a startMessage request, so that this doesn't get immediately thrown back into the queue. If it
	 * makes it through to its start callback being fired, that code will turn the shouldQueueMessages state back on.
	 */ processQueuedMessage() {
        const queuedMessage = this.state.messageQueue.shift();
        // Disable the shouldQueueMessages state here. If we have a queued message, it will turn the shouldQueueMessages state back on when it
        // hits the call to its message's startCallback function. Otherwise, the queue is now empty, and we let things process normally.
        this.state.shouldQueueMessages = false;
        // Also null out the queueingBehindMessage value, which will be recreated if/when another message opens the queue below.
        this.state.queueingBehindMessage = null;
        if (queuedMessage) queuedMessage.resolve(this.startMessage(queuedMessage.productId, queuedMessage.messageId, queuedMessage.analyticsClient, queuedMessage.metricsData, queuedMessage.plugin));
    }
    /**
	 * Responsible for flushing out any queued messages and resolving their Promises as "blocked". We don't officially consider a
	 * message as "blocked" until one of the prior calls has signaled a valid "started" state. This way, any async callbacks that
	 * are in flight can allow additional messages to queue up, and if they eventually opt out, we can move on to the next message
	 * in the queue and see if it will signal success. Only when we get a successful start to we consider all queued up messages to
	 * be "blocked". Run a loop to shift each of them off of the array and resolve them as blocked, until the array is empty.
	 *
	 * @param [plugin] An optional plugin instance
	 */ destroyMessageQueue(plugin) {
        this.state.shouldQueueMessages = false;
        this.state.queueingBehindMessage = null;
        while(this.state.messageQueue.length > 0){
            const { analyticsClient: analyticsClient, messageId: messageId, metricsData: metricsData, productId: productId, resolve: resolve } = this.state.messageQueue.shift();
            const attributes = {
                ...metricsData,
                productId: productId,
                messageId: messageId
            };
            const actionSubject = (0, $TTRxY.MessageAction).START;
            const logger = new (0, $7cTYp.Logger)(actionSubject, messageId, attributes, analyticsClient, plugin);
            const debugLogger = new (0, $labik.DebugLogger)(productId, messageId);
            logger.blocked({
                blockedByProductId: this.state.currentMessage?.productId,
                blockedByMessageId: this.state.currentMessage?.messageId
            });
            debugLogger.log({
                verbose: {
                    phase: actionSubject,
                    disposition: (0, $TTRxY.MessageDeliveryStatus).BLOCKED,
                    blockedByProductId: this.state.currentMessage?.productId,
                    blockedByMessageId: this.state.currentMessage?.messageId
                }
            });
            resolve((0, $TTRxY.MessageDeliveryStatus).BLOCKED);
        }
    }
    /**
	 * Sets a timeout to auto-expire any messaging that stays open for too long, to prevent messaging from being blocked indefinitely.
	 *
	 * @param productId Unique identifier for the product making the current startMessage request that triggered this message timeout.
	 * @param messageId Unique identifier for the messageId that triggered this message timeout.
	 * @param AnalyticsClient The analytics client to be used for logging/metrics.
	 * @param metricsData Additional data from plugin to be sent for metrics logging.
	 * @param [plugin] An optional plugin instance.
	 */ setMessageTtl(productId, messageId, analyticsClient, metricsData, plugin) {
        this.state.currentMessage = {
            productId: productId,
            messageId: messageId,
            analyticsClient: analyticsClient,
            metricsData: metricsData,
            plugin: plugin,
            timestamp: Date.now()
        };
        this.state.messageTtl = setTimeout(()=>{
            if (this.isCurrentMessage(productId, messageId)) this.stopCurrentMessage();
        }, $9286911f96545296$var$CHOREOGRAPHER_MESSAGE_TTL);
    }
    /**
	 * Checks to see if the requesting productId/messageId pair matches the data for the currently-displayed message.
	 *
	 * @param productId Unique identifier for the product being checked for a current message match.
	 * @param messageId Unique identifier for the messageId being checked for a current message match.
	 */ isCurrentMessage(productId, messageId) {
        return Boolean(this.state.currentMessage && this.state.currentMessage.productId === productId && this.state.currentMessage.messageId === messageId);
    }
    /**
	 * Returns the currentMessage object.
	 */ getCurrentMessage() {
        return this.state.currentMessage;
    }
    /**
	 * Returns the queueingBehindMessage object.
	 */ getCurrentPendingMessage() {
        return this.state.queueingBehindMessage;
    }
    /**
	 * Clears the timeout that was established for the currently-displayed message.
	 */ clearMessageTtl() {
        this.state.currentMessage = null;
        if (this.state.messageTtl) clearTimeout(this.state.messageTtl);
    }
    /**
	 * Disables all plugins that are currently registered with the choreographer, called when a startMessage call is being dispatched.
	 *
	 * @param [exceptFor] An optional plugin instance.
	 */ disablePlugins(exceptFor) {
        this.state.isDisabled = true;
        [
            ...this.state.plugins.values()
        ].forEach((p)=>{
            if (p !== exceptFor) p.disable();
        });
    }
    /**
	 * Enables all plugins that are currently registered with the choreographer, called when a matching stopMessage call is successful.
	 */ enablePlugins() {
        [
            ...this.state.plugins.values()
        ].forEach((p)=>p.enable());
        this.state.isDisabled = false;
    }
    /**
	 * A callback used to remove a plugin from the list of subscribers for the choreographer service.
	 *
	 * @param productId A unique string representing the plugin to be unregistered from the choreographer API.
	 */ unregisterPlugin(productId) {
        // If we're unregistering this productId's plugin, and the currentMessage is from this productId, we need to stop it to clear the choreographer
        if (this.state.currentMessage?.productId === productId) this.stopCurrentMessage();
        this.state.messages.delete(productId);
        this.state.plugins.delete(productId);
    }
    /**
	 * Determines whether any message is currently being displayed, by checking its own status and optionally, asking each registered plugin for its individual status.
	 *
	 * @returns A value reflecting whether a message is currently being displayed on screen.
	 */ isDisplayingMessage() {
        return Boolean(this.state.currentMessage || [
            ...this.state.plugins.values()
        ].reduce((isDisplayingMessage, p)=>{
            return isDisplayingMessage || p.isDisplayingMessage();
        }, false));
    }
    /**
	 * This function is intended for test cleanup purposes only, *not* to be called by external callers.
	 *
	 * @ignore
	 * @param productId Unique identifier for the product whose messages are being requested
	 * @returns A Map of IMessage objects, keyed by unique messageId strings.
	 */ getMessages(productId) {
        return this.state.messages.get(productId) ?? new Map();
    }
    /**
	 * Requests to start a message via the choreographer service, ensuring only a single message instance at a time on the screen.
	 * A successful request will block any other message attempts until such time as the matching stopMessage request is received,
	 * or a message TTL timeout has expired.
	 *
	 * @param productId Unique identifier for the product making the current startMessage request that triggered this message timeout.
	 * @param messageId Unique identifier for the messageId that triggered this message timeout.
	 * @param analyticsClient The analytics client to be used for logging/metrics.
	 * @param [metricsData] Additional data from plugin to be sent for metrics logging.
	 * @param [plugin] An optional plugin instance.
	 * @returns A Promise that resolves to a MessageDeliveryStatus value, to denote the ultimate status of the attempted message start operation.
	 */ async startMessage(productId, messageId, analyticsClient, metricsData = {}, plugin) {
        if ((0, $8HM6e.isChoreographerSuppressed)()) {
            if (this.hasMessageRecord(productId, messageId)) {
                const message = this.ensureMessageRecord(productId, messageId);
                const didStart = await message.start?.() ?? true;
                if (didStart) {
                    // Fire the onStart callback, if provided, to handle any post-start concerns for the consumer
                    message.onStart?.();
                    return (0, $TTRxY.MessageDeliveryStatus).STARTED;
                }
                return (0, $TTRxY.MessageDeliveryStatus).CANCELED;
            }
            return (0, $TTRxY.MessageDeliveryStatus).UNREGISTERED;
        }
        const debugLogger = new (0, $labik.DebugLogger)(productId, messageId);
        const actionSubject = (0, $TTRxY.MessageAction).START;
        const requestTimestamp = performance.now();
        debugLogger.log({
            info: {
                phase: actionSubject,
                timestamp: requestTimestamp
            },
            verbose: {
                phase: actionSubject,
                timestamp: requestTimestamp
            }
        });
        const attributes = {
            ...metricsData,
            productId: productId,
            messageId: messageId
        };
        const logger = new (0, $7cTYp.Logger)(actionSubject, messageId, attributes, analyticsClient, plugin);
        try {
            if (!this.hasMessageRecord(productId, messageId)) {
                // Bail early here, before even checking if we're in a queueing situation, or blocked, or anything else
                logger.unregistered();
                debugLogger.log({
                    verbose: {
                        phase: actionSubject,
                        disposition: (0, $TTRxY.MessageDeliveryStatus).UNREGISTERED
                    }
                });
                return (0, $TTRxY.MessageDeliveryStatus).UNREGISTERED;
            }
            // If we're currently queueing messages, push this one onto the queue and return the new Promise
            if (this.state.shouldQueueMessages) {
                debugLogger.log({
                    verbose: {
                        phase: actionSubject,
                        disposition: `queued behind ${this.state.queueingBehindMessage?.productId} ${this.state.queueingBehindMessage?.messageId}`
                    }
                });
                return this.queueMessage(productId, messageId, analyticsClient, metricsData, plugin);
            }
            if (this.state.isDisabled || this.isDisplayingMessage()) {
                logger.blocked({
                    blockedByProductId: this.state.currentMessage?.productId,
                    blockedByMessageId: this.state.currentMessage?.messageId
                });
                debugLogger.log({
                    verbose: {
                        phase: actionSubject,
                        disposition: (0, $TTRxY.MessageDeliveryStatus).BLOCKED,
                        blockedByProductId: this.state.currentMessage?.productId,
                        blockedByMessageId: this.state.currentMessage?.messageId
                    }
                });
                return (0, $TTRxY.MessageDeliveryStatus).BLOCKED;
            }
            const message = this.ensureMessageRecord(productId, messageId);
            this.queueMessages(productId, messageId);
            const didStart = await message.start?.() ?? true;
            if (didStart) {
                // Fire the onStart callback, if provided, to handle any post-start concerns for the consumer
                message.onStart?.();
                logger.started();
                this.disablePlugins(plugin);
                this.setMessageTtl(productId, messageId, analyticsClient, metricsData);
                // Successfully started the message, flush the queue and mark any pending requests as "blocked"
                this.destroyMessageQueue(plugin);
                debugLogger.log({
                    verbose: {
                        phase: actionSubject,
                        disposition: (0, $TTRxY.MessageDeliveryStatus).STARTED
                    }
                });
                return (0, $TTRxY.MessageDeliveryStatus).STARTED;
            }
            // Check to see if we have any pending requests in the message queue and attempt to start the next one in line
            this.processQueuedMessage();
            debugLogger.log({
                verbose: {
                    phase: actionSubject,
                    disposition: (0, $TTRxY.MessageDeliveryStatus).CANCELED
                }
            });
            return (0, $TTRxY.MessageDeliveryStatus).CANCELED;
        } catch (error) {
            const e = error;
            logger.error({
                reason: e.message
            });
            debugLogger.log({
                verbose: {
                    phase: actionSubject,
                    disposition: (0, $TTRxY.MessageDeliveryStatus).ERROR
                }
            });
            return (0, $TTRxY.MessageDeliveryStatus).ERROR;
        }
    }
    /**
	 * Requests to stop a message via the choreographer service. A successful request will allow any other plugins to begin issuing startMessage requests again.
	 * This version of the stopMessage function is private, and only intended to be called internally, so that it can make use of the forceStop parameter without exposing that to external callers.
	 *
	 * @param productId Unique identifier for the product making the current stopMessage request.
	 * @param messageId Unique identifier for the messageId to be stopped.
	 * @param analyticsClient The analytics client to be used for logging/metrics.
	 * @param [metricsData] Additional data from plugin to be sent for metrics logging.
	 * @param [plugin] An optional plugin instance.
	 * @param [forceStop] A boolean to denote whether to forcefully clear the Choreographer's blocked state (used for TTL expiration and unregistering a plugin).
	 * @returns A Promise that resolves to a MessageDeliveryStatus value, to denote the ultimate status of the attempted message stop operation.
	 */ async stopMessageInternal(productId, messageId, analyticsClient, metricsData = {}, plugin, forceStop = false) {
        if ((0, $8HM6e.isChoreographerSuppressed)()) {
            if (this.hasMessageRecord(productId, messageId)) {
                const message = this.ensureMessageRecord(productId, messageId);
                const didStop = await message.stop?.() ?? true;
                if (didStop) {
                    // Fire the onStop callback, if provided, to handle any post-stop concerns for the consumer
                    message.onStop?.();
                    return (0, $TTRxY.MessageDeliveryStatus).STOPPED;
                }
                return (0, $TTRxY.MessageDeliveryStatus).CANCELED;
            }
            return (0, $TTRxY.MessageDeliveryStatus).UNREGISTERED;
        }
        const debugLogger = new (0, $labik.DebugLogger)(productId, messageId);
        const actionSubject = (0, $TTRxY.MessageAction).STOP;
        const requestTimestamp = performance.now();
        debugLogger.log({
            info: {
                phase: actionSubject,
                timestamp: requestTimestamp
            },
            verbose: {
                phase: actionSubject,
                timestamp: requestTimestamp
            }
        });
        const attributes = {
            ...metricsData,
            productId: productId,
            messageId: messageId
        };
        const logger = new (0, $7cTYp.Logger)(actionSubject, messageId, attributes, analyticsClient, plugin);
        try {
            if (!this.hasMessageRecord(productId, messageId)) {
                logger.unregistered();
                debugLogger.log({
                    verbose: {
                        phase: actionSubject,
                        disposition: (0, $TTRxY.MessageDeliveryStatus).UNREGISTERED
                    }
                });
                return (0, $TTRxY.MessageDeliveryStatus).UNREGISTERED;
            }
            const message = this.ensureMessageRecord(productId, messageId);
            // Enable the message queue *if* the current stopMessage request matches the currentMessage data.
            // Any incoming startMessage requests will be queued while this stopMessage request is in-flight,
            // so that they can be immediately honored if this request comes back successfully.
            if (this.isCurrentMessage(productId, messageId)) this.queueMessages(productId, messageId);
            const didStop = await message.stop?.() ?? true;
            // If we're hitting this from stopCurrentMessage, it means either a TTL has expired, or we're
            // unregistering a plugin. We forceStop the choreographer blocked state here, even if the stop
            // callback returned false.We don't want to block the UI indefinitely, we'll just have to risk
            // 1 additional message collision if the current message's stop callback refuses to clear.
            if (didStop || forceStop) {
                if (this.isCurrentMessage(productId, messageId)) {
                    // Fire the onStop callback, if provided, to handle any post-stop concerns for the consumer
                    message.onStop?.();
                    // Only log this even if we're stopping the current message, so we have a 1:1 mapping of starts to stops.
                    // If this is a forced stop, log that in the attributes, so we can track those events specifically.
                    // Also log the value of didStop, so we know if this was a rejected stop attempt that *had* to be force stopped.
                    logger.stopped(forceStop ? {
                        forceStop: forceStop,
                        didStop: didStop
                    } : undefined);
                    // Only clear the message TTL and reenable plugins if we're stopping the *current* message
                    this.clearMessageTtl();
                    this.enablePlugins();
                }
                // Check to see if we have any pending requests in the message queue and attempt to start them
                this.processQueuedMessage();
                debugLogger.log({
                    verbose: {
                        phase: actionSubject,
                        disposition: (0, $TTRxY.MessageDeliveryStatus).STOPPED
                    }
                });
                return (0, $TTRxY.MessageDeliveryStatus).STOPPED;
            }
            // Stopping the message failed, so the UI is still intentionally blocked, flush the queue and mark any pending requests as "blocked"
            this.destroyMessageQueue(plugin);
            debugLogger.log({
                verbose: {
                    phase: actionSubject,
                    disposition: (0, $TTRxY.MessageDeliveryStatus).CANCELED
                }
            });
            return (0, $TTRxY.MessageDeliveryStatus).CANCELED;
        } catch (error) {
            const e = error;
            logger.error({
                reason: e.message
            });
            debugLogger.log({
                verbose: {
                    phase: actionSubject,
                    disposition: (0, $TTRxY.MessageDeliveryStatus).ERROR
                }
            });
            return (0, $TTRxY.MessageDeliveryStatus).ERROR;
        }
    }
    /**
	 * Requests to stop a message via the choreographer service. A successful request will allow any other plugins to begin issuing startMessage requests again.
	 *
	 * @param productId Unique identifier for the product making the current stopMessage request.
	 * @param messageId Unique identifier for the messageId to be stopped.
	 * @param analyticsClient The analytics client to be used for logging/metrics.
	 * @param [metricsData] Additional data from plugin to be sent for metrics logging.
	 * @param [plugin] An optional plugin instance.
	 * @returns A Promise that resolves to a MessageDeliveryStatus value, to denote the ultimate status of the attempted message stop operation.
	 */ async stopMessage(productId, messageId, analyticsClient, metricsData = {}, plugin) {
        return this.stopMessageInternal(productId, messageId, analyticsClient, metricsData, plugin);
    }
    /**
	 * Registers a plugin instance with the choreographer API. Allows the choreographer to enable and disable it as needed to ensure individual message experiences on screen.
	 *
	 * @param productId Unique identifier to register as the product owner of this plugin.
	 * @param plugin A plugin instance to be registered with the choreographer instance.
	 * @returns A callback to be used to unregister this plugin with the choreographer instance, for cleanup purposes, if necessary.
	 */ registerPlugin(productId, plugin) {
        if (this.state.plugins.has(productId)) throw new Error(`Choreographer plugin already registered for ${productId}!`);
        this.state.plugins = this.state.plugins.set(productId, plugin);
        if (this.state.isDisabled) plugin.disable();
        return ()=>{
            this.unregisterPlugin(productId);
        };
    }
    /**
	 * Validates that a message record is present and ready to be retrieved and/or manipulated.
	 * Creates the message instance if it doesn't yet exist, initializing both start and stop callbacks to noop functions.
	 *
	 * @param productId Unique identifier to retrieve map of IMessage objects.
	 * @param messageId Unique identifier for the messageId to be retrieved.
	 * @returns IMessage object for the requested productId/messageId combination.
	 */ ensureMessageRecord(productId, messageId) {
        let productMessages = this.state.messages.get(productId);
        if (!productMessages) {
            productMessages = new Map();
            this.state.messages.set(productId, productMessages);
        }
        let message = productMessages.get(messageId);
        if (!message) {
            message = {};
            productMessages.set(messageId, message);
        }
        return message;
    }
    /**
	 * Checks for the existance of a message record for a given productId/messageId combination.
	 *
	 * @param productId Unique identifier to check for a map of IMessage objects.
	 * @param messageId Unique identifier to check for within the map of productId IMessage objects.
	 * @returns Boolean indicating whether or not an IMessage record exists for the requested productId/messageId combination.
	 */ hasMessageRecord(productId, messageId) {
        return Boolean(this.state.messages.get(productId)?.has?.(messageId));
    }
    /**
	 * Subscribes callbacks to be used for starting and stopping message requests through the choreographer, keyed by a combination of productId and messageId.
	 *
	 * @param productId Unique identifier to be used as a primary key for this message subscription.
	 * @param messageId Unique identifier within the context of all productId message entries, to be used as a secondary key for this message subscription.
	 * @param options An object containing optional start and stop callback functions, to be invoked upon successful requests to startMessage and stopMessage, respectively.
	 * @param finalizers An object containing optional onStart and onStop callback functions, to be invoked upon successful starts and stops of messages, respectively.
	 */ on(productId, messageId, options = {}, finalizers = {}) {
        const message = {
            ...this.ensureMessageRecord(productId, messageId),
            ...options,
            ...finalizers
        };
        this.state.messages.get(productId).set(messageId, message);
    }
    /**
	 * Subscribes a callback to be used for starting message requests through the choreographer, keyed by a combination of productId and messageId.
	 *
	 * @param productId Unique identifier to be used as a primary key for this message subscription.
	 * @param messageId Unique identifier within the context of all productId message entries, to be used as a secondary key for this message subscription.
	 * @param startCallback A callback to be invoked upon successful requests to startMessage.
	 * @param finalizers An object containing optional onStart and onStop callback functions, to be invoked upon successful starts and stops of messages, respectively.
	 */ onStart(productId, messageId, startCallback, finalizers) {
        this.on(productId, messageId, {
            start: startCallback
        }, finalizers);
    }
    /**
	 * Subscribes a callback to be used for stopping message requests through the choreographer, keyed by a combination of productId and messageId.
	 *
	 * @param productId Unique identifier to be used as a primary key for this message subscription.
	 * @param messageId Unique identifier within the context of all productId message entries, to be used as a secondary key for this message subscription.
	 * @param stopCallback A callback to be invoked upon successful requests to stopMessage.
	 * @param finalizers An object containing optional onStart and onStop callback functions, to be invoked upon successful starts and stops of messages, respectively.
	 */ onStop(productId, messageId, stopCallback, finalizers = {}) {
        this.on(productId, messageId, {
            stop: stopCallback
        }, finalizers);
    }
    /**
	 * Unsubscribes a message's start and stop message callbacks from the choreographer, keyed by a combination of productId and messageId.
	 *
	 * @param productId Unique identifier to be used as a primary key for unsubscribing this message.
	 * @param messageId Unique identifier within the context of all productId message entries, to be used as a secondary key for unsubscribing this message.
	 */ off(productId, messageId) {
        this.state.messages.get(productId)?.delete?.(messageId);
    }
}

});
parcelRegister("TTRxY", function(module, exports) {

$parcel$export(module.exports, "MessageEventType", () => $c5cd2ef964768afb$export$d33b097e0a285bc2);
$parcel$export(module.exports, "MessageDeliveryStatus", () => $c5cd2ef964768afb$export$f6a9504bc1305cf0);
$parcel$export(module.exports, "ProductIds", () => $c5cd2ef964768afb$export$7fb117db98868be6);
$parcel$export(module.exports, "IntegratedChoreographerMessageTypesEnum", () => $c5cd2ef964768afb$export$dbe9e38c9d6f26d0);
$parcel$export(module.exports, "MessageAction", () => $c5cd2ef964768afb$export$865c0eaaa43d90f8);
const $c5cd2ef964768afb$export$d33b097e0a285bc2 = {
    START: 'start',
    STOP: 'stop'
};
const $c5cd2ef964768afb$export$f6a9504bc1305cf0 = {
    BLOCKED: 'blocked',
    CANCELED: 'canceled',
    ERROR: 'error',
    STARTED: 'started',
    STOPPED: 'stopped',
    UNREGISTERED: 'unregistered'
};
var $c5cd2ef964768afb$export$7fb117db98868be6 = /*#__PURE__*/ function(ProductIds) {
    ProductIds["CONFLUENCE"] = "confluence";
    ProductIds["ENGAGEKIT"] = "Engagekit";
    ProductIds["INTERCOM"] = "intercom";
    ProductIds["JIRA"] = "jira";
    ProductIds["PENDO"] = "pendo";
    ProductIds["CLOUDADMIN"] = "cloudadmin";
    ProductIds["BITBUCKET"] = "bitbucket";
    ProductIds["POST_OFFICE"] = "post-office";
    return ProductIds;
}({});
const $c5cd2ef964768afb$export$94e85cf3348f045a = {
    ENGAGEMENT: 'engagement',
    MARKETING: 'marketing',
    TRANSACTIONAL: 'transactional'
};
const $c5cd2ef964768afb$export$dbe9e38c9d6f26d0 = [
    $c5cd2ef964768afb$export$94e85cf3348f045a.ENGAGEMENT,
    $c5cd2ef964768afb$export$94e85cf3348f045a.MARKETING
];
const $c5cd2ef964768afb$export$865c0eaaa43d90f8 = {
    START: 'messageStart',
    STOP: 'messageStop'
};
const $c5cd2ef964768afb$export$fc6a8b8cb405f50 = {
    INFO: 'info',
    VERBOSE: 'verbose'
};

});

parcelRegister("labik", function(module, exports) {

$parcel$export(module.exports, "DebugLogger", () => $df6e50e0e93de28e$export$21e6cc849c1dc1ab);
function $df6e50e0e93de28e$var$getCurrentLoggingLevel() {
    return window.choreographerLoggingLevel;
}
function $df6e50e0e93de28e$var$logMessageIfValidLoggingLevel(loggingLevel, data) {
    if ($df6e50e0e93de28e$var$getCurrentLoggingLevel() === loggingLevel) // eslint-disable-next-line no-console
    console.table(data);
}
function $df6e50e0e93de28e$var$traceMessageIfValidLoggingLevel(loggingLevel, productId, messageId, message) {
    if ($df6e50e0e93de28e$var$getCurrentLoggingLevel() === loggingLevel) // eslint-disable-next-line no-console
    console.log(`CHOREOGRAPHER - ${productId} - ${messageId} - ${message}`);
}
class $df6e50e0e93de28e$export$21e6cc849c1dc1ab {
    constructor(productId, messageId){
        /**
	 * A function that takes an object of properties for each logging level
	 * name, e.g. log.info and log.verbose, which are functions that take an
	 * object of any key/value pairs, which will be merged with the productId
	 * and the messageId values passed to the constructor, and output via
	 * console.table.
	 *
	 * Example: debugLogger.log({
	 *   info: { foo: true },
	 *   verbose: {
	 *     foo: true,
	 *     bar: 123,
	 *     baz 'abc',
	 *     timestamp: performance.now()
	 *   },
	 * });
	 *
	 * @param messages Record<LoggingLevels, Record<string, unknown>> An object
	 * keyed by the desired log-level, with each value being an object of any
	 * key/value pairs to be output to console.table.
	 */ this.log = (messages)=>{
            [
                ...Object.keys(messages)
            ].forEach((loggingLevel)=>{
                $df6e50e0e93de28e$var$logMessageIfValidLoggingLevel(loggingLevel, {
                    productId: this.state.productId,
                    messageId: this.state.messageId,
                    ...messages[loggingLevel] ?? {},
                    ...loggingLevel === 'verbose' ? {
                        timestamp: performance.now()
                    } : {}
                });
            });
        };
        /**
	 * A function that takes an object of properties for each logging level
	 * name, e.g. trace.info and trace.verbose, which are functions that take
	 * a string to be used as the label for a stack trace via console.trace.
	 *
	 * Example: debugLogger.trace({
	 *   info: 'This is a stack trace',
	 *   verbose: `This is a stack trace with a much more verbose message which
	 * contains data about the ${productId} and ${messageId} within my function,
	 * invoked at ${performance.now()}ms`,
	 * });
	 *
	 * @param messages Record<LoggingLevels, string> An object keyed by the
	 * desired log-level, with each value being a string to be output as the
	 * label to console.trace.
	 */ this.trace = (messages)=>{
            [
                ...Object.keys(messages)
            ].forEach((loggingLevel)=>{
                $df6e50e0e93de28e$var$traceMessageIfValidLoggingLevel(loggingLevel, this.state.productId, this.state.messageId, `${messages[loggingLevel]}${loggingLevel === 'verbose' ? ` (${performance.now()})` : ''}`);
            });
        };
        this.state = {
            productId: productId,
            messageId: messageId
        };
    }
}

});

parcelRegister("7cTYp", function(module, exports) {

$parcel$export(module.exports, "Logger", () => $d9e69a5d0cc0dc3b$export$efa9a398d6368992);

var $TTRxY = parcelRequire("TTRxY");
class $d9e69a5d0cc0dc3b$export$efa9a398d6368992 {
    /**
	 * Utility class to simplify and allow for wider use of sending operational event to the Analytics web client for logging/metrics.
	 *
	 * @param actionSubject A (MessageActions) string denoting either the start or stop phase of a message.
	 * @param actionSubjectId Unique messageId to be logged with this even.
	 * @param metricsData Additional data from plugin to be sent with event for metrics logging.
	 * @param analyticsClient An instance of AnalyticsWebClient, unique to each caller
	 * @param [plugin] An optional plugin instance.
	 */ constructor(actionSubject, actionSubjectId, metricsData, analyticsClient, plugin){
        this.state = {
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            metricsData: metricsData,
            analyticsClient: analyticsClient,
            plugin: plugin
        };
    }
    /**
	 * Send operational event to the Analytics web client for logging/metrics.
	 *
	 * @param action A (MessageDeliveryStatuses) string denoting the ultimate disposition of this message start or stop request.
	 */ sendOperationalEvent(action, additionalAttributes) {
        const { analyticsClient: analyticsClient, actionSubject: actionSubject, actionSubjectId: actionSubjectId, metricsData: attributes, plugin: plugin } = this.state;
        const event = {
            source: 'choreographer',
            action: action,
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            attributes: {
                ...attributes ?? {},
                ...additionalAttributes ?? {}
            },
            tags: [
                'postOffice'
            ]
        };
        if (plugin?.shouldLogEvent?.(event) ?? true) analyticsClient.sendOperationalEvent(event);
    }
    blocked(additionalAttributes) {
        this.sendOperationalEvent((0, $TTRxY.MessageDeliveryStatus).BLOCKED, additionalAttributes);
    }
    error(additionalAttributes) {
        this.sendOperationalEvent((0, $TTRxY.MessageDeliveryStatus).ERROR, additionalAttributes);
    }
    unregistered(additionalAttributes) {
        this.sendOperationalEvent((0, $TTRxY.MessageDeliveryStatus).UNREGISTERED, additionalAttributes);
    }
    started(additionalAttributes) {
        this.sendOperationalEvent((0, $TTRxY.MessageDeliveryStatus).STARTED, additionalAttributes);
    }
    stopped(additionalAttributes) {
        this.sendOperationalEvent((0, $TTRxY.MessageDeliveryStatus).STOPPED, additionalAttributes);
    }
}

});

parcelRegister("8HM6e", function(module, exports) {

$parcel$export(module.exports, "isChoreographerSuppressed", () => $d93850280d469418$export$a0c8fa5038db1b93);

var $iEN9D = parcelRequire("iEN9D");
function $d93850280d469418$export$a0c8fa5038db1b93() {
    return (0, $iEN9D.default).initializeCompleted() && (0, $iEN9D.default).getExperimentValue('post-office_ipm_choreographer_new_tenants', 'supressChoreographer', false);
}

});


parcelRegister("4YUjU", function(module, exports) {

$parcel$export(module.exports, "ChoreographerPlugin", () => $05d317f1a3b9d082$export$71324a662782c710);

var $buAWB = parcelRequire("buAWB");
var $iZhen = parcelRequire("iZhen");

var $9ACoj = parcelRequire("9ACoj");
class $05d317f1a3b9d082$export$71324a662782c710 {
    /**
	 * Instantiates a plugin to be used with the main choreographer API. Requires a productId string
	 * to be used for segmenting registered messageIds in other parts of the API, which ensures uniqueness
	 * between individual products for tracking purposes.
	 *
	 * @param productId The name of the product for which this plugin will be managing communications with the choreographer API.
	 * @param env The environment type for the product, to be used for analytics events.
	 * @param metaMetricsData An object containing additional metadata to be sent along with every message request.
	 * @returns A new instance of this plugin to use for integrating a 1P or 3P product with the choreographer API.
	 */ constructor(productId, env, metaMetricsData = {}){
        this.state = {
            isDisabled: false,
            isDisplayingMessage: false,
            metaMetricsData: metaMetricsData,
            productId: productId,
            unregisterPlugin: ()=>{}
        };
        this.analyticsClient = this.createAnalyticsClient(env);
        /**
		 * These finalizers are callbacks to be invoked after a valid start or stop request in the Choreographer core.
		 * Declaring them in the constructor because it's the same onStart/onStop pair that will be passed ot all of the
		 * .on, .onStart, and .onStop function registrations.
		 *
		 * This behavior used to be managed by a decorator function that would auto-set the isDisplayingMessage value
		 * whenever its start or stop callbacks were invoked. However, those start and stop callbacks are optional from
		 * this layer, so if a consumer did *not* register a stop callback, the display state would never be cleared here
		 * in the plugin, and would continue blocking messages.
		 *
		 * We're now passing these onStart and onStop callbacks as part of the message registration, so that any time a
		 * message is started or stopped at the core layer, we can fire these callbacks to update the plugin's local state,
		 * whether or not an actual start or stop callback was registered by the consumer.
		 */ this.finalizers = {
            onStart: ()=>this.blockDisplayState(),
            onStop: ()=>this.clearDisplayState()
        };
        this.state.unregisterPlugin = this.registerPlugin(productId);
    }
    /**
	 * Public method to clean up this plugin instance, which will handle unregistering it from the choreographer API.
	 */ destroy() {
        this.state.unregisterPlugin();
    }
    /**
	 * Determines whether this plugin is currently displaying a message on the screen. By default, is a simple boolean
	 * toggle that gets flipped back and forth, but it could also be a function that checks the DOM for a given message
	 * container to be present, or checks with some external API to tell it whether a message is being displayed, or
	 * anything else. The logic is up to the consumer to implement, if something custom is desired.
	 *
	 * @returns A boolean that represents whether this plugin is currently displaying a message on the screen.
	 */ isDisplayingMessage() {
        return this.state.isDisplayingMessage;
    }
    /**
	 * Sets the internal isDisplayingMessage state to true, to denote that this plugin is currently blocking the UI.
	 */ blockDisplayState() {
        this.state.isDisplayingMessage = true;
    }
    /**
	 * Sets the internal isDisplayingMessage state to false, to denote that this plugin is no longer blocking the UI.
	 */ clearDisplayState() {
        this.state.isDisplayingMessage = false;
    }
    /**
	 * Disables the plugin from being able to issue startMessage requests. By default, this is a simple boolean toggle
	 * that gets flipped back and forth, but it could also be a call to an external API to disable some functionality
	 * via its own public interface. The logic is up to the consumer to implement, if something custom is desired.
	 */ disable() {
        this.state.isDisabled = true;
    }
    /**
	 * Enables the plugin from being able to issue startMessage requests. By default, this is a simple boolean toggle
	 * that gets flipped back and forth, but it could also be a call to an external API to disable some functionality
	 * via its own public interface. The logic is up to the consumer to implement, if something custom is desired.
	 */ enable() {
        this.state.isDisabled = false;
    }
    /**
	 * Makes a request to start a message through the choreographer API. Will immediately return false if this plugin
	 * is currently in a disabled state, and will otherwise return the ultimate result of the startMessage request.
	 *
	 * @param messageId The messageId for the message to be started through the choreographer API.
	 * @param additionalData An object containing additional metadata to be sent along with the message start request
	 * @returns A Promise that resolves to a MessageDeliveryStatus value, to denote the ultimate status of the attempted message start operation.
	 */ async startMessage(messageId, additionalData = {}) {
        return (0, $9ACoj.Choreographer).getInstance().startMessage(this.state.productId, messageId, this.analyticsClient, {
            ...this.state.metaMetricsData,
            ...additionalData
        }, this);
    }
    /**
	 * Makes a request to stop a message through the choreographer API. Will return the ultimate result of the stopMessage request.
	 *
	 * @param messageId The messageId for the message to be stopped through the choreographer API.
	 * @param additionalData An object containing additional metadata to be sent along with the message stop request
	 * @returns A Promise that resolves to a MessageDeliveryStatus value, to denote the ultimate status of the attempted message stop operation.
	 */ async stopMessage(messageId, additionalData = {}) {
        return (0, $9ACoj.Choreographer).getInstance().stopMessage(this.state.productId, messageId, this.analyticsClient, {
            ...this.state.metaMetricsData,
            ...additionalData
        });
    }
    /**
	 * Subscribes callbacks to be used for starting and stopping message requests through the choreographer, keyed by a unique (to this plugin instance) messageId.
	 *
	 * @param messageId Unique identifier within the context of all of this plugin's message entries, to be used as a key for this message subscription.
	 * @param options An object containing start and stop callback functions, to be invoked upon successful requests to startMessage and stopMessage, respectively.
	 */ on(messageId, options = {}) {
        return (0, $9ACoj.Choreographer).getInstance().on(this.state.productId, messageId, options, this.finalizers);
    }
    /**
	 * Subscribes a callback to be used for starting message requests through the choreographer, keyed by a unique (to this plugin instance) messageId.
	 *
	 * @param messageId Unique identifier within the context of all of this plugin's message entries, to be used as a key for this message subscription.
	 * @param startCallback A callback to be invoked upon successful requests to startMessage.
	 */ onStart(messageId, startCallback) {
        return (0, $9ACoj.Choreographer).getInstance().onStart(this.state.productId, messageId, startCallback, this.finalizers);
    }
    /**
	 * Subscribes a callback to be used for stopping message requests through the choreographer, keyed by a unique (to this plugin instance) messageId.
	 *
	 * @param messageId Unique identifier within the context of all of this plugin's message entries, to be used as a key for this message subscription.
	 * @param stopCallback A callback to be invoked upon successful requests to stopMessage.
	 */ onStop(messageId, stopCallback) {
        return (0, $9ACoj.Choreographer).getInstance().onStop(this.state.productId, messageId, stopCallback, this.finalizers);
    }
    /**
	 * Unsubscribes a message's start and stop message callbacks from the choreographer, keyed by a unique (to this plugin instance) messageId.
	 *
	 * @param messageId Unique identifier within the context of all of this plugin's message entries, to be used as a key for unsubscribing this message subscription.
	 */ off(messageId) {
        return (0, $9ACoj.Choreographer).getInstance().off(this.state.productId, messageId);
    }
    /**
	 * Registers this plugin instance with the choreographer API. Allows the choreographer to enable and disable it as needed to ensure individual message experiences on screen.
	 *
	 * @param productId The name of the product for which this plugin will be managing communications with the choreographer API.
	 * @returns A callback to be used to unregister this plugin with the choreographer instance, for cleanup purposes, if necessary.
	 */ registerPlugin(productId) {
        return (0, $9ACoj.Choreographer).getInstance().registerPlugin(productId, this);
    }
    /**
	 * Creates a new instance of the Analytics Web Client for a plugin to use for sending analytics events.
	 *
	 * @param env environment type used to create the analytics client
	 * @returns AnalyticsWebClient instance
	 */ createAnalyticsClient(env) {
        const analyticsClient = new (0, $buAWB.default)({
            env: env,
            product: 'postOffice',
            origin: (0, $iZhen.originType).WEB
        });
        return analyticsClient;
    }
}

});


const $da88f8f66d8f0f0a$export$3288b14b6745c572 = 204;
const $da88f8f66d8f0f0a$export$c09e7ea0fc79f34f = 409;
const $da88f8f66d8f0f0a$export$974c37534b0191b1 = 503;

parcelRegister("5Xk79", function(module, exports) {

$parcel$export(module.exports, "errorIfNotOk", () => $4c2fd435c53be241$export$4adbd37839ed7718);
$parcel$export(module.exports, "pullResponseTextIfNotOk", () => $4c2fd435c53be241$export$2ba4cde277adb6b1);
$parcel$export(module.exports, "stargateFetch", () => $4c2fd435c53be241$export$317bcea84a3bea48);
/* eslint-disable @atlassian/tangerine/import/no-restricted-paths */ 
var $2qBHI = parcelRequire("2qBHI");
const $4c2fd435c53be241$export$1f86472c1374185a = 3;
const $4c2fd435c53be241$export$a2d611d5c7be4bb1 = 0.1;
const $4c2fd435c53be241$export$957d605a51548b59 = 2;
const $4c2fd435c53be241$export$80aa83cae6a6c290 = 1000;
async function $4c2fd435c53be241$export$4adbd37839ed7718(response) {
    if (!response.ok) // We use the response body for two reasons:
    // 1. To ensure that we consume the response body, so that it gets reported on in Chrome DevTools
    // 2. It could have some useful information relevant to the error
    throw Error(`${response.status}: ${await response.text()}`);
    return response;
}
async function $4c2fd435c53be241$export$2ba4cde277adb6b1(response) {
    if (!response.ok) await response.text();
    return response;
}
function $4c2fd435c53be241$export$317bcea84a3bea48(input, reqOptions) {
    return $4c2fd435c53be241$var$fetchWithRetry({
        input: input,
        reqOptions: reqOptions,
        numRetries: 0,
        maxRetries: $4c2fd435c53be241$export$1f86472c1374185a,
        waitTimeMs: $4c2fd435c53be241$export$80aa83cae6a6c290,
        backoffFn: $4c2fd435c53be241$export$924aee1254634401
    });
}
function $4c2fd435c53be241$var$fetchWithRetry({ input: input, reqOptions: reqOptions, numRetries: numRetries = 0, maxRetries: maxRetries = 0, waitTimeMs: waitTimeMs = 0, backoffFn: backoffFn = $4c2fd435c53be241$export$924aee1254634401 }) {
    if (numRetries > maxRetries) throw new Error(`Failed to fetch ${input}: Max retries exceeded`);
    const options = {
        ...reqOptions,
        credentials: (0, $2qBHI.default).includes(location.host) ? 'include' : 'same-origin'
    };
    const retryAttempt = ()=>new Promise((resolve)=>{
            setTimeout(()=>{
                resolve($4c2fd435c53be241$var$fetchWithRetry({
                    input: input,
                    reqOptions: reqOptions,
                    numRetries: numRetries + 1,
                    maxRetries: maxRetries,
                    waitTimeMs: backoffFn(waitTimeMs),
                    backoffFn: backoffFn
                }));
            }, waitTimeMs);
        });
    return fetch(input, options).then((response)=>{
        if (response.status >= 500 && response.status <= 599) return retryAttempt();
        return response;
    }).catch(()=>{
        return retryAttempt();
    });
}
function $4c2fd435c53be241$export$924aee1254634401(waitTimeMs) {
    const nextWaitTime = waitTimeMs * $4c2fd435c53be241$export$957d605a51548b59;
    const jitter = nextWaitTime * $4c2fd435c53be241$export$a2d611d5c7be4bb1 * Math.random();
    return nextWaitTime + jitter;
}

});
parcelRegister("2qBHI", function(module, exports) {

$parcel$export(module.exports, "default", () => $269377431b5cba8d$export$2e2bcd8739ae039);
var $269377431b5cba8d$export$2e2bcd8739ae039 = [
    // Bitbucket Pipelines domains (is an iframe and require CORS)
    'bitbucket-pipelines.dev.public.atl-paas.net',
    'bitbucket-pipelines.staging.public.atl-paas.net',
    'bitbucket-pipelines.prod.public.atl-paas.net'
];

});





parcelRegister("5pZVQ", function(module, exports) {

$parcel$export(module.exports, "EngagementProvider", () => $63ee8f5ffbbe7d5e$export$83b8ae7ce7b4d59c);
/* eslint-disable max-lines */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $f8l56 = parcelRequire("f8l56");

var $bxYf9 = parcelRequire("bxYf9");

var $8rCP3 = parcelRequire("8rCP3");

var $dyczo = parcelRequire("dyczo");

var $hDX9C = parcelRequire("hDX9C");
var $bvUB1 = parcelRequire("bvUB1");

var $TTRxY = parcelRequire("TTRxY");
var $kmPbm = parcelRequire("kmPbm");

var $1gxex = parcelRequire("1gxex");

var $6DQWS = parcelRequire("6DQWS");

var $kvwcw = parcelRequire("kvwcw");

var $1V1R5 = parcelRequire("1V1R5");

var $7CfdH = parcelRequire("7CfdH");

var $kjEZw = parcelRequire("kjEZw");

var $jch2y = parcelRequire("jch2y");
const $63ee8f5ffbbe7d5e$var$MAX_EVENT_QUEUE_SIZE = 100;
const $63ee8f5ffbbe7d5e$var$EK_LOADED_EVENT = 'engagement.inproduct.loaded';
const $63ee8f5ffbbe7d5e$export$5306bd00631dbf8c = 'ep.analyticEvent';
function $63ee8f5ffbbe7d5e$var$collapseEventToPayload(event) {
    const payload = {
        ...event.payload,
        context: {}
    };
    Object.assign(payload.context, ...event.context);
    return payload;
}
function $63ee8f5ffbbe7d5e$var$findMatchingTrigger(messageMapping, payload) {
    return Array.from(messageMapping.keys()).find((trigger)=>{
        return (0, (/*@__PURE__*/$parcel$interopDefault($f8l56)))(payload, trigger);
    });
}
function $63ee8f5ffbbe7d5e$var$fireExposureEvent(attributes, clientOrPromise) {
    const analyticsEvent = new (0, $hDX9C.default)({
        payload: {
            action: 'exposed',
            actionSubject: 'feature',
            actionSubjectId: attributes.flagKey,
            source: 'engagement-platform',
            attributes: attributes
        }
    });
    Promise.resolve(clientOrPromise).then((client)=>{
        client.sendTrackEvent(analyticsEvent.payload);
    });
}
function $63ee8f5ffbbe7d5e$var$getExposureAttributes(messageId, cohort, additionalProps) {
    return {
        reason: 'RULE_MATCH',
        ruleId: 'engagement.inproduct',
        flagKey: `engagement.inproduct.${messageId}`,
        value: cohort,
        ...additionalProps
    };
}
function $63ee8f5ffbbe7d5e$var$getBaseAttributes(messageId, variationId, componentId, locale) {
    return {
        messageId: messageId,
        variationId: variationId,
        componentIndex: componentId,
        locale: locale
    };
}
async function $63ee8f5ffbbe7d5e$export$473a2bbbfd90c87b(eventMapping, config, store, clientOrPromise, coordinationOptions, componentConfig) {
    const { locale: locale } = config;
    const { message: message, component: component } = eventMapping;
    if (message.holdout) {
        await (0, $1gxex.startMessage)({
            cloudId: config.cloudId,
            stargateUrl: config.stargateUrl,
            messageId: message.messageId,
            variationId: message.variationId,
            orgId: config.orgId,
            workspaceId: config.workspaceId
        }, coordinationOptions);
        await (0, $1gxex.stopMessage)({
            cloudId: config.cloudId,
            stargateUrl: config.stargateUrl,
            messageId: message.messageId,
            orgId: config.orgId,
            workspaceId: config.workspaceId
        }, coordinationOptions);
        $63ee8f5ffbbe7d5e$var$fireExposureEvent($63ee8f5ffbbe7d5e$var$getExposureAttributes(message.messageId, 'holdout', {
            locale: locale
        }), clientOrPromise);
        return;
    }
    if (component.componentId === 0) {
        const success = await (0, $1gxex.startMessage)({
            cloudId: config.cloudId,
            stargateUrl: config.stargateUrl,
            messageId: message.messageId,
            variationId: message.variationId,
            orgId: config.orgId,
            workspaceId: config.workspaceId
        }, coordinationOptions);
        if (coordinationOptions?.enableChoreographer && componentConfig?.onMessageDisposition) componentConfig.onMessageDisposition(success ? (0, $TTRxY.MessageDeliveryStatus).STARTED : (0, $TTRxY.MessageDeliveryStatus).BLOCKED);
        if (success) {
            $63ee8f5ffbbe7d5e$var$fireExposureEvent($63ee8f5ffbbe7d5e$var$getExposureAttributes(message.messageId, message.variationId, {
                locale: locale
            }), clientOrPromise);
            store.dispatch((0, $kjEZw.setCurrent)(eventMapping));
        }
    } else {
        $63ee8f5ffbbe7d5e$var$fireExposureEvent($63ee8f5ffbbe7d5e$var$getExposureAttributes(message.messageId, message.variationId, {
            locale: locale
        }), clientOrPromise);
        store.dispatch((0, $kjEZw.setCurrent)(eventMapping));
    }
}
class $63ee8f5ffbbe7d5e$export$83b8ae7ce7b4d59c extends (0, $5uXOq.Component) {
    static{
        this.componentConfig = new Map();
    }
    static{
        this.childContextTypes = {
            subscribeEngagementState: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).func,
            setComponentConfig: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).func
        };
    }
    static{
        this.defaultProps = {
            eventTarget: (0, (/*@__PURE__*/$parcel$interopDefault($dyczo)))
        };
    }
    static{
        /*
	 * We use this flag for ensuring that we only fire the engagement.inproduct.loaded event once. This is an interim solution
	 * until we can more holistically rethink our code architecture to eliminate duplicate behaviour across EngagementProviders.
	 */ this.hasInitializedAtLeastOneEngagementProvider = false;
    }
    constructor(props){
        super(props), this.onStoreChange = (state)=>{
            const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
            const config = this.getConfig();
            const { locale: locale } = config;
            if (state.initialized) {
                if (!$63ee8f5ffbbe7d5e$export$83b8ae7ce7b4d59c.hasInitializedAtLeastOneEngagementProvider) {
                    this.sendOperationalEventWithClient({
                        action: 'loaded',
                        actionSubject: 'messages',
                        actionSubjectId: undefined,
                        source: 'engagekit',
                        attributes: {
                            locale: locale
                        }
                    });
                    const browserInfo = (0, $kvwcw.getBrowserInfo)();
                    this.onEvent(createAnalyticsEvent({
                        event: $63ee8f5ffbbe7d5e$var$EK_LOADED_EVENT,
                        properties: {
                            browser: browserInfo.name,
                            browserVersion: browserInfo.version
                        }
                    }));
                    $63ee8f5ffbbe7d5e$export$83b8ae7ce7b4d59c.hasInitializedAtLeastOneEngagementProvider = true;
                }
                this.analyticsEventQueue.flush(this.onEvent);
                if (this.unsubscribeFromStore) this.unsubscribeFromStore();
            }
        }, this.onEvent = (event)=>{
            const state = this.getState();
            if (!state.initialized) {
                const success = this.analyticsEventQueue.enqueue(event);
                if (!success) this.fireQueueOverflowEvent();
                return;
            }
            const { eventTarget: eventTarget, store: store, analyticsClientInstance: analyticsClientInstance } = this.props;
            const config = this.getConfig();
            const { current: current, messageMapping: messageMapping } = state;
            const payload = $63ee8f5ffbbe7d5e$var$collapseEventToPayload(event);
            eventTarget.dispatchEvent((0, $1V1R5.default)({
                eventName: $63ee8f5ffbbe7d5e$export$5306bd00631dbf8c,
                canBubble: false,
                cancellable: false,
                detail: payload
            }));
            if (!(0, $7CfdH.isMessagingEnabled)()) return;
            // existing message found
            if (current) return;
            const trigger = $63ee8f5ffbbe7d5e$var$findMatchingTrigger(messageMapping, payload);
            // No messages found for trigger
            if (!trigger) return;
            const eventMapping = messageMapping.get(trigger);
            let componentConfig;
            if (eventMapping.component?.componentType) {
                const componentConfigId = this.getConfigId(eventMapping.component.componentType, eventMapping.component.target);
                componentConfig = $63ee8f5ffbbe7d5e$export$83b8ae7ce7b4d59c.componentConfig.get(componentConfigId);
            }
            const coordinationOptions = this.getComponentCoordinationOptions(componentConfig);
            $63ee8f5ffbbe7d5e$export$473a2bbbfd90c87b(eventMapping, config, store, analyticsClientInstance, coordinationOptions, componentConfig);
        }, this.onEngagementEvent = (event)=>{
            const { action: action, clickType: clickType, ekMessageId: ekMessageId, ekVariationId: ekVariationId, ekComponentId: ekComponentId, ekComponentType: ekComponentType, ekIsLast: ekIsLast } = event.payload;
            const config = this.getConfig();
            const { locale: locale } = config;
            const attributes = $63ee8f5ffbbe7d5e$var$getBaseAttributes(ekMessageId, ekVariationId, ekComponentId, locale);
            if (action === 'click') {
                this.handleClickEvent(ekMessageId, ekVariationId, ekComponentId);
                attributes.buttonType = clickType;
                this.sendUIEventWithClient({
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: `${clickType}Button`,
                    source: `engagement_${ekComponentType}`,
                    attributes: attributes
                });
            } else {
                if (action === 'shown') {
                    attributes.componentType = ekComponentType;
                    this.sendScreenEventWithClient({
                        name: `engagement_${ekComponentType}`,
                        attributes: attributes
                    });
                }
                if (action === 'hidden') {
                    attributes.isLast = ekIsLast;
                    this.sendUIEventWithClient({
                        action: 'hid',
                        actionSubject: 'component',
                        actionSubjectId: undefined,
                        source: `engagement_${ekComponentType}`,
                        attributes: attributes
                    });
                }
            }
            this.onEvent(event);
        }, this.subscribeEngagementState = (callback)=>{
            const { store: store } = this.props;
            callback(store.getState());
            return store.subscribe(()=>{
                callback(store.getState());
            });
        }, this.getComponentCoordinationOptions = (componentConfig)=>{
            // Default enableChoreographer to the EngagementProvider's coordinationOptions
            const enableChoreographer = Boolean(this.props.coordinationOptions?.enableChoreographer);
            return {
                ...this.props.coordinationOptions,
                enableChoreographer: componentConfig?.messageType ? // regardless of the EngagementProvider's coordinationOptions
                (0, $kmPbm.shouldBeChoreographed)(componentConfig, {
                    enableChoreographer: true
                }) : enableChoreographer
            };
        }, this.getConfigId = (componentType, engagementId)=>{
            return engagementId ? `${componentType}-${engagementId}` : componentType;
        }, this.setComponentConfig = (componentType, config, engagementId)=>{
            const configId = this.getConfigId(componentType, engagementId);
            $63ee8f5ffbbe7d5e$export$83b8ae7ce7b4d59c.componentConfig.set(configId, config);
            return ()=>this.removeComponentConfig(configId);
        }, this.removeComponentConfig = (configId)=>{
            if ($63ee8f5ffbbe7d5e$export$83b8ae7ce7b4d59c.componentConfig.has(configId)) $63ee8f5ffbbe7d5e$export$83b8ae7ce7b4d59c.componentConfig.delete(configId);
        };
        const { analyticsClientInstance: analyticsClientInstance } = this.props;
        this.sendUIEventWithClient = (0, $6DQWS.sendUIEvent).bind(null, analyticsClientInstance);
        this.sendScreenEventWithClient = (0, $6DQWS.sendScreenEvent).bind(null, analyticsClientInstance);
        this.sendOperationalEventWithClient = (0, $6DQWS.sendOperationalEvent).bind(null, analyticsClientInstance);
        this.analyticsEventQueue = new (0, $jch2y.default)($63ee8f5ffbbe7d5e$var$MAX_EVENT_QUEUE_SIZE);
        this.unsubscribeFromStore = this.subscribeEngagementState(this.onStoreChange);
        this.fireQueueOverflowEvent = (0, (/*@__PURE__*/$parcel$interopDefault($bxYf9)))(// TODO: create metric for this with Metal
        ()=>{});
    }
    getConfig() {
        const { config: config } = this.getState();
        return config;
    }
    getChildContext() {
        return {
            subscribeEngagementState: this.subscribeEngagementState,
            setComponentConfig: this.setComponentConfig
        };
    }
    getState() {
        return this.props.store.getState();
    }
    getActiveMessage() {
        return this.getState().current;
    }
    async completeMessage(messageId, componentConfig) {
        const config = this.getConfig();
        const coordinationOptions = this.getComponentCoordinationOptions(componentConfig);
        const disposition = await (0, $1gxex.stopMessage)({
            cloudId: config.cloudId,
            stargateUrl: config.stargateUrl,
            messageId: messageId,
            orgId: config.orgId,
            workspaceId: config.workspaceId
        }, coordinationOptions);
        if (coordinationOptions.enableChoreographer && componentConfig?.onMessageDisposition) componentConfig.onMessageDisposition(disposition ? (0, $TTRxY.MessageDeliveryStatus).STOPPED : (0, $TTRxY.MessageDeliveryStatus).CANCELED);
    }
    handleClickEvent(messageId, variationId, componentId) {
        const activeMessage = this.getActiveMessage();
        // It is important to check that the event we're handling matches the
        // current active message because it is possible for an event to come
        // through for a past message. We don't want to mess up the current
        // message by calling clearCurrent just because the old message is done.
        if (!activeMessage || activeMessage.messageId !== messageId || activeMessage.variationId !== variationId || activeMessage.componentId !== componentId) return;
        let componentConfig;
        if (activeMessage.componentType) {
            const componentConfigId = this.getConfigId(activeMessage.componentType, activeMessage.target);
            componentConfig = $63ee8f5ffbbe7d5e$export$83b8ae7ce7b4d59c.componentConfig.get(componentConfigId);
        }
        if (activeMessage.isLast) this.completeMessage(messageId, componentConfig);
        this.props.store.dispatch((0, $kjEZw.clearCurrent)());
    }
    componentWillUnmount() {
        this.unsubscribeFromStore && this.unsubscribeFromStore();
    }
    render() {
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bvUB1.default), {
            channel: "*",
            onEvent: this.onEvent,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bvUB1.default), {
                channel: "engagement",
                onEvent: this.onEngagementEvent,
                children: this.props.children
            })
        });
    }
}

});
parcelRegister("kmPbm", function(module, exports) {

$parcel$export(module.exports, "shouldBeChoreographed", () => $349a22efab51e753$export$a8ba9111c7eec9ac);
$parcel$export(module.exports, "wrapComponentForChoreographer", () => $349a22efab51e753$export$51d40de083bcc6e7);
$parcel$export(module.exports, "wrapToggleableComponentForChoreographer", () => $349a22efab51e753$export$7c574bc7a8b74124);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $TTRxY = parcelRequire("TTRxY");
const $349a22efab51e753$export$a8ba9111c7eec9ac = (props, coordinationOptions)=>{
    return Boolean(coordinationOptions?.enableChoreographer) && props?.messageType !== undefined && (0, $TTRxY.IntegratedChoreographerMessageTypesEnum).includes(props.messageType);
};
const $349a22efab51e753$export$51d40de083bcc6e7 = (Component)=>{
    function WrapperComponent({ shouldBeChoreographed: shouldBeChoreographedProp, withChoreographedRender: withChoreographedRender, ...props }) {
        const ChoreographedComponent = (0, $5uXOq.useMemo)(()=>withChoreographedRender(Component), [
            withChoreographedRender
        ]);
        if (shouldBeChoreographedProp(props)) {
            // Extract messageType since it is not a property of ChoreographedComponent
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const { messageType: messageType, ...rest } = props;
            return /*#__PURE__*/ (0, $2OMIu.jsx)(ChoreographedComponent, {
                ...rest
            });
        }
        // Extract messageType since it is not a property of the original Atlaskit component
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { messageType: messageType, messageId: messageId, onMessageDisposition: onMessageDisposition, ...rest } = props;
        return /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
            ...rest
        });
    }
    WrapperComponent.displayName = `ChoreographerWrapped${(Component.displayName ?? Component.name) || 'Component'}`;
    return WrapperComponent;
};
const $349a22efab51e753$export$7c574bc7a8b74124 = (Component, toggleableProp)=>{
    function WrapperComponent({ shouldBeChoreographed: shouldBeChoreographedProp, withChoreographedToggle: withChoreographedToggle, ...props }) {
        const ChoreographedComponent = (0, $5uXOq.useMemo)(()=>withChoreographedToggle(Component, toggleableProp), [
            withChoreographedToggle
        ]);
        if (shouldBeChoreographedProp(props)) {
            // Extract messageType since it is not a property of ChoreographedComponent
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const { messageType: messageType, ...rest } = props;
            return /*#__PURE__*/ (0, $2OMIu.jsx)(ChoreographedComponent, {
                ...rest
            });
        }
        // Extract messageType since it is not a property of the original Atlaskit component
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { messageType: messageType, messageId: messageId, onMessageDisposition: onMessageDisposition, ...rest } = props;
        return /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
            ...rest
        });
    }
    WrapperComponent.displayName = `ChoreographerWrapped${(Component.displayName ?? Component.name) || 'Component'}`;
    return WrapperComponent;
};

});

parcelRegister("6DQWS", function(module, exports) {

$parcel$export(module.exports, "sendScreenEvent", () => $e2229a045a8d1e70$export$22a3b1671f38a193);
$parcel$export(module.exports, "sendUIEvent", () => $e2229a045a8d1e70$export$1aecf263098db667);
$parcel$export(module.exports, "sendOperationalEvent", () => $e2229a045a8d1e70$export$e5f89b51c6d4e36b);
function $e2229a045a8d1e70$export$22a3b1671f38a193(clientOrPromise, payload) {
    Promise.resolve(clientOrPromise).then((client)=>{
        client.sendScreenEvent(payload);
    });
}
function $e2229a045a8d1e70$export$1aecf263098db667(clientOrPromise, payload) {
    Promise.resolve(clientOrPromise).then((client)=>{
        client.sendUIEvent(payload);
    });
}
function $e2229a045a8d1e70$export$e5f89b51c6d4e36b(clientOrPromise, payload) {
    Promise.resolve(clientOrPromise).then((client)=>{
        client.sendOperationalEvent(payload);
    });
}

});

parcelRegister("kvwcw", function(module, exports) {

$parcel$export(module.exports, "getBrowserInfo", () => $a57e7d3f26bcd5b0$export$6c724a6ffa2dc3e1);
const $a57e7d3f26bcd5b0$var$browserMatchers = [
    {
        name: 'IE',
        pattern: /Trident\/.*; rv:([^;)]+)/
    },
    {
        name: 'Chrome',
        pattern: /Chrome\/([^ )]+)/
    },
    {
        name: 'Firefox',
        pattern: /Firefox\/([^ )]+)/
    }
];
const $a57e7d3f26bcd5b0$export$cda2203640e08931 = {
    name: 'unknown',
    version: 'unknown'
};
function $a57e7d3f26bcd5b0$export$6c724a6ffa2dc3e1(userAgent) {
    if (!window.navigator) return $a57e7d3f26bcd5b0$export$cda2203640e08931;
    if (!userAgent) userAgent = window.navigator.userAgent;
    for (const matcher of $a57e7d3f26bcd5b0$var$browserMatchers){
        const versionMatch = userAgent.match(matcher.pattern);
        if (versionMatch) return {
            name: matcher.name,
            version: versionMatch[1]
        };
    }
    return $a57e7d3f26bcd5b0$export$cda2203640e08931;
}

});

parcelRegister("1V1R5", function(module, exports) {

$parcel$export(module.exports, "default", () => $2790c6d4b1743589$export$2e2bcd8739ae039);
// @ts-nocheck
const $2790c6d4b1743589$var$createCustomEvent = ({ eventName: eventName, canBubble: canBubble, cancellable: cancellable, detail: detail })=>{
    const customEvent = document.createEvent('CustomEvent');
    customEvent.initCustomEvent(eventName, canBubble, cancellable, detail);
    return customEvent;
};
var $2790c6d4b1743589$export$2e2bcd8739ae039 = $2790c6d4b1743589$var$createCustomEvent;

});

parcelRegister("jch2y", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e7ede0d10dc16ca$export$2e2bcd8739ae039);
class $1e7ede0d10dc16ca$export$2e2bcd8739ae039 {
    constructor(maxSize){
        this.queue = [];
        this.maxSize = maxSize;
    }
    enqueue(item) {
        if (this.queue.length === this.maxSize) return false;
        this.queue.push(item);
        return true;
    }
    flush(callback) {
        this.queue.forEach(callback);
        this.queue = [];
    }
    getSize() {
        return this.queue.length;
    }
}

});



parcelRegister("j7rCb", function(module, exports) {

$parcel$export(module.exports, "setCurrent", () => $89d30012ddef3b50$export$5f80f094fd31fffd);
$parcel$export(module.exports, "LazyPhaseContext", () => $89d30012ddef3b50$export$5a25eca35e5debcb);
$parcel$export(module.exports, "useLazyPhase", () => $89d30012ddef3b50$export$1dc361b277327f88);

var $5uXOq = parcelRequire("5uXOq");

var $fVdZG = parcelRequire("fVdZG");

var $adSzG = parcelRequire("adSzG");

var $cRRE7 = parcelRequire("cRRE7");
let $89d30012ddef3b50$var$CURRENT_PHASE = (0, $fVdZG.PHASE).PAINT;
const $89d30012ddef3b50$export$5f80f094fd31fffd = (phase)=>{
    $89d30012ddef3b50$var$CURRENT_PHASE = phase;
    (0, $adSzG.LISTENERS).slice(0).forEach((listener)=>listener(phase));
};
const $89d30012ddef3b50$export$5a25eca35e5debcb = /*#__PURE__*/ (0, $5uXOq.createContext)({
    subscribe: (0, $cRRE7.createSubscribe)((0, $adSzG.LISTENERS)),
    currentValue: ()=>$89d30012ddef3b50$var$CURRENT_PHASE,
    api: {
        startNextPhase: ()=>{
            $89d30012ddef3b50$export$5f80f094fd31fffd((0, $fVdZG.PHASE).AFTER_PAINT);
        },
        resetPhase: ()=>$89d30012ddef3b50$export$5f80f094fd31fffd((0, $fVdZG.PHASE).PAINT)
    }
});
const $89d30012ddef3b50$export$1dc361b277327f88 = ()=>{
    const v = (0, $5uXOq.useContext)($89d30012ddef3b50$export$5a25eca35e5debcb);
    return v.api;
};

});
parcelRegister("fVdZG", function(module, exports) {

$parcel$export(module.exports, "PHASE", () => $42cd1e694b8e78ec$export$2cc7a2eaaea7809f);
$parcel$export(module.exports, "COLLECTED", () => $42cd1e694b8e78ec$export$4831ef3968ea94ef);
const $42cd1e694b8e78ec$export$2cc7a2eaaea7809f = {
    PAINT: 0,
    AFTER_PAINT: 1,
    LAZY: 2
};
const $42cd1e694b8e78ec$export$4831ef3968ea94ef = new Map();

});

parcelRegister("adSzG", function(module, exports) {

$parcel$export(module.exports, "LISTENERS", () => $c4a06b1b1597f883$export$81b9c458a026d68f);
const $c4a06b1b1597f883$export$81b9c458a026d68f = [];

});

parcelRegister("cRRE7", function(module, exports) {

$parcel$export(module.exports, "createSubscribe", () => $b8fa4315e8c49344$export$364097d812234b3f);
const $b8fa4315e8c49344$export$364097d812234b3f = (listeners)=>(listener)=>{
        listeners.push(listener);
        return ()=>{
            const index = listeners.indexOf(listener);
            if (index !== -1) listeners.splice(index, 1);
        };
    };

});


parcelRegister("bCf8q", function(module, exports) {

$parcel$export(module.exports, "createLoaderError", () => $323c58521b366879$export$c73a6a6f0bf7d425);
$parcel$export(module.exports, "isLoaderError", () => $323c58521b366879$export$16a03aca4a3508b4);
const $323c58521b366879$export$6aa69c1258005366 = Symbol.for('@atlassian/react-loosely-lazy/loader-error');
const $323c58521b366879$export$c73a6a6f0bf7d425 = (error)=>{
    if (typeof error === 'object') // @ts-expect-error Explicitly untyped
    return Object.assign(error, {
        [$323c58521b366879$export$6aa69c1258005366]: true
    });
    return error;
};
const $323c58521b366879$export$16a03aca4a3508b4 = (error)=>Object.getOwnPropertySymbols(error).includes($323c58521b366879$export$6aa69c1258005366);

});

parcelRegister("7hSN4", function(module, exports) {

$parcel$export(module.exports, "LazySuspense", () => $7741fbdbff529fad$export$256c542058532d6f);
/* eslint-disable @repo/internal/react/no-class-components */ 
var $5uXOq = parcelRequire("5uXOq");

var $7AnOd = parcelRequire("7AnOd");

var $ddkdN = parcelRequire("ddkdN");
var $7Ewwd = parcelRequire("7Ewwd");

var $7In2L = parcelRequire("7In2L");

var $VSDnB = parcelRequire("VSDnB");
class $7741fbdbff529fad$export$256c542058532d6f extends (0, $5uXOq.Component) {
    constructor(props){
        super(props), this.state = {
            getIsBoundaryInitialized: ()=>Boolean(this.hydrationFallback),
            // Used on server to render fallback down the tree
            fallback: this.props.fallback,
            // Used on client to replace fallback with magic input
            setFallback: (fallback)=>{
                if (this.hydrationFallback === fallback) return;
                this.hydrationFallback = fallback;
                // Schedule an update so we force switch from the sibling tree
                // back to the suspense boundary
                if (this.mounted && !(0, $ddkdN.getConfig)().react18) this.forceUpdate();
            },
            name: this.props.name
        }, this.hydrationFallback = null, this.mounted = false, this.renderedSuspenseFallback = false, this.DynamicFallback = ({ children: children, outsideSuspense: outsideSuspense })=>{
            // eslint-disable-next-line react-hooks/rules-of-hooks
            (0, $5uXOq.useLayoutEffect)(()=>{
                if (!outsideSuspense && (0, $VSDnB.fg)('react-loosely-lazy_unmount_hydration_fallback')) this.renderedSuspenseFallback = true;
                return ()=>{
                    // the effect cleanup is called by the Suspense boundary itself
                    // when both Lazy AND the eventual promises thrown are done
                    // so Suspense will re-render with actual content and we remove
                    // the hydration fallback at the same time
                    if (!outsideSuspense) this.state.setFallback(null);
                };
            }, [
                outsideSuspense
            ]);
            return outsideSuspense ? children(this.hydrationFallback ? this.hydrationFallback : null) : children(this.hydrationFallback ? null : this.props.fallback);
        }, this.DynamicReact18Fallback = ({ children: children })=>{
            (0, $5uXOq.useLayoutEffect)(()=>{
                if ((0, $VSDnB.fg)('react-loosely-lazy_unmount_hydration_fallback')) this.renderedSuspenseFallback = true;
                return ()=>{
                    // the effect cleanup is called by the Suspense boundary itself
                    // when both Lazy AND the eventual promises thrown are done
                    // so Suspense will re-render with actual content and we remove
                    // the hydration fallback at the same time
                    // - this is more "stable" way that tracking completion inside createComponentClient
                    // - we are done when fallback is removed
                    this.state.setFallback(null);
                };
            }, []);
            if ((0, $ddkdN.getConfig)().mode === (0, $7Ewwd.MODE).HYDRATE) return children(this.props.fallback);
            return children(this.hydrationFallback || this.props.fallback);
        };
        this.DynamicFallback.displayName = 'DynamicFallback';
        this.DynamicReact18Fallback.displayName = 'DynamicFallback';
    }
    componentDidMount() {
        this.mounted = true;
        // It is possible that the fallback is never rendered if React already
        // knows the lazy component was already resolved. In our case this means
        // nothing has suspended in the last render cycle. In that case, when the
        // component is mounted, renderedSuspenseFallback will not be set and
        // there is nothing that can clean up the hydration fallback, and we
        // can immediately clean it here.
        // Also see https://atlassian.slack.com/archives/CFGR2NAUA/p1741009492576969
        if (!this.renderedSuspenseFallback && (0, $VSDnB.fg)('react-loosely-lazy_unmount_hydration_fallback')) this.state.setFallback(null);
    }
    shouldComponentUpdate() {
        const { mode: mode, react18: react18 } = (0, $ddkdN.getConfig)();
        if (react18 && mode === (0, $7Ewwd.MODE).HYDRATE) // This is a workaround to prevent Suspense during hydration
        // from switching to the fallback if a re-render occurs
        // https://github.com/facebook/react/issues/22692
        // is shouldComponentUpdate => false if it's "busy"
        return this.hydrationFallback ? false : true;
        return true;
    }
    renderFallback(outsideSuspense) {
        const { DynamicFallback: DynamicFallback } = this;
        // Use render prop component to allow switch to hydration fallback
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(DynamicFallback, {
            outsideSuspense: outsideSuspense
        }, (fallback)=>fallback);
    }
    renderReact18Fallback() {
        const { DynamicReact18Fallback: DynamicReact18Fallback } = this;
        // Use render prop component to allow switch to hydration fallback
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(DynamicReact18Fallback, null, (fallback)=>fallback);
    }
    renderServer() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7In2L.LazySuspenseContext).Provider, {
            value: this.state
        }, this.props.children);
    }
    renderClient() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7In2L.LazySuspenseContext).Provider, {
            value: this.state
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Suspense), {
            fallback: this.renderFallback(false)
        }, this.props.children), (!this.mounted || this.hydrationFallback) && this.renderFallback(true));
    }
    render() {
        if ((0, $ddkdN.getConfig)().react18) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7In2L.LazySuspenseContext).Provider, {
            value: this.state
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Suspense), {
            fallback: this.renderReact18Fallback()
        }, this.props.children));
        return (0, $7AnOd.isNodeEnvironment)() ? this.renderServer() : this.renderClient();
    }
}

});
parcelRegister("7AnOd", function(module, exports) {

$parcel$export(module.exports, "getExport", () => $6ff86d172f86baa4$export$d4c07b1daf44a7f);
$parcel$export(module.exports, "displayNameFromId", () => $6ff86d172f86baa4$export$4429f98ef60d2d87);
$parcel$export(module.exports, "isNodeEnvironment", () => $6ff86d172f86baa4$export$283635c04a02cc36);
$parcel$export(module.exports, "attrToProp", () => $6ff86d172f86baa4$export$62bf630d0de3d781);

var $jJo8A = parcelRequire("jJo8A");
const $6ff86d172f86baa4$export$d4c07b1daf44a7f = (m)=>'default' in m ? m.default : m;
const $6ff86d172f86baa4$export$4429f98ef60d2d87 = (id)=>{
    const fName = id.split('/').slice(-3).join('/');
    return fName || 'Component';
};
const $6ff86d172f86baa4$export$283635c04a02cc36 = ()=>{
    if (typeof window === 'undefined') return true;
    if (window.name === 'nodejs') return true;
    return false;
};
function $6ff86d172f86baa4$export$62bf630d0de3d781(props, attr) {
    switch(attr.name){
        case 'style':
            break;
        case 'class':
            props.className = attr.value;
            break;
        case 'crossorigin':
            props.crossOrigin = attr.value;
            break;
        default:
            props[attr.name] = attr.value;
    }
    return props;
}

});
parcelRegister("jJo8A", function(module, exports) {

$parcel$export(module.exports, "default", () => $826166571ec93640$export$2e2bcd8739ae039);
/* eslint-disable */ // murmurhash2 via https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function $826166571ec93640$export$2e2bcd8739ae039(str) {
    var l = str.length, h = l ^ l, i = 0, k;
    while(l >= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        k ^= k >>> 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
        l -= 4;
        ++i;
    }
    switch(l){
        // @ts-ignore TS7029 fallthrough
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        // @ts-ignore TS7029 fallthrough
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    }
    h ^= h >>> 13;
    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    h ^= h >>> 15;
    return (h >>> 0).toString(36);
}

});


parcelRegister("ddkdN", function(module, exports) {

$parcel$export(module.exports, "getConfig", () => $215feff881673676$export$44487a86467333c3);
$parcel$export(module.exports, "setConfig", () => $215feff881673676$export$940a7873bb071df8);
$parcel$export(module.exports, "MODE", () => (parcelRequire("7Ewwd")).MODE);

var $7Ewwd = parcelRequire("7Ewwd");
const $215feff881673676$var$DEFAULT_CROSS_ORIGIN = undefined;
const $215feff881673676$var$DEFAULT_MANIFEST = {
    publicPath: '/',
    assets: {}
};
const $215feff881673676$var$DEFAULT_MODE = (0, $7Ewwd.MODE).HYDRATE;
const $215feff881673676$var$DEFAULT_RETRY = 2;
const $215feff881673676$var$nullFunction = ()=>{};
const $215feff881673676$var$config = {
    crossOrigin: $215feff881673676$var$DEFAULT_CROSS_ORIGIN,
    manifest: $215feff881673676$var$DEFAULT_MANIFEST,
    mode: $215feff881673676$var$DEFAULT_MODE,
    retry: $215feff881673676$var$DEFAULT_RETRY,
    react18: false,
    onChunkRender: $215feff881673676$var$nullFunction,
    usePostTaskPhases: false,
    trackDuplicateLazyIds: false
};
const $215feff881673676$export$44487a86467333c3 = ()=>$215feff881673676$var$config;
const $215feff881673676$export$940a7873bb071df8 = (nextConfig)=>{
    $215feff881673676$var$config.crossOrigin = nextConfig.crossOrigin ?? $215feff881673676$var$DEFAULT_CROSS_ORIGIN;
    $215feff881673676$var$config.manifest = nextConfig.manifest ?? $215feff881673676$var$DEFAULT_MANIFEST;
    $215feff881673676$var$config.mode = nextConfig.mode ?? $215feff881673676$var$DEFAULT_MODE;
    $215feff881673676$var$config.retry = nextConfig.retry ?? $215feff881673676$var$DEFAULT_RETRY;
    $215feff881673676$var$config.react18 = nextConfig.react18 ?? false;
    $215feff881673676$var$config.onChunkRender = nextConfig.onChunkRender ?? $215feff881673676$var$nullFunction;
    $215feff881673676$var$config.usePostTaskPhases = nextConfig.usePostTaskPhases ?? false;
    $215feff881673676$var$config.trackDuplicateLazyIds = nextConfig.trackDuplicateLazyIds ?? false;
};

});
parcelRegister("7Ewwd", function(module, exports) {

$parcel$export(module.exports, "MODE", () => $ad15fad8d44b1229$export$e48589d9e4824227);
const $ad15fad8d44b1229$export$e48589d9e4824227 = {
    RENDER: 'RENDER',
    HYDRATE: 'HYDRATE'
};

});


parcelRegister("7In2L", function(module, exports) {

$parcel$export(module.exports, "LazySuspenseContext", () => $2bba2aa329f941bd$export$c33990e84065970c);

var $5uXOq = parcelRequire("5uXOq");
const $2bba2aa329f941bd$export$c33990e84065970c = /*#__PURE__*/ (0, $5uXOq.createContext)({
    getIsBoundaryInitialized: ()=>false,
    fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Fragment), null),
    setFallback: ()=>{
        // eslint-disable-next-line no-console
        console.warn('Missing <LooselySuspense /> boundary');
    }
});

});


parcelRegister("5poak", function(module, exports) {

$parcel$export(module.exports, "WaitContext", () => $472a1d8a4f6b2e6c$export$9ba3fe09d15de47b);

var $5uXOq = parcelRequire("5uXOq");

var $dwdrq = parcelRequire("dwdrq");
const $472a1d8a4f6b2e6c$export$9ba3fe09d15de47b = (0, $5uXOq.createContext)({
    subscribe: ()=>(0, $dwdrq.noopCleanup),
    currentValue: ()=>1
});

});
parcelRegister("dwdrq", function(module, exports) {

$parcel$export(module.exports, "noopCleanup", () => $07eaf0b5e178e983$export$276c7dbda7675aec);
const $07eaf0b5e178e983$export$276c7dbda7675aec = ()=>{
// Nothing to cleanup...
};

});


parcelRegister("kxZPA", function(module, exports) {

$parcel$export(module.exports, "lazyForPaint", () => $f5d25d622251412b$export$c952e5f94576010e);
$parcel$export(module.exports, "lazyAfterPaint", () => $f5d25d622251412b$export$291dd592399bdafa);
$parcel$export(module.exports, "lazy", () => $f5d25d622251412b$export$488013bae63b21da);

var $a6rDZ = parcelRequire("a6rDZ");

var $iyWSs = parcelRequire("iyWSs");

var $ddkdN = parcelRequire("ddkdN");

var $fVdZG = parcelRequire("fVdZG");

var $7AnOd = parcelRequire("7AnOd");
var $jJo8A = parcelRequire("jJo8A");

var $jdTx8 = parcelRequire("jdTx8");

var $WOtQc = parcelRequire("WOtQc");

var $fCMWS = parcelRequire("fCMWS");

var $atSTR = parcelRequire("atSTR");

var $qkBMj = parcelRequire("qkBMj");

var $aoIf8 = parcelRequire("aoIf8");

var $bCf8q = parcelRequire("bCf8q");
function $f5d25d622251412b$var$noop() {}
function $f5d25d622251412b$var$deferToPhase(phase) {
    switch(phase){
        case (0, $fVdZG.PHASE).PAINT:
            return (0, $iyWSs.postTask)($f5d25d622251412b$var$noop, {
                priority: 'user-blocking'
            });
        case (0, $fVdZG.PHASE).AFTER_PAINT:
            return (0, $iyWSs.postTask)($f5d25d622251412b$var$noop, {
                priority: 'user-visible'
            });
        case (0, $fVdZG.PHASE).LAZY:
            return (0, $iyWSs.postTask)($f5d25d622251412b$var$noop, {
                priority: 'background'
            });
        default:
            return Promise.resolve();
    }
}
function $f5d25d622251412b$var$lazyProxy(loader, { defer: defer = (0, $fVdZG.PHASE).PAINT, moduleId: moduleId = '', ssr: ssr = true } = {}) {
    const isServer = (0, $7AnOd.isNodeEnvironment)();
    const dataLazyId = (0, $jJo8A.default)(moduleId);
    // eslint-disable-next-line @typescript-eslint/ban-types
    const LazyInternal = isServer ? (0, $WOtQc.createComponentServer)({
        dataLazyId: dataLazyId,
        defer: defer,
        loader: loader,
        moduleId: moduleId,
        ssr: ssr
    }) : (0, $jdTx8.createComponentClient)({
        dataLazyId: dataLazyId,
        defer: defer,
        // We separate the preload from the retryable request, as we do not want the preload to contribute to retry
        // attempts, when the the loader fallback is used
        deferred: (0, $atSTR.createDeferred)({
            loader: ()=>{
                const { retry: maxAttempts, usePostTaskPhases: usePostTaskPhases } = (0, $ddkdN.getConfig)();
                const deferredLoader = usePostTaskPhases ? ()=>$f5d25d622251412b$var$deferToPhase(defer).then(()=>loader()) : loader;
                return (0, $aoIf8.retry)(deferredLoader, {
                    delay: (0, $fCMWS.RETRY_DELAY),
                    factor: (0, $fCMWS.RETRY_FACTOR),
                    maxAttempts: maxAttempts
                });
            },
            preload: loader
        }),
        moduleId: moduleId
    });
    LazyInternal.displayName = `Lazy(${(0, $7AnOd.displayNameFromId)(moduleId)})`;
    /**
	 * Allows getting module chunks urls
	 */ const getAssetUrls = ()=>{
        const { manifest: manifest } = (0, $ddkdN.getConfig)();
        return (0, $a6rDZ.getAssetUrlsFromId)(manifest, moduleId);
    };
    /**
	 * Allows imperatively preload/ prefetch the module chunk asset
	 */ const preload = (priority)=>{
        const p = priority ?? (defer === (0, $fVdZG.PHASE).PAINT ? (0, $fCMWS.PRIORITY).HIGH : (0, $fCMWS.PRIORITY).LOW);
        return (0, $qkBMj.preloadAsset)({
            loader: loader,
            moduleId: moduleId,
            priority: p
        });
    };
    return Object.assign(LazyInternal, {
        getAssetUrls: getAssetUrls,
        preload: preload
    });
}
const $f5d25d622251412b$export$93ca5d3f8675ae4c = {
    lazyForPaint: {
        ssr: true,
        defer: (0, $fVdZG.PHASE).PAINT
    },
    lazyAfterPaint: {
        ssr: true,
        defer: (0, $fVdZG.PHASE).AFTER_PAINT
    },
    lazy: {
        ssr: false,
        defer: (0, $fVdZG.PHASE).LAZY
    }
};
function $f5d25d622251412b$export$c952e5f94576010e(loader, opts) {
    return $f5d25d622251412b$var$lazyProxy(loader, {
        ...$f5d25d622251412b$export$93ca5d3f8675ae4c.lazyForPaint,
        ...opts || {}
    });
}
function $f5d25d622251412b$export$291dd592399bdafa(loader, opts) {
    return $f5d25d622251412b$var$lazyProxy(loader, {
        ...$f5d25d622251412b$export$93ca5d3f8675ae4c.lazyAfterPaint,
        ...opts || {}
    });
}
function $f5d25d622251412b$export$488013bae63b21da(loader, opts) {
    return $f5d25d622251412b$var$lazyProxy(loader, {
        ...$f5d25d622251412b$export$93ca5d3f8675ae4c.lazy,
        ...opts || {}
    });
}

});
parcelRegister("a6rDZ", function(module, exports) {

$parcel$export(module.exports, "getAssetUrlsFromId", () => $2075c274ba019639$export$303f43e55cf1ef2f);
const $2075c274ba019639$export$303f43e55cf1ef2f = (manifest, id)=>{
    if (!manifest.assets || !manifest.assets[id]) return;
    return manifest.assets[id].map((asset)=>`${manifest.publicPath}${asset}`);
};

});

parcelRegister("iyWSs", function(module, exports) {

$parcel$export(module.exports, "postTask", () => $4dcc2a181ab1528f$export$13c9d02ca54955a3);
async function $4dcc2a181ab1528f$var$toPromise(callback) {
    return callback();
}
function $4dcc2a181ab1528f$var$getScheduler(obj) {
    if ('scheduler' in obj && obj.scheduler !== 'undefined') return obj.scheduler;
}

function $4dcc2a181ab1528f$export$13c9d02ca54955a3(callback, options) {
    // Dynamically import the scheduler-polyfill module, so browsers that do support the Prioritized Task Scheduling API
    // do not pay the performance cost (e.g. bundle size, runtime, etc).
    const scheduler = $4dcc2a181ab1528f$var$getScheduler(globalThis);
    if (!scheduler) {
        // Only load the polyfill if we are using the background priority
        if (options.priority === 'background') // This polyfill will be removed once the Prioritized Task Scheduling API is more widely supported in browsers.
        // eslint-disable-next-line import/dynamic-import-chunkname
        // @ts-ignore error TS7016: Could not find a declaration file for module 'scheduler-polyfill' seen in Jira Typechecking (Cypress) step
        return (parcelRequire("9Aorm")).then(()=>$4dcc2a181ab1528f$var$getScheduler(globalThis).postTask(callback, options));
        return $4dcc2a181ab1528f$var$toPromise(callback);
    }
    return scheduler.postTask(callback, options);
}

});
parcelRegister("9Aorm", function(module, exports) {

let $6faa6f2d24c43be6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6faa6f2d24c43be6$var$load("7EQgJ").then(()=>parcelRequire('9wHM1'));

});
parcelRegister("28QjX", function(module, exports) {
"use strict";


let $18f4e9fbd43d4c3b$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve(id), maxShards));
    };
module.exports = $18f4e9fbd43d4c3b$var$load;

});
parcelRegister("kPuw4", function(module, exports) {

$parcel$export(module.exports, "shardUrl", () => $f2a03df3e93d4e79$export$2bf9932c19d6a5d2, (v) => $f2a03df3e93d4e79$export$2bf9932c19d6a5d2 = v);
// TODO: convert this file to ESM once HMR issues are resolved
var $f2a03df3e93d4e79$export$2bf9932c19d6a5d2;
var $f2a03df3e93d4e79$export$1d37a31d51d1e3ed;
var $f2a03df3e93d4e79$export$b4cd98d62f81485f;
var $f2a03df3e93d4e79$export$108ff8fc702e621f;
var $f2a03df3e93d4e79$export$f6f4188f9108e61;
"use strict";
let $f2a03df3e93d4e79$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 *
 * @param {string} pathname
 * @returns {string}
 */ function $f2a03df3e93d4e79$var$getFilenameFromUrlPath(pathname) {
    let lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 *
 * @param {string} str
 * @param {number} maxShards
 * @returns {number}
 */ function $f2a03df3e93d4e79$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    let totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        let n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
let $f2a03df3e93d4e79$var$trailingShardRegex = /-\d+$/;
/**
 * @param {string} subdomain
 */ function $f2a03df3e93d4e79$var$removeTrailingShard(subdomain) {
    if (!$f2a03df3e93d4e79$var$trailingShardRegex.test(subdomain)) return subdomain;
    let shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 *
 * @param {string} domain
 * @param {number} shard
 */ function $f2a03df3e93d4e79$var$applyShardToDomain(domain, shard) {
    let i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    let shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$f2a03df3e93d4e79$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    let firstSubdomain = $f2a03df3e93d4e79$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 *
 * @param {string} url
 * @param {number} maxShards
 * @returns {string}
 */ function $f2a03df3e93d4e79$var$shardUrlUnchecked(url, maxShards) {
    let parsedUrl = new URL(url);
    let fileName = $f2a03df3e93d4e79$var$getFilenameFromUrlPath(parsedUrl.pathname);
    let shardNumber = $f2a03df3e93d4e79$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $f2a03df3e93d4e79$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 *
 * @param {string} url
 * @param {number} maxShards
 * @returns {string}
 */ function $f2a03df3e93d4e79$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$f2a03df3e93d4e79$var$globalKeyName]) return url;
    return $f2a03df3e93d4e79$var$shardUrlUnchecked(url, maxShards);
}
$f2a03df3e93d4e79$export$2bf9932c19d6a5d2 = $f2a03df3e93d4e79$var$shardUrl;
$f2a03df3e93d4e79$export$1d37a31d51d1e3ed = $f2a03df3e93d4e79$var$shardUrlUnchecked;
$f2a03df3e93d4e79$export$b4cd98d62f81485f = $f2a03df3e93d4e79$var$getDomainShardIndex;
$f2a03df3e93d4e79$export$108ff8fc702e621f = $f2a03df3e93d4e79$var$applyShardToDomain;
$f2a03df3e93d4e79$export$f6f4188f9108e61 = $f2a03df3e93d4e79$var$globalKeyName;

});

parcelRegister("dy9lH", function(module, exports) {

$parcel$export(module.exports, "register", () => $9dd5b3e06d7b5702$export$6503ec6e8aabbaf, (v) => $9dd5b3e06d7b5702$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $9dd5b3e06d7b5702$export$f7ad0328861e2f03, (v) => $9dd5b3e06d7b5702$export$f7ad0328861e2f03 = v);
var $9dd5b3e06d7b5702$export$6503ec6e8aabbaf;
var $9dd5b3e06d7b5702$export$f7ad0328861e2f03;
"use strict";
var $9dd5b3e06d7b5702$var$mapping = new Map();
function $9dd5b3e06d7b5702$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$9dd5b3e06d7b5702$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $9dd5b3e06d7b5702$var$resolve(id) {
    var resolved = $9dd5b3e06d7b5702$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$9dd5b3e06d7b5702$export$6503ec6e8aabbaf = $9dd5b3e06d7b5702$var$register;
$9dd5b3e06d7b5702$export$f7ad0328861e2f03 = $9dd5b3e06d7b5702$var$resolve;

});




parcelRegister("jdTx8", function(module, exports) {

$parcel$export(module.exports, "createComponentClient", () => $1afeb489bc604bb9$export$6898b5504b58699a);

var $5uXOq = parcelRequire("5uXOq");
parcelRequire("1nF7O");
var $bajNy = parcelRequire("bajNy");

var $ddkdN = parcelRequire("ddkdN");
var $7Ewwd = parcelRequire("7Ewwd");

var $fVdZG = parcelRequire("fVdZG");

var $5poak = parcelRequire("5poak");

var $j7rCb = parcelRequire("j7rCb");

var $cEm1b = parcelRequire("cEm1b");

var $7In2L = parcelRequire("7In2L");

var $bCf8q = parcelRequire("bCf8q");

var $2IUgd = parcelRequire("2IUgd");

var $oq2LV = parcelRequire("oq2LV");

var $lO9oD = parcelRequire("lO9oD");
const $1afeb489bc604bb9$var$reportedDuplicate = new Set();
function $1afeb489bc604bb9$export$6898b5504b58699a({ defer: defer, deferred: deferred, dataLazyId: dataLazyId, moduleId: moduleId }) {
    const ResolvedLazy = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>deferred.promise);
    return (props)=>{
        // use a single piece of state to hold info about progress or eventually
        // throw an error. We do change it via direct mutation as re-renders
        // break Suspense in React 18, making it lose hydration state
        const [status, bubbleError] = (0, $5uXOq.useState)(()=>({
                noWait: undefined,
                phase: defer === (0, $fVdZG.PHASE).AFTER_PAINT ? false : true,
                preloaded: defer === (0, $fVdZG.PHASE).AFTER_PAINT ? false : true,
                started: false
            }));
        const { usePostTaskPhases: usePostTaskPhases, trackDuplicateLazyIds: trackDuplicateLazyIds } = (0, $ddkdN.getConfig)();
        const { setFallback: setFallback, getIsBoundaryInitialized: getIsBoundaryInitialized } = (0, $5uXOq.useContext)((0, $7In2L.LazySuspenseContext));
        const profiler = (0, $5uXOq.useContext)((0, $cEm1b.ProfilerContext)).current;
        const load = ()=>{
            if (usePostTaskPhases) {
                if (status.started) return;
            } else {
                if (status.started || !status.phase || !status.noWait) return;
            }
            status.started = true;
            let onResolve;
            if (profiler) {
                const eventInfo = {
                    identifier: moduleId
                };
                onResolve = ()=>{
                    profiler.onLoadComplete(eventInfo);
                };
                profiler.onLoadStart(eventInfo);
            }
            const result = deferred.start().catch((err)=>{
                // Throw the error within the component lifecycle
                // refer to https://github.com/facebook/react/issues/11409
                bubbleError(()=>{
                    throw (0, $bCf8q.createLoaderError)(err);
                });
            });
            if (onResolve) result.then(onResolve);
        };
        if (usePostTaskPhases) // Start loading immediately, as the loader itself will be delayed until the appropriate phase
        (0, $5uXOq.useMemo)(()=>{
            load();
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, []);
        else {
            // Subscribe to LazyWait context, triggering load when until is true
            (0, $lO9oD.useSubscription)({
                context: (0, $5poak.WaitContext),
                load: load,
                onValue: (v)=>status.noWait = v === 1
            });
            if (defer === (0, $fVdZG.PHASE).AFTER_PAINT) // Subscribe to LazyPhase context, triggering load when own phase starts
            (0, $lO9oD.useSubscription)({
                context: (0, $j7rCb.LazyPhaseContext),
                load: load,
                onValue: (v)=>status.phase = v >= defer
            });
        }
        (0, $5uXOq.useMemo)(()=>{
            // Skip collecting fallbacks if the boundary is already initialized
            if (usePostTaskPhases && getIsBoundaryInitialized()) return;
            const contentLength = (0, $fVdZG.COLLECTED).get(dataLazyId)?.length || 0;
            // find SSR content (or fallbacks) wrapped in inputs based on lazyId
            const content = ((0, $fVdZG.COLLECTED).get(dataLazyId) || []).shift();
            if (!content) return;
            if (trackDuplicateLazyIds && contentLength > 1 && !$1afeb489bc604bb9$var$reportedDuplicate.has(dataLazyId)) {
                // This means there are multiple components for the same lazyId
                // This can cause performance issues, so we should log it and resolve it later on
                $1afeb489bc604bb9$var$reportedDuplicate.add(dataLazyId);
                (0, $bajNy.default)({
                    error: new Error(`Duplicate components for ${dataLazyId} found, module name is ${moduleId}, total count: ${$1afeb489bc604bb9$var$reportedDuplicate.size}`),
                    meta: {
                        id: 'rll-duplicate-error',
                        packageName: 'reactLooselyLazy',
                        teamName: 'jfp-magma'
                    },
                    attributes: {
                        moduleName: moduleId
                    }
                });
            }
            // override Suspense fallback with magic input wrappers
            const component = (0, $ddkdN.getConfig)().mode === (0, $7Ewwd.MODE).RENDER ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $oq2LV.PlaceholderFallbackRender), {
                id: dataLazyId,
                content: content
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2IUgd.PlaceholderFallbackHydrate), {
                id: dataLazyId,
                content: content
            });
            setFallback(component);
        }, [
            setFallback,
            getIsBoundaryInitialized,
            usePostTaskPhases,
            trackDuplicateLazyIds
        ]);
        (0, $5uXOq.useMemo)(()=>{
            const { mode: mode, react18: react18 } = (0, $ddkdN.getConfig)();
            // we dont remove fallback in RENDER mode as it happens too early
            // however it's not a problem for HYDRATION as Suspense will handle all nuances
            if (mode === (0, $7Ewwd.MODE).HYDRATE && react18) // Allow hydration to support partials without server components
            // suspense will discard ssr during hydration if re-renders so we
            // set a dummy fallback to block updates from the provider until we resolve
            setFallback(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null));
        }, [
            setFallback
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ResolvedLazy, props);
    };
}

});
parcelRegister("1nF7O", function(module, exports) {

$parcel$export(module.exports, "fireErrorAnalytics", () => (parcelRequire("bajNy")).default);
$parcel$export(module.exports, "initialiseErrorAnalyticsClient", () => (parcelRequire("bajNy")).initialiseErrorAnalyticsClient);
$parcel$export(module.exports, "ReportErrors", () => (parcelRequire("kRBfD")).default);

var $9ZBi7 = parcelRequire("9ZBi7");

var $bajNy = parcelRequire("bajNy");

var $kRBfD = parcelRequire("kRBfD");

});
parcelRegister("9ZBi7", function(module, exports) {

$parcel$export(module.exports, "captureException", () => $e146a6146624d7ff$export$f5282963edea4a68);

var $e4JR5 = parcelRequire("e4JR5");
const $e146a6146624d7ff$export$7da675e3dd1bd6b5 = (sentryUrl, config, getExtraContext)=>(0, $e4JR5.default).installGlobalHandler(sentryUrl, config, getExtraContext);
const $e146a6146624d7ff$export$f5282963edea4a68 = (location, error, details = {})=>(0, $e4JR5.default).captureException(location, error, details);

});
parcelRegister("e4JR5", function(module, exports) {

$parcel$export(module.exports, "default", () => $a438973d9769f0e5$export$2e2bcd8739ae039);
// This is the only file that should directly import Raven.

var $7zHWg = parcelRequire("7zHWg");
var $3kk8J = parcelRequire("3kk8J");
var $kFfmc = parcelRequire("kFfmc");

var $ehYmi = parcelRequire("ehYmi");
var $lt9kQ = parcelRequire("lt9kQ");
var $kBLvL = parcelRequire("kBLvL");
var $50FPh = parcelRequire("50FPh");

var $kGsr8 = parcelRequire("kGsr8");
const $a438973d9769f0e5$var$getFragmentNames = (stackTrace)=>{
    const re = /(?:src\/entry|src|assets)\/([^,./]+)/g;
    const fragmentNames = [];
    let fragmentName = re.exec(stackTrace);
    while(fragmentName){
        fragmentNames.push(fragmentName[1]);
        fragmentName = re.exec(stackTrace);
    }
    const distinctfragmentNames = (0, (/*@__PURE__*/$parcel$interopDefault($kGsr8)))(fragmentNames);
    return distinctfragmentNames;
};
// Add custom tags based on stack trace
const $a438973d9769f0e5$var$getTaggedData = (data, hint)=>{
    if (!hint) return data;
    const exception = hint.originalException || hint.syntheticException;
    if (!exception) return data;
    const stackTrace = exception.stack;
    if (!stackTrace) return data;
    const taggedData = data;
    const fragmentNames = $a438973d9769f0e5$var$getFragmentNames(stackTrace);
    if (!fragmentNames.length) taggedData.tags = {
        ...taggedData.tags,
        fragment: 'unknown'
    };
    else {
        taggedData.tags = {
            ...taggedData.tags,
            fragment: fragmentNames[0]
        };
        if (fragmentNames.length > 1) taggedData.extra = {
            ...taggedData.extra,
            allRelevantFragments: fragmentNames
        };
    }
    return taggedData;
};
// https://docs.sentry.io/platforms/javascript/#removing-an-integration
const $a438973d9769f0e5$var$getFilteredIntegrations = (integrations)=>integrations.filter(({ name: name })=>name !== 'Breadcrumbs');
const $a438973d9769f0e5$var$installGlobalHandler = (sentryUrl, config, getExtraContext)=>{
    // Check for sentry already enabled to be defensive in case two fragments are loaded in the same page, we
    // don't want duplicated error reports
    const sentryClient = $3kk8J.getCurrentHub().getClient();
    if (sentryClient && sentryClient.getOptions().enabled) return;
    const defaultConfig = {
        dsn: sentryUrl,
        environment: "production",
        // This adds our tags to the data sent to sentry
        beforeSend: (event, hint)=>{
            // Yes, we're mutating the argument, but at this point in the error handling lifecycle
            // immutability is not important and it simplifies the logic
            // Event type is documented here: https://github.com/getsentry/sentry-javascript/blob/master/packages/types/src/event.ts
            const extraBeforeSend = config.beforeSend || (()=>null);
            let updatedData = extraBeforeSend(event, hint);
            updatedData = $a438973d9769f0e5$var$getTaggedData(updatedData, hint);
            return updatedData;
        },
        //Integration typing doesn't seem to work well so I'm just typing it to any
        integrations: (integrations)=>[
                ...$a438973d9769f0e5$var$getFilteredIntegrations(integrations),
                new $lt9kQ.Dedupe(),
                new $kBLvL.ExtraErrorData(),
                new $50FPh.Transaction(),
                new $ehYmi.CaptureConsole({
                    levels: [
                        'error'
                    ]
                }),
                // not supporting the case where config.integrations is a function that returns an array
                ...config.integrations && config.integrations instanceof Array ? config.integrations : []
            ]
    };
    // Because we don't want to completely override the platform defaults remove them from the config object.
    // They've been integrated into the defaultConfig above.
    config.beforeSend = undefined;
    config.integrations = undefined;
    $kFfmc.init({
        ...defaultConfig,
        ...config
    });
    try {
        $7zHWg.setExtras(getExtraContext());
    } catch (e) {
        $7zHWg.captureException(e);
    }
};
// structured tags that we send to Sentry
// everything else from details object will go into "extras"
const $a438973d9769f0e5$var$tags = [
    'packageName',
    'teamName'
];
const $a438973d9769f0e5$var$captureException = (location, error, details)=>{
    $7zHWg.configureScope((scope)=>{
        scope.setTag('logger', location);
        if (details) Object.keys(details).forEach((key)=>{
            if ($a438973d9769f0e5$var$tags.includes(key)) scope.setTag(key, details[key]);
            else scope.setExtra(key, details[key]);
        });
    });
    $7zHWg.captureException(error);
};
var $a438973d9769f0e5$export$2e2bcd8739ae039 = {
    installGlobalHandler: $a438973d9769f0e5$var$installGlobalHandler,
    captureException: $a438973d9769f0e5$var$captureException
};

});
parcelRegister("kFfmc", function(module, exports) {

$parcel$export(module.exports, "init", () => $f0b38c92b55bde06$export$2cd8252107eb640b);

var $3VFsf = parcelRequire("3VFsf");

var $3kk8J = parcelRequire("3kk8J");
var $DPuyZ = parcelRequire("DPuyZ");
var $hK2IQ = parcelRequire("hK2IQ");
parcelRequire("8KVVB");
var $1sgxX = parcelRequire("1sgxX");
var $35A7f = parcelRequire("35A7f");
var $4geCF = parcelRequire("4geCF");
var $3X7U8 = parcelRequire("3X7U8");

var $3pmgQ = parcelRequire("3pmgQ");

var $l97zN = parcelRequire("l97zN");

var $9aSEL = parcelRequire("9aSEL");

var $5Z1NC = parcelRequire("5Z1NC");
var $ilDeH = parcelRequire("ilDeH");
var $ijPmO = parcelRequire("ijPmO");
var $5zMCv = parcelRequire("5zMCv");
var $4EoaR = parcelRequire("4EoaR");
var $lKe3d = parcelRequire("lKe3d");
var $f0b38c92b55bde06$export$5ef831fccfce35e5 = [
    new (0, $hK2IQ).InboundFilters(),
    new (0, $hK2IQ).FunctionToString(),
    new (0, $4EoaR.TryCatch)(),
    new (0, $5Z1NC.Breadcrumbs)(),
    new (0, $ijPmO.GlobalHandlers)(),
    new (0, $5zMCv.LinkedErrors)(),
    new (0, $ilDeH.Dedupe)(),
    new (0, $lKe3d.UserAgent)()
];
function $f0b38c92b55bde06$export$2cd8252107eb640b(options) {
    if (options === void 0) options = {};
    if (options.defaultIntegrations === undefined) options.defaultIntegrations = $f0b38c92b55bde06$export$5ef831fccfce35e5;
    if (options.release === undefined) {
        var window_1 = (0, $35A7f.getGlobalObject)();
        // This supports the variable that sentry-webpack-plugin injects
        if (window_1.SENTRY_RELEASE && window_1.SENTRY_RELEASE.id) options.release = window_1.SENTRY_RELEASE.id;
    }
    if (options.autoSessionTracking === undefined) options.autoSessionTracking = true;
    if (options.sendClientReports === undefined) options.sendClientReports = true;
    (0, $DPuyZ.initAndBind)((0, $3pmgQ.BrowserClient), options);
    if (options.autoSessionTracking) $f0b38c92b55bde06$var$startSessionTracking();
}
function $f0b38c92b55bde06$export$3a8fd680da42627b(options) {
    if (options === void 0) options = {};
    var hub = (0, $3kk8J.getCurrentHub)();
    var scope = hub.getScope();
    if (scope) options.user = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, scope.getUser()), options.user);
    if (!options.eventId) options.eventId = hub.lastEventId();
    var client = hub.getClient();
    if (client) client.showReportDialog(options);
}
function $f0b38c92b55bde06$export$5d4e9fd7fac8e617() {
    return (0, $3kk8J.getCurrentHub)().lastEventId();
}
function $f0b38c92b55bde06$export$a3f323d81eede727() {
// Noop
}
function $f0b38c92b55bde06$export$4e4d8b287d028b6b(callback) {
    callback();
}
function $f0b38c92b55bde06$export$4909b86c8034bf73(timeout) {
    var client = (0, $3kk8J.getCurrentHub)().getClient();
    if (client) return client.flush(timeout);
    (0, $l97zN.IS_DEBUG_BUILD) && (0, $4geCF.logger).warn('Cannot flush events. No client defined.');
    return (0, $3X7U8.resolvedSyncPromise)(false);
}
function $f0b38c92b55bde06$export$8360e631d277ea4d(timeout) {
    var client = (0, $3kk8J.getCurrentHub)().getClient();
    if (client) return client.close(timeout);
    (0, $l97zN.IS_DEBUG_BUILD) && (0, $4geCF.logger).warn('Cannot flush events and disable SDK. No client defined.');
    return (0, $3X7U8.resolvedSyncPromise)(false);
}
function $f0b38c92b55bde06$export$4997ffc0176396a6(fn) {
    return (0, $9aSEL.wrap)(fn)();
}
function $f0b38c92b55bde06$var$startSessionOnHub(hub) {
    hub.startSession({
        ignoreDuration: true
    });
    hub.captureSession();
}
/**
 * Enable automatic Session Tracking for the initial page load.
 */ function $f0b38c92b55bde06$var$startSessionTracking() {
    var window = (0, $35A7f.getGlobalObject)();
    var document = window.document;
    if (typeof document === 'undefined') {
        (0, $l97zN.IS_DEBUG_BUILD) && (0, $4geCF.logger).warn('Session tracking in non-browser environment with @sentry/browser is not supported.');
        return;
    }
    var hub = (0, $3kk8J.getCurrentHub)();
    // The only way for this to be false is for there to be a version mismatch between @sentry/browser (>= 6.0.0) and
    // @sentry/hub (< 5.27.0). In the simple case, there won't ever be such a mismatch, because the two packages are
    // pinned at the same version in package.json, but there are edge cases where it's possible. See
    // https://github.com/getsentry/sentry-javascript/issues/3207 and
    // https://github.com/getsentry/sentry-javascript/issues/3234 and
    // https://github.com/getsentry/sentry-javascript/issues/3278.
    if (!hub.captureSession) return;
    // The session duration for browser sessions does not track a meaningful
    // concept that can be used as a metric.
    // Automatically captured sessions are akin to page views, and thus we
    // discard their duration.
    $f0b38c92b55bde06$var$startSessionOnHub(hub);
    // We want to create a session for every navigation as well
    (0, $1sgxX.addInstrumentationHandler)('history', function(_a) {
        var from = _a.from, to = _a.to;
        // Don't create an additional session for the initial route or if the location did not change
        if (!(from === undefined || from === to)) $f0b38c92b55bde06$var$startSessionOnHub((0, $3kk8J.getCurrentHub)());
    });
}

});
parcelRegister("DPuyZ", function(module, exports) {

$parcel$export(module.exports, "initAndBind", () => $077b95dcdc7224fa$export$5333c3f1c58d9bc1);

var $3kk8J = parcelRequire("3kk8J");
parcelRequire("8KVVB");
var $4geCF = parcelRequire("4geCF");

var $aEGcl = parcelRequire("aEGcl");
function $077b95dcdc7224fa$export$5333c3f1c58d9bc1(clientClass, options) {
    if (options.debug === true) {
        if (0, $aEGcl.IS_DEBUG_BUILD) (0, $4geCF.logger).enable();
        else // use `console.warn` rather than `logger.warn` since by non-debug bundles have all `logger.x` statements stripped
        // eslint-disable-next-line no-console
        console.warn('[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.');
    }
    var hub = (0, $3kk8J.getCurrentHub)();
    var scope = hub.getScope();
    if (scope) scope.update(options.initialScope);
    var client = new clientClass(options);
    hub.bindClient(client);
}

});
parcelRegister("8KVVB", function(module, exports) {
$parcel$export(module.exports, "forget", () => (parcelRequire("dYkdu")).forget);
$parcel$export(module.exports, "getLocationHref", () => (parcelRequire("7yHR0")).getLocationHref);
$parcel$export(module.exports, "htmlTreeAsString", () => (parcelRequire("7yHR0")).htmlTreeAsString);
$parcel$export(module.exports, "dsnToString", () => (parcelRequire("gSiM6")).dsnToString);
$parcel$export(module.exports, "makeDsn", () => (parcelRequire("gSiM6")).makeDsn);
$parcel$export(module.exports, "SentryError", () => (parcelRequire("b17Q6")).SentryError);
$parcel$export(module.exports, "getGlobalObject", () => (parcelRequire("35A7f")).getGlobalObject);
$parcel$export(module.exports, "addInstrumentationHandler", () => (parcelRequire("1sgxX")).addInstrumentationHandler);
$parcel$export(module.exports, "isDOMError", () => (parcelRequire("gkmq5")).isDOMError);
$parcel$export(module.exports, "isDOMException", () => (parcelRequire("gkmq5")).isDOMException);
$parcel$export(module.exports, "isError", () => (parcelRequire("gkmq5")).isError);
$parcel$export(module.exports, "isErrorEvent", () => (parcelRequire("gkmq5")).isErrorEvent);
$parcel$export(module.exports, "isEvent", () => (parcelRequire("gkmq5")).isEvent);
$parcel$export(module.exports, "isInstanceOf", () => (parcelRequire("gkmq5")).isInstanceOf);
$parcel$export(module.exports, "isPlainObject", () => (parcelRequire("gkmq5")).isPlainObject);
$parcel$export(module.exports, "isPrimitive", () => (parcelRequire("gkmq5")).isPrimitive);
$parcel$export(module.exports, "isString", () => (parcelRequire("gkmq5")).isString);
$parcel$export(module.exports, "isThenable", () => (parcelRequire("gkmq5")).isThenable);
$parcel$export(module.exports, "CONSOLE_LEVELS", () => (parcelRequire("4geCF")).CONSOLE_LEVELS);
$parcel$export(module.exports, "logger", () => (parcelRequire("4geCF")).logger);
$parcel$export(module.exports, "addExceptionMechanism", () => (parcelRequire("jyUiA")).addExceptionMechanism);
$parcel$export(module.exports, "addExceptionTypeValue", () => (parcelRequire("jyUiA")).addExceptionTypeValue);
$parcel$export(module.exports, "checkOrSetAlreadyCaught", () => (parcelRequire("jyUiA")).checkOrSetAlreadyCaught);
$parcel$export(module.exports, "getEventDescription", () => (parcelRequire("jyUiA")).getEventDescription);
$parcel$export(module.exports, "parseUrl", () => (parcelRequire("jyUiA")).parseUrl);
$parcel$export(module.exports, "uuid4", () => (parcelRequire("jyUiA")).uuid4);
$parcel$export(module.exports, "normalize", () => (parcelRequire("2mY5H")).normalize);
$parcel$export(module.exports, "normalizeToSize", () => (parcelRequire("2mY5H")).normalizeToSize);
$parcel$export(module.exports, "addNonEnumerableProperty", () => (parcelRequire("1l3DN")).addNonEnumerableProperty);
$parcel$export(module.exports, "extractExceptionKeysForMessage", () => (parcelRequire("1l3DN")).extractExceptionKeysForMessage);
$parcel$export(module.exports, "fill", () => (parcelRequire("1l3DN")).fill);
$parcel$export(module.exports, "getOriginalFunction", () => (parcelRequire("1l3DN")).getOriginalFunction);
$parcel$export(module.exports, "markFunctionWrapped", () => (parcelRequire("1l3DN")).markFunctionWrapped);
$parcel$export(module.exports, "urlEncode", () => (parcelRequire("1l3DN")).urlEncode);
$parcel$export(module.exports, "makePromiseBuffer", () => (parcelRequire("9aaXP")).makePromiseBuffer);
$parcel$export(module.exports, "severityFromString", () => (parcelRequire("n3F4l")).severityFromString);
$parcel$export(module.exports, "createStackParser", () => (parcelRequire("aNkwr")).createStackParser);
$parcel$export(module.exports, "getFunctionName", () => (parcelRequire("aNkwr")).getFunctionName);
$parcel$export(module.exports, "eventStatusFromHttpCode", () => (parcelRequire("aGIlP")).eventStatusFromHttpCode);
$parcel$export(module.exports, "isMatchingPattern", () => (parcelRequire("jOwKr")).isMatchingPattern);
$parcel$export(module.exports, "safeJoin", () => (parcelRequire("jOwKr")).safeJoin);
$parcel$export(module.exports, "truncate", () => (parcelRequire("jOwKr")).truncate);
$parcel$export(module.exports, "isNativeFetch", () => (parcelRequire("ci1rH")).isNativeFetch);
$parcel$export(module.exports, "supportsFetch", () => (parcelRequire("ci1rH")).supportsFetch);
$parcel$export(module.exports, "supportsReferrerPolicy", () => (parcelRequire("ci1rH")).supportsReferrerPolicy);
$parcel$export(module.exports, "rejectedSyncPromise", () => (parcelRequire("3X7U8")).rejectedSyncPromise);
$parcel$export(module.exports, "resolvedSyncPromise", () => (parcelRequire("3X7U8")).resolvedSyncPromise);
$parcel$export(module.exports, "SyncPromise", () => (parcelRequire("3X7U8")).SyncPromise);
$parcel$export(module.exports, "createEnvelope", () => (parcelRequire("e1x9C")).createEnvelope);
$parcel$export(module.exports, "getEnvelopeType", () => (parcelRequire("e1x9C")).getEnvelopeType);
$parcel$export(module.exports, "serializeEnvelope", () => (parcelRequire("e1x9C")).serializeEnvelope);
$parcel$export(module.exports, "createClientReportEnvelope", () => (parcelRequire("jk0Xn")).createClientReportEnvelope);
$parcel$export(module.exports, "disabledUntil", () => (parcelRequire("2rF5w")).disabledUntil);
$parcel$export(module.exports, "isRateLimited", () => (parcelRequire("2rF5w")).isRateLimited);
$parcel$export(module.exports, "updateRateLimits", () => (parcelRequire("2rF5w")).updateRateLimits);
parcelRequire("dYkdu");
parcelRequire("7yHR0");
parcelRequire("gSiM6");

parcelRequire("b17Q6");
parcelRequire("35A7f");
parcelRequire("1sgxX");
parcelRequire("gkmq5");
parcelRequire("4geCF");

parcelRequire("jyUiA");

var $9UV3v = parcelRequire("9UV3v");
parcelRequire("2mY5H");
parcelRequire("1l3DN");

parcelRequire("9aaXP");
parcelRequire("n3F4l");
parcelRequire("aNkwr");
parcelRequire("aGIlP");
parcelRequire("jOwKr");
parcelRequire("ci1rH");
parcelRequire("3X7U8");

var $eHWqV = parcelRequire("eHWqV");


parcelRequire("e1x9C");
parcelRequire("jk0Xn");
parcelRequire("2rF5w");
$parcel$exportWildcard(module.exports, $9UV3v);
$parcel$exportWildcard(module.exports, $eHWqV);

});
parcelRegister("dYkdu", function(module, exports) {

$parcel$export(module.exports, "forget", () => $02a00250c53700ca$export$93c25f2590a5b540);
/**
 * Consumes the promise and logs the error when it rejects.
 * @param promise A promise to forget.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $02a00250c53700ca$export$93c25f2590a5b540(promise) {
    promise.then(null, function(e) {
        // TODO: Use a better logging mechanism
        // eslint-disable-next-line no-console
        console.error(e);
    });
}

});

parcelRegister("7yHR0", function(module, exports) {

$parcel$export(module.exports, "htmlTreeAsString", () => $580db9d8ee86b37d$export$5647df6b7814ac86);
$parcel$export(module.exports, "getLocationHref", () => $580db9d8ee86b37d$export$1cfafeee2987818b);

var $35A7f = parcelRequire("35A7f");

var $gkmq5 = parcelRequire("gkmq5");
function $580db9d8ee86b37d$export$5647df6b7814ac86(elem, keyAttrs) {
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        var currentElem = elem;
        var MAX_TRAVERSE_HEIGHT = 5;
        var MAX_OUTPUT_LEN = 80;
        var out = [];
        var height = 0;
        var len = 0;
        var separator = ' > ';
        var sepLength = separator.length;
        var nextStr = void 0;
        // eslint-disable-next-line no-plusplus
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $580db9d8ee86b37d$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds MAX_OUTPUT_LEN
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === 'html' || height > 1 && len + out.length * sepLength + nextStr.length >= MAX_OUTPUT_LEN) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return '<unknown>';
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $580db9d8ee86b37d$var$_htmlElementAsString(el, keyAttrs) {
    var elem = el;
    var out = [];
    var className;
    var classes;
    var key;
    var attr;
    var i;
    if (!elem || !elem.tagName) return '';
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    var keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter(function(keyAttr) {
        return elem.getAttribute(keyAttr);
    }).map(function(keyAttr) {
        return [
            keyAttr,
            elem.getAttribute(keyAttr)
        ];
    }) : null;
    if (keyAttrPairs && keyAttrPairs.length) keyAttrPairs.forEach(function(keyAttrPair) {
        out.push("[" + keyAttrPair[0] + "=\"" + keyAttrPair[1] + "\"]");
    });
    else {
        if (elem.id) out.push("#" + elem.id);
        // eslint-disable-next-line prefer-const
        className = elem.className;
        if (className && (0, $gkmq5.isString)(className)) {
            classes = className.split(/\s+/);
            for(i = 0; i < classes.length; i++)out.push("." + classes[i]);
        }
    }
    var allowedAttrs = [
        'type',
        'name',
        'title',
        'alt'
    ];
    for(i = 0; i < allowedAttrs.length; i++){
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) out.push("[" + key + "=\"" + attr + "\"]");
    }
    return out.join('');
}
function $580db9d8ee86b37d$export$1cfafeee2987818b() {
    var global = (0, $35A7f.getGlobalObject)();
    try {
        return global.document.location.href;
    } catch (oO) {
        return '';
    }
}

});
parcelRegister("35A7f", function(module, exports) {

$parcel$export(module.exports, "getGlobalObject", () => $23fdda930ad06550$export$256479dc0cea61c4);
$parcel$export(module.exports, "getGlobalSingleton", () => $23fdda930ad06550$export$7e223ec222791509);
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ 
var $9UV3v = parcelRequire("9UV3v");
var $23fdda930ad06550$var$fallbackGlobalObject = {};
function $23fdda930ad06550$export$256479dc0cea61c4() {
    return (0, $9UV3v.isNodeEnv)() ? $parcel$global : typeof window !== 'undefined' // eslint-disable-line no-restricted-globals
     ? window // eslint-disable-line no-restricted-globals
     : typeof self !== 'undefined' ? self : $23fdda930ad06550$var$fallbackGlobalObject;
}
function $23fdda930ad06550$export$7e223ec222791509(name, creator, obj) {
    var global1 = obj || $23fdda930ad06550$export$256479dc0cea61c4();
    var __SENTRY__ = global1.__SENTRY__ = global1.__SENTRY__ || {};
    var singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
    return singleton;
}

});
parcelRegister("9UV3v", function(module, exports) {

$parcel$export(module.exports, "isNodeEnv", () => isNodeEnv, (v) => isNodeEnv = v);
$parcel$export(module.exports, "dynamicRequire", () => dynamicRequire, (v) => dynamicRequire = v);
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ 
var $9gXpd = parcelRequire("9gXpd");

var $6cAn5 = parcelRequire("6cAn5");
function isNodeEnv() {
    // explicitly check for browser bundles as those can be optimized statically
    // by terser/rollup.
    return !(0, $9gXpd.isBrowserBundle)() && Object.prototype.toString.call(typeof $6cAn5 !== 'undefined' ? $6cAn5 : 0) === '[object process]';
}
function dynamicRequire(mod, request) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return mod.require(request);
}
function loadModule(moduleName) {
    var mod;
    try {
        mod = dynamicRequire(module, moduleName);
    } catch (e) {
    // no-empty
    }
    try {
        var cwd = dynamicRequire(module, 'process').cwd;
        mod = dynamicRequire(module, cwd() + "/node_modules/" + moduleName);
    } catch (e) {
    // no-empty
    }
    return mod;
}

});
parcelRegister("9gXpd", function(module, exports) {

$parcel$export(module.exports, "isBrowserBundle", () => $6c03b06a7831477f$export$2928c40372e623c0);
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These fags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $6c03b06a7831477f$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
}

});



parcelRegister("gkmq5", function(module, exports) {

$parcel$export(module.exports, "isError", () => $be2fe7accd263025$export$e6127cc7fe7395c3);
$parcel$export(module.exports, "isInstanceOf", () => $be2fe7accd263025$export$49034edbe6b62415);
$parcel$export(module.exports, "isErrorEvent", () => $be2fe7accd263025$export$9f9636d330b71954);
$parcel$export(module.exports, "isDOMError", () => $be2fe7accd263025$export$ef9e2056653f0c8e);
$parcel$export(module.exports, "isDOMException", () => $be2fe7accd263025$export$12e869b2a583f783);
$parcel$export(module.exports, "isString", () => $be2fe7accd263025$export$844ec244b1367d54);
$parcel$export(module.exports, "isPrimitive", () => $be2fe7accd263025$export$c3825b437cbdea5c);
$parcel$export(module.exports, "isPlainObject", () => $be2fe7accd263025$export$53b83ca8eaab0383);
$parcel$export(module.exports, "isEvent", () => $be2fe7accd263025$export$9671ea99bd126ace);
$parcel$export(module.exports, "isElement", () => $be2fe7accd263025$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isRegExp", () => $be2fe7accd263025$export$49841c62b9eff15);
$parcel$export(module.exports, "isThenable", () => $be2fe7accd263025$export$f5b060c2914b97c8);
$parcel$export(module.exports, "isSyntheticEvent", () => $be2fe7accd263025$export$bc2894c7158efbac);
$parcel$export(module.exports, "isNaN", () => $be2fe7accd263025$export$c9f5652083b8129d);
/* eslint-disable @typescript-eslint/no-explicit-any */ /* eslint-disable @typescript-eslint/explicit-module-boundary-types */ // eslint-disable-next-line @typescript-eslint/unbound-method
var $be2fe7accd263025$var$objectToString = Object.prototype.toString;
function $be2fe7accd263025$export$e6127cc7fe7395c3(wat) {
    switch($be2fe7accd263025$var$objectToString.call(wat)){
        case '[object Error]':
        case '[object Exception]':
        case '[object DOMException]':
            return true;
        default:
            return $be2fe7accd263025$export$49034edbe6b62415(wat, Error);
    }
}
function $be2fe7accd263025$var$isBuiltin(wat, ty) {
    return $be2fe7accd263025$var$objectToString.call(wat) === "[object " + ty + "]";
}
function $be2fe7accd263025$export$9f9636d330b71954(wat) {
    return $be2fe7accd263025$var$isBuiltin(wat, 'ErrorEvent');
}
function $be2fe7accd263025$export$ef9e2056653f0c8e(wat) {
    return $be2fe7accd263025$var$isBuiltin(wat, 'DOMError');
}
function $be2fe7accd263025$export$12e869b2a583f783(wat) {
    return $be2fe7accd263025$var$isBuiltin(wat, 'DOMException');
}
function $be2fe7accd263025$export$844ec244b1367d54(wat) {
    return $be2fe7accd263025$var$isBuiltin(wat, 'String');
}
function $be2fe7accd263025$export$c3825b437cbdea5c(wat) {
    return wat === null || typeof wat !== 'object' && typeof wat !== 'function';
}
function $be2fe7accd263025$export$53b83ca8eaab0383(wat) {
    return $be2fe7accd263025$var$isBuiltin(wat, 'Object');
}
function $be2fe7accd263025$export$9671ea99bd126ace(wat) {
    return typeof Event !== 'undefined' && $be2fe7accd263025$export$49034edbe6b62415(wat, Event);
}
function $be2fe7accd263025$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== 'undefined' && $be2fe7accd263025$export$49034edbe6b62415(wat, Element);
}
function $be2fe7accd263025$export$49841c62b9eff15(wat) {
    return $be2fe7accd263025$var$isBuiltin(wat, 'RegExp');
}
function $be2fe7accd263025$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === 'function');
}
function $be2fe7accd263025$export$bc2894c7158efbac(wat) {
    return $be2fe7accd263025$export$53b83ca8eaab0383(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}
function $be2fe7accd263025$export$c9f5652083b8129d(wat) {
    return typeof wat === 'number' && wat !== wat;
}
function $be2fe7accd263025$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}

});


parcelRegister("gSiM6", function(module, exports) {

$parcel$export(module.exports, "dsnToString", () => $c49040c921587e2a$export$44d472fbb931a776);
$parcel$export(module.exports, "makeDsn", () => $c49040c921587e2a$export$128827c3562ec0cb);

var $3VFsf = parcelRequire("3VFsf");

var $b17Q6 = parcelRequire("b17Q6");

var $7zZth = parcelRequire("7zZth");
/** Regular expression used to parse a Dsn. */ var $c49040c921587e2a$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+))?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function $c49040c921587e2a$var$isValidProtocol(protocol) {
    return protocol === 'http' || protocol === 'https';
}
function $c49040c921587e2a$export$44d472fbb931a776(dsn, withPassword) {
    if (withPassword === void 0) withPassword = false;
    var host = dsn.host, path = dsn.path, pass = dsn.pass, port = dsn.port, projectId = dsn.projectId, protocol = dsn.protocol, publicKey = dsn.publicKey;
    return protocol + "://" + publicKey + (withPassword && pass ? ":" + pass : '') + ("@" + host + (port ? ":" + port : '') + "/" + (path ? path + "/" : path) + projectId);
}
function $c49040c921587e2a$var$dsnFromString(str) {
    var match = $c49040c921587e2a$var$DSN_REGEX.exec(str);
    if (!match) throw new (0, $b17Q6.SentryError)("Invalid Sentry Dsn: " + str);
    var _a = (0, $3VFsf.__read)(match.slice(1), 6), protocol = _a[0], publicKey = _a[1], _b = _a[2], pass = _b === void 0 ? '' : _b, host = _a[3], _c = _a[4], port = _c === void 0 ? '' : _c, lastPath = _a[5];
    var path = '';
    var projectId = lastPath;
    var split = projectId.split('/');
    if (split.length > 1) {
        path = split.slice(0, -1).join('/');
        projectId = split.pop();
    }
    if (projectId) {
        var projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $c49040c921587e2a$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $c49040c921587e2a$var$dsnFromComponents(components) {
    // TODO this is for backwards compatibility, and can be removed in a future version
    if ('user' in components && !('publicKey' in components)) components.publicKey = components.user;
    return {
        user: components.publicKey || '',
        protocol: components.protocol,
        publicKey: components.publicKey || '',
        pass: components.pass || '',
        host: components.host,
        port: components.port || '',
        path: components.path || '',
        projectId: components.projectId
    };
}
function $c49040c921587e2a$var$validateDsn(dsn) {
    if (!(0, $7zZth.IS_DEBUG_BUILD)) return;
    var port = dsn.port, projectId = dsn.projectId, protocol = dsn.protocol;
    var requiredComponents = [
        'protocol',
        'publicKey',
        'host',
        'projectId'
    ];
    requiredComponents.forEach(function(component) {
        if (!dsn[component]) throw new (0, $b17Q6.SentryError)("Invalid Sentry Dsn: " + component + " missing");
    });
    if (!projectId.match(/^\d+$/)) throw new (0, $b17Q6.SentryError)("Invalid Sentry Dsn: Invalid projectId " + projectId);
    if (!$c49040c921587e2a$var$isValidProtocol(protocol)) throw new (0, $b17Q6.SentryError)("Invalid Sentry Dsn: Invalid protocol " + protocol);
    if (port && isNaN(parseInt(port, 10))) throw new (0, $b17Q6.SentryError)("Invalid Sentry Dsn: Invalid port " + port);
    return true;
}
function $c49040c921587e2a$export$128827c3562ec0cb(from) {
    var components = typeof from === 'string' ? $c49040c921587e2a$var$dsnFromString(from) : $c49040c921587e2a$var$dsnFromComponents(from);
    $c49040c921587e2a$var$validateDsn(components);
    return components;
}

});
parcelRegister("b17Q6", function(module, exports) {

$parcel$export(module.exports, "SentryError", () => $8055de6a13943cfb$export$5949942ba2a7c0e2);

var $3VFsf = parcelRequire("3VFsf");

var $cQly6 = parcelRequire("cQly6");
/** An error emitted by Sentry SDKs and related utilities. */ var $8055de6a13943cfb$export$5949942ba2a7c0e2 = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(SentryError, _super);
    function SentryError(message) {
        var _newTarget = this.constructor;
        var _this = _super.call(this, message) || this;
        _this.message = message;
        _this.name = _newTarget.prototype.constructor.name;
        (0, $cQly6.setPrototypeOf)(_this, _newTarget.prototype);
        return _this;
    }
    return SentryError;
}(Error);

});
parcelRegister("cQly6", function(module, exports) {

$parcel$export(module.exports, "setPrototypeOf", () => $959b0e8d921af28b$export$1cb0d91350beb6cc);
var $959b0e8d921af28b$export$1cb0d91350beb6cc = Object.setPrototypeOf || (({
    __proto__: []
}) instanceof Array ? $959b0e8d921af28b$var$setProtoOf : $959b0e8d921af28b$var$mixinProperties);
/**
 * setPrototypeOf polyfill using __proto__
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $959b0e8d921af28b$var$setProtoOf(obj, proto) {
    // @ts-ignore __proto__ does not exist on obj
    obj.__proto__ = proto;
    return obj;
}
/**
 * setPrototypeOf polyfill using mixin
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $959b0e8d921af28b$var$mixinProperties(obj, proto) {
    for(var prop in proto)if (!Object.prototype.hasOwnProperty.call(obj, prop)) // @ts-ignore typescript complains about indexing so we remove
    obj[prop] = proto[prop];
    return obj;
}

});


parcelRegister("7zZth", function(module, exports) {

$parcel$export(module.exports, "IS_DEBUG_BUILD", () => $584b7c38f9c3783f$export$48a8984ec0bf2e44);
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */ /** Flag that is true for debug builds, false otherwise. */ var $584b7c38f9c3783f$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;

});


parcelRegister("1sgxX", function(module, exports) {

$parcel$export(module.exports, "addInstrumentationHandler", () => $10f53dcccdcfb2a2$export$285b9172a3741fb7);

var $3VFsf = parcelRequire("3VFsf");

var $7zZth = parcelRequire("7zZth");

var $35A7f = parcelRequire("35A7f");

var $gkmq5 = parcelRequire("gkmq5");

var $4geCF = parcelRequire("4geCF");

var $1l3DN = parcelRequire("1l3DN");

var $aNkwr = parcelRequire("aNkwr");

var $ci1rH = parcelRequire("ci1rH");
var $10f53dcccdcfb2a2$var$global = (0, $35A7f.getGlobalObject)();
/**
 * Instrument native APIs to call handlers that can be used to create breadcrumbs, APM spans etc.
 *  - Console API
 *  - Fetch API
 *  - XHR API
 *  - History API
 *  - DOM API (click/typing)
 *  - Error API
 *  - UnhandledRejection API
 */ var $10f53dcccdcfb2a2$var$handlers = {};
var $10f53dcccdcfb2a2$var$instrumented = {};
/** Instruments given API */ function $10f53dcccdcfb2a2$var$instrument(type) {
    if ($10f53dcccdcfb2a2$var$instrumented[type]) return;
    $10f53dcccdcfb2a2$var$instrumented[type] = true;
    switch(type){
        case 'console':
            $10f53dcccdcfb2a2$var$instrumentConsole();
            break;
        case 'dom':
            $10f53dcccdcfb2a2$var$instrumentDOM();
            break;
        case 'xhr':
            $10f53dcccdcfb2a2$var$instrumentXHR();
            break;
        case 'fetch':
            $10f53dcccdcfb2a2$var$instrumentFetch();
            break;
        case 'history':
            $10f53dcccdcfb2a2$var$instrumentHistory();
            break;
        case 'error':
            $10f53dcccdcfb2a2$var$instrumentError();
            break;
        case 'unhandledrejection':
            $10f53dcccdcfb2a2$var$instrumentUnhandledRejection();
            break;
        default:
            (0, $7zZth.IS_DEBUG_BUILD) && (0, $4geCF.logger).warn('unknown instrumentation type:', type);
            return;
    }
}
function $10f53dcccdcfb2a2$export$285b9172a3741fb7(type, callback) {
    $10f53dcccdcfb2a2$var$handlers[type] = $10f53dcccdcfb2a2$var$handlers[type] || [];
    $10f53dcccdcfb2a2$var$handlers[type].push(callback);
    $10f53dcccdcfb2a2$var$instrument(type);
}
/** JSDoc */ function $10f53dcccdcfb2a2$var$triggerHandlers(type, data) {
    var e_1, _a;
    if (!type || !$10f53dcccdcfb2a2$var$handlers[type]) return;
    try {
        for(var _b = (0, $3VFsf.__values)($10f53dcccdcfb2a2$var$handlers[type] || []), _c = _b.next(); !_c.done; _c = _b.next()){
            var handler = _c.value;
            try {
                handler(data);
            } catch (e) {
                (0, $7zZth.IS_DEBUG_BUILD) && (0, $4geCF.logger).error("Error while triggering instrumentation handler.\nType: " + type + "\nName: " + (0, $aNkwr.getFunctionName)(handler) + "\nError:", e);
            }
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
}
/** JSDoc */ function $10f53dcccdcfb2a2$var$instrumentConsole() {
    if (!('console' in $10f53dcccdcfb2a2$var$global)) return;
    (0, $4geCF.CONSOLE_LEVELS).forEach(function(level) {
        if (!(level in $10f53dcccdcfb2a2$var$global.console)) return;
        (0, $1l3DN.fill)($10f53dcccdcfb2a2$var$global.console, level, function(originalConsoleMethod) {
            return function() {
                var args = [];
                for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                $10f53dcccdcfb2a2$var$triggerHandlers('console', {
                    args: args,
                    level: level
                });
                // this fails for some browsers. :(
                if (originalConsoleMethod) originalConsoleMethod.apply($10f53dcccdcfb2a2$var$global.console, args);
            };
        });
    });
}
/** JSDoc */ function $10f53dcccdcfb2a2$var$instrumentFetch() {
    if (!(0, $ci1rH.supportsNativeFetch)()) return;
    (0, $1l3DN.fill)($10f53dcccdcfb2a2$var$global, 'fetch', function(originalFetch) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var handlerData = {
                args: args,
                fetchData: {
                    method: $10f53dcccdcfb2a2$var$getFetchMethod(args),
                    url: $10f53dcccdcfb2a2$var$getFetchUrl(args)
                },
                startTimestamp: Date.now()
            };
            $10f53dcccdcfb2a2$var$triggerHandlers('fetch', (0, $3VFsf.__assign)({}, handlerData));
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply($10f53dcccdcfb2a2$var$global, args).then(function(response) {
                $10f53dcccdcfb2a2$var$triggerHandlers('fetch', (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, handlerData), {
                    endTimestamp: Date.now(),
                    response: response
                }));
                return response;
            }, function(error) {
                $10f53dcccdcfb2a2$var$triggerHandlers('fetch', (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, handlerData), {
                    endTimestamp: Date.now(),
                    error: error
                }));
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /** Extract `method` from fetch call arguments */ function $10f53dcccdcfb2a2$var$getFetchMethod(fetchArgs) {
    if (fetchArgs === void 0) fetchArgs = [];
    if ('Request' in $10f53dcccdcfb2a2$var$global && (0, $gkmq5.isInstanceOf)(fetchArgs[0], Request) && fetchArgs[0].method) return String(fetchArgs[0].method).toUpperCase();
    if (fetchArgs[1] && fetchArgs[1].method) return String(fetchArgs[1].method).toUpperCase();
    return 'GET';
}
/** Extract `url` from fetch call arguments */ function $10f53dcccdcfb2a2$var$getFetchUrl(fetchArgs) {
    if (fetchArgs === void 0) fetchArgs = [];
    if (typeof fetchArgs[0] === 'string') return fetchArgs[0];
    if ('Request' in $10f53dcccdcfb2a2$var$global && (0, $gkmq5.isInstanceOf)(fetchArgs[0], Request)) return fetchArgs[0].url;
    return String(fetchArgs[0]);
}
/* eslint-enable @typescript-eslint/no-unsafe-member-access */ /** JSDoc */ function $10f53dcccdcfb2a2$var$instrumentXHR() {
    if (!('XMLHttpRequest' in $10f53dcccdcfb2a2$var$global)) return;
    var xhrproto = XMLHttpRequest.prototype;
    (0, $1l3DN.fill)(xhrproto, 'open', function(originalOpen) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            var xhr = this;
            var url = args[1];
            var xhrInfo = xhr.__sentry_xhr__ = {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                method: (0, $gkmq5.isString)(args[0]) ? args[0].toUpperCase() : args[0],
                url: args[1]
            };
            // if Sentry key appears in URL, don't capture it as a request
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            if ((0, $gkmq5.isString)(url) && xhrInfo.method === 'POST' && url.match(/sentry_key/)) xhr.__sentry_own_request__ = true;
            var onreadystatechangeHandler = function() {
                if (xhr.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        xhrInfo.status_code = xhr.status;
                    } catch (e) {
                    /* do nothing */ }
                    $10f53dcccdcfb2a2$var$triggerHandlers('xhr', {
                        args: args,
                        endTimestamp: Date.now(),
                        startTimestamp: Date.now(),
                        xhr: xhr
                    });
                }
            };
            if ('onreadystatechange' in xhr && typeof xhr.onreadystatechange === 'function') (0, $1l3DN.fill)(xhr, 'onreadystatechange', function(original) {
                return function() {
                    var readyStateArgs = [];
                    for(var _i = 0; _i < arguments.length; _i++)readyStateArgs[_i] = arguments[_i];
                    onreadystatechangeHandler();
                    return original.apply(xhr, readyStateArgs);
                };
            });
            else xhr.addEventListener('readystatechange', onreadystatechangeHandler);
            return originalOpen.apply(xhr, args);
        };
    });
    (0, $1l3DN.fill)(xhrproto, 'send', function(originalSend) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.__sentry_xhr__ && args[0] !== undefined) this.__sentry_xhr__.body = args[0];
            $10f53dcccdcfb2a2$var$triggerHandlers('xhr', {
                args: args,
                startTimestamp: Date.now(),
                xhr: this
            });
            return originalSend.apply(this, args);
        };
    });
}
var $10f53dcccdcfb2a2$var$lastHref;
/** JSDoc */ function $10f53dcccdcfb2a2$var$instrumentHistory() {
    if (!(0, $ci1rH.supportsHistory)()) return;
    var oldOnPopState = $10f53dcccdcfb2a2$var$global.onpopstate;
    $10f53dcccdcfb2a2$var$global.onpopstate = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var to = $10f53dcccdcfb2a2$var$global.location.href;
        // keep track of the current URL state, as we always receive only the updated state
        var from = $10f53dcccdcfb2a2$var$lastHref;
        $10f53dcccdcfb2a2$var$lastHref = to;
        $10f53dcccdcfb2a2$var$triggerHandlers('history', {
            from: from,
            to: to
        });
        if (oldOnPopState) // Apparently this can throw in Firefox when incorrectly implemented plugin is installed.
        // https://github.com/getsentry/sentry-javascript/issues/3344
        // https://github.com/bugsnag/bugsnag-js/issues/469
        try {
            return oldOnPopState.apply(this, args);
        } catch (_oO) {
        // no-empty
        }
    };
    /** @hidden */ function historyReplacementFunction(originalHistoryFunction) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var url = args.length > 2 ? args[2] : undefined;
            if (url) {
                // coerce to string (this is what pushState does)
                var from = $10f53dcccdcfb2a2$var$lastHref;
                var to = String(url);
                // keep track of the current URL state, as we always receive only the updated state
                $10f53dcccdcfb2a2$var$lastHref = to;
                $10f53dcccdcfb2a2$var$triggerHandlers('history', {
                    from: from,
                    to: to
                });
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, $1l3DN.fill)($10f53dcccdcfb2a2$var$global.history, 'pushState', historyReplacementFunction);
    (0, $1l3DN.fill)($10f53dcccdcfb2a2$var$global.history, 'replaceState', historyReplacementFunction);
}
var $10f53dcccdcfb2a2$var$debounceDuration = 1000;
var $10f53dcccdcfb2a2$var$debounceTimerID;
var $10f53dcccdcfb2a2$var$lastCapturedEvent;
/**
 * Decide whether the current event should finish the debounce of previously captured one.
 * @param previous previously captured event
 * @param current event to be captured
 */ function $10f53dcccdcfb2a2$var$shouldShortcircuitPreviousDebounce(previous, current) {
    // If there was no previous event, it should always be swapped for the new one.
    if (!previous) return true;
    // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
    if (previous.type !== current.type) return true;
    try {
        // If both events have the same type, it's still possible that actions were performed on different targets.
        // e.g. 2 clicks on different buttons.
        if (previous.target !== current.target) return true;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
    // to which an event listener was attached), we treat them as the same action, as we want to capture
    // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
    return false;
}
/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */ function $10f53dcccdcfb2a2$var$shouldSkipDOMEvent(event) {
    // We are only interested in filtering `keypress` events for now.
    if (event.type !== 'keypress') return false;
    try {
        var target = event.target;
        if (!target || !target.tagName) return true;
        // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
        // e.g.tabbing through elements, hotkeys, etc.
        if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) return false;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    return true;
}
/**
 * Wraps addEventListener to capture UI breadcrumbs
 * @param handler function that will be triggered
 * @param globalListener indicates whether event was captured by the global event listener
 * @returns wrapped breadcrumb events handler
 * @hidden
 */ function $10f53dcccdcfb2a2$var$makeDOMEventHandler(handler, globalListener) {
    if (globalListener === void 0) globalListener = false;
    return function(event) {
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors).
        // Ignore if we've already captured that event.
        if (!event || $10f53dcccdcfb2a2$var$lastCapturedEvent === event) return;
        // We always want to skip _some_ events.
        if ($10f53dcccdcfb2a2$var$shouldSkipDOMEvent(event)) return;
        var name = event.type === 'keypress' ? 'input' : event.type;
        // If there is no debounce timer, it means that we can safely capture the new event and store it for future comparisons.
        if ($10f53dcccdcfb2a2$var$debounceTimerID === undefined) {
            handler({
                event: event,
                name: name,
                global: globalListener
            });
            $10f53dcccdcfb2a2$var$lastCapturedEvent = event;
        } else if ($10f53dcccdcfb2a2$var$shouldShortcircuitPreviousDebounce($10f53dcccdcfb2a2$var$lastCapturedEvent, event)) {
            handler({
                event: event,
                name: name,
                global: globalListener
            });
            $10f53dcccdcfb2a2$var$lastCapturedEvent = event;
        }
        // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
        clearTimeout($10f53dcccdcfb2a2$var$debounceTimerID);
        $10f53dcccdcfb2a2$var$debounceTimerID = $10f53dcccdcfb2a2$var$global.setTimeout(function() {
            $10f53dcccdcfb2a2$var$debounceTimerID = undefined;
        }, $10f53dcccdcfb2a2$var$debounceDuration);
    };
}
/** JSDoc */ function $10f53dcccdcfb2a2$var$instrumentDOM() {
    if (!('document' in $10f53dcccdcfb2a2$var$global)) return;
    // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
    // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
    // we instrument `addEventListener` so that we don't end up attaching this handler twice.
    var triggerDOMHandler = $10f53dcccdcfb2a2$var$triggerHandlers.bind(null, 'dom');
    var globalDOMEventHandler = $10f53dcccdcfb2a2$var$makeDOMEventHandler(triggerDOMHandler, true);
    $10f53dcccdcfb2a2$var$global.document.addEventListener('click', globalDOMEventHandler, false);
    $10f53dcccdcfb2a2$var$global.document.addEventListener('keypress', globalDOMEventHandler, false);
    // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
    // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
    // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
    // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
    // guaranteed to fire at least once.)
    [
        'EventTarget',
        'Node'
    ].forEach(function(target) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        var proto = $10f53dcccdcfb2a2$var$global[target] && $10f53dcccdcfb2a2$var$global[target].prototype;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) return;
        (0, $1l3DN.fill)(proto, 'addEventListener', function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    var el = this;
                    var handlers_1 = el.__sentry_instrumentation_handlers__ = el.__sentry_instrumentation_handlers__ || {};
                    var handlerForType = handlers_1[type] = handlers_1[type] || {
                        refCount: 0
                    };
                    if (!handlerForType.handler) {
                        var handler = $10f53dcccdcfb2a2$var$makeDOMEventHandler(triggerDOMHandler);
                        handlerForType.handler = handler;
                        originalAddEventListener.call(this, type, handler, options);
                    }
                    handlerForType.refCount += 1;
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0, $1l3DN.fill)(proto, 'removeEventListener', function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    var el = this;
                    var handlers_2 = el.__sentry_instrumentation_handlers__ || {};
                    var handlerForType = handlers_2[type];
                    if (handlerForType) {
                        handlerForType.refCount -= 1;
                        // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                        if (handlerForType.refCount <= 0) {
                            originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                            handlerForType.handler = undefined;
                            delete handlers_2[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                        }
                        // If there are no longer any custom handlers of any type on this element, cleanup everything.
                        if (Object.keys(handlers_2).length === 0) delete el.__sentry_instrumentation_handlers__;
                    }
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
var $10f53dcccdcfb2a2$var$_oldOnErrorHandler = null;
/** JSDoc */ function $10f53dcccdcfb2a2$var$instrumentError() {
    $10f53dcccdcfb2a2$var$_oldOnErrorHandler = $10f53dcccdcfb2a2$var$global.onerror;
    $10f53dcccdcfb2a2$var$global.onerror = function(msg, url, line, column, error) {
        $10f53dcccdcfb2a2$var$triggerHandlers('error', {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        });
        if ($10f53dcccdcfb2a2$var$_oldOnErrorHandler) // eslint-disable-next-line prefer-rest-params
        return $10f53dcccdcfb2a2$var$_oldOnErrorHandler.apply(this, arguments);
        return false;
    };
}
var $10f53dcccdcfb2a2$var$_oldOnUnhandledRejectionHandler = null;
/** JSDoc */ function $10f53dcccdcfb2a2$var$instrumentUnhandledRejection() {
    $10f53dcccdcfb2a2$var$_oldOnUnhandledRejectionHandler = $10f53dcccdcfb2a2$var$global.onunhandledrejection;
    $10f53dcccdcfb2a2$var$global.onunhandledrejection = function(e) {
        $10f53dcccdcfb2a2$var$triggerHandlers('unhandledrejection', e);
        if ($10f53dcccdcfb2a2$var$_oldOnUnhandledRejectionHandler) // eslint-disable-next-line prefer-rest-params
        return $10f53dcccdcfb2a2$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
}

});
parcelRegister("4geCF", function(module, exports) {

$parcel$export(module.exports, "CONSOLE_LEVELS", () => $31a3ffca8b63e1cc$export$2a2b1d2252a69ecb);
$parcel$export(module.exports, "logger", () => $31a3ffca8b63e1cc$export$af88d00dbe7f521);

var $3VFsf = parcelRequire("3VFsf");

var $7zZth = parcelRequire("7zZth");

var $35A7f = parcelRequire("35A7f");
// TODO: Implement different loggers for different environments
var $31a3ffca8b63e1cc$var$global = (0, $35A7f.getGlobalObject)();
/** Prefix for logging strings */ var $31a3ffca8b63e1cc$var$PREFIX = 'Sentry Logger ';
var $31a3ffca8b63e1cc$export$2a2b1d2252a69ecb = [
    'debug',
    'info',
    'warn',
    'error',
    'log',
    'assert'
];
function $31a3ffca8b63e1cc$export$cda52e2a8927a2ca(callback) {
    var global = (0, $35A7f.getGlobalObject)();
    if (!('console' in global)) return callback();
    var originalConsole = global.console;
    var wrappedLevels = {};
    // Restore all wrapped console methods
    $31a3ffca8b63e1cc$export$2a2b1d2252a69ecb.forEach(function(level) {
        // TODO(v7): Remove this check as it's only needed for Node 6
        var originalWrappedFunc = originalConsole[level] && originalConsole[level].__sentry_original__;
        if (level in global.console && originalWrappedFunc) {
            wrappedLevels[level] = originalConsole[level];
            originalConsole[level] = originalWrappedFunc;
        }
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        Object.keys(wrappedLevels).forEach(function(level) {
            originalConsole[level] = wrappedLevels[level];
        });
    }
}
function $31a3ffca8b63e1cc$var$makeLogger() {
    var enabled = false;
    var logger = {
        enable: function() {
            enabled = true;
        },
        disable: function() {
            enabled = false;
        }
    };
    if (0, $7zZth.IS_DEBUG_BUILD) $31a3ffca8b63e1cc$export$2a2b1d2252a69ecb.forEach(function(name) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        logger[name] = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (enabled) $31a3ffca8b63e1cc$export$cda52e2a8927a2ca(function() {
                var _a;
                (_a = $31a3ffca8b63e1cc$var$global.console)[name].apply(_a, (0, $3VFsf.__spread)([
                    $31a3ffca8b63e1cc$var$PREFIX + "[" + name + "]:"
                ], args));
            });
        };
    });
    else $31a3ffca8b63e1cc$export$2a2b1d2252a69ecb.forEach(function(name) {
        logger[name] = function() {
            return undefined;
        };
    });
    return logger;
}
// Ensure we only have a single logger instance, even if multiple versions of @sentry/utils are being used
var $31a3ffca8b63e1cc$export$af88d00dbe7f521;
if (0, $7zZth.IS_DEBUG_BUILD) $31a3ffca8b63e1cc$export$af88d00dbe7f521 = (0, $35A7f.getGlobalSingleton)('logger', $31a3ffca8b63e1cc$var$makeLogger);
else $31a3ffca8b63e1cc$export$af88d00dbe7f521 = $31a3ffca8b63e1cc$var$makeLogger();

});

parcelRegister("1l3DN", function(module, exports) {

$parcel$export(module.exports, "fill", () => $0f9a939899ca1852$export$9563e054e6f787fb);
$parcel$export(module.exports, "markFunctionWrapped", () => $0f9a939899ca1852$export$5c1499e2e5d010ae);
$parcel$export(module.exports, "addNonEnumerableProperty", () => $0f9a939899ca1852$export$e73679ffaf56810e);
$parcel$export(module.exports, "getOriginalFunction", () => $0f9a939899ca1852$export$e6cc1e135e2092e5);
$parcel$export(module.exports, "urlEncode", () => $0f9a939899ca1852$export$9ef804feabbcbaf1);
$parcel$export(module.exports, "convertToPlainObject", () => $0f9a939899ca1852$export$62ff257738bf57f5);
$parcel$export(module.exports, "extractExceptionKeysForMessage", () => $0f9a939899ca1852$export$b0244d5063c0b61b);

var $3VFsf = parcelRequire("3VFsf");

var $7yHR0 = parcelRequire("7yHR0");

var $gkmq5 = parcelRequire("gkmq5");

var $jOwKr = parcelRequire("jOwKr");
function $0f9a939899ca1852$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    var original = source[name];
    var wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === 'function') try {
        $0f9a939899ca1852$export$5c1499e2e5d010ae(wrapped, original);
    } catch (_Oo) {
    // This can throw if multiple fill happens on a global object like XMLHttpRequest
    // Fixes https://github.com/getsentry/sentry-javascript/issues/2043
    }
    source[name] = wrapped;
}
function $0f9a939899ca1852$export$e73679ffaf56810e(obj, name, value) {
    Object.defineProperty(obj, name, {
        // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
        value: value,
        writable: true,
        configurable: true
    });
}
function $0f9a939899ca1852$export$5c1499e2e5d010ae(wrapped, original) {
    var proto = original.prototype || {};
    wrapped.prototype = original.prototype = proto;
    $0f9a939899ca1852$export$e73679ffaf56810e(wrapped, '__sentry_original__', original);
}
function $0f9a939899ca1852$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
function $0f9a939899ca1852$export$9ef804feabbcbaf1(object) {
    return Object.keys(object).map(function(key) {
        return encodeURIComponent(key) + "=" + encodeURIComponent(object[key]);
    }).join('&');
}
function $0f9a939899ca1852$export$62ff257738bf57f5(value) {
    var newObj = value;
    if ((0, $gkmq5.isError)(value)) newObj = (0, $3VFsf.__assign)({
        message: value.message,
        name: value.name,
        stack: value.stack
    }, $0f9a939899ca1852$var$getOwnProperties(value));
    else if ((0, $gkmq5.isEvent)(value)) {
        var event_1 = value;
        newObj = (0, $3VFsf.__assign)({
            type: event_1.type,
            target: $0f9a939899ca1852$var$serializeEventTarget(event_1.target),
            currentTarget: $0f9a939899ca1852$var$serializeEventTarget(event_1.currentTarget)
        }, $0f9a939899ca1852$var$getOwnProperties(event_1));
        if (typeof CustomEvent !== 'undefined' && (0, $gkmq5.isInstanceOf)(value, CustomEvent)) newObj.detail = event_1.detail;
    }
    return newObj;
}
/** Creates a string representation of the target of an `Event` object */ function $0f9a939899ca1852$var$serializeEventTarget(target) {
    try {
        return (0, $gkmq5.isElement)(target) ? (0, $7yHR0.htmlTreeAsString)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return '<unknown>';
    }
}
/** Filters out all but an object's own properties */ function $0f9a939899ca1852$var$getOwnProperties(obj) {
    var extractedProps = {};
    for(var property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
    return extractedProps;
}
function $0f9a939899ca1852$export$b0244d5063c0b61b(exception, maxLength) {
    if (maxLength === void 0) maxLength = 40;
    var keys = Object.keys($0f9a939899ca1852$export$62ff257738bf57f5(exception));
    keys.sort();
    if (!keys.length) return '[object has no keys]';
    if (keys[0].length >= maxLength) return (0, $jOwKr.truncate)(keys[0], maxLength);
    for(var includedKeys = keys.length; includedKeys > 0; includedKeys--){
        var serialized = keys.slice(0, includedKeys).join(', ');
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $jOwKr.truncate)(serialized, maxLength);
    }
    return '';
}
function $0f9a939899ca1852$export$d25f2688db1bb433(val) {
    var e_1, _a;
    if ((0, $gkmq5.isPlainObject)(val)) {
        var rv = {};
        try {
            for(var _b = (0, $3VFsf.__values)(Object.keys(val)), _c = _b.next(); !_c.done; _c = _b.next()){
                var key = _c.value;
                if (typeof val[key] !== 'undefined') rv[key] = $0f9a939899ca1852$export$d25f2688db1bb433(val[key]);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return rv;
    }
    if (Array.isArray(val)) return val.map($0f9a939899ca1852$export$d25f2688db1bb433);
    return val;
}
function $0f9a939899ca1852$export$92b78acdbe066b6b(wat) {
    var objectified;
    switch(true){
        case wat === undefined || wat === null:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === 'symbol' || typeof wat === 'bigint':
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $gkmq5.isPrimitive)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}

});
parcelRegister("jOwKr", function(module, exports) {

$parcel$export(module.exports, "truncate", () => $e6cc16e585cef99d$export$6a506b36fdea397d);
$parcel$export(module.exports, "snipLine", () => $e6cc16e585cef99d$export$4215662d762d6f9d);
$parcel$export(module.exports, "safeJoin", () => $e6cc16e585cef99d$export$465e9d514283d4fd);
$parcel$export(module.exports, "isMatchingPattern", () => $e6cc16e585cef99d$export$cdded5b28a5f8c6d);

var $gkmq5 = parcelRequire("gkmq5");
function $e6cc16e585cef99d$export$6a506b36fdea397d(str, max) {
    if (max === void 0) max = 0;
    if (typeof str !== 'string' || max === 0) return str;
    return str.length <= max ? str : str.substr(0, max) + "...";
}
function $e6cc16e585cef99d$export$4215662d762d6f9d(line, colno) {
    var newLine = line;
    var lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    var start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    var end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = "'{snip} " + newLine;
    if (end < lineLength) newLine += ' {snip}';
    return newLine;
}
function $e6cc16e585cef99d$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return '';
    var output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(var i = 0; i < input.length; i++){
        var value = input[i];
        try {
            output.push(String(value));
        } catch (e) {
            output.push('[value cannot be serialized]');
        }
    }
    return output.join(delimiter);
}
function $e6cc16e585cef99d$export$cdded5b28a5f8c6d(value, pattern) {
    if (!(0, $gkmq5.isString)(value)) return false;
    if ((0, $gkmq5.isRegExp)(pattern)) return pattern.test(value);
    if (typeof pattern === 'string') return value.indexOf(pattern) !== -1;
    return false;
}
function $e6cc16e585cef99d$export$466fc863a824cea6(regexString) {
    // escape the hyphen separately so we can also replace it with a unicode literal hyphen, to avoid the problems
    // discussed in https://github.com/sindresorhus/escape-string-regexp/issues/20.
    return regexString.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&').replace(/-/g, '\\x2d');
}

});


parcelRegister("aNkwr", function(module, exports) {

$parcel$export(module.exports, "createStackParser", () => $7dbe6648bfa0e83e$export$a5739666fb2d03d4);
$parcel$export(module.exports, "getFunctionName", () => $7dbe6648bfa0e83e$export$aad197c7121a6651);

var $3VFsf = parcelRequire("3VFsf");
var $7dbe6648bfa0e83e$var$STACKTRACE_LIMIT = 50;
function $7dbe6648bfa0e83e$export$a5739666fb2d03d4() {
    var parsers = [];
    for(var _i = 0; _i < arguments.length; _i++)parsers[_i] = arguments[_i];
    var sortedParsers = parsers.sort(function(a, b) {
        return a[0] - b[0];
    }).map(function(p) {
        return p[1];
    });
    return function(stack, skipFirst) {
        var e_1, _a, e_2, _b;
        if (skipFirst === void 0) skipFirst = 0;
        var frames = [];
        try {
            for(var _c = (0, $3VFsf.__values)(stack.split('\n').slice(skipFirst)), _d = _c.next(); !_d.done; _d = _c.next()){
                var line = _d.value;
                try {
                    for(var sortedParsers_1 = (e_2 = void 0, (0, $3VFsf.__values)(sortedParsers)), sortedParsers_1_1 = sortedParsers_1.next(); !sortedParsers_1_1.done; sortedParsers_1_1 = sortedParsers_1.next()){
                        var parser = sortedParsers_1_1.value;
                        var frame = parser(line);
                        if (frame) {
                            frames.push(frame);
                            break;
                        }
                    }
                } catch (e_2_1) {
                    e_2 = {
                        error: e_2_1
                    };
                } finally{
                    try {
                        if (sortedParsers_1_1 && !sortedParsers_1_1.done && (_b = sortedParsers_1.return)) _b.call(sortedParsers_1);
                    } finally{
                        if (e_2) throw e_2.error;
                    }
                }
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return $7dbe6648bfa0e83e$export$c55c24c0eeba0205(frames);
    };
}
function $7dbe6648bfa0e83e$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    var localStack = stack;
    var firstFrameFunction = localStack[0].function || '';
    var lastFrameFunction = localStack[localStack.length - 1].function || '';
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (firstFrameFunction.indexOf('captureMessage') !== -1 || firstFrameFunction.indexOf('captureException') !== -1) localStack = localStack.slice(1);
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if (lastFrameFunction.indexOf('sentryWrapped') !== -1) localStack = localStack.slice(0, -1);
    // The frame where the crash happened, should be the last entry in the array
    return localStack.slice(0, $7dbe6648bfa0e83e$var$STACKTRACE_LIMIT).map(function(frame) {
        return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, frame), {
            filename: frame.filename || localStack[0].filename,
            function: frame.function || '?'
        });
    }).reverse();
}
var $7dbe6648bfa0e83e$var$defaultFunctionName = '<anonymous>';
function $7dbe6648bfa0e83e$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== 'function') return $7dbe6648bfa0e83e$var$defaultFunctionName;
        return fn.name || $7dbe6648bfa0e83e$var$defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $7dbe6648bfa0e83e$var$defaultFunctionName;
    }
}

});

parcelRegister("ci1rH", function(module, exports) {

$parcel$export(module.exports, "supportsFetch", () => $8f2849975b030cc8$export$edf3cb81fd7d2a3e);
$parcel$export(module.exports, "isNativeFetch", () => $8f2849975b030cc8$export$18cf36ed71d733e7);
$parcel$export(module.exports, "supportsNativeFetch", () => $8f2849975b030cc8$export$c82d238e23c40b21);
$parcel$export(module.exports, "supportsReferrerPolicy", () => $8f2849975b030cc8$export$2d308b428295192f);
$parcel$export(module.exports, "supportsHistory", () => $8f2849975b030cc8$export$67fc34576016d6ec);

var $7zZth = parcelRequire("7zZth");

var $35A7f = parcelRequire("35A7f");

var $4geCF = parcelRequire("4geCF");
function $8f2849975b030cc8$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent('');
        return true;
    } catch (e) {
        return false;
    }
}
function $8f2849975b030cc8$export$1c08bd1a7eb3c472() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-ignore It really needs 1 argument, not 0.
        new DOMError('');
        return true;
    } catch (e) {
        return false;
    }
}
function $8f2849975b030cc8$export$ab12a5d056f1d3a() {
    try {
        new DOMException('');
        return true;
    } catch (e) {
        return false;
    }
}
function $8f2849975b030cc8$export$edf3cb81fd7d2a3e() {
    if (!('fetch' in (0, $35A7f.getGlobalObject)())) return false;
    try {
        new Headers();
        new Request('');
        new Response();
        return true;
    } catch (e) {
        return false;
    }
}
function $8f2849975b030cc8$export$18cf36ed71d733e7(func) {
    return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
function $8f2849975b030cc8$export$c82d238e23c40b21() {
    if (!$8f2849975b030cc8$export$edf3cb81fd7d2a3e()) return false;
    var global = (0, $35A7f.getGlobalObject)();
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if ($8f2849975b030cc8$export$18cf36ed71d733e7(global.fetch)) return true;
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    var result = false;
    var doc = global.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === 'function') try {
        var sandbox = doc.createElement('iframe');
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow && sandbox.contentWindow.fetch) // eslint-disable-next-line @typescript-eslint/unbound-method
        result = $8f2849975b030cc8$export$18cf36ed71d733e7(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, $7zZth.IS_DEBUG_BUILD) && (0, $4geCF.logger).warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
    }
    return result;
}
function $8f2849975b030cc8$export$531055a6c684a70a() {
    return 'ReportingObserver' in (0, $35A7f.getGlobalObject)();
}
function $8f2849975b030cc8$export$2d308b428295192f() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!$8f2849975b030cc8$export$edf3cb81fd7d2a3e()) return false;
    try {
        new Request('_', {
            referrerPolicy: 'origin'
        });
        return true;
    } catch (e) {
        return false;
    }
}
function $8f2849975b030cc8$export$67fc34576016d6ec() {
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    var global = (0, $35A7f.getGlobalObject)();
    /* eslint-disable @typescript-eslint/no-unsafe-member-access */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var chrome = global.chrome;
    var isChromePackagedApp = chrome && chrome.app && chrome.app.runtime;
    /* eslint-enable @typescript-eslint/no-unsafe-member-access */ var hasHistoryApi = 'history' in global && !!global.history.pushState && !!global.history.replaceState;
    return !isChromePackagedApp && hasHistoryApi;
}

});


parcelRegister("jyUiA", function(module, exports) {

$parcel$export(module.exports, "uuid4", () => $e3dcdd1608c449ef$export$19f53698e68b2496);
$parcel$export(module.exports, "parseUrl", () => $e3dcdd1608c449ef$export$7a5253c0f62e0150);
$parcel$export(module.exports, "getEventDescription", () => $e3dcdd1608c449ef$export$4157119e2b157127);
$parcel$export(module.exports, "addExceptionTypeValue", () => $e3dcdd1608c449ef$export$f26508487bf83ee7);
$parcel$export(module.exports, "addExceptionMechanism", () => $e3dcdd1608c449ef$export$c69a9a0313b03bb1);
$parcel$export(module.exports, "checkOrSetAlreadyCaught", () => $e3dcdd1608c449ef$export$6de4ffac6a2f1098);

var $3VFsf = parcelRequire("3VFsf");

var $35A7f = parcelRequire("35A7f");

var $1l3DN = parcelRequire("1l3DN");

var $jOwKr = parcelRequire("jOwKr");
function $e3dcdd1608c449ef$export$19f53698e68b2496() {
    var global = (0, $35A7f.getGlobalObject)();
    var crypto = global.crypto || global.msCrypto;
    if (!(crypto === void 0) && crypto.getRandomValues) {
        // Use window.crypto API if available
        var arr = new Uint16Array(8);
        crypto.getRandomValues(arr);
        // set 4 in byte 7
        // eslint-disable-next-line no-bitwise
        arr[3] = arr[3] & 0xfff | 0x4000;
        // set 2 most significant bits of byte 9 to '10'
        // eslint-disable-next-line no-bitwise
        arr[4] = arr[4] & 0x3fff | 0x8000;
        var pad = function(num) {
            var v = num.toString(16);
            while(v.length < 4)v = "0" + v;
            return v;
        };
        return pad(arr[0]) + pad(arr[1]) + pad(arr[2]) + pad(arr[3]) + pad(arr[4]) + pad(arr[5]) + pad(arr[6]) + pad(arr[7]);
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        // eslint-disable-next-line no-bitwise
        var r = Math.random() * 16 | 0;
        // eslint-disable-next-line no-bitwise
        var v = c === 'x' ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
}
function $e3dcdd1608c449ef$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    var match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    var query = match[6] || '';
    var fragment = match[8] || '';
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        relative: match[5] + query + fragment
    };
}
function $e3dcdd1608c449ef$var$getFirstException(event) {
    return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}
function $e3dcdd1608c449ef$export$4157119e2b157127(event) {
    var message = event.message, eventId = event.event_id;
    if (message) return message;
    var firstException = $e3dcdd1608c449ef$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return firstException.type + ": " + firstException.value;
        return firstException.type || firstException.value || eventId || '<unknown>';
    }
    return eventId || '<unknown>';
}
function $e3dcdd1608c449ef$export$f26508487bf83ee7(event, value, type) {
    var exception = event.exception = event.exception || {};
    var values = exception.values = exception.values || [];
    var firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || '';
    if (!firstException.type) firstException.type = type || 'Error';
}
function $e3dcdd1608c449ef$export$c69a9a0313b03bb1(event, newMechanism) {
    var firstException = $e3dcdd1608c449ef$var$getFirstException(event);
    if (!firstException) return;
    var defaultMechanism = {
        type: 'generic',
        handled: true
    };
    var currentMechanism = firstException.mechanism;
    firstException.mechanism = (0, $3VFsf.__assign)((0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, defaultMechanism), currentMechanism), newMechanism);
    if (newMechanism && 'data' in newMechanism) {
        var mergedData = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, currentMechanism && currentMechanism.data), newMechanism.data);
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
var $e3dcdd1608c449ef$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
function $e3dcdd1608c449ef$export$d364f2020ab30578(input) {
    var match = input.match($e3dcdd1608c449ef$var$SEMVER_REGEXP) || [];
    var major = parseInt(match[1], 10);
    var minor = parseInt(match[2], 10);
    var patch = parseInt(match[3], 10);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
function $e3dcdd1608c449ef$export$ec2291bfc64632f0(lines, frame, linesOfContext) {
    if (linesOfContext === void 0) linesOfContext = 5;
    var lineno = frame.lineno || 0;
    var maxLines = lines.length;
    var sourceLine = Math.max(Math.min(maxLines, lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map(function(line) {
        return (0, $jOwKr.snipLine)(line, 0);
    });
    frame.context_line = (0, $jOwKr.snipLine)(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map(function(line) {
        return (0, $jOwKr.snipLine)(line, 0);
    });
}
function $e3dcdd1608c449ef$export$ce084c78234bd35(urlPath) {
    // eslint-disable-next-line no-useless-escape
    return urlPath.split(/[\?#]/, 1)[0];
}
function $e3dcdd1608c449ef$export$6de4ffac6a2f1098(exception) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (exception && exception.__sentry_captured__) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $1l3DN.addNonEnumerableProperty)(exception, '__sentry_captured__', true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}

});

parcelRegister("2mY5H", function(module, exports) {

$parcel$export(module.exports, "normalize", () => $1b9c3fa19e940880$export$a3295358bff77e);
$parcel$export(module.exports, "normalizeToSize", () => $1b9c3fa19e940880$export$23fbbb20bed71033);

var $3VFsf = parcelRequire("3VFsf");

var $gkmq5 = parcelRequire("gkmq5");

var $377JV = parcelRequire("377JV");

var $1l3DN = parcelRequire("1l3DN");

var $aNkwr = parcelRequire("aNkwr");
function $1b9c3fa19e940880$export$a3295358bff77e(input, depth, maxProperties) {
    if (depth === void 0) depth = Infinity;
    if (maxProperties === void 0) maxProperties = Infinity;
    try {
        // since we're at the outermost level, there is no key
        return $1b9c3fa19e940880$export$588732934346abbf('', input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: "**non-serializable** (" + err + ")"
        };
    }
}
function $1b9c3fa19e940880$export$23fbbb20bed71033(object, // Default Node.js REPL depth
depth, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize) {
    if (depth === void 0) depth = 3;
    if (maxSize === void 0) maxSize = 102400;
    var normalized = $1b9c3fa19e940880$export$a3295358bff77e(object, depth);
    if ($1b9c3fa19e940880$var$jsonSize(normalized) > maxSize) return $1b9c3fa19e940880$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $1b9c3fa19e940880$export$588732934346abbf(key, value, depth, maxProperties, memo) {
    if (depth === void 0) depth = Infinity;
    if (maxProperties === void 0) maxProperties = Infinity;
    if (memo === void 0) memo = (0, $377JV.memoBuilder)();
    var _a = (0, $3VFsf.__read)(memo, 2), memoize = _a[0], unmemoize = _a[1];
    // If the value has a `toJSON` method, see if we can bail and let it do the work
    var valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === 'function') try {
        return valueWithToJSON.toJSON();
    } catch (err) {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // Get the simple cases out of the way first
    if (value === null || [
        'number',
        'boolean',
        'string'
    ].includes(typeof value) && !(0, $gkmq5.isNaN)(value)) return value;
    var stringified = $1b9c3fa19e940880$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith('[object ')) return stringified;
    // We're also done if we've reached the max depth
    if (depth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace('object ', '');
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return '[Circular ~]';
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    var normalized = Array.isArray(value) ? [] : {};
    var numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    var visitable = (0, $gkmq5.isError)(value) || (0, $gkmq5.isEvent)(value) ? (0, $1l3DN.convertToPlainObject)(value) : value;
    for(var visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = '[MaxProperties ~]';
            break;
        }
        // Recursively visit all the child nodes
        var visitValue = visitable[visitKey];
        normalized[visitKey] = $1b9c3fa19e940880$export$588732934346abbf(visitKey, visitValue, depth - 1, maxProperties, memo);
        numAdded += 1;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $1b9c3fa19e940880$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === 'domain' && value && typeof value === 'object' && value._events) return '[Domain]';
        if (key === 'domainEmitter') return '[DomainEmitter]';
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== 'undefined' && value === $parcel$global) return '[Global]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== 'undefined' && value === window) return '[Window]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== 'undefined' && value === document) return '[Document]';
        // React's SyntheticEvent thingy
        if ((0, $gkmq5.isSyntheticEvent)(value)) return '[SyntheticEvent]';
        if (typeof value === 'number' && value !== value) return '[NaN]';
        // this catches `undefined` (but not `null`, which is a primitive and can be serialized on its own)
        if (value === void 0) return '[undefined]';
        if (typeof value === 'function') return "[Function: " + (0, $aNkwr.getFunctionName)(value) + "]";
        if (typeof value === 'symbol') return "[" + String(value) + "]";
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === 'bigint') return "[BigInt: " + String(value) + "]";
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        return "[object " + Object.getPrototypeOf(value).constructor.name + "]";
    } catch (err) {
        return "**non-serializable** (" + err + ")";
    }
}
/** Calculates bytes size of input string */ function $1b9c3fa19e940880$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ function $1b9c3fa19e940880$var$jsonSize(value) {
    return $1b9c3fa19e940880$var$utf8Length(JSON.stringify(value));
}

});
parcelRegister("377JV", function(module, exports) {

$parcel$export(module.exports, "memoBuilder", () => $24480783204ac77c$export$8115b0b78e956ab3);
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Helper to decycle json objects
 */ function $24480783204ac77c$export$8115b0b78e956ab3() {
    var hasWeakSet = typeof WeakSet === 'function';
    var inner = hasWeakSet ? new WeakSet() : [];
    function memoize(obj) {
        if (hasWeakSet) {
            if (inner.has(obj)) return true;
            inner.add(obj);
            return false;
        }
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for(var i = 0; i < inner.length; i++){
            var value = inner[i];
            if (value === obj) return true;
        }
        inner.push(obj);
        return false;
    }
    function unmemoize(obj) {
        if (hasWeakSet) inner.delete(obj);
        else {
            for(var i = 0; i < inner.length; i++)if (inner[i] === obj) {
                inner.splice(i, 1);
                break;
            }
        }
    }
    return [
        memoize,
        unmemoize
    ];
}

});


parcelRegister("9aaXP", function(module, exports) {

$parcel$export(module.exports, "makePromiseBuffer", () => $6abd8d736a42b85d$export$85a4f67f852183e6);

var $b17Q6 = parcelRequire("b17Q6");

var $3X7U8 = parcelRequire("3X7U8");
function $6abd8d736a42b85d$export$85a4f67f852183e6(limit) {
    var buffer = [];
    function isReady() {
        return limit === undefined || buffer.length < limit;
    }
    /**
     * Remove a promise from the queue.
     *
     * @param task Can be any PromiseLike<T>
     * @returns Removed promise.
     */ function remove(task) {
        return buffer.splice(buffer.indexOf(task), 1)[0];
    }
    /**
     * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
     *
     * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
     *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
     *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
     *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
     *        limit check.
     * @returns The original promise.
     */ function add(taskProducer) {
        if (!isReady()) return (0, $3X7U8.rejectedSyncPromise)(new (0, $b17Q6.SentryError)('Not adding Promise due to buffer limit reached.'));
        // start the task and add its promise to the queue
        var task = taskProducer();
        if (buffer.indexOf(task) === -1) buffer.push(task);
        task.then(function() {
            return remove(task);
        })// Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
        // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
        // have promises, so TS has to polyfill when down-compiling.)
        .then(null, function() {
            return remove(task).then(null, function() {
            // We have to add another catch here because `remove()` starts a new promise chain.
            });
        });
        return task;
    }
    /**
     * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
     *
     * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
     * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
     * `true`.
     * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
     * `false` otherwise
     */ function drain(timeout) {
        return new (0, $3X7U8.SyncPromise)(function(resolve, reject) {
            var counter = buffer.length;
            if (!counter) return resolve(true);
            // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
            var capturedSetTimeout = setTimeout(function() {
                if (timeout && timeout > 0) resolve(false);
            }, timeout);
            // if all promises resolve in time, cancel the timer and resolve to `true`
            buffer.forEach(function(item) {
                (0, $3X7U8.resolvedSyncPromise)(item).then(function() {
                    // eslint-disable-next-line no-plusplus
                    if (!--counter) {
                        clearTimeout(capturedSetTimeout);
                        resolve(true);
                    }
                }, reject);
            });
        });
    }
    return {
        $: buffer,
        add: add,
        drain: drain
    };
}

});
parcelRegister("3X7U8", function(module, exports) {

$parcel$export(module.exports, "resolvedSyncPromise", () => $2e0d03738c27a94c$export$1fda8aa4d135f8aa);
$parcel$export(module.exports, "SyncPromise", () => $2e0d03738c27a94c$export$6f292d4960313241);
$parcel$export(module.exports, "rejectedSyncPromise", () => $2e0d03738c27a94c$export$78e43115b553f358);
/* eslint-disable @typescript-eslint/explicit-function-return-type */ /* eslint-disable @typescript-eslint/typedef */ /* eslint-disable @typescript-eslint/explicit-module-boundary-types */ /* eslint-disable @typescript-eslint/no-explicit-any */ 
var $gkmq5 = parcelRequire("gkmq5");
function $2e0d03738c27a94c$export$1fda8aa4d135f8aa(value) {
    return new $2e0d03738c27a94c$export$6f292d4960313241(function(resolve) {
        resolve(value);
    });
}
function $2e0d03738c27a94c$export$78e43115b553f358(reason) {
    return new $2e0d03738c27a94c$export$6f292d4960313241(function(_, reject) {
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ var $2e0d03738c27a94c$export$6f292d4960313241 = /** @class */ function() {
    function SyncPromise(executor) {
        var _this = this;
        this._state = 0 /* PENDING */ ;
        this._handlers = [];
        /** JSDoc */ this._resolve = function(value) {
            _this._setResult(1 /* RESOLVED */ , value);
        };
        /** JSDoc */ this._reject = function(reason) {
            _this._setResult(2 /* REJECTED */ , reason);
        };
        /** JSDoc */ this._setResult = function(state, value) {
            if (_this._state !== 0 /* PENDING */ ) return;
            if ((0, $gkmq5.isThenable)(value)) {
                value.then(_this._resolve, _this._reject);
                return;
            }
            _this._state = state;
            _this._value = value;
            _this._executeHandlers();
        };
        /** JSDoc */ this._executeHandlers = function() {
            if (_this._state === 0 /* PENDING */ ) return;
            var cachedHandlers = _this._handlers.slice();
            _this._handlers = [];
            cachedHandlers.forEach(function(handler) {
                if (handler[0]) return;
                if (_this._state === 1 /* RESOLVED */ ) // eslint-disable-next-line @typescript-eslint/no-floating-promises
                handler[1](_this._value);
                if (_this._state === 2 /* REJECTED */ ) handler[2](_this._value);
                handler[0] = true;
            });
        };
        try {
            executor(this._resolve, this._reject);
        } catch (e) {
            this._reject(e);
        }
    }
    /** JSDoc */ SyncPromise.prototype.then = function(onfulfilled, onrejected) {
        var _this = this;
        return new SyncPromise(function(resolve, reject) {
            _this._handlers.push([
                false,
                function(result) {
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                function(reason) {
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            _this._executeHandlers();
        });
    };
    /** JSDoc */ SyncPromise.prototype.catch = function(onrejected) {
        return this.then(function(val) {
            return val;
        }, onrejected);
    };
    /** JSDoc */ SyncPromise.prototype.finally = function(onfinally) {
        var _this = this;
        return new SyncPromise(function(resolve, reject) {
            var val;
            var isRejected;
            return _this.then(function(value) {
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, function(reason) {
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(function() {
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    };
    return SyncPromise;
}();

});


parcelRegister("n3F4l", function(module, exports) {

$parcel$export(module.exports, "severityFromString", () => $0454fd2cf9d26b9d$export$e01cef29b4327697);

var $4aybe = parcelRequire("4aybe");

var $7UEZR = parcelRequire("7UEZR");
function $0454fd2cf9d26b9d$var$isSupportedSeverity(level) {
    return (0, $7UEZR.SeverityLevels).indexOf(level) !== -1;
}
function $0454fd2cf9d26b9d$export$e01cef29b4327697(level) {
    if (level === 'warn') return (0, $4aybe.Severity).Warning;
    if ($0454fd2cf9d26b9d$var$isSupportedSeverity(level)) return level;
    return (0, $4aybe.Severity).Log;
}

});
parcelRegister("4aybe", function(module, exports) {

$parcel$export(module.exports, "Severity", () => $30929c0b26d77527$export$918a9776c0a3cf27);
/**
 * TODO(v7): Remove this enum and replace with SeverityLevel
 */ var $30929c0b26d77527$export$918a9776c0a3cf27;
(function(Severity) {
    /** JSDoc */ Severity["Fatal"] = "fatal";
    /** JSDoc */ Severity["Error"] = "error";
    /** JSDoc */ Severity["Warning"] = "warning";
    /** JSDoc */ Severity["Log"] = "log";
    /** JSDoc */ Severity["Info"] = "info";
    /** JSDoc */ Severity["Debug"] = "debug";
    /** JSDoc */ Severity["Critical"] = "critical";
})($30929c0b26d77527$export$918a9776c0a3cf27 || ($30929c0b26d77527$export$918a9776c0a3cf27 = {}));
var $30929c0b26d77527$export$484b1ea9aec914c = [
    'fatal',
    'error',
    'warning',
    'log',
    'info',
    'debug',
    'critical'
];

});

parcelRegister("7UEZR", function(module, exports) {

$parcel$export(module.exports, "SeverityLevels", () => $5c2d9075c2497ee3$export$484b1ea9aec914c);
var $5c2d9075c2497ee3$export$484b1ea9aec914c = [
    'fatal',
    'error',
    'warning',
    'log',
    'info',
    'debug',
    'critical'
];

});


parcelRegister("aGIlP", function(module, exports) {

$parcel$export(module.exports, "eventStatusFromHttpCode", () => $7c803ad63297ed5d$export$82713360d763c449);
/**
 * Converts an HTTP status code to sentry status {@link EventStatus}.
 *
 * @param code number HTTP status code
 * @returns EventStatus
 */ function $7c803ad63297ed5d$export$82713360d763c449(code) {
    if (code >= 200 && code < 300) return 'success';
    if (code === 429) return 'rate_limit';
    if (code >= 400 && code < 500) return 'invalid';
    if (code >= 500) return 'failed';
    return 'unknown';
}

});

parcelRegister("eHWqV", function(module, exports) {

$parcel$export(module.exports, "dateTimestampInSeconds", () => dateTimestampInSeconds, (v) => dateTimestampInSeconds = v);

var $35A7f = parcelRequire("35A7f");

var $9UV3v = parcelRequire("9UV3v");
/**
 * A TimestampSource implementation for environments that do not support the Performance Web API natively.
 *
 * Note that this TimestampSource does not use a monotonic clock. A call to `nowSeconds` may return a timestamp earlier
 * than a previously returned value. We do not try to emulate a monotonic behavior in order to facilitate debugging. It
 * is more obvious to explain "why does my span have negative duration" than "why my spans have zero duration".
 */ var dateTimestampSource = {
    nowSeconds: function() {
        return Date.now() / 1000;
    }
};
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function getBrowserPerformance() {
    var performance = (0, $35A7f.getGlobalObject)().performance;
    if (!performance || !performance.now) return undefined;
    // Replace performance.timeOrigin with our own timeOrigin based on Date.now().
    //
    // This is a partial workaround for browsers reporting performance.timeOrigin such that performance.timeOrigin +
    // performance.now() gives a date arbitrarily in the past.
    //
    // Additionally, computing timeOrigin in this way fills the gap for browsers where performance.timeOrigin is
    // undefined.
    //
    // The assumption that performance.timeOrigin + performance.now() ~= Date.now() is flawed, but we depend on it to
    // interact with data coming out of performance entries.
    //
    // Note that despite recommendations against it in the spec, browsers implement the Performance API with a clock that
    // might stop when the computer is asleep (and perhaps under other circumstances). Such behavior causes
    // performance.timeOrigin + performance.now() to have an arbitrary skew over Date.now(). In laptop computers, we have
    // observed skews that can be as long as days, weeks or months.
    //
    // See https://github.com/getsentry/sentry-javascript/issues/2590.
    //
    // BUG: despite our best intentions, this workaround has its limitations. It mostly addresses timings of pageload
    // transactions, but ignores the skew built up over time that can aversely affect timestamps of navigation
    // transactions of long-lived web pages.
    var timeOrigin = Date.now() - performance.now();
    return {
        now: function() {
            return performance.now();
        },
        timeOrigin: timeOrigin
    };
}
/**
 * Returns the native Performance API implementation from Node.js. Returns undefined in old Node.js versions that don't
 * implement the API.
 */ function getNodePerformance() {
    try {
        var perfHooks = (0, $9UV3v.dynamicRequire)(module, 'perf_hooks');
        return perfHooks.performance;
    } catch (_) {
        return undefined;
    }
}
/**
 * The Performance API implementation for the current platform, if available.
 */ var platformPerformance = (0, $9UV3v.isNodeEnv)() ? getNodePerformance() : getBrowserPerformance();
var timestampSource = platformPerformance === undefined ? dateTimestampSource : {
    nowSeconds: function() {
        return (platformPerformance.timeOrigin + platformPerformance.now()) / 1000;
    }
};
var dateTimestampInSeconds = dateTimestampSource.nowSeconds.bind(dateTimestampSource);
var timestampInSeconds = timestampSource.nowSeconds.bind(timestampSource);
var timestampWithMs = timestampInSeconds;
var usingPerformanceAPI = platformPerformance !== undefined;
var _browserPerformanceTimeOriginMode;
var browserPerformanceTimeOrigin = function() {
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    var performance = (0, $35A7f.getGlobalObject)().performance;
    if (!performance || !performance.now) {
        _browserPerformanceTimeOriginMode = 'none';
        return undefined;
    }
    var threshold = 3600000;
    var performanceNow = performance.now();
    var dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    var timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    var timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    var navigationStart = performance.timing && performance.timing.navigationStart;
    var hasNavigationStart = typeof navigationStart === 'number';
    // if navigationStart isn't available set delta to threshold so it isn't used
    var navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    var navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            _browserPerformanceTimeOriginMode = 'timeOrigin';
            return performance.timeOrigin;
        } else {
            _browserPerformanceTimeOriginMode = 'navigationStart';
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    _browserPerformanceTimeOriginMode = 'dateNow';
    return dateNow;
}();

});

parcelRegister("e1x9C", function(module, exports) {

$parcel$export(module.exports, "createEnvelope", () => $a35ae061efedcb1a$export$f93f7f385160c44e);
$parcel$export(module.exports, "getEnvelopeType", () => $a35ae061efedcb1a$export$d84939284bbafcd4);
$parcel$export(module.exports, "serializeEnvelope", () => $a35ae061efedcb1a$export$32f9b428425aac85);

var $3VFsf = parcelRequire("3VFsf");

var $gkmq5 = parcelRequire("gkmq5");
function $a35ae061efedcb1a$export$f93f7f385160c44e(headers, items) {
    if (items === void 0) items = [];
    return [
        headers,
        items
    ];
}
function $a35ae061efedcb1a$export$d650323442802f6f(envelope, newItem) {
    var _a = (0, $3VFsf.__read)(envelope, 2), headers = _a[0], items = _a[1];
    return [
        headers,
        (0, $3VFsf.__spread)(items, [
            newItem
        ])
    ];
}
function $a35ae061efedcb1a$export$d84939284bbafcd4(envelope) {
    var _a = (0, $3VFsf.__read)(envelope, 2), _b = (0, $3VFsf.__read)(_a[1], 1), _c = (0, $3VFsf.__read)(_b[0], 1), firstItemHeader = _c[0];
    return firstItemHeader.type;
}
function $a35ae061efedcb1a$export$32f9b428425aac85(envelope) {
    var _a = (0, $3VFsf.__read)(envelope, 2), headers = _a[0], items = _a[1];
    var serializedHeaders = JSON.stringify(headers);
    // Have to cast items to any here since Envelope is a union type
    // Fixed in Typescript 4.2
    // TODO: Remove any[] cast when we upgrade to TS 4.2
    // https://github.com/microsoft/TypeScript/issues/36390
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return items.reduce(function(acc, item) {
        var _a = (0, $3VFsf.__read)(item, 2), itemHeaders = _a[0], payload = _a[1];
        // We do not serialize payloads that are primitives
        var serializedPayload = (0, $gkmq5.isPrimitive)(payload) ? String(payload) : JSON.stringify(payload);
        return acc + "\n" + JSON.stringify(itemHeaders) + "\n" + serializedPayload;
    }, serializedHeaders);
}

});

parcelRegister("jk0Xn", function(module, exports) {

$parcel$export(module.exports, "createClientReportEnvelope", () => $e110a091c483d2cf$export$f3b9ed77c03eeb00);

var $e1x9C = parcelRequire("e1x9C");

var $eHWqV = parcelRequire("eHWqV");
function $e110a091c483d2cf$export$f3b9ed77c03eeb00(discarded_events, dsn, timestamp) {
    var clientReportItem = [
        {
            type: 'client_report'
        },
        {
            timestamp: timestamp || (0, $eHWqV.dateTimestampInSeconds)(),
            discarded_events: discarded_events
        }
    ];
    return (0, $e1x9C.createEnvelope)(dsn ? {
        dsn: dsn
    } : {}, [
        clientReportItem
    ]);
}

});

parcelRegister("2rF5w", function(module, exports) {

$parcel$export(module.exports, "disabledUntil", () => $1c7df99b82793dbb$export$b89fc7b2e4c799e7);
$parcel$export(module.exports, "isRateLimited", () => $1c7df99b82793dbb$export$6c91fec22056810a);
$parcel$export(module.exports, "updateRateLimits", () => $1c7df99b82793dbb$export$699aff705e0d49d4);

var $3VFsf = parcelRequire("3VFsf");
var $1c7df99b82793dbb$export$b09ce39faaeb1e7c = 60000; // 60 seconds
function $1c7df99b82793dbb$export$615352e17ed7741(header, now) {
    if (now === void 0) now = Date.now();
    var headerDelay = parseInt("" + header, 10);
    if (!isNaN(headerDelay)) return headerDelay * 1000;
    var headerDate = Date.parse("" + header);
    if (!isNaN(headerDate)) return headerDate - now;
    return $1c7df99b82793dbb$export$b09ce39faaeb1e7c;
}
function $1c7df99b82793dbb$export$b89fc7b2e4c799e7(limits, category) {
    return limits[category] || limits.all || 0;
}
function $1c7df99b82793dbb$export$6c91fec22056810a(limits, category, now) {
    if (now === void 0) now = Date.now();
    return $1c7df99b82793dbb$export$b89fc7b2e4c799e7(limits, category) > now;
}
function $1c7df99b82793dbb$export$699aff705e0d49d4(limits, headers, now) {
    var e_1, _a, e_2, _b;
    if (now === void 0) now = Date.now();
    var updatedRateLimits = (0, $3VFsf.__assign)({}, limits);
    // "The name is case-insensitive."
    // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
    var rateLimitHeader = headers['x-sentry-rate-limits'];
    var retryAfterHeader = headers['retry-after'];
    if (rateLimitHeader) try {
        /**
             * rate limit headers are of the form
             *     <header>,<header>,..
             * where each <header> is of the form
             *     <retry_after>: <categories>: <scope>: <reason_code>
             * where
             *     <retry_after> is a delay in seconds
             *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
             *         <category>;<category>;...
             *     <scope> is what's being limited (org, project, or key) - ignored by SDK
             *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
             */ for(var _c = (0, $3VFsf.__values)(rateLimitHeader.trim().split(',')), _d = _c.next(); !_d.done; _d = _c.next()){
            var limit = _d.value;
            var parameters = limit.split(':', 2);
            var headerDelay = parseInt(parameters[0], 10);
            var delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
            if (!parameters[1]) updatedRateLimits.all = now + delay;
            else try {
                for(var _e = (e_2 = void 0, (0, $3VFsf.__values)(parameters[1].split(';'))), _f = _e.next(); !_f.done; _f = _e.next()){
                    var category = _f.value;
                    updatedRateLimits[category] = now + delay;
                }
            } catch (e_2_1) {
                e_2 = {
                    error: e_2_1
                };
            } finally{
                try {
                    if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                } finally{
                    if (e_2) throw e_2.error;
                }
            }
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + $1c7df99b82793dbb$export$615352e17ed7741(retryAfterHeader, now);
    return updatedRateLimits;
}

});


parcelRegister("aEGcl", function(module, exports) {

$parcel$export(module.exports, "IS_DEBUG_BUILD", () => $7c1e5f737e2182ad$export$48a8984ec0bf2e44);
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */ /** Flag that is true for debug builds, false otherwise. */ var $7c1e5f737e2182ad$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;

});


parcelRegister("hK2IQ", function(module, exports) {

$parcel$export(module.exports, "FunctionToString", () => (parcelRequire("dRmVN")).FunctionToString);
$parcel$export(module.exports, "InboundFilters", () => (parcelRequire("7TVcb")).InboundFilters);

var $dRmVN = parcelRequire("dRmVN");

var $7TVcb = parcelRequire("7TVcb");

});
parcelRegister("dRmVN", function(module, exports) {

$parcel$export(module.exports, "FunctionToString", () => $a172034355d26ef7$export$da4704525c20ae79);
parcelRequire("8KVVB");
var $1l3DN = parcelRequire("1l3DN");
var $a172034355d26ef7$var$originalFunctionToString;
/** Patch toString calls to return proper name for wrapped functions */ var $a172034355d26ef7$export$da4704525c20ae79 = /** @class */ function() {
    function FunctionToString() {
        /**
         * @inheritDoc
         */ this.name = FunctionToString.id;
    }
    /**
     * @inheritDoc
     */ FunctionToString.prototype.setupOnce = function() {
        // eslint-disable-next-line @typescript-eslint/unbound-method
        $a172034355d26ef7$var$originalFunctionToString = Function.prototype.toString;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Function.prototype.toString = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var context = (0, $1l3DN.getOriginalFunction)(this) || this;
            return $a172034355d26ef7$var$originalFunctionToString.apply(context, args);
        };
    };
    /**
     * @inheritDoc
     */ FunctionToString.id = 'FunctionToString';
    return FunctionToString;
}();

});

parcelRegister("7TVcb", function(module, exports) {

$parcel$export(module.exports, "InboundFilters", () => $5c0a0947fc55720e$export$2ffbb5359dcc6be4);

var $3VFsf = parcelRequire("3VFsf");
parcelRequire("8KVVB");
var $jyUiA = parcelRequire("jyUiA");
var $jOwKr = parcelRequire("jOwKr");
var $4geCF = parcelRequire("4geCF");

var $aEGcl = parcelRequire("aEGcl");
// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
var $5c0a0947fc55720e$var$DEFAULT_IGNORE_ERRORS = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/
];
/** Inbound filters configurable by the user */ var $5c0a0947fc55720e$export$2ffbb5359dcc6be4 = /** @class */ function() {
    function InboundFilters(_options) {
        if (_options === void 0) _options = {};
        this._options = _options;
        /**
         * @inheritDoc
         */ this.name = InboundFilters.id;
    }
    /**
     * @inheritDoc
     */ InboundFilters.prototype.setupOnce = function(addGlobalEventProcessor, getCurrentHub) {
        addGlobalEventProcessor(function(event) {
            var hub = getCurrentHub();
            if (hub) {
                var self_1 = hub.getIntegration(InboundFilters);
                if (self_1) {
                    var client = hub.getClient();
                    var clientOptions = client ? client.getOptions() : {};
                    var options = $5c0a0947fc55720e$export$6620a151868b99aa(self_1._options, clientOptions);
                    return $5c0a0947fc55720e$export$3c6361fddf6cd929(event, options) ? null : event;
                }
            }
            return event;
        });
    };
    /**
     * @inheritDoc
     */ InboundFilters.id = 'InboundFilters';
    return InboundFilters;
}();
function $5c0a0947fc55720e$export$6620a151868b99aa(internalOptions, clientOptions) {
    if (internalOptions === void 0) internalOptions = {};
    if (clientOptions === void 0) clientOptions = {};
    return {
        allowUrls: (0, $3VFsf.__spread)(internalOptions.whitelistUrls || [], internalOptions.allowUrls || [], clientOptions.whitelistUrls || [], clientOptions.allowUrls || []),
        denyUrls: (0, $3VFsf.__spread)(internalOptions.blacklistUrls || [], internalOptions.denyUrls || [], clientOptions.blacklistUrls || [], clientOptions.denyUrls || []),
        ignoreErrors: (0, $3VFsf.__spread)(internalOptions.ignoreErrors || [], clientOptions.ignoreErrors || [], $5c0a0947fc55720e$var$DEFAULT_IGNORE_ERRORS),
        ignoreInternal: internalOptions.ignoreInternal !== undefined ? internalOptions.ignoreInternal : true
    };
}
function $5c0a0947fc55720e$export$3c6361fddf6cd929(event, options) {
    if (options.ignoreInternal && $5c0a0947fc55720e$var$_isSentryError(event)) {
        (0, $aEGcl.IS_DEBUG_BUILD) && (0, $4geCF.logger).warn("Event dropped due to being internal Sentry Error.\nEvent: " + (0, $jyUiA.getEventDescription)(event));
        return true;
    }
    if ($5c0a0947fc55720e$var$_isIgnoredError(event, options.ignoreErrors)) {
        (0, $aEGcl.IS_DEBUG_BUILD) && (0, $4geCF.logger).warn("Event dropped due to being matched by `ignoreErrors` option.\nEvent: " + (0, $jyUiA.getEventDescription)(event));
        return true;
    }
    if ($5c0a0947fc55720e$var$_isDeniedUrl(event, options.denyUrls)) {
        (0, $aEGcl.IS_DEBUG_BUILD) && (0, $4geCF.logger).warn("Event dropped due to being matched by `denyUrls` option.\nEvent: " + (0, $jyUiA.getEventDescription)(event) + ".\nUrl: " + $5c0a0947fc55720e$var$_getEventFilterUrl(event));
        return true;
    }
    if (!$5c0a0947fc55720e$var$_isAllowedUrl(event, options.allowUrls)) {
        (0, $aEGcl.IS_DEBUG_BUILD) && (0, $4geCF.logger).warn("Event dropped due to not being matched by `allowUrls` option.\nEvent: " + (0, $jyUiA.getEventDescription)(event) + ".\nUrl: " + $5c0a0947fc55720e$var$_getEventFilterUrl(event));
        return true;
    }
    return false;
}
function $5c0a0947fc55720e$var$_isIgnoredError(event, ignoreErrors) {
    if (!ignoreErrors || !ignoreErrors.length) return false;
    return $5c0a0947fc55720e$var$_getPossibleEventMessages(event).some(function(message) {
        return ignoreErrors.some(function(pattern) {
            return (0, $jOwKr.isMatchingPattern)(message, pattern);
        });
    });
}
function $5c0a0947fc55720e$var$_isDeniedUrl(event, denyUrls) {
    // TODO: Use Glob instead?
    if (!denyUrls || !denyUrls.length) return false;
    var url = $5c0a0947fc55720e$var$_getEventFilterUrl(event);
    return !url ? false : denyUrls.some(function(pattern) {
        return (0, $jOwKr.isMatchingPattern)(url, pattern);
    });
}
function $5c0a0947fc55720e$var$_isAllowedUrl(event, allowUrls) {
    // TODO: Use Glob instead?
    if (!allowUrls || !allowUrls.length) return true;
    var url = $5c0a0947fc55720e$var$_getEventFilterUrl(event);
    return !url ? true : allowUrls.some(function(pattern) {
        return (0, $jOwKr.isMatchingPattern)(url, pattern);
    });
}
function $5c0a0947fc55720e$var$_getPossibleEventMessages(event) {
    if (event.message) return [
        event.message
    ];
    if (event.exception) try {
        var _a = event.exception.values && event.exception.values[0] || {}, _b = _a.type, type = _b === void 0 ? '' : _b, _c = _a.value, value = _c === void 0 ? '' : _c;
        return [
            "" + value,
            type + ": " + value
        ];
    } catch (oO) {
        (0, $aEGcl.IS_DEBUG_BUILD) && (0, $4geCF.logger).error("Cannot extract message for event " + (0, $jyUiA.getEventDescription)(event));
        return [];
    }
    return [];
}
function $5c0a0947fc55720e$var$_isSentryError(event) {
    try {
        // @ts-ignore can't be a sentry error if undefined
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return event.exception.values[0].type === 'SentryError';
    } catch (e) {
    // ignore
    }
    return false;
}
function $5c0a0947fc55720e$var$_getLastValidUrl(frames) {
    if (frames === void 0) frames = [];
    for(var i = frames.length - 1; i >= 0; i--){
        var frame = frames[i];
        if (frame && frame.filename !== '<anonymous>' && frame.filename !== '[native code]') return frame.filename || null;
    }
    return null;
}
function $5c0a0947fc55720e$var$_getEventFilterUrl(event) {
    try {
        if (event.stacktrace) return $5c0a0947fc55720e$var$_getLastValidUrl(event.stacktrace.frames);
        var frames_1;
        try {
            // @ts-ignore we only care about frames if the whole thing here is defined
            frames_1 = event.exception.values[0].stacktrace.frames;
        } catch (e) {
        // ignore
        }
        return frames_1 ? $5c0a0947fc55720e$var$_getLastValidUrl(frames_1) : null;
    } catch (oO) {
        (0, $aEGcl.IS_DEBUG_BUILD) && (0, $4geCF.logger).error("Cannot extract url for event " + (0, $jyUiA.getEventDescription)(event));
        return null;
    }
}

});


parcelRegister("3pmgQ", function(module, exports) {

$parcel$export(module.exports, "BrowserClient", () => $27b4fb6362ae1f2a$export$1df9218a526d318d);

var $3VFsf = parcelRequire("3VFsf");

var $4mR0v = parcelRequire("4mR0v");
var $f1FVh = parcelRequire("f1FVh");
parcelRequire("8KVVB");
var $35A7f = parcelRequire("35A7f");
var $4geCF = parcelRequire("4geCF");

var $7bB5K = parcelRequire("7bB5K");

var $l97zN = parcelRequire("l97zN");

var $9aSEL = parcelRequire("9aSEL");

var $5Z1NC = parcelRequire("5Z1NC");
/**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */ var $27b4fb6362ae1f2a$export$1df9218a526d318d = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(BrowserClient, _super);
    /**
     * Creates a new Browser SDK instance.
     *
     * @param options Configuration options for this SDK.
     */ function BrowserClient(options) {
        if (options === void 0) options = {};
        var _this = this;
        options._metadata = options._metadata || {};
        options._metadata.sdk = options._metadata.sdk || {
            name: 'sentry.javascript.browser',
            packages: [
                {
                    name: 'npm:@sentry/browser',
                    version: (0, $f1FVh.SDK_VERSION)
                }
            ],
            version: (0, $f1FVh.SDK_VERSION)
        };
        _this = _super.call(this, (0, $7bB5K.BrowserBackend), options) || this;
        return _this;
    }
    /**
     * Show a report dialog to the user to send feedback to a specific event.
     *
     * @param options Set individual options for the dialog
     */ BrowserClient.prototype.showReportDialog = function(options) {
        if (options === void 0) options = {};
        // doesn't work without a document (React Native)
        var document = (0, $35A7f.getGlobalObject)().document;
        if (!document) return;
        if (!this._isEnabled()) {
            (0, $l97zN.IS_DEBUG_BUILD) && (0, $4geCF.logger).error('Trying to call showReportDialog with Sentry Client disabled');
            return;
        }
        (0, $9aSEL.injectReportDialog)((0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, options), {
            dsn: options.dsn || this.getDsn()
        }));
    };
    /**
     * @inheritDoc
     */ BrowserClient.prototype._prepareEvent = function(event, scope, hint) {
        event.platform = event.platform || 'javascript';
        return _super.prototype._prepareEvent.call(this, event, scope, hint);
    };
    /**
     * @inheritDoc
     */ BrowserClient.prototype._sendEvent = function(event) {
        var integration = this.getIntegration((0, $5Z1NC.Breadcrumbs));
        if (integration) integration.addSentryBreadcrumb(event);
        _super.prototype._sendEvent.call(this, event);
    };
    return BrowserClient;
}((0, $4mR0v.BaseClient));

});
parcelRegister("4mR0v", function(module, exports) {

$parcel$export(module.exports, "BaseClient", () => $32e2559d400632fa$export$4f22f74eddb7716a);

var $3VFsf = parcelRequire("3VFsf");

var $gfYRq = parcelRequire("gfYRq");
parcelRequire("8KVVB");
var $jyUiA = parcelRequire("jyUiA");
var $eHWqV = parcelRequire("eHWqV");
var $gkmq5 = parcelRequire("gkmq5");
var $4geCF = parcelRequire("4geCF");
var $gSiM6 = parcelRequire("gSiM6");
var $2mY5H = parcelRequire("2mY5H");
var $3X7U8 = parcelRequire("3X7U8");
var $b17Q6 = parcelRequire("b17Q6");
var $jOwKr = parcelRequire("jOwKr");

var $aEGcl = parcelRequire("aEGcl");

var $6WKyI = parcelRequire("6WKyI");
var $32e2559d400632fa$var$ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding backend constructor and options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}. Also, the Backend instance is available via
 * {@link Client.getBackend}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event via the backend, it is passed through
 * {@link BaseClient._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeBackend, NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(NodeBackend, options);
 *   }
 *
 *   // ...
 * }
 */ var $32e2559d400632fa$export$4f22f74eddb7716a = /** @class */ function() {
    /**
     * Initializes this client instance.
     *
     * @param backendClass A constructor function to create the backend.
     * @param options Options for the client.
     */ function BaseClient(backendClass, options) {
        /** Array of used integrations. */ this._integrations = {};
        /** Number of calls being processed */ this._numProcessing = 0;
        this._backend = new backendClass(options);
        this._options = options;
        if (options.dsn) this._dsn = (0, $gSiM6.makeDsn)(options.dsn);
    }
    /**
     * @inheritDoc
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    BaseClient.prototype.captureException = function(exception, hint, scope) {
        var _this = this;
        // ensure we haven't captured this very object before
        if ((0, $jyUiA.checkOrSetAlreadyCaught)(exception)) {
            (0, $aEGcl.IS_DEBUG_BUILD) && (0, $4geCF.logger).log($32e2559d400632fa$var$ALREADY_SEEN_ERROR);
            return;
        }
        var eventId = hint && hint.event_id;
        this._process(this._getBackend().eventFromException(exception, hint).then(function(event) {
            return _this._captureEvent(event, hint, scope);
        }).then(function(result) {
            eventId = result;
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.captureMessage = function(message, level, hint, scope) {
        var _this = this;
        var eventId = hint && hint.event_id;
        var promisedEvent = (0, $gkmq5.isPrimitive)(message) ? this._getBackend().eventFromMessage(String(message), level, hint) : this._getBackend().eventFromException(message, hint);
        this._process(promisedEvent.then(function(event) {
            return _this._captureEvent(event, hint, scope);
        }).then(function(result) {
            eventId = result;
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.captureEvent = function(event, hint, scope) {
        // ensure we haven't captured this very object before
        if (hint && hint.originalException && (0, $jyUiA.checkOrSetAlreadyCaught)(hint.originalException)) {
            (0, $aEGcl.IS_DEBUG_BUILD) && (0, $4geCF.logger).log($32e2559d400632fa$var$ALREADY_SEEN_ERROR);
            return;
        }
        var eventId = hint && hint.event_id;
        this._process(this._captureEvent(event, hint, scope).then(function(result) {
            eventId = result;
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.captureSession = function(session) {
        if (!this._isEnabled()) {
            (0, $aEGcl.IS_DEBUG_BUILD) && (0, $4geCF.logger).warn('SDK not enabled, will not capture session.');
            return;
        }
        if (!(typeof session.release === 'string')) (0, $aEGcl.IS_DEBUG_BUILD) && (0, $4geCF.logger).warn('Discarded session because of missing or non-string release');
        else {
            this._sendSession(session);
            // After sending, we set init false to indicate it's not the first occurrence
            session.update({
                init: false
            });
        }
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.getDsn = function() {
        return this._dsn;
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.getOptions = function() {
        return this._options;
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.getTransport = function() {
        return this._getBackend().getTransport();
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.flush = function(timeout) {
        var _this = this;
        return this._isClientDoneProcessing(timeout).then(function(clientFinished) {
            return _this.getTransport().close(timeout).then(function(transportFlushed) {
                return clientFinished && transportFlushed;
            });
        });
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.close = function(timeout) {
        var _this = this;
        return this.flush(timeout).then(function(result) {
            _this.getOptions().enabled = false;
            return result;
        });
    };
    /**
     * Sets up the integrations
     */ BaseClient.prototype.setupIntegrations = function() {
        if (this._isEnabled() && !this._integrations.initialized) this._integrations = (0, $6WKyI.setupIntegrations)(this._options);
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.getIntegration = function(integration) {
        try {
            return this._integrations[integration.id] || null;
        } catch (_oO) {
            (0, $aEGcl.IS_DEBUG_BUILD) && (0, $4geCF.logger).warn("Cannot retrieve integration " + integration.id + " from the current Client");
            return null;
        }
    };
    /** Updates existing session based on the provided event */ BaseClient.prototype._updateSessionFromEvent = function(session, event) {
        var e_1, _a;
        var crashed = false;
        var errored = false;
        var exceptions = event.exception && event.exception.values;
        if (exceptions) {
            errored = true;
            try {
                for(var exceptions_1 = (0, $3VFsf.__values)(exceptions), exceptions_1_1 = exceptions_1.next(); !exceptions_1_1.done; exceptions_1_1 = exceptions_1.next()){
                    var ex = exceptions_1_1.value;
                    var mechanism = ex.mechanism;
                    if (mechanism && mechanism.handled === false) {
                        crashed = true;
                        break;
                    }
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (exceptions_1_1 && !exceptions_1_1.done && (_a = exceptions_1.return)) _a.call(exceptions_1);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
        }
        // A session is updated and that session update is sent in only one of the two following scenarios:
        // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
        // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
        var sessionNonTerminal = session.status === 'ok';
        var shouldUpdateAndSend = sessionNonTerminal && session.errors === 0 || sessionNonTerminal && crashed;
        if (shouldUpdateAndSend) {
            session.update((0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, crashed && {
                status: 'crashed'
            }), {
                errors: session.errors || Number(errored || crashed)
            }));
            this.captureSession(session);
        }
    };
    /** Deliver captured session to Sentry */ BaseClient.prototype._sendSession = function(session) {
        this._getBackend().sendSession(session);
    };
    /**
     * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
     * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
     *
     * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
     * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
     * `true`.
     * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
     * `false` otherwise
     */ BaseClient.prototype._isClientDoneProcessing = function(timeout) {
        var _this = this;
        return new (0, $3X7U8.SyncPromise)(function(resolve) {
            var ticked = 0;
            var tick = 1;
            var interval = setInterval(function() {
                if (_this._numProcessing == 0) {
                    clearInterval(interval);
                    resolve(true);
                } else {
                    ticked += tick;
                    if (timeout && ticked >= timeout) {
                        clearInterval(interval);
                        resolve(false);
                    }
                }
            }, tick);
        });
    };
    /** Returns the current backend. */ BaseClient.prototype._getBackend = function() {
        return this._backend;
    };
    /** Determines whether this SDK is enabled and a valid Dsn is present. */ BaseClient.prototype._isEnabled = function() {
        return this.getOptions().enabled !== false && this._dsn !== undefined;
    };
    /**
     * Adds common information to events.
     *
     * The information includes release and environment from `options`,
     * breadcrumbs and context (extra, tags and user) from the scope.
     *
     * Information that is already present in the event is never overwritten. For
     * nested objects, such as the context, keys are merged.
     *
     * @param event The original event.
     * @param hint May contain additional information about the original exception.
     * @param scope A scope containing event metadata.
     * @returns A new event with more information.
     */ BaseClient.prototype._prepareEvent = function(event, scope, hint) {
        var _this = this;
        var _a = this.getOptions(), _b = _a.normalizeDepth, normalizeDepth = _b === void 0 ? 3 : _b, _c = _a.normalizeMaxBreadth, normalizeMaxBreadth = _c === void 0 ? 1000 : _c;
        var prepared = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, event), {
            event_id: event.event_id || (hint && hint.event_id ? hint.event_id : (0, $jyUiA.uuid4)()),
            timestamp: event.timestamp || (0, $eHWqV.dateTimestampInSeconds)()
        });
        this._applyClientOptions(prepared);
        this._applyIntegrationsMetadata(prepared);
        // If we have scope given to us, use it as the base for further modifications.
        // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
        var finalScope = scope;
        if (hint && hint.captureContext) finalScope = (0, $gfYRq.Scope).clone(finalScope).update(hint.captureContext);
        // We prepare the result here with a resolved Event.
        var result = (0, $3X7U8.resolvedSyncPromise)(prepared);
        // This should be the last thing called, since we want that
        // {@link Hub.addEventProcessor} gets the finished prepared event.
        if (finalScope) // In case we have a hub we reassign it.
        result = finalScope.applyToEvent(prepared, hint);
        return result.then(function(evt) {
            if (evt) // TODO this is more of the hack trying to solve https://github.com/getsentry/sentry-javascript/issues/2809
            // it is only attached as extra data to the event if the event somehow skips being normalized
            evt.sdkProcessingMetadata = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, evt.sdkProcessingMetadata), {
                normalizeDepth: (0, $2mY5H.normalize)(normalizeDepth) + " (" + typeof normalizeDepth + ")"
            });
            if (typeof normalizeDepth === 'number' && normalizeDepth > 0) return _this._normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
            return evt;
        });
    };
    /**
     * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
     * Normalized keys:
     * - `breadcrumbs.data`
     * - `user`
     * - `contexts`
     * - `extra`
     * @param event Event
     * @returns Normalized event
     */ BaseClient.prototype._normalizeEvent = function(event, depth, maxBreadth) {
        if (!event) return null;
        var normalized = (0, $3VFsf.__assign)((0, $3VFsf.__assign)((0, $3VFsf.__assign)((0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, event), event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map(function(b) {
                return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, b), b.data && {
                    data: (0, $2mY5H.normalize)(b.data, depth, maxBreadth)
                });
            })
        }), event.user && {
            user: (0, $2mY5H.normalize)(event.user, depth, maxBreadth)
        }), event.contexts && {
            contexts: (0, $2mY5H.normalize)(event.contexts, depth, maxBreadth)
        }), event.extra && {
            extra: (0, $2mY5H.normalize)(event.extra, depth, maxBreadth)
        });
        // event.contexts.trace stores information about a Transaction. Similarly,
        // event.spans[] stores information about child Spans. Given that a
        // Transaction is conceptually a Span, normalization should apply to both
        // Transactions and Spans consistently.
        // For now the decision is to skip normalization of Transactions and Spans,
        // so this block overwrites the normalized event to add back the original
        // Transaction information prior to normalization.
        if (event.contexts && event.contexts.trace) // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        normalized.contexts.trace = event.contexts.trace;
        normalized.sdkProcessingMetadata = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, normalized.sdkProcessingMetadata), {
            baseClientNormalized: true
        });
        return normalized;
    };
    /**
     *  Enhances event using the client configuration.
     *  It takes care of all "static" values like environment, release and `dist`,
     *  as well as truncating overly long values.
     * @param event event instance to be enhanced
     */ BaseClient.prototype._applyClientOptions = function(event) {
        var options = this.getOptions();
        var environment = options.environment, release = options.release, dist = options.dist, _a = options.maxValueLength, maxValueLength = _a === void 0 ? 250 : _a;
        if (!('environment' in event)) event.environment = 'environment' in options ? environment : 'production';
        if (event.release === undefined && release !== undefined) event.release = release;
        if (event.dist === undefined && dist !== undefined) event.dist = dist;
        if (event.message) event.message = (0, $jOwKr.truncate)(event.message, maxValueLength);
        var exception = event.exception && event.exception.values && event.exception.values[0];
        if (exception && exception.value) exception.value = (0, $jOwKr.truncate)(exception.value, maxValueLength);
        var request = event.request;
        if (request && request.url) request.url = (0, $jOwKr.truncate)(request.url, maxValueLength);
    };
    /**
     * This function adds all used integrations to the SDK info in the event.
     * @param event The event that will be filled with all integrations.
     */ BaseClient.prototype._applyIntegrationsMetadata = function(event) {
        var integrationsArray = Object.keys(this._integrations);
        if (integrationsArray.length > 0) {
            event.sdk = event.sdk || {};
            event.sdk.integrations = (0, $3VFsf.__spread)(event.sdk.integrations || [], integrationsArray);
        }
    };
    /**
     * Tells the backend to send this event
     * @param event The Sentry event to send
     */ BaseClient.prototype._sendEvent = function(event) {
        this._getBackend().sendEvent(event);
    };
    /**
     * Processes the event and logs an error in case of rejection
     * @param event
     * @param hint
     * @param scope
     */ BaseClient.prototype._captureEvent = function(event, hint, scope) {
        return this._processEvent(event, hint, scope).then(function(finalEvent) {
            return finalEvent.event_id;
        }, function(reason) {
            (0, $aEGcl.IS_DEBUG_BUILD) && (0, $4geCF.logger).error(reason);
            return undefined;
        });
    };
    /**
     * Processes an event (either error or message) and sends it to Sentry.
     *
     * This also adds breadcrumbs and context information to the event. However,
     * platform specific meta data (such as the User's IP address) must be added
     * by the SDK implementor.
     *
     *
     * @param event The event to send to Sentry.
     * @param hint May contain additional information about the original exception.
     * @param scope A scope containing event metadata.
     * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
     */ BaseClient.prototype._processEvent = function(event, hint, scope) {
        var _this = this;
        // eslint-disable-next-line @typescript-eslint/unbound-method
        var _a = this.getOptions(), beforeSend = _a.beforeSend, sampleRate = _a.sampleRate;
        var transport = this.getTransport();
        function recordLostEvent(outcome, category) {
            if (transport.recordLostEvent) transport.recordLostEvent(outcome, category);
        }
        if (!this._isEnabled()) return (0, $3X7U8.rejectedSyncPromise)(new (0, $b17Q6.SentryError)('SDK not enabled, will not capture event.'));
        var isTransaction = event.type === 'transaction';
        // 1.0 === 100% events are sent
        // 0.0 === 0% events are sent
        // Sampling for transaction happens somewhere else
        if (!isTransaction && typeof sampleRate === 'number' && Math.random() > sampleRate) {
            recordLostEvent('sample_rate', 'event');
            return (0, $3X7U8.rejectedSyncPromise)(new (0, $b17Q6.SentryError)("Discarding event because it's not included in the random sample (sampling rate = " + sampleRate + ")"));
        }
        return this._prepareEvent(event, scope, hint).then(function(prepared) {
            if (prepared === null) {
                recordLostEvent('event_processor', event.type || 'event');
                throw new (0, $b17Q6.SentryError)('An event processor returned null, will not send event.');
            }
            var isInternalException = hint && hint.data && hint.data.__sentry__ === true;
            if (isInternalException || isTransaction || !beforeSend) return prepared;
            var beforeSendResult = beforeSend(prepared, hint);
            return $32e2559d400632fa$var$_ensureBeforeSendRv(beforeSendResult);
        }).then(function(processedEvent) {
            if (processedEvent === null) {
                recordLostEvent('before_send', event.type || 'event');
                throw new (0, $b17Q6.SentryError)('`beforeSend` returned `null`, will not send event.');
            }
            var session = scope && scope.getSession && scope.getSession();
            if (!isTransaction && session) _this._updateSessionFromEvent(session, processedEvent);
            _this._sendEvent(processedEvent);
            return processedEvent;
        }).then(null, function(reason) {
            if (reason instanceof (0, $b17Q6.SentryError)) throw reason;
            _this.captureException(reason, {
                data: {
                    __sentry__: true
                },
                originalException: reason
            });
            throw new (0, $b17Q6.SentryError)("Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: " + reason);
        });
    };
    /**
     * Occupies the client with processing and event
     */ BaseClient.prototype._process = function(promise) {
        var _this = this;
        this._numProcessing += 1;
        promise.then(function(value) {
            _this._numProcessing -= 1;
            return value;
        }, function(reason) {
            _this._numProcessing -= 1;
            return reason;
        });
    };
    return BaseClient;
}();
/**
 * Verifies that return value of configured `beforeSend` is of expected type.
 */ function $32e2559d400632fa$var$_ensureBeforeSendRv(rv) {
    var nullErr = '`beforeSend` method has to return `null` or a valid event.';
    if ((0, $gkmq5.isThenable)(rv)) return rv.then(function(event) {
        if (!((0, $gkmq5.isPlainObject)(event) || event === null)) throw new (0, $b17Q6.SentryError)(nullErr);
        return event;
    }, function(e) {
        throw new (0, $b17Q6.SentryError)("beforeSend rejected with " + e);
    });
    else if (!((0, $gkmq5.isPlainObject)(rv) || rv === null)) throw new (0, $b17Q6.SentryError)(nullErr);
    return rv;
}

});
parcelRegister("6WKyI", function(module, exports) {

$parcel$export(module.exports, "setupIntegrations", () => $50ec467f037cb5b6$export$51abed9797baa598);

var $3VFsf = parcelRequire("3VFsf");

var $gfYRq = parcelRequire("gfYRq");
var $3kk8J = parcelRequire("3kk8J");
parcelRequire("8KVVB");
var $1l3DN = parcelRequire("1l3DN");
var $4geCF = parcelRequire("4geCF");

var $aEGcl = parcelRequire("aEGcl");
var $50ec467f037cb5b6$export$b14a8888f80a0b3e = [];
/**
 * @private
 */ function $50ec467f037cb5b6$var$filterDuplicates(integrations) {
    return integrations.reduce(function(acc, integrations) {
        if (acc.every(function(accIntegration) {
            return integrations.name !== accIntegration.name;
        })) acc.push(integrations);
        return acc;
    }, []);
}
function $50ec467f037cb5b6$export$68bc4c01ab8ae766(options) {
    var defaultIntegrations = options.defaultIntegrations && (0, $3VFsf.__spread)(options.defaultIntegrations) || [];
    var userIntegrations = options.integrations;
    var integrations = (0, $3VFsf.__spread)($50ec467f037cb5b6$var$filterDuplicates(defaultIntegrations));
    if (Array.isArray(userIntegrations)) // Filter out integrations that are also included in user options
    integrations = (0, $3VFsf.__spread)(integrations.filter(function(integrations) {
        return userIntegrations.every(function(userIntegration) {
            return userIntegration.name !== integrations.name;
        });
    }), $50ec467f037cb5b6$var$filterDuplicates(userIntegrations));
    else if (typeof userIntegrations === 'function') {
        integrations = userIntegrations(integrations);
        integrations = Array.isArray(integrations) ? integrations : [
            integrations
        ];
    }
    // Make sure that if present, `Debug` integration will always run last
    var integrationsNames = integrations.map(function(i) {
        return i.name;
    });
    var alwaysLastToRun = 'Debug';
    if (integrationsNames.indexOf(alwaysLastToRun) !== -1) integrations.push.apply(integrations, (0, $3VFsf.__spread)(integrations.splice(integrationsNames.indexOf(alwaysLastToRun), 1)));
    return integrations;
}
function $50ec467f037cb5b6$export$e7390a03b70a6f2f(integration) {
    if ($50ec467f037cb5b6$export$b14a8888f80a0b3e.indexOf(integration.name) !== -1) return;
    integration.setupOnce((0, $gfYRq.addGlobalEventProcessor), (0, $3kk8J.getCurrentHub));
    $50ec467f037cb5b6$export$b14a8888f80a0b3e.push(integration.name);
    (0, $aEGcl.IS_DEBUG_BUILD) && (0, $4geCF.logger).log("Integration installed: " + integration.name);
}
function $50ec467f037cb5b6$export$51abed9797baa598(options) {
    var integrations = {};
    $50ec467f037cb5b6$export$68bc4c01ab8ae766(options).forEach(function(integration) {
        integrations[integration.name] = integration;
        $50ec467f037cb5b6$export$e7390a03b70a6f2f(integration);
    });
    // set the `initialized` flag so we don't run through the process again unecessarily; use `Object.defineProperty`
    // because by default it creates a property which is nonenumerable, which we want since `initialized` shouldn't be
    // considered a member of the index the way the actual integrations are
    (0, $1l3DN.addNonEnumerableProperty)(integrations, 'initialized', true);
    return integrations;
}

});


parcelRegister("f1FVh", function(module, exports) {

$parcel$export(module.exports, "SDK_VERSION", () => $af0778001337a981$export$31499a9cd224b78c);
var $af0778001337a981$export$31499a9cd224b78c = '6.19.7';

});

parcelRegister("7bB5K", function(module, exports) {

$parcel$export(module.exports, "BrowserBackend", () => $53b6551be133373f$export$2526e21aec9d0ce7);

var $3VFsf = parcelRequire("3VFsf");

var $hNPWg = parcelRequire("hNPWg");
var $eo4PV = parcelRequire("eo4PV");

var $4aybe = parcelRequire("4aybe");
parcelRequire("8KVVB");
var $ci1rH = parcelRequire("ci1rH");

var $j0O65 = parcelRequire("j0O65");

var $dPxoy = parcelRequire("dPxoy");
var $j0yJv = parcelRequire("j0yJv");
var $9FggM = parcelRequire("9FggM");
var $li9k9 = parcelRequire("li9k9");
/**
 * The Sentry Browser SDK Backend.
 * @hidden
 */ var $53b6551be133373f$export$2526e21aec9d0ce7 = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(BrowserBackend, _super);
    function BrowserBackend() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @inheritDoc
     */ BrowserBackend.prototype.eventFromException = function(exception, hint) {
        return (0, $j0O65.eventFromException)(exception, hint, this._options.attachStacktrace);
    };
    /**
     * @inheritDoc
     */ BrowserBackend.prototype.eventFromMessage = function(message, level, hint) {
        if (level === void 0) level = (0, $4aybe.Severity).Info;
        return (0, $j0O65.eventFromMessage)(message, level, hint, this._options.attachStacktrace);
    };
    /**
     * @inheritDoc
     */ BrowserBackend.prototype._setupTransport = function() {
        if (!this._options.dsn) // We return the noop transport here in case there is no Dsn.
        return _super.prototype._setupTransport.call(this);
        var transportOptions = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this._options.transportOptions), {
            dsn: this._options.dsn,
            tunnel: this._options.tunnel,
            sendClientReports: this._options.sendClientReports,
            _metadata: this._options._metadata
        });
        var api = (0, $eo4PV.initAPIDetails)(transportOptions.dsn, transportOptions._metadata, transportOptions.tunnel);
        var url = (0, $eo4PV.getEnvelopeEndpointWithUrlEncodedAuth)(api.dsn, api.tunnel);
        if (this._options.transport) return new this._options.transport(transportOptions);
        if ((0, $ci1rH.supportsFetch)()) {
            var requestOptions = (0, $3VFsf.__assign)({}, transportOptions.fetchParameters);
            this._newTransport = (0, $j0yJv.makeNewFetchTransport)({
                requestOptions: requestOptions,
                url: url
            });
            return new (0, $dPxoy.FetchTransport)(transportOptions);
        }
        this._newTransport = (0, $9FggM.makeNewXHRTransport)({
            url: url,
            headers: transportOptions.headers
        });
        return new (0, $li9k9.XHRTransport)(transportOptions);
    };
    return BrowserBackend;
}((0, $hNPWg.BaseBackend));

});
parcelRegister("hNPWg", function(module, exports) {

$parcel$export(module.exports, "BaseBackend", () => $cf5f4d389fcdf9b4$export$8f43a53a38d7e95f);

var $3VFsf = parcelRequire("3VFsf");
parcelRequire("8KVVB");
var $4geCF = parcelRequire("4geCF");
var $b17Q6 = parcelRequire("b17Q6");

var $eo4PV = parcelRequire("eo4PV");

var $aEGcl = parcelRequire("aEGcl");

var $74I1Q = parcelRequire("74I1Q");

var $bp300 = parcelRequire("bp300");
/**
 * This is the base implemention of a Backend.
 * @hidden
 */ var $cf5f4d389fcdf9b4$export$8f43a53a38d7e95f = /** @class */ function() {
    /** Creates a new backend instance. */ function BaseBackend(options) {
        this._options = options;
        if (!this._options.dsn) (0, $aEGcl.IS_DEBUG_BUILD) && (0, $4geCF.logger).warn('No DSN provided, backend will not do anything.');
        this._transport = this._setupTransport();
    }
    /**
     * @inheritDoc
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    BaseBackend.prototype.eventFromException = function(_exception, _hint) {
        throw new (0, $b17Q6.SentryError)('Backend has to implement `eventFromException` method');
    };
    /**
     * @inheritDoc
     */ BaseBackend.prototype.eventFromMessage = function(_message, _level, _hint) {
        throw new (0, $b17Q6.SentryError)('Backend has to implement `eventFromMessage` method');
    };
    /**
     * @inheritDoc
     */ BaseBackend.prototype.sendEvent = function(event) {
        // TODO(v7): Remove the if-else
        if (this._newTransport && this._options.dsn && this._options._experiments && this._options._experiments.newTransport) {
            var api = (0, $eo4PV.initAPIDetails)(this._options.dsn, this._options._metadata, this._options.tunnel);
            var env = (0, $74I1Q.createEventEnvelope)(event, api);
            this._newTransport.send(env).then(null, function(reason) {
                (0, $aEGcl.IS_DEBUG_BUILD) && (0, $4geCF.logger).error('Error while sending event:', reason);
            });
        } else this._transport.sendEvent(event).then(null, function(reason) {
            (0, $aEGcl.IS_DEBUG_BUILD) && (0, $4geCF.logger).error('Error while sending event:', reason);
        });
    };
    /**
     * @inheritDoc
     */ BaseBackend.prototype.sendSession = function(session) {
        if (!this._transport.sendSession) {
            (0, $aEGcl.IS_DEBUG_BUILD) && (0, $4geCF.logger).warn("Dropping session because custom transport doesn't implement sendSession");
            return;
        }
        // TODO(v7): Remove the if-else
        if (this._newTransport && this._options.dsn && this._options._experiments && this._options._experiments.newTransport) {
            var api = (0, $eo4PV.initAPIDetails)(this._options.dsn, this._options._metadata, this._options.tunnel);
            var _a = (0, $3VFsf.__read)((0, $74I1Q.createSessionEnvelope)(session, api), 1), env = _a[0];
            this._newTransport.send(env).then(null, function(reason) {
                (0, $aEGcl.IS_DEBUG_BUILD) && (0, $4geCF.logger).error('Error while sending session:', reason);
            });
        } else this._transport.sendSession(session).then(null, function(reason) {
            (0, $aEGcl.IS_DEBUG_BUILD) && (0, $4geCF.logger).error('Error while sending session:', reason);
        });
    };
    /**
     * @inheritDoc
     */ BaseBackend.prototype.getTransport = function() {
        return this._transport;
    };
    /**
     * Sets up the transport so it can be used later to send requests.
     */ BaseBackend.prototype._setupTransport = function() {
        return new (0, $bp300.NoopTransport)();
    };
    return BaseBackend;
}();

});
parcelRegister("eo4PV", function(module, exports) {

$parcel$export(module.exports, "getStoreEndpointWithUrlEncodedAuth", () => $a7970f0597e3bc77$export$c1677e22ac2217a5);
$parcel$export(module.exports, "getEnvelopeEndpointWithUrlEncodedAuth", () => $a7970f0597e3bc77$export$9964600bfe84e6a3);
$parcel$export(module.exports, "initAPIDetails", () => $a7970f0597e3bc77$export$ad00a06efb2a29cb);
$parcel$export(module.exports, "getReportDialogEndpoint", () => $a7970f0597e3bc77$export$671c7ed8e40a7a57);
parcelRequire("8KVVB");
var $gSiM6 = parcelRequire("gSiM6");
var $1l3DN = parcelRequire("1l3DN");
var $a7970f0597e3bc77$var$SENTRY_API_VERSION = '7';
/**
 * Helper class to provide urls, headers and metadata that can be used to form
 * different types of requests to Sentry endpoints.
 * Supports both envelopes and regular event requests.
 *
 * @deprecated Please use APIDetails
 **/ var $a7970f0597e3bc77$export$2c4e825dc9120f87 = /** @class */ function() {
    /** Create a new instance of API */ function API(dsn, metadata, tunnel) {
        if (metadata === void 0) metadata = {};
        this.dsn = dsn;
        this._dsnObject = (0, $gSiM6.makeDsn)(dsn);
        this.metadata = metadata;
        this._tunnel = tunnel;
    }
    /** Returns the Dsn object. */ API.prototype.getDsn = function() {
        return this._dsnObject;
    };
    /** Does this transport force envelopes? */ API.prototype.forceEnvelope = function() {
        return !!this._tunnel;
    };
    /** Returns the prefix to construct Sentry ingestion API endpoints. */ API.prototype.getBaseApiEndpoint = function() {
        return $a7970f0597e3bc77$var$getBaseApiEndpoint(this._dsnObject);
    };
    /** Returns the store endpoint URL. */ API.prototype.getStoreEndpoint = function() {
        return $a7970f0597e3bc77$var$getStoreEndpoint(this._dsnObject);
    };
    /**
     * Returns the store endpoint URL with auth in the query string.
     *
     * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
     */ API.prototype.getStoreEndpointWithUrlEncodedAuth = function() {
        return $a7970f0597e3bc77$export$c1677e22ac2217a5(this._dsnObject);
    };
    /**
     * Returns the envelope endpoint URL with auth in the query string.
     *
     * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
     */ API.prototype.getEnvelopeEndpointWithUrlEncodedAuth = function() {
        return $a7970f0597e3bc77$export$9964600bfe84e6a3(this._dsnObject, this._tunnel);
    };
    return API;
}();
function $a7970f0597e3bc77$export$ad00a06efb2a29cb(dsn, metadata, tunnel) {
    return {
        initDsn: dsn,
        metadata: metadata || {},
        dsn: (0, $gSiM6.makeDsn)(dsn),
        tunnel: tunnel
    };
}
/** Returns the prefix to construct Sentry ingestion API endpoints. */ function $a7970f0597e3bc77$var$getBaseApiEndpoint(dsn) {
    var protocol = dsn.protocol ? dsn.protocol + ":" : '';
    var port = dsn.port ? ":" + dsn.port : '';
    return protocol + "//" + dsn.host + port + (dsn.path ? "/" + dsn.path : '') + "/api/";
}
/** Returns the ingest API endpoint for target. */ function $a7970f0597e3bc77$var$_getIngestEndpoint(dsn, target) {
    return "" + $a7970f0597e3bc77$var$getBaseApiEndpoint(dsn) + dsn.projectId + "/" + target + "/";
}
/** Returns a URL-encoded string with auth config suitable for a query string. */ function $a7970f0597e3bc77$var$_encodedAuth(dsn) {
    return (0, $1l3DN.urlEncode)({
        // We send only the minimum set of required information. See
        // https://github.com/getsentry/sentry-javascript/issues/2572.
        sentry_key: dsn.publicKey,
        sentry_version: $a7970f0597e3bc77$var$SENTRY_API_VERSION
    });
}
/** Returns the store endpoint URL. */ function $a7970f0597e3bc77$var$getStoreEndpoint(dsn) {
    return $a7970f0597e3bc77$var$_getIngestEndpoint(dsn, 'store');
}
function $a7970f0597e3bc77$export$c1677e22ac2217a5(dsn) {
    return $a7970f0597e3bc77$var$getStoreEndpoint(dsn) + "?" + $a7970f0597e3bc77$var$_encodedAuth(dsn);
}
/** Returns the envelope endpoint URL. */ function $a7970f0597e3bc77$var$_getEnvelopeEndpoint(dsn) {
    return $a7970f0597e3bc77$var$_getIngestEndpoint(dsn, 'envelope');
}
function $a7970f0597e3bc77$export$9964600bfe84e6a3(dsn, tunnel) {
    return tunnel ? tunnel : $a7970f0597e3bc77$var$_getEnvelopeEndpoint(dsn) + "?" + $a7970f0597e3bc77$var$_encodedAuth(dsn);
}
function $a7970f0597e3bc77$export$1e4d4724de7b199e(dsn, clientName, clientVersion) {
    // CHANGE THIS to use metadata but keep clientName and clientVersion compatible
    var header = [
        "Sentry sentry_version=" + $a7970f0597e3bc77$var$SENTRY_API_VERSION
    ];
    header.push("sentry_client=" + clientName + "/" + clientVersion);
    header.push("sentry_key=" + dsn.publicKey);
    if (dsn.pass) header.push("sentry_secret=" + dsn.pass);
    return {
        'Content-Type': 'application/json',
        'X-Sentry-Auth': header.join(', ')
    };
}
function $a7970f0597e3bc77$export$671c7ed8e40a7a57(dsnLike, dialogOptions) {
    var dsn = (0, $gSiM6.makeDsn)(dsnLike);
    var endpoint = $a7970f0597e3bc77$var$getBaseApiEndpoint(dsn) + "embed/error-page/";
    var encodedOptions = "dsn=" + (0, $gSiM6.dsnToString)(dsn);
    for(var key in dialogOptions){
        if (key === 'dsn') continue;
        if (key === 'user') {
            if (!dialogOptions.user) continue;
            if (dialogOptions.user.name) encodedOptions += "&name=" + encodeURIComponent(dialogOptions.user.name);
            if (dialogOptions.user.email) encodedOptions += "&email=" + encodeURIComponent(dialogOptions.user.email);
        } else encodedOptions += "&" + encodeURIComponent(key) + "=" + encodeURIComponent(dialogOptions[key]);
    }
    return endpoint + "?" + encodedOptions;
}

});

parcelRegister("74I1Q", function(module, exports) {

$parcel$export(module.exports, "createSessionEnvelope", () => $526b0f525f112293$export$124b03c077baa2f3);
$parcel$export(module.exports, "sessionToSentryRequest", () => $526b0f525f112293$export$977ee6eda1884ec3);
$parcel$export(module.exports, "createEventEnvelope", () => $526b0f525f112293$export$c31057337a18010f);
$parcel$export(module.exports, "eventToSentryRequest", () => $526b0f525f112293$export$2006389de558b996);

var $3VFsf = parcelRequire("3VFsf");
parcelRequire("8KVVB");
var $e1x9C = parcelRequire("e1x9C");
var $gSiM6 = parcelRequire("gSiM6");
var $2mY5H = parcelRequire("2mY5H");

var $eo4PV = parcelRequire("eo4PV");
/** Extract sdk info from from the API metadata */ function $526b0f525f112293$var$getSdkMetadataForEnvelopeHeader(api) {
    if (!api.metadata || !api.metadata.sdk) return;
    var _a = api.metadata.sdk, name = _a.name, version = _a.version;
    return {
        name: name,
        version: version
    };
}
/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/ function $526b0f525f112293$var$enhanceEventWithSdkInfo(event, sdkInfo) {
    if (!sdkInfo) return event;
    event.sdk = event.sdk || {};
    event.sdk.name = event.sdk.name || sdkInfo.name;
    event.sdk.version = event.sdk.version || sdkInfo.version;
    event.sdk.integrations = (0, $3VFsf.__spread)(event.sdk.integrations || [], sdkInfo.integrations || []);
    event.sdk.packages = (0, $3VFsf.__spread)(event.sdk.packages || [], sdkInfo.packages || []);
    return event;
}
function $526b0f525f112293$export$124b03c077baa2f3(session, api) {
    var sdkInfo = $526b0f525f112293$var$getSdkMetadataForEnvelopeHeader(api);
    var envelopeHeaders = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({
        sent_at: new Date().toISOString()
    }, sdkInfo && {
        sdk: sdkInfo
    }), !!api.tunnel && {
        dsn: (0, $gSiM6.dsnToString)(api.dsn)
    });
    // I know this is hacky but we don't want to add `sessions` to request type since it's never rate limited
    var type = 'aggregates' in session ? 'sessions' : 'session';
    // TODO (v7) Have to cast type because envelope items do not accept a `SentryRequestType`
    var envelopeItem = [
        {
            type: type
        },
        session
    ];
    var envelope = (0, $e1x9C.createEnvelope)(envelopeHeaders, [
        envelopeItem
    ]);
    return [
        envelope,
        type
    ];
}
function $526b0f525f112293$export$977ee6eda1884ec3(session, api) {
    var _a = (0, $3VFsf.__read)($526b0f525f112293$export$124b03c077baa2f3(session, api), 2), envelope = _a[0], type = _a[1];
    return {
        body: (0, $e1x9C.serializeEnvelope)(envelope),
        type: type,
        url: (0, $eo4PV.getEnvelopeEndpointWithUrlEncodedAuth)(api.dsn, api.tunnel)
    };
}
function $526b0f525f112293$export$c31057337a18010f(event, api) {
    var sdkInfo = $526b0f525f112293$var$getSdkMetadataForEnvelopeHeader(api);
    var eventType = event.type || 'event';
    var transactionSampling = (event.sdkProcessingMetadata || {}).transactionSampling;
    var _a = transactionSampling || {}, samplingMethod = _a.method, sampleRate = _a.rate;
    // TODO: Below is a temporary hack in order to debug a serialization error - see
    // https://github.com/getsentry/sentry-javascript/issues/2809,
    // https://github.com/getsentry/sentry-javascript/pull/4425, and
    // https://github.com/getsentry/sentry-javascript/pull/4574.
    //
    // TL; DR: even though we normalize all events (which should prevent this), something is causing `JSON.stringify` to
    // throw a circular reference error.
    //
    // When it's time to remove it:
    // 1. Delete everything between here and where the request object `req` is created, EXCEPT the line deleting
    //    `sdkProcessingMetadata`
    // 2. Restore the original version of the request body, which is commented out
    // 3. Search for either of the PR URLs above and pull out the companion hacks in the browser playwright tests and the
    //    baseClient tests in this package
    $526b0f525f112293$var$enhanceEventWithSdkInfo(event, api.metadata.sdk);
    event.tags = event.tags || {};
    event.extra = event.extra || {};
    // In theory, all events should be marked as having gone through normalization and so
    // we should never set this tag/extra data
    if (!(event.sdkProcessingMetadata && event.sdkProcessingMetadata.baseClientNormalized)) {
        event.tags.skippedNormalization = true;
        event.extra.normalizeDepth = event.sdkProcessingMetadata ? event.sdkProcessingMetadata.normalizeDepth : 'unset';
    }
    // prevent this data from being sent to sentry
    // TODO: This is NOT part of the hack - DO NOT DELETE
    delete event.sdkProcessingMetadata;
    var envelopeHeaders = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({
        event_id: event.event_id,
        sent_at: new Date().toISOString()
    }, sdkInfo && {
        sdk: sdkInfo
    }), !!api.tunnel && {
        dsn: (0, $gSiM6.dsnToString)(api.dsn)
    });
    var eventItem = [
        {
            type: eventType,
            sample_rates: [
                {
                    id: samplingMethod,
                    rate: sampleRate
                }
            ]
        },
        event
    ];
    return (0, $e1x9C.createEnvelope)(envelopeHeaders, [
        eventItem
    ]);
}
function $526b0f525f112293$export$2006389de558b996(event, api) {
    var sdkInfo = $526b0f525f112293$var$getSdkMetadataForEnvelopeHeader(api);
    var eventType = event.type || 'event';
    var useEnvelope = eventType === 'transaction' || !!api.tunnel;
    var transactionSampling = (event.sdkProcessingMetadata || {}).transactionSampling;
    var _a = transactionSampling || {}, samplingMethod = _a.method, sampleRate = _a.rate;
    // TODO: Below is a temporary hack in order to debug a serialization error - see
    // https://github.com/getsentry/sentry-javascript/issues/2809,
    // https://github.com/getsentry/sentry-javascript/pull/4425, and
    // https://github.com/getsentry/sentry-javascript/pull/4574.
    //
    // TL; DR: even though we normalize all events (which should prevent this), something is causing `JSON.stringify` to
    // throw a circular reference error.
    //
    // When it's time to remove it:
    // 1. Delete everything between here and where the request object `req` is created, EXCEPT the line deleting
    //    `sdkProcessingMetadata`
    // 2. Restore the original version of the request body, which is commented out
    // 3. Search for either of the PR URLs above and pull out the companion hacks in the browser playwright tests and the
    //    baseClient tests in this package
    $526b0f525f112293$var$enhanceEventWithSdkInfo(event, api.metadata.sdk);
    event.tags = event.tags || {};
    event.extra = event.extra || {};
    // In theory, all events should be marked as having gone through normalization and so
    // we should never set this tag/extra data
    if (!(event.sdkProcessingMetadata && event.sdkProcessingMetadata.baseClientNormalized)) {
        event.tags.skippedNormalization = true;
        event.extra.normalizeDepth = event.sdkProcessingMetadata ? event.sdkProcessingMetadata.normalizeDepth : 'unset';
    }
    // prevent this data from being sent to sentry
    // TODO: This is NOT part of the hack - DO NOT DELETE
    delete event.sdkProcessingMetadata;
    var body;
    try {
        // 99.9% of events should get through just fine - no change in behavior for them
        body = JSON.stringify(event);
    } catch (err) {
        // Record data about the error without replacing original event data, then force renormalization
        event.tags.JSONStringifyError = true;
        event.extra.JSONStringifyError = err;
        try {
            body = JSON.stringify((0, $2mY5H.normalize)(event));
        } catch (newErr) {
            // At this point even renormalization hasn't worked, meaning something about the event data has gone very wrong.
            // Time to cut our losses and record only the new error. With luck, even in the problematic cases we're trying to
            // debug with this hack, we won't ever land here.
            var innerErr = newErr;
            body = JSON.stringify({
                message: 'JSON.stringify error after renormalization',
                // setting `extra: { innerErr }` here for some reason results in an empty object, so unpack manually
                extra: {
                    message: innerErr.message,
                    stack: innerErr.stack
                }
            });
        }
    }
    var req = {
        // this is the relevant line of code before the hack was added, to make it easy to undo said hack once we've solved
        // the mystery
        // body: JSON.stringify(sdkInfo ? enhanceEventWithSdkInfo(event, api.metadata.sdk) : event),
        body: body,
        type: eventType,
        url: useEnvelope ? (0, $eo4PV.getEnvelopeEndpointWithUrlEncodedAuth)(api.dsn, api.tunnel) : (0, $eo4PV.getStoreEndpointWithUrlEncodedAuth)(api.dsn)
    };
    // https://develop.sentry.dev/sdk/envelopes/
    // Since we don't need to manipulate envelopes nor store them, there is no
    // exported concept of an Envelope with operations including serialization and
    // deserialization. Instead, we only implement a minimal subset of the spec to
    // serialize events inline here.
    if (useEnvelope) {
        var envelopeHeaders = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({
            event_id: event.event_id,
            sent_at: new Date().toISOString()
        }, sdkInfo && {
            sdk: sdkInfo
        }), !!api.tunnel && {
            dsn: (0, $gSiM6.dsnToString)(api.dsn)
        });
        var eventItem = [
            {
                type: eventType,
                sample_rates: [
                    {
                        id: samplingMethod,
                        rate: sampleRate
                    }
                ]
            },
            req.body
        ];
        var envelope = (0, $e1x9C.createEnvelope)(envelopeHeaders, [
            eventItem
        ]);
        req.body = (0, $e1x9C.serializeEnvelope)(envelope);
    }
    return req;
}

});

parcelRegister("bp300", function(module, exports) {

$parcel$export(module.exports, "NoopTransport", () => $84d45b1428dd62f9$export$6f2767450ea1346c);
parcelRequire("8KVVB");
var $3X7U8 = parcelRequire("3X7U8");
/** Noop transport */ var $84d45b1428dd62f9$export$6f2767450ea1346c = /** @class */ function() {
    function NoopTransport() {}
    /**
     * @inheritDoc
     */ NoopTransport.prototype.sendEvent = function(_) {
        return (0, $3X7U8.resolvedSyncPromise)({
            reason: 'NoopTransport: Event has been skipped because no Dsn is configured.',
            status: 'skipped'
        });
    };
    /**
     * @inheritDoc
     */ NoopTransport.prototype.close = function(_) {
        return (0, $3X7U8.resolvedSyncPromise)(true);
    };
    return NoopTransport;
}();

});


parcelRegister("j0O65", function(module, exports) {

$parcel$export(module.exports, "exceptionFromError", () => $dd74e0aea3b95fc8$export$a6c2d27607295951);
$parcel$export(module.exports, "eventFromException", () => $dd74e0aea3b95fc8$export$ea3ec7e569b823fc);
$parcel$export(module.exports, "eventFromUnknownInput", () => $dd74e0aea3b95fc8$export$9dd56ed1ef0c3420);
$parcel$export(module.exports, "eventFromMessage", () => $dd74e0aea3b95fc8$export$5425b53185d13d6c);

var $3VFsf = parcelRequire("3VFsf");

var $4aybe = parcelRequire("4aybe");
parcelRequire("8KVVB");
var $jyUiA = parcelRequire("jyUiA");
var $aNkwr = parcelRequire("aNkwr");
var $1l3DN = parcelRequire("1l3DN");
var $gkmq5 = parcelRequire("gkmq5");
var $2mY5H = parcelRequire("2mY5H");
var $3X7U8 = parcelRequire("3X7U8");

var $kwRAs = parcelRequire("kwRAs");
function $dd74e0aea3b95fc8$export$a6c2d27607295951(ex) {
    // Get the frames first since Opera can lose the stack if we touch anything else first
    var frames = $dd74e0aea3b95fc8$export$d478b2c12fbcfdda(ex);
    var exception = {
        type: ex && ex.name,
        value: $dd74e0aea3b95fc8$var$extractMessage(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === undefined && exception.value === '') exception.value = 'Unrecoverable error caught';
    return exception;
}
function $dd74e0aea3b95fc8$export$a6a5dd73e489caf(exception, syntheticException, isUnhandledRejection) {
    var event = {
        exception: {
            values: [
                {
                    type: (0, $gkmq5.isEvent)(exception) ? exception.constructor.name : isUnhandledRejection ? 'UnhandledRejection' : 'Error',
                    value: "Non-Error " + (isUnhandledRejection ? 'promise rejection' : 'exception') + " captured with keys: " + (0, $1l3DN.extractExceptionKeysForMessage)(exception)
                }
            ]
        },
        extra: {
            __serialized__: (0, $2mY5H.normalizeToSize)(exception)
        }
    };
    if (syntheticException) {
        var frames_1 = $dd74e0aea3b95fc8$export$d478b2c12fbcfdda(syntheticException);
        if (frames_1.length) event.stacktrace = {
            frames: frames_1
        };
    }
    return event;
}
function $dd74e0aea3b95fc8$export$73fbea5a0a5234af(ex) {
    return {
        exception: {
            values: [
                $dd74e0aea3b95fc8$export$a6c2d27607295951(ex)
            ]
        }
    };
}
function $dd74e0aea3b95fc8$export$d478b2c12fbcfdda(ex) {
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    var stacktrace = ex.stacktrace || ex.stack || '';
    var popSize = $dd74e0aea3b95fc8$var$getPopSize(ex);
    try {
        return (0, $aNkwr.createStackParser)((0, $kwRAs.opera10StackParser), (0, $kwRAs.opera11StackParser), (0, $kwRAs.chromeStackParser), (0, $kwRAs.winjsStackParser), (0, $kwRAs.geckoStackParser))(stacktrace, popSize);
    } catch (e) {
    // no-empty
    }
    return [];
}
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
var $dd74e0aea3b95fc8$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
function $dd74e0aea3b95fc8$var$getPopSize(ex) {
    if (ex) {
        if (typeof ex.framesToPop === 'number') return ex.framesToPop;
        if ($dd74e0aea3b95fc8$var$reactMinifiedRegexp.test(ex.message)) return 1;
    }
    return 0;
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */ function $dd74e0aea3b95fc8$var$extractMessage(ex) {
    var message = ex && ex.message;
    if (!message) return 'No error message';
    if (message.error && typeof message.error.message === 'string') return message.error.message;
    return message;
}
function $dd74e0aea3b95fc8$export$ea3ec7e569b823fc(exception, hint, attachStacktrace) {
    var syntheticException = hint && hint.syntheticException || undefined;
    var event = $dd74e0aea3b95fc8$export$9dd56ed1ef0c3420(exception, syntheticException, attachStacktrace);
    (0, $jyUiA.addExceptionMechanism)(event); // defaults to { type: 'generic', handled: true }
    event.level = (0, $4aybe.Severity).Error;
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $3X7U8.resolvedSyncPromise)(event);
}
function $dd74e0aea3b95fc8$export$5425b53185d13d6c(message, level, hint, attachStacktrace) {
    if (level === void 0) level = (0, $4aybe.Severity).Info;
    var syntheticException = hint && hint.syntheticException || undefined;
    var event = $dd74e0aea3b95fc8$export$47d86ae4b3c9994(message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $3X7U8.resolvedSyncPromise)(event);
}
function $dd74e0aea3b95fc8$export$9dd56ed1ef0c3420(exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    var event;
    if ((0, $gkmq5.isErrorEvent)(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        var errorEvent = exception;
        return $dd74e0aea3b95fc8$export$73fbea5a0a5234af(errorEvent.error);
    }
    // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
    //
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
    if ((0, $gkmq5.isDOMError)(exception) || (0, $gkmq5.isDOMException)(exception)) {
        var domException = exception;
        if ('stack' in exception) event = $dd74e0aea3b95fc8$export$73fbea5a0a5234af(exception);
        else {
            var name_1 = domException.name || ((0, $gkmq5.isDOMError)(domException) ? 'DOMError' : 'DOMException');
            var message = domException.message ? name_1 + ": " + domException.message : name_1;
            event = $dd74e0aea3b95fc8$export$47d86ae4b3c9994(message, syntheticException, attachStacktrace);
            (0, $jyUiA.addExceptionTypeValue)(event, message);
        }
        if ('code' in domException) event.tags = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, event.tags), {
            'DOMException.code': "" + domException.code
        });
        return event;
    }
    if ((0, $gkmq5.isError)(exception)) // we have a real Error object, do nothing
    return $dd74e0aea3b95fc8$export$73fbea5a0a5234af(exception);
    if ((0, $gkmq5.isPlainObject)(exception) || (0, $gkmq5.isEvent)(exception)) {
        // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
        // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
        // group on any key/value change.
        var objectException = exception;
        event = $dd74e0aea3b95fc8$export$a6a5dd73e489caf(objectException, syntheticException, isUnhandledRejection);
        (0, $jyUiA.addExceptionMechanism)(event, {
            synthetic: true
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = $dd74e0aea3b95fc8$export$47d86ae4b3c9994(exception, syntheticException, attachStacktrace);
    (0, $jyUiA.addExceptionTypeValue)(event, "" + exception, undefined);
    (0, $jyUiA.addExceptionMechanism)(event, {
        synthetic: true
    });
    return event;
}
function $dd74e0aea3b95fc8$export$47d86ae4b3c9994(input, syntheticException, attachStacktrace) {
    var event = {
        message: input
    };
    if (attachStacktrace && syntheticException) {
        var frames_2 = $dd74e0aea3b95fc8$export$d478b2c12fbcfdda(syntheticException);
        if (frames_2.length) event.stacktrace = {
            frames: frames_2
        };
    }
    return event;
}

});
parcelRegister("kwRAs", function(module, exports) {

$parcel$export(module.exports, "chromeStackParser", () => $ef205d17f92bb38b$export$c693d9295441d8f9);
$parcel$export(module.exports, "geckoStackParser", () => $ef205d17f92bb38b$export$c9ddf1e2b5d48bff);
$parcel$export(module.exports, "winjsStackParser", () => $ef205d17f92bb38b$export$b6d155d85c1dcba5);
$parcel$export(module.exports, "opera10StackParser", () => $ef205d17f92bb38b$export$966ec832d9699d6);
$parcel$export(module.exports, "opera11StackParser", () => $ef205d17f92bb38b$export$989a1824b4734ce6);

var $3VFsf = parcelRequire("3VFsf");
// global reference to slice
var $ef205d17f92bb38b$var$UNKNOWN_FUNCTION = '?';
var $ef205d17f92bb38b$var$OPERA10_PRIORITY = 10;
var $ef205d17f92bb38b$var$OPERA11_PRIORITY = 20;
var $ef205d17f92bb38b$var$CHROME_PRIORITY = 30;
var $ef205d17f92bb38b$var$WINJS_PRIORITY = 40;
var $ef205d17f92bb38b$var$GECKO_PRIORITY = 50;
function $ef205d17f92bb38b$var$createFrame(filename, func, lineno, colno) {
    var frame = {
        filename: filename,
        function: func,
        // All browser frames are considered in_app
        in_app: true
    };
    if (lineno !== undefined) frame.lineno = lineno;
    if (colno !== undefined) frame.colno = colno;
    return frame;
}
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
var $ef205d17f92bb38b$var$chromeRegex = /^\s*at (?:(.*?) ?\((?:address at )?)?((?:file|https?|blob|chrome-extension|address|native|eval|webpack|<anonymous>|[-a-z]+:|.*bundle|\/).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
var $ef205d17f92bb38b$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
var $ef205d17f92bb38b$var$chrome = function(line) {
    var parts = $ef205d17f92bb38b$var$chromeRegex.exec(line);
    if (parts) {
        var isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
        if (isEval) {
            var subMatch = $ef205d17f92bb38b$var$chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = subMatch[1]; // url
                parts[3] = subMatch[2]; // line
                parts[4] = subMatch[3]; // column
            }
        }
        // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
        // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
        var _a = (0, $3VFsf.__read)($ef205d17f92bb38b$var$extractSafariExtensionDetails(parts[1] || $ef205d17f92bb38b$var$UNKNOWN_FUNCTION, parts[2]), 2), func = _a[0], filename = _a[1];
        return $ef205d17f92bb38b$var$createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
    }
    return;
};
var $ef205d17f92bb38b$export$c693d9295441d8f9 = [
    $ef205d17f92bb38b$var$CHROME_PRIORITY,
    $ef205d17f92bb38b$var$chrome
];
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
var $ef205d17f92bb38b$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:file|https?|blob|chrome|webpack|resource|moz-extension|capacitor).*?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
var $ef205d17f92bb38b$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
var $ef205d17f92bb38b$var$gecko = function(line) {
    var _a;
    var parts = $ef205d17f92bb38b$var$geckoREgex.exec(line);
    if (parts) {
        var isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
        if (isEval) {
            var subMatch = $ef205d17f92bb38b$var$geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || 'eval';
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = ''; // no column when eval
            }
        }
        var filename = parts[3];
        var func = parts[1] || $ef205d17f92bb38b$var$UNKNOWN_FUNCTION;
        _a = (0, $3VFsf.__read)($ef205d17f92bb38b$var$extractSafariExtensionDetails(func, filename), 2), func = _a[0], filename = _a[1];
        return $ef205d17f92bb38b$var$createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
    }
    return;
};
var $ef205d17f92bb38b$export$c9ddf1e2b5d48bff = [
    $ef205d17f92bb38b$var$GECKO_PRIORITY,
    $ef205d17f92bb38b$var$gecko
];
var $ef205d17f92bb38b$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
var $ef205d17f92bb38b$var$winjs = function(line) {
    var parts = $ef205d17f92bb38b$var$winjsRegex.exec(line);
    return parts ? $ef205d17f92bb38b$var$createFrame(parts[2], parts[1] || $ef205d17f92bb38b$var$UNKNOWN_FUNCTION, +parts[3], parts[4] ? +parts[4] : undefined) : undefined;
};
var $ef205d17f92bb38b$export$b6d155d85c1dcba5 = [
    $ef205d17f92bb38b$var$WINJS_PRIORITY,
    $ef205d17f92bb38b$var$winjs
];
var $ef205d17f92bb38b$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
var $ef205d17f92bb38b$var$opera10 = function(line) {
    var parts = $ef205d17f92bb38b$var$opera10Regex.exec(line);
    return parts ? $ef205d17f92bb38b$var$createFrame(parts[2], parts[3] || $ef205d17f92bb38b$var$UNKNOWN_FUNCTION, +parts[1]) : undefined;
};
var $ef205d17f92bb38b$export$966ec832d9699d6 = [
    $ef205d17f92bb38b$var$OPERA10_PRIORITY,
    $ef205d17f92bb38b$var$opera10
];
var $ef205d17f92bb38b$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
var $ef205d17f92bb38b$var$opera11 = function(line) {
    var parts = $ef205d17f92bb38b$var$opera11Regex.exec(line);
    return parts ? $ef205d17f92bb38b$var$createFrame(parts[5], parts[3] || parts[4] || $ef205d17f92bb38b$var$UNKNOWN_FUNCTION, +parts[1], +parts[2]) : undefined;
};
var $ef205d17f92bb38b$export$989a1824b4734ce6 = [
    $ef205d17f92bb38b$var$OPERA11_PRIORITY,
    $ef205d17f92bb38b$var$opera11
];
/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */ var $ef205d17f92bb38b$var$extractSafariExtensionDetails = function(func, filename) {
    var isSafariExtension = func.indexOf('safari-extension') !== -1;
    var isSafariWebExtension = func.indexOf('safari-web-extension') !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf('@') !== -1 ? func.split('@')[0] : $ef205d17f92bb38b$var$UNKNOWN_FUNCTION,
        isSafariExtension ? "safari-extension:" + filename : "safari-web-extension:" + filename
    ] : [
        func,
        filename
    ];
};

});


parcelRegister("dPxoy", function(module, exports) {

$parcel$export(module.exports, "FetchTransport", () => $a119f15ae89a1689$export$2bdee3f9b92f4e82);

var $3VFsf = parcelRequire("3VFsf");
parcelRequire("8KVVB");
var $b17Q6 = parcelRequire("b17Q6");
var $ci1rH = parcelRequire("ci1rH");
var $3X7U8 = parcelRequire("3X7U8");

var $hZuUW = parcelRequire("hZuUW");

var $4pdWf = parcelRequire("4pdWf");
/** `fetch` based transport */ var $a119f15ae89a1689$export$2bdee3f9b92f4e82 = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(FetchTransport, _super);
    function FetchTransport(options, fetchImpl) {
        if (fetchImpl === void 0) fetchImpl = (0, $4pdWf.getNativeFetchImplementation)();
        var _this = _super.call(this, options) || this;
        _this._fetch = fetchImpl;
        return _this;
    }
    /**
     * @param sentryRequest Prepared SentryRequest to be delivered
     * @param originalPayload Original payload used to create SentryRequest
     */ FetchTransport.prototype._sendRequest = function(sentryRequest, originalPayload) {
        var _this = this;
        // eslint-disable-next-line deprecation/deprecation
        if (this._isRateLimited(sentryRequest.type)) {
            this.recordLostEvent('ratelimit_backoff', sentryRequest.type);
            return Promise.reject({
                event: originalPayload,
                type: sentryRequest.type,
                // eslint-disable-next-line deprecation/deprecation
                reason: "Transport for " + sentryRequest.type + " requests locked till " + this._disabledUntil(sentryRequest.type) + " due to too many requests.",
                status: 429
            });
        }
        var options = {
            body: sentryRequest.body,
            method: 'POST',
            // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
            // (see https://caniuse.com/#feat=referrer-policy),
            // it doesn't. And it throws an exception instead of ignoring this parameter...
            // REF: https://github.com/getsentry/raven-js/issues/1233
            referrerPolicy: (0, $ci1rH.supportsReferrerPolicy)() ? 'origin' : ''
        };
        if (this.options.fetchParameters !== undefined) Object.assign(options, this.options.fetchParameters);
        if (this.options.headers !== undefined) options.headers = this.options.headers;
        return this._buffer.add(function() {
            return new (0, $3X7U8.SyncPromise)(function(resolve, reject) {
                _this._fetch(sentryRequest.url, options).then(function(response) {
                    var headers = {
                        'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
                        'retry-after': response.headers.get('Retry-After')
                    };
                    _this._handleResponse({
                        requestType: sentryRequest.type,
                        response: response,
                        headers: headers,
                        resolve: resolve,
                        reject: reject
                    });
                }).catch(reject);
            });
        }).then(undefined, function(reason) {
            // It's either buffer rejection or any other xhr/fetch error, which are treated as NetworkError.
            if (reason instanceof (0, $b17Q6.SentryError)) _this.recordLostEvent('queue_overflow', sentryRequest.type);
            else _this.recordLostEvent('network_error', sentryRequest.type);
            throw reason;
        });
    };
    return FetchTransport;
}((0, $hZuUW.BaseTransport));

});
parcelRegister("hZuUW", function(module, exports) {

$parcel$export(module.exports, "BaseTransport", () => $d1901dbbc4f5b26b$export$74b99d619e90f481);

var $3VFsf = parcelRequire("3VFsf");

var $74I1Q = parcelRequire("74I1Q");
var $eo4PV = parcelRequire("eo4PV");
parcelRequire("8KVVB");
var $jk0Xn = parcelRequire("jk0Xn");
var $2rF5w = parcelRequire("2rF5w");
var $gSiM6 = parcelRequire("gSiM6");
var $aGIlP = parcelRequire("aGIlP");
var $35A7f = parcelRequire("35A7f");
var $4geCF = parcelRequire("4geCF");
var $9aaXP = parcelRequire("9aaXP");
var $e1x9C = parcelRequire("e1x9C");

var $l97zN = parcelRequire("l97zN");

var $4pdWf = parcelRequire("4pdWf");
function $d1901dbbc4f5b26b$var$requestTypeToCategory(ty) {
    var tyStr = ty;
    return tyStr === 'event' ? 'error' : tyStr;
}
var $d1901dbbc4f5b26b$var$global = (0, $35A7f.getGlobalObject)();
/** Base Transport class implementation */ var $d1901dbbc4f5b26b$export$74b99d619e90f481 = /** @class */ function() {
    function BaseTransport(options) {
        var _this = this;
        this.options = options;
        /** A simple buffer holding all requests. */ this._buffer = (0, $9aaXP.makePromiseBuffer)(30);
        /** Locks transport after receiving rate limits in a response */ this._rateLimits = {};
        this._outcomes = {};
        this._api = (0, $eo4PV.initAPIDetails)(options.dsn, options._metadata, options.tunnel);
        // eslint-disable-next-line deprecation/deprecation
        this.url = (0, $eo4PV.getStoreEndpointWithUrlEncodedAuth)(this._api.dsn);
        if (this.options.sendClientReports && $d1901dbbc4f5b26b$var$global.document) $d1901dbbc4f5b26b$var$global.document.addEventListener('visibilitychange', function() {
            if ($d1901dbbc4f5b26b$var$global.document.visibilityState === 'hidden') _this._flushOutcomes();
        });
    }
    /**
     * @inheritDoc
     */ BaseTransport.prototype.sendEvent = function(event) {
        return this._sendRequest((0, $74I1Q.eventToSentryRequest)(event, this._api), event);
    };
    /**
     * @inheritDoc
     */ BaseTransport.prototype.sendSession = function(session) {
        return this._sendRequest((0, $74I1Q.sessionToSentryRequest)(session, this._api), session);
    };
    /**
     * @inheritDoc
     */ BaseTransport.prototype.close = function(timeout) {
        return this._buffer.drain(timeout);
    };
    /**
     * @inheritDoc
     */ BaseTransport.prototype.recordLostEvent = function(reason, category) {
        var _a;
        if (!this.options.sendClientReports) return;
        // We want to track each category (event, transaction, session) separately
        // but still keep the distinction between different type of outcomes.
        // We could use nested maps, but it's much easier to read and type this way.
        // A correct type for map-based implementation if we want to go that route
        // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
        var key = $d1901dbbc4f5b26b$var$requestTypeToCategory(category) + ":" + reason;
        (0, $l97zN.IS_DEBUG_BUILD) && (0, $4geCF.logger).log("Adding outcome: " + key);
        this._outcomes[key] = (_a = this._outcomes[key], _a !== null && _a !== void 0 ? _a : 0) + 1;
    };
    /**
     * Send outcomes as an envelope
     */ BaseTransport.prototype._flushOutcomes = function() {
        if (!this.options.sendClientReports) return;
        var outcomes = this._outcomes;
        this._outcomes = {};
        // Nothing to send
        if (!Object.keys(outcomes).length) {
            (0, $l97zN.IS_DEBUG_BUILD) && (0, $4geCF.logger).log('No outcomes to flush');
            return;
        }
        (0, $l97zN.IS_DEBUG_BUILD) && (0, $4geCF.logger).log("Flushing outcomes:\n" + JSON.stringify(outcomes, null, 2));
        var url = (0, $eo4PV.getEnvelopeEndpointWithUrlEncodedAuth)(this._api.dsn, this._api.tunnel);
        var discardedEvents = Object.keys(outcomes).map(function(key) {
            var _a = (0, $3VFsf.__read)(key.split(':'), 2), category = _a[0], reason = _a[1];
            return {
                reason: reason,
                category: category,
                quantity: outcomes[key]
            };
        // TODO: Improve types on discarded_events to get rid of cast
        });
        var envelope = (0, $jk0Xn.createClientReportEnvelope)(discardedEvents, this._api.tunnel && (0, $gSiM6.dsnToString)(this._api.dsn));
        try {
            (0, $4pdWf.sendReport)(url, (0, $e1x9C.serializeEnvelope)(envelope));
        } catch (e) {
            (0, $l97zN.IS_DEBUG_BUILD) && (0, $4geCF.logger).error(e);
        }
    };
    /**
     * Handle Sentry repsonse for promise-based transports.
     */ BaseTransport.prototype._handleResponse = function(_a) {
        var requestType = _a.requestType, response = _a.response, headers = _a.headers, resolve = _a.resolve, reject = _a.reject;
        var status = (0, $aGIlP.eventStatusFromHttpCode)(response.status);
        this._rateLimits = (0, $2rF5w.updateRateLimits)(this._rateLimits, headers);
        // eslint-disable-next-line deprecation/deprecation
        if (this._isRateLimited(requestType)) (0, $l97zN.IS_DEBUG_BUILD) && // eslint-disable-next-line deprecation/deprecation
        (0, $4geCF.logger).warn("Too many " + requestType + " requests, backing off until: " + this._disabledUntil(requestType));
        if (status === 'success') {
            resolve({
                status: status
            });
            return;
        }
        reject(response);
    };
    /**
     * Gets the time that given category is disabled until for rate limiting
     *
     * @deprecated Please use `disabledUntil` from @sentry/utils
     */ BaseTransport.prototype._disabledUntil = function(requestType) {
        var category = $d1901dbbc4f5b26b$var$requestTypeToCategory(requestType);
        return new Date((0, $2rF5w.disabledUntil)(this._rateLimits, category));
    };
    /**
     * Checks if a category is rate limited
     *
     * @deprecated Please use `isRateLimited` from @sentry/utils
     */ BaseTransport.prototype._isRateLimited = function(requestType) {
        var category = $d1901dbbc4f5b26b$var$requestTypeToCategory(requestType);
        return (0, $2rF5w.isRateLimited)(this._rateLimits, category);
    };
    return BaseTransport;
}();

});
parcelRegister("l97zN", function(module, exports) {

$parcel$export(module.exports, "IS_DEBUG_BUILD", () => $f65050bba670d163$export$48a8984ec0bf2e44);
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */ /** Flag that is true for debug builds, false otherwise. */ var $f65050bba670d163$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;

});

parcelRegister("4pdWf", function(module, exports) {

$parcel$export(module.exports, "getNativeFetchImplementation", () => $33544f207336afe5$export$8be2119ce08e3379);
$parcel$export(module.exports, "sendReport", () => $33544f207336afe5$export$84bb63b2c17ec44d);
parcelRequire("8KVVB");
var $dYkdu = parcelRequire("dYkdu");
var $35A7f = parcelRequire("35A7f");
var $ci1rH = parcelRequire("ci1rH");
var $4geCF = parcelRequire("4geCF");

var $l97zN = parcelRequire("l97zN");
var $33544f207336afe5$var$global = (0, $35A7f.getGlobalObject)();
var $33544f207336afe5$var$cachedFetchImpl;
function $33544f207336afe5$export$8be2119ce08e3379() {
    if ($33544f207336afe5$var$cachedFetchImpl) return $33544f207336afe5$var$cachedFetchImpl;
    /* eslint-disable @typescript-eslint/unbound-method */ // Fast path to avoid DOM I/O
    if ((0, $ci1rH.isNativeFetch)($33544f207336afe5$var$global.fetch)) return $33544f207336afe5$var$cachedFetchImpl = $33544f207336afe5$var$global.fetch.bind($33544f207336afe5$var$global);
    var document = $33544f207336afe5$var$global.document;
    var fetchImpl = $33544f207336afe5$var$global.fetch;
    // eslint-disable-next-line deprecation/deprecation
    if (document && typeof document.createElement === 'function') try {
        var sandbox = document.createElement('iframe');
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        var contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow.fetch) fetchImpl = contentWindow.fetch;
        document.head.removeChild(sandbox);
    } catch (e) {
        (0, $l97zN.IS_DEBUG_BUILD) && (0, $4geCF.logger).warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', e);
    }
    return $33544f207336afe5$var$cachedFetchImpl = fetchImpl.bind($33544f207336afe5$var$global);
/* eslint-enable @typescript-eslint/unbound-method */ }
function $33544f207336afe5$export$84bb63b2c17ec44d(url, body) {
    var isRealNavigator = Object.prototype.toString.call($33544f207336afe5$var$global && $33544f207336afe5$var$global.navigator) === '[object Navigator]';
    var hasSendBeacon = isRealNavigator && typeof $33544f207336afe5$var$global.navigator.sendBeacon === 'function';
    if (hasSendBeacon) {
        // Prevent illegal invocations - https://xgwang.me/posts/you-may-not-know-beacon/#it-may-throw-error%2C-be-sure-to-catch
        var sendBeacon = $33544f207336afe5$var$global.navigator.sendBeacon.bind($33544f207336afe5$var$global.navigator);
        return sendBeacon(url, body);
    }
    if ((0, $ci1rH.supportsFetch)()) {
        var fetch_1 = $33544f207336afe5$export$8be2119ce08e3379();
        return (0, $dYkdu.forget)(fetch_1(url, {
            body: body,
            method: 'POST',
            credentials: 'omit',
            keepalive: true
        }));
    }
}

});



parcelRegister("j0yJv", function(module, exports) {

$parcel$export(module.exports, "makeNewFetchTransport", () => $dd68f5a63b9639f9$export$1c57e6bfd09bad13);

var $3VFsf = parcelRequire("3VFsf");

var $l15lu = parcelRequire("l15lu");

var $4pdWf = parcelRequire("4pdWf");
function $dd68f5a63b9639f9$export$1c57e6bfd09bad13(options, nativeFetch) {
    if (nativeFetch === void 0) nativeFetch = (0, $4pdWf.getNativeFetchImplementation)();
    function makeRequest(request) {
        var requestOptions = (0, $3VFsf.__assign)({
            body: request.body,
            method: 'POST',
            referrerPolicy: 'origin'
        }, options.requestOptions);
        return nativeFetch(options.url, requestOptions).then(function(response) {
            return response.text().then(function(body) {
                return {
                    body: body,
                    headers: {
                        'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
                        'retry-after': response.headers.get('Retry-After')
                    },
                    reason: response.statusText,
                    statusCode: response.status
                };
            });
        });
    }
    return (0, $l15lu.createTransport)({
        bufferSize: options.bufferSize
    }, makeRequest);
}

});
parcelRegister("l15lu", function(module, exports) {

$parcel$export(module.exports, "createTransport", () => $f4cdd67afa492495$export$d09f50d9ab7f7b69);
parcelRequire("8KVVB");
var $2rF5w = parcelRequire("2rF5w");
var $aGIlP = parcelRequire("aGIlP");
var $e1x9C = parcelRequire("e1x9C");
var $9aaXP = parcelRequire("9aaXP");
var $3X7U8 = parcelRequire("3X7U8");
var $f4cdd67afa492495$export$d8a725a7dce95622 = 'error';
var $f4cdd67afa492495$export$99adc6fe67a3c63e = 'transaction';
var $f4cdd67afa492495$export$9d7ad34f132fe68f = 'attachment';
var $f4cdd67afa492495$export$42d9e7b5fc564c45 = 'session';
var $f4cdd67afa492495$export$e515cf6dfd2f98b8 = 30;
function $f4cdd67afa492495$export$d09f50d9ab7f7b69(options, makeRequest, buffer) {
    if (buffer === void 0) buffer = (0, $9aaXP.makePromiseBuffer)(options.bufferSize || $f4cdd67afa492495$export$e515cf6dfd2f98b8);
    var rateLimits = {};
    var flush = function(timeout) {
        return buffer.drain(timeout);
    };
    function send(envelope) {
        var envCategory = (0, $e1x9C.getEnvelopeType)(envelope);
        var category = envCategory === 'event' ? 'error' : envCategory;
        var request = {
            category: category,
            body: (0, $e1x9C.serializeEnvelope)(envelope)
        };
        // Don't add to buffer if transport is already rate-limited
        if ((0, $2rF5w.isRateLimited)(rateLimits, category)) return (0, $3X7U8.rejectedSyncPromise)({
            status: 'rate_limit',
            reason: $f4cdd67afa492495$var$getRateLimitReason(rateLimits, category)
        });
        var requestTask = function() {
            return makeRequest(request).then(function(_a) {
                var body = _a.body, headers = _a.headers, reason = _a.reason, statusCode = _a.statusCode;
                var status = (0, $aGIlP.eventStatusFromHttpCode)(statusCode);
                if (headers) rateLimits = (0, $2rF5w.updateRateLimits)(rateLimits, headers);
                if (status === 'success') return (0, $3X7U8.resolvedSyncPromise)({
                    status: status,
                    reason: reason
                });
                return (0, $3X7U8.rejectedSyncPromise)({
                    status: status,
                    reason: reason || body || (status === 'rate_limit' ? $f4cdd67afa492495$var$getRateLimitReason(rateLimits, category) : 'Unknown transport error')
                });
            });
        };
        return buffer.add(requestTask);
    }
    return {
        send: send,
        flush: flush
    };
}
function $f4cdd67afa492495$var$getRateLimitReason(rateLimits, category) {
    return "Too many " + category + " requests, backing off until: " + new Date((0, $2rF5w.disabledUntil)(rateLimits, category)).toISOString();
}

});


parcelRegister("9FggM", function(module, exports) {

$parcel$export(module.exports, "makeNewXHRTransport", () => $709490302946f0a5$export$4c0ac1dd4bbf4921);

var $l15lu = parcelRequire("l15lu");
parcelRequire("8KVVB");
var $3X7U8 = parcelRequire("3X7U8");
/**
 * The DONE ready state for XmlHttpRequest
 *
 * Defining it here as a constant b/c XMLHttpRequest.DONE is not always defined
 * (e.g. during testing, it is `undefined`)
 *
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/readyState}
 */ var $709490302946f0a5$var$XHR_READYSTATE_DONE = 4;
function $709490302946f0a5$export$4c0ac1dd4bbf4921(options) {
    function makeRequest(request) {
        return new (0, $3X7U8.SyncPromise)(function(resolve, _reject) {
            var xhr = new XMLHttpRequest();
            xhr.onreadystatechange = function() {
                if (xhr.readyState === $709490302946f0a5$var$XHR_READYSTATE_DONE) {
                    var response = {
                        body: xhr.response,
                        headers: {
                            'x-sentry-rate-limits': xhr.getResponseHeader('X-Sentry-Rate-Limits'),
                            'retry-after': xhr.getResponseHeader('Retry-After')
                        },
                        reason: xhr.statusText,
                        statusCode: xhr.status
                    };
                    resolve(response);
                }
            };
            xhr.open('POST', options.url);
            for(var header in options.headers)if (Object.prototype.hasOwnProperty.call(options.headers, header)) xhr.setRequestHeader(header, options.headers[header]);
            xhr.send(request.body);
        });
    }
    return (0, $l15lu.createTransport)({
        bufferSize: options.bufferSize
    }, makeRequest);
}

});

parcelRegister("li9k9", function(module, exports) {

$parcel$export(module.exports, "XHRTransport", () => $f80282f2edc4209e$export$874a283af77e8e62);

var $3VFsf = parcelRequire("3VFsf");
parcelRequire("8KVVB");
var $b17Q6 = parcelRequire("b17Q6");
var $3X7U8 = parcelRequire("3X7U8");

var $hZuUW = parcelRequire("hZuUW");
/** `XHR` based transport */ var $f80282f2edc4209e$export$874a283af77e8e62 = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(XHRTransport, _super);
    function XHRTransport() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @param sentryRequest Prepared SentryRequest to be delivered
     * @param originalPayload Original payload used to create SentryRequest
     */ XHRTransport.prototype._sendRequest = function(sentryRequest, originalPayload) {
        var _this = this;
        // eslint-disable-next-line deprecation/deprecation
        if (this._isRateLimited(sentryRequest.type)) {
            this.recordLostEvent('ratelimit_backoff', sentryRequest.type);
            return Promise.reject({
                event: originalPayload,
                type: sentryRequest.type,
                // eslint-disable-next-line deprecation/deprecation
                reason: "Transport for " + sentryRequest.type + " requests locked till " + this._disabledUntil(sentryRequest.type) + " due to too many requests.",
                status: 429
            });
        }
        return this._buffer.add(function() {
            return new (0, $3X7U8.SyncPromise)(function(resolve, reject) {
                var request = new XMLHttpRequest();
                request.onreadystatechange = function() {
                    if (request.readyState === 4) {
                        var headers = {
                            'x-sentry-rate-limits': request.getResponseHeader('X-Sentry-Rate-Limits'),
                            'retry-after': request.getResponseHeader('Retry-After')
                        };
                        _this._handleResponse({
                            requestType: sentryRequest.type,
                            response: request,
                            headers: headers,
                            resolve: resolve,
                            reject: reject
                        });
                    }
                };
                request.open('POST', sentryRequest.url);
                for(var header in _this.options.headers)if (Object.prototype.hasOwnProperty.call(_this.options.headers, header)) request.setRequestHeader(header, _this.options.headers[header]);
                request.send(sentryRequest.body);
            });
        }).then(undefined, function(reason) {
            // It's either buffer rejection or any other xhr/fetch error, which are treated as NetworkError.
            if (reason instanceof (0, $b17Q6.SentryError)) _this.recordLostEvent('queue_overflow', sentryRequest.type);
            else _this.recordLostEvent('network_error', sentryRequest.type);
            throw reason;
        });
    };
    return XHRTransport;
}((0, $hZuUW.BaseTransport));

});


parcelRegister("9aSEL", function(module, exports) {

$parcel$export(module.exports, "shouldIgnoreOnError", () => $6adf71defd0a32ad$export$b79738ab10c590b2);
$parcel$export(module.exports, "wrap", () => $6adf71defd0a32ad$export$4997ffc0176396a6);
$parcel$export(module.exports, "injectReportDialog", () => $6adf71defd0a32ad$export$deb9aac8ea0b576c);

var $3VFsf = parcelRequire("3VFsf");

var $7zHWg = parcelRequire("7zHWg");
var $eo4PV = parcelRequire("eo4PV");
parcelRequire("8KVVB");
var $jyUiA = parcelRequire("jyUiA");
var $1l3DN = parcelRequire("1l3DN");
var $35A7f = parcelRequire("35A7f");
var $4geCF = parcelRequire("4geCF");

var $l97zN = parcelRequire("l97zN");
var $6adf71defd0a32ad$var$global = (0, $35A7f.getGlobalObject)();
var $6adf71defd0a32ad$var$ignoreOnError = 0;
function $6adf71defd0a32ad$export$b79738ab10c590b2() {
    return $6adf71defd0a32ad$var$ignoreOnError > 0;
}
function $6adf71defd0a32ad$export$1265a142ff5ba165() {
    // onerror should trigger before setTimeout
    $6adf71defd0a32ad$var$ignoreOnError += 1;
    setTimeout(function() {
        $6adf71defd0a32ad$var$ignoreOnError -= 1;
    });
}
function $6adf71defd0a32ad$export$4997ffc0176396a6(fn, options, before) {
    // for future readers what this does is wrap a function and then create
    // a bi-directional wrapping between them.
    //
    // example: wrapped = wrap(original);
    //  original.__sentry_wrapped__ -> wrapped
    //  wrapped.__sentry_original__ -> original
    if (options === void 0) options = {};
    if (typeof fn !== 'function') return fn;
    try {
        // if we're dealing with a function that was previously wrapped, return
        // the original wrapper.
        var wrapper = fn.__sentry_wrapped__;
        if (wrapper) return wrapper;
        // We don't wanna wrap it twice
        if ((0, $1l3DN.getOriginalFunction)(fn)) return fn;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    /* eslint-disable prefer-rest-params */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var sentryWrapped = function() {
        var args = Array.prototype.slice.call(arguments);
        try {
            if (before && typeof before === 'function') before.apply(this, arguments);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
            var wrappedArguments = args.map(function(arg) {
                return $6adf71defd0a32ad$export$4997ffc0176396a6(arg, options);
            });
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            $6adf71defd0a32ad$export$1265a142ff5ba165();
            (0, $7zHWg.withScope)(function(scope) {
                scope.addEventProcessor(function(event) {
                    if (options.mechanism) {
                        (0, $jyUiA.addExceptionTypeValue)(event, undefined, undefined);
                        (0, $jyUiA.addExceptionMechanism)(event, options.mechanism);
                    }
                    event.extra = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, event.extra), {
                        arguments: args
                    });
                    return event;
                });
                (0, $7zHWg.captureException)(ex);
            });
            throw ex;
        }
    };
    /* eslint-enable prefer-rest-params */ // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    try {
        for(var property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch (_oO) {} // eslint-disable-line no-empty
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    (0, $1l3DN.markFunctionWrapped)(sentryWrapped, fn);
    (0, $1l3DN.addNonEnumerableProperty)(fn, '__sentry_wrapped__', sentryWrapped);
    // Restore original function name (not all browsers allow that)
    try {
        var descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, 'name');
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, 'name', {
            get: function() {
                return fn.name;
            }
        });
    // eslint-disable-next-line no-empty
    } catch (_oO) {}
    return sentryWrapped;
}
function $6adf71defd0a32ad$export$deb9aac8ea0b576c(options) {
    if (options === void 0) options = {};
    if (!$6adf71defd0a32ad$var$global.document) return;
    if (!options.eventId) {
        (0, $l97zN.IS_DEBUG_BUILD) && (0, $4geCF.logger).error('Missing eventId option in showReportDialog call');
        return;
    }
    if (!options.dsn) {
        (0, $l97zN.IS_DEBUG_BUILD) && (0, $4geCF.logger).error('Missing dsn option in showReportDialog call');
        return;
    }
    var script = $6adf71defd0a32ad$var$global.document.createElement('script');
    script.async = true;
    script.src = (0, $eo4PV.getReportDialogEndpoint)(options.dsn, options);
    if (options.onLoad) // eslint-disable-next-line @typescript-eslint/unbound-method
    script.onload = options.onLoad;
    var injectionPoint = $6adf71defd0a32ad$var$global.document.head || $6adf71defd0a32ad$var$global.document.body;
    if (injectionPoint) injectionPoint.appendChild(script);
}

});

parcelRegister("5Z1NC", function(module, exports) {

$parcel$export(module.exports, "Breadcrumbs", () => $45b40b8d79a6890b$export$2dc68d50d56fbbd);

var $3VFsf = parcelRequire("3VFsf");

var $3kk8J = parcelRequire("3kk8J");

var $4aybe = parcelRequire("4aybe");
parcelRequire("8KVVB");
var $1sgxX = parcelRequire("1sgxX");
var $jyUiA = parcelRequire("jyUiA");
var $35A7f = parcelRequire("35A7f");
var $7yHR0 = parcelRequire("7yHR0");
var $jOwKr = parcelRequire("jOwKr");
var $n3F4l = parcelRequire("n3F4l");
/**
 * Default Breadcrumbs instrumentations
 * TODO: Deprecated - with v6, this will be renamed to `Instrument`
 */ var $45b40b8d79a6890b$export$2dc68d50d56fbbd = /** @class */ function() {
    /**
     * @inheritDoc
     */ function Breadcrumbs(options) {
        /**
         * @inheritDoc
         */ this.name = Breadcrumbs.id;
        this._options = (0, $3VFsf.__assign)({
            console: true,
            dom: true,
            fetch: true,
            history: true,
            sentry: true,
            xhr: true
        }, options);
    }
    /**
     * Create a breadcrumb of `sentry` from the events themselves
     */ Breadcrumbs.prototype.addSentryBreadcrumb = function(event) {
        if (!this._options.sentry) return;
        (0, $3kk8J.getCurrentHub)().addBreadcrumb({
            category: "sentry." + (event.type === 'transaction' ? 'transaction' : 'event'),
            event_id: event.event_id,
            level: event.level,
            message: (0, $jyUiA.getEventDescription)(event)
        }, {
            event: event
        });
    };
    /**
     * Instrument browser built-ins w/ breadcrumb capturing
     *  - Console API
     *  - DOM API (click/typing)
     *  - XMLHttpRequest API
     *  - Fetch API
     *  - History API
     */ Breadcrumbs.prototype.setupOnce = function() {
        if (this._options.console) (0, $1sgxX.addInstrumentationHandler)('console', $45b40b8d79a6890b$var$_consoleBreadcrumb);
        if (this._options.dom) (0, $1sgxX.addInstrumentationHandler)('dom', $45b40b8d79a6890b$var$_domBreadcrumb(this._options.dom));
        if (this._options.xhr) (0, $1sgxX.addInstrumentationHandler)('xhr', $45b40b8d79a6890b$var$_xhrBreadcrumb);
        if (this._options.fetch) (0, $1sgxX.addInstrumentationHandler)('fetch', $45b40b8d79a6890b$var$_fetchBreadcrumb);
        if (this._options.history) (0, $1sgxX.addInstrumentationHandler)('history', $45b40b8d79a6890b$var$_historyBreadcrumb);
    };
    /**
     * @inheritDoc
     */ Breadcrumbs.id = 'Breadcrumbs';
    return Breadcrumbs;
}();
/**
 * A HOC that creaes a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $45b40b8d79a6890b$var$_domBreadcrumb(dom) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function _innerDomBreadcrumb(handlerData) {
        var target;
        var keyAttrs = typeof dom === 'object' ? dom.serializeAttribute : undefined;
        if (typeof keyAttrs === 'string') keyAttrs = [
            keyAttrs
        ];
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            target = handlerData.event.target ? (0, $7yHR0.htmlTreeAsString)(handlerData.event.target, keyAttrs) : (0, $7yHR0.htmlTreeAsString)(handlerData.event, keyAttrs);
        } catch (e) {
            target = '<unknown>';
        }
        if (target.length === 0) return;
        (0, $3kk8J.getCurrentHub)().addBreadcrumb({
            category: "ui." + handlerData.name,
            message: target
        }, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    }
    return _innerDomBreadcrumb;
}
/**
 * Creates breadcrumbs from console API calls
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $45b40b8d79a6890b$var$_consoleBreadcrumb(handlerData) {
    var breadcrumb = {
        category: 'console',
        data: {
            arguments: handlerData.args,
            logger: 'console'
        },
        level: (0, $n3F4l.severityFromString)(handlerData.level),
        message: (0, $jOwKr.safeJoin)(handlerData.args, ' ')
    };
    if (handlerData.level === 'assert') {
        if (handlerData.args[0] === false) {
            breadcrumb.message = "Assertion failed: " + ((0, $jOwKr.safeJoin)(handlerData.args.slice(1), ' ') || 'console.assert');
            breadcrumb.data.arguments = handlerData.args.slice(1);
        } else // Don't capture a breadcrumb for passed assertions
        return;
    }
    (0, $3kk8J.getCurrentHub)().addBreadcrumb(breadcrumb, {
        input: handlerData.args,
        level: handlerData.level
    });
}
/**
 * Creates breadcrumbs from XHR API calls
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $45b40b8d79a6890b$var$_xhrBreadcrumb(handlerData) {
    if (handlerData.endTimestamp) {
        // We only capture complete, non-sentry requests
        if (handlerData.xhr.__sentry_own_request__) return;
        var _a = handlerData.xhr.__sentry_xhr__ || {}, method = _a.method, url = _a.url, status_code = _a.status_code, body = _a.body;
        (0, $3kk8J.getCurrentHub)().addBreadcrumb({
            category: 'xhr',
            data: {
                method: method,
                url: url,
                status_code: status_code
            },
            type: 'http'
        }, {
            xhr: handlerData.xhr,
            input: body
        });
        return;
    }
}
/**
 * Creates breadcrumbs from fetch API calls
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $45b40b8d79a6890b$var$_fetchBreadcrumb(handlerData) {
    // We only capture complete fetch requests
    if (!handlerData.endTimestamp) return;
    if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === 'POST') // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
    return;
    if (handlerData.error) (0, $3kk8J.getCurrentHub)().addBreadcrumb({
        category: 'fetch',
        data: handlerData.fetchData,
        level: (0, $4aybe.Severity).Error,
        type: 'http'
    }, {
        data: handlerData.error,
        input: handlerData.args
    });
    else (0, $3kk8J.getCurrentHub)().addBreadcrumb({
        category: 'fetch',
        data: (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, handlerData.fetchData), {
            status_code: handlerData.response.status
        }),
        type: 'http'
    }, {
        input: handlerData.args,
        response: handlerData.response
    });
}
/**
 * Creates breadcrumbs from history API calls
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $45b40b8d79a6890b$var$_historyBreadcrumb(handlerData) {
    var global = (0, $35A7f.getGlobalObject)();
    var from = handlerData.from;
    var to = handlerData.to;
    var parsedLoc = (0, $jyUiA.parseUrl)(global.location.href);
    var parsedFrom = (0, $jyUiA.parseUrl)(from);
    var parsedTo = (0, $jyUiA.parseUrl)(to);
    // Initial pushState doesn't provide `from` information
    if (!parsedFrom.path) parsedFrom = parsedLoc;
    // Use only the path component of the URL if the URL matches the current
    // document (almost all the time when using pushState)
    if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
    if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
    (0, $3kk8J.getCurrentHub)().addBreadcrumb({
        category: 'navigation',
        data: {
            from: from,
            to: to
        }
    });
}

});


parcelRegister("ilDeH", function(module, exports) {

$parcel$export(module.exports, "Dedupe", () => $d5b89f9e1dbfa430$export$688d98c249d31ad3);
parcelRequire("8KVVB");
var $4geCF = parcelRequire("4geCF");

var $l97zN = parcelRequire("l97zN");
/** Deduplication filter */ var $d5b89f9e1dbfa430$export$688d98c249d31ad3 = /** @class */ function() {
    function Dedupe() {
        /**
         * @inheritDoc
         */ this.name = Dedupe.id;
    }
    /**
     * @inheritDoc
     */ Dedupe.prototype.setupOnce = function(addGlobalEventProcessor, getCurrentHub) {
        addGlobalEventProcessor(function(currentEvent) {
            var self = getCurrentHub().getIntegration(Dedupe);
            if (self) {
                // Juuust in case something goes wrong
                try {
                    if ($d5b89f9e1dbfa430$var$_shouldDropEvent(currentEvent, self._previousEvent)) {
                        (0, $l97zN.IS_DEBUG_BUILD) && (0, $4geCF.logger).warn('Event dropped due to being a duplicate of previously captured event.');
                        return null;
                    }
                } catch (_oO) {
                    return self._previousEvent = currentEvent;
                }
                return self._previousEvent = currentEvent;
            }
            return currentEvent;
        });
    };
    /**
     * @inheritDoc
     */ Dedupe.id = 'Dedupe';
    return Dedupe;
}();
/** JSDoc */ function $d5b89f9e1dbfa430$var$_shouldDropEvent(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($d5b89f9e1dbfa430$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($d5b89f9e1dbfa430$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
/** JSDoc */ function $d5b89f9e1dbfa430$var$_isSameMessageEvent(currentEvent, previousEvent) {
    var currentMessage = currentEvent.message;
    var previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$d5b89f9e1dbfa430$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$d5b89f9e1dbfa430$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
/** JSDoc */ function $d5b89f9e1dbfa430$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    var previousException = $d5b89f9e1dbfa430$var$_getExceptionFromEvent(previousEvent);
    var currentException = $d5b89f9e1dbfa430$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$d5b89f9e1dbfa430$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$d5b89f9e1dbfa430$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
/** JSDoc */ function $d5b89f9e1dbfa430$var$_isSameStacktrace(currentEvent, previousEvent) {
    var currentFrames = $d5b89f9e1dbfa430$var$_getFramesFromEvent(currentEvent);
    var previousFrames = $d5b89f9e1dbfa430$var$_getFramesFromEvent(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(var i = 0; i < previousFrames.length; i++){
        var frameA = previousFrames[i];
        var frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
/** JSDoc */ function $d5b89f9e1dbfa430$var$_isSameFingerprint(currentEvent, previousEvent) {
    var currentFingerprint = currentEvent.fingerprint;
    var previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join('') === previousFingerprint.join(''));
    } catch (_oO) {
        return false;
    }
}
/** JSDoc */ function $d5b89f9e1dbfa430$var$_getExceptionFromEvent(event) {
    return event.exception && event.exception.values && event.exception.values[0];
}
/** JSDoc */ function $d5b89f9e1dbfa430$var$_getFramesFromEvent(event) {
    var exception = event.exception;
    if (exception) try {
        // @ts-ignore Object could be undefined
        return exception.values[0].stacktrace.frames;
    } catch (_oO) {
        return undefined;
    }
    else if (event.stacktrace) return event.stacktrace.frames;
    return undefined;
}

});

parcelRegister("ijPmO", function(module, exports) {

$parcel$export(module.exports, "GlobalHandlers", () => $d561d8bc9ed14bc0$export$204155decbc90e5a);

var $3VFsf = parcelRequire("3VFsf");

var $3kk8J = parcelRequire("3kk8J");

var $4aybe = parcelRequire("4aybe");
parcelRequire("8KVVB");
var $jyUiA = parcelRequire("jyUiA");
var $1sgxX = parcelRequire("1sgxX");
var $7yHR0 = parcelRequire("7yHR0");
var $gkmq5 = parcelRequire("gkmq5");
var $4geCF = parcelRequire("4geCF");

var $j0O65 = parcelRequire("j0O65");

var $l97zN = parcelRequire("l97zN");

var $9aSEL = parcelRequire("9aSEL");
/** Global handlers */ var $d561d8bc9ed14bc0$export$204155decbc90e5a = /** @class */ function() {
    /** JSDoc */ function GlobalHandlers(options) {
        /**
         * @inheritDoc
         */ this.name = GlobalHandlers.id;
        /**
         * Stores references functions to installing handlers. Will set to undefined
         * after they have been run so that they are not used twice.
         */ this._installFunc = {
            onerror: $d561d8bc9ed14bc0$var$_installGlobalOnErrorHandler,
            onunhandledrejection: $d561d8bc9ed14bc0$var$_installGlobalOnUnhandledRejectionHandler
        };
        this._options = (0, $3VFsf.__assign)({
            onerror: true,
            onunhandledrejection: true
        }, options);
    }
    /**
     * @inheritDoc
     */ GlobalHandlers.prototype.setupOnce = function() {
        Error.stackTraceLimit = 50;
        var options = this._options;
        // We can disable guard-for-in as we construct the options object above + do checks against
        // `this._installFunc` for the property.
        // eslint-disable-next-line guard-for-in
        for(var key in options){
            var installFunc = this._installFunc[key];
            if (installFunc && options[key]) {
                $d561d8bc9ed14bc0$var$globalHandlerLog(key);
                installFunc();
                this._installFunc[key] = undefined;
            }
        }
    };
    /**
     * @inheritDoc
     */ GlobalHandlers.id = 'GlobalHandlers';
    return GlobalHandlers;
}();
/** JSDoc */ function $d561d8bc9ed14bc0$var$_installGlobalOnErrorHandler() {
    (0, $1sgxX.addInstrumentationHandler)('error', // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function(data) {
        var _a = (0, $3VFsf.__read)($d561d8bc9ed14bc0$var$getHubAndAttachStacktrace(), 2), hub = _a[0], attachStacktrace = _a[1];
        if (!hub.getIntegration($d561d8bc9ed14bc0$export$204155decbc90e5a)) return;
        var msg = data.msg, url = data.url, line = data.line, column = data.column, error = data.error;
        if ((0, $9aSEL.shouldIgnoreOnError)() || error && error.__sentry_own_request__) return;
        var event = error === undefined && (0, $gkmq5.isString)(msg) ? $d561d8bc9ed14bc0$var$_eventFromIncompleteOnError(msg, url, line, column) : $d561d8bc9ed14bc0$var$_enhanceEventWithInitialFrame((0, $j0O65.eventFromUnknownInput)(error || msg, undefined, attachStacktrace, false), url, line, column);
        event.level = (0, $4aybe.Severity).Error;
        $d561d8bc9ed14bc0$var$addMechanismAndCapture(hub, error, event, 'onerror');
    });
}
/** JSDoc */ function $d561d8bc9ed14bc0$var$_installGlobalOnUnhandledRejectionHandler() {
    (0, $1sgxX.addInstrumentationHandler)('unhandledrejection', // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function(e) {
        var _a = (0, $3VFsf.__read)($d561d8bc9ed14bc0$var$getHubAndAttachStacktrace(), 2), hub = _a[0], attachStacktrace = _a[1];
        if (!hub.getIntegration($d561d8bc9ed14bc0$export$204155decbc90e5a)) return;
        var error = e;
        // dig the object of the rejection out of known event types
        try {
            // PromiseRejectionEvents store the object of the rejection under 'reason'
            // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
            if ('reason' in e) error = e.reason;
            else if ('detail' in e && 'reason' in e.detail) error = e.detail.reason;
        } catch (_oO) {
        // no-empty
        }
        if ((0, $9aSEL.shouldIgnoreOnError)() || error && error.__sentry_own_request__) return true;
        var event = (0, $gkmq5.isPrimitive)(error) ? $d561d8bc9ed14bc0$var$_eventFromRejectionWithPrimitive(error) : (0, $j0O65.eventFromUnknownInput)(error, undefined, attachStacktrace, true);
        event.level = (0, $4aybe.Severity).Error;
        $d561d8bc9ed14bc0$var$addMechanismAndCapture(hub, error, event, 'onunhandledrejection');
        return;
    });
}
/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */ function $d561d8bc9ed14bc0$var$_eventFromRejectionWithPrimitive(reason) {
    return {
        exception: {
            values: [
                {
                    type: 'UnhandledRejection',
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: "Non-Error promise rejection captured with value: " + String(reason)
                }
            ]
        }
    };
}
/**
 * This function creates a stack from an old, error-less onerror handler.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $d561d8bc9ed14bc0$var$_eventFromIncompleteOnError(msg, url, line, column) {
    var ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
    // If 'message' is ErrorEvent, get real message from inside
    var message = (0, $gkmq5.isErrorEvent)(msg) ? msg.message : msg;
    var name = 'Error';
    var groups = message.match(ERROR_TYPES_RE);
    if (groups) {
        name = groups[1];
        message = groups[2];
    }
    var event = {
        exception: {
            values: [
                {
                    type: name,
                    value: message
                }
            ]
        }
    };
    return $d561d8bc9ed14bc0$var$_enhanceEventWithInitialFrame(event, url, line, column);
}
/** JSDoc */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $d561d8bc9ed14bc0$var$_enhanceEventWithInitialFrame(event, url, line, column) {
    // event.exception
    var e = event.exception = event.exception || {};
    // event.exception.values
    var ev = e.values = e.values || [];
    // event.exception.values[0]
    var ev0 = ev[0] = ev[0] || {};
    // event.exception.values[0].stacktrace
    var ev0s = ev0.stacktrace = ev0.stacktrace || {};
    // event.exception.values[0].stacktrace.frames
    var ev0sf = ev0s.frames = ev0s.frames || [];
    var colno = isNaN(parseInt(column, 10)) ? undefined : column;
    var lineno = isNaN(parseInt(line, 10)) ? undefined : line;
    var filename = (0, $gkmq5.isString)(url) && url.length > 0 ? url : (0, $7yHR0.getLocationHref)();
    // event.exception.values[0].stacktrace.frames
    if (ev0sf.length === 0) ev0sf.push({
        colno: colno,
        filename: filename,
        function: '?',
        in_app: true,
        lineno: lineno
    });
    return event;
}
function $d561d8bc9ed14bc0$var$globalHandlerLog(type) {
    (0, $l97zN.IS_DEBUG_BUILD) && (0, $4geCF.logger).log("Global Handler attached: " + type);
}
function $d561d8bc9ed14bc0$var$addMechanismAndCapture(hub, error, event, type) {
    (0, $jyUiA.addExceptionMechanism)(event, {
        handled: false,
        type: type
    });
    hub.captureEvent(event, {
        originalException: error
    });
}
function $d561d8bc9ed14bc0$var$getHubAndAttachStacktrace() {
    var hub = (0, $3kk8J.getCurrentHub)();
    var client = hub.getClient();
    var attachStacktrace = client && client.getOptions().attachStacktrace;
    return [
        hub,
        attachStacktrace
    ];
}

});

parcelRegister("5zMCv", function(module, exports) {

$parcel$export(module.exports, "LinkedErrors", () => $40f5ef8f867e83cc$export$8d1e60aaf616fb4f);

var $3VFsf = parcelRequire("3VFsf");

var $gfYRq = parcelRequire("gfYRq");
var $3kk8J = parcelRequire("3kk8J");
parcelRequire("8KVVB");
var $gkmq5 = parcelRequire("gkmq5");

var $j0O65 = parcelRequire("j0O65");
var $40f5ef8f867e83cc$var$DEFAULT_KEY = 'cause';
var $40f5ef8f867e83cc$var$DEFAULT_LIMIT = 5;
/** Adds SDK info to an event. */ var $40f5ef8f867e83cc$export$8d1e60aaf616fb4f = /** @class */ function() {
    /**
     * @inheritDoc
     */ function LinkedErrors(options) {
        if (options === void 0) options = {};
        /**
         * @inheritDoc
         */ this.name = LinkedErrors.id;
        this._key = options.key || $40f5ef8f867e83cc$var$DEFAULT_KEY;
        this._limit = options.limit || $40f5ef8f867e83cc$var$DEFAULT_LIMIT;
    }
    /**
     * @inheritDoc
     */ LinkedErrors.prototype.setupOnce = function() {
        (0, $gfYRq.addGlobalEventProcessor)(function(event, hint) {
            var self = (0, $3kk8J.getCurrentHub)().getIntegration(LinkedErrors);
            return self ? $40f5ef8f867e83cc$export$7bd713d0612d8839(self._key, self._limit, event, hint) : event;
        });
    };
    /**
     * @inheritDoc
     */ LinkedErrors.id = 'LinkedErrors';
    return LinkedErrors;
}();
function $40f5ef8f867e83cc$export$7bd713d0612d8839(key, limit, event, hint) {
    if (!event.exception || !event.exception.values || !hint || !(0, $gkmq5.isInstanceOf)(hint.originalException, Error)) return event;
    var linkedErrors = $40f5ef8f867e83cc$export$e4e3ecf6f8f76c75(limit, hint.originalException, key);
    event.exception.values = (0, $3VFsf.__spread)(linkedErrors, event.exception.values);
    return event;
}
function $40f5ef8f867e83cc$export$e4e3ecf6f8f76c75(limit, error, key, stack) {
    if (stack === void 0) stack = [];
    if (!(0, $gkmq5.isInstanceOf)(error[key], Error) || stack.length + 1 >= limit) return stack;
    var exception = (0, $j0O65.exceptionFromError)(error[key]);
    return $40f5ef8f867e83cc$export$e4e3ecf6f8f76c75(limit, error[key], key, (0, $3VFsf.__spread)([
        exception
    ], stack));
}

});

parcelRegister("4EoaR", function(module, exports) {

$parcel$export(module.exports, "TryCatch", () => $362da65422a63562$export$f1a018517668e6d3);

var $3VFsf = parcelRequire("3VFsf");
parcelRequire("8KVVB");
var $1l3DN = parcelRequire("1l3DN");
var $aNkwr = parcelRequire("aNkwr");
var $35A7f = parcelRequire("35A7f");

var $9aSEL = parcelRequire("9aSEL");
var $362da65422a63562$var$DEFAULT_EVENT_TARGET = [
    'EventTarget',
    'Window',
    'Node',
    'ApplicationCache',
    'AudioTrackList',
    'ChannelMergerNode',
    'CryptoOperation',
    'EventSource',
    'FileReader',
    'HTMLUnknownElement',
    'IDBDatabase',
    'IDBRequest',
    'IDBTransaction',
    'KeyOperation',
    'MediaController',
    'MessagePort',
    'ModalWindow',
    'Notification',
    'SVGElementInstance',
    'Screen',
    'TextTrack',
    'TextTrackCue',
    'TextTrackList',
    'WebSocket',
    'WebSocketWorker',
    'Worker',
    'XMLHttpRequest',
    'XMLHttpRequestEventTarget',
    'XMLHttpRequestUpload'
];
/** Wrap timer functions and event targets to catch errors and provide better meta data */ var $362da65422a63562$export$f1a018517668e6d3 = /** @class */ function() {
    /**
     * @inheritDoc
     */ function TryCatch(options) {
        /**
         * @inheritDoc
         */ this.name = TryCatch.id;
        this._options = (0, $3VFsf.__assign)({
            XMLHttpRequest: true,
            eventTarget: true,
            requestAnimationFrame: true,
            setInterval: true,
            setTimeout: true
        }, options);
    }
    /**
     * Wrap timer functions and event targets to catch errors
     * and provide better metadata.
     */ TryCatch.prototype.setupOnce = function() {
        var global = (0, $35A7f.getGlobalObject)();
        if (this._options.setTimeout) (0, $1l3DN.fill)(global, 'setTimeout', $362da65422a63562$var$_wrapTimeFunction);
        if (this._options.setInterval) (0, $1l3DN.fill)(global, 'setInterval', $362da65422a63562$var$_wrapTimeFunction);
        if (this._options.requestAnimationFrame) (0, $1l3DN.fill)(global, 'requestAnimationFrame', $362da65422a63562$var$_wrapRAF);
        if (this._options.XMLHttpRequest && 'XMLHttpRequest' in global) (0, $1l3DN.fill)(XMLHttpRequest.prototype, 'send', $362da65422a63562$var$_wrapXHR);
        var eventTargetOption = this._options.eventTarget;
        if (eventTargetOption) {
            var eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : $362da65422a63562$var$DEFAULT_EVENT_TARGET;
            eventTarget.forEach($362da65422a63562$var$_wrapEventTarget);
        }
    };
    /**
     * @inheritDoc
     */ TryCatch.id = 'TryCatch';
    return TryCatch;
}();
/** JSDoc */ function $362da65422a63562$var$_wrapTimeFunction(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var originalCallback = args[0];
        args[0] = (0, $9aSEL.wrap)(originalCallback, {
            mechanism: {
                data: {
                    function: (0, $aNkwr.getFunctionName)(original)
                },
                handled: true,
                type: 'instrument'
            }
        });
        return original.apply(this, args);
    };
}
/** JSDoc */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $362da65422a63562$var$_wrapRAF(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(callback) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return original.apply(this, [
            (0, $9aSEL.wrap)(callback, {
                mechanism: {
                    data: {
                        function: 'requestAnimationFrame',
                        handler: (0, $aNkwr.getFunctionName)(original)
                    },
                    handled: true,
                    type: 'instrument'
                }
            })
        ]);
    };
}
/** JSDoc */ function $362da65422a63562$var$_wrapXHR(originalSend) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        var xhr = this;
        var xmlHttpRequestProps = [
            'onload',
            'onerror',
            'onprogress',
            'onreadystatechange'
        ];
        xmlHttpRequestProps.forEach(function(prop) {
            if (prop in xhr && typeof xhr[prop] === 'function') // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (0, $1l3DN.fill)(xhr, prop, function(original) {
                var wrapOptions = {
                    mechanism: {
                        data: {
                            function: prop,
                            handler: (0, $aNkwr.getFunctionName)(original)
                        },
                        handled: true,
                        type: 'instrument'
                    }
                };
                // If Instrument integration has been called before TryCatch, get the name of original function
                var originalFunction = (0, $1l3DN.getOriginalFunction)(original);
                if (originalFunction) wrapOptions.mechanism.data.handler = (0, $aNkwr.getFunctionName)(originalFunction);
                // Otherwise wrap directly
                return (0, $9aSEL.wrap)(original, wrapOptions);
            });
        });
        return originalSend.apply(this, args);
    };
}
/** JSDoc */ function $362da65422a63562$var$_wrapEventTarget(target) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var global = (0, $35A7f.getGlobalObject)();
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    var proto = global[target] && global[target].prototype;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
    if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) return;
    (0, $1l3DN.fill)(proto, 'addEventListener', function(original) {
        return function(eventName, fn, options) {
            try {
                if (typeof fn.handleEvent === 'function') fn.handleEvent = (0, $9aSEL.wrap)(fn.handleEvent.bind(fn), {
                    mechanism: {
                        data: {
                            function: 'handleEvent',
                            handler: (0, $aNkwr.getFunctionName)(fn),
                            target: target
                        },
                        handled: true,
                        type: 'instrument'
                    }
                });
            } catch (err) {
            // can sometimes get 'Permission denied to access property "handle Event'
            }
            return original.apply(this, [
                eventName,
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (0, $9aSEL.wrap)(fn, {
                    mechanism: {
                        data: {
                            function: 'addEventListener',
                            handler: (0, $aNkwr.getFunctionName)(fn),
                            target: target
                        },
                        handled: true,
                        type: 'instrument'
                    }
                }),
                options
            ]);
        };
    });
    (0, $1l3DN.fill)(proto, 'removeEventListener', function(originalRemoveEventListener) {
        return function(eventName, fn, options) {
            /**
             * There are 2 possible scenarios here:
             *
             * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
             * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
             * as a pass-through, and call original `removeEventListener` with it.
             *
             * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
             * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
             * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
             * in order for us to make a distinction between wrapped/non-wrapped functions possible.
             * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
             *
             * When someone adds a handler prior to initialization, and then do it again, but after,
             * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
             * to get rid of the initial handler and it'd stick there forever.
             */ var wrappedEventHandler = fn;
            try {
                var originalEventHandler = wrappedEventHandler && wrappedEventHandler.__sentry_wrapped__;
                if (originalEventHandler) originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
            } catch (e) {
            // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
            }
            return originalRemoveEventListener.call(this, eventName, wrappedEventHandler, options);
        };
    });
}

});

parcelRegister("lKe3d", function(module, exports) {

$parcel$export(module.exports, "UserAgent", () => $fd48cb0c99c1602c$export$5fba5e10934a4faf);

var $3VFsf = parcelRequire("3VFsf");

var $gfYRq = parcelRequire("gfYRq");
var $3kk8J = parcelRequire("3kk8J");
parcelRequire("8KVVB");
var $35A7f = parcelRequire("35A7f");
var $fd48cb0c99c1602c$var$global = (0, $35A7f.getGlobalObject)();
/** UserAgent */ var $fd48cb0c99c1602c$export$5fba5e10934a4faf = /** @class */ function() {
    function UserAgent() {
        /**
         * @inheritDoc
         */ this.name = UserAgent.id;
    }
    /**
     * @inheritDoc
     */ UserAgent.prototype.setupOnce = function() {
        (0, $gfYRq.addGlobalEventProcessor)(function(event) {
            if ((0, $3kk8J.getCurrentHub)().getIntegration(UserAgent)) {
                // if none of the information we want exists, don't bother
                if (!$fd48cb0c99c1602c$var$global.navigator && !$fd48cb0c99c1602c$var$global.location && !$fd48cb0c99c1602c$var$global.document) return event;
                // grab as much info as exists and add it to the event
                var url = event.request && event.request.url || $fd48cb0c99c1602c$var$global.location && $fd48cb0c99c1602c$var$global.location.href;
                var referrer = ($fd48cb0c99c1602c$var$global.document || {}).referrer;
                var userAgent = ($fd48cb0c99c1602c$var$global.navigator || {}).userAgent;
                var headers = (0, $3VFsf.__assign)((0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, event.request && event.request.headers), referrer && {
                    Referer: referrer
                }), userAgent && {
                    'User-Agent': userAgent
                });
                var request = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, url && {
                    url: url
                }), {
                    headers: headers
                });
                return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, event), {
                    request: request
                });
            }
            return event;
        });
    };
    /**
     * @inheritDoc
     */ UserAgent.id = 'UserAgent';
    return UserAgent;
}();

});


parcelRegister("ehYmi", function(module, exports) {

$parcel$export(module.exports, "CaptureConsole", () => $a6717928cd5d30a0$export$25a43cb5b5c58c08);
parcelRequire("8KVVB");
var $4geCF = parcelRequire("4geCF");
var $1l3DN = parcelRequire("1l3DN");
var $35A7f = parcelRequire("35A7f");
var $jOwKr = parcelRequire("jOwKr");
var $n3F4l = parcelRequire("n3F4l");
var $a6717928cd5d30a0$var$global = (0, $35A7f.getGlobalObject)();
/** Send Console API calls as Sentry Events */ var $a6717928cd5d30a0$export$25a43cb5b5c58c08 = /** @class */ function() {
    /**
     * @inheritDoc
     */ function CaptureConsole(options) {
        if (options === void 0) options = {};
        /**
         * @inheritDoc
         */ this.name = CaptureConsole.id;
        /**
         * @inheritDoc
         */ this._levels = (0, $4geCF.CONSOLE_LEVELS);
        if (options.levels) this._levels = options.levels;
    }
    /**
     * @inheritDoc
     */ CaptureConsole.prototype.setupOnce = function(_, getCurrentHub) {
        if (!('console' in $a6717928cd5d30a0$var$global)) return;
        this._levels.forEach(function(level) {
            if (!(level in $a6717928cd5d30a0$var$global.console)) return;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (0, $1l3DN.fill)($a6717928cd5d30a0$var$global.console, level, function(originalConsoleMethod) {
                return function() {
                    var args = [];
                    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                    var hub = getCurrentHub();
                    if (hub.getIntegration(CaptureConsole)) hub.withScope(function(scope) {
                        scope.setLevel((0, $n3F4l.severityFromString)(level));
                        scope.setExtra('arguments', args);
                        scope.addEventProcessor(function(event) {
                            event.logger = 'console';
                            return event;
                        });
                        var message = (0, $jOwKr.safeJoin)(args, ' ');
                        if (level === 'assert') {
                            if (args[0] === false) {
                                message = "Assertion failed: " + ((0, $jOwKr.safeJoin)(args.slice(1), ' ') || 'console.assert');
                                scope.setExtra('arguments', args.slice(1));
                                hub.captureMessage(message);
                            }
                        } else if (level === 'error' && args[0] instanceof Error) hub.captureException(args[0]);
                        else hub.captureMessage(message);
                    });
                    // this fails for some browsers. :(
                    if (originalConsoleMethod) originalConsoleMethod.apply($a6717928cd5d30a0$var$global.console, args);
                };
            });
        });
    };
    /**
     * @inheritDoc
     */ CaptureConsole.id = 'CaptureConsole';
    return CaptureConsole;
}();

});

parcelRegister("lt9kQ", function(module, exports) {

$parcel$export(module.exports, "Dedupe", () => $fa138c2da26103f3$export$688d98c249d31ad3);
parcelRequire("8KVVB");
var $4geCF = parcelRequire("4geCF");

var $gVBdk = parcelRequire("gVBdk");
/** Deduplication filter */ var $fa138c2da26103f3$export$688d98c249d31ad3 = /** @class */ function() {
    function Dedupe() {
        /**
         * @inheritDoc
         */ this.name = Dedupe.id;
    }
    /**
     * @inheritDoc
     */ Dedupe.prototype.setupOnce = function(addGlobalEventProcessor, getCurrentHub) {
        addGlobalEventProcessor(function(currentEvent) {
            var self = getCurrentHub().getIntegration(Dedupe);
            if (self) {
                // Juuust in case something goes wrong
                try {
                    if ($fa138c2da26103f3$export$3c6361fddf6cd929(currentEvent, self._previousEvent)) {
                        (0, $gVBdk.IS_DEBUG_BUILD) && (0, $4geCF.logger).warn('Event dropped due to being a duplicate of previously captured event.');
                        return null;
                    }
                } catch (_oO) {
                    return self._previousEvent = currentEvent;
                }
                return self._previousEvent = currentEvent;
            }
            return currentEvent;
        });
    };
    /**
     * @inheritDoc
     */ Dedupe.id = 'Dedupe';
    return Dedupe;
}();
function $fa138c2da26103f3$export$3c6361fddf6cd929(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($fa138c2da26103f3$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($fa138c2da26103f3$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
/** JSDoc */ function $fa138c2da26103f3$var$_isSameMessageEvent(currentEvent, previousEvent) {
    var currentMessage = currentEvent.message;
    var previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$fa138c2da26103f3$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$fa138c2da26103f3$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
/** JSDoc */ function $fa138c2da26103f3$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    var previousException = $fa138c2da26103f3$var$_getExceptionFromEvent(previousEvent);
    var currentException = $fa138c2da26103f3$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$fa138c2da26103f3$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$fa138c2da26103f3$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
/** JSDoc */ function $fa138c2da26103f3$var$_isSameStacktrace(currentEvent, previousEvent) {
    var currentFrames = $fa138c2da26103f3$var$_getFramesFromEvent(currentEvent);
    var previousFrames = $fa138c2da26103f3$var$_getFramesFromEvent(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(var i = 0; i < previousFrames.length; i++){
        var frameA = previousFrames[i];
        var frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
/** JSDoc */ function $fa138c2da26103f3$var$_isSameFingerprint(currentEvent, previousEvent) {
    var currentFingerprint = currentEvent.fingerprint;
    var previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join('') === previousFingerprint.join(''));
    } catch (_oO) {
        return false;
    }
}
/** JSDoc */ function $fa138c2da26103f3$var$_getExceptionFromEvent(event) {
    return event.exception && event.exception.values && event.exception.values[0];
}
/** JSDoc */ function $fa138c2da26103f3$var$_getFramesFromEvent(event) {
    var exception = event.exception;
    if (exception) try {
        // @ts-ignore Object could be undefined
        return exception.values[0].stacktrace.frames;
    } catch (_oO) {
        return undefined;
    }
    else if (event.stacktrace) return event.stacktrace.frames;
    return undefined;
}

});
parcelRegister("gVBdk", function(module, exports) {

$parcel$export(module.exports, "IS_DEBUG_BUILD", () => $c52ed61e693d7b9c$export$48a8984ec0bf2e44);
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */ /** Flag that is true for debug builds, false otherwise. */ var $c52ed61e693d7b9c$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;

});


parcelRegister("kBLvL", function(module, exports) {

$parcel$export(module.exports, "ExtraErrorData", () => $f00c1e1a00938139$export$56d961ef3a52a072);

var $3VFsf = parcelRequire("3VFsf");
parcelRequire("8KVVB");
var $gkmq5 = parcelRequire("gkmq5");
var $4geCF = parcelRequire("4geCF");
var $2mY5H = parcelRequire("2mY5H");

var $gVBdk = parcelRequire("gVBdk");
/** Patch toString calls to return proper name for wrapped functions */ var $f00c1e1a00938139$export$56d961ef3a52a072 = /** @class */ function() {
    /**
     * @inheritDoc
     */ function ExtraErrorData(options) {
        /**
         * @inheritDoc
         */ this.name = ExtraErrorData.id;
        this._options = (0, $3VFsf.__assign)({
            depth: 3
        }, options);
    }
    /**
     * @inheritDoc
     */ ExtraErrorData.prototype.setupOnce = function(addGlobalEventProcessor, getCurrentHub) {
        addGlobalEventProcessor(function(event, hint) {
            var self = getCurrentHub().getIntegration(ExtraErrorData);
            if (!self) return event;
            return self.enhanceEventWithErrorData(event, hint);
        });
    };
    /**
     * Attaches extracted information from the Error object to extra field in the Event
     */ ExtraErrorData.prototype.enhanceEventWithErrorData = function(event, hint) {
        var _a;
        if (!hint || !hint.originalException || !(0, $gkmq5.isError)(hint.originalException)) return event;
        var name = hint.originalException.name || hint.originalException.constructor.name;
        var errorData = this._extractErrorData(hint.originalException);
        if (errorData) {
            var contexts = (0, $3VFsf.__assign)({}, event.contexts);
            var normalizedErrorData = (0, $2mY5H.normalize)(errorData, this._options.depth);
            if ((0, $gkmq5.isPlainObject)(normalizedErrorData)) contexts = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, event.contexts), (_a = {}, _a[name] = (0, $3VFsf.__assign)({}, normalizedErrorData), _a));
            return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, event), {
                contexts: contexts
            });
        }
        return event;
    };
    /**
     * Extract extra information from the Error object
     */ ExtraErrorData.prototype._extractErrorData = function(error) {
        var e_1, _a, e_2, _b;
        // We are trying to enhance already existing event, so no harm done if it won't succeed
        try {
            var nativeKeys = [
                'name',
                'message',
                'stack',
                'line',
                'column',
                'fileName',
                'lineNumber',
                'columnNumber',
                'toJSON'
            ];
            var extraErrorInfo = {};
            try {
                // We want only enumerable properties, thus `getOwnPropertyNames` is redundant here, as we filter keys anyway.
                for(var _c = (0, $3VFsf.__values)(Object.keys(error)), _d = _c.next(); !_d.done; _d = _c.next()){
                    var key = _d.value;
                    if (nativeKeys.indexOf(key) !== -1) continue;
                    var value = error[key];
                    extraErrorInfo[key] = (0, $gkmq5.isError)(value) ? value.toString() : value;
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
            // Check if someone attached `toJSON` method to grab even more properties (eg. axios is doing that)
            if (typeof error.toJSON === 'function') {
                var serializedError = error.toJSON();
                try {
                    for(var _e = (0, $3VFsf.__values)(Object.keys(serializedError)), _f = _e.next(); !_f.done; _f = _e.next()){
                        var key = _f.value;
                        var value = serializedError[key];
                        extraErrorInfo[key] = (0, $gkmq5.isError)(value) ? value.toString() : value;
                    }
                } catch (e_2_1) {
                    e_2 = {
                        error: e_2_1
                    };
                } finally{
                    try {
                        if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                    } finally{
                        if (e_2) throw e_2.error;
                    }
                }
            }
            return extraErrorInfo;
        } catch (oO) {
            (0, $gVBdk.IS_DEBUG_BUILD) && (0, $4geCF.logger).error('Unable to extract extra data from the Error object:', oO);
        }
        return null;
    };
    /**
     * @inheritDoc
     */ ExtraErrorData.id = 'ExtraErrorData';
    return ExtraErrorData;
}();

});

parcelRegister("50FPh", function(module, exports) {

$parcel$export(module.exports, "Transaction", () => $3a5d659acff7091e$export$febc5573c75cefb0);
/** Add node transaction to the event */ var $3a5d659acff7091e$export$febc5573c75cefb0 = /** @class */ function() {
    function Transaction() {
        /**
         * @inheritDoc
         */ this.name = Transaction.id;
    }
    /**
     * @inheritDoc
     */ Transaction.prototype.setupOnce = function(addGlobalEventProcessor, getCurrentHub) {
        addGlobalEventProcessor(function(event) {
            var self = getCurrentHub().getIntegration(Transaction);
            if (self) return self.process(event);
            return event;
        });
    };
    /**
     * @inheritDoc
     */ Transaction.prototype.process = function(event) {
        var frames = this._getFramesFromEvent(event);
        // use for loop so we don't have to reverse whole frames array
        for(var i = frames.length - 1; i >= 0; i--){
            var frame = frames[i];
            if (frame.in_app === true) {
                event.transaction = this._getTransaction(frame);
                break;
            }
        }
        return event;
    };
    /** JSDoc */ Transaction.prototype._getFramesFromEvent = function(event) {
        var exception = event.exception && event.exception.values && event.exception.values[0];
        return exception && exception.stacktrace && exception.stacktrace.frames || [];
    };
    /** JSDoc */ Transaction.prototype._getTransaction = function(frame) {
        return frame.module || frame.function ? (frame.module || '?') + "/" + (frame.function || '?') : '<unknown>';
    };
    /**
     * @inheritDoc
     */ Transaction.id = 'Transaction';
    return Transaction;
}();

});



parcelRegister("bajNy", function(module, exports) {

$parcel$export(module.exports, "initialiseErrorAnalyticsClient", () => $d5c5a4f71e96ff9b$export$d4079397f9611138);
$parcel$export(module.exports, "default", () => $d5c5a4f71e96ff9b$export$2e2bcd8739ae039);

var $gccSB = parcelRequire("gccSB");

var $9xWGk = parcelRequire("9xWGk");

var $kCVub = parcelRequire("kCVub");
var $h8yj2 = parcelRequire("h8yj2");

var $9ZBi7 = parcelRequire("9ZBi7");
let $d5c5a4f71e96ff9b$var$analyticsClient;
const $d5c5a4f71e96ff9b$export$d4079397f9611138 = (client)=>{
    $d5c5a4f71e96ff9b$var$analyticsClient = client;
};
const $d5c5a4f71e96ff9b$export$bf406c01a195b215 = ()=>{
    $d5c5a4f71e96ff9b$var$analyticsClient = undefined;
};
const $d5c5a4f71e96ff9b$var$fireErrorAnalytics = ({ event: event, error: error, errorInfo: errorInfo, meta: meta, attributes: attributes })=>{
    const { id: id, packageName: packageName, teamName: teamName } = meta;
    if (false) {
        if (error) throw error;
        else {
            const payload = event && (0, $kCVub.extractAWCDataFromEvent)(event).payload;
            throw new Error(JSON.stringify({
                event: payload,
                errorInfo: errorInfo,
                meta: meta,
                attributes: attributes
            }));
        }
    }
    const fullAnalyticsId = `${packageName}.${id}`;
    if (error) {
        const details = (0, (/*@__PURE__*/$parcel$interopDefault($9xWGk)))({
            ...attributes,
            packageName: packageName,
            teamName: teamName,
            errorInfo: errorInfo
        }, (0, (/*@__PURE__*/$parcel$interopDefault($gccSB))));
        if (event && event.context) {
            const fullEvent = (0, $kCVub.extractAWCDataFromEvent)(event);
            (0, $9ZBi7.captureException)(fullAnalyticsId, error, {
                ...details,
                ...fullEvent.payload
            });
        } else (0, $9ZBi7.captureException)(fullAnalyticsId, error, details);
    }
    if (event && event.handlers && event.handlers.length > 0) {
        const attrs = attributes || {};
        (0, $h8yj2.fireOperationalAnalytics)(event, `${fullAnalyticsId} failed`, attrs);
    } else //Allow this to pass in a promise so that we can avoid blocking render for firing these events.
    if ($d5c5a4f71e96ff9b$var$analyticsClient && $d5c5a4f71e96ff9b$var$analyticsClient.sendOperationalEvent) {
        const gasV3Event = {
            action: 'failed',
            actionSubject: fullAnalyticsId,
            source: 'unknownErrorSource',
            attributes: attributes
        };
        $d5c5a4f71e96ff9b$var$analyticsClient.sendOperationalEvent(gasV3Event);
    } else {
        const analyticsClientUninitialisedError = new Error("Analytics client hasn't been initialised, unable to fire error operational event");
        (0, $9ZBi7.captureException)(fullAnalyticsId, analyticsClientUninitialisedError);
    }
};
const $d5c5a4f71e96ff9b$export$706c486c6b5abdfb = async ({ error: error, id: id, packageName: packageName })=>{
    if (error.statusCode) {
        const { statusCode: statusCode } = error;
        let statusCodeGroup;
        if (statusCode >= 300 && statusCode < 400) statusCodeGroup = '3xx';
        else if (statusCode >= 400 && statusCode < 500) statusCodeGroup = '4xx';
        else if (statusCode >= 500 && statusCode < 600) statusCodeGroup = '5xx';
        else statusCodeGroup = 'unknown';
        await $d5c5a4f71e96ff9b$var$fireErrorAnalytics({
            meta: {
                id: id,
                packageName: packageName
            },
            attributes: {
                statusCodeGroup: statusCodeGroup
            }
        });
    } else await $d5c5a4f71e96ff9b$var$fireErrorAnalytics({
        error: error,
        meta: {
            id: id,
            packageName: packageName
        }
    });
};
var $d5c5a4f71e96ff9b$export$2e2bcd8739ae039 = $d5c5a4f71e96ff9b$var$fireErrorAnalytics;

});
parcelRegister("kCVub", function(module, exports) {

$parcel$export(module.exports, "extractAWCDataFromEvent", () => $d006147c8436533b$export$1c850cf68c053906);

var $cjFoH = parcelRequire("cjFoH");

var $9xWGk = parcelRequire("9xWGk");


var $8HgKr = parcelRequire("8HgKr");
const $d006147c8436533b$export$1c850cf68c053906 = (event)=>{
    // TODO: the distinction between AnalyticsEvent and UIAnalyticsEvent is all odd in AK and needs to be understood better
    const castedEvent = event;
    const analyticsType = (0, $8HgKr.getAnalyticsType)(castedEvent);
    const attributes = (0, $8HgKr.getAttributes)(castedEvent);
    const source = (0, $8HgKr.getSource)(castedEvent);
    const actionSubject = (0, $8HgKr.getActionSubject)(castedEvent);
    if (analyticsType === (0, $6e65040b988c460f$export$f1d537d508d2945a)) return {
        type: (0, $6e65040b988c460f$export$f1d537d508d2945a),
        payload: {
            name: source,
            attributes: attributes
        }
    };
    switch(analyticsType){
        case 0, $6e65040b988c460f$export$a1562d08625f5d7e:
        case 0, $6e65040b988c460f$export$947dac6c72b26f81:
        case 0, $6e65040b988c460f$export$12346a674644c156:
            {
                const action = (0, $8HgKr.getAction)(castedEvent);
                const actionSubjectId = (0, $8HgKr.getActionSubjectId)(castedEvent);
                const containerId = (0, $8HgKr.getContainerId)(castedEvent);
                const containerType = (0, $8HgKr.getContainerType)(castedEvent);
                const objectId = (0, $8HgKr.getObjectId)(castedEvent);
                const objectType = (0, $8HgKr.getObjectType)(castedEvent);
                const tags = (0, $8HgKr.getTags)(castedEvent);
                return {
                    type: analyticsType,
                    payload: (0, (/*@__PURE__*/$parcel$interopDefault($9xWGk)))({
                        action: action,
                        actionSubject: actionSubject,
                        actionSubjectId: actionSubjectId,
                        source: source,
                        tags: tags,
                        containerType: containerType,
                        containerId: containerId,
                        objectType: objectType,
                        objectId: objectId,
                        attributes: attributes
                    }, (0, (/*@__PURE__*/$parcel$interopDefault($cjFoH))))
                };
            }
        default:
            return {
                payload: {
                    source: source,
                    actionSubject: actionSubject,
                    attributes: attributes
                },
                type: undefined
            };
    }
};

});
const $6e65040b988c460f$export$f636b5b56f1d624a = 'Screen';
const $6e65040b988c460f$export$9d2de6eebf7462b5 = 'Drawer';
const $6e65040b988c460f$export$1171103ea9083ffa = 'Modal';
const $6e65040b988c460f$export$cae2783c9279926 = 'InlineDialog';
const $6e65040b988c460f$export$d1123261ca8831d2 = 'Dropdown';
const $6e65040b988c460f$export$a1562d08625f5d7e = 'UI';
const $6e65040b988c460f$export$947dac6c72b26f81 = 'TRACK';
const $6e65040b988c460f$export$f1d537d508d2945a = 'SCREEN';
const $6e65040b988c460f$export$12346a674644c156 = 'OPERATIONAL';
const $6e65040b988c460f$export$2ceccf177fae277c = 'analyticsBridge';

parcelRegister("8HgKr", function(module, exports) {

$parcel$export(module.exports, "getAnalyticsType", () => $6831e52439d2a9a2$export$a3569ac53b82a914);
$parcel$export(module.exports, "getAttributes", () => $6831e52439d2a9a2$export$fe94072fee8a6976);
$parcel$export(module.exports, "getSource", () => $6831e52439d2a9a2$export$dd2b6e807fb37ba3);
$parcel$export(module.exports, "getActionSubject", () => $6831e52439d2a9a2$export$6f40cdf6d42c018d);
$parcel$export(module.exports, "getAction", () => $6831e52439d2a9a2$export$6ca3170acb89054);
$parcel$export(module.exports, "getActionSubjectId", () => $6831e52439d2a9a2$export$b6f8db3ad0711b02);
$parcel$export(module.exports, "getContainerId", () => $6831e52439d2a9a2$export$7c8178cc9001d237);
$parcel$export(module.exports, "getContainerType", () => $6831e52439d2a9a2$export$acc6f3e19803b3dc);
$parcel$export(module.exports, "getObjectId", () => $6831e52439d2a9a2$export$fa986b91291934c7);
$parcel$export(module.exports, "getObjectType", () => $6831e52439d2a9a2$export$11cc42aebef2ef3a);
$parcel$export(module.exports, "getTags", () => $6831e52439d2a9a2$export$af63d7414243dad3);

var $183uB = parcelRequire("183uB");

var $cjFoH = parcelRequire("cjFoH");

var $hYfgW = parcelRequire("hYfgW");

var $1UikQ = parcelRequire("1UikQ");

var $9xWGk = parcelRequire("9xWGk");

var $kGsr8 = parcelRequire("kGsr8");
const $6831e52439d2a9a2$var$extractFromContext = (event, property)=>event.context.map((item)=>item[property]);
const $6831e52439d2a9a2$export$a3569ac53b82a914 = (event)=>event.payload.analyticsType;
const $6831e52439d2a9a2$export$fe94072fee8a6976 = (event)=>{
    const contextAttributes = $6831e52439d2a9a2$var$extractFromContext(event, 'attributes');
    const payloadAttributes = event.payload.attributes;
    const allAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))(contextAttributes.reduce((result, extraAttributes)=>(0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))(result, extraAttributes), {}), payloadAttributes);
    const sources = $6831e52439d2a9a2$var$extractFromContext(event, 'source');
    const namespaces = sources.filter(Boolean).join('.');
    return (0, (/*@__PURE__*/$parcel$interopDefault($9xWGk)))({
        ...allAttributes,
        namespaces: namespaces
    }, (0, (/*@__PURE__*/$parcel$interopDefault($cjFoH))));
};
const $6831e52439d2a9a2$export$dd2b6e807fb37ba3 = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))($6831e52439d2a9a2$var$extractFromContext(event, 'source').filter(Boolean));
const $6831e52439d2a9a2$export$6f40cdf6d42c018d = (event)=>{
    const { actionSubject: actionSubject } = event.payload;
    if (actionSubject) return actionSubject;
    const component = (0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))($6831e52439d2a9a2$var$extractFromContext(event, 'component').filter(Boolean)) || (0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))($6831e52439d2a9a2$var$extractFromContext(event, 'componentName').filter(Boolean));
    return component;
};
const $6831e52439d2a9a2$export$6ca3170acb89054 = (event)=>event.payload.action;
const $6831e52439d2a9a2$export$b6f8db3ad0711b02 = (event)=>event.payload.actionSubjectId;
const $6831e52439d2a9a2$export$7c8178cc9001d237 = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))($6831e52439d2a9a2$var$extractFromContext(event, 'containerId').filter(Boolean));
const $6831e52439d2a9a2$export$acc6f3e19803b3dc = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))($6831e52439d2a9a2$var$extractFromContext(event, 'containerType').filter(Boolean));
const $6831e52439d2a9a2$export$fa986b91291934c7 = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))($6831e52439d2a9a2$var$extractFromContext(event, 'objectId').filter(Boolean));
const $6831e52439d2a9a2$export$11cc42aebef2ef3a = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))($6831e52439d2a9a2$var$extractFromContext(event, 'objectType').filter(Boolean));
const $6831e52439d2a9a2$export$af63d7414243dad3 = (event)=>{
    const tags = (0, (/*@__PURE__*/$parcel$interopDefault($kGsr8)))((0, (/*@__PURE__*/$parcel$interopDefault($183uB)))($6831e52439d2a9a2$var$extractFromContext(event, 'tags'))).filter(Boolean);
    return tags.length ? tags : undefined;
};

});


parcelRegister("h8yj2", function(module, exports) {

$parcel$export(module.exports, "fireAnalytics", () => $b264de6d6a035739$export$34ac71ce24cddec2);
$parcel$export(module.exports, "fireUIAnalytics", () => $b264de6d6a035739$export$5d00cd31b1bf8e94);
$parcel$export(module.exports, "fireTrackAnalytics", () => $b264de6d6a035739$export$13990ad4625571ed);
$parcel$export(module.exports, "fireOperationalAnalytics", () => $b264de6d6a035739$export$79f423cc3fd39762);
$parcel$export(module.exports, "fireScreenAnalytics", () => $b264de6d6a035739$export$6f46fb37ad7d962b);

var $hYfgW = parcelRequire("hYfgW");


var $4zfLY = parcelRequire("4zfLY");
const $b264de6d6a035739$export$34ac71ce24cddec2 = (event, type, payload)=>{
    // TODO: the distinction between AnalyticsEvent and UIAnalyticsEvent is all odd in AK and needs to be understood better
    const castedEvent = event;
    const clonedEvent = castedEvent.clone();
    if (!clonedEvent) throw new Error("Cannot clone an event after it's been fired.");
    clonedEvent.update({
        ...payload,
        analyticsType: type
    }).fire((0, $6e65040b988c460f$export$2ceccf177fae277c));
};
const $b264de6d6a035739$var$getActionSubjectFromContext = (event)=>{
    // TODO: the distinction between AnalyticsEvent and UIAnalyticsEvent is all odd in AK and needs to be understood better
    const castedEvent = event;
    return (0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))(castedEvent.context.map((i)=>i.component || i.componentName).filter(Boolean));
};
const $b264de6d6a035739$export$5d00cd31b1bf8e94 = (event, ...rest)=>{
    if (!event.clone) throw new Error('There is no analytics event from Atlaskit in UI event');
    const { action: argumentsAction, actionSubject: argumentsActionSubject, actionSubjectId: actionSubjectId, attributes: attributes } = (0, $4zfLY.getImperativeAnalyticsDataFromArguments)(rest);
    const castedEvent = event;
    const action = event.payload && event.payload.action || argumentsAction;
    const actionSubject = event.payload && event.payload.actionSubject || argumentsActionSubject || $b264de6d6a035739$var$getActionSubjectFromContext(castedEvent);
    if (!action) throw new Error('Mandatory "action" field is missing from UI event');
    if (!actionSubject) throw new Error('Mandatory "actionSubject" field is missing from UI event');
    $b264de6d6a035739$export$34ac71ce24cddec2(event, (0, $6e65040b988c460f$export$a1562d08625f5d7e), {
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    });
};
const $b264de6d6a035739$export$13990ad4625571ed = (event, ...rest)=>{
    if (!event.clone) throw new Error('There is no analytics event from Atlaskit in Track event');
    const { action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes } = (0, $4zfLY.getImperativeAnalyticsDataFromArguments)(rest);
    if (!action) throw new Error('Mandatory "action" field is missing from Track event');
    if (!actionSubject) throw new Error('Mandatory "actionSubject" field is missing from Track event');
    $b264de6d6a035739$export$34ac71ce24cddec2(event, (0, $6e65040b988c460f$export$947dac6c72b26f81), {
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    });
};
const $b264de6d6a035739$export$79f423cc3fd39762 = (event, ...rest)=>{
    if (!event.clone) throw new Error('There is no analytics event from Atlaskit in Operational event');
    const { action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes } = (0, $4zfLY.getImperativeAnalyticsDataFromArguments)(rest);
    if (!action) throw new Error('Mandatory "action" field is missing from Operational event');
    if (!actionSubject) throw new Error('Mandatory "actionSubject" field is missing from Operational event');
    $b264de6d6a035739$export$34ac71ce24cddec2(event, (0, $6e65040b988c460f$export$12346a674644c156), {
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    });
};
const $b264de6d6a035739$export$6f46fb37ad7d962b = (event, ...rest)=>{
    if (!event.clone) throw new Error('There is no analytics event from Atlaskit in Screen event');
    const { attributes: attributes } = (0, $4zfLY.getImperativeAnalyticsDataFromArguments)(rest);
    $b264de6d6a035739$export$34ac71ce24cddec2(event, (0, $6e65040b988c460f$export$f1d537d508d2945a), {
        attributes: attributes
    });
};

});
parcelRegister("4zfLY", function(module, exports) {

$parcel$export(module.exports, "getImperativeAnalyticsDataFromArguments", () => $ccaec2c661eabde7$export$e6baab532ef8c6bf);
const $ccaec2c661eabde7$var$extractDataFromStringAttribute = (string)=>{
    const arr = string.split(' ');
    switch(arr.length){
        case 1:
            return {
                actionSubject: undefined,
                action: undefined,
                actionSubjectId: arr[0],
                attributes: undefined
            };
        case 2:
            return {
                actionSubject: arr[0],
                action: arr[1],
                actionSubjectId: undefined,
                attributes: undefined
            };
        default:
            throw Error('Event of this type is not supported');
    }
};
const $ccaec2c661eabde7$var$extractDataFromOneAttribute = (one)=>{
    if (typeof one === 'string') return $ccaec2c661eabde7$var$extractDataFromStringAttribute(one);
    if (typeof one === 'object') return {
        actionSubject: undefined,
        action: undefined,
        actionSubjectId: undefined,
        attributes: one
    };
    throw Error('Event of this type is not supported');
};
const $ccaec2c661eabde7$var$extractDataFromTwoAttribute = (one, two)=>{
    if (typeof one === 'string' && typeof two === 'string') {
        const { action: action, actionSubject: actionSubject } = $ccaec2c661eabde7$var$extractDataFromStringAttribute(one);
        const actionSubjectId = two;
        return {
            actionSubject: actionSubject,
            action: action,
            actionSubjectId: actionSubjectId,
            attributes: undefined
        };
    }
    if (typeof one === 'string' && typeof two === 'object') {
        const { action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId } = $ccaec2c661eabde7$var$extractDataFromStringAttribute(one);
        return {
            actionSubject: actionSubject,
            action: action,
            actionSubjectId: actionSubjectId,
            attributes: two
        };
    }
    throw Error('Event of this type is not supported');
};
const $ccaec2c661eabde7$var$extractDataFromThreeAttribute = (one, two, three)=>{
    if (typeof one === 'string' && typeof two === 'string' && typeof three === 'object') {
        const { action: action, actionSubject: actionSubject } = $ccaec2c661eabde7$var$extractDataFromStringAttribute(one);
        const actionSubjectId = two;
        return {
            actionSubject: actionSubject,
            action: action,
            actionSubjectId: actionSubjectId,
            attributes: three
        };
    }
    throw Error('Event of this type is not supported');
};
const $ccaec2c661eabde7$export$e6baab532ef8c6bf = (args)=>{
    switch(args.length){
        case 0:
            return {
                actionSubject: undefined,
                action: undefined,
                actionSubjectId: undefined,
                attributes: undefined
            };
        case 1:
            return $ccaec2c661eabde7$var$extractDataFromOneAttribute(args[0]);
        case 2:
            return $ccaec2c661eabde7$var$extractDataFromTwoAttribute(args[0], args[1]);
        case 3:
            return $ccaec2c661eabde7$var$extractDataFromThreeAttribute(args[0], args[1], args[2]);
        default:
            throw Error('Can not fire an empty event');
    }
};

});



parcelRegister("kRBfD", function(module, exports) {

$parcel$export(module.exports, "default", () => $72219f5167e88013$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $cb25w = parcelRequire("cb25w");

var $bajNy = parcelRequire("bajNy");
class $72219f5167e88013$var$CatchAndReportErrors extends (0, $5uXOq.Component) {
    componentDidCatch(error, errorInfo) {
        const { packageName: packageName, id: id, attributes: attributes, createAnalyticsEvent: createAnalyticsEvent } = this.props;
        const analyticsEvent = createAnalyticsEvent({
            action: 'failed'
        });
        (0, $bajNy.default)({
            event: analyticsEvent,
            errorInfo: errorInfo,
            error: error,
            meta: {
                id: id,
                packageName: packageName
            },
            attributes: attributes
        });
        throw error;
    }
    render() {
        const { children: children } = this.props;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
            children: children
        });
    }
}
var $72219f5167e88013$export$2e2bcd8739ae039 = (0, $cb25w.default)()($72219f5167e88013$var$CatchAndReportErrors);

});


parcelRegister("cEm1b", function(module, exports) {

$parcel$export(module.exports, "GlobalReactLooselyLazyProfiler", () => $fb9d2138d0a4f430$export$e2d53c0cbedd2710);
$parcel$export(module.exports, "ProfilerContext", () => $fb9d2138d0a4f430$export$8146ab57a3f7a7cb);

var $5uXOq = parcelRequire("5uXOq");
const $fb9d2138d0a4f430$export$e2d53c0cbedd2710 = {
    current: null
};
const $fb9d2138d0a4f430$export$8146ab57a3f7a7cb = (0, $5uXOq.createContext)($fb9d2138d0a4f430$export$e2d53c0cbedd2710);

});

parcelRegister("2IUgd", function(module, exports) {

$parcel$export(module.exports, "PlaceholderFallbackHydrate", () => $d6ce82b512d53993$export$ca5b8fbc835d95e4);

var $5uXOq = parcelRequire("5uXOq");

var $7AnOd = parcelRequire("7AnOd");
const $d6ce82b512d53993$export$ca5b8fbc835d95e4 = ({ id: id, content: content })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("input", {
        type: "hidden",
        "data-lazy-begin": id
    }), content.map((el, i)=>{
        const { tagName: tagName = '', childNodes: childNodes = [], attributes: attributes = [] } = el;
        const props = Array.from(attributes).reduce((0, $7AnOd.attrToProp), {
            key: String(i)
        });
        // text node
        if (!tagName) return /*#__PURE__*/ (0, $5uXOq.createElement)((0, $5uXOq.Fragment), props, el.textContent);
        // childless tag
        if (!childNodes.length) return /*#__PURE__*/ (0, $5uXOq.createElement)(tagName.toLowerCase(), props);
        // tag with content
        return /*#__PURE__*/ (0, $5uXOq.createElement)(tagName.toLowerCase(), {
            ...props,
            dangerouslySetInnerHTML: {
                __html: ''
            },
            suppressHydrationWarning: true
        });
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("input", {
        type: "hidden",
        "data-lazy-end": id
    }));
};

});

parcelRegister("oq2LV", function(module, exports) {

$parcel$export(module.exports, "PlaceholderFallbackRender", () => $935294f441ec99ac$export$d55db778a3e1446b);

var $5uXOq = parcelRequire("5uXOq");

var $cEm1b = parcelRequire("cEm1b");

var $5poak = parcelRequire("5poak");

var $7In2L = parcelRequire("7In2L");
function $935294f441ec99ac$var$isLinkPrefetch(el) {
    return el.tagName === 'LINK' && el.rel === 'prefetch';
}
const $935294f441ec99ac$var$usePlaceholderRender = (resolveId, content)=>{
    const hydrationRef = (0, $5uXOq.useRef)(null);
    const { current: ssrDomNodes } = (0, $5uXOq.useRef)(content || []);
    const profilerContext = (0, $5uXOq.useContext)((0, $cEm1b.ProfilerContext)).current;
    const waitContext = (0, $5uXOq.useContext)((0, $5poak.WaitContext));
    const suspenseContext = (0, $5uXOq.useContext)((0, $7In2L.LazySuspenseContext));
    (0, $5uXOq.useLayoutEffect)(()=>{
        const element = hydrationRef.current;
        const { parentNode: parentNode } = element || {};
        profilerContext?.placeholderFallBackMounted(resolveId, suspenseContext.name, !waitContext.currentValue());
        if (parentNode && !parentNode.contains(ssrDomNodes[0])) ssrDomNodes.reverse().forEach((node)=>{
            // this fixes an issue with Chrome that re-triggers and cancels prefetch
            // when node is appended again, making network panel quite noisy
            if ($935294f441ec99ac$var$isLinkPrefetch(node)) node.rel = '';
            parentNode.insertBefore(node, element.nextSibling);
        });
        return ()=>{
            profilerContext?.placeholderFallBackUnmounted(resolveId, suspenseContext.name, !waitContext.currentValue());
            ssrDomNodes.forEach((node)=>node.parentNode?.removeChild(node));
        };
    // [hydrationRef.current, ssrDomNodes] are expected to be stable
    // with the second one never changing by design and the first one changing after first render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return hydrationRef;
};
const $935294f441ec99ac$export$d55db778a3e1446b = ({ id: id, content: content })=>{
    const placeholderRef = $935294f441ec99ac$var$usePlaceholderRender(id, content);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("input", {
        type: "hidden",
        "data-lazy-begin": id,
        ref: placeholderRef
    });
};

});

parcelRegister("lO9oD", function(module, exports) {

$parcel$export(module.exports, "useSubscription", () => $7755a72a55b4f109$export$368b4214baeb914c);

var $5uXOq = parcelRequire("5uXOq");
function $7755a72a55b4f109$export$368b4214baeb914c({ context: context, load: load, onValue: onValue }) {
    const { subscribe: subscribe, currentValue: currentValue } = (0, $5uXOq.useContext)(context);
    (0, $5uXOq.useMemo)(()=>{
        let unsubscribe = null;
        const check = ()=>{
            const done = onValue(currentValue());
            if (done) load();
            if (done && unsubscribe) unsubscribe();
            return done;
        };
        unsubscribe = !check() ? subscribe(check) : null;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}

});


parcelRegister("WOtQc", function(module, exports) {

$parcel$export(module.exports, "createComponentServer", () => $3c9928cdf43ed0ec$export$eb2e4b04351cdd9e);

var $5uXOq = parcelRequire("5uXOq");

var $a6rDZ = parcelRequire("a6rDZ");

var $ddkdN = parcelRequire("ddkdN");
var $7Ewwd = parcelRequire("7Ewwd");

var $fVdZG = parcelRequire("fVdZG");

var $7In2L = parcelRequire("7In2L");

var $7AnOd = parcelRequire("7AnOd");

var $bCf8q = parcelRequire("bCf8q");
function $3c9928cdf43ed0ec$var$load(moduleId, loader) {
    try {
        return (0, $7AnOd.getExport)(loader());
    } catch (err) {
        throw (0, $bCf8q.createLoaderError)(err);
    }
}
function $3c9928cdf43ed0ec$export$eb2e4b04351cdd9e({ dataLazyId: dataLazyId, defer: defer, loader: loader, moduleId: moduleId, ssr: ssr }) {
    return (props)=>{
        const Resolved = ssr ? $3c9928cdf43ed0ec$var$load(moduleId, loader) : null;
        const { fallback: fallback } = (0, $5uXOq.useContext)((0, $7In2L.LazySuspenseContext));
        const { crossOrigin: crossOrigin, manifest: manifest, onChunkRender: onChunkRender, mode: mode, react18: react18 } = (0, $ddkdN.getConfig)();
        onChunkRender(moduleId, defer);
        if (mode === (0, $7Ewwd.MODE).HYDRATE && react18) {
            if (!Resolved) {
                const error = new Error(`RLL(${moduleId}) not listed for SSR`);
                // TODO: find a way to mark this error as "ok"
                // error.ignore = true;
                throw error;
            }
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Resolved, props);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("input", {
            type: "hidden",
            "data-lazy-begin": dataLazyId
        }), defer !== (0, $fVdZG.PHASE).LAZY && (0, $a6rDZ.getAssetUrlsFromId)(manifest, moduleId)?.map((url)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("link", {
                key: url,
                rel: defer === (0, $fVdZG.PHASE).PAINT ? 'preload' : 'prefetch',
                href: url,
                crossOrigin: crossOrigin,
                as: "script"
            })), Resolved ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Resolved, props) : fallback, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("input", {
            type: "hidden",
            "data-lazy-end": dataLazyId
        }));
    };
}

});

parcelRegister("fCMWS", function(module, exports) {

$parcel$export(module.exports, "PRIORITY", () => $a5cf4b862e654127$export$bb34f3538ba26c7e);
$parcel$export(module.exports, "RETRY_DELAY", () => $a5cf4b862e654127$export$a339266ad71b2447);
$parcel$export(module.exports, "RETRY_FACTOR", () => $a5cf4b862e654127$export$ba64c908e55507fe);
const $a5cf4b862e654127$export$bb34f3538ba26c7e = {
    HIGH: 0,
    LOW: 2
};
const $a5cf4b862e654127$export$a339266ad71b2447 = 300;
const $a5cf4b862e654127$export$ba64c908e55507fe = 1;

});

parcelRegister("atSTR", function(module, exports) {

$parcel$export(module.exports, "createDeferred", () => $133a960512c1fe96$export$e673efccd97e4223);
const $133a960512c1fe96$export$e673efccd97e4223 = ({ loader: loader, preload: preload })=>{
    let resolve;
    const deferred = {
        promise: new Promise((res)=>{
            resolve = (m)=>{
                let withDefault;
                deferred.result = m;
                if (!m.default) withDefault = {
                    default: m
                };
                res(withDefault ? withDefault : m);
            };
        }),
        result: undefined,
        preload: ()=>{
            if (deferred.result) return;
            preload().then((m)=>{
                deferred.result = m;
            }).catch(()=>{
            // Do nothing...
            });
        },
        start: ()=>{
            if (deferred.result) {
                resolve(deferred.result);
                return Promise.resolve();
            }
            // Make a new loader request when none have started or resolved yet
            return loader().then(resolve);
        }
    };
    return deferred;
};

});

parcelRegister("qkBMj", function(module, exports) {

$parcel$export(module.exports, "preloadAsset", () => $0ca34b961c7287e8$export$25bad4aa00c45355);

var $a6rDZ = parcelRequire("a6rDZ");

var $dwdrq = parcelRequire("dwdrq");

var $ddkdN = parcelRequire("ddkdN");

var $cEm1b = parcelRequire("cEm1b");

var $7AnOd = parcelRequire("7AnOd");

var $fCMWS = parcelRequire("fCMWS");

var $5VuPF = parcelRequire("5VuPF");
function $0ca34b961c7287e8$export$3af04dbcb01bad4d({ moduleId: moduleId, rel: rel }) {
    const { manifest: manifest } = (0, $ddkdN.getConfig)();
    const assets = (0, $a6rDZ.getAssetUrlsFromId)(manifest, moduleId);
    if (!assets) throw new Error('Unsupported preload strategy');
    const cleanupLinkTags = assets.map((url)=>(0, $5VuPF.insertLinkTag)(url, rel));
    return ()=>{
        for (const cleanupLinkTag of cleanupLinkTags)cleanupLinkTag();
    };
}
const $0ca34b961c7287e8$var$fakePromise = {
    then: ()=>$0ca34b961c7287e8$var$fakePromise,
    catch: ()=>$0ca34b961c7287e8$var$fakePromise,
    finally: ()=>$0ca34b961c7287e8$var$fakePromise
};
function $0ca34b961c7287e8$export$1046fd6a49d5e7a({ loader: loader, rel: rel }) {
    if (typeof __webpack_require__ === 'undefined' || typeof __webpack_get_script_filename__ === 'undefined') throw new Error('Unsupported preload strategy');
    // Replace requireEnsure to create link tags instead of scripts
    const requireEnsure = __webpack_require__.e;
    const cleanupLinkTags = [];
    __webpack_require__.e = function requirePreload(chunkId) {
        const href = __webpack_get_script_filename__(chunkId);
        cleanupLinkTags.push((0, $5VuPF.insertLinkTag)(href, rel));
        return $0ca34b961c7287e8$var$fakePromise;
    };
    try {
        loader();
    } catch (err) {
    // Ignore any errors
    }
    // Restore real webpack require ensure
    __webpack_require__.e = requireEnsure;
    return ()=>{
        for (const cleanupLinkTag of cleanupLinkTags)cleanupLinkTag();
    };
}
function $0ca34b961c7287e8$export$eb05139fa4dcf992({ loader: loader }) {
    loader();
    return 0, $dwdrq.noopCleanup;
}
function $0ca34b961c7287e8$export$25bad4aa00c45355({ loader: loader, moduleId: moduleId, priority: priority }) {
    if ((0, $7AnOd.isNodeEnvironment)()) return 0, $dwdrq.noopCleanup;
    (0, $cEm1b.GlobalReactLooselyLazyProfiler).current?.onPreload(moduleId, priority);
    const rel = priority === (0, $fCMWS.PRIORITY).HIGH ? 'preload' : 'prefetch';
    const preloadStrategies = [
        $0ca34b961c7287e8$export$3af04dbcb01bad4d,
        $0ca34b961c7287e8$export$1046fd6a49d5e7a,
        $0ca34b961c7287e8$export$eb05139fa4dcf992
    ];
    for (const strategy of preloadStrategies)try {
        return strategy({
            loader: loader,
            moduleId: moduleId,
            rel: rel
        });
    } catch (_) {
    // Try next strategy...
    }
    return 0, $dwdrq.noopCleanup;
}

});
parcelRegister("5VuPF", function(module, exports) {

$parcel$export(module.exports, "insertLinkTag", () => $f90e93988869ca21$export$6610512821c8a4ce);

var $dwdrq = parcelRequire("dwdrq");

var $ddkdN = parcelRequire("ddkdN");

var $cEm1b = parcelRequire("cEm1b");
function $f90e93988869ca21$export$6610512821c8a4ce(href, rel) {
    // Skip if already preloaded, prefetched, or loaded
    if (document.querySelector(`link[href="${href}"]`) || document.querySelector(`script[src="${href}"]`)) return 0, $dwdrq.noopCleanup;
    const { crossOrigin: crossOrigin } = (0, $ddkdN.getConfig)();
    const link = document.createElement('link');
    link.rel = rel;
    link.as = 'script';
    if (crossOrigin) link.crossOrigin = crossOrigin;
    link.href = href;
    const profiler = (0, $cEm1b.GlobalReactLooselyLazyProfiler).current;
    let removableListener = null;
    if (profiler) {
        const eventInfo = {
            identifier: href
        };
        const listener = ()=>{
            link.removeEventListener('onload', listener);
            removableListener = null;
            profiler.onLoadComplete(eventInfo);
        };
        link.addEventListener('onload', listener);
        removableListener = listener;
        profiler.onLoadStart(eventInfo);
    }
    document.head?.appendChild(link);
    return ()=>{
        // Remove the link if it is still in the document head
        if (link.parentNode === document.head) document.head?.removeChild(link);
        if (removableListener) link.removeEventListener('onload', removableListener);
    };
}

});


parcelRegister("aoIf8", function(module, exports) {

$parcel$export(module.exports, "retry", () => $3a7c17a9826ee760$export$9369b12211e1fce4);
const $3a7c17a9826ee760$var$calculateDelay = (context, policy)=>{
    const { attempt: attempt } = context;
    const { delay: delay, factor: factor } = policy;
    const retryAttempt = attempt - 1;
    // Do not use a delay on the first retry, or when the configured delay is 0
    if (retryAttempt === 1 || delay === 0) return 0;
    // Linear factor, like: https://github.com/Polly-Contrib/Polly.Contrib.WaitAndRetry#wait-and-retry-with-linear-back-off
    const add = factor * delay;
    return delay + add * (retryAttempt - 2);
};
const $3a7c17a9826ee760$var$sleep = (delay)=>new Promise((resolve)=>setTimeout(resolve, delay));
const $3a7c17a9826ee760$var$getPolicy = (configuration)=>({
        delay: Math.max(0, configuration.delay ?? 0),
        factor: Math.max(0, configuration.factor ?? 0),
        maxAttempts: Math.max(0, configuration.maxAttempts ?? 0)
    });
function $3a7c17a9826ee760$export$9369b12211e1fce4(retryable, policyConfiguration = {}) {
    const policy = $3a7c17a9826ee760$var$getPolicy(policyConfiguration);
    const { maxAttempts: maxAttempts } = policy;
    const context = {
        attempt: 1,
        attemptsRemaining: maxAttempts
    };
    const onError = async (err)=>{
        if (context.attemptsRemaining === 0) throw err;
        context.attempt += 1;
        context.attemptsRemaining -= 1;
        const delay = $3a7c17a9826ee760$var$calculateDelay(context, policy);
        if (delay) await $3a7c17a9826ee760$var$sleep(delay);
        return retryable().catch(onError);
    };
    return retryable().catch(onError);
}

});


parcelRegister("eUO5L", function(module, exports) {

$parcel$export(module.exports, "getGlobalObject", () => $adbd26dd4cdaba08$export$256479dc0cea61c4);
$parcel$export(module.exports, "getGlobalSingleton", () => $adbd26dd4cdaba08$export$7e223ec222791509);
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ 
var $3kiq9 = parcelRequire("3kiq9");
var $adbd26dd4cdaba08$var$fallbackGlobalObject = {};
function $adbd26dd4cdaba08$export$256479dc0cea61c4() {
    return (0, $3kiq9.isNodeEnv)() ? $parcel$global : typeof window !== 'undefined' // eslint-disable-line no-restricted-globals
     ? window // eslint-disable-line no-restricted-globals
     : typeof self !== 'undefined' ? self : $adbd26dd4cdaba08$var$fallbackGlobalObject;
}
function $adbd26dd4cdaba08$export$7e223ec222791509(name, creator, obj) {
    var global1 = obj || $adbd26dd4cdaba08$export$256479dc0cea61c4();
    var __SENTRY__ = global1.__SENTRY__ = global1.__SENTRY__ || {};
    var singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
    return singleton;
}

});
parcelRegister("3kiq9", function(module, exports) {

$parcel$export(module.exports, "isNodeEnv", () => isNodeEnv, (v) => isNodeEnv = v);
$parcel$export(module.exports, "dynamicRequire", () => dynamicRequire, (v) => dynamicRequire = v);
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ 
var $diNsD = parcelRequire("diNsD");

var $6cAn5 = parcelRequire("6cAn5");
function isNodeEnv() {
    // explicitly check for browser bundles as those can be optimized statically
    // by terser/rollup.
    return !(0, $diNsD.isBrowserBundle)() && Object.prototype.toString.call(typeof $6cAn5 !== 'undefined' ? $6cAn5 : 0) === '[object process]';
}
function dynamicRequire(mod, request) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return mod.require(request);
}
function loadModule(moduleName) {
    var mod;
    try {
        mod = dynamicRequire(module, moduleName);
    } catch (e) {
    // no-empty
    }
    try {
        var cwd = dynamicRequire(module, 'process').cwd;
        mod = dynamicRequire(module, cwd() + "/node_modules/" + moduleName);
    } catch (e) {
    // no-empty
    }
    return mod;
}

});
parcelRegister("diNsD", function(module, exports) {

$parcel$export(module.exports, "isBrowserBundle", () => $9af352b66430744d$export$2928c40372e623c0);
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These fags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $9af352b66430744d$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
}

});



parcelRegister("okkfE", function(module, exports) {

$parcel$export(module.exports, "isError", () => $04920240eebc235f$export$e6127cc7fe7395c3);
$parcel$export(module.exports, "isInstanceOf", () => $04920240eebc235f$export$49034edbe6b62415);
$parcel$export(module.exports, "isErrorEvent", () => $04920240eebc235f$export$9f9636d330b71954);
$parcel$export(module.exports, "isDOMError", () => $04920240eebc235f$export$ef9e2056653f0c8e);
$parcel$export(module.exports, "isDOMException", () => $04920240eebc235f$export$12e869b2a583f783);
$parcel$export(module.exports, "isString", () => $04920240eebc235f$export$844ec244b1367d54);
$parcel$export(module.exports, "isPrimitive", () => $04920240eebc235f$export$c3825b437cbdea5c);
$parcel$export(module.exports, "isPlainObject", () => $04920240eebc235f$export$53b83ca8eaab0383);
$parcel$export(module.exports, "isEvent", () => $04920240eebc235f$export$9671ea99bd126ace);
$parcel$export(module.exports, "isElement", () => $04920240eebc235f$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isRegExp", () => $04920240eebc235f$export$49841c62b9eff15);
$parcel$export(module.exports, "isThenable", () => $04920240eebc235f$export$f5b060c2914b97c8);
$parcel$export(module.exports, "isSyntheticEvent", () => $04920240eebc235f$export$bc2894c7158efbac);
$parcel$export(module.exports, "isNaN", () => $04920240eebc235f$export$c9f5652083b8129d);
/* eslint-disable @typescript-eslint/no-explicit-any */ /* eslint-disable @typescript-eslint/explicit-module-boundary-types */ // eslint-disable-next-line @typescript-eslint/unbound-method
var $04920240eebc235f$var$objectToString = Object.prototype.toString;
function $04920240eebc235f$export$e6127cc7fe7395c3(wat) {
    switch($04920240eebc235f$var$objectToString.call(wat)){
        case '[object Error]':
        case '[object Exception]':
        case '[object DOMException]':
            return true;
        default:
            return $04920240eebc235f$export$49034edbe6b62415(wat, Error);
    }
}
function $04920240eebc235f$var$isBuiltin(wat, ty) {
    return $04920240eebc235f$var$objectToString.call(wat) === "[object " + ty + "]";
}
function $04920240eebc235f$export$9f9636d330b71954(wat) {
    return $04920240eebc235f$var$isBuiltin(wat, 'ErrorEvent');
}
function $04920240eebc235f$export$ef9e2056653f0c8e(wat) {
    return $04920240eebc235f$var$isBuiltin(wat, 'DOMError');
}
function $04920240eebc235f$export$12e869b2a583f783(wat) {
    return $04920240eebc235f$var$isBuiltin(wat, 'DOMException');
}
function $04920240eebc235f$export$844ec244b1367d54(wat) {
    return $04920240eebc235f$var$isBuiltin(wat, 'String');
}
function $04920240eebc235f$export$c3825b437cbdea5c(wat) {
    return wat === null || typeof wat !== 'object' && typeof wat !== 'function';
}
function $04920240eebc235f$export$53b83ca8eaab0383(wat) {
    return $04920240eebc235f$var$isBuiltin(wat, 'Object');
}
function $04920240eebc235f$export$9671ea99bd126ace(wat) {
    return typeof Event !== 'undefined' && $04920240eebc235f$export$49034edbe6b62415(wat, Event);
}
function $04920240eebc235f$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== 'undefined' && $04920240eebc235f$export$49034edbe6b62415(wat, Element);
}
function $04920240eebc235f$export$49841c62b9eff15(wat) {
    return $04920240eebc235f$var$isBuiltin(wat, 'RegExp');
}
function $04920240eebc235f$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === 'function');
}
function $04920240eebc235f$export$bc2894c7158efbac(wat) {
    return $04920240eebc235f$export$53b83ca8eaab0383(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}
function $04920240eebc235f$export$c9f5652083b8129d(wat) {
    return typeof wat === 'number' && wat !== wat;
}
function $04920240eebc235f$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}

});

parcelRegister("aHQIJ", function(module, exports) {

$parcel$export(module.exports, "CONSOLE_LEVELS", () => $7cb6d0bbf859a350$export$2a2b1d2252a69ecb);
$parcel$export(module.exports, "consoleSandbox", () => $7cb6d0bbf859a350$export$cda52e2a8927a2ca);
$parcel$export(module.exports, "logger", () => $7cb6d0bbf859a350$export$af88d00dbe7f521);

var $3VFsf = parcelRequire("3VFsf");

var $1pUkh = parcelRequire("1pUkh");

var $eUO5L = parcelRequire("eUO5L");
// TODO: Implement different loggers for different environments
var $7cb6d0bbf859a350$var$global = (0, $eUO5L.getGlobalObject)();
/** Prefix for logging strings */ var $7cb6d0bbf859a350$var$PREFIX = 'Sentry Logger ';
var $7cb6d0bbf859a350$export$2a2b1d2252a69ecb = [
    'debug',
    'info',
    'warn',
    'error',
    'log',
    'assert'
];
function $7cb6d0bbf859a350$export$cda52e2a8927a2ca(callback) {
    var global = (0, $eUO5L.getGlobalObject)();
    if (!('console' in global)) return callback();
    var originalConsole = global.console;
    var wrappedLevels = {};
    // Restore all wrapped console methods
    $7cb6d0bbf859a350$export$2a2b1d2252a69ecb.forEach(function(level) {
        // TODO(v7): Remove this check as it's only needed for Node 6
        var originalWrappedFunc = originalConsole[level] && originalConsole[level].__sentry_original__;
        if (level in global.console && originalWrappedFunc) {
            wrappedLevels[level] = originalConsole[level];
            originalConsole[level] = originalWrappedFunc;
        }
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        Object.keys(wrappedLevels).forEach(function(level) {
            originalConsole[level] = wrappedLevels[level];
        });
    }
}
function $7cb6d0bbf859a350$var$makeLogger() {
    var enabled = false;
    var logger = {
        enable: function() {
            enabled = true;
        },
        disable: function() {
            enabled = false;
        }
    };
    if (0, $1pUkh.IS_DEBUG_BUILD) $7cb6d0bbf859a350$export$2a2b1d2252a69ecb.forEach(function(name) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        logger[name] = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (enabled) $7cb6d0bbf859a350$export$cda52e2a8927a2ca(function() {
                var _a;
                (_a = $7cb6d0bbf859a350$var$global.console)[name].apply(_a, (0, $3VFsf.__spread)([
                    $7cb6d0bbf859a350$var$PREFIX + "[" + name + "]:"
                ], args));
            });
        };
    });
    else $7cb6d0bbf859a350$export$2a2b1d2252a69ecb.forEach(function(name) {
        logger[name] = function() {
            return undefined;
        };
    });
    return logger;
}
// Ensure we only have a single logger instance, even if multiple versions of @sentry/utils are being used
var $7cb6d0bbf859a350$export$af88d00dbe7f521;
if (0, $1pUkh.IS_DEBUG_BUILD) $7cb6d0bbf859a350$export$af88d00dbe7f521 = (0, $eUO5L.getGlobalSingleton)('logger', $7cb6d0bbf859a350$var$makeLogger);
else $7cb6d0bbf859a350$export$af88d00dbe7f521 = $7cb6d0bbf859a350$var$makeLogger();

});
parcelRegister("1pUkh", function(module, exports) {

$parcel$export(module.exports, "IS_DEBUG_BUILD", () => $1083d16d6e02eb4b$export$48a8984ec0bf2e44);
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */ /** Flag that is true for debug builds, false otherwise. */ var $1083d16d6e02eb4b$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;

});


parcelRegister("1vYJz", function(module, exports) {

$parcel$export(module.exports, "uuid4", () => $11a7cc3993e3d0c3$export$19f53698e68b2496);
$parcel$export(module.exports, "parseUrl", () => $11a7cc3993e3d0c3$export$7a5253c0f62e0150);
$parcel$export(module.exports, "getEventDescription", () => $11a7cc3993e3d0c3$export$4157119e2b157127);
$parcel$export(module.exports, "addExceptionTypeValue", () => $11a7cc3993e3d0c3$export$f26508487bf83ee7);
$parcel$export(module.exports, "addExceptionMechanism", () => $11a7cc3993e3d0c3$export$c69a9a0313b03bb1);
$parcel$export(module.exports, "checkOrSetAlreadyCaught", () => $11a7cc3993e3d0c3$export$6de4ffac6a2f1098);

var $3VFsf = parcelRequire("3VFsf");

var $eUO5L = parcelRequire("eUO5L");

var $59M0S = parcelRequire("59M0S");

var $keOcA = parcelRequire("keOcA");
function $11a7cc3993e3d0c3$export$19f53698e68b2496() {
    var global = (0, $eUO5L.getGlobalObject)();
    var crypto = global.crypto || global.msCrypto;
    if (!(crypto === void 0) && crypto.getRandomValues) {
        // Use window.crypto API if available
        var arr = new Uint16Array(8);
        crypto.getRandomValues(arr);
        // set 4 in byte 7
        // eslint-disable-next-line no-bitwise
        arr[3] = arr[3] & 0xfff | 0x4000;
        // set 2 most significant bits of byte 9 to '10'
        // eslint-disable-next-line no-bitwise
        arr[4] = arr[4] & 0x3fff | 0x8000;
        var pad = function(num) {
            var v = num.toString(16);
            while(v.length < 4)v = "0" + v;
            return v;
        };
        return pad(arr[0]) + pad(arr[1]) + pad(arr[2]) + pad(arr[3]) + pad(arr[4]) + pad(arr[5]) + pad(arr[6]) + pad(arr[7]);
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        // eslint-disable-next-line no-bitwise
        var r = Math.random() * 16 | 0;
        // eslint-disable-next-line no-bitwise
        var v = c === 'x' ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
}
function $11a7cc3993e3d0c3$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    var match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    var query = match[6] || '';
    var fragment = match[8] || '';
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        relative: match[5] + query + fragment
    };
}
function $11a7cc3993e3d0c3$var$getFirstException(event) {
    return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}
function $11a7cc3993e3d0c3$export$4157119e2b157127(event) {
    var message = event.message, eventId = event.event_id;
    if (message) return message;
    var firstException = $11a7cc3993e3d0c3$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return firstException.type + ": " + firstException.value;
        return firstException.type || firstException.value || eventId || '<unknown>';
    }
    return eventId || '<unknown>';
}
function $11a7cc3993e3d0c3$export$f26508487bf83ee7(event, value, type) {
    var exception = event.exception = event.exception || {};
    var values = exception.values = exception.values || [];
    var firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || '';
    if (!firstException.type) firstException.type = type || 'Error';
}
function $11a7cc3993e3d0c3$export$c69a9a0313b03bb1(event, newMechanism) {
    var firstException = $11a7cc3993e3d0c3$var$getFirstException(event);
    if (!firstException) return;
    var defaultMechanism = {
        type: 'generic',
        handled: true
    };
    var currentMechanism = firstException.mechanism;
    firstException.mechanism = (0, $3VFsf.__assign)((0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, defaultMechanism), currentMechanism), newMechanism);
    if (newMechanism && 'data' in newMechanism) {
        var mergedData = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, currentMechanism && currentMechanism.data), newMechanism.data);
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
var $11a7cc3993e3d0c3$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
function $11a7cc3993e3d0c3$export$d364f2020ab30578(input) {
    var match = input.match($11a7cc3993e3d0c3$var$SEMVER_REGEXP) || [];
    var major = parseInt(match[1], 10);
    var minor = parseInt(match[2], 10);
    var patch = parseInt(match[3], 10);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
function $11a7cc3993e3d0c3$export$ec2291bfc64632f0(lines, frame, linesOfContext) {
    if (linesOfContext === void 0) linesOfContext = 5;
    var lineno = frame.lineno || 0;
    var maxLines = lines.length;
    var sourceLine = Math.max(Math.min(maxLines, lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map(function(line) {
        return (0, $keOcA.snipLine)(line, 0);
    });
    frame.context_line = (0, $keOcA.snipLine)(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map(function(line) {
        return (0, $keOcA.snipLine)(line, 0);
    });
}
function $11a7cc3993e3d0c3$export$ce084c78234bd35(urlPath) {
    // eslint-disable-next-line no-useless-escape
    return urlPath.split(/[\?#]/, 1)[0];
}
function $11a7cc3993e3d0c3$export$6de4ffac6a2f1098(exception) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (exception && exception.__sentry_captured__) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $59M0S.addNonEnumerableProperty)(exception, '__sentry_captured__', true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}

});
parcelRegister("59M0S", function(module, exports) {

$parcel$export(module.exports, "fill", () => $3c130969d9628ee3$export$9563e054e6f787fb);
$parcel$export(module.exports, "markFunctionWrapped", () => $3c130969d9628ee3$export$5c1499e2e5d010ae);
$parcel$export(module.exports, "addNonEnumerableProperty", () => $3c130969d9628ee3$export$e73679ffaf56810e);
$parcel$export(module.exports, "getOriginalFunction", () => $3c130969d9628ee3$export$e6cc1e135e2092e5);
$parcel$export(module.exports, "urlEncode", () => $3c130969d9628ee3$export$9ef804feabbcbaf1);
$parcel$export(module.exports, "convertToPlainObject", () => $3c130969d9628ee3$export$62ff257738bf57f5);
$parcel$export(module.exports, "extractExceptionKeysForMessage", () => $3c130969d9628ee3$export$b0244d5063c0b61b);
$parcel$export(module.exports, "dropUndefinedKeys", () => $3c130969d9628ee3$export$d25f2688db1bb433);

var $3VFsf = parcelRequire("3VFsf");

var $fB1v8 = parcelRequire("fB1v8");

var $okkfE = parcelRequire("okkfE");

var $keOcA = parcelRequire("keOcA");
function $3c130969d9628ee3$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    var original = source[name];
    var wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === 'function') try {
        $3c130969d9628ee3$export$5c1499e2e5d010ae(wrapped, original);
    } catch (_Oo) {
    // This can throw if multiple fill happens on a global object like XMLHttpRequest
    // Fixes https://github.com/getsentry/sentry-javascript/issues/2043
    }
    source[name] = wrapped;
}
function $3c130969d9628ee3$export$e73679ffaf56810e(obj, name, value) {
    Object.defineProperty(obj, name, {
        // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
        value: value,
        writable: true,
        configurable: true
    });
}
function $3c130969d9628ee3$export$5c1499e2e5d010ae(wrapped, original) {
    var proto = original.prototype || {};
    wrapped.prototype = original.prototype = proto;
    $3c130969d9628ee3$export$e73679ffaf56810e(wrapped, '__sentry_original__', original);
}
function $3c130969d9628ee3$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
function $3c130969d9628ee3$export$9ef804feabbcbaf1(object) {
    return Object.keys(object).map(function(key) {
        return encodeURIComponent(key) + "=" + encodeURIComponent(object[key]);
    }).join('&');
}
function $3c130969d9628ee3$export$62ff257738bf57f5(value) {
    var newObj = value;
    if ((0, $okkfE.isError)(value)) newObj = (0, $3VFsf.__assign)({
        message: value.message,
        name: value.name,
        stack: value.stack
    }, $3c130969d9628ee3$var$getOwnProperties(value));
    else if ((0, $okkfE.isEvent)(value)) {
        var event_1 = value;
        newObj = (0, $3VFsf.__assign)({
            type: event_1.type,
            target: $3c130969d9628ee3$var$serializeEventTarget(event_1.target),
            currentTarget: $3c130969d9628ee3$var$serializeEventTarget(event_1.currentTarget)
        }, $3c130969d9628ee3$var$getOwnProperties(event_1));
        if (typeof CustomEvent !== 'undefined' && (0, $okkfE.isInstanceOf)(value, CustomEvent)) newObj.detail = event_1.detail;
    }
    return newObj;
}
/** Creates a string representation of the target of an `Event` object */ function $3c130969d9628ee3$var$serializeEventTarget(target) {
    try {
        return (0, $okkfE.isElement)(target) ? (0, $fB1v8.htmlTreeAsString)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return '<unknown>';
    }
}
/** Filters out all but an object's own properties */ function $3c130969d9628ee3$var$getOwnProperties(obj) {
    var extractedProps = {};
    for(var property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
    return extractedProps;
}
function $3c130969d9628ee3$export$b0244d5063c0b61b(exception, maxLength) {
    if (maxLength === void 0) maxLength = 40;
    var keys = Object.keys($3c130969d9628ee3$export$62ff257738bf57f5(exception));
    keys.sort();
    if (!keys.length) return '[object has no keys]';
    if (keys[0].length >= maxLength) return (0, $keOcA.truncate)(keys[0], maxLength);
    for(var includedKeys = keys.length; includedKeys > 0; includedKeys--){
        var serialized = keys.slice(0, includedKeys).join(', ');
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $keOcA.truncate)(serialized, maxLength);
    }
    return '';
}
function $3c130969d9628ee3$export$d25f2688db1bb433(val) {
    var e_1, _a;
    if ((0, $okkfE.isPlainObject)(val)) {
        var rv = {};
        try {
            for(var _b = (0, $3VFsf.__values)(Object.keys(val)), _c = _b.next(); !_c.done; _c = _b.next()){
                var key = _c.value;
                if (typeof val[key] !== 'undefined') rv[key] = $3c130969d9628ee3$export$d25f2688db1bb433(val[key]);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return rv;
    }
    if (Array.isArray(val)) return val.map($3c130969d9628ee3$export$d25f2688db1bb433);
    return val;
}
function $3c130969d9628ee3$export$92b78acdbe066b6b(wat) {
    var objectified;
    switch(true){
        case wat === undefined || wat === null:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === 'symbol' || typeof wat === 'bigint':
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $okkfE.isPrimitive)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}

});
parcelRegister("fB1v8", function(module, exports) {

$parcel$export(module.exports, "htmlTreeAsString", () => $b5ab79d71b24e1dd$export$5647df6b7814ac86);
$parcel$export(module.exports, "getLocationHref", () => $b5ab79d71b24e1dd$export$1cfafeee2987818b);

var $eUO5L = parcelRequire("eUO5L");

var $okkfE = parcelRequire("okkfE");
function $b5ab79d71b24e1dd$export$5647df6b7814ac86(elem, keyAttrs) {
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        var currentElem = elem;
        var MAX_TRAVERSE_HEIGHT = 5;
        var MAX_OUTPUT_LEN = 80;
        var out = [];
        var height = 0;
        var len = 0;
        var separator = ' > ';
        var sepLength = separator.length;
        var nextStr = void 0;
        // eslint-disable-next-line no-plusplus
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $b5ab79d71b24e1dd$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds MAX_OUTPUT_LEN
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === 'html' || height > 1 && len + out.length * sepLength + nextStr.length >= MAX_OUTPUT_LEN) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return '<unknown>';
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $b5ab79d71b24e1dd$var$_htmlElementAsString(el, keyAttrs) {
    var elem = el;
    var out = [];
    var className;
    var classes;
    var key;
    var attr;
    var i;
    if (!elem || !elem.tagName) return '';
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    var keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter(function(keyAttr) {
        return elem.getAttribute(keyAttr);
    }).map(function(keyAttr) {
        return [
            keyAttr,
            elem.getAttribute(keyAttr)
        ];
    }) : null;
    if (keyAttrPairs && keyAttrPairs.length) keyAttrPairs.forEach(function(keyAttrPair) {
        out.push("[" + keyAttrPair[0] + "=\"" + keyAttrPair[1] + "\"]");
    });
    else {
        if (elem.id) out.push("#" + elem.id);
        // eslint-disable-next-line prefer-const
        className = elem.className;
        if (className && (0, $okkfE.isString)(className)) {
            classes = className.split(/\s+/);
            for(i = 0; i < classes.length; i++)out.push("." + classes[i]);
        }
    }
    var allowedAttrs = [
        'type',
        'name',
        'title',
        'alt'
    ];
    for(i = 0; i < allowedAttrs.length; i++){
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) out.push("[" + key + "=\"" + attr + "\"]");
    }
    return out.join('');
}
function $b5ab79d71b24e1dd$export$1cfafeee2987818b() {
    var global = (0, $eUO5L.getGlobalObject)();
    try {
        return global.document.location.href;
    } catch (oO) {
        return '';
    }
}

});

parcelRegister("keOcA", function(module, exports) {

$parcel$export(module.exports, "truncate", () => $ebbc0e804ef05913$export$6a506b36fdea397d);
$parcel$export(module.exports, "snipLine", () => $ebbc0e804ef05913$export$4215662d762d6f9d);
$parcel$export(module.exports, "safeJoin", () => $ebbc0e804ef05913$export$465e9d514283d4fd);
$parcel$export(module.exports, "isMatchingPattern", () => $ebbc0e804ef05913$export$cdded5b28a5f8c6d);

var $okkfE = parcelRequire("okkfE");
function $ebbc0e804ef05913$export$6a506b36fdea397d(str, max) {
    if (max === void 0) max = 0;
    if (typeof str !== 'string' || max === 0) return str;
    return str.length <= max ? str : str.substr(0, max) + "...";
}
function $ebbc0e804ef05913$export$4215662d762d6f9d(line, colno) {
    var newLine = line;
    var lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    var start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    var end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = "'{snip} " + newLine;
    if (end < lineLength) newLine += ' {snip}';
    return newLine;
}
function $ebbc0e804ef05913$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return '';
    var output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(var i = 0; i < input.length; i++){
        var value = input[i];
        try {
            output.push(String(value));
        } catch (e) {
            output.push('[value cannot be serialized]');
        }
    }
    return output.join(delimiter);
}
function $ebbc0e804ef05913$export$cdded5b28a5f8c6d(value, pattern) {
    if (!(0, $okkfE.isString)(value)) return false;
    if ((0, $okkfE.isRegExp)(pattern)) return pattern.test(value);
    if (typeof pattern === 'string') return value.indexOf(pattern) !== -1;
    return false;
}
function $ebbc0e804ef05913$export$466fc863a824cea6(regexString) {
    // escape the hyphen separately so we can also replace it with a unicode literal hyphen, to avoid the problems
    // discussed in https://github.com/sindresorhus/escape-string-regexp/issues/20.
    return regexString.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&').replace(/-/g, '\\x2d');
}

});



parcelRegister("4mVTs", function(module, exports) {

$parcel$export(module.exports, "resolvedSyncPromise", () => $32e61feb582e8017$export$1fda8aa4d135f8aa);
$parcel$export(module.exports, "SyncPromise", () => $32e61feb582e8017$export$6f292d4960313241);
$parcel$export(module.exports, "rejectedSyncPromise", () => $32e61feb582e8017$export$78e43115b553f358);
/* eslint-disable @typescript-eslint/explicit-function-return-type */ /* eslint-disable @typescript-eslint/typedef */ /* eslint-disable @typescript-eslint/explicit-module-boundary-types */ /* eslint-disable @typescript-eslint/no-explicit-any */ 
var $okkfE = parcelRequire("okkfE");
function $32e61feb582e8017$export$1fda8aa4d135f8aa(value) {
    return new $32e61feb582e8017$export$6f292d4960313241(function(resolve) {
        resolve(value);
    });
}
function $32e61feb582e8017$export$78e43115b553f358(reason) {
    return new $32e61feb582e8017$export$6f292d4960313241(function(_, reject) {
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ var $32e61feb582e8017$export$6f292d4960313241 = /** @class */ function() {
    function SyncPromise(executor) {
        var _this = this;
        this._state = 0 /* PENDING */ ;
        this._handlers = [];
        /** JSDoc */ this._resolve = function(value) {
            _this._setResult(1 /* RESOLVED */ , value);
        };
        /** JSDoc */ this._reject = function(reason) {
            _this._setResult(2 /* REJECTED */ , reason);
        };
        /** JSDoc */ this._setResult = function(state, value) {
            if (_this._state !== 0 /* PENDING */ ) return;
            if ((0, $okkfE.isThenable)(value)) {
                value.then(_this._resolve, _this._reject);
                return;
            }
            _this._state = state;
            _this._value = value;
            _this._executeHandlers();
        };
        /** JSDoc */ this._executeHandlers = function() {
            if (_this._state === 0 /* PENDING */ ) return;
            var cachedHandlers = _this._handlers.slice();
            _this._handlers = [];
            cachedHandlers.forEach(function(handler) {
                if (handler[0]) return;
                if (_this._state === 1 /* RESOLVED */ ) // eslint-disable-next-line @typescript-eslint/no-floating-promises
                handler[1](_this._value);
                if (_this._state === 2 /* REJECTED */ ) handler[2](_this._value);
                handler[0] = true;
            });
        };
        try {
            executor(this._resolve, this._reject);
        } catch (e) {
            this._reject(e);
        }
    }
    /** JSDoc */ SyncPromise.prototype.then = function(onfulfilled, onrejected) {
        var _this = this;
        return new SyncPromise(function(resolve, reject) {
            _this._handlers.push([
                false,
                function(result) {
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                function(reason) {
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            _this._executeHandlers();
        });
    };
    /** JSDoc */ SyncPromise.prototype.catch = function(onrejected) {
        return this.then(function(val) {
            return val;
        }, onrejected);
    };
    /** JSDoc */ SyncPromise.prototype.finally = function(onfinally) {
        var _this = this;
        return new SyncPromise(function(resolve, reject) {
            var val;
            var isRejected;
            return _this.then(function(value) {
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, function(reason) {
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(function() {
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    };
    return SyncPromise;
}();

});

parcelRegister("gI8Be", function(module, exports) {

$parcel$export(module.exports, "dateTimestampInSeconds", () => dateTimestampInSeconds, (v) => dateTimestampInSeconds = v);
$parcel$export(module.exports, "timestampInSeconds", () => timestampInSeconds, (v) => timestampInSeconds = v);

var $eUO5L = parcelRequire("eUO5L");

var $3kiq9 = parcelRequire("3kiq9");
/**
 * A TimestampSource implementation for environments that do not support the Performance Web API natively.
 *
 * Note that this TimestampSource does not use a monotonic clock. A call to `nowSeconds` may return a timestamp earlier
 * than a previously returned value. We do not try to emulate a monotonic behavior in order to facilitate debugging. It
 * is more obvious to explain "why does my span have negative duration" than "why my spans have zero duration".
 */ var dateTimestampSource = {
    nowSeconds: function() {
        return Date.now() / 1000;
    }
};
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function getBrowserPerformance() {
    var performance = (0, $eUO5L.getGlobalObject)().performance;
    if (!performance || !performance.now) return undefined;
    // Replace performance.timeOrigin with our own timeOrigin based on Date.now().
    //
    // This is a partial workaround for browsers reporting performance.timeOrigin such that performance.timeOrigin +
    // performance.now() gives a date arbitrarily in the past.
    //
    // Additionally, computing timeOrigin in this way fills the gap for browsers where performance.timeOrigin is
    // undefined.
    //
    // The assumption that performance.timeOrigin + performance.now() ~= Date.now() is flawed, but we depend on it to
    // interact with data coming out of performance entries.
    //
    // Note that despite recommendations against it in the spec, browsers implement the Performance API with a clock that
    // might stop when the computer is asleep (and perhaps under other circumstances). Such behavior causes
    // performance.timeOrigin + performance.now() to have an arbitrary skew over Date.now(). In laptop computers, we have
    // observed skews that can be as long as days, weeks or months.
    //
    // See https://github.com/getsentry/sentry-javascript/issues/2590.
    //
    // BUG: despite our best intentions, this workaround has its limitations. It mostly addresses timings of pageload
    // transactions, but ignores the skew built up over time that can aversely affect timestamps of navigation
    // transactions of long-lived web pages.
    var timeOrigin = Date.now() - performance.now();
    return {
        now: function() {
            return performance.now();
        },
        timeOrigin: timeOrigin
    };
}
/**
 * Returns the native Performance API implementation from Node.js. Returns undefined in old Node.js versions that don't
 * implement the API.
 */ function getNodePerformance() {
    try {
        var perfHooks = (0, $3kiq9.dynamicRequire)(module, 'perf_hooks');
        return perfHooks.performance;
    } catch (_) {
        return undefined;
    }
}
/**
 * The Performance API implementation for the current platform, if available.
 */ var platformPerformance = (0, $3kiq9.isNodeEnv)() ? getNodePerformance() : getBrowserPerformance();
var timestampSource = platformPerformance === undefined ? dateTimestampSource : {
    nowSeconds: function() {
        return (platformPerformance.timeOrigin + platformPerformance.now()) / 1000;
    }
};
var dateTimestampInSeconds = dateTimestampSource.nowSeconds.bind(dateTimestampSource);
var timestampInSeconds = timestampSource.nowSeconds.bind(timestampSource);
var timestampWithMs = timestampInSeconds;
var usingPerformanceAPI = platformPerformance !== undefined;
var _browserPerformanceTimeOriginMode;
var browserPerformanceTimeOrigin = function() {
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    var performance = (0, $eUO5L.getGlobalObject)().performance;
    if (!performance || !performance.now) {
        _browserPerformanceTimeOriginMode = 'none';
        return undefined;
    }
    var threshold = 3600000;
    var performanceNow = performance.now();
    var dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    var timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    var timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    var navigationStart = performance.timing && performance.timing.navigationStart;
    var hasNavigationStart = typeof navigationStart === 'number';
    // if navigationStart isn't available set delta to threshold so it isn't used
    var navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    var navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            _browserPerformanceTimeOriginMode = 'timeOrigin';
            return performance.timeOrigin;
        } else {
            _browserPerformanceTimeOriginMode = 'navigationStart';
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    _browserPerformanceTimeOriginMode = 'dateNow';
    return dateNow;
}();

});

parcelRegister("2aljs", function(module, exports) {

$parcel$export(module.exports, "default", () => $21c50eeb436ec60e$export$2e2bcd8739ae039);

var $dmK6z = parcelRequire("dmK6z");


var $21c50eeb436ec60e$export$2e2bcd8739ae039 = (0, $dmK6z.matchRoute);

});
parcelRegister("dmK6z", function(module, exports) {

$parcel$export(module.exports, "matchRoute", () => $f620d08b02c8bdf5$export$b4ee0d6794375c82);

var $gX0Cm = parcelRequire("gX0Cm");

var $iMVWC = parcelRequire("iMVWC");

var $9Kn20 = parcelRequire("9Kn20");

var $djSaC = parcelRequire("djSaC");
function $f620d08b02c8bdf5$export$b4ee0d6794375c82(routes, pathname, queryParams = {}, basePath = '') {
    const queryParamObject = typeof queryParams === 'string' ? (0, $9Kn20.parseQuery)(queryParams) : queryParams;
    // fast return if there is no route or only one route
    if (routes.length === 0) return null;
    if (routes.length === 1) return (0, $iMVWC.getRouteMatch)(routes[0], pathname, queryParamObject, basePath);
    const tree = (0, $djSaC.treeifyRoutes)(routes);
    const route = (0, $gX0Cm.findRoute)(tree, pathname, queryParamObject, basePath) || tree.fallbackRoute;
    return (0, $iMVWC.getRouteMatch)(route, pathname, queryParamObject, basePath);
}

});
parcelRegister("gX0Cm", function(module, exports) {

$parcel$export(module.exports, "findRoute", () => $6fd08c5c012123ec$export$4fa936acba669006);

var $4Gjcu = parcelRequire("4Gjcu");

var $2Vxk3 = parcelRequire("2Vxk3");

var $djSaC = parcelRequire("djSaC");
function $6fd08c5c012123ec$var$pushOrUnshiftByCaptureGroup(arr, node) {
    if (node.segmentPattern.includes('(') && node.segmentPattern.includes(')')) // if the segmentPattern has capturing group, it's more specific
    // so we place it at the beginning of the array
    arr.unshift(node);
    else // otherwise place at the end of the array
    arr.push(node);
}
// Find matching nodes by segment
// sort the nodes by specificity
function $6fd08c5c012123ec$var$matchChildren(node, segments) {
    // how do we define specificity? This is a tricky question.
    // the specificity goes like this:
    // 1. if the segment is an exact match, of course it's the most specific
    // 2. the rest is regex match, within the regex match, we have to consider:
    // 		2.1 the length of segments and if node has descendants. /jira/:id/summary is more specific than /jira/:id if the request URL is /jira/123/summary
    // 3 after checking the length, we have to consider if the segmentPattern has any capturing group. /jira/:id(\d+) is more specific than /jira/:id
    //
    // This is not a comprehensive solution to the specificity problem
    // I will use production urls to verify this heuristic
    const exactMatch = []; // segment is an exact match e.g. /jira matches /jira
    const lengthMatch = []; // check #2.1 from the above comment
    const rest = [];
    const { children: children } = node;
    // treat url segment as empty string if it's undefined
    // possible if we have optional segmentPattern
    const segment = segments[node.level] || '';
    // check if there is next segment
    const hasNextSegment = segments.length > node.level;
    for(const segmentPattern in children)if (Object.prototype.hasOwnProperty.call(children, segmentPattern)) {
        const child = children[segmentPattern];
        if (segment === segmentPattern) // we have exact segment match
        exactMatch.push(child);
        else {
            const regex = (0, $2Vxk3.pathToRegexp)(segmentPattern, [], {
                end: true,
                strict: true,
                sensitive: false
            });
            if (regex.test(segment)) {
                const nodeAhasChildren = Object.keys(child.children).length > 0;
                if (hasNextSegment && nodeAhasChildren) // if there is a next segment, we should prioritize nodes with children
                $6fd08c5c012123ec$var$pushOrUnshiftByCaptureGroup(lengthMatch, child);
                else if (!hasNextSegment && !nodeAhasChildren) // if there is no next segment, we should prioritize nodes without children
                $6fd08c5c012123ec$var$pushOrUnshiftByCaptureGroup(lengthMatch, child);
                else $6fd08c5c012123ec$var$pushOrUnshiftByCaptureGroup(rest, child);
            }
        }
    }
    return [
        ...exactMatch,
        ...lengthMatch,
        ...rest
    ];
}
function $6fd08c5c012123ec$var$recursivelyFindOptionalNodes(node, queryParams = {}) {
    const { segmentPattern: segmentPattern, children: children, routes: routes } = node;
    if (segmentPattern.endsWith('?')) {
        const maybeMatchedRoute = $6fd08c5c012123ec$var$matchRoutesByQuery(routes, queryParams);
        if (maybeMatchedRoute) return maybeMatchedRoute;
        for(const key in children){
            if (Object.prototype.hasOwnProperty.call(children, key)) return $6fd08c5c012123ec$var$recursivelyFindOptionalNodes(children[key]);
        }
    }
}
function $6fd08c5c012123ec$var$matchRoutesByQuery(routes, queryParamObject) {
    if (routes.length === 0) return null;
    // why do we sort the routes by query length?
    // because we want to match the most specific route first
    // and we assume that the more query params a route has, the more specific it is
    // of course, this is a heuristic and is prehaps not true in all cases but good enough for now
    const sortedRoutes = routes.sort((a, b)=>{
        const aQueryLength = a.query?.length || 0;
        const bQueryLength = b.query?.length || 0;
        if (bQueryLength === aQueryLength) {
            const aOrder = a.__unsafeOrder || 0;
            const bOrder = b.__unsafeOrder || 0;
            return aOrder - bOrder;
        }
        return bQueryLength - aQueryLength;
    });
    const filterRoutes = sortedRoutes.filter((route)=>{
        // if route has no query, anything query param will match
        if (route.query === undefined) return true;
        // we will get a real match from the execRouteMatching function later
        const fakeMatch = {
            params: {},
            query: {},
            isExact: false,
            path: '',
            url: ''
        };
        return !!(0, $4Gjcu.matchQuery)(route.query, queryParamObject, fakeMatch);
    });
    if (filterRoutes.length) // return the first (most specific) route that matches the query
    return filterRoutes[0];
    return null;
}
function $6fd08c5c012123ec$export$4fa936acba669006(tree, p, queryParams = {}, basePath) {
    const pathname = p.replace(basePath, '');
    // split the pathname into segments
    // e.g. /jira/projects/123 => ['', 'jira', 'projects', '123']
    const segments = pathname.split('/');
    // remove the first empty string
    if (segments[0] === '') segments.shift();
    // remove the last empty string
    if (segments[segments.length - 1] === '') segments.pop();
    // a first-in-first-out stack to keep track of the nodes we need to visit
    // start with the root node
    const stack = [
        tree.root
    ];
    let count = 0;
    const maxCount = 2000; // to prevent infinite loop
    // when we exacust the stack and can't find a match, means nothing matches
    while(stack.length > 0 && count < maxCount){
        count += 1;
        // pop the first node from the stack
        const node = stack.shift();
        // to make TypeScript happy. It's impossible to have a null node
        if (!node) return null;
        // if the node is a InvariantRoute, it means we have traversed its children and cannot find a higher specificity match
        // we should return this route
        if (!(node instanceof (0, $djSaC.Node))) // we found a match
        return node;
        const { children: children, routes: routes, level: level } = node;
        let maybeMatchedRoute = null;
        let shouldMatchChildren = true;
        if (Object.keys(children).length === 0) {
            // we've reached the end of a branch
            if (!routes.length) throw new Error('It should have a route at the end of a branch.');
            // let's match query
            maybeMatchedRoute = $6fd08c5c012123ec$var$matchRoutesByQuery(routes, queryParams);
            if (maybeMatchedRoute) {
                // do we have more segments to match with?
                if (segments.length > level) // we have more segments to match but this branch doesn't have any children left
                // let's check if the route has `exact: true`.
                {
                    if (maybeMatchedRoute.exact) // let's go to another branch.
                    maybeMatchedRoute = null;
                }
            }
        } else if (segments.length === level) // we've reached the end of the segments
        // does the node have a route?
        {
            if (routes.length) // let's match query
            maybeMatchedRoute = $6fd08c5c012123ec$var$matchRoutesByQuery(routes, queryParams);
        } else if (segments.length < level) {
            // we've exceeded the segments and shouldn't match children anymore
            shouldMatchChildren = false;
            // we check if this node and its children are optional
            // e.g. `/:a?/:b?/:c?` matches `/`
            // we check if `/:a?` node has a route, if `/:b?` node has a route, and if `/:c?` node has a route
            // if any of them has a route, we have a match
            maybeMatchedRoute = $6fd08c5c012123ec$var$recursivelyFindOptionalNodes(node, queryParams);
        } else {
            // there are more segments to match and this node has children
            // we need to check if this node has a route that has `exact: false`
            // if it has, we have a potential match. We will unshift it to the stack.
            // we will continue to check the children of this node to see if we can find a more specific match
            // let's match query
            const lowSpecifityRoute = $6fd08c5c012123ec$var$matchRoutesByQuery(routes, queryParams);
            if (lowSpecifityRoute && !lowSpecifityRoute.exact) // we have a potential match
            stack.unshift(lowSpecifityRoute);
        }
        // yay, we found a match
        if (maybeMatchedRoute) return maybeMatchedRoute;
        if (shouldMatchChildren) {
            // if we haven't found a match, let's check the current node's children
            const nodes = $6fd08c5c012123ec$var$matchChildren(node, segments);
            // add potential matched children to the stack
            stack.unshift(...nodes);
        }
    // go back to the beginning of the loop, pop out the next node from the stack, and repeat
    }
    return null;
}

});
parcelRegister("4Gjcu", function(module, exports) {

$parcel$export(module.exports, "matchQuery", () => $2140f7a77a1b7404$export$c5d1efe363797780);
function $2140f7a77a1b7404$export$c5d1efe363797780(queryConfig, queryParams, pathMatch) {
    const queryMatch = {};
    const isMatchingQuery = queryConfig.every((query)=>{
        // eslint-disable-next-line prefer-const
        let [names, value] = query.split('=');
        let negation = false;
        /* Check if negative matching query param (eg 'foo!=1') */ if (query.includes('!=')) {
            names = names.substring(0, names.length - 1);
            negation = true;
        }
        /* Allow alternate query params presence (eg 'foo|bar') */ const matched = names.split('|').map((name)=>{
            let isOptional = false;
            /* Check if optional query param (eg 'foo?') */ if (name.includes('?')) {
                // eslint-disable-next-line no-param-reassign
                name = name.substring(0, name.length - 1);
                isOptional = true;
            }
            /* First check if queryParams contains the relevant param */ let match = Object.prototype.hasOwnProperty.call(queryParams, name);
            /* Save actual value so we expose it as part of match object */ if (match) queryMatch[name] = queryParams[name] || '';
            /* If no value matching required or it is optional and the param is missing */ if (!value || isOptional && !match) return isOptional || match;
            if (value.startsWith('(')) /* Handle value being a regexp eg 's=(\\d+)' */ match = new RegExp(`^${value}$`).test(queryParams[name] || '');
            else /* Handle value exact matching eg 's=123' */ match = queryParams[name] === value;
            return negation ? !match : match;
        });
        /* If at least one of alternate query params matches then it is a match */ return matched.includes(true);
    });
    return isMatchingQuery ? {
        ...pathMatch,
        query: queryMatch
    } : null;
}

});

parcelRegister("2Vxk3", function(module, exports) {

$parcel$export(module.exports, "pathToRegexp", () => $87141647066fc9c8$export$71304158c7e35877);
// Taken from https://github.com/pillarjs/path-to-regexp/blob/v6.2.1/src/index.ts
// To address version mismatch with root package.json
/**
 * Tokenizer results.
 */ /**
 * Tokenize input string.
 */ function $87141647066fc9c8$var$lexer(str) {
    const tokens = [];
    let i = 0;
    while(i < str.length){
        const char = str[i];
        if (char === '*' || char === '+' || char === '?') {
            tokens.push({
                type: 'MODIFIER',
                index: i,
                value: str[i++]
            });
            continue;
        }
        if (char === '\\') {
            tokens.push({
                type: 'ESCAPED_CHAR',
                index: i++,
                value: str[i++]
            });
            continue;
        }
        if (char === '{') {
            tokens.push({
                type: 'OPEN',
                index: i,
                value: str[i++]
            });
            continue;
        }
        if (char === '}') {
            tokens.push({
                type: 'CLOSE',
                index: i,
                value: str[i++]
            });
            continue;
        }
        if (char === ':') {
            let name = '';
            let j = i + 1;
            while(j < str.length){
                const code = str.charCodeAt(j);
                if (// `0-9`
                code >= 48 && code <= 57 || // `A-Z`
                code >= 65 && code <= 90 || // `a-z`
                code >= 97 && code <= 122 || // `_`
                code === 95) {
                    name += str[j++];
                    continue;
                }
                break;
            }
            if (!name) throw new TypeError(`Missing parameter name at ${i}`);
            tokens.push({
                type: 'NAME',
                index: i,
                value: name
            });
            i = j;
            continue;
        }
        if (char === '(') {
            let count = 1;
            let pattern = '';
            let j = i + 1;
            if (str[j] === '?') throw new TypeError(`Pattern cannot start with "?" at ${j}`);
            while(j < str.length){
                if (str[j] === '\\') {
                    pattern += str[j++] + str[j++];
                    continue;
                }
                if (str[j] === ')') {
                    count--;
                    if (count === 0) {
                        j++;
                        break;
                    }
                } else if (str[j] === '(') {
                    count++;
                    if (str[j + 1] !== '?') throw new TypeError(`Capturing groups are not allowed at ${j}`);
                }
                pattern += str[j++];
            }
            if (count) throw new TypeError(`Unbalanced pattern at ${i}`);
            if (!pattern) throw new TypeError(`Missing pattern at ${i}`);
            tokens.push({
                type: 'PATTERN',
                index: i,
                value: pattern
            });
            i = j;
            continue;
        }
        tokens.push({
            type: 'CHAR',
            index: i,
            value: str[i++]
        });
    }
    tokens.push({
        type: 'END',
        index: i,
        value: ''
    });
    return tokens;
}
function $87141647066fc9c8$export$98e6a39c04603d36(str, options = {}) {
    const tokens = $87141647066fc9c8$var$lexer(str);
    const { prefixes: prefixes = './' } = options;
    const defaultPattern = `[^${$87141647066fc9c8$var$escapeString(options.delimiter || '/#?')}]+?`;
    const result = [];
    let key = 0;
    let i = 0;
    let path = '';
    const tryConsume = (type)=>{
        if (i < tokens.length && tokens[i].type === type) return tokens[i++].value;
    };
    const mustConsume = (type)=>{
        const value = tryConsume(type);
        if (value !== undefined) return value;
        const { type: nextType, index: index } = tokens[i];
        throw new TypeError(`Unexpected ${nextType} at ${index}, expected ${type}`);
    };
    const consumeText = ()=>{
        // eslint-disable-next-line @typescript-eslint/no-shadow -- ERROR TO BE FIXED
        let result = '';
        let value;
        // eslint-disable-next-line no-cond-assign -- ERROR TO BE FIXED
        while(value = tryConsume('CHAR') || tryConsume('ESCAPED_CHAR'))result += value;
        return result;
    };
    while(i < tokens.length){
        const char = tryConsume('CHAR');
        const name = tryConsume('NAME');
        const pattern = tryConsume('PATTERN');
        if (name || pattern) {
            let prefix = char || '';
            if (prefixes.indexOf(prefix) === -1) {
                path += prefix;
                prefix = '';
            }
            if (path) {
                result.push(path);
                path = '';
            }
            result.push({
                name: name || key++,
                prefix: prefix,
                suffix: '',
                pattern: pattern || defaultPattern,
                modifier: tryConsume('MODIFIER') || ''
            });
            continue;
        }
        const value = char || tryConsume('ESCAPED_CHAR');
        if (value) {
            path += value;
            continue;
        }
        if (path) {
            result.push(path);
            path = '';
        }
        const open = tryConsume('OPEN');
        if (open) {
            const prefix = consumeText();
            // eslint-disable-next-line @typescript-eslint/no-shadow -- ERROR TO BE FIXED
            const name = tryConsume('NAME') || '';
            // eslint-disable-next-line @typescript-eslint/no-shadow -- ERROR TO BE FIXED
            const pattern = tryConsume('PATTERN') || '';
            const suffix = consumeText();
            mustConsume('CLOSE');
            result.push({
                name: name || (pattern ? key++ : ''),
                pattern: name && !pattern ? defaultPattern : pattern,
                prefix: prefix,
                suffix: suffix,
                modifier: tryConsume('MODIFIER') || ''
            });
            continue;
        }
        mustConsume('END');
    }
    return result;
}
function $87141647066fc9c8$export$ef7acd7185315e22(str, options) {
    return $87141647066fc9c8$export$5b9bad9e403cf3d9($87141647066fc9c8$export$98e6a39c04603d36(str, options), options);
}
function $87141647066fc9c8$export$5b9bad9e403cf3d9(tokens, options = {}) {
    const reFlags = $87141647066fc9c8$var$flags(options);
    const { encode: encode = (x)=>x, validate: validate = true } = options;
    // Compile all the tokens into regexps.
    // eslint-disable-next-line array-callback-return -- ERROR TO BE FIXED
    const matches = tokens.map((token)=>{
        if (typeof token === 'object') return new RegExp(`^(?:${token.pattern})$`, reFlags);
    });
    return (data)=>{
        let path = '';
        for(let i = 0; i < tokens.length; i++){
            const token = tokens[i];
            if (typeof token === 'string') {
                path += token;
                continue;
            }
            const value = data ? data[token.name] : undefined;
            const optional = token.modifier === '?' || token.modifier === '*';
            const repeat = token.modifier === '*' || token.modifier === '+';
            if (Array.isArray(value)) {
                if (!repeat) throw new TypeError(`Expected "${token.name}" to not repeat, but got an array`);
                if (value.length === 0) {
                    // eslint-disable-next-line no-continue -- ERROR TO BE FIXED
                    if (optional) continue;
                    throw new TypeError(`Expected "${token.name}" to not be empty`);
                }
                for(let j = 0; j < value.length; j++){
                    const segment = encode(value[j], token);
                    if (validate && !matches[i].test(segment)) throw new TypeError(`Expected all "${token.name}" to match "${token.pattern}", but got "${segment}"`);
                    path += token.prefix + segment + token.suffix;
                }
                continue;
            }
            if (typeof value === 'string' || typeof value === 'number') {
                const segment = encode(String(value), token);
                if (validate && !matches[i].test(segment)) throw new TypeError(`Expected "${token.name}" to match "${token.pattern}", but got "${segment}"`);
                path += token.prefix + segment + token.suffix;
                continue;
            }
            // eslint-disable-next-line no-continue -- ERROR TO BE FIXED
            if (optional) continue;
            const typeOfMessage = repeat ? 'an array' : 'a string';
            throw new TypeError(`Expected "${token.name}" to be ${typeOfMessage}`);
        }
        return path;
    };
}
function $87141647066fc9c8$export$4659b591c19bdf3d(str, options) {
    const keys = [];
    const re = $87141647066fc9c8$export$71304158c7e35877(str, keys, options);
    return $87141647066fc9c8$export$968e97c88708237a(re, keys, options);
}
function $87141647066fc9c8$export$968e97c88708237a(re, keys, options = {}) {
    const { decode: decode = (x)=>x } = options;
    return function(pathname) {
        const m = re.exec(pathname);
        if (!m) return false;
        const { 0: path, index: index } = m;
        const params = Object.create(null);
        for(let i = 1; i < m.length; i++){
            // eslint-disable-next-line no-continue -- ERROR TO BE FIXED
            if (m[i] === undefined) continue;
            const key = keys[i - 1];
            if (key.modifier === '*' || key.modifier === '+') params[key.name] = m[i].split(key.prefix + key.suffix).map((value)=>decode(value, key));
            else params[key.name] = decode(m[i], key);
        }
        return {
            path: path,
            index: index,
            params: params
        };
    };
}
/**
 * Escape a regular expression string.
 */ function $87141647066fc9c8$var$escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|/\\])/g, '\\$1');
}
/**
 * Get the flags for a regexp from the options.
 */ function $87141647066fc9c8$var$flags(options) {
    return options && options.sensitive ? '' : 'i';
}
/**
 * Pull out keys from a regexp.
 */ function $87141647066fc9c8$var$regexpToRegexp(path, keys) {
    if (!keys) return path;
    const groupsRegex = /\((?:\?<(.*?)>)?(?!\?)/g;
    let index = 0;
    let execResult = groupsRegex.exec(path.source);
    while(execResult){
        keys.push({
            // Use parenthesized substring match if available, index otherwise
            name: execResult[1] || index++,
            prefix: '',
            suffix: '',
            modifier: '',
            pattern: ''
        });
        execResult = groupsRegex.exec(path.source);
    }
    return path;
}
/**
 * Transform an array into a regexp.
 */ function $87141647066fc9c8$var$arrayToRegexp(paths, keys, options) {
    const parts = paths.map((path)=>$87141647066fc9c8$export$71304158c7e35877(path, keys, options).source);
    return new RegExp(`(?:${parts.join('|')})`, $87141647066fc9c8$var$flags(options));
}
/**
 * Create a path regexp from string input.
 */ function $87141647066fc9c8$var$stringToRegexp(path, keys, options) {
    return $87141647066fc9c8$export$9a9303716def6456($87141647066fc9c8$export$98e6a39c04603d36(path, options), keys, options);
}
function $87141647066fc9c8$export$9a9303716def6456(tokens, keys, options = {}) {
    const { strict: strict = false, start: start = true, end: end = true, encode: encode = (x)=>x, delimiter: delimiter = '/#?', endsWith: endsWith = '' } = options;
    const endsWithRe = `[${$87141647066fc9c8$var$escapeString(endsWith)}]|$`;
    const delimiterRe = `[${$87141647066fc9c8$var$escapeString(delimiter)}]`;
    let route = start ? '^' : '';
    // Iterate over the tokens and create our regexp string.
    for (const token of tokens)if (typeof token === 'string') route += $87141647066fc9c8$var$escapeString(encode(token));
    else {
        const prefix = $87141647066fc9c8$var$escapeString(encode(token.prefix));
        const suffix = $87141647066fc9c8$var$escapeString(encode(token.suffix));
        if (token.pattern) {
            if (keys) keys.push(token);
            if (prefix || suffix) {
                if (token.modifier === '+' || token.modifier === '*') {
                    const mod = token.modifier === '*' ? '?' : '';
                    route += `(?:${prefix}((?:${token.pattern})(?:${suffix}${prefix}(?:${token.pattern}))*)${suffix})${mod}`;
                } else route += `(?:${prefix}(${token.pattern})${suffix})${token.modifier}`;
            } else if (token.modifier === '+' || token.modifier === '*') route += `((?:${token.pattern})${token.modifier})`;
            else route += `(${token.pattern})${token.modifier}`;
        } else route += `(?:${prefix}${suffix})${token.modifier}`;
    }
    if (end) {
        if (!strict) route += `${delimiterRe}?`;
        route += !options.endsWith ? '$' : `(?=${endsWithRe})`;
    } else {
        const endToken = tokens[tokens.length - 1];
        const isEndDelimited = typeof endToken === 'string' ? delimiterRe.indexOf(endToken[endToken.length - 1]) > -1 : endToken === undefined;
        if (!strict) route += `(?:${delimiterRe}(?=${endsWithRe}))?`;
        if (!isEndDelimited) route += `(?=${delimiterRe}|${endsWithRe})`;
    }
    return new RegExp(route, $87141647066fc9c8$var$flags(options));
}
function $87141647066fc9c8$export$71304158c7e35877(path, keys, options) {
    if (path instanceof RegExp) return $87141647066fc9c8$var$regexpToRegexp(path, keys);
    if (Array.isArray(path)) return $87141647066fc9c8$var$arrayToRegexp(path, keys, options);
    return $87141647066fc9c8$var$stringToRegexp(path, keys, options);
}

});

parcelRegister("djSaC", function(module, exports) {

$parcel$export(module.exports, "Node", () => $962456da31b406b7$export$85c928794f8d04d4);
$parcel$export(module.exports, "treeifyRoutes", () => $962456da31b406b7$export$6e055daf7492da67);
/* eslint-disable max-classes-per-file */ class $962456da31b406b7$export$85c928794f8d04d4 {
    constructor(level, segmentPattern){
        this.children = {};
        this.routes = [];
        this.level = level;
        this.segmentPattern = segmentPattern;
    }
}
class $962456da31b406b7$export$7fbedc92909ed28e {
    constructor(){
        // fallback route is the routes that match everything.
        // this is normally useful for 404 pages
        // we specifically handle this route for performance reason
        // because if we put it into the tree, it will always get traversed and has the least specificity.
        this.fallbackRoute = null;
        this.root = new $962456da31b406b7$export$85c928794f8d04d4(0, '');
    }
    insert(segmentPatterns, route) {
        let current = this.root;
        for(let i = 0; i < segmentPatterns.length; i++){
            const segmentPattern = segmentPatterns[i];
            if (!current.children[segmentPattern]) current.children[segmentPattern] = new $962456da31b406b7$export$85c928794f8d04d4(i + 1, segmentPattern);
            current = current.children[segmentPattern];
        }
        current.routes.push(route);
    }
}
const $962456da31b406b7$var$trim = (segmentPatterns)=>{
    // remove the first empty string
    if (segmentPatterns[0] === '') segmentPatterns.shift();
    // remove the last empty string
    if (segmentPatterns[segmentPatterns.length - 1] === '') segmentPatterns.pop();
};
function $962456da31b406b7$export$6e055daf7492da67(routes) {
    const tree = new $962456da31b406b7$export$7fbedc92909ed28e();
    routes.forEach((route)=>{
        if (typeof route.path !== 'string' || route.path === '' || route.path === '/*' || route.path === '*') {
            if (tree.fallbackRoute) throw new Error('There should be only one route that mates everything.');
            tree.fallbackRoute = route;
            return;
        }
        // the regex will match ":projectType(software|software/c|servicedesk|core)"
        // it handles the case where we have multiple segments in a capture group such as "software/c"
        // the regex can be improved to handle more general cases, however let's keep it simple for now
        const match = /:projectType\(([a-z|]*software\/c[a-z|]*)\)/.exec(route.path);
        if (match) {
            // `match` looks like [":projectType(software|software/c|servicedesk|core)", "software|software/c|servicedesk|core" ...]
            const segment = match[0];
            const captureGroup = match[1];
            captureGroup.split('|').forEach((projectType)=>{
                // we craete several branches, e.g.
                // /jira/:projectType(software|software/c)/foo
                // becauses
                // - /jira/software/foo
                // - /jira/software/c/foo
                // although they appear in different position in the tree, they should share the same route
                const path = route.path.replace(segment, projectType);
                const segmentPatterns = path.split('/');
                $962456da31b406b7$var$trim(segmentPatterns);
                tree.insert(segmentPatterns, route);
            });
        } else {
            const segmentPatterns = route.path.split('/');
            $962456da31b406b7$var$trim(segmentPatterns);
            tree.insert(segmentPatterns, route);
        }
    });
    return tree;
}

});


parcelRegister("iMVWC", function(module, exports) {

$parcel$export(module.exports, "getRouteMatch", () => $885117985596e590$export$b4cb787dccedb024);

var $1MIOq = parcelRequire("1MIOq");

var $4Gjcu = parcelRequire("4Gjcu");
/* This should match what react-router does to compute a root match. */ const $885117985596e590$var$computeRootMatch = (pathname)=>({
        path: '/',
        url: '/',
        params: {},
        isExact: pathname === '/',
        query: {}
    });
function $885117985596e590$var$execRouteMatching(route, pathname, queryObj, basePath) {
    const pathMatch = route.path ? (0, $1MIOq.matchPath)(pathname, {
        path: route.path,
        exact: route.exact,
        basePath: basePath
    }) : $885117985596e590$var$computeRootMatch(pathname);
    let match = pathMatch;
    if (pathMatch && route.query) match = (0, $4Gjcu.matchQuery)(route.query, queryObj, pathMatch);
    else if (pathMatch) match = {
        ...pathMatch,
        query: {}
    };
    if (match) return {
        match: match,
        route: route
    };
    return null;
}
function $885117985596e590$export$b4cb787dccedb024(route, pathname, queryParamObject, basePath) {
    if (route) {
        const matchedRoute = $885117985596e590$var$execRouteMatching(route, pathname, queryParamObject, basePath);
        if (matchedRoute) return matchedRoute;
    }
    return null;
}

});
parcelRegister("1MIOq", function(module, exports) {

$parcel$export(module.exports, "matchPath", () => $c26adb01e9b3f781$export$81336c211d5ff295);
// TAKEN FROM https://github.com/ReactTraining/react-router/blob/master/packages/react-router/modules/matchPath.js

var $2Vxk3 = parcelRequire("2Vxk3");
const $c26adb01e9b3f781$var$cache = {};
const $c26adb01e9b3f781$var$cacheLimit = 10000;
let $c26adb01e9b3f781$var$cacheCount = 0;
function $c26adb01e9b3f781$var$compilePath(path, options) {
    const cacheKey = `${options.end}${options.strict}${options.sensitive}`;
    const pathCache = $c26adb01e9b3f781$var$cache[cacheKey] || ($c26adb01e9b3f781$var$cache[cacheKey] = {});
    if (pathCache[path]) return pathCache[path];
    const keys = [];
    const regexp = (0, $2Vxk3.pathToRegexp)(path, keys, options);
    const result = {
        regexp: regexp,
        keys: keys
    };
    if ($c26adb01e9b3f781$var$cacheCount < $c26adb01e9b3f781$var$cacheLimit) {
        pathCache[path] = result;
        $c26adb01e9b3f781$var$cacheCount++;
    }
    return result;
}
function $c26adb01e9b3f781$export$81336c211d5ff295(pathname, options = {}) {
    if (typeof options === 'string' || Array.isArray(options)) // eslint-disable-next-line no-param-reassign
    options = {
        path: options
    };
    const { path: p, exact: exact = false, strict: strict = false, sensitive: sensitive = false, basePath: basePath = '' } = options;
    const paths = [].concat(basePath + p);
    return paths.reduce((matched, path)=>{
        if (!path && path !== '') return null;
        if (matched) return matched;
        const { regexp: regexp, keys: keys } = $c26adb01e9b3f781$var$compilePath(path, {
            end: exact,
            strict: strict,
            sensitive: sensitive
        });
        const match = regexp.exec(pathname);
        if (!match) return null;
        const [url, ...values] = match;
        const isExact = pathname === url;
        if (exact && !isExact) return null;
        return {
            path: path,
            url: path === '/' && url === '' ? '/' : url,
            isExact: isExact,
            params: keys.reduce((memo, key, index)=>{
                // eslint-disable-next-line no-param-reassign
                memo[key.name] = values[index];
                return memo;
            }, {})
        };
    }, null);
}

});


parcelRegister("9Kn20", function(module, exports) {

$parcel$export(module.exports, "parseQuery", () => $ad82e193093a228f$export$1e8473eaf75b0d10);
// Source: https://github.com/unshiftio/querystringify/blob/2.2.0/index.js
// Purpose: Eliminate dependencies from `@atlassian/match-route` for micro-optimization
/**
 * Decode a URI encoded string.
 *
 * @param {String} input The URI encoded string.
 * @returns {String|Null} The decoded string.
 * @api private
 */ function $ad82e193093a228f$var$decode(input) {
    try {
        return decodeURIComponent(input.replace(/\+/g, ' '));
    } catch (e) {
        return null;
    }
}
function $ad82e193093a228f$export$1e8473eaf75b0d10(query) {
    const parser = /([^=?#&]+)=?([^&]*)/g;
    const result = {};
    let part;
    while(part = parser.exec(query)){
        var key = $ad82e193093a228f$var$decode(part[1]), value = $ad82e193093a228f$var$decode(part[2]);
        //
        // Prevent overriding of existing properties. This ensures that build-in
        // methods like `toString` or __proto__ are not overriden by malicious
        // querystrings.
        //
        // In the case if failed decoding, we want to omit the key/value pairs
        // from the result.
        //
        if (key === null || value === null || key in result) continue;
        result[key] = value;
    }
    return result;
}

});



parcelRegister("9E7Uh", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d201f329142c2c2$export$2e2bcd8739ae039);

var $bhUJ4 = parcelRequire("bhUJ4");

var $ibWJJ = parcelRequire("ibWJJ");
const $6d201f329142c2c2$var$DEFAULT_TIMING = {
    initialPollInterval: 5000,
    idleTimeout: 30000,
    multiplierCallback: (x)=>x + x
};
class $6d201f329142c2c2$export$2e2bcd8739ae039 {
    /**
	 * Callback for sending a 'track' analytics event. This callback should either be the
	 * 'sendTrackEvent' method on the AnalyticsWebClient, or a method that eventually delegates to it.
	 * The data for the dwell event will be passed to this method for sending.
	 *
	 * @callback trackCallback
	 * @param {Object} eventData - the base event data that will be added to the track event.
	 */ /**
	 * Creates and initialises the DwellTimeHelper.
	 *
	 * @param {trackCallback} trackCallback - the track callback responsible for actually sending
	 * the event.
	 * @param {Object} eventData - the base data that will be added to the track event.
	 * Additional dwell time attributes will be appended to this data. Note that you don't need to
	 * include the 'action' property, as this will be added automatically.
	 * @param {?string} searchSessionId - a unique identifier for the related search session.
	 * @param {?Object} timingOptions - for the purpose of debugging, you can override the default
	 * timing used for measuring dwell time. The following values are possible:
	 * - initialPollInterval: how long to wait before the first dwell milestone event
	 * is fired (in seconds). Default = 5.
	 * - pollBackoffRate: how much to multiply the last poll interval by on each dwell milestone.
	 * event. Default = 2.
	 * - idleTimeout: how long to wait for no user activity before pausing
	 * the dwell timer (in seconds). Default = 30s.
	 */ constructor(trackCallback, eventData, searchSessionId, timingOptions){
        /**
	 * Starts the dwell timer. This method should be called upon the initial page load.
	 */ this.start = ()=>{
            this.browserInteractionTime.startTimer();
            this.browserInteractionTime.addTimeIntervalEllapsedCallback({
                callback: (timeInMilliseconds)=>this._sendDwellEvent(this._eventData, this._searchSessionId, timeInMilliseconds, false),
                timeInMilliseconds: this._timing.initialPollInterval,
                multiplier: this._timing.multiplierCallback
            });
            if (typeof window !== 'undefined') window.addEventListener('beforeunload', this._onBeforeUnload);
        };
        /**
	 * Stops the dwell timer and sends the final dwell event. Call this method if you wish to
	 * finalise a dwell measurement without starting a new one. When switching to a new page in a
	 * single-page app, use newPage instead.
	 */ this.stop = ()=>{
            if (this.browserInteractionTime.isRunning()) this._sendDwellEvent(this._eventData, this._searchSessionId, this.browserInteractionTime.getTimeInMilliseconds(), true);
            this.browserInteractionTime.stopTimer();
        };
        /**
	 * Send the final dwell event and reinitialise the dwell timer for a new page.
	 * This method should be called whenever a new page is switched to in a single-page app context.
	 *
	 * @param {Object} eventData - the base data that will be added to the track event.
	 * @param {?string} searchSessionId - the new search session ID.
	 */ this.newPage = (eventData, searchSessionId)=>{
            (0, $ibWJJ.validateDwellBaseEvent)(eventData);
            this.stop();
            this.browserInteractionTime.reset();
            this.setEventData(eventData);
            this.setSearchSessionId(searchSessionId);
            this.start();
        };
        this.setEventData = (eventData)=>{
            this._eventData = eventData;
        };
        this.getEventData = ()=>this._eventData;
        this.setSearchSessionId = (searchSessionId)=>{
            this._searchSessionId = searchSessionId;
        };
        this.getSearchSessionId = ()=>this._searchSessionId;
        this.destroy = ()=>{
            this.browserInteractionTime.destroy();
            if (typeof window !== 'undefined') window.removeEventListener('beforeunload', this._onBeforeUnload);
        };
        this._onBeforeUnload = ()=>{
            this.stop();
            this.destroy();
        };
        this._sendDwellEvent = (eventData, searchSessionId, timeInMilliseconds, isFinalDwellEvent)=>{
            const dwellAttributes = {
                dwellTime: timeInMilliseconds,
                searchReferrer: searchSessionId,
                finalDwellEvent: isFinalDwellEvent
            };
            this._trackCallback({
                action: 'dwelled',
                actionSubject: eventData.actionSubject,
                actionSubjectId: eventData.actionSubjectId,
                source: eventData.source,
                containerType: eventData.containerType,
                containerId: eventData.containerId,
                objectType: eventData.objectType,
                objectId: eventData.objectId,
                attributes: {
                    ...dwellAttributes,
                    ...eventData.attributes
                },
                tags: eventData.tags
            });
        };
        if (!trackCallback) throw new Error('trackCallback is required for DwellTimeHelper');
        (0, $ibWJJ.validateDwellBaseEvent)(eventData);
        this._trackCallback = trackCallback;
        this._eventData = eventData;
        this._searchSessionId = searchSessionId;
        this._timing = {
            ...$6d201f329142c2c2$var$DEFAULT_TIMING,
            ...timingOptions
        };
        this.browserInteractionTime = new (0, $bhUJ4.default)({
            idleTimeoutMs: this._timing.idleTimeout,
            checkCallbacksIntervalMs: 500
        });
    }
}

});

parcelRegister("6Lg6A", function(module, exports) {

$parcel$export(module.exports, "LazyWait", () => $cbd15d2aa1b9d641$export$7bf6cf03fd32cddb);

var $5uXOq = parcelRequire("5uXOq");

var $5poak = parcelRequire("5poak");
const $cbd15d2aa1b9d641$export$7bf6cf03fd32cddb = ({ until: until, children: children })=>{
    const closestWait = (0, $5uXOq.useContext)((0, $5poak.WaitContext));
    const value = (0, $5uXOq.useRef)(until && closestWait.currentValue() ? 1 : 0);
    const subscribers = (0, $5uXOq.useRef)(new Set());
    const api = (0, $5uXOq.useRef)({
        subscribe: (subscriber)=>{
            subscribers.current.add(subscriber);
            return ()=>{
                subscribers.current.delete(subscriber);
            };
        },
        currentValue: ()=>value.current
    });
    (0, $5uXOq.useEffect)(()=>{
        // Notify subscribers when until prop or closest until value changes
        const notify = ()=>{
            value.current = closestWait.currentValue() && until ? 1 : 0;
            subscribers.current.forEach((subscriber)=>subscriber());
        };
        notify();
        return closestWait.subscribe(notify);
    }, [
        closestWait,
        until
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5poak.WaitContext).Provider, {
        value: api.current
    }, children);
};

});

parcelRegister("hZpZ3", function(module, exports) {

$parcel$export(module.exports, "forget", () => $d18c4a06ec047594$export$93c25f2590a5b540);
/**
 * Consumes the promise and logs the error when it rejects.
 * @param promise A promise to forget.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $d18c4a06ec047594$export$93c25f2590a5b540(promise) {
    promise.then(null, function(e) {
        // TODO: Use a better logging mechanism
        // eslint-disable-next-line no-console
        console.error(e);
    });
}

});

parcelRegister("ha3jm", function(module, exports) {

$parcel$export(module.exports, "dsnToString", () => $033962d845f489d3$export$44d472fbb931a776);
$parcel$export(module.exports, "makeDsn", () => $033962d845f489d3$export$128827c3562ec0cb);

var $3VFsf = parcelRequire("3VFsf");

var $f7sqx = parcelRequire("f7sqx");

var $1pUkh = parcelRequire("1pUkh");
/** Regular expression used to parse a Dsn. */ var $033962d845f489d3$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+))?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function $033962d845f489d3$var$isValidProtocol(protocol) {
    return protocol === 'http' || protocol === 'https';
}
function $033962d845f489d3$export$44d472fbb931a776(dsn, withPassword) {
    if (withPassword === void 0) withPassword = false;
    var host = dsn.host, path = dsn.path, pass = dsn.pass, port = dsn.port, projectId = dsn.projectId, protocol = dsn.protocol, publicKey = dsn.publicKey;
    return protocol + "://" + publicKey + (withPassword && pass ? ":" + pass : '') + ("@" + host + (port ? ":" + port : '') + "/" + (path ? path + "/" : path) + projectId);
}
function $033962d845f489d3$var$dsnFromString(str) {
    var match = $033962d845f489d3$var$DSN_REGEX.exec(str);
    if (!match) throw new (0, $f7sqx.SentryError)("Invalid Sentry Dsn: " + str);
    var _a = (0, $3VFsf.__read)(match.slice(1), 6), protocol = _a[0], publicKey = _a[1], _b = _a[2], pass = _b === void 0 ? '' : _b, host = _a[3], _c = _a[4], port = _c === void 0 ? '' : _c, lastPath = _a[5];
    var path = '';
    var projectId = lastPath;
    var split = projectId.split('/');
    if (split.length > 1) {
        path = split.slice(0, -1).join('/');
        projectId = split.pop();
    }
    if (projectId) {
        var projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $033962d845f489d3$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $033962d845f489d3$var$dsnFromComponents(components) {
    // TODO this is for backwards compatibility, and can be removed in a future version
    if ('user' in components && !('publicKey' in components)) components.publicKey = components.user;
    return {
        user: components.publicKey || '',
        protocol: components.protocol,
        publicKey: components.publicKey || '',
        pass: components.pass || '',
        host: components.host,
        port: components.port || '',
        path: components.path || '',
        projectId: components.projectId
    };
}
function $033962d845f489d3$var$validateDsn(dsn) {
    if (!(0, $1pUkh.IS_DEBUG_BUILD)) return;
    var port = dsn.port, projectId = dsn.projectId, protocol = dsn.protocol;
    var requiredComponents = [
        'protocol',
        'publicKey',
        'host',
        'projectId'
    ];
    requiredComponents.forEach(function(component) {
        if (!dsn[component]) throw new (0, $f7sqx.SentryError)("Invalid Sentry Dsn: " + component + " missing");
    });
    if (!projectId.match(/^\d+$/)) throw new (0, $f7sqx.SentryError)("Invalid Sentry Dsn: Invalid projectId " + projectId);
    if (!$033962d845f489d3$var$isValidProtocol(protocol)) throw new (0, $f7sqx.SentryError)("Invalid Sentry Dsn: Invalid protocol " + protocol);
    if (port && isNaN(parseInt(port, 10))) throw new (0, $f7sqx.SentryError)("Invalid Sentry Dsn: Invalid port " + port);
    return true;
}
function $033962d845f489d3$export$128827c3562ec0cb(from) {
    var components = typeof from === 'string' ? $033962d845f489d3$var$dsnFromString(from) : $033962d845f489d3$var$dsnFromComponents(from);
    $033962d845f489d3$var$validateDsn(components);
    return components;
}

});
parcelRegister("f7sqx", function(module, exports) {

$parcel$export(module.exports, "SentryError", () => $b01d8f7464044e0f$export$5949942ba2a7c0e2);

var $3VFsf = parcelRequire("3VFsf");

var $aKKyi = parcelRequire("aKKyi");
/** An error emitted by Sentry SDKs and related utilities. */ var $b01d8f7464044e0f$export$5949942ba2a7c0e2 = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(SentryError, _super);
    function SentryError(message) {
        var _newTarget = this.constructor;
        var _this = _super.call(this, message) || this;
        _this.message = message;
        _this.name = _newTarget.prototype.constructor.name;
        (0, $aKKyi.setPrototypeOf)(_this, _newTarget.prototype);
        return _this;
    }
    return SentryError;
}(Error);

});
parcelRegister("aKKyi", function(module, exports) {

$parcel$export(module.exports, "setPrototypeOf", () => $020532d4ed9bf426$export$1cb0d91350beb6cc);
var $020532d4ed9bf426$export$1cb0d91350beb6cc = Object.setPrototypeOf || (({
    __proto__: []
}) instanceof Array ? $020532d4ed9bf426$var$setProtoOf : $020532d4ed9bf426$var$mixinProperties);
/**
 * setPrototypeOf polyfill using __proto__
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $020532d4ed9bf426$var$setProtoOf(obj, proto) {
    // @ts-ignore __proto__ does not exist on obj
    obj.__proto__ = proto;
    return obj;
}
/**
 * setPrototypeOf polyfill using mixin
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $020532d4ed9bf426$var$mixinProperties(obj, proto) {
    for(var prop in proto)if (!Object.prototype.hasOwnProperty.call(obj, prop)) // @ts-ignore typescript complains about indexing so we remove
    obj[prop] = proto[prop];
    return obj;
}

});



parcelRegister("iDqcL", function(module, exports) {

$parcel$export(module.exports, "addInstrumentationHandler", () => $d9103240d7f3ffea$export$285b9172a3741fb7);

var $3VFsf = parcelRequire("3VFsf");

var $1pUkh = parcelRequire("1pUkh");

var $eUO5L = parcelRequire("eUO5L");

var $okkfE = parcelRequire("okkfE");

var $aHQIJ = parcelRequire("aHQIJ");

var $59M0S = parcelRequire("59M0S");

var $1M66C = parcelRequire("1M66C");

var $9BO8q = parcelRequire("9BO8q");
var $d9103240d7f3ffea$var$global = (0, $eUO5L.getGlobalObject)();
/**
 * Instrument native APIs to call handlers that can be used to create breadcrumbs, APM spans etc.
 *  - Console API
 *  - Fetch API
 *  - XHR API
 *  - History API
 *  - DOM API (click/typing)
 *  - Error API
 *  - UnhandledRejection API
 */ var $d9103240d7f3ffea$var$handlers = {};
var $d9103240d7f3ffea$var$instrumented = {};
/** Instruments given API */ function $d9103240d7f3ffea$var$instrument(type) {
    if ($d9103240d7f3ffea$var$instrumented[type]) return;
    $d9103240d7f3ffea$var$instrumented[type] = true;
    switch(type){
        case 'console':
            $d9103240d7f3ffea$var$instrumentConsole();
            break;
        case 'dom':
            $d9103240d7f3ffea$var$instrumentDOM();
            break;
        case 'xhr':
            $d9103240d7f3ffea$var$instrumentXHR();
            break;
        case 'fetch':
            $d9103240d7f3ffea$var$instrumentFetch();
            break;
        case 'history':
            $d9103240d7f3ffea$var$instrumentHistory();
            break;
        case 'error':
            $d9103240d7f3ffea$var$instrumentError();
            break;
        case 'unhandledrejection':
            $d9103240d7f3ffea$var$instrumentUnhandledRejection();
            break;
        default:
            (0, $1pUkh.IS_DEBUG_BUILD) && (0, $aHQIJ.logger).warn('unknown instrumentation type:', type);
            return;
    }
}
function $d9103240d7f3ffea$export$285b9172a3741fb7(type, callback) {
    $d9103240d7f3ffea$var$handlers[type] = $d9103240d7f3ffea$var$handlers[type] || [];
    $d9103240d7f3ffea$var$handlers[type].push(callback);
    $d9103240d7f3ffea$var$instrument(type);
}
/** JSDoc */ function $d9103240d7f3ffea$var$triggerHandlers(type, data) {
    var e_1, _a;
    if (!type || !$d9103240d7f3ffea$var$handlers[type]) return;
    try {
        for(var _b = (0, $3VFsf.__values)($d9103240d7f3ffea$var$handlers[type] || []), _c = _b.next(); !_c.done; _c = _b.next()){
            var handler = _c.value;
            try {
                handler(data);
            } catch (e) {
                (0, $1pUkh.IS_DEBUG_BUILD) && (0, $aHQIJ.logger).error("Error while triggering instrumentation handler.\nType: " + type + "\nName: " + (0, $1M66C.getFunctionName)(handler) + "\nError:", e);
            }
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
}
/** JSDoc */ function $d9103240d7f3ffea$var$instrumentConsole() {
    if (!('console' in $d9103240d7f3ffea$var$global)) return;
    (0, $aHQIJ.CONSOLE_LEVELS).forEach(function(level) {
        if (!(level in $d9103240d7f3ffea$var$global.console)) return;
        (0, $59M0S.fill)($d9103240d7f3ffea$var$global.console, level, function(originalConsoleMethod) {
            return function() {
                var args = [];
                for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                $d9103240d7f3ffea$var$triggerHandlers('console', {
                    args: args,
                    level: level
                });
                // this fails for some browsers. :(
                if (originalConsoleMethod) originalConsoleMethod.apply($d9103240d7f3ffea$var$global.console, args);
            };
        });
    });
}
/** JSDoc */ function $d9103240d7f3ffea$var$instrumentFetch() {
    if (!(0, $9BO8q.supportsNativeFetch)()) return;
    (0, $59M0S.fill)($d9103240d7f3ffea$var$global, 'fetch', function(originalFetch) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var handlerData = {
                args: args,
                fetchData: {
                    method: $d9103240d7f3ffea$var$getFetchMethod(args),
                    url: $d9103240d7f3ffea$var$getFetchUrl(args)
                },
                startTimestamp: Date.now()
            };
            $d9103240d7f3ffea$var$triggerHandlers('fetch', (0, $3VFsf.__assign)({}, handlerData));
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply($d9103240d7f3ffea$var$global, args).then(function(response) {
                $d9103240d7f3ffea$var$triggerHandlers('fetch', (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, handlerData), {
                    endTimestamp: Date.now(),
                    response: response
                }));
                return response;
            }, function(error) {
                $d9103240d7f3ffea$var$triggerHandlers('fetch', (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, handlerData), {
                    endTimestamp: Date.now(),
                    error: error
                }));
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /** Extract `method` from fetch call arguments */ function $d9103240d7f3ffea$var$getFetchMethod(fetchArgs) {
    if (fetchArgs === void 0) fetchArgs = [];
    if ('Request' in $d9103240d7f3ffea$var$global && (0, $okkfE.isInstanceOf)(fetchArgs[0], Request) && fetchArgs[0].method) return String(fetchArgs[0].method).toUpperCase();
    if (fetchArgs[1] && fetchArgs[1].method) return String(fetchArgs[1].method).toUpperCase();
    return 'GET';
}
/** Extract `url` from fetch call arguments */ function $d9103240d7f3ffea$var$getFetchUrl(fetchArgs) {
    if (fetchArgs === void 0) fetchArgs = [];
    if (typeof fetchArgs[0] === 'string') return fetchArgs[0];
    if ('Request' in $d9103240d7f3ffea$var$global && (0, $okkfE.isInstanceOf)(fetchArgs[0], Request)) return fetchArgs[0].url;
    return String(fetchArgs[0]);
}
/* eslint-enable @typescript-eslint/no-unsafe-member-access */ /** JSDoc */ function $d9103240d7f3ffea$var$instrumentXHR() {
    if (!('XMLHttpRequest' in $d9103240d7f3ffea$var$global)) return;
    var xhrproto = XMLHttpRequest.prototype;
    (0, $59M0S.fill)(xhrproto, 'open', function(originalOpen) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            var xhr = this;
            var url = args[1];
            var xhrInfo = xhr.__sentry_xhr__ = {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                method: (0, $okkfE.isString)(args[0]) ? args[0].toUpperCase() : args[0],
                url: args[1]
            };
            // if Sentry key appears in URL, don't capture it as a request
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            if ((0, $okkfE.isString)(url) && xhrInfo.method === 'POST' && url.match(/sentry_key/)) xhr.__sentry_own_request__ = true;
            var onreadystatechangeHandler = function() {
                if (xhr.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        xhrInfo.status_code = xhr.status;
                    } catch (e) {
                    /* do nothing */ }
                    $d9103240d7f3ffea$var$triggerHandlers('xhr', {
                        args: args,
                        endTimestamp: Date.now(),
                        startTimestamp: Date.now(),
                        xhr: xhr
                    });
                }
            };
            if ('onreadystatechange' in xhr && typeof xhr.onreadystatechange === 'function') (0, $59M0S.fill)(xhr, 'onreadystatechange', function(original) {
                return function() {
                    var readyStateArgs = [];
                    for(var _i = 0; _i < arguments.length; _i++)readyStateArgs[_i] = arguments[_i];
                    onreadystatechangeHandler();
                    return original.apply(xhr, readyStateArgs);
                };
            });
            else xhr.addEventListener('readystatechange', onreadystatechangeHandler);
            return originalOpen.apply(xhr, args);
        };
    });
    (0, $59M0S.fill)(xhrproto, 'send', function(originalSend) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.__sentry_xhr__ && args[0] !== undefined) this.__sentry_xhr__.body = args[0];
            $d9103240d7f3ffea$var$triggerHandlers('xhr', {
                args: args,
                startTimestamp: Date.now(),
                xhr: this
            });
            return originalSend.apply(this, args);
        };
    });
}
var $d9103240d7f3ffea$var$lastHref;
/** JSDoc */ function $d9103240d7f3ffea$var$instrumentHistory() {
    if (!(0, $9BO8q.supportsHistory)()) return;
    var oldOnPopState = $d9103240d7f3ffea$var$global.onpopstate;
    $d9103240d7f3ffea$var$global.onpopstate = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var to = $d9103240d7f3ffea$var$global.location.href;
        // keep track of the current URL state, as we always receive only the updated state
        var from = $d9103240d7f3ffea$var$lastHref;
        $d9103240d7f3ffea$var$lastHref = to;
        $d9103240d7f3ffea$var$triggerHandlers('history', {
            from: from,
            to: to
        });
        if (oldOnPopState) // Apparently this can throw in Firefox when incorrectly implemented plugin is installed.
        // https://github.com/getsentry/sentry-javascript/issues/3344
        // https://github.com/bugsnag/bugsnag-js/issues/469
        try {
            return oldOnPopState.apply(this, args);
        } catch (_oO) {
        // no-empty
        }
    };
    /** @hidden */ function historyReplacementFunction(originalHistoryFunction) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var url = args.length > 2 ? args[2] : undefined;
            if (url) {
                // coerce to string (this is what pushState does)
                var from = $d9103240d7f3ffea$var$lastHref;
                var to = String(url);
                // keep track of the current URL state, as we always receive only the updated state
                $d9103240d7f3ffea$var$lastHref = to;
                $d9103240d7f3ffea$var$triggerHandlers('history', {
                    from: from,
                    to: to
                });
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, $59M0S.fill)($d9103240d7f3ffea$var$global.history, 'pushState', historyReplacementFunction);
    (0, $59M0S.fill)($d9103240d7f3ffea$var$global.history, 'replaceState', historyReplacementFunction);
}
var $d9103240d7f3ffea$var$debounceDuration = 1000;
var $d9103240d7f3ffea$var$debounceTimerID;
var $d9103240d7f3ffea$var$lastCapturedEvent;
/**
 * Decide whether the current event should finish the debounce of previously captured one.
 * @param previous previously captured event
 * @param current event to be captured
 */ function $d9103240d7f3ffea$var$shouldShortcircuitPreviousDebounce(previous, current) {
    // If there was no previous event, it should always be swapped for the new one.
    if (!previous) return true;
    // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
    if (previous.type !== current.type) return true;
    try {
        // If both events have the same type, it's still possible that actions were performed on different targets.
        // e.g. 2 clicks on different buttons.
        if (previous.target !== current.target) return true;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
    // to which an event listener was attached), we treat them as the same action, as we want to capture
    // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
    return false;
}
/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */ function $d9103240d7f3ffea$var$shouldSkipDOMEvent(event) {
    // We are only interested in filtering `keypress` events for now.
    if (event.type !== 'keypress') return false;
    try {
        var target = event.target;
        if (!target || !target.tagName) return true;
        // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
        // e.g.tabbing through elements, hotkeys, etc.
        if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) return false;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    return true;
}
/**
 * Wraps addEventListener to capture UI breadcrumbs
 * @param handler function that will be triggered
 * @param globalListener indicates whether event was captured by the global event listener
 * @returns wrapped breadcrumb events handler
 * @hidden
 */ function $d9103240d7f3ffea$var$makeDOMEventHandler(handler, globalListener) {
    if (globalListener === void 0) globalListener = false;
    return function(event) {
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors).
        // Ignore if we've already captured that event.
        if (!event || $d9103240d7f3ffea$var$lastCapturedEvent === event) return;
        // We always want to skip _some_ events.
        if ($d9103240d7f3ffea$var$shouldSkipDOMEvent(event)) return;
        var name = event.type === 'keypress' ? 'input' : event.type;
        // If there is no debounce timer, it means that we can safely capture the new event and store it for future comparisons.
        if ($d9103240d7f3ffea$var$debounceTimerID === undefined) {
            handler({
                event: event,
                name: name,
                global: globalListener
            });
            $d9103240d7f3ffea$var$lastCapturedEvent = event;
        } else if ($d9103240d7f3ffea$var$shouldShortcircuitPreviousDebounce($d9103240d7f3ffea$var$lastCapturedEvent, event)) {
            handler({
                event: event,
                name: name,
                global: globalListener
            });
            $d9103240d7f3ffea$var$lastCapturedEvent = event;
        }
        // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
        clearTimeout($d9103240d7f3ffea$var$debounceTimerID);
        $d9103240d7f3ffea$var$debounceTimerID = $d9103240d7f3ffea$var$global.setTimeout(function() {
            $d9103240d7f3ffea$var$debounceTimerID = undefined;
        }, $d9103240d7f3ffea$var$debounceDuration);
    };
}
/** JSDoc */ function $d9103240d7f3ffea$var$instrumentDOM() {
    if (!('document' in $d9103240d7f3ffea$var$global)) return;
    // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
    // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
    // we instrument `addEventListener` so that we don't end up attaching this handler twice.
    var triggerDOMHandler = $d9103240d7f3ffea$var$triggerHandlers.bind(null, 'dom');
    var globalDOMEventHandler = $d9103240d7f3ffea$var$makeDOMEventHandler(triggerDOMHandler, true);
    $d9103240d7f3ffea$var$global.document.addEventListener('click', globalDOMEventHandler, false);
    $d9103240d7f3ffea$var$global.document.addEventListener('keypress', globalDOMEventHandler, false);
    // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
    // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
    // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
    // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
    // guaranteed to fire at least once.)
    [
        'EventTarget',
        'Node'
    ].forEach(function(target) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        var proto = $d9103240d7f3ffea$var$global[target] && $d9103240d7f3ffea$var$global[target].prototype;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) return;
        (0, $59M0S.fill)(proto, 'addEventListener', function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    var el = this;
                    var handlers_1 = el.__sentry_instrumentation_handlers__ = el.__sentry_instrumentation_handlers__ || {};
                    var handlerForType = handlers_1[type] = handlers_1[type] || {
                        refCount: 0
                    };
                    if (!handlerForType.handler) {
                        var handler = $d9103240d7f3ffea$var$makeDOMEventHandler(triggerDOMHandler);
                        handlerForType.handler = handler;
                        originalAddEventListener.call(this, type, handler, options);
                    }
                    handlerForType.refCount += 1;
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0, $59M0S.fill)(proto, 'removeEventListener', function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    var el = this;
                    var handlers_2 = el.__sentry_instrumentation_handlers__ || {};
                    var handlerForType = handlers_2[type];
                    if (handlerForType) {
                        handlerForType.refCount -= 1;
                        // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                        if (handlerForType.refCount <= 0) {
                            originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                            handlerForType.handler = undefined;
                            delete handlers_2[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                        }
                        // If there are no longer any custom handlers of any type on this element, cleanup everything.
                        if (Object.keys(handlers_2).length === 0) delete el.__sentry_instrumentation_handlers__;
                    }
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
var $d9103240d7f3ffea$var$_oldOnErrorHandler = null;
/** JSDoc */ function $d9103240d7f3ffea$var$instrumentError() {
    $d9103240d7f3ffea$var$_oldOnErrorHandler = $d9103240d7f3ffea$var$global.onerror;
    $d9103240d7f3ffea$var$global.onerror = function(msg, url, line, column, error) {
        $d9103240d7f3ffea$var$triggerHandlers('error', {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        });
        if ($d9103240d7f3ffea$var$_oldOnErrorHandler) // eslint-disable-next-line prefer-rest-params
        return $d9103240d7f3ffea$var$_oldOnErrorHandler.apply(this, arguments);
        return false;
    };
}
var $d9103240d7f3ffea$var$_oldOnUnhandledRejectionHandler = null;
/** JSDoc */ function $d9103240d7f3ffea$var$instrumentUnhandledRejection() {
    $d9103240d7f3ffea$var$_oldOnUnhandledRejectionHandler = $d9103240d7f3ffea$var$global.onunhandledrejection;
    $d9103240d7f3ffea$var$global.onunhandledrejection = function(e) {
        $d9103240d7f3ffea$var$triggerHandlers('unhandledrejection', e);
        if ($d9103240d7f3ffea$var$_oldOnUnhandledRejectionHandler) // eslint-disable-next-line prefer-rest-params
        return $d9103240d7f3ffea$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
}

});
parcelRegister("1M66C", function(module, exports) {

$parcel$export(module.exports, "createStackParser", () => $14af02975f6319e3$export$a5739666fb2d03d4);
$parcel$export(module.exports, "getFunctionName", () => $14af02975f6319e3$export$aad197c7121a6651);

var $3VFsf = parcelRequire("3VFsf");
var $14af02975f6319e3$var$STACKTRACE_LIMIT = 50;
function $14af02975f6319e3$export$a5739666fb2d03d4() {
    var parsers = [];
    for(var _i = 0; _i < arguments.length; _i++)parsers[_i] = arguments[_i];
    var sortedParsers = parsers.sort(function(a, b) {
        return a[0] - b[0];
    }).map(function(p) {
        return p[1];
    });
    return function(stack, skipFirst) {
        var e_1, _a, e_2, _b;
        if (skipFirst === void 0) skipFirst = 0;
        var frames = [];
        try {
            for(var _c = (0, $3VFsf.__values)(stack.split('\n').slice(skipFirst)), _d = _c.next(); !_d.done; _d = _c.next()){
                var line = _d.value;
                try {
                    for(var sortedParsers_1 = (e_2 = void 0, (0, $3VFsf.__values)(sortedParsers)), sortedParsers_1_1 = sortedParsers_1.next(); !sortedParsers_1_1.done; sortedParsers_1_1 = sortedParsers_1.next()){
                        var parser = sortedParsers_1_1.value;
                        var frame = parser(line);
                        if (frame) {
                            frames.push(frame);
                            break;
                        }
                    }
                } catch (e_2_1) {
                    e_2 = {
                        error: e_2_1
                    };
                } finally{
                    try {
                        if (sortedParsers_1_1 && !sortedParsers_1_1.done && (_b = sortedParsers_1.return)) _b.call(sortedParsers_1);
                    } finally{
                        if (e_2) throw e_2.error;
                    }
                }
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return $14af02975f6319e3$export$c55c24c0eeba0205(frames);
    };
}
function $14af02975f6319e3$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    var localStack = stack;
    var firstFrameFunction = localStack[0].function || '';
    var lastFrameFunction = localStack[localStack.length - 1].function || '';
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (firstFrameFunction.indexOf('captureMessage') !== -1 || firstFrameFunction.indexOf('captureException') !== -1) localStack = localStack.slice(1);
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if (lastFrameFunction.indexOf('sentryWrapped') !== -1) localStack = localStack.slice(0, -1);
    // The frame where the crash happened, should be the last entry in the array
    return localStack.slice(0, $14af02975f6319e3$var$STACKTRACE_LIMIT).map(function(frame) {
        return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, frame), {
            filename: frame.filename || localStack[0].filename,
            function: frame.function || '?'
        });
    }).reverse();
}
var $14af02975f6319e3$var$defaultFunctionName = '<anonymous>';
function $14af02975f6319e3$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== 'function') return $14af02975f6319e3$var$defaultFunctionName;
        return fn.name || $14af02975f6319e3$var$defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $14af02975f6319e3$var$defaultFunctionName;
    }
}

});

parcelRegister("9BO8q", function(module, exports) {

$parcel$export(module.exports, "supportsFetch", () => $6fee758568fb716d$export$edf3cb81fd7d2a3e);
$parcel$export(module.exports, "isNativeFetch", () => $6fee758568fb716d$export$18cf36ed71d733e7);
$parcel$export(module.exports, "supportsNativeFetch", () => $6fee758568fb716d$export$c82d238e23c40b21);
$parcel$export(module.exports, "supportsReferrerPolicy", () => $6fee758568fb716d$export$2d308b428295192f);
$parcel$export(module.exports, "supportsHistory", () => $6fee758568fb716d$export$67fc34576016d6ec);

var $1pUkh = parcelRequire("1pUkh");

var $eUO5L = parcelRequire("eUO5L");

var $aHQIJ = parcelRequire("aHQIJ");
function $6fee758568fb716d$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent('');
        return true;
    } catch (e) {
        return false;
    }
}
function $6fee758568fb716d$export$1c08bd1a7eb3c472() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-ignore It really needs 1 argument, not 0.
        new DOMError('');
        return true;
    } catch (e) {
        return false;
    }
}
function $6fee758568fb716d$export$ab12a5d056f1d3a() {
    try {
        new DOMException('');
        return true;
    } catch (e) {
        return false;
    }
}
function $6fee758568fb716d$export$edf3cb81fd7d2a3e() {
    if (!('fetch' in (0, $eUO5L.getGlobalObject)())) return false;
    try {
        new Headers();
        new Request('');
        new Response();
        return true;
    } catch (e) {
        return false;
    }
}
function $6fee758568fb716d$export$18cf36ed71d733e7(func) {
    return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
function $6fee758568fb716d$export$c82d238e23c40b21() {
    if (!$6fee758568fb716d$export$edf3cb81fd7d2a3e()) return false;
    var global = (0, $eUO5L.getGlobalObject)();
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if ($6fee758568fb716d$export$18cf36ed71d733e7(global.fetch)) return true;
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    var result = false;
    var doc = global.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === 'function') try {
        var sandbox = doc.createElement('iframe');
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow && sandbox.contentWindow.fetch) // eslint-disable-next-line @typescript-eslint/unbound-method
        result = $6fee758568fb716d$export$18cf36ed71d733e7(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, $1pUkh.IS_DEBUG_BUILD) && (0, $aHQIJ.logger).warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
    }
    return result;
}
function $6fee758568fb716d$export$531055a6c684a70a() {
    return 'ReportingObserver' in (0, $eUO5L.getGlobalObject)();
}
function $6fee758568fb716d$export$2d308b428295192f() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!$6fee758568fb716d$export$edf3cb81fd7d2a3e()) return false;
    try {
        new Request('_', {
            referrerPolicy: 'origin'
        });
        return true;
    } catch (e) {
        return false;
    }
}
function $6fee758568fb716d$export$67fc34576016d6ec() {
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    var global = (0, $eUO5L.getGlobalObject)();
    /* eslint-disable @typescript-eslint/no-unsafe-member-access */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var chrome = global.chrome;
    var isChromePackagedApp = chrome && chrome.app && chrome.app.runtime;
    /* eslint-enable @typescript-eslint/no-unsafe-member-access */ var hasHistoryApi = 'history' in global && !!global.history.pushState && !!global.history.replaceState;
    return !isChromePackagedApp && hasHistoryApi;
}

});


parcelRegister("gBQwe", function(module, exports) {

$parcel$export(module.exports, "normalize", () => $c178d7365214c01f$export$a3295358bff77e);
$parcel$export(module.exports, "normalizeToSize", () => $c178d7365214c01f$export$23fbbb20bed71033);

var $3VFsf = parcelRequire("3VFsf");

var $okkfE = parcelRequire("okkfE");

var $kbQkj = parcelRequire("kbQkj");

var $59M0S = parcelRequire("59M0S");

var $1M66C = parcelRequire("1M66C");
function $c178d7365214c01f$export$a3295358bff77e(input, depth, maxProperties) {
    if (depth === void 0) depth = Infinity;
    if (maxProperties === void 0) maxProperties = Infinity;
    try {
        // since we're at the outermost level, there is no key
        return $c178d7365214c01f$export$588732934346abbf('', input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: "**non-serializable** (" + err + ")"
        };
    }
}
function $c178d7365214c01f$export$23fbbb20bed71033(object, // Default Node.js REPL depth
depth, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize) {
    if (depth === void 0) depth = 3;
    if (maxSize === void 0) maxSize = 102400;
    var normalized = $c178d7365214c01f$export$a3295358bff77e(object, depth);
    if ($c178d7365214c01f$var$jsonSize(normalized) > maxSize) return $c178d7365214c01f$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $c178d7365214c01f$export$588732934346abbf(key, value, depth, maxProperties, memo) {
    if (depth === void 0) depth = Infinity;
    if (maxProperties === void 0) maxProperties = Infinity;
    if (memo === void 0) memo = (0, $kbQkj.memoBuilder)();
    var _a = (0, $3VFsf.__read)(memo, 2), memoize = _a[0], unmemoize = _a[1];
    // If the value has a `toJSON` method, see if we can bail and let it do the work
    var valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === 'function') try {
        return valueWithToJSON.toJSON();
    } catch (err) {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // Get the simple cases out of the way first
    if (value === null || [
        'number',
        'boolean',
        'string'
    ].includes(typeof value) && !(0, $okkfE.isNaN)(value)) return value;
    var stringified = $c178d7365214c01f$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith('[object ')) return stringified;
    // We're also done if we've reached the max depth
    if (depth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace('object ', '');
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return '[Circular ~]';
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    var normalized = Array.isArray(value) ? [] : {};
    var numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    var visitable = (0, $okkfE.isError)(value) || (0, $okkfE.isEvent)(value) ? (0, $59M0S.convertToPlainObject)(value) : value;
    for(var visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = '[MaxProperties ~]';
            break;
        }
        // Recursively visit all the child nodes
        var visitValue = visitable[visitKey];
        normalized[visitKey] = $c178d7365214c01f$export$588732934346abbf(visitKey, visitValue, depth - 1, maxProperties, memo);
        numAdded += 1;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $c178d7365214c01f$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === 'domain' && value && typeof value === 'object' && value._events) return '[Domain]';
        if (key === 'domainEmitter') return '[DomainEmitter]';
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== 'undefined' && value === $parcel$global) return '[Global]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== 'undefined' && value === window) return '[Window]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== 'undefined' && value === document) return '[Document]';
        // React's SyntheticEvent thingy
        if ((0, $okkfE.isSyntheticEvent)(value)) return '[SyntheticEvent]';
        if (typeof value === 'number' && value !== value) return '[NaN]';
        // this catches `undefined` (but not `null`, which is a primitive and can be serialized on its own)
        if (value === void 0) return '[undefined]';
        if (typeof value === 'function') return "[Function: " + (0, $1M66C.getFunctionName)(value) + "]";
        if (typeof value === 'symbol') return "[" + String(value) + "]";
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === 'bigint') return "[BigInt: " + String(value) + "]";
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        return "[object " + Object.getPrototypeOf(value).constructor.name + "]";
    } catch (err) {
        return "**non-serializable** (" + err + ")";
    }
}
/** Calculates bytes size of input string */ function $c178d7365214c01f$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ function $c178d7365214c01f$var$jsonSize(value) {
    return $c178d7365214c01f$var$utf8Length(JSON.stringify(value));
}

});
parcelRegister("kbQkj", function(module, exports) {

$parcel$export(module.exports, "memoBuilder", () => $eb2d6cb7d9719f25$export$8115b0b78e956ab3);
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Helper to decycle json objects
 */ function $eb2d6cb7d9719f25$export$8115b0b78e956ab3() {
    var hasWeakSet = typeof WeakSet === 'function';
    var inner = hasWeakSet ? new WeakSet() : [];
    function memoize(obj) {
        if (hasWeakSet) {
            if (inner.has(obj)) return true;
            inner.add(obj);
            return false;
        }
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for(var i = 0; i < inner.length; i++){
            var value = inner[i];
            if (value === obj) return true;
        }
        inner.push(obj);
        return false;
    }
    function unmemoize(obj) {
        if (hasWeakSet) inner.delete(obj);
        else {
            for(var i = 0; i < inner.length; i++)if (inner[i] === obj) {
                inner.splice(i, 1);
                break;
            }
        }
    }
    return [
        memoize,
        unmemoize
    ];
}

});


parcelRegister("6dKoA", function(module, exports) {

$parcel$export(module.exports, "makePromiseBuffer", () => $4877f229d6ada624$export$85a4f67f852183e6);

var $f7sqx = parcelRequire("f7sqx");

var $4mVTs = parcelRequire("4mVTs");
function $4877f229d6ada624$export$85a4f67f852183e6(limit) {
    var buffer = [];
    function isReady() {
        return limit === undefined || buffer.length < limit;
    }
    /**
     * Remove a promise from the queue.
     *
     * @param task Can be any PromiseLike<T>
     * @returns Removed promise.
     */ function remove(task) {
        return buffer.splice(buffer.indexOf(task), 1)[0];
    }
    /**
     * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
     *
     * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
     *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
     *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
     *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
     *        limit check.
     * @returns The original promise.
     */ function add(taskProducer) {
        if (!isReady()) return (0, $4mVTs.rejectedSyncPromise)(new (0, $f7sqx.SentryError)('Not adding Promise due to buffer limit reached.'));
        // start the task and add its promise to the queue
        var task = taskProducer();
        if (buffer.indexOf(task) === -1) buffer.push(task);
        task.then(function() {
            return remove(task);
        })// Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
        // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
        // have promises, so TS has to polyfill when down-compiling.)
        .then(null, function() {
            return remove(task).then(null, function() {
            // We have to add another catch here because `remove()` starts a new promise chain.
            });
        });
        return task;
    }
    /**
     * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
     *
     * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
     * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
     * `true`.
     * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
     * `false` otherwise
     */ function drain(timeout) {
        return new (0, $4mVTs.SyncPromise)(function(resolve, reject) {
            var counter = buffer.length;
            if (!counter) return resolve(true);
            // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
            var capturedSetTimeout = setTimeout(function() {
                if (timeout && timeout > 0) resolve(false);
            }, timeout);
            // if all promises resolve in time, cancel the timer and resolve to `true`
            buffer.forEach(function(item) {
                (0, $4mVTs.resolvedSyncPromise)(item).then(function() {
                    // eslint-disable-next-line no-plusplus
                    if (!--counter) {
                        clearTimeout(capturedSetTimeout);
                        resolve(true);
                    }
                }, reject);
            });
        });
    }
    return {
        $: buffer,
        add: add,
        drain: drain
    };
}

});

parcelRegister("5L8AU", function(module, exports) {

$parcel$export(module.exports, "severityFromString", () => $431802330db86aeb$export$e01cef29b4327697);

var $8vvJk = parcelRequire("8vvJk");

var $c1CzK = parcelRequire("c1CzK");
function $431802330db86aeb$var$isSupportedSeverity(level) {
    return (0, $c1CzK.SeverityLevels).indexOf(level) !== -1;
}
function $431802330db86aeb$export$e01cef29b4327697(level) {
    if (level === 'warn') return (0, $8vvJk.Severity).Warning;
    if ($431802330db86aeb$var$isSupportedSeverity(level)) return level;
    return (0, $8vvJk.Severity).Log;
}

});
parcelRegister("8vvJk", function(module, exports) {

$parcel$export(module.exports, "Severity", () => $6319d4e940dba412$export$918a9776c0a3cf27);
/**
 * TODO(v7): Remove this enum and replace with SeverityLevel
 */ var $6319d4e940dba412$export$918a9776c0a3cf27;
(function(Severity) {
    /** JSDoc */ Severity["Fatal"] = "fatal";
    /** JSDoc */ Severity["Error"] = "error";
    /** JSDoc */ Severity["Warning"] = "warning";
    /** JSDoc */ Severity["Log"] = "log";
    /** JSDoc */ Severity["Info"] = "info";
    /** JSDoc */ Severity["Debug"] = "debug";
    /** JSDoc */ Severity["Critical"] = "critical";
})($6319d4e940dba412$export$918a9776c0a3cf27 || ($6319d4e940dba412$export$918a9776c0a3cf27 = {}));
var $6319d4e940dba412$export$484b1ea9aec914c = [
    'fatal',
    'error',
    'warning',
    'log',
    'info',
    'debug',
    'critical'
];

});

parcelRegister("c1CzK", function(module, exports) {

$parcel$export(module.exports, "SeverityLevels", () => $8c138058cfd4daeb$export$484b1ea9aec914c);
var $8c138058cfd4daeb$export$484b1ea9aec914c = [
    'fatal',
    'error',
    'warning',
    'log',
    'info',
    'debug',
    'critical'
];

});


parcelRegister("h2Oxu", function(module, exports) {

$parcel$export(module.exports, "eventStatusFromHttpCode", () => $c689d399d8025b2a$export$82713360d763c449);
/**
 * Converts an HTTP status code to sentry status {@link EventStatus}.
 *
 * @param code number HTTP status code
 * @returns EventStatus
 */ function $c689d399d8025b2a$export$82713360d763c449(code) {
    if (code >= 200 && code < 300) return 'success';
    if (code === 429) return 'rate_limit';
    if (code >= 400 && code < 500) return 'invalid';
    if (code >= 500) return 'failed';
    return 'unknown';
}

});

parcelRegister("2cvr9", function(module, exports) {

$parcel$export(module.exports, "createEnvelope", () => $19a51673c063482c$export$f93f7f385160c44e);
$parcel$export(module.exports, "getEnvelopeType", () => $19a51673c063482c$export$d84939284bbafcd4);
$parcel$export(module.exports, "serializeEnvelope", () => $19a51673c063482c$export$32f9b428425aac85);

var $3VFsf = parcelRequire("3VFsf");

var $okkfE = parcelRequire("okkfE");
function $19a51673c063482c$export$f93f7f385160c44e(headers, items) {
    if (items === void 0) items = [];
    return [
        headers,
        items
    ];
}
function $19a51673c063482c$export$d650323442802f6f(envelope, newItem) {
    var _a = (0, $3VFsf.__read)(envelope, 2), headers = _a[0], items = _a[1];
    return [
        headers,
        (0, $3VFsf.__spread)(items, [
            newItem
        ])
    ];
}
function $19a51673c063482c$export$d84939284bbafcd4(envelope) {
    var _a = (0, $3VFsf.__read)(envelope, 2), _b = (0, $3VFsf.__read)(_a[1], 1), _c = (0, $3VFsf.__read)(_b[0], 1), firstItemHeader = _c[0];
    return firstItemHeader.type;
}
function $19a51673c063482c$export$32f9b428425aac85(envelope) {
    var _a = (0, $3VFsf.__read)(envelope, 2), headers = _a[0], items = _a[1];
    var serializedHeaders = JSON.stringify(headers);
    // Have to cast items to any here since Envelope is a union type
    // Fixed in Typescript 4.2
    // TODO: Remove any[] cast when we upgrade to TS 4.2
    // https://github.com/microsoft/TypeScript/issues/36390
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return items.reduce(function(acc, item) {
        var _a = (0, $3VFsf.__read)(item, 2), itemHeaders = _a[0], payload = _a[1];
        // We do not serialize payloads that are primitives
        var serializedPayload = (0, $okkfE.isPrimitive)(payload) ? String(payload) : JSON.stringify(payload);
        return acc + "\n" + JSON.stringify(itemHeaders) + "\n" + serializedPayload;
    }, serializedHeaders);
}

});

parcelRegister("fLq1q", function(module, exports) {

$parcel$export(module.exports, "createClientReportEnvelope", () => $b79f6e3445ee6042$export$f3b9ed77c03eeb00);

var $2cvr9 = parcelRequire("2cvr9");

var $gI8Be = parcelRequire("gI8Be");
function $b79f6e3445ee6042$export$f3b9ed77c03eeb00(discarded_events, dsn, timestamp) {
    var clientReportItem = [
        {
            type: 'client_report'
        },
        {
            timestamp: timestamp || (0, $gI8Be.dateTimestampInSeconds)(),
            discarded_events: discarded_events
        }
    ];
    return (0, $2cvr9.createEnvelope)(dsn ? {
        dsn: dsn
    } : {}, [
        clientReportItem
    ]);
}

});

parcelRegister("giEo2", function(module, exports) {

$parcel$export(module.exports, "disabledUntil", () => $bddda7bd22e98b4c$export$b89fc7b2e4c799e7);
$parcel$export(module.exports, "isRateLimited", () => $bddda7bd22e98b4c$export$6c91fec22056810a);
$parcel$export(module.exports, "updateRateLimits", () => $bddda7bd22e98b4c$export$699aff705e0d49d4);

var $3VFsf = parcelRequire("3VFsf");
var $bddda7bd22e98b4c$export$b09ce39faaeb1e7c = 60000; // 60 seconds
function $bddda7bd22e98b4c$export$615352e17ed7741(header, now) {
    if (now === void 0) now = Date.now();
    var headerDelay = parseInt("" + header, 10);
    if (!isNaN(headerDelay)) return headerDelay * 1000;
    var headerDate = Date.parse("" + header);
    if (!isNaN(headerDate)) return headerDate - now;
    return $bddda7bd22e98b4c$export$b09ce39faaeb1e7c;
}
function $bddda7bd22e98b4c$export$b89fc7b2e4c799e7(limits, category) {
    return limits[category] || limits.all || 0;
}
function $bddda7bd22e98b4c$export$6c91fec22056810a(limits, category, now) {
    if (now === void 0) now = Date.now();
    return $bddda7bd22e98b4c$export$b89fc7b2e4c799e7(limits, category) > now;
}
function $bddda7bd22e98b4c$export$699aff705e0d49d4(limits, headers, now) {
    var e_1, _a, e_2, _b;
    if (now === void 0) now = Date.now();
    var updatedRateLimits = (0, $3VFsf.__assign)({}, limits);
    // "The name is case-insensitive."
    // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
    var rateLimitHeader = headers['x-sentry-rate-limits'];
    var retryAfterHeader = headers['retry-after'];
    if (rateLimitHeader) try {
        /**
             * rate limit headers are of the form
             *     <header>,<header>,..
             * where each <header> is of the form
             *     <retry_after>: <categories>: <scope>: <reason_code>
             * where
             *     <retry_after> is a delay in seconds
             *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
             *         <category>;<category>;...
             *     <scope> is what's being limited (org, project, or key) - ignored by SDK
             *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
             */ for(var _c = (0, $3VFsf.__values)(rateLimitHeader.trim().split(',')), _d = _c.next(); !_d.done; _d = _c.next()){
            var limit = _d.value;
            var parameters = limit.split(':', 2);
            var headerDelay = parseInt(parameters[0], 10);
            var delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
            if (!parameters[1]) updatedRateLimits.all = now + delay;
            else try {
                for(var _e = (e_2 = void 0, (0, $3VFsf.__values)(parameters[1].split(';'))), _f = _e.next(); !_f.done; _f = _e.next()){
                    var category = _f.value;
                    updatedRateLimits[category] = now + delay;
                }
            } catch (e_2_1) {
                e_2 = {
                    error: e_2_1
                };
            } finally{
                try {
                    if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                } finally{
                    if (e_2) throw e_2.error;
                }
            }
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + $bddda7bd22e98b4c$export$615352e17ed7741(retryAfterHeader, now);
    return updatedRateLimits;
}

});

parcelRegister("lGgkA", function(module, exports) {

$parcel$export(module.exports, "LooselyLazy", () => $fb5c81c3481f1496$export$33c5f161e1d4706);

var $14COT = parcelRequire("14COT");

var $ddkdN = parcelRequire("ddkdN");

var $adSzG = parcelRequire("adSzG");
var $j7rCb = parcelRequire("j7rCb");

var $7AnOd = parcelRequire("7AnOd");
const $fb5c81c3481f1496$export$33c5f161e1d4706 = {
    init: (config)=>{
        (0, $ddkdN.setConfig)(config);
        (0, $adSzG.LISTENERS).length = 0;
        (0, $j7rCb.setCurrent)(0);
        if (!(0, $7AnOd.isNodeEnvironment)()) (0, $14COT.collect)();
    }
};

});
parcelRegister("14COT", function(module, exports) {

$parcel$export(module.exports, "collect", () => $978a626ba3d81e71$export$bb44f104e3c54dae);

var $ddkdN = parcelRequire("ddkdN");
var $7Ewwd = parcelRequire("7Ewwd");

var $fVdZG = parcelRequire("fVdZG");

var $jM6DK = parcelRequire("jM6DK");

var $89lw9 = parcelRequire("89lw9");
const $978a626ba3d81e71$export$bb44f104e3c54dae = ()=>{
    const markers = document.querySelectorAll('input[data-lazy-begin]');
    const { mode: mode } = (0, $ddkdN.getConfig)();
    for(let i = 0, j = markers.length; i < j; i += 1){
        const el = markers[i];
        const { lazyBegin: lazyBegin } = el.dataset || {};
        const value = mode === (0, $7Ewwd.MODE).RENDER ? (0, $jM6DK.cloneElements)(markers[i], lazyBegin) : (0, $89lw9.refElements)(markers[i], lazyBegin);
        if ((0, $fVdZG.COLLECTED).has(lazyBegin)) (0, $fVdZG.COLLECTED).get(lazyBegin).push(value);
        else (0, $fVdZG.COLLECTED).set(lazyBegin, [
            value
        ]);
    }
};

});
parcelRegister("jM6DK", function(module, exports) {

$parcel$export(module.exports, "cloneElements", () => $4f61859029d09f51$export$c42217d53a7ebafb);
const $4f61859029d09f51$export$c42217d53a7ebafb = (fromEl, id)=>{
    const fragment = document.createElement('div');
    let el = fromEl;
    while(el = el.nextSibling){
        if (el.dataset && el.dataset.lazyEnd === id) break;
        // cloneNode is 50% faster than outerHTML/textContent
        fragment.appendChild(el.cloneNode(true));
    }
    return Array.from(fragment.childNodes);
};

});

parcelRegister("89lw9", function(module, exports) {

$parcel$export(module.exports, "refElements", () => $3e418ca48259b973$export$c69443129766a7fc);
const $3e418ca48259b973$export$c69443129766a7fc = (fromEl, id)=>{
    const result = [];
    let el = fromEl;
    while(el = el.nextSibling){
        if (el.dataset && el.dataset.lazyEnd === id) break;
        result.push(el);
    }
    return result;
};

});



parcelRegister("5NkCx", function(module, exports) {

$parcel$export(module.exports, "default", () => $693fcf9674734d10$export$2e2bcd8739ae039);
// @ts-ignore no types for this package :(

var $awmeS = parcelRequire("awmeS");

var $ibWJJ = parcelRequire("ibWJJ");
const $693fcf9674734d10$var$DEFAULT_TIMING = {
    initialPollInterval: 5,
    pollBackoffRate: 2,
    idleTimeout: 30
};
class $693fcf9674734d10$export$2e2bcd8739ae039 {
    /**
	 * Callback for sending a 'track' analytics event. This callback should either be the
	 * 'sendTrackEvent' method on the AnalyticsWebClient, or a method that eventually delegates to it.
	 * The data for the dwell event will be passed to this method for sending.
	 *
	 * @callback trackCallback
	 * @param {Object} eventData - the base event data that will be added to the track event.
	 */ /**
	 * Creates and initialises the DwellTimeHelper.
	 *
	 * @param {trackCallback} trackCallback - the track callback responsible for actually sending
	 * the event.
	 * @param {Object} eventData - the base data that will be added to the track event.
	 * Additional dwell time attributes will be appended to this data. Note that you don't need to
	 * include the 'action' property, as this will be added automatically.
	 * @param {?string} searchSessionId - a unique identifier for the related search session.
	 * @param {?Object} timingOptions - for the purpose of debugging, you can override the default
	 * timing used for measuring dwell time. The following values are possible:
	 * - initialPollInterval: how long to wait before the first dwell milestone event
	 * is fired (in seconds). Default = 5.
	 * - pollBackoffRate: how much to multiply the last poll interval by on each dwell milestone.
	 * event. Default = 2.
	 * - idleTimeout: how long to wait for no user activity before pausing
	 * the dwell timer (in seconds). Default = 30s.
	 * @param {?DwellTimeHelperOptions} dwellTimeHelperOptions - options provided to customise behaviour
	 * of the helper.
	 * - iframeDwell = enable detection of activity in iframes.
	 */ constructor(trackCallback, eventData, searchSessionId, timingOptions, dwellTimeHelperOptions){
        this.timeMeInitialized = false;
        /**
	 * Starts the dwell timer. This method should be called upon the initial page load.
	 */ this.start = ()=>{
            if (this.timeMeInitialized) throw new Error('DwellTimeHelper should only be initialised once per page load.');
            this.timeMeInitialized = true;
            this._initDwellTimeCounterAndPolling();
            if (typeof window !== 'undefined') window.addEventListener('beforeunload', ()=>{
                this.stop();
            });
        };
        /**
	 * Stops the dwell timer and sends the final dwell event. Call this method if you wish to
	 * finalise a dwell measurement without starting a new one. When switching to a new page in a
	 * single-page app, use newPage instead.
	 */ this.stop = ()=>{
            if ((0, (/*@__PURE__*/$parcel$interopDefault($awmeS))).isUserCurrentlyOnPage) this._sendDwellEvent(this._eventData, this._searchSessionId, true);
            (0, (/*@__PURE__*/$parcel$interopDefault($awmeS))).stopAllTimers();
            (0, (/*@__PURE__*/$parcel$interopDefault($awmeS))).resetAllRecordedPageTimes();
            (0, (/*@__PURE__*/$parcel$interopDefault($awmeS))).timeElapsedCallbacks = [];
            this.timeMeInitialized = false;
        };
        /**
	 * Send the final dwell event and reinitialise the dwell timer for a new page.
	 * This method should be called whenever a new page is switched to in a single-page app context.
	 *
	 * @param {Object} eventData - the base data that will be added to the track event.
	 * @param {?string} searchSessionId - the new search session ID.
	 */ this.newPage = (eventData, searchSessionId)=>{
            (0, $ibWJJ.validateDwellBaseEvent)(eventData);
            this.stop();
            this._eventData = eventData;
            this._searchSessionId = searchSessionId;
            this._initDwellTimeCounterAndPolling();
        };
        /**
	 * This is a modified version of timeit's original listForIdleEvents function,
	 * which also listens to events inside same-origin iframes (such as Confluence whiteboards and databases).
	 * https://github.com/jasonzissman/TimeMe.js/blob/master/timeme.js#L338
	 */ this._listForIdleEvents = ()=>{
            document.addEventListener('mousemove', ()=>{
                (0, (/*@__PURE__*/$parcel$interopDefault($awmeS))).userActivityDetected();
            });
            document.addEventListener('keyup', ()=>{
                (0, (/*@__PURE__*/$parcel$interopDefault($awmeS))).userActivityDetected();
            });
            document.addEventListener('touchstart', ()=>{
                (0, (/*@__PURE__*/$parcel$interopDefault($awmeS))).userActivityDetected();
            });
            window.addEventListener('scroll', ()=>{
                (0, (/*@__PURE__*/$parcel$interopDefault($awmeS))).userActivityDetected();
            });
            /**
		 * Find all same origin iframes (same origin allow access to contentWindow.document)
		 * and add event listeners to them too.
		 */ const iframes = document.getElementsByTagName('iframe');
            for(let i = 0; i < iframes.length; i++){
                const iframe = iframes[i];
                try {
                    iframe?.contentWindow?.document.addEventListener('mousemove', ()=>{
                        (0, (/*@__PURE__*/$parcel$interopDefault($awmeS))).userActivityDetected();
                    });
                    iframe?.contentWindow?.document.addEventListener('keyup', ()=>{
                        (0, (/*@__PURE__*/$parcel$interopDefault($awmeS))).userActivityDetected();
                    });
                    iframe?.contentWindow?.document.addEventListener('touchstart', ()=>{
                        (0, (/*@__PURE__*/$parcel$interopDefault($awmeS))).userActivityDetected();
                    });
                } catch (e) {
                // do nothing: We don't want to listen to cross-origin iframes
                }
            }
            setInterval(()=>{
                if ((0, (/*@__PURE__*/$parcel$interopDefault($awmeS))).isUserCurrentlyIdle !== true) {
                    (0, (/*@__PURE__*/$parcel$interopDefault($awmeS))).checkIdleState();
                    // This ensures the timer continues when switching between the iframe and the rest of the page
                    (0, (/*@__PURE__*/$parcel$interopDefault($awmeS))).startTimer();
                }
            }, (0, (/*@__PURE__*/$parcel$interopDefault($awmeS))).checkIdleStateRateMs);
        };
        this._initDwellTimeCounterAndPolling = ()=>{
            // If iframeDwell is enabled, override the listener for idle events to also listen to events in iframes.
            if (this._dwellTimeHelperOptions?.iframeDwell) (0, (/*@__PURE__*/$parcel$interopDefault($awmeS))).listForIdleEvents = this._listForIdleEvents;
            (0, (/*@__PURE__*/$parcel$interopDefault($awmeS))).initialize({
                idleTimeoutInSeconds: this._timing.idleTimeout
            });
            this._pollDwellTime(this._timing.initialPollInterval, this._searchSessionId, this._eventData);
        };
        this._pollDwellTime = (pollTime, searchSessionId, eventData)=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($awmeS))).callAfterTimeElapsedInSeconds(pollTime, ()=>{
                this._sendDwellEvent(eventData, searchSessionId, false);
                this._pollDwellTime(pollTime * this._timing.pollBackoffRate, searchSessionId, eventData);
            });
        };
        this._sendDwellEvent = (eventData, searchSessionId, isFinalDwellEvent)=>{
            const dwellAttributes = {
                dwellTime: (0, (/*@__PURE__*/$parcel$interopDefault($awmeS))).getTimeOnCurrentPageInMilliseconds(),
                searchReferrer: searchSessionId,
                finalDwellEvent: isFinalDwellEvent
            };
            this._trackCallback({
                action: 'dwelled',
                actionSubject: eventData.actionSubject,
                actionSubjectId: eventData.actionSubjectId,
                source: eventData.source,
                containerType: eventData.containerType,
                containerId: eventData.containerId,
                containers: eventData.containers,
                objectType: eventData.objectType,
                objectId: eventData.objectId,
                attributes: {
                    ...dwellAttributes,
                    ...eventData.attributes
                },
                tags: eventData.tags
            });
        };
        if (!trackCallback) throw new Error('trackCallback is required for DwellTimeHelper');
        (0, $ibWJJ.validateDwellBaseEvent)(eventData);
        this._trackCallback = trackCallback;
        this._eventData = eventData;
        this._searchSessionId = searchSessionId;
        this._timing = {
            ...$693fcf9674734d10$var$DEFAULT_TIMING,
            ...timingOptions
        };
        this._dwellTimeHelperOptions = dwellTimeHelperOptions;
    }
}

});

const $af03419a6de12610$export$e4c79eb95c23a0da = 'atlaskit-portal-container';
const $af03419a6de12610$export$72f415121273627e = 'body > .atlaskit-portal-container';
const $af03419a6de12610$export$13f57c02915787b3 = 'atlaskit-portal';

const $edbbaf000cbe1dd7$export$ed5835cc67e87f72 = 'akPortalMount';
const $edbbaf000cbe1dd7$export$80816bd900e5bd00 = 'akPortalUnmount';

var $829f609a65d26a98$exports = {};

$parcel$export($829f609a65d26a98$exports, "R50", () => $829f609a65d26a98$export$4b84fd0e2c617bd);
$parcel$export($829f609a65d26a98$exports, "R75", () => $829f609a65d26a98$export$b34b069eff244586);
$parcel$export($829f609a65d26a98$exports, "R100", () => $829f609a65d26a98$export$be802dd0d8b57f35);
$parcel$export($829f609a65d26a98$exports, "R200", () => $829f609a65d26a98$export$60847d42f9da92a6);
$parcel$export($829f609a65d26a98$exports, "R300", () => $829f609a65d26a98$export$4a7404f376229999);
$parcel$export($829f609a65d26a98$exports, "R400", () => $829f609a65d26a98$export$2010d0fb4295b346);
$parcel$export($829f609a65d26a98$exports, "R500", () => $829f609a65d26a98$export$2837b5a1a71d5c02);
$parcel$export($829f609a65d26a98$exports, "Y50", () => $829f609a65d26a98$export$8d9596b529bbb9cf);
$parcel$export($829f609a65d26a98$exports, "Y75", () => $829f609a65d26a98$export$41060a744ab0b7ae);
$parcel$export($829f609a65d26a98$exports, "Y100", () => $829f609a65d26a98$export$1cc05bbbf340e559);
$parcel$export($829f609a65d26a98$exports, "Y200", () => $829f609a65d26a98$export$5aae31392d72caaa);
$parcel$export($829f609a65d26a98$exports, "Y300", () => $829f609a65d26a98$export$c6930421db9fa514);
$parcel$export($829f609a65d26a98$exports, "Y400", () => $829f609a65d26a98$export$59619663aa6500fb);
$parcel$export($829f609a65d26a98$exports, "Y500", () => $829f609a65d26a98$export$874739ea9e379ab6);
$parcel$export($829f609a65d26a98$exports, "G50", () => $829f609a65d26a98$export$8a6341c32b6a3ee6);
$parcel$export($829f609a65d26a98$exports, "G75", () => $829f609a65d26a98$export$69a3bf21b9686c2b);
$parcel$export($829f609a65d26a98$exports, "G100", () => $829f609a65d26a98$export$afbce1382ec95f73);
$parcel$export($829f609a65d26a98$exports, "G200", () => $829f609a65d26a98$export$747d86715d4175de);
$parcel$export($829f609a65d26a98$exports, "G300", () => $829f609a65d26a98$export$940e1f69e873f202);
$parcel$export($829f609a65d26a98$exports, "G400", () => $829f609a65d26a98$export$a49394138f7b8e85);
$parcel$export($829f609a65d26a98$exports, "G500", () => $829f609a65d26a98$export$6fa04827ac68a4fb);
$parcel$export($829f609a65d26a98$exports, "B50", () => $829f609a65d26a98$export$226de0355ed012f8);
$parcel$export($829f609a65d26a98$exports, "B75", () => $829f609a65d26a98$export$8c13c2ee36917869);
$parcel$export($829f609a65d26a98$exports, "B100", () => $829f609a65d26a98$export$ecfc1dff386a3e7a);
$parcel$export($829f609a65d26a98$exports, "B200", () => $829f609a65d26a98$export$215b7063051591f1);
$parcel$export($829f609a65d26a98$exports, "B300", () => $829f609a65d26a98$export$e62e8919cca44969);
$parcel$export($829f609a65d26a98$exports, "B400", () => $829f609a65d26a98$export$b3de0ae08da2ce64);
$parcel$export($829f609a65d26a98$exports, "B500", () => $829f609a65d26a98$export$a6ee3d71bc067634);
$parcel$export($829f609a65d26a98$exports, "B600", () => $829f609a65d26a98$export$67f15409e87642a1);
$parcel$export($829f609a65d26a98$exports, "B700", () => $829f609a65d26a98$export$f0539dbc42dbb067);
$parcel$export($829f609a65d26a98$exports, "P50", () => $829f609a65d26a98$export$363e4475840015bb);
$parcel$export($829f609a65d26a98$exports, "P75", () => $829f609a65d26a98$export$4b0a4417ed59760f);
$parcel$export($829f609a65d26a98$exports, "P100", () => $829f609a65d26a98$export$6011520a64d9a187);
$parcel$export($829f609a65d26a98$exports, "P200", () => $829f609a65d26a98$export$a7175d4e9206bc80);
$parcel$export($829f609a65d26a98$exports, "P300", () => $829f609a65d26a98$export$b48405b95304b5a1);
$parcel$export($829f609a65d26a98$exports, "P400", () => $829f609a65d26a98$export$c71e4279dd54a18d);
$parcel$export($829f609a65d26a98$exports, "P500", () => $829f609a65d26a98$export$147899de772240ec);
$parcel$export($829f609a65d26a98$exports, "T50", () => $829f609a65d26a98$export$2cf711fe14c66f06);
$parcel$export($829f609a65d26a98$exports, "T75", () => $829f609a65d26a98$export$7a8f4d33f6f9772c);
$parcel$export($829f609a65d26a98$exports, "T100", () => $829f609a65d26a98$export$776c9c497ef08533);
$parcel$export($829f609a65d26a98$exports, "T200", () => $829f609a65d26a98$export$69cb3ca10c1e330e);
$parcel$export($829f609a65d26a98$exports, "T300", () => $829f609a65d26a98$export$9dc1ef0f3f48059b);
$parcel$export($829f609a65d26a98$exports, "T400", () => $829f609a65d26a98$export$7c835c78b6fcdef8);
$parcel$export($829f609a65d26a98$exports, "T500", () => $829f609a65d26a98$export$6036577f95c3877e);
$parcel$export($829f609a65d26a98$exports, "N0", () => $829f609a65d26a98$export$29a4f05edc054374);
$parcel$export($829f609a65d26a98$exports, "N10", () => $829f609a65d26a98$export$e655ef011c4aa1a2);
$parcel$export($829f609a65d26a98$exports, "N20", () => $829f609a65d26a98$export$9fdfb749e33cdf97);
$parcel$export($829f609a65d26a98$exports, "N30", () => $829f609a65d26a98$export$3e51e8f1440314ba);
$parcel$export($829f609a65d26a98$exports, "N40", () => $829f609a65d26a98$export$1ce2d1575d444ceb);
$parcel$export($829f609a65d26a98$exports, "N50", () => $829f609a65d26a98$export$8754fc7e6d8b3000);
$parcel$export($829f609a65d26a98$exports, "N60", () => $829f609a65d26a98$export$c2e91cbeada39b8b);
$parcel$export($829f609a65d26a98$exports, "N70", () => $829f609a65d26a98$export$5f71e19f3a7ad9de);
$parcel$export($829f609a65d26a98$exports, "N80", () => $829f609a65d26a98$export$eaa8c8a70ac22806);
$parcel$export($829f609a65d26a98$exports, "N90", () => $829f609a65d26a98$export$7c87d337fb91a97d);
$parcel$export($829f609a65d26a98$exports, "N100", () => $829f609a65d26a98$export$d6447c357493214f);
$parcel$export($829f609a65d26a98$exports, "N200", () => $829f609a65d26a98$export$f563ee71e9ee74cd);
$parcel$export($829f609a65d26a98$exports, "N300", () => $829f609a65d26a98$export$e2ef2124cf4024b1);
$parcel$export($829f609a65d26a98$exports, "N400", () => $829f609a65d26a98$export$eece5f492e429f08);
$parcel$export($829f609a65d26a98$exports, "N500", () => $829f609a65d26a98$export$c39c0fe0f26207ae);
$parcel$export($829f609a65d26a98$exports, "N600", () => $829f609a65d26a98$export$7090862dc3038a9f);
$parcel$export($829f609a65d26a98$exports, "N700", () => $829f609a65d26a98$export$ad0bacf983b7ddaa);
$parcel$export($829f609a65d26a98$exports, "N800", () => $829f609a65d26a98$export$7d61b15e0da132af);
$parcel$export($829f609a65d26a98$exports, "N900", () => $829f609a65d26a98$export$fbda843f0a27fe96);
$parcel$export($829f609a65d26a98$exports, "N10A", () => $829f609a65d26a98$export$791e57b27ca738ef);
$parcel$export($829f609a65d26a98$exports, "N20A", () => $829f609a65d26a98$export$8d43898f60b96a82);
$parcel$export($829f609a65d26a98$exports, "N30A", () => $829f609a65d26a98$export$920c0d5c49070351);
$parcel$export($829f609a65d26a98$exports, "N40A", () => $829f609a65d26a98$export$46987b49aab6d1a8);
$parcel$export($829f609a65d26a98$exports, "N50A", () => $829f609a65d26a98$export$7d3359664e8bb0e5);
$parcel$export($829f609a65d26a98$exports, "N60A", () => $829f609a65d26a98$export$d2d3bedfb276cac0);
$parcel$export($829f609a65d26a98$exports, "N70A", () => $829f609a65d26a98$export$6e5e7499ff054f6d);
$parcel$export($829f609a65d26a98$exports, "N80A", () => $829f609a65d26a98$export$59264b346c877fa7);
$parcel$export($829f609a65d26a98$exports, "N90A", () => $829f609a65d26a98$export$d092757d7c64925c);
$parcel$export($829f609a65d26a98$exports, "N100A", () => $829f609a65d26a98$export$486ab785e4bac3c6);
$parcel$export($829f609a65d26a98$exports, "N200A", () => $829f609a65d26a98$export$fba592bbc6419fea);
$parcel$export($829f609a65d26a98$exports, "N300A", () => $829f609a65d26a98$export$13609db0e6812ab8);
$parcel$export($829f609a65d26a98$exports, "N400A", () => $829f609a65d26a98$export$fbae4efaa892d883);
$parcel$export($829f609a65d26a98$exports, "N500A", () => $829f609a65d26a98$export$f13946d26f440ce6);
$parcel$export($829f609a65d26a98$exports, "N600A", () => $829f609a65d26a98$export$19f58225ac52a306);
$parcel$export($829f609a65d26a98$exports, "N700A", () => $829f609a65d26a98$export$6384f09da70e7b62);
$parcel$export($829f609a65d26a98$exports, "N800A", () => $829f609a65d26a98$export$d0dccc730683edc2);
$parcel$export($829f609a65d26a98$exports, "DN900", () => $829f609a65d26a98$export$2f6319cf7d736c2a);
$parcel$export($829f609a65d26a98$exports, "DN800", () => $829f609a65d26a98$export$95126bc8884d6634);
$parcel$export($829f609a65d26a98$exports, "DN700", () => $829f609a65d26a98$export$8338d8c35d44ff1);
$parcel$export($829f609a65d26a98$exports, "DN600", () => $829f609a65d26a98$export$5368d76ae4fbbda7);
$parcel$export($829f609a65d26a98$exports, "DN500", () => $829f609a65d26a98$export$9f0a771d16ec8d36);
$parcel$export($829f609a65d26a98$exports, "DN400", () => $829f609a65d26a98$export$abcf8c38338b4aa5);
$parcel$export($829f609a65d26a98$exports, "DN300", () => $829f609a65d26a98$export$97e81faa16a182c7);
$parcel$export($829f609a65d26a98$exports, "DN200", () => $829f609a65d26a98$export$bfe21c59123ecf33);
$parcel$export($829f609a65d26a98$exports, "DN100", () => $829f609a65d26a98$export$ee82aa2ea6a1558);
$parcel$export($829f609a65d26a98$exports, "DN90", () => $829f609a65d26a98$export$682927c6ed76be02);
$parcel$export($829f609a65d26a98$exports, "DN80", () => $829f609a65d26a98$export$91fd9994c5be9757);
$parcel$export($829f609a65d26a98$exports, "DN70", () => $829f609a65d26a98$export$d281fbfe3cff2df6);
$parcel$export($829f609a65d26a98$exports, "DN60", () => $829f609a65d26a98$export$3902c91d8b98a753);
$parcel$export($829f609a65d26a98$exports, "DN50", () => $829f609a65d26a98$export$8e8133c1ba5845b5);
$parcel$export($829f609a65d26a98$exports, "DN40", () => $829f609a65d26a98$export$33ff357f6620b39);
$parcel$export($829f609a65d26a98$exports, "DN30", () => $829f609a65d26a98$export$633847cf062b69e0);
$parcel$export($829f609a65d26a98$exports, "DN20", () => $829f609a65d26a98$export$9776a6e503bdbf76);
$parcel$export($829f609a65d26a98$exports, "DN10", () => $829f609a65d26a98$export$6c813d5160dff5db);
$parcel$export($829f609a65d26a98$exports, "DN0", () => $829f609a65d26a98$export$3d4f271a500072a);
$parcel$export($829f609a65d26a98$exports, "DN800A", () => $829f609a65d26a98$export$fe151285c22759ec);
$parcel$export($829f609a65d26a98$exports, "DN700A", () => $829f609a65d26a98$export$a101c6190d0da34);
$parcel$export($829f609a65d26a98$exports, "DN600A", () => $829f609a65d26a98$export$4b16f52932fda51);
$parcel$export($829f609a65d26a98$exports, "DN500A", () => $829f609a65d26a98$export$a74bcd7b9845b0d8);
$parcel$export($829f609a65d26a98$exports, "DN400A", () => $829f609a65d26a98$export$9209c179316d1751);
$parcel$export($829f609a65d26a98$exports, "DN300A", () => $829f609a65d26a98$export$88f55133f636c8dd);
$parcel$export($829f609a65d26a98$exports, "DN200A", () => $829f609a65d26a98$export$51126f85d1009512);
$parcel$export($829f609a65d26a98$exports, "DN100A", () => $829f609a65d26a98$export$a069b547bd23af78);
$parcel$export($829f609a65d26a98$exports, "DN90A", () => $829f609a65d26a98$export$40cce05af3b2600a);
$parcel$export($829f609a65d26a98$exports, "DN80A", () => $829f609a65d26a98$export$b78942185925a0d);
$parcel$export($829f609a65d26a98$exports, "DN70A", () => $829f609a65d26a98$export$e058fb44b8eaafca);
$parcel$export($829f609a65d26a98$exports, "DN60A", () => $829f609a65d26a98$export$92b0b8de26920c18);
$parcel$export($829f609a65d26a98$exports, "DN50A", () => $829f609a65d26a98$export$67564f7459d3fc9e);
$parcel$export($829f609a65d26a98$exports, "DN40A", () => $829f609a65d26a98$export$77868e1ca884ffa3);
$parcel$export($829f609a65d26a98$exports, "DN30A", () => $829f609a65d26a98$export$2afd71d7d3ea2cd5);
$parcel$export($829f609a65d26a98$exports, "DN20A", () => $829f609a65d26a98$export$f2a0acaab9972c70);
$parcel$export($829f609a65d26a98$exports, "DN10A", () => $829f609a65d26a98$export$9ab70e67d6475361);
$parcel$export($829f609a65d26a98$exports, "T30", () => $829f609a65d26a98$export$d2adc5dedf09fced);
$parcel$export($829f609a65d26a98$exports, "L50", () => $829f609a65d26a98$export$f51762073d2bb381);
$parcel$export($829f609a65d26a98$exports, "L75", () => $829f609a65d26a98$export$95e26d54def96891);
// Reds
const $829f609a65d26a98$export$4b84fd0e2c617bd = '#FFEBE6';
const $829f609a65d26a98$export$b34b069eff244586 = '#FFBDAD';
const $829f609a65d26a98$export$be802dd0d8b57f35 = '#FF8F73';
const $829f609a65d26a98$export$60847d42f9da92a6 = '#FF7452';
const $829f609a65d26a98$export$4a7404f376229999 = '#FF5630';
const $829f609a65d26a98$export$2010d0fb4295b346 = '#DE350B';
const $829f609a65d26a98$export$2837b5a1a71d5c02 = '#BF2600';
const $829f609a65d26a98$export$8d9596b529bbb9cf = '#FFFAE6';
const $829f609a65d26a98$export$41060a744ab0b7ae = '#FFF0B3';
const $829f609a65d26a98$export$1cc05bbbf340e559 = '#FFE380';
const $829f609a65d26a98$export$5aae31392d72caaa = '#FFC400';
const $829f609a65d26a98$export$c6930421db9fa514 = '#FFAB00';
const $829f609a65d26a98$export$59619663aa6500fb = '#FF991F';
const $829f609a65d26a98$export$874739ea9e379ab6 = '#FF8B00';
const $829f609a65d26a98$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $829f609a65d26a98$export$69a3bf21b9686c2b = '#ABF5D1';
const $829f609a65d26a98$export$afbce1382ec95f73 = '#79F2C0';
const $829f609a65d26a98$export$747d86715d4175de = '#57D9A3';
const $829f609a65d26a98$export$940e1f69e873f202 = '#36B37E';
const $829f609a65d26a98$export$a49394138f7b8e85 = '#00875A';
const $829f609a65d26a98$export$6fa04827ac68a4fb = '#006644';
const $829f609a65d26a98$export$226de0355ed012f8 = '#DEEBFF';
const $829f609a65d26a98$export$8c13c2ee36917869 = '#B3D4FF';
const $829f609a65d26a98$export$ecfc1dff386a3e7a = '#4C9AFF';
const $829f609a65d26a98$export$215b7063051591f1 = '#2684FF';
const $829f609a65d26a98$export$e62e8919cca44969 = '#0065FF';
const $829f609a65d26a98$export$b3de0ae08da2ce64 = '#0052CC';
const $829f609a65d26a98$export$a6ee3d71bc067634 = '#0747A6';
const $829f609a65d26a98$export$67f15409e87642a1 = '#669DF1';
const $829f609a65d26a98$export$f0539dbc42dbb067 = '#8FB8F6';
const $829f609a65d26a98$export$363e4475840015bb = '#EAE6FF';
const $829f609a65d26a98$export$4b0a4417ed59760f = '#C0B6F2';
const $829f609a65d26a98$export$6011520a64d9a187 = '#998DD9';
const $829f609a65d26a98$export$a7175d4e9206bc80 = '#8777D9';
const $829f609a65d26a98$export$b48405b95304b5a1 = '#6554C0';
const $829f609a65d26a98$export$c71e4279dd54a18d = '#5243AA';
const $829f609a65d26a98$export$147899de772240ec = '#403294';
const $829f609a65d26a98$export$2cf711fe14c66f06 = '#E6FCFF';
const $829f609a65d26a98$export$7a8f4d33f6f9772c = '#B3F5FF';
const $829f609a65d26a98$export$776c9c497ef08533 = '#79E2F2';
const $829f609a65d26a98$export$69cb3ca10c1e330e = '#00C7E6';
const $829f609a65d26a98$export$9dc1ef0f3f48059b = '#00B8D9';
const $829f609a65d26a98$export$7c835c78b6fcdef8 = '#00A3BF';
const $829f609a65d26a98$export$6036577f95c3877e = '#008DA6';
const $829f609a65d26a98$export$29a4f05edc054374 = '#FFFFFF';
const $829f609a65d26a98$export$e655ef011c4aa1a2 = '#FAFBFC';
const $829f609a65d26a98$export$9fdfb749e33cdf97 = '#F4F5F7';
const $829f609a65d26a98$export$3e51e8f1440314ba = '#EBECF0';
const $829f609a65d26a98$export$1ce2d1575d444ceb = '#DFE1E6';
const $829f609a65d26a98$export$8754fc7e6d8b3000 = '#C1C7D0';
const $829f609a65d26a98$export$c2e91cbeada39b8b = '#B3BAC5';
const $829f609a65d26a98$export$5f71e19f3a7ad9de = '#A5ADBA';
const $829f609a65d26a98$export$eaa8c8a70ac22806 = '#97A0AF';
const $829f609a65d26a98$export$7c87d337fb91a97d = '#8993A4';
const $829f609a65d26a98$export$d6447c357493214f = '#7A869A';
const $829f609a65d26a98$export$f563ee71e9ee74cd = '#6B778C';
const $829f609a65d26a98$export$e2ef2124cf4024b1 = '#5E6C84';
const $829f609a65d26a98$export$eece5f492e429f08 = '#505F79';
const $829f609a65d26a98$export$c39c0fe0f26207ae = '#42526E';
const $829f609a65d26a98$export$7090862dc3038a9f = '#344563';
const $829f609a65d26a98$export$ad0bacf983b7ddaa = '#253858';
const $829f609a65d26a98$export$7d61b15e0da132af = '#172B4D';
const $829f609a65d26a98$export$fbda843f0a27fe96 = '#091E42';
const $829f609a65d26a98$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $829f609a65d26a98$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $829f609a65d26a98$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $829f609a65d26a98$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $829f609a65d26a98$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $829f609a65d26a98$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $829f609a65d26a98$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $829f609a65d26a98$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $829f609a65d26a98$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $829f609a65d26a98$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $829f609a65d26a98$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $829f609a65d26a98$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $829f609a65d26a98$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $829f609a65d26a98$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $829f609a65d26a98$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $829f609a65d26a98$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $829f609a65d26a98$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $829f609a65d26a98$export$2f6319cf7d736c2a = '#E6EDFA';
const $829f609a65d26a98$export$95126bc8884d6634 = '#DCE5F5';
const $829f609a65d26a98$export$8338d8c35d44ff1 = '#CED9EB';
const $829f609a65d26a98$export$5368d76ae4fbbda7 = '#B8C7E0';
const $829f609a65d26a98$export$9f0a771d16ec8d36 = '#ABBBD6';
const $829f609a65d26a98$export$abcf8c38338b4aa5 = '#9FB0CC';
const $829f609a65d26a98$export$97e81faa16a182c7 = '#8C9CB8';
const $829f609a65d26a98$export$bfe21c59123ecf33 = '#7988A3';
const $829f609a65d26a98$export$ee82aa2ea6a1558 = '#67758F';
const $829f609a65d26a98$export$682927c6ed76be02 = '#56637A';
const $829f609a65d26a98$export$91fd9994c5be9757 = '#455166';
const $829f609a65d26a98$export$d281fbfe3cff2df6 = '#3B475C';
const $829f609a65d26a98$export$3902c91d8b98a753 = '#313D52';
const $829f609a65d26a98$export$8e8133c1ba5845b5 = '#283447';
const $829f609a65d26a98$export$33ff357f6620b39 = '#202B3D';
const $829f609a65d26a98$export$633847cf062b69e0 = '#1B2638';
const $829f609a65d26a98$export$9776a6e503bdbf76 = '#121A29';
const $829f609a65d26a98$export$6c813d5160dff5db = '#0E1624';
const $829f609a65d26a98$export$3d4f271a500072a = '#0D1424';
const $829f609a65d26a98$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $829f609a65d26a98$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $829f609a65d26a98$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $829f609a65d26a98$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $829f609a65d26a98$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $829f609a65d26a98$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $829f609a65d26a98$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $829f609a65d26a98$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $829f609a65d26a98$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $829f609a65d26a98$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $829f609a65d26a98$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $829f609a65d26a98$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $829f609a65d26a98$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $829f609a65d26a98$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $829f609a65d26a98$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $829f609a65d26a98$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $829f609a65d26a98$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $829f609a65d26a98$export$d2adc5dedf09fced = '#292A2E';
const $829f609a65d26a98$export$f51762073d2bb381 = '#94C748';
const $829f609a65d26a98$export$95e26d54def96891 = '#B3DF72';

// Media uses a namespaced analytics context under the following key MEDIA_CONTEXT.
const $b276966247f2f12d$export$70df29c238ba7306 = 'mediaCtx'; // However we don't export any JSX component to create that namespaced analytics context.
 // In media components, analytics context is being created by this component:
 // @see packages/media/media-common/src/analytics/withMediaAnalyticsContext.tsx

// same types defined in analytics-web-client but avoid creating dependency with that
const $676c5e519aa5ba55$export$a1562d08625f5d7e = 'ui';
const $676c5e519aa5ba55$export$947dac6c72b26f81 = 'track';
const $676c5e519aa5ba55$export$f1d537d508d2945a = 'screen';
const $676c5e519aa5ba55$export$12346a674644c156 = 'operational';
const $676c5e519aa5ba55$export$b055de0e665cb20c = 'unknown';

const $ff8b18549b2c06bf$export$d6830277b06edd6 = 'normal';


$parcel$global.rlb("2Lfdl")
//# sourceMappingURL=shared~vendor~atlassian~ar.191b0819.js.map
